webpackJsonp([37],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(890)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(560)(module)))

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.withAsyncChangeLoader = exports.withAsyncEnterLoader = exports.withSyncChangeLoader = exports.withSyncEnterLoader = exports.withLoader = undefined;

var _global = __webpack_require__(46);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var withLoader = exports.withLoader = function withLoader(fn, store, page) {
	return function (nextState, cb) {
		store.dispatch((0, _global.pageLoading)(page));

		fn(nextState, function (error, component) {
			cb(error, component);
			store.dispatch((0, _global.pageLoaded)(page));
		});
	};
};

var withSyncEnterLoader = exports.withSyncEnterLoader = function withSyncEnterLoader(fn, store, page) {
	return function (nextState, replace, cb) {
		store.dispatch((0, _global.pageEntering)(page));
		store.dispatch((0, _global.loadingRatio)(0, page));

		return fn(nextState, replace, function (ratio) {
			return store.dispatch((0, _global.loadingRatio)(ratio, page));
		}, function () {
			cb();
			store.dispatch((0, _global.loadingRatio)(1));
			store.dispatch((0, _global.pageEntered)(page));
		});
	};
};

var withSyncChangeLoader = exports.withSyncChangeLoader = function withSyncChangeLoader(fn, store, page) {
	return function () {
		var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(prevState, nextState, replace, cb) {
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							store.dispatch((0, _global.pageChanging)(page));
							store.dispatch((0, _global.loadingRatio)(0, page));

							return _context.abrupt('return', fn(prevState, nextState, replace, function (ratio) {
								return store.dispatch((0, _global.loadingRatio)(ratio, page));
							}, function () {
								cb();
								store.dispatch((0, _global.loadingRatio)(1, page));
								store.dispatch((0, _global.pageChanged)(page));
							}));

						case 3:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x, _x2, _x3, _x4) {
			return _ref.apply(this, arguments);
		};
	}();
};

var withAsyncEnterLoader = exports.withAsyncEnterLoader = function withAsyncEnterLoader(fn, store, page) {
	return function () {
		var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(nextState, replace) {
			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							store.dispatch((0, _global.pageEntering)(page));
							store.dispatch((0, _global.loadingRatio)(0, page));

							_context2.prev = 2;
							_context2.next = 5;
							return fn(nextState, replace, function (ratio) {
								return store.dispatch((0, _global.loadingRatio)(ratio, page));
							});

						case 5:
							_context2.next = 10;
							break;

						case 7:
							_context2.prev = 7;
							_context2.t0 = _context2['catch'](2);

							console.log('Exception on ' + page, _context2.t0);

						case 10:
							_context2.prev = 10;

							store.dispatch((0, _global.loadingRatio)(1, page));
							store.dispatch((0, _global.pageEntered)(page));
							return _context2.finish(10);

						case 14:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined, [[2, 7, 10, 14]]);
		}));

		return function (_x5, _x6) {
			return _ref2.apply(this, arguments);
		};
	}();
};

var withAsyncChangeLoader = exports.withAsyncChangeLoader = function withAsyncChangeLoader(fn, store, page) {
	return function () {
		var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(prevState, nextState, replace) {
			return regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							store.dispatch((0, _global.pageChanging)(page));
							store.dispatch((0, _global.loadingRatio)(0, page));

							_context3.prev = 2;
							_context3.next = 5;
							return fn(prevState, nextState, replace, function (ratio) {
								return store.dispatch((0, _global.loadingRatio)(ratio, page));
							});

						case 5:
							_context3.next = 10;
							break;

						case 7:
							_context3.prev = 7;
							_context3.t0 = _context3['catch'](2);

							console.log('Exception on change ' + page, _context3.t0);

						case 10:
							_context3.prev = 10;

							store.dispatch((0, _global.loadingRatio)(1, page));
							store.dispatch((0, _global.pageChanged)(page));
							return _context3.finish(10);

						case 14:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, undefined, [[2, 7, 10, 14]]);
		}));

		return function (_x7, _x8, _x9) {
			return _ref3.apply(this, arguments);
		};
	}();
};

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.t = exports.getLanguage = exports.changeLng = exports.initi18next = exports.languageMapRoute = exports.routeMapLanguage = exports.isLanguageSupportWithRoute = exports.mapLanguageName = exports.LANGUAGE_OPTIONS = undefined;

var _i18next = __webpack_require__(827);

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextBrowserLanguagedetector = __webpack_require__(836);

var _i18nextBrowserLanguagedetector2 = _interopRequireDefault(_i18nextBrowserLanguagedetector);

var _reactI18next = __webpack_require__(69);

var _i18n = __webpack_require__(289);

var _storage = __webpack_require__(66);

var _resources = __webpack_require__(891);

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAPPING_LANGUAGE = {
	'zh-tw': 'zh-TW',
	en: 'en'
};
// import Backend from 'i18next-xhr-backend';
var LANGUAGE_OPTIONS = exports.LANGUAGE_OPTIONS = [{
	label: '中文',
	value: 'zh-TW'
}, {
	label: 'English',
	value: 'en'
}];

var mapLanguageName = exports.mapLanguageName = function mapLanguageName(lan) {
	var _LANGUAGE_OPTIONS$fil = LANGUAGE_OPTIONS.filter(function (item) {
		return item.value === lan;
	}).map(function (item) {
		return item.label;
	}),
	    _LANGUAGE_OPTIONS$fil2 = _LANGUAGE_OPTIONS$fil[0],
	    name = _LANGUAGE_OPTIONS$fil2 === undefined ? '中文' : _LANGUAGE_OPTIONS$fil2;

	return name;
};

var isLanguageSupportWithRoute = exports.isLanguageSupportWithRoute = function isLanguageSupportWithRoute(route) {
	return Object.keys(MAPPING_LANGUAGE).includes(route);
};

var routeMapLanguage = exports.routeMapLanguage = function routeMapLanguage(route) {
	var _Object$keys$filter$m = Object.keys(MAPPING_LANGUAGE).filter(function (key) {
		return key === route;
	}).map(function (key) {
		return MAPPING_LANGUAGE[key];
	}),
	    _Object$keys$filter$m2 = _Object$keys$filter$m[0],
	    lang = _Object$keys$filter$m2 === undefined ? 'zh-TW' : _Object$keys$filter$m2;

	return lang;
};

var languageMapRoute = exports.languageMapRoute = function languageMapRoute(lan) {
	var _Object$keys$filter = Object.keys(MAPPING_LANGUAGE).filter(function (key) {
		return MAPPING_LANGUAGE[key] === lan;
	}),
	    _Object$keys$filter$ = _Object$keys$filter[0],
	    route = _Object$keys$filter$ === undefined ? 'zh-tw' : _Object$keys$filter$;

	return route;
};

var languageDetect = {
	name: 'urlDetect',

	lookup: function lookup() {
		var pathnames = window.location.pathname.split('/');

		if (pathnames.length >= 2) {
			return routeMapLanguage(pathnames[1]);
		}

		return 'zh-TW';
	}
};

var initi18next = exports.initi18next = function initi18next(store) {
	var lngDetector = new _i18nextBrowserLanguagedetector2.default();
	// Setup Custom detector;
	lngDetector.addDetector(languageDetect);

	_i18next2.default
	// .use(Backend)
	.use(lngDetector).use(_reactI18next.reactI18nextModule).init({
		fallbackLng: 'zh-TW',

		// have a common namespace used around the full app
		ns: ['common'],
		defaultNS: 'common',

		debug: "production" !== 'production',

		interpolation: {
			escapeValue: false // not needed for react!!
		},

		// Open when use backend
		// saveMissing: true,

		react: {
			wait: true
		},

		detection: {
			order: ['urlDetect', 'localStorage', 'cookie', 'navigator', 'htmlTag'],
			lookupLocalStorage: (0, _storage.getLanguageLocalStorage)()
		},

		caches: ['localStorage'],

		// Fakes translations resources. If you want to use backend, turn off this.
		resources: _resources2.default
	}, function () {
		store.dispatch((0, _i18n.changeLanguage)(_i18next2.default.language));
	});

	_i18next2.default.on('languageChanged', function () {
		store.dispatch((0, _i18n.changeLanguage)(_i18next2.default.language));
	});

	return _i18next2.default;
};

var changeLng = exports.changeLng = function changeLng(lng) {
	return _i18next2.default.changeLanguage(lng);
};

var getLanguage = exports.getLanguage = function getLanguage() {
	return _i18next2.default.language;
};

var t = exports.t = function t(keys, options) {
	return _i18next2.default.t(keys, options);
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.errorHandleEpic = exports.openSuccessAlert = exports.closeAlert = exports.openFailedAlert = undefined;

var _reduxActions = __webpack_require__(5);

var _authStorage = __webpack_require__(105);

var _authStorage2 = _interopRequireDefault(_authStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var openFailedAlert = exports.openFailedAlert = (0, _reduxActions.createAction)('OPEN_ALERT', function () {
	var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'generic';
	var message = arguments[1];
	var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	return {
		type: type,
		message: message,
		option: option,
		success: false
	};
});

var closeAlert = exports.closeAlert = (0, _reduxActions.createAction)('CLOSE_ALERT', function (type) {
	return { type: type };
});

var openSuccessAlert = exports.openSuccessAlert = (0, _reduxActions.createAction)('OPEN_ALERT', function () {
	var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'generic';
	var message = arguments[1];
	var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	return {
		type: type,
		message: message,
		option: option,
		success: true
	};
});

var errorHandleEpic = exports.errorHandleEpic = function errorHandleEpic(action$) {
	return action$.filter(function (action) {
		return action.type.includes('REJECTED');
	}).map(function (action) {
		if (action.payload instanceof Error) {
			console.error(action.payload);

			return {
				type: 'OPEN_ALERT',
				payload: { type: 'generic', message: action.payload.message, option: {}, success: false }
			};
		}

		if (action.payload.payload.message === 'Access token could not be verified') {
			_authStorage2.default.removeToken();
			window.location.reload();
			return { type: 'CLEAR_TOKEN' };
		}

		return action.payload;
	});
};

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isOutOfMonth = exports.isiOS = exports.convertPingToM = exports.getLocationFromApartment = exports.normalizeRange = exports.calculateDigit = exports.covertSocialType = exports.mapSocialType = exports.convertReservationEvent = exports.mapReservationEventType = exports.mapBookingType = exports.mapUserLevelName = exports.mapUserLevel = exports.mapGenderLabel = exports.serverMapEmpty = exports.mapMrtColor = exports.mapApartmentDetail = exports.mapRoomStatus = exports.mapRoomType = exports.normalizeArray = exports.keyTransform = exports.toCamelCase = exports.isEmpty = exports.isExist = exports.range = exports.sleep = undefined;

var _i18n = __webpack_require__(16);

var sleep = exports.sleep = function sleep(time) {
	return new Promise(function (resolve) {
		return setTimeout(function () {
			return resolve();
		}, time);
	});
};

var range = exports.range = function range(start, length) {
	return Array.from(new Array(length), function (_, i) {
		return start + i;
	});
};

var isExist = exports.isExist = function isExist(value) {
	return value !== null && value !== '' && typeof value !== 'undefined';
};

var isEmpty = exports.isEmpty = function isEmpty(value) {
	return !isExist(value);
};

var toCamelCase = exports.toCamelCase = function toCamelCase(str) {
	var keyArray = str.split('_');

	return keyArray.reduce(function (prev, cur) {
		if (prev === '') {
			return cur;
		}

		if (cur.length > 0) {
			return '' + prev + cur[0].toUpperCase() + cur.slice(1);
		}

		return prev;
	}, '');
};

var keyTransform = exports.keyTransform = function keyTransform(data) {
	var newData = {};

	Object.keys(data).forEach(function (key) {
		newData[toCamelCase(key)] = data[key];
	});

	return newData;
};

var normalizeArray = exports.normalizeArray = function normalizeArray(oldData) {
	var data = {};

	var list = oldData.map(function (item) {
		data[item.id] = item;
		return item.id;
	});

	return { data: data, list: list };
};

// MEN_LIVING: '男生宿舍房',
// WOMEN_LIVING: '女生宿舍房',
// CO_LIVING: '混合宿舍房',
// ROOM: '雅房',
// STUDIO: '獨立套房',
var mapRoomType = exports.mapRoomType = function mapRoomType(key) {
	return (0, _i18n.t)('roomType:' + key);
};

// RENTED: '未開放',
// AVAILABLE: '招募中',
// FULL: '額滿',
var mapRoomStatus = exports.mapRoomStatus = function mapRoomStatus(key) {
	return (0, _i18n.t)('roomStatus:' + key);
};

var APARTMENT_DETAIL_MAP = {
	balcony: function balcony(state) {
		if (state) {
			return { name: 'balcony', value: (0, _i18n.t)('room:yes'), display: true };
		}
		return { name: '', value: '', display: false };
	},
	kitchen: function kitchen(state) {
		if (state) {
			return { name: 'kitchen', value: (0, _i18n.t)('room:yes'), display: true };
		}
		return { name: '', value: '', display: false };
	},
	publicBath: function publicBath(num) {
		if (num > 0) {
			return { name: 'sharedBathrooms', value: '' + num + (0, _i18n.t)('room:room'), display: true };
		}
		return { name: '', value: '', display: false };
	},
	pingNumber: function pingNumber(num) {
		if (num > 0) {
			return { name: 'size', value: '' + num + (0, _i18n.t)('room:roomSize'), display: true };
		}
		return { name: '', value: '', display: false };
	},
	room: function room(num) {
		return { name: 'bedrooms', value: '' + num + (0, _i18n.t)('room:room'), display: true };
	},
	floor: function floor(num) {
		return { name: 'totalFloors', value: '' + num + (0, _i18n.t)('room:floor'), display: true };
	},
	elevator: function elevator(state) {
		if (state) {
			return { name: 'elevator', value: (0, _i18n.t)('room:yes'), display: true };
		}
		return { name: '', value: '', display: false };
	},
	cleanService: function cleanService(state) {
		return { name: 'cleaningService', value: state, display: true };
	},
	trashService: function trashService(state) {
		return { name: 'garbageDisposal', value: state, display: true };
	}
};

var mapApartmentDetail = exports.mapApartmentDetail = function mapApartmentDetail(data) {
	return Object.keys(APARTMENT_DETAIL_MAP).map(function (key) {
		return APARTMENT_DETAIL_MAP[key](data[key]);
	});
};

var MRT_COLOR_MAP = {
	文山內湖: { name: 'BR', color: '#c38830' },
	淡水信義: { name: 'R', color: '#e1012d' },
	松山新店: { name: 'G', color: '#397f56' },
	中和新蘆: { name: 'O', color: '#f5b61c' },
	板橋南港: { name: 'BL', color: '#056dc2' },
	'Wenshan/Neihu': { name: 'BR', color: '#c38830' },
	'Tamsui-Xinyi': { name: 'R', color: '#e1012d' },
	'Songshan-Xindian': { name: 'G', color: '#397f56' },
	'Zhonghe-Xinlu': { name: 'O', color: '#f5b61c' },
	Bannan: { name: 'BL', color: '#056dc2' }
};

var mapMrtColor = exports.mapMrtColor = function mapMrtColor(mrtLine) {
	return mrtLine.split(',').map(function (line) {
		return {
			station: MRT_COLOR_MAP[line].name + ' ' + line,
			lineColor: MRT_COLOR_MAP[line].color
		};
	});
};

var serverMapEmpty = exports.serverMapEmpty = function serverMapEmpty(value) {
	if (typeof value === 'undefined' || value === null) {
		return '';
	}
	return value;
};

// value 回傳 FEMALE / MALE / OTHER
var mapGenderLabel = exports.mapGenderLabel = function mapGenderLabel(value) {
	return (0, _i18n.t)('settings:' + value);
};

var USER_LEVEL_MAP = {
	1: 'BLACK_LIST', // 黑名單 L4
	2: 'REGISTERED', // 已註冊 L0
	3: 'DENIED', // 資格未過 L.75
	4: 'UNDER_PREVIEW', // 審核中 L0.5
	5: 'BASIC', // 潛水村民 L1
	6: 'CERTIFIED', // 敲門村民 L2
	7: 'RESIDENT' // 入住室友 L3
};

var mapUserLevel = exports.mapUserLevel = function mapUserLevel(id) {
	return USER_LEVEL_MAP[id];
};

var USER_LEVEL_NAME_MAP = {
	1: 'BLOCKED', // 黑名單
	2: 'REGISTERED', // 已註冊
	3: 'MEMBERSHIP_DENIED', // 資格未過
	4: 'MEMBERSHIP_UNDER_REVIEW', // 資格審核中
	5: 'BASIC_MEMBER', // 一般會員
	6: 'CERTIFIED_MEMBER', // 認證會員
	7: 'RESIDENT_MEMBER' // 入住會員
};

var mapUserLevelName = exports.mapUserLevelName = function mapUserLevelName(id) {
	return (0, _i18n.t)('MemberBadge:' + USER_LEVEL_NAME_MAP[id]);
};

var BOOKING_TYPE_MAP = {
	REVIEW: '審核中',
	PROCESSING: '合約進行中',
	FINISHED: '已結束',
	CANCEL: '已作廢'
};

var mapBookingType = exports.mapBookingType = function mapBookingType(key) {
	return BOOKING_TYPE_MAP[key];
};

// PHONE: 'phone',
// LIVE: 'live',
// ONLINE: 'online',
// CHECKIN: 'checkin',
// CHECKOUT: 'checkout',
// INTERVIEW_PHONE: 'interview_phone',
// INTERVIEW_ONLINE: 'interview_online',
var mapReservationEventType = exports.mapReservationEventType = function mapReservationEventType(key) {
	return key.toLowerCase();
};

var convertReservationEvent = exports.convertReservationEvent = function convertReservationEvent(type) {
	return type.toUpperCase();
};

var SOCIAL_TYPE_MAP = {
	FACEBOOK: 'Facebook',
	TWITTER: 'Twitter',
	SPOTIFY: 'Spotify',
	SOUNDCLOUD: 'Soundcloud',
	BEHANCE: 'Behance',
	LINKEDIN: 'Linkedin'
};

var mapSocialType = exports.mapSocialType = function mapSocialType(type) {
	return SOCIAL_TYPE_MAP[type];
};

var covertSocialType = exports.covertSocialType = function covertSocialType(type) {
	return type.toUpperCase();
};

var calculateDigit = exports.calculateDigit = function calculateDigit(num) {
	return ('' + num).split('.')[0].length;
};

var normalizeRange = exports.normalizeRange = function normalizeRange(minMax, digit) {
	var normalizeDigit = Math.pow(10, digit);

	return [Math.floor(minMax[0] / normalizeDigit) * normalizeDigit, Math.ceil(minMax[1] / normalizeDigit) * normalizeDigit];
};

var getLocationFromApartment = exports.getLocationFromApartment = function getLocationFromApartment(cityData, districtData) {
	var city = '';
	var district = '';

	if (cityData) {
		city = cityData.name;
	}

	if (districtData) {
		district = districtData.name;
	}

	return city + ' ' + district;
};

var convertPingToM = exports.convertPingToM = function convertPingToM(value) {
	return Math.round(value * 3.30579 * 100) / 100;
};

var isiOS = exports.isiOS = function isiOS() {
	return !!window.navigator.platform && /iPad|iPhone|iPod/.test(window.navigator.platform);
};

var isOutOfMonth = exports.isOutOfMonth = function isOutOfMonth(month) {
	if (month.length === 1) {
		return parseInt(month, 10) !== 1 && parseInt(month, 10) !== 0;
	}

	return month.length > 2 || parseInt(month, 10) > 12 || parseInt(month, 10) < 1;
};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.wrapFetchAuth = exports.wrapFetchFormData = exports.wrapFetch = exports.generateUrl = exports.SELF_HOST_ENDPOINT = exports.API_ENDPOINT = exports.HOST_MAP = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(232);

var _queryString2 = _interopRequireDefault(_queryString);

var _alert = __webpack_require__(17);

var _authStorage = __webpack_require__(105);

var _authStorage2 = _interopRequireDefault(_authStorage);

var _i18n = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var HOST_MAP = exports.HOST_MAP = {
	dev: 'http://localhost:9000',
	demo: 'https://9floorco-living.25demo.com',
	production: 'https://9floor.co'
};

var SELF_HOST_MAP = {
	dev: 'http://localhost:3000',
	demo: 'https://9floorco-living.25demo.com',
	production: 'https://9floor.co'
};

var API_ENDPOINT = exports.API_ENDPOINT = HOST_MAP["production"];
var SELF_HOST_ENDPOINT = exports.SELF_HOST_ENDPOINT = SELF_HOST_MAP["production"];

var generateUrl = exports.generateUrl = function generateUrl(url, params) {
	var paramsString = _queryString2.default.stringify(params, { arrayFormat: 'bracket' });

	var lan = (0, _i18n.getLanguage)();

	var URL = paramsString !== '' ? API_ENDPOINT + '/backend/api/web/' + (0, _i18n.languageMapRoute)(lan) + '/' + url + '?' + paramsString : API_ENDPOINT + '/backend/api/web/' + (0, _i18n.languageMapRoute)(lan) + '/' + url;

	return URL;
};

var wrapFetch = exports.wrapFetch = function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(url) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { headers: {} };
		var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var URL, headers, result;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						URL = generateUrl(url, params);
						headers = new Headers(_extends({
							'Content-Type': 'application/json',
							Accept: 'application/json'
						}, options.headers));
						_context.next = 4;
						return fetch(URL, _extends({}, options, { headers: headers }));

					case 4:
						result = _context.sent;
						return _context.abrupt('return', result.json());

					case 6:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function wrapFetch(_x) {
		return _ref.apply(this, arguments);
	};
}();

var wrapFetchFormData = exports.wrapFetchFormData = function () {
	var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(url, options) {
		var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var tokenData, tokenDefault, token, URL, result;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						tokenData = _authStorage2.default.getToken();
						tokenDefault = {
							accessToken: '',
							endAt: '',
							expiresIn: '',
							refreshToken: ''
						};
						token = tokenData === null ? tokenDefault : JSON.parse(tokenData);

						if (!(token.accessToken === '')) {
							_context2.next = 5;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', 'No Token Exist');

					case 5:
						URL = generateUrl(url, params);
						_context2.next = 8;
						return fetch(URL, _extends({}, options, {
							headers: _extends({
								Authorization: 'Bearer ' + token.accessToken
							}, options.headers)
						}));

					case 8:
						result = _context2.sent;
						return _context2.abrupt('return', result.json());

					case 10:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, undefined);
	}));

	return function wrapFetchFormData(_x4, _x5) {
		return _ref2.apply(this, arguments);
	};
}();

var wrapFetchAuth = exports.wrapFetchAuth = function wrapFetchAuth(url) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { headers: {} };
	var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	var tokenData = _authStorage2.default.getToken();
	var tokenDefault = {
		accessToken: '',
		endAt: '',
		expiresIn: '',
		refreshToken: ''
	};

	var token = tokenData === null ? tokenDefault : JSON.parse(tokenData);

	if (token.accessToken === '') {
		throw (0, _alert.openFailedAlert)('generic', 'No Token Exist');
	}

	return wrapFetch(url, _extends({}, options, {
		headers: _extends({
			Authorization: 'Bearer ' + token.accessToken
		}, options.headers)
	}), params);
};

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.agreeCookie = exports.updateOffsetTop = exports.loadingRatio = exports.pageChanged = exports.pageChanging = exports.pageEntered = exports.pageEntering = exports.pageLoaded = exports.pageLoading = exports.loadedLibrary = exports.loadConfig = exports.matchMedia = exports.scrollWindow = exports.resizeWindow = undefined;

var _reduxActions = __webpack_require__(5);

var _storage = __webpack_require__(66);

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resizeWindow = exports.resizeWindow = (0, _reduxActions.createAction)('RESIZE_WINDOW', function (width, height) {
	return { width: width, height: height };
});

var scrollWindow = exports.scrollWindow = (0, _reduxActions.createAction)('SCROLL_WINDOW', function (scrollY) {
	return { scrollY: scrollY };
});

var matchMedia = exports.matchMedia = (0, _reduxActions.createAction)('MATCH_MEDIA', function (media) {
	return { media: media };
});

var loadConfig = exports.loadConfig = (0, _reduxActions.createAction)('LOAD_CONFIG', function (config) {
	return config;
});

var loadedLibrary = exports.loadedLibrary = (0, _reduxActions.createAction)('LOAD_LIBRARY', function (lib) {
	return { lib: lib };
});

// 處理頁面 lazy loading
var pageLoading = exports.pageLoading = (0, _reduxActions.createAction)('PAGE_LOADING', function (page) {
	return { page: page };
});

var pageLoaded = exports.pageLoaded = (0, _reduxActions.createAction)('PAGE_LOADED', function (page) {
	return { page: page };
});

var pageEntering = exports.pageEntering = (0, _reduxActions.createAction)('PAGE_ENTERING', function (page) {
	return { page: page };
});

var pageEntered = exports.pageEntered = (0, _reduxActions.createAction)('PAGE_ENTERED', function (page) {
	return { page: page };
});

var pageChanging = exports.pageChanging = (0, _reduxActions.createAction)('PAGE_CHANGING', function (page) {
	return { page: page };
});

var pageChanged = exports.pageChanged = (0, _reduxActions.createAction)('PAGE_CHANGED', function (page) {
	return { page: page };
});

var loadingRatio = exports.loadingRatio = (0, _reduxActions.createAction)('LOADING_RATIO', function (ratio, page) {
	return { ratio: ratio, page: page };
});

var updateOffsetTop = exports.updateOffsetTop = (0, _reduxActions.createAction)('UPDATE_OFFSET_TOP', function (page, section, offsetTop) {
	return {
		page: page,
		section: section,
		offsetTop: offsetTop
	};
});

var agreeCookie = exports.agreeCookie = (0, _reduxActions.createAction)('AGREE_COOKIE', function () {
	_storage2.default.setItem('cookie', JSON.stringify({ display: false }));
});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getRoomById = exports.getMoreRoom = exports.getRoom = exports.updateRoomByApartment = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var _reactRouterRedux = __webpack_require__(36);

var _alert = __webpack_require__(17);

var _apartment = __webpack_require__(145);

var _endpoint = __webpack_require__(35);

var _room = __webpack_require__(229);

var _helper = __webpack_require__(28);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var updateRoomByApartment = exports.updateRoomByApartment = (0, _reduxActions.createAction)('UPDATE_ROOM', function (room) {
	return function (_, getState) {
		var _ref;

		var newRoom = (0, _helper.keyTransform)(room);
		var oldRoom = getState().room.data[room.id] || _room.defaultRoomData;

		return _ref = {}, _ref[newRoom.id] = _extends({}, _room.defaultRoomData, oldRoom, newRoom), _ref;
	};
});

var getRoom = (0, _reduxActions.createAction)('FETCH_ROOM', function () {
	var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	return function () {
		var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
			var _, useedQuery, _ref3, status, message, data, newData, list;

			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_ = query.mrt_line, useedQuery = _objectWithoutProperties(query, ['mrt_line']);
							_context.next = 3;
							return (0, _endpoint.wrapFetch)('room', { method: 'GET' }, useedQuery);

						case 3:
							_ref3 = _context.sent;
							status = _ref3.status;
							message = _ref3.message;
							data = _ref3.data;

							if (!(status !== 200)) {
								_context.next = 9;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 9:
							newData = {};
							list = data.data.map(function (item) {
								newData[item.id] = _extends({}, _room.defaultRoomData, (0, _helper.keyTransform)(item));
								var apartment = newData[item.id].apartment;

								newData[item.id].apartment = undefined;

								dispatch((0, _apartment.updateApartmentByRoom)(apartment, item.id));

								return item.id;
							});
							return _context.abrupt('return', {
								list: list,
								data: newData,
								currentPage: data.current_page,
								lastPage: data.last_page,
								perPage: data.per_page,
								total: data.total
							});

						case 12:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x2) {
			return _ref2.apply(this, arguments);
		};
	}();
});

exports.getRoom = getRoom;
var getMoreRoom = exports.getMoreRoom = (0, _reduxActions.createAction)('FETCH_MORE_ROOM', function () {
	return function () {
		var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
			var _getState, query, currentPage, _ref5, status, message, data, newData, list;

			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_getState = getState(), query = _getState.routing.locationBeforeTransitions.query, currentPage = _getState.room.currentPage;
							_context2.next = 3;
							return (0, _endpoint.wrapFetch)('room', { method: 'GET' }, _extends({}, query, { page: currentPage + 1 }));

						case 3:
							_ref5 = _context2.sent;
							status = _ref5.status;
							message = _ref5.message;
							data = _ref5.data;

							if (!(status !== 200)) {
								_context2.next = 9;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 9:
							newData = {};
							list = data.data.map(function (item) {
								newData[item.id] = _extends({}, _room.defaultRoomData, (0, _helper.keyTransform)(item));
								var apartment = newData[item.id].apartment;

								newData[item.id].apartment = undefined;

								dispatch((0, _apartment.updateApartmentByRoom)(apartment, item.id));

								return item.id;
							});
							return _context2.abrupt('return', {
								list: list,
								data: newData,
								currentPage: data.current_page,
								lastPage: data.last_page,
								perPage: data.per_page,
								total: data.total
							});

						case 12:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x3, _x4) {
			return _ref4.apply(this, arguments);
		};
	}();
});

var getRoomById = exports.getRoomById = (0, _reduxActions.createAction)('FETCH_ROOM_BY_ID', function (id) {
	return function () {
		var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch) {
			var _data;

			var _ref7, status, data, newData, recommend;

			return regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.next = 2;
							return (0, _endpoint.wrapFetch)('room/' + id, {
								method: 'GET'
							});

						case 2:
							_ref7 = _context3.sent;
							status = _ref7.status;
							data = _ref7.data;

							if (!(status !== 200)) {
								_context3.next = 8;
								break;
							}

							dispatch((0, _reactRouterRedux.replace)({ pathname: '/404' }));
							return _context3.abrupt('return', { data: {}, recommend: [] });

						case 8:
							newData = _extends({}, _room.defaultRoomData, (0, _helper.keyTransform)(data.data));


							dispatch((0, _apartment.updateApartmentByRoom)(newData.apartment, newData.id));
							newData.apartment = undefined;

							recommend = data.recommend.map(function (item) {
								dispatch(updateRoomByApartment(item));

								return item.id;
							});
							return _context3.abrupt('return', { data: (_data = {}, _data[newData.id] = newData, _data), recommend: recommend });

						case 13:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, undefined);
		}));

		return function (_x5) {
			return _ref6.apply(this, arguments);
		};
	}();
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setAccessBooking = exports.getOrderItemByRoomId = exports.getOrderById = exports.getOrder = exports.editPay = exports.createOrder = exports.verifyStepTwo = exports.clearCertificateFile = exports.uploadCertificateFile = exports.verifyStepOne = exports.setBookingFormData = exports.bookingGoToStep = exports.updateBookingMonthEpic = exports.updateBookingField = undefined;

var _reduxActions = __webpack_require__(5);

var _reactRouterRedux = __webpack_require__(36);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _endpoint = __webpack_require__(35);

var _alert = __webpack_require__(17);

var _global = __webpack_require__(46);

var _payment = __webpack_require__(943);

var _rent = __webpack_require__(230);

var _helper = __webpack_require__(28);

var _i18n = __webpack_require__(16);

var _exam = __webpack_require__(117);

var _country = __webpack_require__(85);

var _country2 = _interopRequireDefault(_country);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var updateBookingField = exports.updateBookingField = (0, _reduxActions.createAction)('UPDATE_BOOKING_FIELD', function (type, key, value) {
	return function (_, getState) {
		if (type === 'creditForm') {
			if (['cardNumber', 'expireMonth', 'expireYear', 'cvc'].includes(key) && value.value !== '') {
				if (!/^\d+$/.test(value.value) || key === 'cardNumber' && value.value.length > 16 || key === 'expireMonth' && (0, _helper.isOutOfMonth)(value.value) || key === 'expireYear' && value.value.length > 2 || key === 'cvc' && value.value.length > 3) {
					var oldValue = getState().booking.creditForm[key].value;
					return {
						type: type,
						key: key,
						value: { value: oldValue }
					};
				}
			}
		}

		return {
			type: type,
			key: key,
			value: value
		};
	};
});

var updateBookingMonthEpic = exports.updateBookingMonthEpic = function updateBookingMonthEpic(action$) {
	return action$.ofType('UPDATE_BOOKING_FIELD').filter(function (action) {
		return action.payload.type === 'form' && action.payload.key === 'dateFrom';
	}).map(function () {
		return updateBookingField('form', 'rentMonth', { value: { range: [], yearRange: [] } });
	});
};

var bookingGoToStep = exports.bookingGoToStep = (0, _reduxActions.createAction)('BOOKING_GO_TO_STEP', function (step) {
	return { step: step };
});

var setBookingFormData = exports.setBookingFormData = (0, _reduxActions.createAction)('SET_BOOKING_FORM_DATA', function (_ref) {
	var address = _ref.address,
	    emergencyContact = _ref.emergencyContact,
	    emergencyContactMobile = _ref.emergencyContactMobile,
	    emergencyContactMobileCountryCode = _ref.emergencyContactMobileCountryCode,
	    emergencyContactRelationship = _ref.emergencyContactRelationship,
	    emergencyAddress = _ref.emergencyAddress;
	return {
		address: { value: (0, _helper.serverMapEmpty)(address) },
		emergencyContact: {
			value: (0, _helper.serverMapEmpty)(emergencyContact)
		},
		emergencyContactMobile: {
			value: (0, _helper.serverMapEmpty)(emergencyContactMobile),
			country: _country2.default.getCountryByCode(emergencyContactMobileCountryCode)
		},
		emergencyContactRelationship: {
			value: (0, _helper.serverMapEmpty)(emergencyContactRelationship)
		},
		emergencyAddress: {
			value: (0, _helper.serverMapEmpty)(emergencyAddress)
		}
	};
});

var verifyStepOne = exports.verifyStepOne = (0, _reduxActions.createAction)('VERIFY_STEP_ONE', function () {
	return function (dispatch, getState) {
		var _getState = getState(),
		    _getState$booking$for = _getState.booking.form,
		    dateFrom = _getState$booking$for.dateFrom,
		    rentMonth = _getState$booking$for.rentMonth;

		if (dateFrom.value === '' || rentMonth.value.range.length === 0 || rentMonth.value.yearRange.length === 0) {
			dispatch((0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidText')));
			return;
		}

		var _getState2 = getState(),
		    userData = _getState2.user.data;

		dispatch(setBookingFormData(userData));

		dispatch((0, _alert.closeAlert)('booking'));
		dispatch(bookingGoToStep(1));
	};
});

var uploadCertificateFile = exports.uploadCertificateFile = (0, _reduxActions.createAction)('UPLOAD_CERTIFICATE_FILE', function (key, e) {
	var files = e.target.files || e.dataTransfer.files;

	var file = files[0];

	if (typeof file === 'undefined') {
		return { filename: '', file: null };
	}

	return { filename: file.name, file: file, key: key };
});

var clearCertificateFile = exports.clearCertificateFile = (0, _reduxActions.createAction)('CLEAR_CERTIFICATE_FILE', function (key) {
	return { key: key };
});

var generageOrderData = function generageOrderData(lan, form, oldOrderData) {
	var dateFrom = (0, _moment2.default)(form.dateFrom.value, 'X');

	var totalMonth = (0, _rent.calculateMonth)([parseInt(dateFrom.format('M'), 10) - 1].concat(form.rentMonth.value.range), [parseInt(dateFrom.format('YYYY'), 10)].concat(form.rentMonth.value.yearRange));

	var orderItem = form.orderItem.value;

	// Filter the PET CLEANING FEE action if already pay before
	if (oldOrderData) {
		var oldOrderHasPet = oldOrderData.detail.filter(function (item) {
			return item.order_item_id === _rent.ORDER_ITEM_PET_ID;
		}).length > 0;

		if (oldOrderHasPet) {
			orderItem = orderItem.filter(function (id) {
				return id !== _rent.ORDER_ITEM_PET_CLEANING_FEE_ID;
			});
		}
	}

	return {
		name: form.name.value,
		rent_month: totalMonth,
		date_from: dateFrom.format('YYYY/MM/DD'),
		date_to: dateFrom.add(totalMonth, 'M').subtract(1, 'days').format('YYYY/MM/DD'),
		address: form.address.value,
		certificate_type: form.certificateType.value.length > 0 ? form.certificateType.value[0].value : '',
		certificate_number: form.certificate.value,
		extra_certificate_type: form.extraCertificateType.value.length > 0 ? form.extraCertificateType.value[0].value : '',
		extra_certificate_number: form.extraCertificate.value,
		emergency_contact: form.emergencyContact.value,
		emergency_contact_mobile: form.emergencyContactMobile.value,
		emergency_contact_mobile_country_code: form.emergencyContactMobile.country.iso2,
		emergency_contact_relationship: form.emergencyContactRelationship.value,
		order_item_id: orderItem,
		certificate_file: form.certificateFile,
		extra_certificate_file: form.extraCertificateFile,
		emergency_address: form.emergencyAddress.value
	};
};

var validateOrderPolicyData = (0, _reduxActions.createAction)('VALIDATE_ORDER_POLICY_DATA', function (key, valid) {
	return {
		key: key,
		valid: valid
	};
});

var clearValidateOrderPolicyData = (0, _reduxActions.createAction)('CLEAR_VALIDATE_ORDER_POLICY_DATA');

var verifyStepTwo = exports.verifyStepTwo = (0, _reduxActions.createAction)('VERIFY_STEP_TWO', function () {
	return function (dispatch, getState) {
		var _getState3 = getState(),
		    lan = _getState3.i18n.lan,
		    form = _getState3.booking.form;

		var orderData = generageOrderData(lan, form);

		var orderCheckData = (0, _exam.examOrderPolicyData)(orderData);

		dispatch(clearValidateOrderPolicyData());

		if (!orderCheckData.value) {
			if (orderCheckData.notValid.includes('extra_certificate_number')) {
				dispatch((0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidCertificate')));
			} else {
				dispatch((0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidText')));
			}

			var notValidData = (0, _exam.orderPolicyKeyFrom)(orderCheckData.notValid);
			notValidData.forEach(function (key) {
				return dispatch(validateOrderPolicyData(key, false));
			});
			window.scrollTo(0, 0);
			return;
		}

		if (!form.emergencyContactMobile.validate) {
			dispatch((0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidFormat')));
			dispatch(validateOrderPolicyData('emergencyContactMobile', false));
			window.scrollTo(0, 0);
			return;
		}

		if (!form.accept.value) {
			dispatch((0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notAcceptText')));
			window.scrollTo(0, 0);
			return;
		}

		if (!form.acceptInsurance.value) {
			dispatch((0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notAcceptInsuranceText')));
			window.scrollTo(0, 0);
			return;
		}

		dispatch((0, _alert.closeAlert)('booking'));
		dispatch(bookingGoToStep(2));
	};
});

var createOrder = exports.createOrder = (0, _reduxActions.createAction)('CREATE_ORDER', function (roomId, orderId) {
	return function () {
		var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
			var _getState4, lan, creditForm, creditData, creditCheckData, notValidData, _getState5, _getState5$booking, form, bookingData, _getState5$user$data, name, certificateType, certificateNumber, oldOrderData, orderData, orderFormData, _ref3, status, message;

			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_getState4 = getState(), lan = _getState4.i18n.lan, creditForm = _getState4.booking.creditForm;
							creditData = (0, _payment.generateCreditData)(creditForm);
							creditCheckData = (0, _exam.examCreditData)(creditData);


							dispatch((0, _payment.clearValidateOrderCreditData)());

							if (creditCheckData.value) {
								_context.next = 22;
								break;
							}

							if (!creditCheckData.notValid.includes('card_number')) {
								_context.next = 9;
								break;
							}

							dispatch((0, _payment.validateOrderCreditData)('cardNumber', false));
							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidCreditNumber'));

						case 9:
							if (!(creditCheckData.notValid.includes('expiry_year') || creditCheckData.notValid.includes('expiry_month'))) {
								_context.next = 14;
								break;
							}

							dispatch((0, _payment.validateOrderCreditData)('expireYear', false));
							dispatch((0, _payment.validateOrderCreditData)('expireMonth', false));
							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidCreditDate'));

						case 14:
							if (!creditCheckData.notValid.includes('security_code')) {
								_context.next = 18;
								break;
							}

							dispatch((0, _payment.validateOrderCreditData)('cvc', false));
							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidCreditCVC'));

						case 18:
							notValidData = (0, _exam.creditKeyFrom)(creditCheckData.notValid);

							notValidData.forEach(function (key) {
								return dispatch((0, _payment.validateOrderCreditData)(key, false));
							});
							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidCreditNumber'));

						case 22:
							_getState5 = getState(), _getState5$booking = _getState5.booking, form = _getState5$booking.form, bookingData = _getState5$booking.data, _getState5$user$data = _getState5.user.data, name = _getState5$user$data.name, certificateType = _getState5$user$data.certificateType, certificateNumber = _getState5$user$data.certificateNumber;
							oldOrderData = orderId ? bookingData[orderId] : null;
							orderData = generageOrderData(lan, form, oldOrderData);
							orderFormData = new FormData();


							orderFormData.append('room_id', roomId);
							orderFormData.append('name', name);
							orderFormData.append('rent_month', orderData.rent_month);
							orderFormData.append('date_from', orderData.date_from);
							orderFormData.append('date_to', orderData.date_to);
							orderFormData.append('address', orderData.address);
							orderFormData.append('certificate_type', certificateType);
							orderFormData.append('certificate_file', orderData.certificate_file.file, orderData.certificate_file.filename);
							orderFormData.append('certificate_number', certificateNumber);
							orderFormData.append('emergency_contact', orderData.emergency_contact);
							orderFormData.append('emergency_contact_mobile', orderData.emergency_contact_mobile);
							orderFormData.append('emergency_contact_mobile_country_code', orderData.emergency_contact_mobile_country_code);
							orderFormData.append('emergency_contact_relationship', orderData.emergency_contact_relationship);
							orderFormData.append('emergency_address', orderData.emergency_address);

							orderData.order_item_id.forEach(function (id) {
								return orderFormData.append('order_item_id[]', id);
							});

							// Have 第二人入住
							if (form.orderItem.value.includes(_rent.ORDER_ITEM_EXTRA_PERSON_ID)) {
								orderFormData.append('extra_certificate_type', orderData.extra_certificate_type);
								orderFormData.append('extra_certificate_file', orderData.extra_certificate_file.file, orderData.extra_certificate_file.filename);
								orderFormData.append('extra_certificate_number', orderData.extra_certificate_number);
							}

							if (orderId) {
								orderFormData.append('original_order_id', orderId);
							}

							// Credit Card Data
							orderFormData.append('card_number', creditData.card_number);
							orderFormData.append('expiry_year', creditData.expiry_year);
							orderFormData.append('expiry_month', creditData.expiry_month);
							orderFormData.append('security_code', creditData.security_code);
							orderFormData.append('credit_name', creditData.credit_name);

							dispatch((0, _global.pageChanging)('CREATE_BOOKING_ORDER'));
							dispatch((0, _global.loadingRatio)(0.3, 'CREATE_BOOKING_ORDER'));

							_context.next = 52;
							return (0, _endpoint.wrapFetchFormData)('order', {
								method: 'POST',
								body: orderFormData
							});

						case 52:
							_ref3 = _context.sent;
							status = _ref3.status;
							message = _ref3.message;


							dispatch((0, _global.loadingRatio)(0.8, 'CREATE_BOOKING_ORDER'));
							_context.next = 58;
							return (0, _helper.sleep)(300);

						case 58:
							dispatch((0, _global.pageChanged)('CREATE_BOOKING_ORDER'));

							if (!(status !== 200 && status !== 201)) {
								_context.next = 68;
								break;
							}

							if (!(message === 'credit card number error')) {
								_context.next = 63;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidCreditNumber')));
							return _context.abrupt('return');

						case 63:
							if (!(message === 'credit card expired')) {
								_context.next = 66;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:expiredCreditCard')));
							return _context.abrupt('return');

						case 66:

							dispatch((0, _alert.openFailedAlert)('booking', message));
							return _context.abrupt('return');

						case 68:

							dispatch((0, _alert.closeAlert)('booking'));
							dispatch(bookingGoToStep(3));

						case 70:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x, _x2) {
			return _ref2.apply(this, arguments);
		};
	}();
});

var editPay = exports.editPay = (0, _reduxActions.createAction)('CONFIRM_PAY', function () {
	return function () {
		var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
			var _getState6, lan;

			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return dispatch((0, _payment.addCreditCard)());

						case 2:
							_getState6 = getState(), lan = _getState6.i18n.lan;


							dispatch((0, _reactRouterRedux.push)('/' + (0, _i18n.languageMapRoute)(lan) + '/user/booking'));

						case 4:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x3, _x4) {
			return _ref4.apply(this, arguments);
		};
	}();
});

var getOrder = exports.getOrder = (0, _reduxActions.createAction)('FETCH_ORDER', _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
	var _ref6, status, data, message, bookingData, list, current, old;

	return regeneratorRuntime.wrap(function _callee3$(_context3) {
		while (1) {
			switch (_context3.prev = _context3.next) {
				case 0:
					_context3.next = 2;
					return (0, _endpoint.wrapFetchAuth)('order', { method: 'GET' });

				case 2:
					_ref6 = _context3.sent;
					status = _ref6.status;
					data = _ref6.data;
					message = _ref6.message;

					if (!(status !== 200)) {
						_context3.next = 8;
						break;
					}

					throw (0, _alert.openFailedAlert)('generic', message);

				case 8:
					bookingData = {};
					list = data.map(function (item) {
						bookingData[item.id] = (0, _helper.keyTransform)(item);

						return item.id;
					});
					current = list.filter(function (id) {
						return ['REVIEW', 'PROCESSING'].includes(bookingData[id].status);
					});
					old = list.filter(function (id) {
						return ['FINISHED', 'CANCEL'].includes(bookingData[id].status);
					});
					return _context3.abrupt('return', { current: current, old: old, data: bookingData });

				case 13:
				case 'end':
					return _context3.stop();
			}
		}
	}, _callee3, undefined);
})));

var getOrderById = exports.getOrderById = (0, _reduxActions.createAction)('FETCH_ORDER_BY_ID', function () {
	var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(orderId) {
		var _ref8, status, data, message;

		return regeneratorRuntime.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.next = 2;
						return (0, _endpoint.wrapFetchAuth)('order/' + orderId, { method: 'GET' });

					case 2:
						_ref8 = _context4.sent;
						status = _ref8.status;
						data = _ref8.data;
						message = _ref8.message;

						if (!(status !== 200)) {
							_context4.next = 8;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 8:
						return _context4.abrupt('return', { data: (0, _helper.keyTransform)(data) });

					case 9:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, undefined);
	}));

	return function (_x5) {
		return _ref7.apply(this, arguments);
	};
}());

var getOrderItemByRoomId = exports.getOrderItemByRoomId = (0, _reduxActions.createAction)('FETCH_ORDER_ITEM_BY_ROOM_ID', function () {
	var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(roomId) {
		var _ref10, status, data, message, orderItemData, list;

		return regeneratorRuntime.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						_context5.next = 2;
						return (0, _endpoint.wrapFetchAuth)('room/' + roomId + '/orderItem', {
							method: 'GET'
						});

					case 2:
						_ref10 = _context5.sent;
						status = _ref10.status;
						data = _ref10.data;
						message = _ref10.message;

						if (!(status !== 200)) {
							_context5.next = 8;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 8:
						orderItemData = {};
						list = data.map(function (item) {
							orderItemData[item.id] = (0, _helper.keyTransform)(item);

							return item.id;
						});
						return _context5.abrupt('return', { data: orderItemData, list: list });

					case 11:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, undefined);
	}));

	return function (_x6) {
		return _ref9.apply(this, arguments);
	};
}());

var setAccessBooking = exports.setAccessBooking = (0, _reduxActions.createAction)('SET_ACCESS_BOOKING');

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.handleForgetVerifyModalEpic = exports.closeMessageModalEpic = exports.closeMessageModal = exports.handleLoginModalEpic = exports.openMessageModalEpic = exports.openMessageModal = undefined;

var _reduxActions = __webpack_require__(5);

var _reactRouterRedux = __webpack_require__(36);

var _alert = __webpack_require__(17);

var _i18n = __webpack_require__(16);

var setModalBackgroundScrollY = (0, _reduxActions.createAction)('SET_MODAL_BACKGROUND_SCROLLY', function (scrollY) {
	if (!document.body.className.includes('no-scroll')) {
		document.body.style.top = '-' + scrollY + 'px';
		document.body.className += ' no-scroll';
	}
	return scrollY;
});

var restoreModalBackgroundScrollY = (0, _reduxActions.createAction)('RESTORE_MODAL_BACKGROUND_SCROLLY', function (globalTop) {
	document.body.className = document.body.className.replace(' no-scroll', '');
	document.body.style.top = 'unset';
	window.scrollTo(0, globalTop);
});

var openMessageModal = exports.openMessageModal = (0, _reduxActions.createAction)('OPEN_MESSAGE_MODAL', function (modal, message) {
	return {
		modal: modal,
		message: message
	};
});

// Set modal background scroll position
var openMessageModalEpic = exports.openMessageModalEpic = function openMessageModalEpic(action$, store) {
	return action$.ofType('OPEN_MESSAGE_MODAL').map(function () {
		var _store$getState = store.getState(),
		    scrollY = _store$getState.global.scrollY;

		return setModalBackgroundScrollY(scrollY);
	});
};

// Handle open login modal
var handleLoginModalEpic = exports.handleLoginModalEpic = function handleLoginModalEpic(action$) {
	return action$.ofType('OPEN_MESSAGE_MODAL').filter(function (action) {
		return action.payload.modal === 'loginSignup' && action.payload.message.type === 'loginForm';
	}).map(function () {
		return (0, _alert.openSuccessAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:welcomeBack'));
	});
};

var closeMessageModal = exports.closeMessageModal = (0, _reduxActions.createAction)('CLOSE_MESSAGE_MODAL', function (modal) {
	return function (dispatch) {
		dispatch((0, _alert.closeAlert)(modal));
		return { modal: modal };
	};
});

// Restore modal background scroll position after close modal
var closeMessageModalEpic = exports.closeMessageModalEpic = function closeMessageModalEpic(action$, store) {
	return action$.ofType('CLOSE_MESSAGE_MODAL').map(function () {
		var _store$getState2 = store.getState(),
		    globalTop = _store$getState2.modal.globalTop;

		return restoreModalBackgroundScrollY(globalTop);
	});
};

// Handle forget, verify email modal close
var handleForgetVerifyModalEpic = exports.handleForgetVerifyModalEpic = function handleForgetVerifyModalEpic(action$, store) {
	return action$.ofType('CLOSE_MESSAGE_MODAL').filter(function (action) {
		return action.payload.modal === 'loginSignup';
	}).map(function () {
		var _store$getState3 = store.getState(),
		    pathname = _store$getState3.routing.locationBeforeTransitions.pathname,
		    accessToken = _store$getState3.auth.token.accessToken;

		if (pathname.includes('forget') || pathname.includes('verify') || pathname.includes('signup') || pathname.includes('login') && accessToken === '') {
			return (0, _reactRouterRedux.replace)('/');
		}

		return { type: 'CLOSE_LOGIN_SIGNUP_MODAL' };
	});
};

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var data = {};
var isLocalStorageSupport = true;

var prefix = function prefix(key) {
	return 'frontend-' + key;
};

var getLanguageLocalStorage = exports.getLanguageLocalStorage = function getLanguageLocalStorage() {
	return prefix('i18nextLng');
};

var detectLocalStorageSupport = exports.detectLocalStorageSupport = function detectLocalStorageSupport() {
	try {
		window.localStorage.setItem('test', '1');
		window.localStorage.removeItem('test');
	} catch (e) {
		console.warn('Does not support localStorage', e);
		isLocalStorageSupport = false;
	}
};

var setItem = function setItem(key, value) {
	var prefixKey = prefix(key);

	if (isLocalStorageSupport) {
		window.localStorage.setItem(prefixKey, value);
		return;
	}

	data[prefixKey] = value;
};

var getItem = function getItem(key) {
	var prefixKey = prefix(key);

	if (isLocalStorageSupport) {
		return window.localStorage.getItem(prefixKey);
	}

	if (Object.hasOwnProperty.call(data, prefixKey)) {
		return data[prefixKey];
	}

	return null;
};

var removeItem = function removeItem(key) {
	var prefixKey = prefix(key);

	if (isLocalStorageSupport) {
		window.localStorage.removeItem(prefixKey);
		return;
	}

	if (Object.hasOwnProperty.call(data, prefixKey)) {
		delete data[prefixKey];
	}
};

exports.default = {
	setItem: setItem,
	getItem: getItem,
	removeItem: removeItem
};


var sessionData = {};
var isSessionStorageSupport = true;

var detectSessionStorageSupport = exports.detectSessionStorageSupport = function detectSessionStorageSupport() {
	try {
		window.sessionStorage.setItem('test', '1');
		window.sessionStorage.removeItem('test');
	} catch (e) {
		console.warn('Does not support sessionStorage', e);
		isSessionStorageSupport = false;
	}
};

var setSessionItem = function setSessionItem(key, value) {
	var prefixKey = prefix(key);

	if (isSessionStorageSupport) {
		window.sessionStorage.setItem(prefixKey, value);
		return;
	}

	sessionData[prefixKey] = value;
};

var getSessionItem = function getSessionItem(key) {
	var prefixKey = prefix(key);

	if (isSessionStorageSupport) {
		return window.sessionStorage.getItem(prefixKey);
	}

	if (Object.hasOwnProperty.call(sessionData, prefixKey)) {
		return sessionData[prefixKey];
	}

	return null;
};

var removeSessionItem = function removeSessionItem(key) {
	var prefixKey = prefix(key);

	if (isSessionStorageSupport) {
		window.sessionStorage.removeItem(prefixKey);
		return;
	}

	if (Object.hasOwnProperty.call(sessionData, prefixKey)) {
		delete sessionData[prefixKey];
	}
};

var sessionStorage = exports.sessionStorage = {
	setItem: setSessionItem,
	getItem: getSessionItem,
	removeItem: removeSessionItem
};

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translate__ = __webpack_require__(783);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "translate", function() { return __WEBPACK_IMPORTED_MODULE_0__translate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__I18n__ = __webpack_require__(273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I18n", function() { return __WEBPACK_IMPORTED_MODULE_1__I18n__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Interpolate__ = __webpack_require__(787);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Interpolate", function() { return __WEBPACK_IMPORTED_MODULE_2__Interpolate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Trans__ = __webpack_require__(788);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Trans", function() { return __WEBPACK_IMPORTED_MODULE_3__Trans__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__ = __webpack_require__(794);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I18nextProvider", function() { return __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loadNamespaces__ = __webpack_require__(795);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return __WEBPACK_IMPORTED_MODULE_5__loadNamespaces__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactI18nextModule", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaults", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaults", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setI18n", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getI18n", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["b"]; });








/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getUserOverview = exports.removeIgAccessToken = exports.getIgMedia = exports.setIgAccessToken = exports.uploadUserPhoto = exports.updateUserCareerOptionData = exports.getUserCareerOptionData = exports.updateUserProfessionOptionData = exports.getUserProfessionOptionData = exports.updateUserInterestOptionData = exports.getUserInterestOptionData = exports.getUserJobTypeOptionData = exports.applyUserDataProcess = exports.getUser = exports.showAlert = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouterRedux = __webpack_require__(36);

var _alert = __webpack_require__(17);

var _endpoint = __webpack_require__(35);

var _helper = __webpack_require__(28);

var _exam = __webpack_require__(117);

var _util = __webpack_require__(568);

var _country = __webpack_require__(85);

var _country2 = _interopRequireDefault(_country);

var _i18n = __webpack_require__(16);

var _storage = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var showAlert = exports.showAlert = (0, _reduxActions.createAction)('SHOW_ALERT', function (message, success) {
	return {
		show: true,
		message: message,
		success: success
	};
});

var getUser = exports.getUser = (0, _reduxActions.createAction)('FETCH_USER', function () {
	return function () {
		var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
			var _ref2, status, message, data, transData, favoriteData, songData, songList, socialData, socialList, certificate;

			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return (0, _endpoint.wrapFetchAuth)('user', {
								method: 'GET'
							});

						case 2:
							_ref2 = _context.sent;
							status = _ref2.status;
							message = _ref2.message;
							data = _ref2.data;

							if (!(status !== 200)) {
								_context.next = 8;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 8:
							transData = (0, _helper.keyTransform)(data);


							if ((0, _helper.mapUserLevel)(transData.levelId) === 'REGISTERED') {
								dispatch((0, _alert.openSuccessAlert)('settings', (0, _i18n.t)('settings:welcomeText')));
							}

							if ((0, _helper.mapUserLevel)(transData.levelId) === 'DENIED') {
								dispatch((0, _alert.openFailedAlert)('settings', (0, _i18n.t)('settings:deniedText')));
							}

							favoriteData = {};
							songData = {};
							songList = transData.songs.map(function (item) {
								favoriteData[item.spotify_id] = item.id;
								songData[item.spotify_id] = {
									name: item.name,
									album: {
										name: item.album_name,
										images: [{ id: 0, url: item.album_image }]
									},
									artists: item.artist_name.split(', ').map(function (name) {
										return { name: name };
									})
								};

								return item.spotify_id;
							});
							socialData = {};
							socialList = transData.socialMedia.map(function (item) {
								socialData[item.id] = _extends({}, item, { type: (0, _helper.mapSocialType)(item.type) });
								return item.id;
							});
							certificate = {
								type: [],
								value: transData.certificateNumber === null ? '' : transData.certificateNumber
							};


							if (transData.certificateType !== null) {
								certificate.type.push({
									value: transData.certificateType,
									label: (0, _i18n.t)('certificateType:' + transData.certificateType)
								});
							}

							return _context.abrupt('return', {
								name: { value: (0, _helper.serverMapEmpty)(transData.name) },
								gender: { value: { value: transData.gender, label: (0, _helper.mapGenderLabel)(transData.gender) } },
								jobTypes: { value: transData.jobTypes.map(function (item) {
										return { value: item.id, label: item.name };
									}) },
								birth: {
									value: (0, _helper.serverMapEmpty)(transData.birth) !== '' ? (0, _moment2.default)((0, _helper.serverMapEmpty)(transData.birth), 'YYYY/MM/DD').format('X') : ''
								},
								country: {
									value: transData.country === null ? [] : [{ value: transData.country, label: (0, _util.mapCountryCode)(transData.country) }]
								},
								certificate: certificate,
								professions: {
									value: transData.professions.map(function (item) {
										return { value: item.id, label: item.name };
									})
								},
								phone: {
									value: (0, _helper.serverMapEmpty)(transData.phone),
									country: _country2.default.getCountryByCode(transData.phoneCountry)
								},
								expect: { value: (0, _helper.serverMapEmpty)(transData.expect) },
								open: { value: transData.open === 1 },
								nickname: { value: (0, _helper.serverMapEmpty)(transData.nickname) },
								company: { value: (0, _helper.serverMapEmpty)(transData.company) },
								career: {
									value: transData.careers.map(function (item) {
										return { value: item.id, label: item.name };
									})
								},
								intro: { value: (0, _helper.serverMapEmpty)(transData.intro) },
								interests: { value: transData.interests.map(function (item) {
										return { value: item.id, label: item.name };
									}) },
								songs: { value: songList, favoriteData: favoriteData },
								socialMedia: { value: socialList, data: socialData, latestIndex: -1 },
								image: { value: (0, _helper.serverMapEmpty)(transData.image), url: (0, _helper.serverMapEmpty)(transData.imageUrl) },
								data: transData,

								songData: songData,

								social: { list: socialList, data: socialData, latestIndex: -1 }
							});

						case 19:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x) {
			return _ref.apply(this, arguments);
		};
	}();
});

var generateUserData = function generateUserData(lan, userData, songData) {
	return {
		name: userData.name.value,
		gender: userData.gender.value.value,
		job_types: userData.jobTypes.value.map(function (item) {
			return { id: item.value };
		}),
		birth: userData.birth.value !== '' ? (0, _moment2.default)(userData.birth.value, 'X').format('YYYY/MM/DD') : '',
		country: userData.country.value.length > 0 ? userData.country.value[0].value : '',
		certificate_type: userData.certificate.type.length > 0 ? userData.certificate.type[0].value : '',
		certificate_number: userData.certificate.value,
		professions: userData.professions.value.map(function (item) {
			return { id: item.value };
		}),
		phone: userData.phone.value,
		phone_country: userData.phone.country.iso2,
		expect: userData.expect.value,
		open: userData.open.value ? 1 : 0,
		nickname: userData.nickname.value,
		company: userData.company.value,
		careers: userData.career.value.map(function (item) {
			return { id: item.value };
		}),
		intro: userData.intro.value,
		interests: userData.interests.value.map(function (item) {
			return { id: item.value };
		}),
		songs: userData.songs.value.map(function (id) {
			return {
				id: Object.keys(userData.songs.favoriteData).includes(id) ? userData.songs.favoriteData[id] : null,
				spotify_id: id,
				name: songData[id].name,
				album_name: songData[id].album.name,
				album_image: songData[id].album.images.length > 0 ? songData[id].album.images[0].url : '',
				artist_name: songData[id].artists.map(function (artist) {
					return artist.name;
				}).join(', ')
			};
		}),
		social_media: userData.socialMedia.value.map(function (id) {
			if (id < 0) {
				return {
					id: null,
					url: userData.socialMedia.data[id].url,
					type: (0, _helper.covertSocialType)(userData.socialMedia.data[id].type)
				};
			}

			return _extends({}, userData.socialMedia.data[id], {
				type: (0, _helper.covertSocialType)(userData.socialMedia.data[id].type)
			});
		}),

		image: userData.image.value
	};
};

var validateUserData = (0, _reduxActions.createAction)('VALIDATE_USER_DATA', function (key, valid) {
	return { key: key, valid: valid };
});

var clearValidateUserData = (0, _reduxActions.createAction)('CLEAR_VALIDATE_USER_DATA');

var applyUserDataProcess = exports.applyUserDataProcess = (0, _reduxActions.createAction)('APPLY_USER_DATA_PROCESS', function () {
	return function () {
		var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
			var _getState, lan, _getState$user, form, levelId, userIgData, songData, userData, userCheckData, userCheckCertificateData, result;

			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_getState = getState(), lan = _getState.i18n.lan, _getState$user = _getState.user, form = _getState$user.form, levelId = _getState$user.data.levelId, userIgData = _getState$user.userIgData, songData = _getState.song.data;
							userData = generateUserData(lan, form, songData);
							userCheckData = (0, _exam.examUserData)(userData, userIgData, form.phone);


							dispatch(clearValidateUserData());
							dispatch((0, _alert.closeAlert)('settings'));

							if (userCheckData.value) {
								_context2.next = 11;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('settings', (0, _i18n.t)('settings:notValidText')));
							userCheckData.notValid.forEach(function (key) {
								return dispatch(validateUserData((0, _helper.toCamelCase)(key), false));
							});

							window.scrollTo(0, 0);
							document.activeElement.blur();
							return _context2.abrupt('return');

						case 11:
							userCheckCertificateData = (0, _exam.examUserCertificateData)(userData);

							if (userCheckCertificateData.value) {
								_context2.next = 18;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('settings', (0, _i18n.t)('settings:notValidCertificate')));
							dispatch(validateUserData('certificate', false));

							window.scrollTo(0, 0);
							document.activeElement.blur();
							return _context2.abrupt('return');

						case 18:
							result = {};

							if (!['REGISTERED', 'DENIED'].includes((0, _helper.mapUserLevel)(levelId))) {
								_context2.next = 25;
								break;
							}

							_context2.next = 22;
							return (0, _endpoint.wrapFetchAuth)('user/apply', {
								method: 'POST',
								body: JSON.stringify(userData)
							});

						case 22:
							result = _context2.sent;
							_context2.next = 28;
							break;

						case 25:
							_context2.next = 27;
							return (0, _endpoint.wrapFetchAuth)('user/update', {
								method: 'POST',
								body: JSON.stringify(userData)
							});

						case 27:
							result = _context2.sent;

						case 28:
							if (!(result.status !== 200)) {
								_context2.next = 33;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('settings', result.message));
							window.scrollTo(0, 0);
							document.activeElement.blur();
							return _context2.abrupt('return');

						case 33:

							_storage.sessionStorage.removeItem('userForm');

							dispatch(getUser());
							window.scrollTo(0, 0);
							document.activeElement.blur();

						case 37:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x2, _x3) {
			return _ref3.apply(this, arguments);
		};
	}();
});

var getUserJobTypeOptionData = exports.getUserJobTypeOptionData = (0, _reduxActions.createAction)('FETCH_USER_JOB_TYPE_OPTION_DATA', _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
	var _ref5, status, message, data;

	return regeneratorRuntime.wrap(function _callee3$(_context3) {
		while (1) {
			switch (_context3.prev = _context3.next) {
				case 0:
					_context3.next = 2;
					return (0, _endpoint.wrapFetchAuth)('user/getJobType', {
						method: 'GET'
					});

				case 2:
					_ref5 = _context3.sent;
					status = _ref5.status;
					message = _ref5.message;
					data = _ref5.data;

					if (!(status !== 200)) {
						_context3.next = 8;
						break;
					}

					throw (0, _alert.openFailedAlert)('generic', message);

				case 8:
					return _context3.abrupt('return', {
						jobTypes: (0, _helper.normalizeArray)(data)
					});

				case 9:
				case 'end':
					return _context3.stop();
			}
		}
	}, _callee3, undefined);
})));

var getUserInterestOptionData = exports.getUserInterestOptionData = (0, _reduxActions.createAction)('FETCH_USER_INTEREST_OPTION_DATA', function () {
	var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4() {
		var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		var _ref7, status, message, data;

		return regeneratorRuntime.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.next = 2;
						return (0, _endpoint.wrapFetchAuth)('user/getInterest', {
							method: 'GET'
						}, name !== '' ? { name: name } : {});

					case 2:
						_ref7 = _context4.sent;
						status = _ref7.status;
						message = _ref7.message;
						data = _ref7.data;

						if (!(status !== 200)) {
							_context4.next = 8;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 8:
						return _context4.abrupt('return', {
							interests: (0, _helper.normalizeArray)(data)
						});

					case 9:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, undefined);
	}));

	return function () {
		return _ref6.apply(this, arguments);
	};
}());

var updateUserInterestOptionData = exports.updateUserInterestOptionData = (0, _reduxActions.createAction)('UPDATE_USER_INTEREST_OPTION_DATA', function () {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	return function () {
		var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
			var _getState2, interests, existValue, existOption, _ref9, status, message, data;

			return regeneratorRuntime.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_getState2 = getState(), interests = _getState2.user.form.interests;
							existValue = interests.value.filter(function (item) {
								return item.label.toLowerCase() === name.toLowerCase();
							});

							if (!(existValue.length > 0)) {
								_context5.next = 4;
								break;
							}

							return _context5.abrupt('return', { value: interests.value });

						case 4:
							existOption = interests.list.filter(function (id) {
								return interests.data[id].name.toLowerCase() === name.toLowerCase();
							}).map(function (id) {
								return { value: id, label: interests.data[id].name };
							});

							if (!(existOption.length > 0)) {
								_context5.next = 8;
								break;
							}

							dispatch(getUserInterestOptionData());
							return _context5.abrupt('return', { value: [].concat(interests.value, existOption), inputValue: '' });

						case 8:
							_context5.next = 10;
							return (0, _endpoint.wrapFetchAuth)('user/getInterest', {
								method: 'POST',
								body: JSON.stringify({ name: name })
							});

						case 10:
							_ref9 = _context5.sent;
							status = _ref9.status;
							message = _ref9.message;
							data = _ref9.data;

							if (!(status !== 200)) {
								_context5.next = 16;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 16:

							dispatch(getUserInterestOptionData());

							return _context5.abrupt('return', { value: [].concat(interests.value, [{ value: data.id, label: data.name }]), inputValue: '' });

						case 18:
						case 'end':
							return _context5.stop();
					}
				}
			}, _callee5, undefined);
		}));

		return function (_x6, _x7) {
			return _ref8.apply(this, arguments);
		};
	}();
});

var getUserProfessionOptionData = exports.getUserProfessionOptionData = (0, _reduxActions.createAction)('FETCH_USER_PROFESSION_OPTION_DATA', function () {
	var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6() {
		var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		var _ref11, status, message, data;

		return regeneratorRuntime.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						_context6.next = 2;
						return (0, _endpoint.wrapFetchAuth)('user/getProfession', {
							method: 'GET'
						}, name !== '' ? { name: name } : {});

					case 2:
						_ref11 = _context6.sent;
						status = _ref11.status;
						message = _ref11.message;
						data = _ref11.data;

						if (!(status !== 200)) {
							_context6.next = 8;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 8:
						return _context6.abrupt('return', {
							professions: (0, _helper.normalizeArray)(data)
						});

					case 9:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, undefined);
	}));

	return function () {
		return _ref10.apply(this, arguments);
	};
}());

var updateUserProfessionOptionData = exports.updateUserProfessionOptionData = (0, _reduxActions.createAction)('UPDATE_USER_PROFESSION_OPTION_DATA', function () {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	return function () {
		var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
			var _getState3, professions, existValue, existOption, _ref13, status, message, data;

			return regeneratorRuntime.wrap(function _callee7$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							_getState3 = getState(), professions = _getState3.user.form.professions;
							existValue = professions.value.filter(function (item) {
								return item.label.toLowerCase() === name.toLowerCase();
							});

							if (!(existValue.length > 0)) {
								_context7.next = 4;
								break;
							}

							return _context7.abrupt('return', { value: professions.value });

						case 4:
							existOption = professions.list.filter(function (id) {
								return professions.data[id].name.toLowerCase() === name.toLowerCase();
							}).map(function (id) {
								return { value: id, label: professions.data[id].name };
							});

							if (!(existOption.length > 0)) {
								_context7.next = 8;
								break;
							}

							dispatch(getUserProfessionOptionData());
							return _context7.abrupt('return', { value: [].concat(professions.value, existOption), inputValue: '' });

						case 8:
							_context7.next = 10;
							return (0, _endpoint.wrapFetchAuth)('user/getProfession', {
								method: 'POST',
								body: JSON.stringify({ name: name })
							});

						case 10:
							_ref13 = _context7.sent;
							status = _ref13.status;
							message = _ref13.message;
							data = _ref13.data;

							if (!(status !== 200)) {
								_context7.next = 16;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 16:

							dispatch(getUserProfessionOptionData());

							return _context7.abrupt('return', { value: [].concat(professions.value, [{ value: data.id, label: data.name }]), inputValue: '' });

						case 18:
						case 'end':
							return _context7.stop();
					}
				}
			}, _callee7, undefined);
		}));

		return function (_x10, _x11) {
			return _ref12.apply(this, arguments);
		};
	}();
});

var getUserCareerOptionData = exports.getUserCareerOptionData = (0, _reduxActions.createAction)('FETCH_USER_CAREER_OPTION_DATA', function () {
	var _ref14 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8() {
		var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		var _ref15, status, message, data;

		return regeneratorRuntime.wrap(function _callee8$(_context8) {
			while (1) {
				switch (_context8.prev = _context8.next) {
					case 0:
						_context8.next = 2;
						return (0, _endpoint.wrapFetchAuth)('user/getCareer', {
							method: 'GET'
						}, name !== '' ? { name: name } : {});

					case 2:
						_ref15 = _context8.sent;
						status = _ref15.status;
						message = _ref15.message;
						data = _ref15.data;

						if (!(status !== 200)) {
							_context8.next = 8;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 8:
						return _context8.abrupt('return', {
							career: (0, _helper.normalizeArray)(data)
						});

					case 9:
					case 'end':
						return _context8.stop();
				}
			}
		}, _callee8, undefined);
	}));

	return function () {
		return _ref14.apply(this, arguments);
	};
}());

var updateUserCareerOptionData = exports.updateUserCareerOptionData = (0, _reduxActions.createAction)('UPDATE_USER_CAREER_OPTION_DATA', function () {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	return function () {
		var _ref16 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState) {
			var _getState4, career, existValue, existOption, _ref17, status, message, data;

			return regeneratorRuntime.wrap(function _callee9$(_context9) {
				while (1) {
					switch (_context9.prev = _context9.next) {
						case 0:
							_getState4 = getState(), career = _getState4.user.form.career;
							existValue = career.value.filter(function (item) {
								return item.label.toLowerCase() === name.toLowerCase();
							});

							if (!(existValue.length > 0)) {
								_context9.next = 4;
								break;
							}

							return _context9.abrupt('return', { value: career.value });

						case 4:
							existOption = career.list.filter(function (id) {
								return career.data[id].name.toLowerCase() === name.toLowerCase();
							}).map(function (id) {
								return { value: id, label: career.data[id].name };
							});

							if (!(existOption.length > 0)) {
								_context9.next = 8;
								break;
							}

							dispatch(getUserCareerOptionData());
							return _context9.abrupt('return', { value: [].concat(career.value, existOption), inputValue: '' });

						case 8:
							_context9.next = 10;
							return (0, _endpoint.wrapFetchAuth)('user/getCareer', {
								method: 'POST',
								body: JSON.stringify({ name: name })
							});

						case 10:
							_ref17 = _context9.sent;
							status = _ref17.status;
							message = _ref17.message;
							data = _ref17.data;

							if (!(status !== 200)) {
								_context9.next = 16;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 16:

							dispatch(getUserCareerOptionData());

							return _context9.abrupt('return', { value: [].concat(career.value, [{ value: data.id, label: data.name }]), inputValue: '' });

						case 18:
						case 'end':
							return _context9.stop();
					}
				}
			}, _callee9, undefined);
		}));

		return function (_x14, _x15) {
			return _ref16.apply(this, arguments);
		};
	}();
});

var uploadUserPhoto = exports.uploadUserPhoto = (0, _reduxActions.createAction)('UPLOAD_USER_PHOTO', function () {
	var _ref18 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(e) {
		var files, file, photoData, _ref19, status, message, data;

		return regeneratorRuntime.wrap(function _callee10$(_context10) {
			while (1) {
				switch (_context10.prev = _context10.next) {
					case 0:
						files = e.target.files || e.dataTransfer.files;
						file = files[0];
						photoData = new FormData();


						photoData.append('file', file, file.name);

						_context10.next = 6;
						return (0, _endpoint.wrapFetchFormData)('user/uploadPhoto', {
							method: 'POST',
							body: photoData
						});

					case 6:
						_ref19 = _context10.sent;
						status = _ref19.status;
						message = _ref19.message;
						data = _ref19.data;

						if (!(status !== 200 && status !== 201)) {
							_context10.next = 12;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 12:
						return _context10.abrupt('return', { image: data.file_name, imageUrl: data.image_url });

					case 13:
					case 'end':
						return _context10.stop();
				}
			}
		}, _callee10, undefined);
	}));

	return function (_x16) {
		return _ref18.apply(this, arguments);
	};
}());

var setIgAccessToken = exports.setIgAccessToken = (0, _reduxActions.createAction)('SET_IG_ACCESS_TOKEN', function (code) {
	return function () {
		var _ref20 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(dispatch, getState) {
			var _ref21, status, message, _getState5, lan;

			return regeneratorRuntime.wrap(function _callee11$(_context11) {
				while (1) {
					switch (_context11.prev = _context11.next) {
						case 0:
							_context11.next = 2;
							return (0, _endpoint.wrapFetchAuth)('user/saveIgAccessToken', {
								method: 'POST',
								body: JSON.stringify({ code: code, redirect_uri: _endpoint.SELF_HOST_ENDPOINT + '/auth' })
							});

						case 2:
							_ref21 = _context11.sent;
							status = _ref21.status;
							message = _ref21.message;

							if (!(status !== 200)) {
								_context11.next = 7;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 7:
							_getState5 = getState(), lan = _getState5.i18n.lan;


							dispatch((0, _reactRouterRedux.replace)((0, _i18n.languageMapRoute)(lan) + '/user/settings'));

						case 9:
						case 'end':
							return _context11.stop();
					}
				}
			}, _callee11, undefined);
		}));

		return function (_x17, _x18) {
			return _ref20.apply(this, arguments);
		};
	}();
});

var getIgMedia = exports.getIgMedia = (0, _reduxActions.createAction)('FETCH_IG_MEDIA', _asyncToGenerator(regeneratorRuntime.mark(function _callee12() {
	var _ref23, status, message, data, igData, userIgData, list;

	return regeneratorRuntime.wrap(function _callee12$(_context12) {
		while (1) {
			switch (_context12.prev = _context12.next) {
				case 0:
					_context12.next = 2;
					return (0, _endpoint.wrapFetchAuth)('user/getIgMedia', {
						method: 'GET'
					});

				case 2:
					_ref23 = _context12.sent;
					status = _ref23.status;
					message = _ref23.message;
					data = _ref23.data;

					if (!(status === 400)) {
						_context12.next = 8;
						break;
					}

					return _context12.abrupt('return', { list: [], data: {}, userIgData: { id: '', username: '' } });

				case 8:
					if (!(status !== 200)) {
						_context12.next = 10;
						break;
					}

					throw (0, _alert.openFailedAlert)('generic', message);

				case 10:
					igData = {};
					userIgData = { id: '', username: '' };
					list = data.map(function (item) {
						igData[item.id] = item;
						userIgData.id = item.user.id;
						userIgData.username = item.user.username;

						return item.id;
					});
					return _context12.abrupt('return', { list: list, data: igData, userIgData: userIgData });

				case 14:
				case 'end':
					return _context12.stop();
			}
		}
	}, _callee12, undefined);
})));

var removeIgAccessToken = exports.removeIgAccessToken = (0, _reduxActions.createAction)('REMOVE_IG_ACCESS_TOKEN', _asyncToGenerator(regeneratorRuntime.mark(function _callee13() {
	var _ref25, status, message;

	return regeneratorRuntime.wrap(function _callee13$(_context13) {
		while (1) {
			switch (_context13.prev = _context13.next) {
				case 0:
					_context13.next = 2;
					return (0, _endpoint.wrapFetchAuth)('user/removeIgAccessToken', {
						method: 'POST'
					});

				case 2:
					_ref25 = _context13.sent;
					status = _ref25.status;
					message = _ref25.message;

					if (!(status !== 200)) {
						_context13.next = 7;
						break;
					}

					throw (0, _alert.openFailedAlert)('generic', message);

				case 7:
				case 'end':
					return _context13.stop();
			}
		}
	}, _callee13, undefined);
})));

var getUserOverview = exports.getUserOverview = (0, _reduxActions.createAction)('FETCH_USER_OVERVIEW', function () {
	return function () {
		var _ref26 = _asyncToGenerator(regeneratorRuntime.mark(function _callee14(dispatch, getState) {
			var _ref27, status, message, data, level, needCheckinOrders, needCheckoutOrders, alertCheckMethod, _getState6, lan, bookingData, list, reservationData, reservationList;

			return regeneratorRuntime.wrap(function _callee14$(_context14) {
				while (1) {
					switch (_context14.prev = _context14.next) {
						case 0:
							_context14.next = 2;
							return (0, _endpoint.wrapFetchAuth)('user/overview', {
								method: 'GET'
							});

						case 2:
							_ref27 = _context14.sent;
							status = _ref27.status;
							message = _ref27.message;
							data = _ref27.data;

							if (!(status !== 200)) {
								_context14.next = 8;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 8:
							level = (0, _helper.mapUserLevel)(data.level_id);


							if (level === 'REGISTERED') {
								dispatch((0, _alert.openFailedAlert)('overview', (0, _i18n.t)('userOverview:incomplete')));
							}

							if (level === 'UNDER_PREVIEW') {
								dispatch((0, _alert.openFailedAlert)('overview', (0, _i18n.t)('userOverview:underPreview')));
							}

							if (level === 'DENIED') {
								dispatch((0, _alert.openFailedAlert)('overview', (0, _i18n.t)('userOverview:reject')));
							}

							needCheckinOrders = data.orders.filter(function (item) {
								return item.check_message === 'NEED_CHECKIN';
							});
							needCheckoutOrders = data.orders.filter(function (item) {
								return item.check_message === 'NEED_CHECKOUT';
							});
							alertCheckMethod = { orderId: -1, type: '' };
							_getState6 = getState(), lan = _getState6.i18n.lan;


							if (needCheckinOrders.length > 0) {
								alertCheckMethod.orderId = needCheckinOrders[0].id;
								alertCheckMethod.type = 'NEED_CHECKIN';

								dispatch((0, _alert.openSuccessAlert)('overview', (0, _i18n.t)('userOverview:needCheckin', {
									startDate: (0, _moment2.default)(needCheckinOrders[0].date_from).add(7, 'days').format(lan === 'en' ? 'MMM/DD/YYYY' : 'YYYY/MM/DD')
								})));
							}

							if (needCheckoutOrders.length > 0) {
								alertCheckMethod.orderId = needCheckoutOrders[0].id;
								alertCheckMethod.type = 'NEED_CHECKOUT';

								dispatch((0, _alert.openSuccessAlert)('overview', (0, _i18n.t)('userOverview:needCheckout', {
									endDate: (0, _moment2.default)(needCheckoutOrders[0].date_to).format(lan === 'en' ? 'MMM/DD/YYYY' : 'YYYY/MM/DD')
								})));
							}

							bookingData = {};
							list = data.orders.map(function (item) {
								bookingData[item.id] = (0, _helper.keyTransform)(item);

								return item.id;
							});
							reservationData = {};
							reservationList = data.events.map(function (item) {
								reservationData[item.id] = item;

								return item.id;
							});
							return _context14.abrupt('return', { current: list, data: bookingData, reservationData: reservationData, reservationList: reservationList, alertCheckMethod: alertCheckMethod });

						case 23:
						case 'end':
							return _context14.stop();
					}
				}
			}, _callee14, undefined);
		}));

		return function (_x19, _x20) {
			return _ref26.apply(this, arguments);
		};
	}();
});

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// From https://github.com/patw0929/react-intl-tel-input

// Tell JSHint to ignore this warning: 'character may get silently deleted by one or more browsers'
// jshint -W100

// Array of country objects for the flag dropdown.
// Each contains a name, country code (ISO 3166-1 alpha-2) and dial code.

// Originally from https://github.com/mledoze/countries
// then with a couple of manual re-arrangements to be alphabetical
// then changed Kazakhstan from +76 to +7
// and Vatican City from +379 to +39 (see issue 50)
// and Caribean Netherlands from +5997 to +599
// and Curacao from +5999 to +599
// Removed:  Kosovo, Pitcairn Islands, South Georgia

// UPDATE Sept 12th 2015
// List of regions that have iso2 country codes, which I have chosen to omit:
// (based on this information: https://en.wikipedia.org/wiki/List_of_country_calling_codes)
// AQ - Antarctica - all different country codes depending on which 'base'
// BV - Bouvet Island - no calling code
// GS - South Georgia and the South Sandwich Islands -
// 'inhospitable collection of islands' - same flag and calling code as Falkland Islands
// HM - Heard Island and McDonald Islands - no calling code
// PN - Pitcairn - tiny population (56), same calling code as New Zealand
// TF - French Southern Territories - no calling code
// UM - United States Minor Outlying Islands - no calling code

// UPDATE the criteria of supported countries or territories (see issue 297)
// Have an iso2 code: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
// Have a country calling code: https://en.wikipedia.org/wiki/List_of_country_calling_codes
// Have a flag
// Must be supported by libphonenumber: https://github.com/googlei18n/libphonenumber

// Update: converted objects to arrays to save bytes!
// Update: added 'priority' for countries with the same dialCode as others
// Update: added array of area codes for countries with the same dialCode as others

// So each country array has the following information:
// [
//    Country name,
//    iso2 code,
//    International dial code,
//    Order (if >1 country with same dial code),
//    Area codes (if >1 country with same dial code)
// ]
var defaultCountriesData = [['Afghanistan (‫افغانستان‬‎)', 'af', '93'], ['Albania (Shqipëri)', 'al', '355'], ['Algeria (‫الجزائر‬‎)', 'dz', '213'], ['American Samoa', 'as', '1684'], ['Andorra', 'ad', '376'], ['Angola', 'ao', '244'], ['Anguilla', 'ai', '1264'], ['Antigua and Barbuda', 'ag', '1268'], ['Argentina', 'ar', '54'], ['Armenia (Հայաստան)', 'am', '374'], ['Aruba', 'aw', '297'], ['Australia', 'au', '61', 0], ['Austria (Österreich)', 'at', '43'], ['Azerbaijan (Azərbaycan)', 'az', '994'], ['Bahamas', 'bs', '1242'], ['Bahrain (‫البحرين‬‎)', 'bh', '973'], ['Bangladesh (বাংলাদেশ)', 'bd', '880'], ['Barbados', 'bb', '1246'], ['Belarus (Беларусь)', 'by', '375'], ['Belgium (België)', 'be', '32'], ['Belize', 'bz', '501'], ['Benin (Bénin)', 'bj', '229'], ['Bermuda', 'bm', '1441'], ['Bhutan (འབྲུག)', 'bt', '975'], ['Bolivia', 'bo', '591'], ['Bosnia and Herzegovina (Босна и Херцеговина)', 'ba', '387'], ['Botswana', 'bw', '267'], ['Brazil (Brasil)', 'br', '55'], ['British Indian Ocean Territory', 'io', '246'], ['British Virgin Islands', 'vg', '1284'], ['Brunei', 'bn', '673'], ['Bulgaria (България)', 'bg', '359'], ['Burkina Faso', 'bf', '226'], ['Burundi (Uburundi)', 'bi', '257'], ['Cambodia (កម្ពុជា)', 'kh', '855'], ['Cameroon (Cameroun)', 'cm', '237'], ['Canada', 'ca', '1', 1, ['204', '226', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742', '778', '780', '782', '807', '819', '825', '867', '873', '902', '905']], ['Cape Verde (Kabu Verdi)', 'cv', '238'], ['Caribbean Netherlands', 'bq', '599', 1], ['Cayman Islands', 'ky', '1345'], ['Central African Republic (République centrafricaine)', 'cf', '236'], ['Chad (Tchad)', 'td', '235'], ['Chile', 'cl', '56'], ['China (中国)', 'cn', '86'], ['Christmas Island', 'cx', '61', 2], ['Cocos (Keeling) Islands', 'cc', '61', 1], ['Colombia', 'co', '57'], ['Comoros (‫جزر القمر‬‎)', 'km', '269'], ['Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', 'cd', '243'], ['Congo (Republic) (Congo-Brazzaville)', 'cg', '242'], ['Cook Islands', 'ck', '682'], ['Costa Rica', 'cr', '506'], ['Côte d’Ivoire', 'ci', '225'], ['Croatia (Hrvatska)', 'hr', '385'], ['Cuba', 'cu', '53'], ['Curaçao', 'cw', '599', 0], ['Cyprus (Κύπρος)', 'cy', '357'], ['Czech Republic (Česká republika)', 'cz', '420'], ['Denmark (Danmark)', 'dk', '45'], ['Djibouti', 'dj', '253'], ['Dominica', 'dm', '1767'], ['Dominican Republic (República Dominicana)', 'do', '1', 2, ['809', '829', '849']], ['Ecuador', 'ec', '593'], ['Egypt (‫مصر‬‎)', 'eg', '20'], ['El Salvador', 'sv', '503'], ['Equatorial Guinea (Guinea Ecuatorial)', 'gq', '240'], ['Eritrea', 'er', '291'], ['Estonia (Eesti)', 'ee', '372'], ['Ethiopia', 'et', '251'], ['Falkland Islands (Islas Malvinas)', 'fk', '500'], ['Faroe Islands (Føroyar)', 'fo', '298'], ['Fiji', 'fj', '679'], ['Finland (Suomi)', 'fi', '358', 0], ['France', 'fr', '33'], ['French Guiana (Guyane française)', 'gf', '594'], ['French Polynesia (Polynésie française)', 'pf', '689'], ['Gabon', 'ga', '241'], ['Gambia', 'gm', '220'], ['Georgia (საქართველო)', 'ge', '995'], ['Germany (Deutschland)', 'de', '49'], ['Ghana (Gaana)', 'gh', '233'], ['Gibraltar', 'gi', '350'], ['Greece (Ελλάδα)', 'gr', '30'], ['Greenland (Kalaallit Nunaat)', 'gl', '299'], ['Grenada', 'gd', '1473'], ['Guadeloupe', 'gp', '590', 0], ['Guam', 'gu', '1671'], ['Guatemala', 'gt', '502'], ['Guernsey', 'gg', '44', 1], ['Guinea (Guinée)', 'gn', '224'], ['Guinea-Bissau (Guiné Bissau)', 'gw', '245'], ['Guyana', 'gy', '592'], ['Haiti', 'ht', '509'], ['Honduras', 'hn', '504'], ['Hong Kong (香港)', 'hk', '852'], ['Hungary (Magyarország)', 'hu', '36'], ['Iceland (Ísland)', 'is', '354'], ['India (भारत)', 'in', '91'], ['Indonesia', 'id', '62'], ['Iran (‫ایران‬‎)', 'ir', '98'], ['Iraq (‫العراق‬‎)', 'iq', '964'], ['Ireland', 'ie', '353'], ['Isle of Man', 'im', '44', 2], ['Israel (‫ישראל‬‎)', 'il', '972'], ['Italy (Italia)', 'it', '39', 0], ['Jamaica', 'jm', '1876'], ['Japan (日本)', 'jp', '81'], ['Jersey', 'je', '44', 3], ['Jordan (‫الأردن‬‎)', 'jo', '962'], ['Kazakhstan (Казахстан)', 'kz', '7', 1], ['Kenya', 'ke', '254'], ['Kiribati', 'ki', '686'], ['Kosovo', 'xk', '383'], ['Kuwait (‫الكويت‬‎)', 'kw', '965'], ['Kyrgyzstan (Кыргызстан)', 'kg', '996'], ['Laos (ລາວ)', 'la', '856'], ['Latvia (Latvija)', 'lv', '371'], ['Lebanon (‫لبنان‬‎)', 'lb', '961'], ['Lesotho', 'ls', '266'], ['Liberia', 'lr', '231'], ['Libya (‫ليبيا‬‎)', 'ly', '218'], ['Liechtenstein', 'li', '423'], ['Lithuania (Lietuva)', 'lt', '370'], ['Luxembourg', 'lu', '352'], ['Macau (澳門)', 'mo', '853'], ['Macedonia (FYROM) (Македонија)', 'mk', '389'], ['Madagascar (Madagasikara)', 'mg', '261'], ['Malawi', 'mw', '265'], ['Malaysia', 'my', '60'], ['Maldives', 'mv', '960'], ['Mali', 'ml', '223'], ['Malta', 'mt', '356'], ['Marshall Islands', 'mh', '692'], ['Martinique', 'mq', '596'], ['Mauritania (‫موريتانيا‬‎)', 'mr', '222'], ['Mauritius (Moris)', 'mu', '230'], ['Mayotte', 'yt', '262', 1], ['Mexico (México)', 'mx', '52'], ['Micronesia', 'fm', '691'], ['Moldova (Republica Moldova)', 'md', '373'], ['Monaco', 'mc', '377'], ['Mongolia (Монгол)', 'mn', '976'], ['Montenegro (Crna Gora)', 'me', '382'], ['Montserrat', 'ms', '1664'], ['Morocco (‫المغرب‬‎)', 'ma', '212', 0], ['Mozambique (Moçambique)', 'mz', '258'], ['Myanmar (Burma) (မြန်မာ)', 'mm', '95'], ['Namibia (Namibië)', 'na', '264'], ['Nauru', 'nr', '674'], ['Nepal (नेपाल)', 'np', '977'], ['Netherlands (Nederland)', 'nl', '31'], ['New Caledonia (Nouvelle-Calédonie)', 'nc', '687'], ['New Zealand', 'nz', '64'], ['Nicaragua', 'ni', '505'], ['Niger (Nijar)', 'ne', '227'], ['Nigeria', 'ng', '234'], ['Niue', 'nu', '683'], ['Norfolk Island', 'nf', '672'], ['North Korea (조선 민주주의 인민 공화국)', 'kp', '850'], ['Northern Mariana Islands', 'mp', '1670'], ['Norway (Norge)', 'no', '47', 0], ['Oman (‫عُمان‬‎)', 'om', '968'], ['Pakistan (‫پاکستان‬‎)', 'pk', '92'], ['Palau', 'pw', '680'], ['Palestine (‫فلسطين‬‎)', 'ps', '970'], ['Panama (Panamá)', 'pa', '507'], ['Papua New Guinea', 'pg', '675'], ['Paraguay', 'py', '595'], ['Peru (Perú)', 'pe', '51'], ['Philippines', 'ph', '63'], ['Poland (Polska)', 'pl', '48'], ['Portugal', 'pt', '351'], ['Puerto Rico', 'pr', '1', 3, ['787', '939']], ['Qatar (‫قطر‬‎)', 'qa', '974'], ['Réunion (La Réunion)', 're', '262', 0], ['Romania (România)', 'ro', '40'], ['Russia (Россия)', 'ru', '7', 0], ['Rwanda', 'rw', '250'], ['Saint Barthélemy (Saint-Barthélemy)', 'bl', '590', 1], ['Saint Helena', 'sh', '290'], ['Saint Kitts and Nevis', 'kn', '1869'], ['Saint Lucia', 'lc', '1758'], ['Saint Martin (Saint-Martin (partie française))', 'mf', '590', 2], ['Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)', 'pm', '508'], ['Saint Vincent and the Grenadines', 'vc', '1784'], ['Samoa', 'ws', '685'], ['San Marino', 'sm', '378'], ['São Tomé and Príncipe (São Tomé e Príncipe)', 'st', '239'], ['Saudi Arabia (‫المملكة العربية السعودية‬‎)', 'sa', '966'], ['Senegal (Sénégal)', 'sn', '221'], ['Serbia (Србија)', 'rs', '381'], ['Seychelles', 'sc', '248'], ['Sierra Leone', 'sl', '232'], ['Singapore', 'sg', '65'], ['Sint Maarten', 'sx', '1721'], ['Slovakia (Slovensko)', 'sk', '421'], ['Slovenia (Slovenija)', 'si', '386'], ['Solomon Islands', 'sb', '677'], ['Somalia (Soomaaliya)', 'so', '252'], ['South Africa', 'za', '27'], ['South Korea (대한민국)', 'kr', '82'], ['South Sudan (‫جنوب السودان‬‎)', 'ss', '211'], ['Spain (España)', 'es', '34'], ['Sri Lanka (ශ්‍රී ලංකාව)', 'lk', '94'], ['Sudan (‫السودان‬‎)', 'sd', '249'], ['Suriname', 'sr', '597'], ['Svalbard and Jan Mayen', 'sj', '47', 1], ['Swaziland', 'sz', '268'], ['Sweden (Sverige)', 'se', '46'], ['Switzerland (Schweiz)', 'ch', '41'], ['Syria (‫سوريا‬‎)', 'sy', '963'], ['Taiwan (台灣)', 'tw', '886'], ['Tajikistan', 'tj', '992'], ['Tanzania', 'tz', '255'], ['Thailand (ไทย)', 'th', '66'], ['Timor-Leste', 'tl', '670'], ['Togo', 'tg', '228'], ['Tokelau', 'tk', '690'], ['Tonga', 'to', '676'], ['Trinidad and Tobago', 'tt', '1868'], ['Tunisia (‫تونس‬‎)', 'tn', '216'], ['Turkey (Türkiye)', 'tr', '90'], ['Turkmenistan', 'tm', '993'], ['Turks and Caicos Islands', 'tc', '1649'], ['Tuvalu', 'tv', '688'], ['U.S. Virgin Islands', 'vi', '1340'], ['Uganda', 'ug', '256'], ['Ukraine (Україна)', 'ua', '380'], ['United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', 'ae', '971'], ['United Kingdom', 'gb', '44', 0], ['United States', 'us', '1', 0], ['Uruguay', 'uy', '598'], ['Uzbekistan (Oʻzbekiston)', 'uz', '998'], ['Vanuatu', 'vu', '678'], ['Vatican City (Città del Vaticano)', 'va', '39', 1], ['Venezuela', 've', '58'], ['Vietnam (Việt Nam)', 'vn', '84'], ['Wallis and Futuna', 'wf', '681'], ['Western Sahara (‫الصحراء الغربية‬‎)', 'eh', '212', 1], ['Yemen (‫اليمن‬‎)', 'ye', '967'], ['Zambia', 'zm', '260'], ['Zimbabwe', 'zw', '263'], ['Åland Islands', 'ax', '358', 1]];

var defaultCountry = {
	areaCodes: null,
	dialCode: '886',
	iso2: 'tw',
	name: 'Taiwan (台灣)',
	priority: 0
};

var countries = void 0;

function _formatCountriesData(countriesData) {
	return countriesData.map(function (country) {
		return {
			name: country[0],
			iso2: country[1],
			dialCode: country[2],
			priority: country[3] || 0,
			areaCodes: country[4] || null
		};
	});
}

function initialize(externalCountriesList) {
	countries = _formatCountriesData(externalCountriesList || defaultCountriesData);
}

function getCountries() {
	if (!countries) {
		initialize();
	}

	return countries;
}

var getCountryByCode = function getCountryByCode(iso2) {
	if (!countries) {
		initialize();
	}

	var _countries$filter = countries.filter(function (item) {
		return item.iso2 === iso2;
	}),
	    _countries$filter$ = _countries$filter[0],
	    country = _countries$filter$ === undefined ? defaultCountry : _countries$filter$;

	return country;
};

var AllCountries = {
	initialize: initialize,
	getCountries: getCountries,
	getCountryByCode: getCountryByCode
};

exports.default = AllCountries;

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Logger());

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setAccessReserve = exports.changeReservation = exports.cancelReservation = exports.getReservationById = exports.getReservation = exports.reserveInterviewProcess = exports.reserveProcess = exports.setReservationFormData = exports.initReservationFormData = exports.getReservationDateWithOrder = exports.getReservationDateWithInterview = exports.getReservationDate = exports.getReservationTimeWithInterview = exports.getReservationTime = exports.clearReservationTime = exports.changeReservationStep = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var _reactRouterRedux = __webpack_require__(36);

var _isEmail = __webpack_require__(457);

var _isEmail2 = _interopRequireDefault(_isEmail);

var _alert = __webpack_require__(17);

var _endpoint = __webpack_require__(35);

var _helper = __webpack_require__(28);

var _i18n = __webpack_require__(16);

var _user = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var changeReservationStep = exports.changeReservationStep = (0, _reduxActions.createAction)('CHANGE_RESERVATION_STEP', function (step) {
	return { step: step };
});

var clearReservationTime = exports.clearReservationTime = (0, _reduxActions.createAction)('CLEAR_RESERVATION_TIME');

var getReservationTime = exports.getReservationTime = (0, _reduxActions.createAction)('FETCH_RESERVATION_TIME', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(workDate, roomId) {
		var _reservationTimeList;

		var period = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'MORNING';

		var _ref2, status, message, data;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return (0, _endpoint.wrapFetchAuth)('reservation/getDateStatus', { method: 'GET' }, { work_date: workDate, period: period, room_id: roomId });

					case 2:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						data = _ref2.data;

						if (!(status !== 200)) {
							_context.next = 8;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 8:
						return _context.abrupt('return', {
							reservationTimeList: (_reservationTimeList = {}, _reservationTimeList[period] = data.reservations.map(function (timeInfo) {
								return {
									time: timeInfo.work_date,
									live: timeInfo.LIVE,
									phone: timeInfo.PHONE,
									online: timeInfo.ONLINE,
									checkin: timeInfo.CHECKIN,
									checkout: timeInfo.CHECKOUT,
									available: timeInfo.LIVE > 0 || timeInfo.PHONE > 0 || timeInfo.ONLINE > 0
								};
							}), _reservationTimeList)
						});

					case 9:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function (_x, _x2) {
		return _ref.apply(this, arguments);
	};
}());

var getReservationTimeWithInterview = exports.getReservationTimeWithInterview = (0, _reduxActions.createAction)('FETCH_RESERVATION_TIME', function () {
	var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(workDate) {
		var _reservationTimeList2;

		var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MORNING';

		var _ref4, status, message, data;

		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return (0, _endpoint.wrapFetchAuth)('reservation/getInterviewDateStatus', { method: 'GET' }, { work_date: workDate, period: period });

					case 2:
						_ref4 = _context2.sent;
						status = _ref4.status;
						message = _ref4.message;
						data = _ref4.data;

						if (!(status !== 200)) {
							_context2.next = 8;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 8:
						return _context2.abrupt('return', {
							reservationTimeList: (_reservationTimeList2 = {}, _reservationTimeList2[period] = data.reservations.map(function (timeInfo) {
								return {
									time: timeInfo.work_date,
									live: 0,
									phone: 0,
									online: 0,
									checkin: 0,
									checkout: 0,
									interview_phone: timeInfo.INTERVIEW_PHONE,
									interview_online: timeInfo.INTERVIEW_ONLINE,
									available: timeInfo.INTERVIEW_PHONE > 0 || timeInfo.INTERVIEW_ONLINE > 0
								};
							}), _reservationTimeList2)
						});

					case 9:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, undefined);
	}));

	return function (_x4) {
		return _ref3.apply(this, arguments);
	};
}());

var getReservationDate = exports.getReservationDate = (0, _reduxActions.createAction)('FETCH_RESERVATION_DATE', function () {
	var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(workDate, roomId) {
		var _ref6, status, message, data, reservationDate;

		return regeneratorRuntime.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.next = 2;
						return (0, _endpoint.wrapFetchAuth)('reservation/getMonthStatus', { method: 'GET' }, { work_date: workDate, room_id: roomId });

					case 2:
						_ref6 = _context3.sent;
						status = _ref6.status;
						message = _ref6.message;
						data = _ref6.data;
						reservationDate = {};


						data.forEach(function (item) {
							reservationDate[item.work_date] = item.status;
						});

						if (!(status !== 200)) {
							_context3.next = 10;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 10:
						return _context3.abrupt('return', { reservationDate: reservationDate });

					case 11:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, undefined);
	}));

	return function (_x6, _x7) {
		return _ref5.apply(this, arguments);
	};
}());

var getReservationDateWithInterview = exports.getReservationDateWithInterview = (0, _reduxActions.createAction)('FETCH_RESERVATION_DATE', function () {
	var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(workDate) {
		var _ref8, status, message, data, reservationDate;

		return regeneratorRuntime.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.next = 2;
						return (0, _endpoint.wrapFetchAuth)('reservation/getInterviewMonthStatus', { method: 'GET' }, { work_date: workDate });

					case 2:
						_ref8 = _context4.sent;
						status = _ref8.status;
						message = _ref8.message;
						data = _ref8.data;
						reservationDate = {};


						data.forEach(function (item) {
							reservationDate[item.work_date] = item.status;
						});

						if (!(status !== 200)) {
							_context4.next = 10;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 10:
						return _context4.abrupt('return', { reservationDate: reservationDate });

					case 11:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, undefined);
	}));

	return function (_x8) {
		return _ref7.apply(this, arguments);
	};
}());

var getReservationDateWithOrder = exports.getReservationDateWithOrder = (0, _reduxActions.createAction)('FETCH_RESERVATION_DATE', function (orderId, type) {
	return function () {
		var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch) {
			var _ref10, status, message, data, reservationDate, canReserveOrder;

			return regeneratorRuntime.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_context5.next = 2;
							return (0, _endpoint.wrapFetchAuth)('reservation/getOrderRecentDayStatus', { method: 'GET' }, { order_id: orderId, event_type: type });

						case 2:
							_ref10 = _context5.sent;
							status = _ref10.status;
							message = _ref10.message;
							data = _ref10.data;
							reservationDate = {};
							canReserveOrder = false;


							data.forEach(function (item) {
								reservationDate[item.work_date] = item.status;
								canReserveOrder = canReserveOrder || item.status;
							});

							if (!canReserveOrder) {
								if (type === 'CHECKIN') {
									dispatch((0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:notReserveCheckinDate')));
								} else if (type === 'CHECKOUT') {
									dispatch((0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:notReserveCheckoutDate')));
								}
							}

							if (!(status !== 200)) {
								_context5.next = 12;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 12:
							return _context5.abrupt('return', { reservationDate: reservationDate });

						case 13:
						case 'end':
							return _context5.stop();
					}
				}
			}, _callee5, undefined);
		}));

		return function (_x9) {
			return _ref9.apply(this, arguments);
		};
	}();
});

var initReservationFormData = exports.initReservationFormData = (0, _reduxActions.createAction)('INIT_RESERVATION_FORM_DATA');

var setReservationFormData = exports.setReservationFormData = (0, _reduxActions.createAction)('SET_RESERVATION_FORM_DATA', function (phone, hangout) {
	return {
		phone: phone,
		hangout: hangout
	};
});

var reserveProcess = exports.reserveProcess = (0, _reduxActions.createAction)('RESERVE_PROCESS', function (_ref11) {
	var type = _ref11.type,
	    roomId = _ref11.roomId,
	    orderId = _ref11.orderId,
	    time = _ref11.time;
	return function () {
		var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
			var eventType, _getState, _getState$reservation, phone, hangout, data, _ref13, status, _getState2, _getState2$routing$lo, query, pathname;

			return regeneratorRuntime.wrap(function _callee6$(_context6) {
				while (1) {
					switch (_context6.prev = _context6.next) {
						case 0:
							if (!(0, _helper.isEmpty)(time)) {
								_context6.next = 3;
								break;
							}

							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:notValidText'));

						case 3:
							if (!(0, _helper.isEmpty)(type)) {
								_context6.next = 5;
								break;
							}

							throw (0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:chooseTypeValid'));

						case 5:
							eventType = (0, _helper.convertReservationEvent)(type);
							_getState = getState(), _getState$reservation = _getState.reservation.form, phone = _getState$reservation.phone, hangout = _getState$reservation.hangout;

							if (!(['PHONE', 'LIVE'].includes(eventType) && (0, _helper.isEmpty)(phone.value) && !phone.validate || eventType === 'ONLINE' && ((0, _helper.isEmpty)(hangout.value) || !(0, _isEmail2.default)(hangout.value)))) {
								_context6.next = 10;
								break;
							}

							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:checkPhoneAndHangoutAlert'));

						case 10:
							data = {
								event_type: eventType,
								room_id: roomId,
								work_date: time.format('YYYY-MM-DD HH:mm:ss')
							};


							if (['PHONE', 'LIVE'].includes(eventType)) {
								data.phone = phone.value;
								data.phone_country = phone.country.iso2;
							}

							if (['CHECKIN', 'CHECKOUT'].includes(eventType)) {
								data.order_id = orderId;
							}

							if (eventType === 'ONLINE') {
								data.hangout = hangout.value;
							}

							_context6.next = 16;
							return (0, _endpoint.wrapFetchAuth)('reservation/book', {
								method: 'POST',
								body: JSON.stringify(data)
							});

						case 16:
							_ref13 = _context6.sent;
							status = _ref13.status;

							if (!(status !== 200)) {
								_context6.next = 21;
								break;
							}

							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:notValidReserve'));

						case 21:
							_getState2 = getState(), _getState2$routing$lo = _getState2.routing.locationBeforeTransitions, query = _getState2$routing$lo.query, pathname = _getState2$routing$lo.pathname;


							dispatch((0, _user.getUser)());
							dispatch((0, _reactRouterRedux.push)({ pathname: pathname, query: _extends({}, query, { step: 'success' }) }));

							return _context6.abrupt('return', { type: type, time: time.valueOf(), canAccess: false });

						case 25:
						case 'end':
							return _context6.stop();
					}
				}
			}, _callee6, undefined);
		}));

		return function (_x10, _x11) {
			return _ref12.apply(this, arguments);
		};
	}();
});

var reserveInterviewProcess = exports.reserveInterviewProcess = (0, _reduxActions.createAction)('RESERVE_PROCESS', function (_ref14) {
	var type = _ref14.type,
	    time = _ref14.time;
	return function () {
		var _ref15 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
			var eventType, _getState3, _getState3$reservatio, phone, hangout, data, _ref16, status, _getState4, _getState4$routing$lo, query, pathname;

			return regeneratorRuntime.wrap(function _callee7$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							if (!(0, _helper.isEmpty)(time)) {
								_context7.next = 3;
								break;
							}

							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:notValidText'));

						case 3:
							if (!(0, _helper.isEmpty)(type)) {
								_context7.next = 5;
								break;
							}

							throw (0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:chooseTypeValid'));

						case 5:
							eventType = (0, _helper.convertReservationEvent)(type);
							_getState3 = getState(), _getState3$reservatio = _getState3.reservation.form, phone = _getState3$reservatio.phone, hangout = _getState3$reservatio.hangout;

							if (!(eventType === 'INTERVIEW_PHONE' && (0, _helper.isEmpty)(phone.value) && !phone.validate || eventType === 'INTERVIEW_ONLINE' && ((0, _helper.isEmpty)(hangout.value) || !(0, _isEmail2.default)(hangout.value)))) {
								_context7.next = 10;
								break;
							}

							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:checkPhoneAndHangoutAlert'));

						case 10:
							data = {
								event_type: eventType,
								work_date: time.format('YYYY-MM-DD HH:mm:ss')
							};


							if (eventType === 'INTERVIEW_PHONE') {
								data.phone = phone.value;
								data.phone_country = phone.country.iso2;
							}

							if (eventType === 'INTERVIEW_ONLINE') {
								data.hangout = hangout.value;
							}

							_context7.next = 15;
							return (0, _endpoint.wrapFetchAuth)('reservation/bookInterview', {
								method: 'POST',
								body: JSON.stringify(data)
							});

						case 15:
							_ref16 = _context7.sent;
							status = _ref16.status;

							if (!(status !== 200)) {
								_context7.next = 20;
								break;
							}

							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:notValidReserve'));

						case 20:
							_getState4 = getState(), _getState4$routing$lo = _getState4.routing.locationBeforeTransitions, query = _getState4$routing$lo.query, pathname = _getState4$routing$lo.pathname;


							dispatch((0, _user.getUser)());
							dispatch((0, _reactRouterRedux.push)({ pathname: pathname, query: _extends({}, query, { step: 'success' }) }));

							return _context7.abrupt('return', { type: type, time: time.valueOf(), canAccess: false });

						case 24:
						case 'end':
							return _context7.stop();
					}
				}
			}, _callee7, undefined);
		}));

		return function (_x12, _x13) {
			return _ref15.apply(this, arguments);
		};
	}();
});

var getReservation = exports.getReservation = (0, _reduxActions.createAction)('FETCH_RESERVATION', _asyncToGenerator(regeneratorRuntime.mark(function _callee8() {
	var _ref18, status, data, message, reservationData, list;

	return regeneratorRuntime.wrap(function _callee8$(_context8) {
		while (1) {
			switch (_context8.prev = _context8.next) {
				case 0:
					_context8.next = 2;
					return (0, _endpoint.wrapFetchAuth)('reservation', { method: 'GET' });

				case 2:
					_ref18 = _context8.sent;
					status = _ref18.status;
					data = _ref18.data;
					message = _ref18.message;

					if (!(status !== 200)) {
						_context8.next = 8;
						break;
					}

					throw (0, _alert.openFailedAlert)('generic', message);

				case 8:
					reservationData = {};
					list = data.map(function (item) {
						reservationData[item.id] = item;

						return item.id;
					});
					return _context8.abrupt('return', { list: list, data: reservationData });

				case 11:
				case 'end':
					return _context8.stop();
			}
		}
	}, _callee8, undefined);
})));

var getReservationById = exports.getReservationById = (0, _reduxActions.createAction)('FETCH_RESERVATION_BY_ID', function () {
	var _ref19 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(id) {
		var _ref20, status, data, message;

		return regeneratorRuntime.wrap(function _callee9$(_context9) {
			while (1) {
				switch (_context9.prev = _context9.next) {
					case 0:
						_context9.next = 2;
						return (0, _endpoint.wrapFetchAuth)('reservation/' + id, { method: 'GET' });

					case 2:
						_ref20 = _context9.sent;
						status = _ref20.status;
						data = _ref20.data;
						message = _ref20.message;

						if (!(status !== 200)) {
							_context9.next = 8;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 8:
						return _context9.abrupt('return', { data: data });

					case 9:
					case 'end':
						return _context9.stop();
				}
			}
		}, _callee9, undefined);
	}));

	return function (_x14) {
		return _ref19.apply(this, arguments);
	};
}());

var cancelReservation = exports.cancelReservation = (0, _reduxActions.createAction)('CANCEL_RESERVATION', function (id, reason) {
	return function () {
		var _ref21 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(dispatch, getState) {
			var _ref22, status, message, _getState5, lan;

			return regeneratorRuntime.wrap(function _callee10$(_context10) {
				while (1) {
					switch (_context10.prev = _context10.next) {
						case 0:
							_context10.next = 2;
							return (0, _endpoint.wrapFetchAuth)('reservation/' + id + '/cancel', {
								method: 'POST',
								body: JSON.stringify({ note: reason })
							});

						case 2:
							_ref22 = _context10.sent;
							status = _ref22.status;
							message = _ref22.message;


							if (status !== 200) {
								// throw openFailedAlert(message);
								dispatch((0, _alert.openFailedAlert)('reserveRecord', message));
							} else {
								dispatch((0, _alert.openSuccessAlert)('reserveRecord', (0, _i18n.t)('reservation:cancelSuccess')));
							}
							_getState5 = getState(), lan = _getState5.i18n.lan;


							dispatch((0, _reactRouterRedux.push)('/' + (0, _i18n.languageMapRoute)(lan) + '/user/reservation'));

						case 8:
						case 'end':
							return _context10.stop();
					}
				}
			}, _callee10, undefined);
		}));

		return function (_x15, _x16) {
			return _ref21.apply(this, arguments);
		};
	}();
});

var changeReservation = exports.changeReservation = (0, _reduxActions.createAction)('CHANGE_RESERVE', function (_ref23) {
	var reservationId = _ref23.reservationId,
	    type = _ref23.type,
	    roomId = _ref23.roomId,
	    orderId = _ref23.orderId,
	    time = _ref23.time;
	return function () {
		var _ref24 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(dispatch, getState) {
			var eventType, _getState6, _getState6$reservatio, phone, hangout, data, _ref25, status, message, _getState7, lan;

			return regeneratorRuntime.wrap(function _callee11$(_context11) {
				while (1) {
					switch (_context11.prev = _context11.next) {
						case 0:
							if (!(0, _helper.isEmpty)(time)) {
								_context11.next = 3;
								break;
							}

							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:notValidText'));

						case 3:
							eventType = (0, _helper.convertReservationEvent)(type);
							_getState6 = getState(), _getState6$reservatio = _getState6.reservation.form, phone = _getState6$reservatio.phone, hangout = _getState6$reservatio.hangout;

							if (!(['PHONE', 'LIVE'].includes(eventType) && (0, _helper.isEmpty)(phone.value) && !phone.validate || eventType === 'ONLINE' && ((0, _helper.isEmpty)(hangout.value) || !(0, _isEmail2.default)(hangout.value)))) {
								_context11.next = 8;
								break;
							}

							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('reserve', (0, _i18n.t)('reservation:checkPhoneAndHangoutAlert'));

						case 8:
							data = {
								event_type: eventType,
								room_id: roomId,
								work_date: time.format('YYYY-MM-DD HH:mm:ss')
							};


							if (['PHONE', 'LIVE'].includes(eventType)) {
								data.phone = phone.value;
								data.phone_country = phone.country.iso2;
							}

							if (eventType === 'ONLINE') {
								data.hangout = hangout.value;
							}

							if (['CHECKIN', 'CHECKOUT'].includes(eventType)) {
								data.order_id = orderId;
							}

							_context11.next = 14;
							return (0, _endpoint.wrapFetchAuth)('reservation/' + reservationId, {
								method: 'PUT',
								body: JSON.stringify(data)
							});

						case 14:
							_ref25 = _context11.sent;
							status = _ref25.status;
							message = _ref25.message;

							if (!(status !== 200)) {
								_context11.next = 20;
								break;
							}

							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('reserve', message);

						case 20:

							dispatch((0, _alert.openSuccessAlert)('reserveRecord', (0, _i18n.t)('reservation:updateSuccess')));

							_getState7 = getState(), lan = _getState7.i18n.lan;


							dispatch((0, _reactRouterRedux.push)('/' + (0, _i18n.languageMapRoute)(lan) + '/user/reservation'));

						case 23:
						case 'end':
							return _context11.stop();
					}
				}
			}, _callee11, undefined);
		}));

		return function (_x17, _x18) {
			return _ref24.apply(this, arguments);
		};
	}();
});

var setAccessReserve = exports.setAccessReserve = (0, _reduxActions.createAction)('SET_ACCESS_RESERVE');

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.detectAuthStorageSupport = undefined;

var _storage = __webpack_require__(66);

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storeInLocalStorage = false;

var setStoreInLocalStorage = function setStoreInLocalStorage(isStore) {
	storeInLocalStorage = isStore;
};

var detectAuthStorageSupport = exports.detectAuthStorageSupport = function detectAuthStorageSupport() {
	if (_storage2.default.getItem('token') !== null) {
		setStoreInLocalStorage(true);
		_storage.sessionStorage.removeItem('token');
	}
};

var setToken = function setToken(value) {
	if (storeInLocalStorage) {
		_storage2.default.setItem('token', value);
		return;
	}

	_storage.sessionStorage.setItem('token', value);
};

var getToken = function getToken() {
	if (storeInLocalStorage) {
		return _storage2.default.getItem('token');
	}

	return _storage.sessionStorage.getItem('token');
};

var removeToken = function removeToken() {
	if (storeInLocalStorage) {
		_storage2.default.removeItem('token');
		return;
	}

	_storage.sessionStorage.removeItem('token');
};

exports.default = {
	setToken: setToken,
	getToken: getToken,
	removeToken: removeToken,
	setStoreInLocalStorage: setStoreInLocalStorage
};

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.examCreditData = exports.creditKeyFrom = exports.examOrderPolicyData = exports.orderPolicyKeyFrom = exports.examPassword = exports.userNameFrom = exports.examUserCertificateData = exports.examUserData = exports.examCertificate = exports.isValidOrNot = undefined;

var _cardValidator = __webpack_require__(944);

var _cardValidator2 = _interopRequireDefault(_cardValidator);

var _helper = __webpack_require__(28);

var _rent = __webpack_require__(230);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isValidOrNot = exports.isValidOrNot = function isValidOrNot(item) {
	return item.status === 'VALIDATED' ? item.valid : true;
};

var codes = '0123456789ABCDEFGHJKLMNPQRSTUVXYWZIO';
var codesMap = {};

codes.split('').forEach(function (code, i) {
	codesMap[code] = i;
});

var examCertificate = exports.examCertificate = function examCertificate(certificate) {
	if (certificate.length !== 10) {
		return false;
	}
	try {
		var sum = certificate.split('').reduce(function (prev, cur, i) {
			var codeNumber = codesMap[cur];

			if (typeof codeNumber === 'undefined') {
				throw new Error('Not certificate');
			}

			// First Number
			if (i === 0) {
				var firstCheck = Math.floor(codeNumber / 10);
				var secondCheck = codeNumber % 10 * 9;

				return prev + firstCheck + secondCheck;
			}

			// Last Number
			if (i === 9) {
				return prev + codeNumber;
			}

			// 1~8
			var normalNumber = codeNumber * (9 - i);
			return prev + normalNumber;
		}, 0);

		return sum % 10 === 0;
	} catch (e) {
		console.log(e);

		return false;
	}
};

var examUserData = exports.examUserData = function examUserData(user, userIgData, phone) {
	var keyArray = ['name', 'birth', 'country', 'expect', 'nickname', 'image'];

	var result = {
		value: keyArray.every(function (key) {
			return (0, _helper.isExist)(user[key]);
		}),
		notValid: keyArray.filter(function (key) {
			return (0, _helper.isEmpty)(user[key]);
		})
	};

	if (user.gender === 'OTHER' || (0, _helper.isEmpty)(user.gender)) {
		result.notValid.push('gender');
		result.value = false;
	}

	if (user.certificate_type === null || user.certificate_number === '') {
		result.notValid.push('certificate');
		result.value = false;
	}

	if (!phone.validate || (0, _helper.isEmpty)(user.phone) || (0, _helper.isEmpty)(user.phone_country)) {
		result.notValid.push('phone');
		result.value = false;
	}

	if ((typeof user.social_media.length === 'undefined' || user.social_media.length === 0) && userIgData.id === '') {
		result.notValid.push('social_media');
		result.value = false;
	}

	var arrayResult = ['job_types', 'professions', 'interests'].every(function (key) {
		return typeof user[key] !== 'undefined' && user[key].length !== 0;
	});

	var arrayNotValid = ['job_types', 'professions', 'interests'].filter(function (key) {
		return typeof user[key] === 'undefined' || user[key].length === 0;
	});

	return {
		value: result.value && arrayResult,
		notValid: [].concat(result.notValid, arrayNotValid)
	};
};

var examUserCertificateData = exports.examUserCertificateData = function examUserCertificateData(user) {
	var result = {
		value: true,
		notValid: []
	};

	if (user.certificate_type === null || user.certificate_number === '' || user.certificate_type === 'IDENTITY' && !examCertificate(user.certificate_number)) {
		result.notValid.push('certificate');
		result.value = false;
	}

	return result;
};

var USER_KEY_MAP = {
	name: '真實姓名',
	gender: '生理性別',
	birth: '生日',
	country: '國家',
	certificate: '身份證',
	job_types: '工作型態',
	professions: '專長',
	phone: '聯絡電話',
	expect: '社群想像',
	nickname: '顯示名稱',
	company: '公司',
	career: '職業',
	intro: '社群短自介',
	interests: '興趣標籤',
	songs: 'Favorite Song',
	social_media: '社群帳號連結',
	image: '頭像'
};

var userNameFrom = exports.userNameFrom = function userNameFrom(keys) {
	return keys.map(function (key) {
		return USER_KEY_MAP[key];
	});
};

var examPassword = exports.examPassword = function examPassword(password) {
	return (0, _helper.isExist)(password) && /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(password);
};

var ORDER_POLICY_KEY_MAP = {
	name: 'name',
	certificate_number: 'certificate',
	certificate_type: 'certificateType',
	address: 'address',
	extra_certificate_number: 'extraCertificate',
	extra_certificate_type: 'extraCertificateType',
	emergency_contact: 'emergencyContact',
	emergency_contact_mobile: 'emergencyContactMobile',
	emergency_contact_mobile_country_code: 'emergencyContactMobile',
	emergency_contact_relationship: 'emergencyContactRelationship',
	order_item_id: 'orderItem',
	certificate_file: 'certificateFile',
	extra_certificate_file: 'extraCertificateFile',
	emergency_address: 'emergencyAddress'
};

var orderPolicyKeyFrom = exports.orderPolicyKeyFrom = function orderPolicyKeyFrom(keys) {
	return keys.map(function (key) {
		return ORDER_POLICY_KEY_MAP[key];
	});
};

var examOrderPolicyData = exports.examOrderPolicyData = function examOrderPolicyData(order) {
	var keyArray = ['address', 'emergency_contact', 'emergency_contact_mobile', 'emergency_contact_relationship', 'emergency_address'];

	var result = {
		value: keyArray.every(function (key) {
			return (0, _helper.isExist)(order[key]);
		}),
		notValid: keyArray.filter(function (key) {
			return (0, _helper.isEmpty)(order[key]);
		})
	};

	var certificateResult = {
		value: true,
		notValid: []
	};

	if (order.certificate_file.fileName === '' || order.certificate_file.file === null) {
		certificateResult.value = false;
		certificateResult.notValid.push('certificate_file');
	}

	// Have 第二人入住
	if (order.order_item_id.includes(_rent.ORDER_ITEM_EXTRA_PERSON_ID)) {
		if (!['IDENTITY', 'PASSPORT'].includes(order.extra_certificate_type)) {
			certificateResult.value = false;
			certificateResult.notValid.push('extra_certificate_type');
		}

		if (order.extra_certificate_type === 'IDENTITY' && !examCertificate(order.extra_certificate_number)) {
			certificateResult.value = false;
			certificateResult.notValid.push('extra_certificate_number');
		}

		if (order.extra_certificate_file.fileName === '' || order.extra_certificate_file.file === null) {
			certificateResult.value = false;
			certificateResult.notValid.push('extra_certificate_file');
		}
	}

	return {
		value: result.value && certificateResult.value,
		notValid: [].concat(result.notValid, certificateResult.notValid)
	};
};

var CREDIT_KEY_MAP = {
	card_number: 'cardNumber',
	expiry_year: 'expireYear',
	expiry_month: 'expireMonth',
	security_code: 'cvc',
	credit_name: 'name'
};

var creditKeyFrom = exports.creditKeyFrom = function creditKeyFrom(keys) {
	return keys.map(function (key) {
		return CREDIT_KEY_MAP[key];
	});
};

var examCreditData = exports.examCreditData = function examCreditData(credit) {
	var keyArray = ['credit_name'];

	var result = {
		value: keyArray.every(function (key) {
			return (0, _helper.isExist)(credit[key]);
		}),
		notValid: keyArray.filter(function (key) {
			return (0, _helper.isEmpty)(credit[key]);
		})
	};

	var checkCreditNumber = _cardValidator2.default.number(credit.card_number);

	if (!checkCreditNumber.isValid || !['visa', 'mastercard', 'jcb'].includes(checkCreditNumber.card.type)) {
		if (true) {
			result.notValid.push('card_number');
			result.value = false;
		}
	}

	var checkCreditDate = _cardValidator2.default.expirationDate({
		month: credit.expiry_month,
		year: credit.expiry_year
	});

	if (!checkCreditDate.isValid) {
		result.notValid.push('expiry_year');
		result.notValid.push('expiry_month');
		result.value = false;
	}

	if (!_cardValidator2.default.cvv(credit.security_code).isValid) {
		result.notValid.push('security_code');
		result.value = false;
	}

	return {
		value: result.value,
		notValid: result.notValid
	};
};

/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        var _ref;

        observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = makeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["h"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["f"] = pushPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["g"] = regexEscape;
/* harmony export (immutable) */ __webpack_exports__["c"] = escape;
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getApartment = exports.getApartmentById = exports.updateApartmentByRoom = exports.updateApartment = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var _endpoint = __webpack_require__(35);

var _alert = __webpack_require__(17);

var _room = __webpack_require__(47);

var _helper = __webpack_require__(28);

var _apartment = __webpack_require__(228);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var updateApartment = exports.updateApartment = (0, _reduxActions.createAction)('UPDATE_APARTMENT', function (apartment) {
	return function (dispatch, getState) {
		var _ref2;

		var newApartment = (0, _helper.keyTransform)(apartment);
		var oldApartment = getState().apartment.data[newApartment.id] || _apartment.defaultApartmentData;

		newApartment.rooms.forEach(function (room) {
			return dispatch((0, _room.updateRoomByApartment)(room));
		});

		return _ref2 = {}, _ref2[newApartment.id] = _extends({}, _apartment.defaultApartmentData, oldApartment, newApartment, {
			rooms: newApartment.rooms.map(function (_ref) {
				var id = _ref.id;
				return id;
			})
		}), _ref2;
	};
});

var updateApartmentByRoom = exports.updateApartmentByRoom = (0, _reduxActions.createAction)('UPDATE_APARTMENT', function (apartment, roomId) {
	return function (_, getState) {
		var _ref3;

		var newApartment = (0, _helper.keyTransform)(apartment);
		var oldApartment = getState().apartment.data[newApartment.id] || _apartment.defaultApartmentData;

		return _ref3 = {}, _ref3[newApartment.id] = _extends({}, _apartment.defaultApartmentData, oldApartment, newApartment, {
			rooms: [].concat(oldApartment.rooms, [roomId])
		}), _ref3;
	};
});

var getApartmentById = exports.getApartmentById = (0, _reduxActions.createAction)('FETCH_APARTMENT_BY_ID', function (id) {
	return function () {
		var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
			var _ref5, status, message, data, newData, recommend;

			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return (0, _endpoint.wrapFetch)('apartment/' + id, {
								method: 'GET'
							});

						case 2:
							_ref5 = _context.sent;
							status = _ref5.status;
							message = _ref5.message;
							data = _ref5.data;

							if (!(status !== 200)) {
								_context.next = 8;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 8:
							newData = (0, _helper.keyTransform)(data.data);

							dispatch(updateApartment(newData));

							recommend = data.recommend.map(function (item) {
								dispatch(updateApartment((0, _helper.keyTransform)(item)));

								return item.id;
							});
							return _context.abrupt('return', { recommend: recommend });

						case 12:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x) {
			return _ref4.apply(this, arguments);
		};
	}();
});

var getApartment = exports.getApartment = (0, _reduxActions.createAction)('FETCH_APARTMENT', function () {
	return function () {
		var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch) {
			var _ref7, status, message, data, newData, list;

			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return (0, _endpoint.wrapFetch)('apartment', {
								method: 'GET'
							});

						case 2:
							_ref7 = _context2.sent;
							status = _ref7.status;
							message = _ref7.message;
							data = _ref7.data;

							if (!(status !== 200)) {
								_context2.next = 8;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 8:
							newData = {};
							list = data.map(function (item) {
								newData[item.id] = (0, _helper.keyTransform)(item);

								newData[item.id].rooms.forEach(function (room) {
									return dispatch((0, _room.updateRoomByApartment)(room));
								});

								newData[item.id].rooms = newData[item.id].rooms.map(function (_ref8) {
									var id = _ref8.id;
									return id;
								});

								return item.id;
							});
							return _context2.abrupt('return', {
								list: list,
								data: newData
							});

						case 11:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x2) {
			return _ref6.apply(this, arguments);
		};
	}();
});

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(40);

var _component = __webpack_require__(970);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var lan = _ref.i18n.lan;
	return {
		lan: lan
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, function () {
	return {};
})(_component2.default);

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setDefaults;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaults;
/* harmony export (immutable) */ __webpack_exports__["e"] = setI18n;
/* harmony export (immutable) */ __webpack_exports__["b"] = getI18n;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reactI18nextModule; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var defaultOptions = {
  wait: false,
  withRef: false,
  bindI18n: 'languageChanged loaded',
  bindStore: 'added removed',
  translateFuncName: 't',
  nsMode: 'default',
  usePureComponent: false
};

var i18n = void 0;

function setDefaults(options) {
  defaultOptions = _extends({}, defaultOptions, options);
}

function getDefaults() {
  return defaultOptions;
}

function setI18n(instance) {
  i18n = instance;
}

function getI18n() {
  return i18n;
}

var reactI18nextModule = {
  type: '3rdParty',

  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

/***/ }),
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.syncUserSettingFromLocalStorage = exports.syncUserSettingLocalStorageEpic = exports.updateUserCareerKeywordEpic = exports.updateUserInterestKeywordEpic = exports.updateUserProfessionKeywordEpic = exports.FIELD_ACTION_MAP = undefined;

var _reduxActions = __webpack_require__(5);

var _booking = __webpack_require__(55);

var _user = __webpack_require__(71);

var _helper = __webpack_require__(28);

var _storage = __webpack_require__(66);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var FIELD_ACTION_MAP = exports.FIELD_ACTION_MAP = {
	auth: (0, _reduxActions.createAction)('UPDATE_AUTH_FIELD', function (type, key, value) {
		return {
			type: type,
			key: key,
			value: value
		};
	}),
	user: (0, _reduxActions.createAction)('UPDATE_USER_FIELD', function (type, key, value) {
		return {
			type: type,
			key: key,
			value: value
		};
	}),
	community: (0, _reduxActions.createAction)('UPDATE_COMMUNITY_FIELD', function (type, key, value) {
		return {
			type: type,
			key: key,
			value: value
		};
	}),
	booking: _booking.updateBookingField,
	reservation: (0, _reduxActions.createAction)('UPDATE_RESERVATION_FIELD', function (type, key, value) {
		return {
			type: type,
			key: key,
			value: value
		};
	})
};

var updateUserProfessionKeywordEpic = exports.updateUserProfessionKeywordEpic = function updateUserProfessionKeywordEpic(action$) {
	return action$.ofType('UPDATE_USER_FIELD').debounceTime(500).filter(function (action) {
		return action.payload.key === 'professions' && Object.keys(action.payload.value).includes('inputValue');
	}).switchMap(function () {
		var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(action) {
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							return _context.abrupt('return', (0, _user.getUserProfessionOptionData)(action.payload.value.inputValue));

						case 1:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x) {
			return _ref.apply(this, arguments);
		};
	}());
};

var updateUserInterestKeywordEpic = exports.updateUserInterestKeywordEpic = function updateUserInterestKeywordEpic(action$) {
	return action$.ofType('UPDATE_USER_FIELD').debounceTime(500).filter(function (action) {
		return action.payload.key === 'interests' && Object.keys(action.payload.value).includes('inputValue');
	}).switchMap(function () {
		var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(action) {
			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							return _context2.abrupt('return', (0, _user.getUserInterestOptionData)(action.payload.value.inputValue));

						case 1:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x2) {
			return _ref2.apply(this, arguments);
		};
	}());
};

var updateUserCareerKeywordEpic = exports.updateUserCareerKeywordEpic = function updateUserCareerKeywordEpic(action$) {
	return action$.ofType('UPDATE_USER_FIELD').debounceTime(500).filter(function (action) {
		return action.payload.key === 'career' && Object.keys(action.payload.value).includes('inputValue');
	}).switchMap(function () {
		var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(action) {
			return regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							return _context3.abrupt('return', (0, _user.getUserCareerOptionData)(action.payload.value.inputValue));

						case 1:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, undefined);
		}));

		return function (_x3) {
			return _ref3.apply(this, arguments);
		};
	}());
};

var syncUserSettingLocalStorageEpic = exports.syncUserSettingLocalStorageEpic = function syncUserSettingLocalStorageEpic(action$, store) {
	return action$.ofType('UPDATE_USER_FIELD').debounceTime(500).filter(function () {
		return (0, _helper.mapUserLevel)(store.getState().user.data.levelId) === 'REGISTERED';
	}).forEach(function () {
		_storage.sessionStorage.setItem('userForm', JSON.stringify(store.getState().user.form));
	});
};

var syncUserSettingFromLocalStorage = exports.syncUserSettingFromLocalStorage = (0, _reduxActions.createAction)('SYNC_USER_SETTING_FROM_LOCALSTORAGE', function (form) {
	return { form: form };
});

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE = 19;

function verification(isValid, isPotentiallyValid, isCurrentYear) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    isCurrentYear: isCurrentYear || false
  };
}

function expirationYear(value, maxElapsedYear) {
  var currentFirstTwo, currentYear, firstTwo, len, twoDigitYear, valid, isCurrentYear;

  maxElapsedYear = maxElapsedYear || DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE;

  if (typeof value !== 'string') {
    return verification(false, false);
  }
  if (value.replace(/\s/g, '') === '') {
    return verification(false, true);
  }
  if (!/^\d*$/.test(value)) {
    return verification(false, false);
  }

  len = value.length;

  if (len < 2) {
    return verification(false, true);
  }

  currentYear = new Date().getFullYear();

  if (len === 3) {
    // 20x === 20x
    firstTwo = value.slice(0, 2);
    currentFirstTwo = String(currentYear).slice(0, 2);
    return verification(false, firstTwo === currentFirstTwo);
  }

  if (len > 4) {
    return verification(false, false);
  }

  value = parseInt(value, 10);
  twoDigitYear = Number(String(currentYear).substr(2, 2));

  if (len === 2) {
    isCurrentYear = twoDigitYear === value;
    valid = value >= twoDigitYear && value <= twoDigitYear + maxElapsedYear;
  } else if (len === 4) {
    isCurrentYear = currentYear === value;
    valid = value >= currentYear && value <= currentYear + maxElapsedYear;
  }

  return verification(valid, valid, isCurrentYear);
}

module.exports = expirationYear;


/***/ }),
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.resendVerifyEmail = exports.logout = exports.verifyEmail = exports.setNewPassword = exports.forgetPassword = exports.loginNormal = exports.signupNormal = undefined;

var _reduxActions = __webpack_require__(5);

var _isEmail = __webpack_require__(457);

var _isEmail2 = _interopRequireDefault(_isEmail);

var _reactRouterRedux = __webpack_require__(36);

var _modal = __webpack_require__(56);

var _endpoint = __webpack_require__(35);

var _user = __webpack_require__(71);

var _alert = __webpack_require__(17);

var _authStorage = __webpack_require__(105);

var _authStorage2 = _interopRequireDefault(_authStorage);

var _exam = __webpack_require__(117);

var _i18n = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var updateAccessToken = (0, _reduxActions.createAction)('UPDATE_ACCESS_TOKEN', function (_ref, remember) {
	var status = _ref.status,
	    message = _ref.message,
	    data = _ref.data;

	var token = {
		accessToken: '',
		endAt: '',
		expiresIn: '',
		refreshToken: ''
	};

	if (status === 200 || status === 201) {
		var expireMS = data.expires_in * 1000;

		token.accessToken = data.access_token;
		token.endAt = new Date().getTime() + expireMS;
		token.expiresIn = expireMS;
		token.refreshToken = data.refresh_token;
	}

	_authStorage2.default.setStoreInLocalStorage(remember);

	_authStorage2.default.setToken(JSON.stringify(token));

	return {
		token: token,
		status: status,
		message: message
	};
});

var signupNormal = exports.signupNormal = (0, _reduxActions.createAction)('SIGNUP_NORMAL', function () {
	return function () {
		var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
			var _getState, _getState$auth$signup, email, password, checkPassword, agreement, query, result;

			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_getState = getState(), _getState$auth$signup = _getState.auth.signupForm, email = _getState$auth$signup.email, password = _getState$auth$signup.password, checkPassword = _getState$auth$signup.checkPassword, agreement = _getState$auth$signup.agreement, query = _getState.routing.locationBeforeTransitions.query;

							if (!(email.value === '' || !(0, _isEmail2.default)(email.value))) {
								_context.next = 4;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:verifyEmailFail')));
							return _context.abrupt('return');

						case 4:
							if ((0, _exam.examPassword)(password.value)) {
								_context.next = 7;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:verifyPasswordFail')));
							return _context.abrupt('return');

						case 7:
							if (!(password.value !== checkPassword.value)) {
								_context.next = 10;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:verifyCheckPasswordFail')));
							return _context.abrupt('return');

						case 10:
							if (!(agreement.value === false)) {
								_context.next = 13;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:verifyAgree')));
							return _context.abrupt('return');

						case 13:
							_context.next = 15;
							return (0, _endpoint.wrapFetch)('auth/signUp', {
								method: 'POST',
								body: JSON.stringify({
									email: email.value,
									password: password.value,
									vip_token: query.vip_token
								})
							});

						case 15:
							result = _context.sent;

							if (!(result.status !== 200 && result.status !== 201)) {
								_context.next = 19;
								break;
							}

							if (result.message === 'email repeat') {
								dispatch((0, _alert.openFailedAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:SignupLoginFail')));
							} else {
								dispatch((0, _alert.openFailedAlert)('loginSignup', result.message));
							}
							return _context.abrupt('return');

						case 19:

							dispatch((0, _modal.openMessageModal)('loginSignup', { type: 'signupSuccess' }));

						case 20:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x, _x2) {
			return _ref2.apply(this, arguments);
		};
	}();
});

var loginNormal = exports.loginNormal = (0, _reduxActions.createAction)('LOGIN_NORMAL', function () {
	return function () {
		var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
			var _getState2, _getState2$auth$login, email, password, remember, result, _getState3, pathname, _getState4, state;

			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_getState2 = getState(), _getState2$auth$login = _getState2.auth.loginForm, email = _getState2$auth$login.email, password = _getState2$auth$login.password, remember = _getState2$auth$login.remember;

							if (!(email.value === '' || !(0, _isEmail2.default)(email.value))) {
								_context2.next = 4;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:verifyEmailFail')));
							return _context2.abrupt('return');

						case 4:
							_context2.next = 6;
							return (0, _endpoint.wrapFetch)('auth/login', {
								method: 'POST',
								body: JSON.stringify({ email: email.value, password: password.value })
							});

						case 6:
							result = _context2.sent;


							dispatch(updateAccessToken(result, remember.value));

							if (!(result.status !== 200 && result.status !== 201)) {
								_context2.next = 11;
								break;
							}

							if (result.message === 'login failed') {
								dispatch((0, _alert.openFailedAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:SignupLoginFail')));
							} else if (result.message === 'need verify') {
								dispatch((0, _alert.openFailedAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:verifyFail'), {
									type: 'resendVerifyEmail'
								}));
							} else {
								dispatch((0, _alert.openFailedAlert)('loginSignup', result.message));
							}
							return _context2.abrupt('return');

						case 11:

							dispatch((0, _modal.closeMessageModal)('loginSignup'));

							// Fetch user data after login
							_context2.next = 14;
							return dispatch((0, _user.getUser)());

						case 14:
							_getState3 = getState(), pathname = _getState3.routing.locationBeforeTransitions.pathname;

							// Specfic page for smart redirect

							if (!pathname.includes('/login')) {
								_context2.next = 21;
								break;
							}

							_getState4 = getState(), state = _getState4.routing.locationBeforeTransitions.state;

							if (!(state && !state.nextPathname.includes('/login'))) {
								_context2.next = 20;
								break;
							}

							dispatch((0, _reactRouterRedux.replace)({ pathname: state.nextPathname, query: state.nextQuery }));
							return _context2.abrupt('return');

						case 20:

							dispatch((0, _reactRouterRedux.replace)({ pathname: '/' }));

						case 21:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x3, _x4) {
			return _ref3.apply(this, arguments);
		};
	}();
});

var forgetPassword = exports.forgetPassword = (0, _reduxActions.createAction)('FORGET_PASSWORD', function () {
	return function () {
		var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
			var _getState5, email, _ref5, status, message;

			return regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_getState5 = getState(), email = _getState5.auth.forgetForm.email;
							_context3.next = 3;
							return (0, _endpoint.wrapFetch)('auth/forgetPassword', {
								method: 'POST',
								body: JSON.stringify({ email: email.value })
							});

						case 3:
							_ref5 = _context3.sent;
							status = _ref5.status;
							message = _ref5.message;


							if (status !== 200) {
								dispatch((0, _alert.openFailedAlert)('loginSignup', message));
							}

							dispatch((0, _alert.openSuccessAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:forgetPasswordSendSuccess', { email: email.value })));

						case 8:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, undefined);
		}));

		return function (_x5, _x6) {
			return _ref4.apply(this, arguments);
		};
	}();
});

var setNewPassword = exports.setNewPassword = (0, _reduxActions.createAction)('SET_NEW_PASSWORD', function () {
	return function () {
		var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
			var _getState6, _getState6$auth$passw, password, checkPassword, _getState6$routing$lo, token, pathname, result, _getState7, lan, _ref7, status, message;

			return regeneratorRuntime.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							_getState6 = getState(), _getState6$auth$passw = _getState6.auth.passwordForm, password = _getState6$auth$passw.password, checkPassword = _getState6$auth$passw.checkPassword, _getState6$routing$lo = _getState6.routing.locationBeforeTransitions, token = _getState6$routing$lo.query.token, pathname = _getState6$routing$lo.pathname;

							if ((0, _exam.examPassword)(password.value)) {
								_context4.next = 4;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:verifyPasswordFail')));
							return _context4.abrupt('return');

						case 4:
							if (!(password.value !== checkPassword.value)) {
								_context4.next = 7;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:verifyCheckPasswordFail')));
							return _context4.abrupt('return');

						case 7:
							if (!pathname.includes('signup')) {
								_context4.next = 25;
								break;
							}

							_context4.next = 10;
							return (0, _endpoint.wrapFetch)('auth/setVipPassword', {
								method: 'POST',
								body: JSON.stringify({
									password: password.value,
									token: token
								})
							});

						case 10:
							result = _context4.sent;


							dispatch(updateAccessToken(result, true));

							if (!(result.status !== 200)) {
								_context4.next = 18;
								break;
							}

							if (!(result.message === 'not found vip')) {
								_context4.next = 16;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:vipTokenFailed')));
							return _context4.abrupt('return');

						case 16:
							dispatch((0, _alert.openFailedAlert)('loginSignup', result.message));
							return _context4.abrupt('return');

						case 18:

							dispatch((0, _modal.closeMessageModal)('loginSignup'));

							// Fetch user data after login
							_context4.next = 21;
							return dispatch((0, _user.getUser)());

						case 21:
							_getState7 = getState(), lan = _getState7.i18n.lan;


							dispatch((0, _reactRouterRedux.replace)({ pathname: (0, _i18n.languageMapRoute)(lan) + '/user/settings' }));
							_context4.next = 38;
							break;

						case 25:
							_context4.next = 27;
							return (0, _endpoint.wrapFetch)('auth/resetPassword', {
								method: 'POST',
								body: JSON.stringify({
									password: password.value,
									password_confirmation: checkPassword.value,
									password_token: token
								})
							});

						case 27:
							_ref7 = _context4.sent;
							status = _ref7.status;
							message = _ref7.message;

							if (!(status !== 200)) {
								_context4.next = 36;
								break;
							}

							if (!(message === 'The payload is invalid.')) {
								_context4.next = 34;
								break;
							}

							dispatch((0, _alert.openFailedAlert)('loginSignup', '重設密碼連結失效，請重新索取'));
							return _context4.abrupt('return');

						case 34:
							dispatch((0, _alert.openFailedAlert)('loginSignup', message));
							return _context4.abrupt('return');

						case 36:

							dispatch((0, _alert.openSuccessAlert)('loginSignup', '新密碼設定好了！來登入吧'));
							dispatch((0, _modal.openMessageModal)('loginSignup', { type: 'loginForm' }));

						case 38:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, undefined);
		}));

		return function (_x7, _x8) {
			return _ref6.apply(this, arguments);
		};
	}();
});

var verifyEmail = exports.verifyEmail = (0, _reduxActions.createAction)('VERIFY_EMAIL', function (token) {
	return function () {
		var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch) {
			var _ref9, status;

			return regeneratorRuntime.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_context5.next = 2;
							return (0, _endpoint.wrapFetch)('auth/verify', {
								method: 'POST',
								body: JSON.stringify({ email_token: token })
							});

						case 2:
							_ref9 = _context5.sent;
							status = _ref9.status;

							if (!(status !== 200 && status !== 201)) {
								_context5.next = 8;
								break;
							}

							dispatch((0, _modal.openMessageModal)('loginSignup', { type: 'loginForm' }));
							dispatch((0, _alert.openFailedAlert)('loginSignup', 'token 錯誤'));
							return _context5.abrupt('return');

						case 8:

							dispatch((0, _modal.openMessageModal)('loginSignup', { type: 'loginForm' }));
							dispatch((0, _alert.openSuccessAlert)('loginSignup', (0, _i18n.t)('modalLoginSignup:verifySuccess')));

						case 10:
						case 'end':
							return _context5.stop();
					}
				}
			}, _callee5, undefined);
		}));

		return function (_x9) {
			return _ref8.apply(this, arguments);
		};
	}();
});

var logout = exports.logout = (0, _reduxActions.createAction)('LOGOUT', function () {
	return function () {
		var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
			var _ref11, status, _getState8, pathname;

			return regeneratorRuntime.wrap(function _callee6$(_context6) {
				while (1) {
					switch (_context6.prev = _context6.next) {
						case 0:
							_context6.next = 2;
							return (0, _endpoint.wrapFetchAuth)('user/logout', {
								method: 'POST'
							});

						case 2:
							_ref11 = _context6.sent;
							status = _ref11.status;


							if (status !== 200) {
								dispatch((0, _alert.openFailedAlert)('generic', 'Logout Failed'));
							}

							_authStorage2.default.removeToken();

							_getState8 = getState(), pathname = _getState8.routing.locationBeforeTransitions.pathname;


							if (pathname.includes('/user') || pathname.includes('/booking') || pathname.includes('/reservation')) {
								dispatch((0, _reactRouterRedux.push)('/'));
							}

						case 8:
						case 'end':
							return _context6.stop();
					}
				}
			}, _callee6, undefined);
		}));

		return function (_x10, _x11) {
			return _ref10.apply(this, arguments);
		};
	}();
});

var resendVerifyEmail = exports.resendVerifyEmail = (0, _reduxActions.createAction)('RESEND_VERIFY_EMAIL', function () {
	return function () {
		var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
			var _getState9, email, _ref13, status;

			return regeneratorRuntime.wrap(function _callee7$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							_getState9 = getState(), email = _getState9.auth.loginForm.email;
							_context7.next = 3;
							return (0, _endpoint.wrapFetch)('auth/resendVerify', {
								method: 'POST',
								body: JSON.stringify({ email: email })
							});

						case 3:
							_ref13 = _context7.sent;
							status = _ref13.status;


							if (status !== 200) {
								dispatch((0, _alert.openFailedAlert)('loginSignup', 'Resend Faild'));
							}

							dispatch((0, _alert.openSuccessAlert)('loginSignup', '認證信已寄出'));

						case 7:
						case 'end':
							return _context7.stop();
					}
				}
			}, _callee7, undefined);
		}));

		return function (_x12, _x13) {
			return _ref12.apply(this, arguments);
		};
	}();
});

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.loadGoogleMapLibrary = undefined;

var _key = __webpack_require__(572);

var insertScript = function insertScript(id, src) {
	var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { async: true, defer: true };

	if (document.getElementById(id)) {
		return 1;
	}

	var jss = document.getElementsByTagName('script')[0];
	var js = document.createElement('script');

	js.id = id;
	js.src = src;

	if (options.async) {
		js.async = true;
	}

	if (options.defer) {
		js.defer = true;
	}

	jss.parentNode.insertBefore(js, jss);
	return 0;
}; // This file is to async load external library and add into global

var loadGoogleMapLibrary = exports.loadGoogleMapLibrary = function loadGoogleMapLibrary() {
	return new Promise(function (resolve) {
		window.initMap = function () {
			return resolve();
		};

		var result = insertScript('google-map-jssdk', '//maps.googleapis.com/maps/api/js?key=' + _key.GOOGLE_MAP_API_KEY + '&callback=initMap');

		// Aready insert
		if (result === 1) {
			resolve();
		}
	});
};

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(27);

var _classnames3 = _interopRequireDefault(_classnames2);

var _index = __webpack_require__(980);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Icon = function Icon(_ref) {
	var _classnames;

	var children = _ref.children,
	    className = _ref.className,
	    _ref$light = _ref.light,
	    light = _ref$light === undefined ? false : _ref$light,
	    other = _objectWithoutProperties(_ref, ['children', 'className', 'light']);

	return _react2.default.createElement(
		'i',
		_extends({
			className: (0, _classnames3.default)('material-icons', _index2.default.icon, className, (_classnames = {}, _classnames[_index2.default.light] = light, _classnames))
		}, other),
		children
	);
};

exports.default = Icon;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultApartmentData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var defaultApartmentData = exports.defaultApartmentData = {
	id: -1,
	name: '',
	type: 'CO_LIVING',
	status: 'COMING_SOON',
	publishStatus: 'DELETE',
	content: '',
	mrt: '',
	cleanService: '',
	trashService: '',
	room: 0,
	kitchen: 0,
	balcony: 0,
	pet: 0,
	publicBath: 0,
	pingNumber: 0,
	floor: 0,
	elevator: 0,
	address: '',
	mrtWalkTime: 0,
	doorPassword: '',
	wifiName: '',
	wifiPassword: '',
	taxId: '',
	electricNumber: '',
	waterNumber: '',
	gasNumber: '',
	networkNumber: '',
	latitude: -21.58704,
	longitude: 59.228986,
	remarks: '',
	createdAt: '2018-06-19 16:43:20',
	updatedAt: '2018-06-19 16:43:20',
	owners: [],
	photos: [],
	tags: [],
	rooms: [],
	mrtData: {
		id: 95,
		name: '龍山寺',
		name_en: 'Longshan Temple',
		line: '板橋南港',
		line_en: 'Bannan',
		near_station: '西門,江子翠',
		near_station_en: 'Ximen,Jianzicui',
		created_at: '2018-10-12 18:43:06',
		updated_at: '2018-10-12 19:01:14'
	},
	cityData: null,
	districtData: null
};

exports.default = (0, _reduxActions.handleActions)({
	FETCH_APARTMENT_FULFILLED: function FETCH_APARTMENT_FULFILLED(state, action) {
		return _extends({}, state, {
			list: action.payload.list,
			data: action.payload.data
		});
	},

	UPDATE_APARTMENT: function UPDATE_APARTMENT(state, action) {
		return _extends({}, state, {
			data: _extends({}, state.data, action.payload)
		});
	},

	FETCH_APARTMENT_BY_ID_FULFILLED: function FETCH_APARTMENT_BY_ID_FULFILLED(state, action) {
		return _extends({}, state, {

			recommend: action.payload.recommend
		});
	},

	FETCH_COLLECT_FULFILLED: function FETCH_COLLECT_FULFILLED(state, action) {
		return _extends({}, state, {

			data: _extends({}, state.data, action.payload.apartmentData)
		});
	}
}, {
	list: [],
	data: {},
	recommend: [],
	currentPage: 0,
	lastPage: 0,
	perPage: 0,
	total: 0
});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultRoomData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var defaultRoomData = exports.defaultRoomData = {
	id: -1,
	apartmentId: -1,
	name: '',
	number: '',
	type: '',
	status: 'AVAILABLE',
	price: 0,
	energyPrice: 0,
	deposit: 0,
	pingNumber: 0,
	releaseTime: '2018-06-19 16:43:20',
	sexLimit: 'MALE',
	maxOrder: 0,
	double: 0,
	pet: 0,
	createdAt: '2018-06-19 16:43:20',
	updatedAt: '2018-06-19 16:43:20',
	photos: [],
	tags: [],
	hasProcessingEvent: [],
	hasProcessingOrder: [],
	users: [],
	roommate: []
};

exports.default = (0, _reduxActions.handleActions)({
	FETCH_ROOM_PENDING: function FETCH_ROOM_PENDING(state) {
		return _extends({}, state, {
			list: []
		});
	},

	FETCH_ROOM_FULFILLED: function FETCH_ROOM_FULFILLED(state, action) {
		return _extends({}, state, action.payload);
	},

	FETCH_ROOM_BY_ID_FULFILLED: function FETCH_ROOM_BY_ID_FULFILLED(state, action) {
		return _extends({}, state, {
			data: _extends({}, state.data, action.payload.data),

			recommend: action.payload.recommend
		});
	},

	UPDATE_ROOM: function UPDATE_ROOM(state, action) {
		return _extends({}, state, {
			data: _extends({}, state.data, action.payload)
		});
	},

	FETCH_MORE_ROOM_FULFILLED: function FETCH_MORE_ROOM_FULFILLED(state, action) {
		return _extends({}, state, {

			list: [].concat(state.list, action.payload.list),
			data: _extends({}, state.data, action.payload.data),
			currentPage: action.payload.currentPage,
			lastPage: action.payload.lastPage,
			perPage: action.payload.perPage,
			total: action.payload.total
		});
	},

	FETCH_COLLECT_FULFILLED: function FETCH_COLLECT_FULFILLED(state, action) {
		return _extends({}, state, {

			data: _extends({}, state.data, action.payload.roomData)
		});
	}
}, {
	list: [],
	data: {},
	recommend: [],
	currentPage: 0,
	lastPage: 0,
	perPage: 0,
	total: 0
});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.calculateRoomStatus = exports.calculateCheckinTime = exports.ORDER_ITEM_PET_CLEANING_FEE_ID = exports.ORDER_ITEM_EXTRA_PERSON_ID = exports.ORDER_ITEM_PET_ID = exports.calculateMonth = exports.calculateRent = exports.normalizePrice = undefined;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _i18n = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-mixed-operators */

var normalizePrice = exports.normalizePrice = function normalizePrice(price) {
	return Math.round(price / 100) * 100;
};

var calculateRent = exports.calculateRent = function calculateRent(roomData) {
	return {
		deposit: roomData.deposit,
		shortRent: normalizePrice(roomData.price * 1.6),
		middleRent: normalizePrice(roomData.price * 1.3),
		rent: roomData.price
	};
};

var calculateMonth = exports.calculateMonth = function calculateMonth(range, yearRange) {
	var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { excludeLastMonth: true },
	    excludeLastMonth = _ref.excludeLastMonth;

	if (range.length === 0 || yearRange.length === 0) {
		return 0;
	}

	if (range.length < 2 || yearRange.length < 2) {
		return 1;
	}

	var dumpNumber = excludeLastMonth ? 1 : 0;

	return range[1] - range[0] + 1 + 12 * (yearRange[1] - yearRange[0]) - dumpNumber;
};

var ORDER_ITEM_PET_ID = exports.ORDER_ITEM_PET_ID = 1;
var ORDER_ITEM_EXTRA_PERSON_ID = exports.ORDER_ITEM_EXTRA_PERSON_ID = 2;
var ORDER_ITEM_PET_CLEANING_FEE_ID = exports.ORDER_ITEM_PET_CLEANING_FEE_ID = 3;

var calculateCheckinTime = exports.calculateCheckinTime = function calculateCheckinTime(events, lan) {
	var _events$filter = events.filter(function (event) {
		return ['VERIFY', 'RESERVED', 'SUCCESS'].includes(event.status) && event.event_type === 'CHECKIN';
	}),
	    _events$filter$ = _events$filter[0];

	_events$filter$ = _events$filter$ === undefined ? { work_date: '' } : _events$filter$;
	var workDate = _events$filter$.work_date;


	if (workDate === '') {
		return '';
	}

	var startTime = (0, _moment2.default)(workDate);
	var endTime = (0, _moment2.default)(workDate).add(15, 'm');

	return startTime.format(lan === 'en' ? 'MMM/DD/YYYY HH:mm' : 'YYYY/MM/DD HH:mm') + ' - ' + endTime.format('HH:mm');
};

var calculateRoomStatus = exports.calculateRoomStatus = function calculateRoomStatus(roomData, lan) {
	if (roomData.hasProcessingOrder === null) {
		return { date: '', available: (0, _i18n.t)('bookingBar:available'), isAvailable: true };
	}

	if (roomData.canOrderStart === null) {
		return { date: '', available: (0, _i18n.t)('bookingBar:available'), isAvailable: true };
	}

	var canOrderStart = (0, _moment2.default)(roomData.canOrderStart);

	if (roomData.canBooking) {
		return {
			date: (0, _i18n.t)('bookingBar:releaseTime', {
				YYYY: canOrderStart.format('YYYY'),
				MM: canOrderStart.format(lan === 'en' ? 'MMM' : 'MM'),
				DD: canOrderStart.format('DD')
			}),
			available: (0, _i18n.t)('bookingBar:available'),
			isAvailable: true
		};
	}

	return {
		date: '',
		available: (0, _i18n.t)('bookingBar:notAvailable'),
		isAvailable: false
	};
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(40);

var _alert = __webpack_require__(17);

var _component = __webpack_require__(571);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
	var alert = _ref.alert;
	var namespace = _ref2.namespace;
	return {
		show: alert[namespace].show,
		text: alert[namespace].message,
		success: alert[namespace].success
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
	var namespace = _ref3.namespace;
	return {
		onCloseAlert: function onCloseAlert() {
			return dispatch((0, _alert.closeAlert)(namespace));
		}
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_component2.default);

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(281);
var objectAssign = __webpack_require__(98);
var decodeComponent = __webpack_require__(942);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getCollect = exports.collect = undefined;

var _reduxActions = __webpack_require__(5);

var _alert = __webpack_require__(17);

var _endpoint = __webpack_require__(35);

var _helper = __webpack_require__(28);

var _apartment = __webpack_require__(145);

var _room = __webpack_require__(47);

var _modal = __webpack_require__(56);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var collect = exports.collect = (0, _reduxActions.createAction)('COLLECT_APARTMENT_OR_ROOM', function (type, id) {
	return function () {
		var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
			var _getState, accessToken, _ref2, status, message, ID, _getState2, _getState2$collect, roomList, apartmentList;

			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_getState = getState(), accessToken = _getState.auth.token.accessToken;

							if (!(accessToken === '')) {
								_context.next = 4;
								break;
							}

							dispatch((0, _modal.openMessageModal)('loginSignup', { type: 'loginForm' }));
							return _context.abrupt('return', { roomList: [], apartmentList: [] });

						case 4:
							_context.next = 6;
							return (0, _endpoint.wrapFetchAuth)('collect', {
								method: 'POST',
								body: JSON.stringify({ model: type, id: id })
							});

						case 6:
							_ref2 = _context.sent;
							status = _ref2.status;
							message = _ref2.message;

							if (!(status !== 200)) {
								_context.next = 11;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 11:
							ID = parseInt(id, 10);
							_getState2 = getState(), _getState2$collect = _getState2.collect, roomList = _getState2$collect.roomList, apartmentList = _getState2$collect.apartmentList;

							if (!(type === 'rooms')) {
								_context.next = 16;
								break;
							}

							console.log(roomList);
							return _context.abrupt('return', {
								roomList: roomList.includes(ID) ? roomList.filter(function (tmpId) {
									return tmpId !== ID;
								}) : [].concat(roomList, [ID]),
								apartmentList: apartmentList
							});

						case 16:
							return _context.abrupt('return', {
								apartmentList: apartmentList.includes(ID) ? apartmentList.filter(function (tmpId) {
									return tmpId !== ID;
								}) : [].concat(apartmentList, [ID]),
								roomList: roomList
							});

						case 17:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x, _x2) {
			return _ref.apply(this, arguments);
		};
	}();
});

var getCollect = exports.getCollect = (0, _reduxActions.createAction)('FETCH_COLLECT', function () {
	return function () {
		var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch) {
			var _ref4, status, message, data, roomData, roomList, apartmentData, apartmentList;

			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return (0, _endpoint.wrapFetchAuth)('user/collections', {
								method: 'GET'
							});

						case 2:
							_ref4 = _context2.sent;
							status = _ref4.status;
							message = _ref4.message;
							data = _ref4.data;

							if (!(status !== 200)) {
								_context2.next = 8;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 8:
							roomData = {};
							roomList = data.rooms.map(function (item) {
								roomData[item.id] = (0, _helper.keyTransform)(item);
								var apartment = roomData[item.id].apartment;

								roomData[item.id].apartment = undefined;

								dispatch((0, _apartment.updateApartmentByRoom)(apartment, item.id));

								return item.id;
							});
							apartmentData = {};
							apartmentList = data.apartments.map(function (item) {
								apartmentData[item.id] = (0, _helper.keyTransform)(item);
								apartmentData[item.id].rooms.forEach(function (room) {
									return dispatch((0, _room.updateRoomByApartment)(room));
								});
								apartmentData[item.id].rooms = apartmentData[item.id].rooms.map(function (_ref5) {
									var id = _ref5.id;
									return id;
								});

								return item.id;
							});
							return _context2.abrupt('return', {
								roomList: roomList,
								apartmentList: apartmentList,
								roomData: roomData,
								apartmentData: apartmentData
							});

						case 13:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x3) {
			return _ref3.apply(this, arguments);
		};
	}();
});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setRoomFilterQuery = exports.getRoomFilter = exports.handleQueryStringEpic = exports.handleMrtLineChangeEpic = exports.handleCityChangeEpic = exports.updateRoomFilter = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var _reactRouterRedux = __webpack_require__(36);

var _mrt = __webpack_require__(941);

var _endpoint = __webpack_require__(35);

var _alert = __webpack_require__(17);

var _helper = __webpack_require__(28);

var _i18n = __webpack_require__(16);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var calcEndMonth = function calcEndMonth(year, month) {
	if (month === 11) {
		return { year: year + 1, month: 0 };
	}

	return { year: year, month: month + 1 };
};

var filterKeyMapRoute = {
	city: function city(value, query) {
		var _ = query.district,
		    resetQuery = _objectWithoutProperties(query, ['district']);

		if (![1, 2, 3].includes(value.select[0].value)) {
			var __ = resetQuery.mrt_line,
			    ___ = resetQuery.mrt,
			    resultQuery = _objectWithoutProperties(resetQuery, ['mrt_line', 'mrt']);

			return _extends({}, resultQuery, { city: value.select[0].value });
		}

		return _extends({}, resetQuery, { city: value.select[0].value });
	},

	district: function district(value, query) {
		if (value.select[0].value === -1) {
			var _ = query.district,
			    resultQuery = _objectWithoutProperties(query, ['district']);

			return resultQuery;
		}

		return _extends({}, query, { district: value.select[0].value });
	},

	month: function month(value, query) {
		if (value.range.length < 2) {
			var _ = query.live_start,
			    __ = query.live_end,
			    other = _objectWithoutProperties(query, ['live_start', 'live_end']);

			return other;
		}

		var startYear = value.yearRange[0];
		var startMonth = value.range[0];

		var _calcEndMonth = calcEndMonth(value.yearRange[1], value.range[1]),
		    endYear = _calcEndMonth.year,
		    endMonth = _calcEndMonth.month;

		return _extends({}, query, {
			live_start: startYear + '-' + (startMonth + 1) + '-01',
			live_end: endYear + '-' + (endMonth + 1) + '-01'
		});
	},

	mrtLine: function mrtLine(value, query) {
		var _ = query.mrt,
		    resetQuery = _objectWithoutProperties(query, ['mrt']);

		if (value.select[0].value === 0) {
			var __ = resetQuery.mrt_line,
			    resultQuery = _objectWithoutProperties(resetQuery, ['mrt_line']);

			return resultQuery;
		}

		return _extends({}, resetQuery, { mrt_line: value.select[0].value });
	},

	mrtStation: function mrtStation(value, query) {
		return _extends({}, query, { mrt: value.select[0].value });
	},

	mrtAround: function mrtAround(value, query) {
		return _extends({}, query, { near_station: value.value ? 1 : 0 });
	},

	apartment: function apartment(value, query) {
		if (value.select[0].value === -1) {
			var __ = query.apartment_id,
			    resultQuery = _objectWithoutProperties(query, ['apartment_id']);

			return resultQuery;
		}

		return _extends({}, query, { apartment_id: value.select[0].value });
	},

	roomType: function roomType(value, query) {
		return _extends({}, query, { room_type: value.select.map(function (item) {
				return item.value;
			}) });
	},

	price: function price(value, query) {
		return _extends({}, query, { price_start: value.range[0], price_end: value.range[1] });
	},

	area: function area(value, query) {
		return _extends({}, query, { ping_start: value.range[0], ping_end: value.range[1] });
	},

	double: function double(value, query) {
		if (value.select.value === '-1') {
			// remove unnecessary query
			var _ = query.double,
			    other = _objectWithoutProperties(query, ['double']);

			return other;
		}

		return _extends({}, query, { double: value.select.value });
	},

	pet: function pet(value, query) {
		if (value.select.value === '-1') {
			// remove unnecessary query
			var _ = query.pet,
			    other = _objectWithoutProperties(query, ['pet']);

			return other;
		}

		return _extends({}, query, { pet: value.select.value });
	},

	feature: function feature(value, query) {
		return _extends({}, query, { tag: value.select.map(function (item) {
				return item.value;
			}) });
	},

	unavailableType: function unavailableType(value, query) {
		return _extends({}, query, { type: value.value ? 'all' : 'waiting' });
	},

	sort: function sort(value, query) {
		return _extends({}, query, { sort_by: value.select[0].value });
	}
};

var updateRoomFilter = exports.updateRoomFilter = (0, _reduxActions.createAction)('UPDATE_ROOM_FILTER', function (key, value) {
	return {
		key: key,
		value: value
	};
});

var handleCityChangeEpic = exports.handleCityChangeEpic = function handleCityChangeEpic(action$) {
	return action$.ofType('UPDATE_ROOM_FILTER').filter(function (action) {
		return action.payload.key === 'city';
	}).map(function (action) {
		return {
			type: 'UPDATE_DISTRICT_OPTIONS',
			payload: {
				list: action.payload.value.select[0].districts
			}
		};
	});
};

var handleMrtLineChangeEpic = exports.handleMrtLineChangeEpic = function handleMrtLineChangeEpic(action$) {
	return action$.ofType('UPDATE_ROOM_FILTER').filter(function (action) {
		return action.payload.key === 'mrtLine';
	}).map(function (action) {
		return {
			type: 'UPDATE_MRT_STATION_OPTIONS',
			payload: { list: action.payload.value.select[0].stations }
		};
	});
};

var handleQueryStringEpic = exports.handleQueryStringEpic = function handleQueryStringEpic(action$, store) {
	return action$.ofType('UPDATE_ROOM_FILTER').debounceTime(500).map(function (action) {
		var _store$getState = store.getState(),
		    _store$getState$routi = _store$getState.routing.locationBeforeTransitions,
		    query = _store$getState$routi.query,
		    pathname = _store$getState$routi.pathname;

		var newQuery = filterKeyMapRoute[action.payload.key](action.payload.value, query);

		// Prevent refresh the route if query not change
		if (newQuery === query) {
			return { type: 'FILTER_NOT_CHANGE' };
		}

		return (0, _reactRouterRedux.push)({
			pathname: pathname,
			query: newQuery
		});
	});
};

var getRoomFilter = exports.getRoomFilter = (0, _reduxActions.createAction)('FETCH_ROOM_FILTER', _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	var _ref2, status, message, data, cityData, districtsData, cityList, apartmentData, apartmentList, roomTypeData, roomTypeList, featureData, featureList;

	return regeneratorRuntime.wrap(function _callee$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					_context.next = 2;
					return (0, _endpoint.wrapFetch)('room/getFilter', {
						method: 'GET'
					});

				case 2:
					_ref2 = _context.sent;
					status = _ref2.status;
					message = _ref2.message;
					data = _ref2.data;

					if (!(status !== 200)) {
						_context.next = 8;
						break;
					}

					throw (0, _alert.openFailedAlert)('generic', message);

				case 8:
					cityData = {};
					districtsData = { '-1': { value: -1, label: (0, _i18n.t)('roomFilter:all') } };
					cityList = data.city.map(function (item) {
						cityData[item.id] = { value: item.id, label: item.name };
						if (item.id !== 1) {
							cityData[item.id].districts = [-1].concat(item.districts.map(function (district) {
								districtsData[district.id] = { value: district.id, label: district.name };
								return district.id;
							}));
						} else {
							cityData[item.id].districts = item.districts.map(function (district) {
								districtsData[district.id] = { value: district.id, label: district.name };
								return district.id;
							});
						}
						return item.id;
					});
					apartmentData = { '-1': { value: -1, label: (0, _i18n.t)('roomFilter:all') } };
					apartmentList = [-1].concat(data.apartment.map(function (item) {
						apartmentData[item.id] = { value: item.id, label: item.name };

						return item.id;
					}));
					roomTypeData = {};
					roomTypeList = data.room_type.map(function (item) {
						roomTypeData[item] = { value: item, label: (0, _helper.mapRoomType)(item) };

						return item;
					});
					featureData = {};
					featureList = data.apartment_tags.map(function (item) {
						featureData[item.id] = { value: item.id, label: item.name };

						return item.id;
					});
					return _context.abrupt('return', _extends({}, (0, _mrt.organizeMrtData)(data.mrt), {
						cityData: cityData,
						cityList: cityList,
						districtsData: districtsData,
						apartmentData: apartmentData,
						apartmentList: apartmentList,
						roomTypeData: roomTypeData,
						roomTypeList: roomTypeList,
						minMaxPriceRange: (0, _helper.normalizeRange)([data.min_price, data.max_price], (0, _helper.calculateDigit)(data.min_price) - 1),
						minMaxAreaRange: (0, _helper.normalizeRange)([data.min_ping, data.max_ping], (0, _helper.calculateDigit)(data.min_ping) - 1),
						featureData: featureData,
						featureList: featureList
					}));

				case 18:
				case 'end':
					return _context.stop();
			}
		}
	}, _callee, undefined);
})));

var normalizeMonth = function normalizeMonth(start, end) {
	if (start.length < 3 || end.length < 3) {
		return { range: [], yearRange: [] };
	}

	var startMonth = parseInt(start[1], 10);
	var startYear = parseInt(start[0], 10);
	var endMonth = parseInt(end[1], 10);
	var endYear = parseInt(end[0], 10);

	if (startMonth > 12 || startMonth < 1 || endMonth > 12 || endMonth < 1) {
		return { range: [], yearRange: [] };
	}

	if (endMonth === 1) {
		return { range: [startMonth - 1, 11], yearRange: [startYear, endYear - 1] };
	}

	return { range: [startMonth - 1, endMonth - 2], yearRange: [startYear, endYear] };
};

var setRoomFilterQuery = exports.setRoomFilterQuery = (0, _reduxActions.createAction)('SET_ROOM_FILTER_QUERY', function (query) {
	return function (_, getState) {
		var resultFilter = {
			city: { select: [] },
			district: { select: [], list: [] },
			mrtLine: { select: [] },
			mrtStation: { select: [], list: [] },
			mrtAround: { value: false },
			apartment: { select: [] },
			roomType: { select: [] },
			month: { range: [], yearRange: [] },
			price: {},
			area: {},
			double: { select: { label: '', value: '' } },
			pet: { select: { label: '', value: '' } },
			feature: { select: [] },
			unavailableType: { value: false },
			sort: { select: [{ label: (0, _i18n.t)('rooms:UpToDate'), value: 'new' }] }
		};

		if (query.city) {
			var _getState = getState(),
			    city = _getState.filter.city;

			var _city$list$filter = city.list.filter(function (id) {
				return id === parseInt(query.city, 10);
			}),
			    cityId = _city$list$filter[0];

			if (cityId) {
				resultFilter.city.select = [city.data[cityId]];
				resultFilter.district.list = city.data[cityId].districts;
			}
		}

		if (query.district) {
			var _getState2 = getState(),
			    district = _getState2.filter.district;

			var _resultFilter$distric = resultFilter.district.list.filter(function (id) {
				return id === parseInt(query.district, 10);
			}),
			    districtId = _resultFilter$distric[0];

			if (districtId) {
				resultFilter.district.select = [district.data[districtId]];
			}
		}

		if (query.mrt_line) {
			var _getState3 = getState(),
			    mrtLine = _getState3.filter.mrtLine;

			var _mrtLine$list$filter = mrtLine.list.filter(function (id) {
				return id === parseInt(query.mrt_line, 10);
			}),
			    mrtLineId = _mrtLine$list$filter[0];

			if (mrtLineId) {
				resultFilter.mrtLine.select = [mrtLine.data[mrtLineId]];
				resultFilter.mrtStation.list = mrtLine.data[mrtLineId].stations;
			}
		}

		if (query.mrt) {
			var _getState4 = getState(),
			    mrtStation = _getState4.filter.mrtStation;

			var _resultFilter$mrtStat = resultFilter.mrtStation.list.filter(function (id) {
				return id === parseInt(query.mrt, 10);
			}),
			    mrtStationId = _resultFilter$mrtStat[0];

			if (mrtStationId) {
				resultFilter.mrtStation.select = [mrtStation.data[mrtStationId]];
			}
		}

		if (typeof query.near_station !== 'undefined') {
			resultFilter.mrtAround.value = query.near_station !== 0;
		}

		if (query.apartment_id) {
			var _getState5 = getState(),
			    apartment = _getState5.filter.apartment;

			var _apartment$list$filte = apartment.list.filter(function (id) {
				return id === parseInt(query.apartment_id, 10);
			}),
			    apartmentId = _apartment$list$filte[0];

			if (apartmentId) {
				resultFilter.apartment.select = [apartment.data[apartmentId]];
			}
		}

		if (query.room_type) {
			var _getState6 = getState(),
			    roomType = _getState6.filter.roomType;

			var roomTypeIds = roomType.list.filter(function (type) {
				return query.room_type.includes(type);
			});

			if (roomTypeIds.length > 0) {
				resultFilter.roomType.select = roomTypeIds.map(function (type) {
					return roomType.data[type];
				});
			}
		}

		if (query.live_start && query.live_end) {
			var liveStart = query.live_start.split('-');
			var liveEnd = query.live_end.split('-');

			var resultRange = normalizeMonth(liveStart, liveEnd);

			resultFilter.month.range = resultRange.range;
			resultFilter.month.yearRange = resultRange.yearRange;
		}

		if (query.price_start && query.price_end) {
			resultFilter.price.range = [parseInt(query.price_start, 10), parseInt(query.price_end, 10)];
		}

		if (query.ping_start && query.ping_end) {
			resultFilter.area.range = [parseInt(query.ping_start, 10), parseInt(query.ping_end, 10)];
		}

		if (typeof query.double !== 'undefined') {
			resultFilter.double.select = {
				value: query.double === '1' ? '1' : '0',
				label: query.double === '1' ? (0, _i18n.t)('roomFilter:allowed') : (0, _i18n.t)('roomFilter:notAllow')
			};
		}

		if (typeof query.pet !== 'undefined') {
			resultFilter.pet.select = {
				value: query.pet === '1' ? '1' : '0',
				label: query.pet === '1' ? (0, _i18n.t)('roomFilter:allowed') : (0, _i18n.t)('roomFilter:notAllow')
			};
		}

		if (query.tag) {
			var _getState7 = getState(),
			    feature = _getState7.filter.feature;

			var featureIds = feature.list.filter(function (type) {
				return query.tag.includes('' + type);
			});

			if (featureIds.length > 0) {
				resultFilter.feature.select = featureIds.map(function (type) {
					return feature.data[type];
				});
			}
		}

		if (typeof query.type !== 'undefined') {
			resultFilter.unavailableType.value = query.type === 'all';
		}

		if (query.sort_by) {
			var sortOptions = [{ value: 'new', label: (0, _i18n.t)('rooms:UpToDate') }, { value: 'high', label: (0, _i18n.t)('rooms:HighestPrice') }, { value: 'low', label: (0, _i18n.t)('rooms:LowestPrice') }];
			var matchSort = sortOptions.filter(function (item) {
				return item.value === query.sort_by;
			});

			if (matchSort.length > 0) {
				resultFilter.sort.select = matchSort;
			}
		}

		return resultFilter;
	};
});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(40);

var _i18n = __webpack_require__(289);

var _component = __webpack_require__(979);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var lan = _ref.i18n.lan;
	return {
		lan: lan
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		select: function select(targetLanguage) {
			return dispatch((0, _i18n.changeRouteByLanguage)(targetLanguage));
		}
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_component2.default);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, "logo-black.inline");

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "logo-black.inline",
  fill: "#1F1F1F",
  fillRule: "nonzero"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M23.0943396,9.51003773 L23.178566,9.51003773 C23.1310189,9.50867924 23.0943396,9.51003773 23.0943396,9.51003773",
  id: "Fill-1"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M9.83286026,18.2233403 C9.58863836,18.6714996 9.1425504,19.0386662 8.49549754,19.3257399 C7.84574113,19.611014 7.03467209,19.754101 6.0577845,19.754101 C5.08089691,19.754101 4.26171718,19.4409295 3.60475127,18.8136867 C3.2992486,18.5203133 3.03880532,18.1801443 2.82342142,17.7940795 C2.60533398,17.4089145 2.44402136,16.9985519 2.33768119,16.5620917 C2.22863746,16.1265313 2.17636858,15.6315764 2.17636858,15.076327 C2.17636858,14.5210775 2.25657429,13.9676279 2.41608453,13.4150783 C2.96941385,11.5432487 4.19683165,10.607334 6.10104152,10.607334 C7.15903601,10.607334 8.01516444,11.0284956 8.67483391,11.8690191 C8.97402827,12.2469847 9.22545967,12.6924441 9.43363406,13.2017977 C9.64090725,13.7120513 9.78870205,14.2448026 9.88242559,14.8000521 C9.97344556,15.3544017 10.0212085,15.9996429 10.0212085,16.733976 C10.0212085,17.4683091 9.95812537,17.9650638 9.83286026,18.2233403 M6.00461442,9.50943396 C4.62940181,9.50943396 3.44163627,9.85320265 2.44582373,10.5398401 C1.9519728,10.8791092 1.52120504,11.2867721 1.15532278,11.7646286 C0.789440526,12.2424851 0.503763989,12.8040339 0.303700294,13.4483752 C0.100933035,14.0927165 0,14.8612465 0,15.7521654 C0,16.6430843 0.209976761,17.4926069 0.629029095,18.2989335 C1.04627905,19.1043602 1.65548202,19.7379024 2.45303323,20.1950607 C3.24968327,20.653119 4.10581168,20.8816982 5.01691258,20.8816982 C5.92891464,20.8816982 6.72556467,20.7854071 7.4032579,20.5910247 C8.08185233,20.3966424 8.58111038,20.1995603 8.90643918,20.0015784 C9.23086679,19.8017966 9.41200555,19.7046054 9.452559,19.709105 C9.49131007,19.7145046 9.47598988,19.8215948 9.40659841,20.0312757 C8.81902397,21.6844252 7.87908508,23.0648995 6.58768293,24.1744984 C6.02353936,24.6676535 5.43596491,25.1104131 4.82045362,25.5045773 C4.20404116,25.8969415 3.61826908,26.2146126 3.06133502,26.4557906 C2.5071045,26.6978686 2.00424171,26.9012501 1.55815374,27.0650352 C1.11296695,27.2288202 0.757898952,27.3566085 0.493850923,27.4493001 C0.229802893,27.5410918 0.097328284,27.604986 0.097328284,27.6400827 C0.097328284,27.7786702 0.132474609,27.9613535 0.200964883,28.1881329 C0.27215872,28.4149122 0.349660872,28.5283019 0.433471339,28.5283019 C0.847116546,28.5283019 1.71315804,28.2817243 3.02799106,27.7894691 C3.757052,27.5149941 4.52125928,27.1802247 5.3251188,26.7851607 C6.12717595,26.3891967 6.94094855,25.870844 7.76643659,25.2319021 C8.59012226,24.5920604 9.33270102,23.8874245 9.99056812,23.1179946 C10.647534,22.3494646 11.184642,21.4162496 11.6018919,20.3183496 C12.0182407,19.2204496 12.2264151,18.052356 12.2264151,16.8131688 C12.2264151,14.4625828 11.6226193,12.6456483 10.4159288,11.3614653 C9.2452858,10.1267777 7.77454728,9.50943396 6.00461442,9.50943396",
  id: "Fill-3"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M38.5902921,19.4396521 C37.6823536,19.4396521 36.9231371,19.1127057 36.3135605,18.4588128 C35.4386714,17.5280077 35.003522,16.3401312 35.003522,14.8934581 C35.003522,11.0244486 36.2391996,9.08864982 38.713309,9.08864982 C39.5257717,9.08864982 40.2179714,9.34399583 40.7917444,9.85555049 C41.8630935,10.8139606 42.399227,12.1502139 42.399227,13.8634474 C42.399227,17.5806296 41.1305001,19.4396521 38.5902921,19.4396521 M39.0942943,8.1509434 C37.1581545,8.1509434 35.5873934,8.7720553 34.3783388,10.0125538 C33.8256807,10.580181 33.3905312,11.2496016 33.0765625,12.0199529 C32.7598398,12.7911668 32.6037736,13.591711 32.6037736,14.4215856 C32.6037736,16.0821973 33.1757106,17.4900509 34.3177484,18.6451465 C35.4652946,19.8002421 36.8891697,20.3773585 38.5902921,20.3773585 C40.530104,20.3773585 42.0613894,19.7812636 43.1841486,18.5882112 C44.2812027,17.4236264 44.8301887,15.91743 44.8301887,14.0704848 C44.8301887,12.4245383 44.3069076,11.0313498 43.2594276,9.89091936 C42.199095,8.73151049 40.8101052,8.1509434 39.0942943,8.1509434",
  id: "Fill-5"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M53.5346063,19.4396521 C52.6266678,19.4396521 51.8665334,19.1127057 51.2569568,18.4588128 C50.3839038,17.5280077 49.9478362,16.3401312 49.9478362,14.8934581 C49.9478362,11.0244486 51.1825958,9.08864982 53.6576233,9.08864982 C54.4700858,9.08864982 55.1613676,9.34399583 55.7351406,9.85555049 C56.8074077,10.8139606 57.3435413,12.1502139 57.3435413,13.8634474 C57.3435413,17.5806296 56.0748144,19.4396521 53.5346063,19.4396521 M54.0376905,8.1509434 C52.1024688,8.1509434 50.5307896,8.7720553 49.3226531,10.0125538 C48.769995,10.580181 48.3339274,11.2496016 48.0199588,12.0199529 C47.7041541,12.7911668 47.5471698,13.591711 47.5471698,14.4215856 C47.5471698,16.0821973 48.1191068,17.4900509 49.2611446,18.6451465 C50.4086908,19.8002421 51.833484,20.3773585 53.5346063,20.3773585 C55.4744182,20.3773585 57.0057037,19.7812636 58.1284629,18.5882112 C59.2255168,17.4236264 59.7735849,15.91743 59.7735849,14.0704848 C59.7735849,12.4245383 59.2503038,11.0313498 58.2037419,9.89091936 C57.1434093,8.73151049 55.7535014,8.1509434 54.0376905,8.1509434",
  id: "Fill-7"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M71.3986313,8.66388349 C70.9970991,8.32192343 70.5490934,8.1509434 70.0536845,8.1509434 C69.5573461,8.1509434 69.0238288,8.38995737 68.4522031,8.86798531 C67.8824364,9.34601325 67.4223476,9.98785977 67.0728658,10.7953152 C66.9957196,10.9439157 66.9576112,11.0325388 66.9576112,11.062975 L66.9492461,10.9439157 L66.9492461,10.7353379 L66.9799186,8.96824585 C66.9799186,8.83396834 66.9631881,8.75698257 66.9287976,8.7337078 C66.896266,8.7122234 64.9443736,8.73012706 63.1858115,8.79010435 C62.846554,8.79010435 62.661589,8.84918646 62.6290575,8.96824585 C62.6151153,9.04791718 62.5955964,9.12937886 62.5723597,9.21263093 C62.5491228,9.29767335 62.5305334,9.37555431 62.5138029,9.44716899 C62.4989314,9.51878365 62.490566,9.55459099 62.490566,9.60472126 C62.490566,9.65395636 62.5649238,9.70319144 62.7154984,9.70319144 L64.7082876,9.64410934 L64.7082876,19.3747531 L63.2164842,19.3747531 C63.031519,19.3747531 62.9209118,19.4221978 62.8846624,19.5152969 C62.864214,19.5654271 62.8512014,19.6119766 62.846554,19.6567359 C62.8409773,19.701495 62.8391183,19.794594 62.8391183,19.9351379 C62.8391183,20.0765769 62.862355,20.1857892 62.9116171,20.2618799 C62.9608791,20.3388657 63.0714864,20.3773585 63.2462272,20.3773585 L69.5015777,20.3773585 C69.6976965,20.3773585 69.8185278,20.3227523 69.8650015,20.2135399 C69.8900972,20.159829 69.9058983,20.1096986 69.9096161,20.0649395 C69.915193,20.0210755 69.9189109,19.9333475 69.9189109,19.8008603 C69.9189109,19.6701636 69.8928856,19.5672175 69.8408352,19.4902317 C69.7906437,19.4132459 69.6753891,19.3747531 69.5015777,19.3747531 L67.5032116,19.379229 C67.0068734,19.379229 66.9892134,19.0175749 66.9892134,16.1771579 C66.9892134,11.7424193 67.7011893,9.94936688 68.8388638,9.94936688 C69.0498541,9.94936688 69.3398494,10.1122903 69.7107091,10.438137 C69.848271,10.5571964 70.0109287,10.667304 70.1968232,10.7702501 C70.3817882,10.8714058 70.5816249,10.9215361 70.7981919,10.9215361 C71.0138296,10.9215361 71.2675757,10.7460801 71.5612889,10.394273 C71.8540728,10.042466 72,9.75153134 72,9.52146921 C72,9.29140707 71.8001635,9.00584356 71.3986313,8.66388349",
  id: "Fill-9"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M28.1374593,19.3981402 L26.4759317,19.3981402 C26.3974063,19.3981402 26.3884829,4.81653014 26.4670085,1.23364023 C26.4670085,0.879547889 26.5044865,0.59365111 26.3563589,0.59365111 C26.2724794,0.59365111 26.2760487,0.605017037 26.1671839,0.626874589 C26.0592113,0.648732141 25.9084068,0.676709807 25.7165548,0.709933286 C25.5238105,0.744031066 25.3292814,0.772883035 25.1320755,0.797363493 C24.9339771,0.821843951 24.8028038,0.827964067 24.7376634,0.815723837 C24.6743078,0.802609306 24.5636582,0.749276879 24.4057149,0.652229349 C23.6356299,0.217701217 22.868222,0 22.1025987,0 C20.6427388,0 19.4559335,0.398681747 18.5412903,1.19691954 C17.2527589,2.31864911 16.7700057,3.7498816 16.6093853,5.9400083 L16.6388324,8.82083365 C16.6388324,8.86804595 16.6361555,8.90738955 16.6316938,8.94061303 C16.6254475,8.99307115 16.6120624,9.02804324 16.5933234,9.04552928 C16.5647686,9.07438124 16.4880278,9.08924438 16.365778,9.08924438 L15.4609504,9.08924438 C15.3128228,9.08924438 15.2182353,9.11984495 15.179865,9.1792975 C15.1406022,9.24049864 15.1209709,9.36814675 15.1209709,9.56486471 C15.1209709,9.76070838 15.1477409,9.88835649 15.2021733,9.94868333 C15.2566057,10.0098845 15.3726093,10.0396107 15.550184,10.0396107 L16.6093853,10.0396107 C16.6236627,10.0396107 16.6432941,10.0824515 16.6432941,10.3622282 L16.6424018,19.3981402 L16.5504912,19.3981402 L15.3056842,19.3981402 C15.1281095,19.3981402 15.0219217,19.4444781 14.9871206,19.5354056 C14.9674893,19.5843665 14.9558889,19.6307045 14.950535,19.6735453 C14.9451809,19.7172605 14.9433962,19.8046906 14.9433962,19.9349617 C14.9433962,20.066107 14.9621352,20.1797662 15.0022903,20.2759394 C15.0317374,20.3432606 15.1423868,20.3773585 15.3351312,20.3773585 L20.7623118,20.3773585 C21.0487513,20.3773585 21.1933095,20.211241 21.1933095,19.8772578 C21.1933095,19.7845817 21.1897402,19.7172605 21.1843861,19.6735453 C21.1656471,19.4899419 21.0237658,19.3981402 20.7623118,19.3981402 L18.945518,19.3981402 L18.7304653,19.3981402 L18.7902518,10.2782952 C18.7902518,10.1585158 18.8161295,10.0833258 18.8678849,10.0535996 C18.9196402,10.0247476 19.1489703,10.0107588 19.3702694,10.0107588 L22.0544126,10.0107588 C22.1275841,10.0107588 22.2391259,10.0203761 22.2391259,9.91720845 L22.2391259,9.24137295 C22.2391259,9.11372484 22.1311534,9.09186729 22.0633359,9.08924438 L22.0106881,9.08924438 L19.3702694,9.08924438 C19.0989996,9.08924438 18.8491459,9.07175834 18.8009598,9.03853486 C18.783113,9.02454604 18.767051,8.99481976 18.7554506,8.95110465 C18.7554506,8.95110465 18.945518,4.38200201 18.9499797,4.11359127 C18.956226,3.71403522 19.0409979,3.31098196 19.1195232,3.01371926 C19.1971564,2.71645655 19.3042367,2.42443966 19.4371944,2.13941718 C19.5701524,1.85439471 19.7298803,1.61920744 19.9145937,1.43560401 C20.1001992,1.25200057 20.32596,1.10424352 20.5918758,0.993207158 C20.8586839,0.881296493 21.2209719,0.826215462 21.6778474,0.826215462 C22.132938,0.826215462 22.5041494,0.993207158 22.7834501,1.32631625 C22.9271161,1.49155934 23.0440119,1.65330523 23.1368147,1.8133025 C23.2269405,1.97242548 23.3340207,2.17176636 23.4589476,2.41132513 C23.5811975,2.6508839 23.675785,2.82049849 23.7427101,2.91929464 C23.8096352,3.01896507 23.8774526,3.11164109 23.9434855,3.1990713 C24.0095182,3.2856272 24.0550273,3.35119986 24.0800127,3.39404066 C24.1032134,3.43775576 24.1299834,3.50595133 24.1540765,3.59775304 C24.1781695,3.68955477 24.3218354,4.24211367 24.3405744,5.25542977 C24.3602059,6.26787159 24.2102936,19.3981402 24.1317681,19.3981402 L22.7022477,19.3981402 C22.524673,19.3981402 22.4184853,19.4444781 22.3854688,19.5354056 C22.3640527,19.5843665 22.3524524,19.6307045 22.3470985,19.6735453 C22.3417444,19.7172605 22.3399598,19.8081879 22.3399598,19.9454533 C22.3399598,20.0835931 22.3640527,20.1902578 22.4140236,20.2645735 C22.4639943,20.3397635 22.5719669,20.3773585 22.7397258,20.3773585 L28.1374593,20.3773585 C28.2302621,20.3773585 28.3203879,20.3598724 28.403375,20.3231517 C28.4890392,20.2873054 28.5283019,20.1377997 28.5283019,19.8772578 C28.5283019,19.5581375 28.3989133,19.3981402 28.1374593,19.3981402",
  id: "Fill-11"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M23.0943396,9.50943396 C23.1975849,9.51350943 23.3606038,9.5474717 23.3606038,9.74581132",
  id: "Fill-13"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M17.6603774,5.43396226 L17.6943396,8.1509434 C17.7024906,8.12086027 17.7052075,8.08523552 17.7052075,8.04248582 L17.6603774,5.43396226 Z",
  id: "Fill-15"
})));

var SvgComponent = function SvgComponent(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    width: "72px",
    height: "29px",
    viewBox: "0 0 72 29",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgComponent);

/***/ }),
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context__ = __webpack_require__(183);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var removedIsInitialSSR = false;

var I18n = function (_Component) {
  _inherits(I18n, _Component);

  function I18n(props, context) {
    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, (I18n.__proto__ || Object.getPrototypeOf(I18n)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n || Object(__WEBPACK_IMPORTED_MODULE_2__context__["b" /* getI18n */])();
    _this.namespaces = props.ns || _this.i18n.options && _this.i18n.options.defaultNS;
    if (typeof _this.namespaces === 'string') _this.namespaces = [_this.namespaces];

    var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
    _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2__context__["a" /* getDefaults */])(), i18nOptions, props);

    // nextjs SSR: getting data from next.js or other ssr stack
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.options.wait = false; // we got all passed down already
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }

    // provider SSR: data was set in provider and ssr flag was set
    if (_this.i18n.options && _this.i18n.options.isInitialSSR) {
      _this.options.wait = false;
    }

    var language = _this.i18n.languages && _this.i18n.languages[0];
    var ready = !!language && _this.namespaces.every(function (ns) {
      return _this.i18n.hasResourceBundle(language, ns);
    });

    _this.state = {
      i18nLoadedAt: null,
      ready: ready
    };

    _this.t = _this.getI18nTranslate();

    _this.onI18nChanged = _this.onI18nChanged.bind(_this);
    _this.getI18nTranslate = _this.getI18nTranslate.bind(_this);
    return _this;
  }

  _createClass(I18n, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        t: this.t,
        i18n: this.i18n
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var bind = function bind() {
        if (_this2.options.bindI18n && _this2.i18n) _this2.i18n.on(_this2.options.bindI18n, _this2.onI18nChanged);
        if (_this2.options.bindStore && _this2.i18n.store) _this2.i18n.store.on(_this2.options.bindStore, _this2.onI18nChanged);
      };

      this.mounted = true;
      this.i18n.loadNamespaces(this.namespaces, function () {
        var ready = function ready() {
          if (_this2.mounted && !_this2.state.ready) _this2.setState({ ready: true });
          if (_this2.options.wait && _this2.mounted) bind();
        };

        if (_this2.i18n.isInitialized) {
          ready();
        } else {
          var initialized = function initialized() {
            // due to emitter removing issue in i18next we need to delay remove
            setTimeout(function () {
              _this2.i18n.off('initialized', initialized);
            }, 1000);
            ready();
          };

          _this2.i18n.on('initialized', initialized);
        }
      });

      if (!this.options.wait) bind();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      this.mounted = false;
      if (this.onI18nChanged) {
        if (this.options.bindI18n) {
          var p = this.options.bindI18n.split(' ');
          p.forEach(function (f) {
            return _this3.i18n.off(f, _this3.onI18nChanged);
          });
        }
        if (this.options.bindStore) {
          var _p = this.options.bindStore.split(' ');
          _p.forEach(function (f) {
            return _this3.i18n.store && _this3.i18n.store.off(f, _this3.onI18nChanged);
          });
        }
      }
    }
  }, {
    key: 'onI18nChanged',
    value: function onI18nChanged() {
      if (!this.mounted) return;

      this.t = this.getI18nTranslate();
      this.setState({ i18nLoadedAt: new Date() }); // rerender
    }
  }, {
    key: 'getI18nTranslate',
    value: function getI18nTranslate() {
      return this.i18n.getFixedT(null, this.options.nsMode === 'fallback' ? this.namespaces : this.namespaces[0]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var children = this.props.children;
      var ready = this.state.ready;


      if (!ready && this.options.wait) return null;

      // remove ssr flag set by provider - first render was done from now on wait if set to wait
      if (this.i18n.options && this.i18n.options.isInitialSSR && !removedIsInitialSSR) {
        removedIsInitialSSR = true;
        setTimeout(function () {
          delete _this4.i18n.options.isInitialSSR;
        }, 100);
      }

      return children(this.t, {
        i18n: this.i18n,
        t: this.t,
        ready: ready
      });
    }
  }]);

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (I18n);


I18n.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

I18n.childContextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.changeRouteByLanguage = exports.changeLanguage = undefined;

var _reduxActions = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouterRedux = __webpack_require__(36);

var _i18n = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var changeLanguage = exports.changeLanguage = (0, _reduxActions.createAction)('CHANGE_LANGUAGE', function (lan) {
	_moment2.default.locale(lan);
	document.body.setAttribute('lan', lan);
	return { lan: lan };
});

var changeRouteByLanguage = exports.changeRouteByLanguage = (0, _reduxActions.createAction)('CHANGE_ROUTE_BY_LANGUAGE', function (targetLanguage) {
	return function (dispatch, getState) {
		var _getState = getState(),
		    _getState$routing$loc = _getState.routing.locationBeforeTransitions,
		    query = _getState$routing$loc.query,
		    pathname = _getState$routing$loc.pathname,
		    lan = _getState.i18n.lan;

		var newPathname = pathname !== '/' ? pathname.replace((0, _i18n.languageMapRoute)(lan), (0, _i18n.languageMapRoute)(targetLanguage)) : '/' + (0, _i18n.languageMapRoute)(targetLanguage);

		dispatch((0, _reactRouterRedux.push)({ pathname: newPathname, query: query }));
	};
});

/***/ }),
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ar;

})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arDz = moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arDz;

})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arKw = moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arKw;

})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var arLy = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arLy;

})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arMa = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arMa;

})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arSa;

})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;

})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return az;

})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return be;

})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bg;

})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bm = moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;

})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bn;

})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bo;

})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bs;

})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsParse : (function (months, monthsShort) {
            var i, _monthsParse = [];
            for (i = 0; i < 12; i++) {
                // use custom parser to solve problem with July (červenec)
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months, monthsShort)),
        shortMonthsParse : (function (monthsShort) {
            var i, _shortMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
            }
            return _shortMonthsParse;
        }(monthsShort)),
        longMonthsParse : (function (months) {
            var i, _longMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
            }
            return _longMonthsParse;
        }(months)),
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return cv;

})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return dv;

})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eo;

})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'MMMM [de] D [de] YYYY',
            LLL : 'MMMM [de] D [de] YYYY h:mm A',
            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eu;

})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return fa;

})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minutt',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaði',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka horan', 'ek hor'],
            'hh': [number + ' horanim', number + ' horam'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;

})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return gu;

})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hi;

})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var hyAm = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hyAm;

})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return id;

})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return jv;

})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return kk;

})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return kn;

})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кече саат] LT',
            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ky;

})));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

})));


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

})));


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

})));


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

})));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return me;

})));


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

})));


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mk;

})));


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

})));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;

})));


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mr;

})));


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ms;

})));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var msMy = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return msMy;

})));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mt = moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;

})));


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return my;

})));


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

})));


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ne;

})));


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

})));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return paIn;

})));


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ro;

})));


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    var sd = moment.defineLocale('sd', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;

})));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

})));


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

})));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

})));


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sl;

})));


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

})));


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sr;

})));


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return srCyrl;

})));


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

})));


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sw;

})));


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ta;

})));


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return te;

})));


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tet = moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;

})));


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;

})));


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tlPh = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;

})));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate,
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

})));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tr;

})));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

})));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzm;

})));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzmLatn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzmLatn;

})));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;

})));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return uk;

})));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    var ur = moment.defineLocale('ur', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;

})));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

})));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uzLatn = moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return uzLatn;

})));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var xPseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;

})));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var yo = moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;

})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhTw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhTw;

})));


/***/ }),
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var testOrder;
var types = {};
var customCards = {};
var VISA = 'visa';
var MASTERCARD = 'mastercard';
var AMERICAN_EXPRESS = 'american-express';
var DINERS_CLUB = 'diners-club';
var DISCOVER = 'discover';
var ELO = 'elo';
var JCB = 'jcb';
var UNIONPAY = 'unionpay';
var MAESTRO = 'maestro';
var MIR = 'mir';
var CVV = 'CVV';
var CID = 'CID';
var CVC = 'CVC';
var CVN = 'CVN';
var CVP2 = 'CVP2';
var CVE = 'CVE';
var ORIGINAL_TEST_ORDER = [
  VISA,
  MASTERCARD,
  AMERICAN_EXPRESS,
  DINERS_CLUB,
  DISCOVER,
  JCB,
  UNIONPAY,
  MAESTRO,
  ELO,
  MIR
];

function clone(originalObject) {
  var dupe;

  if (!originalObject) { return null; }

  dupe = JSON.parse(JSON.stringify(originalObject));

  return dupe;
}

testOrder = clone(ORIGINAL_TEST_ORDER);

types[VISA] = {
  niceType: 'Visa',
  type: VISA,
  patterns: [
    4
  ],
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[MASTERCARD] = {
  niceType: 'Mastercard',
  type: MASTERCARD,
  patterns: [
    [51, 55],
    [2221, 2229],
    [223, 229],
    [23, 26],
    [270, 271],
    2720
  ],
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: CVC,
    size: 3
  }
};

types[AMERICAN_EXPRESS] = {
  niceType: 'American Express',
  type: AMERICAN_EXPRESS,
  patterns: [
    34,
    37
  ],
  gaps: [4, 10],
  lengths: [15],
  code: {
    name: CID,
    size: 4
  }
};

types[DINERS_CLUB] = {
  niceType: 'Diners Club',
  type: DINERS_CLUB,
  patterns: [
    [300, 305],
    36,
    38,
    39
  ],
  gaps: [4, 10],
  lengths: [14, 16, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[DISCOVER] = {
  niceType: 'Discover',
  type: DISCOVER,
  patterns: [
    6011,
    [644, 649],
    65
  ],
  gaps: [4, 8, 12],
  lengths: [16, 19],
  code: {
    name: CID,
    size: 3
  }
};

types[JCB] = {
  niceType: 'JCB',
  type: JCB,
  patterns: [
    2131,
    1800,
    [3528, 3589]
  ],
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[UNIONPAY] = {
  niceType: 'UnionPay',
  type: UNIONPAY,
  patterns: [
    620,
    [624, 626],
    [62100, 62182],
    [62184, 62187],
    [62185, 62197],
    [62200, 62205],
    [622010, 622999],
    622018,
    [622019, 622999],
    [62207, 62209],
    [622126, 622925],
    [623, 626],
    6270,
    6272,
    6276,
    [627700, 627779],
    [627781, 627799],
    [6282, 6289],
    6291,
    6292
  ],
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVN,
    size: 3
  }
};

types[MAESTRO] = {
  niceType: 'Maestro',
  type: MAESTRO,
  patterns: [
    493698,
    [500000, 506698],
    [506779, 508999],
    [56, 59],
    63,
    67,
    6
  ],
  gaps: [4, 8, 12],
  lengths: [12, 13, 14, 15, 16, 17, 18, 19],
  code: {
    name: CVC,
    size: 3
  }
};

types[ELO] = {
  niceType: 'Elo',
  type: ELO,
  patterns: [
    401178,
    401179,
    438935,
    457631,
    457632,
    431274,
    451416,
    457393,
    504175,
    [506699, 506778],
    [509000, 509999],
    627780,
    636297,
    636368,
    [650031, 650033],
    [650035, 650051],
    [650405, 650439],
    [650485, 650538],
    [650541, 650598],
    [650700, 650718],
    [650720, 650727],
    [650901, 650978],
    [651652, 651679],
    [655000, 655019],
    [655021, 655058]
  ],
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: CVE,
    size: 3
  }
};

types[MIR] = {
  niceType: 'Mir',
  type: MIR,
  patterns: [
    [2200, 2204]
  ],
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVP2,
    size: 3
  }
};

function findType(type) {
  return customCards[type] || types[type];
}

function isValidInputType(cardNumber) {
  return typeof cardNumber === 'string' || cardNumber instanceof String;
}

function hasEnoughResultsToDetermineBestMatch(results) {
  var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) {
    return result.matchStrength;
  }).length;

  // if all possible results have a maxStrength property
  // that means the card number is sufficiently long
  // enough to determine conclusively what the type is
  return numberOfResultsWithMaxStrengthProperty > 0 &&
    numberOfResultsWithMaxStrengthProperty === results.length;
}

function findBestMatch(results) {
  if (!hasEnoughResultsToDetermineBestMatch(results)) {
    return;
  }

  return results.reduce(function (bestMatch, result) { // eslint-disable-line consistent-return
    if (!bestMatch) {
      return result;
    }

    // if the current best match pattern is less specific
    // than this result, set the result as the new best match
    if (bestMatch.matchStrength < result.matchStrength) {
      return result;
    }

    return bestMatch;
  });
}

function getAllCardTypes() {
  return testOrder.map(function (type) {
    return clone(findType(type));
  });
}

function creditCardType(cardNumber) {
  var bestMatch;
  var results = [];

  if (!isValidInputType(cardNumber)) {
    return [];
  }

  if (cardNumber.length === 0) {
    return getAllCardTypes();
  }

  testOrder.forEach(function (type) {
    var cardConfiguration = findType(type);

    loopOverCardPatterns(cardNumber, cardConfiguration, results);
  });

  bestMatch = findBestMatch(results);

  if (bestMatch) {
    return [bestMatch];
  }

  return results;
}

function loopOverCardPatterns(cardNumber, cardConfiguration, results) {
  var i, pattern, patternLength, clonedCardConfiguration;

  for (i = 0; i < cardConfiguration.patterns.length; i++) {
    pattern = cardConfiguration.patterns[i];

    if (!matches(cardNumber, pattern)) {
      continue;
    }

    clonedCardConfiguration = clone(cardConfiguration);

    if (Array.isArray(pattern)) {
      patternLength = String(pattern[0]).length;
    } else {
      patternLength = String(pattern).length;
    }

    if (cardNumber.length >= patternLength) {
      clonedCardConfiguration.matchStrength = patternLength;
    }

    results.push(clonedCardConfiguration);
    break;
  }
}

function matches(cardNumber, pattern) {
  if (Array.isArray(pattern)) {
    return matchesRange(cardNumber, pattern[0], pattern[1]);
  }

  return matchesPattern(cardNumber, pattern);
}

function matchesPattern(cardNumber, pattern) {
  pattern = String(pattern);

  return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
}

// Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
function matchesRange(cardNumber, min, max) {
  var maxLengthToCheck = String(min).length;
  var substr = cardNumber.substr(0, maxLengthToCheck);
  var integerRepresentationOfCardNumber = parseInt(substr, 10);

  min = parseInt(String(min).substr(0, substr.length), 10);
  max = parseInt(String(max).substr(0, substr.length), 10);

  return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
}

creditCardType.getTypeInfo = function (type) {
  return clone(findType(type));
};

function getCardPosition(name, ignoreErrorForNotExisting) {
  var position = testOrder.indexOf(name);

  if (!ignoreErrorForNotExisting && position === -1) {
    throw new Error('"' + name + '" is not a supported card type.');
  }

  return position;
}

creditCardType.removeCard = function (name) {
  var position = getCardPosition(name);

  testOrder.splice(position, 1);
};

creditCardType.addCard = function (config) {
  var existingCardPosition = getCardPosition(config.type, true);

  customCards[config.type] = config;

  if (existingCardPosition === -1) {
    testOrder.push(config.type);
  }
};

creditCardType.updateCard = function (cardType, updates) {
  var clonedCard;
  var originalObject = customCards[cardType] || types[cardType];

  if (!originalObject) {
    throw new Error('"' + cardType + '" is not a recognized type. Use `addCard` instead.');
  }

  if (updates.type && originalObject.type !== updates.type) {
    throw new Error('Cannot overwrite type parameter.');
  }

  clonedCard = clone(originalObject, true);

  Object.keys(clonedCard).forEach(function (key) {
    if (updates[key]) {
      clonedCard[key] = updates[key];
    }
  });

  customCards[clonedCard.type] = clonedCard;
};

creditCardType.changeOrder = function (name, position) {
  var currentPosition = getCardPosition(name);

  testOrder.splice(currentPosition, 1);
  testOrder.splice(position, 0, name);
};

creditCardType.resetModifications = function () {
  testOrder = clone(ORIGINAL_TEST_ORDER);
  customCards = {};
};

creditCardType.types = {
  VISA: VISA,
  MASTERCARD: MASTERCARD,
  AMERICAN_EXPRESS: AMERICAN_EXPRESS,
  DINERS_CLUB: DINERS_CLUB,
  DISCOVER: DISCOVER,
  JCB: JCB,
  UNIONPAY: UNIONPAY,
  MAESTRO: MAESTRO,
  ELO: ELO,
  MIR: MIR
};

module.exports = creditCardType;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function verification(isValid, isPotentiallyValid, isValidForThisYear) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    isValidForThisYear: isValidForThisYear || false
  };
}

function expirationMonth(value) {
  var month, result;
  var currentMonth = new Date().getMonth() + 1;

  if (typeof value !== 'string') {
    return verification(false, false);
  }
  if (value.replace(/\s/g, '') === '' || value === '0') {
    return verification(false, true);
  }
  if (!/^\d*$/.test(value)) {
    return verification(false, false);
  }

  month = parseInt(value, 10);

  if (isNaN(value)) {
    return verification(false, false);
  }

  result = month > 0 && month < 13;

  return verification(result, result, result && month >= currentMonth);
}

module.exports = expirationMonth;


/***/ }),
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = __webpack_require__(213);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(458);

var _merge2 = _interopRequireDefault(_merge);

var _isByteLength = __webpack_require__(967);

var _isByteLength2 = _interopRequireDefault(_isByteLength);

var _isFQDN = __webpack_require__(968);

var _isFQDN2 = _interopRequireDefault(_isFQDN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);
    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');

  var lower_domain = domain.toLowerCase();

  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase();

    // Removing sub-address from username before gmail validation
    var username = user.split('+')[0];

    // Dots are not included in gmail length restriction
    if (!(0, _isByteLength2.default)(username.replace('.', ''), { min: 6, max: 30 })) {
      return false;
    }

    var _user_parts = username.split('.');
    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }

  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
    return false;
  }

  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
    return false;
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;

  var user_parts = user.split('.');
  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _instagramInline = __webpack_require__(982);

var _instagramInline2 = _interopRequireDefault(_instagramInline);

var _facebookInline = __webpack_require__(983);

var _facebookInline2 = _interopRequireDefault(_facebookInline);

var _spotifyInline = __webpack_require__(569);

var _spotifyInline2 = _interopRequireDefault(_spotifyInline);

var _index = __webpack_require__(984);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialMedia = function SocialMedia() {
	return _react2.default.createElement(
		'div',
		{ className: _index2.default.socialMedia },
		_react2.default.createElement(
			'a',
			{ target: '_blank', href: 'https://www.instagram.com/9floor.co/', rel: 'noopener noreferrer' },
			_react2.default.createElement(_instagramInline2.default, null)
		),
		_react2.default.createElement(
			'a',
			{ target: '_blank', href: 'https://www.facebook.com/9floor.co/', rel: 'noopener noreferrer' },
			_react2.default.createElement(_facebookInline2.default, null)
		),
		_react2.default.createElement(
			'a',
			{
				target: '_blank',
				href: 'https://open.spotify.com/user/cmas3ut0ye02tk1q56qwkf3pu?si=1MWz3EIzQYyVmYMd2CbmbQ',
				rel: 'noopener noreferrer'
			},
			_react2.default.createElement(_spotifyInline2.default, null)
		)
	);
};

exports.default = SocialMedia;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(15);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(96);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(461);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(15);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(15);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__(992);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disables exit animations
    * for all children. Note that specifying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        return (0, _react.cloneElement)(child, {
          onExited: _this.handleExited.bind(_this, child),
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: _this2.handleExited.bind(_this2, child),
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: _this2.handleExited.bind(_this2, child),
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.contain = undefined;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultLifecycle = {
	componentDidMount: function componentDidMount() {},
	componentDidUpdate: function componentDidUpdate() {},
	componentWillUnmount: function componentWillUnmount() {},
	getDerivedStateFromProps: function getDerivedStateFromProps() {
		return null;
	},
	getSnapshotBeforeUpdate: function getSnapshotBeforeUpdate() {
		return null;
	}
};

var contain = exports.contain = function contain() {
	var initState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
		return {};
	};
	var mapSetStateToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
		return {};
	};
	var setLifecycle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
		return defaultLifecycle;
	};
	return function (Component) {
		var displayName = Component.displayName || Component.name || 'Component';
		var newLifecycle = setLifecycle();
		var componentLifecycle = Object.assign({}, defaultLifecycle, newLifecycle);

		var ContainerComponent = function (_React$PureComponent) {
			_inherits(ContainerComponent, _React$PureComponent);

			ContainerComponent.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
				return componentLifecycle.getDerivedStateFromProps(nextProps, prevState);
			};

			function ContainerComponent(props) {
				_classCallCheck(this, ContainerComponent);

				var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

				_this.state = initState(props);

				_this.setState = _this.setState.bind(_this);
				_this.getState = _this.getState.bind(_this);
				_this.getProps = _this.getProps.bind(_this);
				return _this;
			}

			ContainerComponent.prototype.componentDidMount = function componentDidMount() {
				componentLifecycle.componentDidMount({
					setState: this.setState,
					getState: this.getState,
					getProps: this.getProps
				});
			};

			ContainerComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snap) {
				componentLifecycle.componentDidUpdate(prevProps, prevState, snap, {
					setState: this.setState,
					getState: this.getState,
					getProps: this.getProps
				});
			};

			ContainerComponent.prototype.componentWillUnmount = function componentWillUnmount() {
				componentLifecycle.componentWillUnmount({
					getState: this.getState,
					getProps: this.getProps
				});
			};

			ContainerComponent.prototype.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps, prevState) {
				return componentLifecycle.getSnapshotBeforeUpdate(prevProps, prevState);
			};

			ContainerComponent.prototype.getState = function getState() {
				return this.state;
			};

			ContainerComponent.prototype.getProps = function getProps() {
				return this.props;
			};

			ContainerComponent.prototype.render = function render() {
				var setStateProps = mapSetStateToProps(this.state, this.props, this.setState);

				return _react2.default.createElement(Component, setStateProps);
			};

			return ContainerComponent;
		}(_react2.default.PureComponent);

		ContainerComponent.displayName = 'Contain(' + displayName + ')';

		return ContainerComponent;
	};
};

/***/ }),
/* 555 */,
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(227);

var _Icon2 = _interopRequireDefault(_Icon);

var _index = __webpack_require__(1000);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_Component) {
	_inherits(Checkbox, _Component);

	function Checkbox(props) {
		_classCallCheck(this, Checkbox);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.handleChange = _this.handleChange.bind(_this);
		return _this;
	}

	Checkbox.prototype.handleChange = function handleChange(evt) {
		var _props$onChange = this.props.onChange,
		    onChange = _props$onChange === undefined ? function () {} : _props$onChange;


		onChange(evt.target.value, evt.target.checked);
	};

	Checkbox.prototype.render = function render() {
		var _props = this.props,
		    name = _props.name,
		    value = _props.value,
		    content = _props.content,
		    className = _props.className,
		    small = _props.small,
		    _ = _props.onChange,
		    other = _objectWithoutProperties(_props, ['name', 'value', 'content', 'className', 'small', 'onChange']);

		return _react2.default.createElement(
			'label',
			{
				htmlFor: name,
				className: (0, _classnames2.default)(_index2.default.label, className, small ? _index2.default.small : '')
			},
			content,
			_react2.default.createElement('input', _extends({
				type: 'checkbox',
				id: name,
				name: name,
				value: value,
				onChange: this.handleChange
			}, other)),
			_react2.default.createElement(
				'span',
				{ className: _index2.default.checkbox },
				_react2.default.createElement(
					_Icon2.default,
					null,
					'check'
				)
			)
		);
	};

	return Checkbox;
}(_react.Component);

exports.default = Checkbox;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(27);

var _classnames3 = _interopRequireDefault(_classnames2);

var _index = __webpack_require__(999);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Field = function Field(_ref) {
	var _classnames;

	var type = _ref.type,
	    icon = _ref.icon,
	    name = _ref.name,
	    className = _ref.className,
	    _ref$valid = _ref.valid,
	    valid = _ref$valid === undefined ? true : _ref$valid,
	    other = _objectWithoutProperties(_ref, ['type', 'icon', 'name', 'className', 'valid']);

	return _react2.default.createElement(
		'label',
		{
			htmlFor: name,
			className: (0, _classnames3.default)(_index2.default.field, className, (_classnames = {}, _classnames[_index2.default.file] = type === 'file', _classnames[_index2.default.icon] = icon !== '', _classnames[_index2.default.invalid] = !valid, _classnames))
		},
		icon && _react2.default.createElement(
			'i',
			{ className: 'material-icons' },
			icon
		),
		_react2.default.createElement('input', _extends({ type: type, name: name }, other))
	);
};

exports.default = Field;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.bindCertificate = exports.bindCheckbox = exports.bindToggleButton = exports.bindDropdownMonthRange = exports.bindDropdownBirthday = exports.bindDatePicker = exports.bindFieldTel = exports.bindSearchTag = exports.bindDropdown = exports.bindSelector = exports.bindField = undefined;

var _reactRedux = __webpack_require__(40);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _bind = __webpack_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// reducer selector ex. ['auth', 'signupForm', 'email']
var selector = function selector(state, _ref) {
	var key = _ref[0],
	    other = _ref.slice(1);

	if (state[key]) {
		if (other.length > 0) {
			return selector(state[key], other);
		}
		return state[key];
	}
	return '';
};

// bind reducer HOC ex. ('auth', 'signupForm', 'email') => (Field) => Component
var bindField = exports.bindField = function bindField(key) {
	for (var _len = arguments.length, other = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		other[_key - 1] = arguments[_key];
	}

	return function (Component) {
		var mapStateToProps = function mapStateToProps(state) {
			return {
				value: selector(state, [key].concat(other)).value
			};
		};

		var action = _bind.FIELD_ACTION_MAP[key];
		var mapDispatchToProps = function mapDispatchToProps(dispatch) {
			return {
				onChange: function onChange(e) {
					var c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

					if (c !== null) {
						dispatch(action.apply(undefined, other.concat([{ value: c }])));
					} else {
						dispatch(action.apply(undefined, other.concat([{ value: e.target.value }])));
					}
				}
			};
		};

		return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
	};
};

var bindSelector = exports.bindSelector = function bindSelector(key) {
	for (var _len2 = arguments.length, other = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		other[_key2 - 1] = arguments[_key2];
	}

	return function (Component) {
		var mapStateToProps = function mapStateToProps(state) {
			return {
				value: selector(state, [key].concat(other)).value
			};
		};

		var action = _bind.FIELD_ACTION_MAP[key];

		var mapDispatchToProps = function mapDispatchToProps(dispatch) {
			return {
				onChange: function onChange(select) {
					return dispatch(action.apply(undefined, other.concat([{ value: select }])));
				}
			};
		};

		return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
	};
};

var bindDropdown = exports.bindDropdown = function bindDropdown(key) {
	for (var _len3 = arguments.length, other = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
		other[_key3 - 1] = arguments[_key3];
	}

	return function (Component) {
		var mapStateToProps = function mapStateToProps(state) {
			return {
				value: selector(state, [key].concat(other)).value
			};
		};

		var action = _bind.FIELD_ACTION_MAP[key];

		var mapDispatchToProps = function mapDispatchToProps(dispatch) {
			return {
				onChange: function onChange(value) {
					return dispatch(action.apply(undefined, other.concat([{ value: value }])));
				}
			};
		};

		return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
	};
};

var bindSearchTag = exports.bindSearchTag = function bindSearchTag(key) {
	for (var _len4 = arguments.length, other = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
		other[_key4 - 1] = arguments[_key4];
	}

	return function (Component) {
		var mapStateToProps = function mapStateToProps(state) {
			return {
				value: selector(state, [key].concat(other)).value
			};
		};

		var action = _bind.FIELD_ACTION_MAP[key];

		var mapDispatchToProps = function mapDispatchToProps(dispatch) {
			return {
				onChange: function onChange(value) {
					return dispatch(action.apply(undefined, other.concat([{ value: value }])));
				},
				onChangeInputValue: function onChangeInputValue(value) {
					return dispatch(action.apply(undefined, other.concat([{ inputValue: value }])));
				}
			};
		};

		return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
	};
};

var bindFieldTel = exports.bindFieldTel = function bindFieldTel(key) {
	for (var _len5 = arguments.length, other = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
		other[_key5 - 1] = arguments[_key5];
	}

	return function (Component) {
		var mapStateToProps = function mapStateToProps(state) {
			return {
				value: selector(state, [key].concat(other)).value,
				country: selector(state, [key].concat(other)).country,
				defaultCountry: selector(state, [key].concat(other)).country.iso2,
				status: selector(state, [key].concat(other)).status
			};
		};

		var action = _bind.FIELD_ACTION_MAP[key];

		var mapDispatchToProps = function mapDispatchToProps(dispatch) {
			return {
				onPhoneNumberChange: function onPhoneNumberChange(validate, phone, country) {
					dispatch(action.apply(undefined, other.concat([{ value: phone, country: country, validate: validate }])));
				},
				onSelectFlag: function onSelectFlag(_, country) {
					dispatch(action.apply(undefined, other.concat([{ value: '', country: country, validate: false }])));
				}
			};
		};

		return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
	};
};

var bindDatePicker = exports.bindDatePicker = function bindDatePicker(key) {
	for (var _len6 = arguments.length, other = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
		other[_key6 - 1] = arguments[_key6];
	}

	return function (Component) {
		var mapStateToProps = function mapStateToProps(state) {
			var date = selector(state, [key].concat(other)).value;

			return {
				date: date === '' ? null : (0, _moment2.default)(date, 'X')
			};
		};

		var action = _bind.FIELD_ACTION_MAP[key];

		var mapDispatchToProps = function mapDispatchToProps(dispatch) {
			return {
				onDateChange: function onDateChange(selectedDate) {
					return dispatch(action.apply(undefined, other.concat([{ value: selectedDate.format('X') }])));
				}
			};
		};

		return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
	};
};

var bindDropdownBirthday = exports.bindDropdownBirthday = function bindDropdownBirthday(key) {
	for (var _len7 = arguments.length, other = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
		other[_key7 - 1] = arguments[_key7];
	}

	return function (Component) {
		var mapStateToProps = function mapStateToProps(state) {
			var lan = state.i18n.lan;

			var date = selector(state, [key].concat(other)).value;

			return {
				value: date === '' ? '' : (0, _moment2.default)(date, 'X').format(lan === 'en' ? 'MMM/DD/YYYY' : 'YYYY/MM/DD'),
				date: date === '' ? null : (0, _moment2.default)(date, 'X')
			};
		};

		var action = _bind.FIELD_ACTION_MAP[key];

		var mapDispatchToProps = function mapDispatchToProps(dispatch) {
			return {
				onDateChange: function onDateChange(selectedDate) {
					return dispatch(action.apply(undefined, other.concat([{ value: selectedDate.format('X') }])));
				}
			};
		};

		return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
	};
};

var bindDropdownMonthRange = exports.bindDropdownMonthRange = function bindDropdownMonthRange(key) {
	for (var _len8 = arguments.length, other = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
		other[_key8 - 1] = arguments[_key8];
	}

	return function (Component) {
		var mapStateToProps = function mapStateToProps(state) {
			return selector(state, [key].concat(other)).value;
		};

		var action = _bind.FIELD_ACTION_MAP[key];

		var mapDispatchToProps = function mapDispatchToProps(dispatch) {
			return {
				onChange: function onChange(value) {
					return dispatch(action.apply(undefined, other.concat([{ value: value }])));
				}
			};
		};

		return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
	};
};

var bindToggleButton = exports.bindToggleButton = function bindToggleButton(key) {
	for (var _len9 = arguments.length, other = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
		other[_key9 - 1] = arguments[_key9];
	}

	return function (Component) {
		var mapStateToProps = function mapStateToProps(state) {
			return {
				checked: selector(state, [key].concat(other)).value
			};
		};

		var action = _bind.FIELD_ACTION_MAP[key];

		var mapDispatchToProps = function mapDispatchToProps(dispatch) {
			return {
				onChange: function onChange(e) {
					return dispatch(action.apply(undefined, other.concat([{ value: e.target.checked }])));
				}
			};
		};

		return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
	};
};

var bindCheckbox = exports.bindCheckbox = function bindCheckbox(key) {
	for (var _len10 = arguments.length, other = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
		other[_key10 - 1] = arguments[_key10];
	}

	return function (Component) {
		var mapStateToProps = function mapStateToProps(state) {
			return {
				checked: selector(state, [key].concat(other)).value
			};
		};

		var action = _bind.FIELD_ACTION_MAP[key];

		var mapDispatchToProps = function mapDispatchToProps(dispatch) {
			return {
				onChange: function onChange(_, checked) {
					return dispatch(action.apply(undefined, other.concat([{ value: checked }])));
				}
			};
		};

		return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
	};
};

var bindCertificate = exports.bindCertificate = function bindCertificate(key) {
	for (var _len11 = arguments.length, other = Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
		other[_key11 - 1] = arguments[_key11];
	}

	return function (Component) {
		var mapStateToProps = function mapStateToProps(state) {
			return {
				type: selector(state, [key].concat(other)).type,
				value: selector(state, [key].concat(other)).value
			};
		};

		var action = _bind.FIELD_ACTION_MAP[key];

		var mapDispatchToProps = function mapDispatchToProps(dispatch) {
			return {
				onTypeChange: function onTypeChange(value) {
					dispatch(action.apply(undefined, other.concat([{ type: value }])));
				},
				onValueChange: function onValueChange(e) {
					dispatch(action.apply(undefined, other.concat([{ value: e.target.value }])));
				}
			};
		};

		return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
	};
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.generateSurvey = undefined;

var _queryString = __webpack_require__(232);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateSurvey = exports.generateSurvey = function generateSurvey(surveyId, options) {
	if (typeof options === 'undefined') {
		return 'https://www.surveycake.com/s/' + surveyId;
	}
	return 'https://www.surveycake.com/s/' + surveyId + '?' + _queryString2.default.stringify(options);
};

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(96);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactTransitionGroup = __webpack_require__(986);

var _classnames2 = __webpack_require__(27);

var _classnames3 = _interopRequireDefault(_classnames2);

__webpack_require__(993);

var _index = __webpack_require__(994);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalComponent = function ModalComponent(_ref) {
	var _classnames;

	var className = _ref.className,
	    children = _ref.children,
	    active = _ref.active,
	    inline = _ref.inline,
	    onDeactive = _ref.onDeactive;
	return _react2.default.createElement(
		_reactTransitionGroup.CSSTransition,
		{
			'in': active,
			classNames: {
				enter: 'animated',
				enterActive: 'fadeIn',
				exit: 'animated',
				exitActive: 'fadeOut'
			},
			timeout: 300,
			unmountOnExit: true
		},
		_react2.default.createElement(
			'div',
			{
				className: (0, _classnames3.default)(_index2.default.modal, (_classnames = {}, _classnames[_index2.default.inline] = inline, _classnames), className),
				onClick: function onClick(e) {
					if (e.target === e.currentTarget) {
						onDeactive(e);
					}
				},
				role: 'presentation'
			},
			children
		)
	);
};

var Modal = function (_React$PureComponent) {
	_inherits(Modal, _React$PureComponent);

	function Modal(props) {
		_classCallCheck(this, Modal);

		var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

		var _props$inline = props.inline,
		    inline = _props$inline === undefined ? false : _props$inline;


		if (inline) {
			return _possibleConstructorReturn(_this);
		}

		_this.modalRoot = document.getElementById('modal-root');

		if (_this.modalRoot === null) {
			_this.modalRoot = document.createElement('div');
			_this.modalRoot.setAttribute('id', 'modal-root');
			document.body.appendChild(_this.modalRoot);
		}

		_this.el = document.createElement('div');
		return _this;
	}

	Modal.prototype.componentDidMount = function componentDidMount() {
		var _props$inline2 = this.props.inline,
		    inline = _props$inline2 === undefined ? false : _props$inline2;


		if (!inline) {
			this.modalRoot.appendChild(this.el);
		}
	};

	Modal.prototype.componentWillUnmount = function componentWillUnmount() {
		var _props$inline3 = this.props.inline,
		    inline = _props$inline3 === undefined ? false : _props$inline3;


		if (!inline) {
			this.modalRoot.removeChild(this.el);
		}
	};

	Modal.prototype.render = function render() {
		var _props = this.props,
		    children = _props.children,
		    _props$inline4 = _props.inline,
		    inline = _props$inline4 === undefined ? false : _props$inline4,
		    other = _objectWithoutProperties(_props, ['children', 'inline']);

		if (inline) {
			return _react2.default.createElement(
				ModalComponent,
				_extends({ inline: inline }, other),
				children
			);
		}

		return _reactDom2.default.createPortal(_react2.default.createElement(
			ModalComponent,
			other,
			children
		), this.el);
	};

	return Modal;
}(_react2.default.PureComponent);

exports.default = Modal;

/***/ }),
/* 562 */,
/* 563 */,
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(40);

var _modal = __webpack_require__(56);

var _component = __webpack_require__(561);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ModalWrap = function ModalWrap(_ref) {
	var className = _ref.className,
	    active = _ref.active,
	    onDeactive = _ref.onDeactive,
	    children = _ref.children,
	    inline = _ref.inline,
	    other = _objectWithoutProperties(_ref, ['className', 'active', 'onDeactive', 'children', 'inline']);

	return _react2.default.createElement(
		_component2.default,
		{ className: className, active: active, onDeactive: onDeactive, inline: inline },
		children(_extends({ active: active, onDeactive: onDeactive }, other))
	);
};

var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
	var modal = _ref2.modal;
	var name = _ref3.name;
	return {
		active: modal[name].open,
		message: modal[name].message
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref4) {
	var name = _ref4.name,
	    _ref4$onDeactive = _ref4.onDeactive,
	    _onDeactive = _ref4$onDeactive === undefined ? function () {} : _ref4$onDeactive;

	return {
		onDeactive: function onDeactive() {
			dispatch((0, _modal.closeMessageModal)(name));
			_onDeactive();
		}
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModalWrap);

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.updateSongKeywordEpic = exports.getSong = exports.removeFavoriteSong = exports.addFavoriteSong = exports.updateSongKeyword = undefined;

var _reduxActions = __webpack_require__(5);

var _alert = __webpack_require__(17);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var updateSongKeyword = exports.updateSongKeyword = (0, _reduxActions.createAction)('UPDATE_SONG_KEYWORD', function (value) {
	return { value: value };
});
var addFavoriteSong = exports.addFavoriteSong = (0, _reduxActions.createAction)('ADD_FAVORITE_SONG', function (id) {
	return { id: id };
});
var removeFavoriteSong = exports.removeFavoriteSong = (0, _reduxActions.createAction)('REMOVE_FAVORITE_SONG', function (id) {
	return { id: id };
});

var getSong = exports.getSong = (0, _reduxActions.createAction)('FETCH_SONG', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(keyword) {
		var _ref2, status, message, data, songData, list;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return (0, _endpoint.wrapFetchAuth)('user/searchSong', {
							method: 'GET'
						}, {
							q: keyword,
							limit: 50,
							offset: 0
						});

					case 2:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						data = _ref2.data;

						if (!(status !== 200)) {
							_context.next = 8;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 8:
						songData = {};
						list = data.tracks.items.map(function (item) {
							songData[item.id] = item;

							return item.id;
						});
						return _context.abrupt('return', { list: list, data: songData, limit: 10, offset: 0 });

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function (_x) {
		return _ref.apply(this, arguments);
	};
}());

var updateSongKeywordEpic = exports.updateSongKeywordEpic = function updateSongKeywordEpic(action$) {
	return action$.ofType('UPDATE_SONG_KEYWORD').debounceTime(500).filter(function (action) {
		return action.payload.value !== '';
	}).switchMap(function () {
		var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(action) {
			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							return _context2.abrupt('return', getSong(action.payload.value));

						case 1:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x2) {
			return _ref3.apply(this, arguments);
		};
	}());
};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getCommunityCity = exports.getCommunityByKeyword = exports.getMoreCommunity = exports.getCommunity = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var _alert = __webpack_require__(17);

var _endpoint = __webpack_require__(35);

var _global = __webpack_require__(46);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getCommunity = exports.getCommunity = (0, _reduxActions.createAction)('FETCH_COMMUNITY', function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
		var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var city = arguments[1];

		var params, _ref2, status, message, data, communityData, list;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = keyword !== '' ? { keyword: keyword } : {};


						if (city) {
							params.city_id = city;
						}

						_context.next = 4;
						return (0, _endpoint.wrapFetch)('community', {
							method: 'GET'
						}, params);

					case 4:
						_ref2 = _context.sent;
						status = _ref2.status;
						message = _ref2.message;
						data = _ref2.data;

						if (!(status !== 200)) {
							_context.next = 10;
							break;
						}

						throw (0, _alert.openFailedAlert)('generic', message);

					case 10:
						communityData = {};
						list = data.data.map(function (item) {
							communityData[item.id] = item;

							return item.id;
						});
						return _context.abrupt('return', { currentPage: data.current_page, lastPage: data.last_page, list: list, data: communityData });

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function () {
		return _ref.apply(this, arguments);
	};
}());

var getMoreCommunity = exports.getMoreCommunity = (0, _reduxActions.createAction)('FETCH_MORE_COMMUNITY', function () {
	return function () {
		var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_, getState) {
			var _getState, _getState$community, currentPage, _getState$community$s, city, keyword, params, _city$value, _city$value$, cityValue, _ref4, status, message, data, communityData, list;

			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_getState = getState(), _getState$community = _getState.community, currentPage = _getState$community.currentPage, _getState$community$s = _getState$community.search, city = _getState$community$s.city, keyword = _getState$community$s.keyword;
							params = keyword.value !== '' ? { keyword: keyword.value } : {};
							_city$value = city.value, _city$value$ = _city$value[0];
							_city$value$ = _city$value$ === undefined ? { value: null } : _city$value$;
							cityValue = _city$value$.value;


							if (cityValue) {
								params.city_id = cityValue;
							}

							_context2.next = 8;
							return (0, _endpoint.wrapFetch)('community', { method: 'GET' }, _extends({ page: currentPage + 1 }, params));

						case 8:
							_ref4 = _context2.sent;
							status = _ref4.status;
							message = _ref4.message;
							data = _ref4.data;

							if (!(status !== 200)) {
								_context2.next = 14;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 14:
							communityData = {};
							list = data.data.map(function (item) {
								communityData[item.id] = item;

								return item.id;
							});
							return _context2.abrupt('return', {
								list: list,
								data: communityData,
								currentPage: data.current_page,
								lastPage: data.last_page
							});

						case 17:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function (_x2, _x3) {
			return _ref3.apply(this, arguments);
		};
	}();
});

var getCommunityByKeyword = exports.getCommunityByKeyword = (0, _reduxActions.createAction)('FETCH_COMMUNITY_BY_KEYWORD', function () {
	return function () {
		var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
			var _getState2, _getState2$community$, keyword, city, _city$value2, _city$value2$, value;

			return regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_getState2 = getState(), _getState2$community$ = _getState2.community.search, keyword = _getState2$community$.keyword, city = _getState2$community$.city;
							_city$value2 = city.value, _city$value2$ = _city$value2[0];
							_city$value2$ = _city$value2$ === undefined ? { value: null } : _city$value2$;
							value = _city$value2$.value;


							dispatch((0, _global.pageChanging)('FETCH_COMMUNITY_BY_KEYWORD'));
							dispatch((0, _global.loadingRatio)(0.8, 'FETCH_COMMUNITY_BY_KEYWORD'));

							_context3.next = 8;
							return dispatch(getCommunity(keyword.value, value));

						case 8:

							dispatch((0, _global.pageChanged)('FETCH_COMMUNITY_BY_KEYWORD'));

						case 9:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, undefined);
		}));

		return function (_x4, _x5) {
			return _ref5.apply(this, arguments);
		};
	}();
});

var getCommunityCity = exports.getCommunityCity = (0, _reduxActions.createAction)('FETCH_COMMUNITY_CITY', _asyncToGenerator(regeneratorRuntime.mark(function _callee4() {
	var _ref7, status, message, data, cityData, list;

	return regeneratorRuntime.wrap(function _callee4$(_context4) {
		while (1) {
			switch (_context4.prev = _context4.next) {
				case 0:
					_context4.next = 2;
					return (0, _endpoint.wrapFetch)('community/city', {
						method: 'GET'
					});

				case 2:
					_ref7 = _context4.sent;
					status = _ref7.status;
					message = _ref7.message;
					data = _ref7.data;

					if (!(status !== 200)) {
						_context4.next = 8;
						break;
					}

					throw (0, _alert.openFailedAlert)('generic', message);

				case 8:
					cityData = {};
					list = data.map(function (item) {
						cityData[item.id] = item;

						return item.id;
					});
					return _context4.abrupt('return', { list: list, data: cityData });

				case 11:
				case 'end':
					return _context4.stop();
			}
		}
	}, _callee4, undefined);
})));

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultCreditData = exports.defaultBookingData = exports.defaultOrderData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var defaultOrderItemData = {
	0: {
		id: 0,
		name: '寵物入住',
		content: '寵物入住',
		price: 1500,
		type: 'MONTHLY'
	},
	1: {
		id: 1,
		name: '第二人入住',
		content: '第二人入住',
		price: 1500,
		type: 'MONTHLY'
	},

	2: {
		id: 2,
		name: '床包組租借',
		content: '床包組租借',
		price: 1500,
		type: 'SINGLE'
	}
};

var defaultOrderData = exports.defaultOrderData = {
	id: 1,
	userId: 93,
	roomId: 1,
	eventId: null,
	status: 'REVIEW',
	name: '',
	rentMonth: 3,
	dateFrom: '2018-09-14 00:00:00',
	dateTo: '2018-12-14 00:00:00',
	monthlyRent: 14639,
	initialPayment: 23562,
	roomMonthlyRent: 0,
	deposit: 0,
	energyPrice: 1939,
	administrativeFee: 1500,
	cleaningFee: 2500,
	serviceFee: 0,
	continue: 'WAIT',
	lastRenewableDate: '2018-10-29',
	certificateType: 'IDENTITY',
	certificateFile: '20180910-8d674c1e689541ae8b5f1153a5b58c7b.png',
	certificateNumber: '',
	extraCertificateNumber: null,
	extraCertificateFile: null,
	extraCertificateType: null,
	emergencyContact: 'Test2222',
	emergencyContactRelationship: '',
	emergencyContactMobile: '0912 345 678',
	emergencyContactMobileCountryCode: '',
	remark: '',
	createdAt: '2018-09-10 18:45:43',
	updatedAt: '2018-09-10 18:45:43',
	certificateFileUrl: 'https://9floorco-living.25demo.com/backend/web/order/20180910-8d674c1e689541ae8b5f1153a5b58c7b.png',
	extraCertificateFileUrl: 'https://9floorco-living.25demo.com/backend/web/order/',
	renewButton: false,
	user: {},
	room: {
		id: 1,
		apartment_id: 1,
		name: 'Lois Wintheiser PhD',
		name_en: null,
		number: '產品編號_J76qg',
		type: 'CO_LIVING',
		status: 'AVAILABLE',
		living_status: 0,
		publish_status: 'DRAFT',
		price: 9781,
		energy_price: 1939,
		service_fee: 0,
		deposit: 19562,
		ping_number: 18,
		can_order_start: '2018-07-24 11:33:44',
		can_order_end: null,
		sex_limit: 'FEMALE',
		max_order: 200,
		double: 1,
		highlight: 0,
		release_time: '2018-09-04',
		order_expire_date: null,
		pet: 1,
		created_at: '2018-07-24 19:33:44',
		updated_at: '2018-09-18 14:53:32',
		performance: '43.56%',
		can_reserve: true,
		has_processing_order: null,
		has_processing_event: [],
		apartment: {
			id: 1,
			name: '(zh-tw)Emerald Predovic',
			name_en: '(en)Emerald Predovic',
			publish_status: 'DELETE',
			content: '介紹_F6SY3',
			mrt_id: 100,
			content_en: null,
			clean_service: '清潔打掃_9vV4I',
			trash_service: '垃圾代收_oXeLi',
			room: 3,
			max_people: 6,
			kitchen: 1,
			balcony: 1,
			pet: 1,
			public_bath: 2,
			ping_number: 21,
			floor_location: '5',
			floor: 18,
			elevator: 0,
			district_id: 214,
			city_id: 13,
			address: '彰化縣員林市中正里三民街18號',
			address_en: null,
			mrt_walk_time: 7,
			door_password: '門鎖密碼_oxvkF',
			wifi_name: '名稱_wMUZJ',
			wifi_password: '密碼_oRIqb',
			tax_id: 'ID_TwgP2',
			electric_number: '電號_O8Sv5',
			water_number: '水號_OLhpu',
			gas_number: '瓦斯區號_lNvf2',
			network_number: '網路區號_2C:86:72:57:7D:99',
			latitude: 23.9589925,
			longitude: 120.574348,
			remarks: '其他備註_zuPe6',
			remarks_en: null,
			created_at: '2018-07-24 19:33:43',
			updated_at: '2018-09-04 21:01:58'
		},
		photos: []
	},
	detail: [],
	events: [{
		id: 106,
		no: '1809136KdTaA',
		staff_id: 36,
		event_type: 'CHECKOUT',
		room_id: 1,
		user_id: 93,
		work_date: '2018-09-19 11:45:00',
		hangout_url: '',
		status: 'RESERVED',
		check: 'N',
		feedback: 0,
		note: null,
		created_at: '2018-09-13 17:34:01',
		updated_at: '2018-09-13 17:39:56',
		order_id: 501,
		cancelable: false,
		changeable: false
	}, {
		id: 108,
		no: '180917vrz7J2',
		staff_id: 36,
		event_type: 'CHECKIN',
		room_id: 1,
		user_id: 93,
		work_date: '2018-09-19 11:30:00',
		hangout_url: '',
		status: 'CANCEL',
		check: 'N',
		feedback: 0,
		note: '',
		created_at: '2018-09-17 16:48:25',
		updated_at: '2018-09-18 00:41:14',
		order_id: 501,
		cancelable: false,
		changeable: false
	}],
	payments: []
};

var defaultBookingData = exports.defaultBookingData = {
	dateFrom: { value: '', status: '', valid: false },
	rentMonth: { value: { range: [], yearRange: [] }, status: '', valid: false },
	orderItem: {
		value: [],
		data: defaultOrderItemData,
		options: [0, 1, 2],
		status: '',
		valid: false
	},
	name: { value: '', status: '', valid: false },
	address: { value: '', status: '', valid: false },
	certificateType: { value: [], status: '', valid: false },
	certificate: { value: '', status: '', valid: false },
	extraCertificateType: { value: [], status: '', valid: false },
	extraCertificate: { value: '', status: '', valid: false },
	emergencyContact: { value: '', status: '', valid: false },
	emergencyContactMobile: {
		value: '',
		country: {
			areaCodes: null,
			dialCode: '886',
			iso2: 'tw',
			name: 'Taiwan (台灣)',
			priority: 0
		},
		validate: false,
		valid: false,
		status: ''
	},
	emergencyContactRelationship: { value: '', status: '', valid: false },
	emergencyAddress: { value: '', status: '', valid: false },
	accept: { value: false, status: '', valid: false },
	acceptInsurance: { value: false, status: '', valid: false },
	certificateFile: {
		filename: '',
		file: null,
		status: '',
		valid: false
	},

	extraCertificateFile: {
		filename: '',
		file: null,
		status: '',
		valid: false
	}
};

var defaultCreditData = exports.defaultCreditData = {
	cardNumber: { value: '', status: '', valid: false },
	expireMonth: { value: '', status: '', valid: false },
	expireYear: { value: '', status: '', valid: false },
	cvc: { value: '', status: '', valid: false },
	name: { value: '', status: '', valid: false }
};

exports.default = (0, _reduxActions.handleActions)({
	UPDATE_BOOKING_FIELD: function UPDATE_BOOKING_FIELD(state, action) {
		var _extends2, _extends3;

		return _extends({}, state, (_extends3 = {}, _extends3[action.payload.type] = _extends({}, state[action.payload.type], (_extends2 = {}, _extends2[action.payload.key] = _extends({}, state[action.payload.type][action.payload.key], action.payload.value), _extends2)), _extends3));
	},

	UPLOAD_CERTIFICATE_FILE: function UPLOAD_CERTIFICATE_FILE(state, action) {
		var _extends4;

		return _extends({}, state, {

			form: _extends({}, state.form, (_extends4 = {}, _extends4[action.payload.key] = {
				filename: action.payload.filename,
				file: action.payload.file
			}, _extends4))
		});
	},

	CLEAR_CERTIFICATE_FILE: function CLEAR_CERTIFICATE_FILE(state, action) {
		var _extends5;

		return _extends({}, state, {

			form: _extends({}, state.form, (_extends5 = {}, _extends5[action.payload.key] = {
				filename: '',
				file: null
			}, _extends5))
		});
	},

	BOOKING_GO_TO_STEP: function BOOKING_GO_TO_STEP(state, action) {
		return _extends({}, state, {

			step: action.payload.step
		});
	},

	FETCH_ORDER_FULFILLED: function FETCH_ORDER_FULFILLED(state, action) {
		return _extends({}, state, {

			data: action.payload.data,
			current: action.payload.current,
			old: action.payload.old
		});
	},

	FETCH_USER_OVERVIEW_FULFILLED: function FETCH_USER_OVERVIEW_FULFILLED(state, action) {
		return _extends({}, state, {
			current: action.payload.current,
			data: _extends({}, state.data, action.payload.data),
			alertCheckMethod: action.payload.alertCheckMethod
		});
	},

	FETCH_ORDER_BY_ID_FULFILLED: function FETCH_ORDER_BY_ID_FULFILLED(state, action) {
		var _extends6;

		return _extends({}, state, {

			data: _extends({}, state.data, (_extends6 = {}, _extends6[action.payload.data.id] = action.payload.data, _extends6))
		});
	},

	FETCH_ORDER_ITEM_BY_ROOM_ID_FULFILLED: function FETCH_ORDER_ITEM_BY_ROOM_ID_FULFILLED(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {
				orderItem: _extends({}, state.form.orderItem, {
					data: action.payload.data,
					options: action.payload.list
				})
			})
		});
	},

	VALIDATE_ORDER_POLICY_DATA: function VALIDATE_ORDER_POLICY_DATA(state, action) {
		var _extends7;

		return _extends({}, state, {

			form: _extends({}, state.form, (_extends7 = {}, _extends7[action.payload.key] = _extends({}, state.form[action.payload.key], {
				status: 'VALIDATED',
				valid: action.payload.valid
			}), _extends7))
		});
	},

	CLEAR_VALIDATE_ORDER_POLICY_DATA: function CLEAR_VALIDATE_ORDER_POLICY_DATA(state) {
		return _extends({}, state, {

			form: _extends({}, state.form, {
				name: _extends({}, state.form.name, { status: 'VALIDATING', valid: false }),
				certificateType: _extends({}, state.form.certificateType, { status: 'VALIDATING', valid: false }),
				certificate: _extends({}, state.form.certificate, { status: 'VALIDATING', valid: false }),
				extraCertificateType: _extends({}, state.form.extraCertificateType, {
					status: 'VALIDATING',
					valid: false
				}),
				extraCertificate: _extends({}, state.form.extraCertificate, { status: 'VALIDATING', valid: false }),
				emergencyContact: _extends({}, state.form.emergencyContact, { status: 'VALIDATING', valid: false }),
				emergencyContactMobile: _extends({}, state.form.emergencyContactMobile, {
					status: 'VALIDATING',
					valid: false
				}),
				emergencyContactRelationship: _extends({}, state.form.emergencyContactRelationship, {
					status: 'VALIDATING',
					valid: false
				}),
				emergencyAddress: _extends({}, state.form.emergencyAddress, {
					status: 'VALIDATING',
					valid: false
				}),
				certificateFile: _extends({}, state.form.certificateFile, {
					status: 'VALIDATING',
					valid: false
				}),
				extraCertificateFile: _extends({}, state.form.extraCertificateFile, {
					status: 'VALIDATING',
					valid: false
				})
			})
		});
	},

	SET_ACCESS_BOOKING: function SET_ACCESS_BOOKING(state) {
		return _extends({}, state, {
			canAccess: true
		});
	},

	SET_BOOKING_FORM_DATA: function SET_BOOKING_FORM_DATA(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				address: _extends({}, state.form.address, action.payload.address),
				emergencyContact: _extends({}, state.form.emergencyContact, action.payload.emergencyContact),
				emergencyContactMobile: _extends({}, state.form.emergencyContactMobile, action.payload.emergencyContactMobile),
				emergencyContactRelationship: _extends({}, state.form.emergencyContactRelationship, action.payload.emergencyContactRelationship),
				emergencyAddress: _extends({}, state.form.emergencyAddress, action.payload.emergencyAddress)
			})
		});
	},

	VALIDATE_ORDER_CREDIT_DATA: function VALIDATE_ORDER_CREDIT_DATA(state, action) {
		var _extends8;

		return _extends({}, state, {

			creditForm: _extends({}, state.creditForm, (_extends8 = {}, _extends8[action.payload.key] = _extends({}, state.creditForm[action.payload.key], {
				status: 'VALIDATED',
				valid: action.payload.valid
			}), _extends8))
		});
	},

	CLEAR_VALIDATE_ORDER_CREDIT_DATA: function CLEAR_VALIDATE_ORDER_CREDIT_DATA(state) {
		return _extends({}, state, {

			creditForm: _extends({}, state.creditForm, {
				name: _extends({}, state.creditForm.name, { status: 'VALIDATING', valid: false }),
				cardNumber: _extends({}, state.creditForm.cardNumber, { status: 'VALIDATING', valid: false }),
				expireMonth: _extends({}, state.creditForm.expireMonth, { status: 'VALIDATING', valid: false }),
				expireYear: _extends({}, state.creditForm.expireYear, { status: 'VALIDATING', valid: false }),
				cvc: _extends({}, state.creditForm.cvc, { status: 'VALIDATING', valid: false })
			})
		});
	}
}, {
	form: defaultBookingData,

	data: {},
	current: [],
	old: [],

	step: 0,

	canAccess: false,

	alertCheckMethod: { orderId: -1, type: '' },

	creditForm: defaultCreditData
});

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.mapCountryCode = exports.countryOptions = undefined;

var _countries = __webpack_require__(952);

var _countries2 = _interopRequireDefault(_countries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countryOptions = exports.countryOptions = _countries2.default.map(function (item) {
	return {
		value: item.cca2.toLowerCase(),
		label: item.name.common
	};
}).sort(function (a, b) {
	return a.label > b.label ? 1 : -1;
});

var mapCountryCode = exports.mapCountryCode = function mapCountryCode(code) {
	var result = countryOptions.filter(function (item) {
		return item.value === code;
	});

	return result.length > 0 ? result[0].label : '';
};

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.057,16.406c-0.188,0-0.282-0.094-0.47-0.188 c-1.411-0.847-3.198-1.317-5.079-1.317c-1.035,0-2.163,0.188-3.104,0.376c-0.188,0-0.376,0.094-0.47,0.094 c-0.376,0-0.658-0.282-0.658-0.658c0-0.376,0.188-0.658,0.564-0.658c1.223-0.282,2.446-0.47,3.763-0.47 c2.163,0,4.139,0.564,5.832,1.505c0.188,0.188,0.376,0.282,0.376,0.658C16.621,16.218,16.339,16.406,16.057,16.406z M17.091,13.773 c-0.188,0-0.376-0.094-0.564-0.188c-1.599-1.035-3.857-1.599-6.302-1.599c-1.223,0-2.352,0.188-3.198,0.376 c-0.188,0.094-0.282,0.094-0.47,0.094c-0.47,0-0.753-0.376-0.753-0.753c0-0.47,0.188-0.658,0.658-0.847 c1.129-0.282,2.258-0.564,3.857-0.564c2.634,0,5.079,0.658,7.149,1.881c0.282,0.188,0.47,0.47,0.47,0.753 C17.844,13.396,17.562,13.773,17.091,13.773z M18.314,10.762c-0.188,0-0.282-0.094-0.564-0.188 c-1.881-1.035-4.609-1.693-7.243-1.693c-1.317,0-2.728,0.188-3.951,0.47c-0.188,0-0.282,0.094-0.564,0.094 C5.428,9.54,5.051,9.069,5.051,8.505c0-0.564,0.282-0.847,0.658-0.941C7.215,7.188,8.814,7,10.507,7 c2.916,0,5.926,0.658,8.278,1.881c0.282,0.188,0.564,0.47,0.564,0.941C19.255,10.386,18.878,10.762,18.314,10.762z",
  fill: "#000000"
});

var SvgComponent = function SvgComponent(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#000000"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgComponent);

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/banner-temp__7aef114c76d699b95212663dfdc48399.png";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(27);

var _classnames3 = _interopRequireDefault(_classnames2);

var _infoInline = __webpack_require__(1001);

var _infoInline2 = _interopRequireDefault(_infoInline);

var _index = __webpack_require__(1002);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alert = function Alert(_ref) {
	var _classnames;

	var children = _ref.children,
	    text = _ref.text,
	    success = _ref.success,
	    className = _ref.className,
	    _ref$show = _ref.show,
	    show = _ref$show === undefined ? false : _ref$show,
	    onCloseAlert = _ref.onCloseAlert,
	    isDangerouslySetInnerHTML = _ref.isDangerouslySetInnerHTML;
	return _react2.default.createElement(
		'div',
		{
			className: (0, _classnames3.default)(className, _index2.default.alert, (_classnames = {}, _classnames[_index2.default.success] = success, _classnames[_index2.default.show] = show, _classnames))
		},
		_react2.default.createElement(
			'i',
			{ className: 'material-icons', onClick: onCloseAlert, role: 'presentation' },
			success ? _react2.default.createElement(_infoInline2.default, null) : 'highlight_off'
		),
		_react2.default.createElement(
			'span',
			{ className: _index2.default.text },
			isDangerouslySetInnerHTML ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: text } }) : text,
			children
		)
	);
};

exports.default = Alert;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var GOOGLE_MAP_API_KEY_MAP = {
	dev: 'AIzaSyBIEB2bD42FcB3scU6m3qjhMUFvfDD7Y9o',
	demo: 'AIzaSyBIEB2bD42FcB3scU6m3qjhMUFvfDD7Y9o',
	production: 'AIzaSyDYaLEin5fR1YX8RVl2FUeTOF1TTC9Rp2w'
};

var GOOGLE_MAP_API_KEY = exports.GOOGLE_MAP_API_KEY = GOOGLE_MAP_API_KEY_MAP["production"];

var INSTAGRAM_CLIENT_ID_MAP = {
	dev: '1d494b437b3a418a833e716129408e8c',
	demo: '1d494b437b3a418a833e716129408e8c',
	production: '1d494b437b3a418a833e716129408e8c'
};

var INSTAGRAM_CLIENT_ID = exports.INSTAGRAM_CLIENT_ID = INSTAGRAM_CLIENT_ID_MAP["production"];

/***/ }),
/* 573 */,
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(237);

__webpack_require__(272);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(96);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactI18next = __webpack_require__(69);

var _reactHotLoader = __webpack_require__(796);

var _reactRouter = __webpack_require__(45);

var _reactRouterRedux = __webpack_require__(36);

var _i18n = __webpack_require__(16);

var _event = __webpack_require__(894);

var _external = __webpack_require__(895);

var _storage = __webpack_require__(66);

var _authStorage = __webpack_require__(105);

__webpack_require__(896);

__webpack_require__(897);

var _store = __webpack_require__(898);

var _store2 = _interopRequireDefault(_store);

var _routes = __webpack_require__(953);

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// A modern alternative to CSS resets
var store = (0, _store2.default)({});
// Global css setting

var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

var i18n = (0, _i18n.initi18next)(store);

(0, _event.addResizeListener)(store);
(0, _event.addScrollListener)(store);
(0, _event.addMatchMediaListener)(store);
(0, _storage.detectLocalStorageSupport)();
(0, _storage.detectSessionStorageSupport)();
(0, _authStorage.detectAuthStorageSupport)();
(0, _external.loadConfigFromLocalStorage)(store);

_reactDom2.default.render(_react2.default.createElement(
	_reactHotLoader.AppContainer,
	null,
	_react2.default.createElement(
		_reactI18next.I18nextProvider,
		{ i18n: i18n },
		_react2.default.createElement(_routes2.default, { store: store, history: history })
	)
), document.getElementById('content'));

if (false) {
	module.hot.accept('./routes', function () {
		var NewRoutes = require('./routes').default; // eslint-disable-line global-require
		_reactDom2.default.render(_react2.default.createElement(
			_reactHotLoader.AppContainer,
			null,
			_react2.default.createElement(
				_reactI18next.I18nextProvider,
				{ i18n: i18n },
				_react2.default.createElement(NewRoutes, { store: store, history: history })
			)
		), document.getElementById('content'));
	});
}

/***/ }),
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = translate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shallowEqual__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__I18n__ = __webpack_require__(273);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}

function translate(namespaceArg) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  return function Wrapper(WrappedComponent) {
    var Translate = function (_Component) {
      _inherits(Translate, _Component);

      function Translate(props, context) {
        _classCallCheck(this, Translate);

        var _this = _possibleConstructorReturn(this, (Translate.__proto__ || Object.getPrototypeOf(Translate)).call(this, props, context));

        _this.i18n = props.i18n || options.i18n || context.i18n || Object(__WEBPACK_IMPORTED_MODULE_4__context__["b" /* getI18n */])();
        _this.namespaces = typeof namespaceArg === 'function' ? namespaceArg(props) : namespaceArg || _this.i18n.options && _this.i18n.options.defaultNS;
        if (typeof _this.namespaces === 'string') _this.namespaces = [_this.namespaces];

        var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
        _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__context__["a" /* getDefaults */])(), i18nOptions, options);

        _this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
        return _this;
      }

      _createClass(Translate, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
          if (!this.options.usePureComponent) {
            return true;
          }

          return !Object(__WEBPACK_IMPORTED_MODULE_3__shallowEqual__["a" /* default */])(this.props, nextProps);
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          if (!this.options.withRef) {
            // eslint-disable-next-line no-console
            console.error('To access the wrapped instance, you need to specify ' + '{ withRef: true } as the second argument of the translate() call.');
          }

          /* eslint react/no-string-refs: 1 */
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var extraProps = {};

          if (this.options.withRef) {
            extraProps.ref = function (c) {
              _this2.wrappedInstance = c;
            };
          }

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__I18n__["a" /* default */], _extends({ ns: this.namespaces }, this.options, this.props, { i18n: this.i18n }), function (t, _ref) {
            var ready = _ref.ready,
                context = _objectWithoutProperties(_ref, ['ready']);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
              tReady: ready
            }, _this2.props, extraProps, context));
          });
        }
      }]);

      return Translate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Translate.WrappedComponent = WrappedComponent;

    Translate.contextTypes = {
      i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    };

    Translate.displayName = 'Translate(' + getDisplayName(WrappedComponent) + ')';

    Translate.namespaces = namespaceArg;

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Translate, WrappedComponent);
  };
}

translate.setDefaults = __WEBPACK_IMPORTED_MODULE_4__context__["d" /* setDefaults */];

translate.setI18n = __WEBPACK_IMPORTED_MODULE_4__context__["e" /* setI18n */];

/***/ }),
/* 784 */,
/* 785 */,
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

/* eslint-disable no-self-compare */

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }
  // Step 6.a: NaN == NaN
  return x !== x && y !== y;
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Interpolate = function (_Component) {
  _inherits(Interpolate, _Component);

  function Interpolate(props, context) {
    _classCallCheck(this, Interpolate);

    var _this = _possibleConstructorReturn(this, (Interpolate.__proto__ || Object.getPrototypeOf(Interpolate)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n;
    _this.t = props.t || context.t;
    return _this;
  }

  _createClass(Interpolate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var parent = this.props.parent || 'span';
      var REGEXP = this.props.regexp || this.i18n.services.interpolator.regexp;
      var _props = this.props,
          className = _props.className,
          style = _props.style;

      // Set to true if you want to use raw HTML in translation values
      // See https://github.com/i18next/react-i18next/issues/189

      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';

      var tOpts = _extends({}, this.props.options, { interpolation: { prefix: '#$?', suffix: '?$#' } });
      var format = this.t(this.props.i18nKey, tOpts);

      if (!format || typeof format !== 'string') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('noscript', null);

      var children = [];

      var handleFormat = function handleFormat(key, props) {
        if (key.indexOf(_this2.i18n.options.interpolation.formatSeparator) < 0) {
          if (props[key] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + key + ' for interpolating ' + format);
          return props[key];
        }

        var p = key.split(_this2.i18n.options.interpolation.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this2.i18n.options.interpolation.formatSeparator).trim();

        if (props[k] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + k + ' for interpolating ' + format);
        return _this2.i18n.options.interpolation.format(props[k], f, _this2.i18n.language);
      };

      format.split(REGEXP).reduce(function (memo, match, index) {
        var child = void 0;

        if (index % 2 === 0) {
          if (match.length === 0) return memo;
          if (useDangerouslySetInnerHTML) {
            child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: match } });
          } else {
            child = match;
          }
        } else {
          child = handleFormat(match, _this2.props);
        }

        memo.push(child);
        return memo;
      }, children);

      var additionalProps = {};
      if (this.i18n.options.react && this.i18n.options.react.exposeNamespace) {
        var ns = typeof this.t.ns === 'string' ? this.t.ns : this.t.ns[0];
        if (this.props.i18nKey && this.i18n.options.nsSeparator && this.props.i18nKey.indexOf(this.i18n.options.nsSeparator) > -1) {
          var parts = this.props.i18nKey.split(this.i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (this.t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (className) additionalProps.className = className;
      if (style) additionalProps.style = style;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement.apply(this, [parent, additionalProps].concat(children));
    }
  }]);

  return Interpolate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Interpolate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Interpolate.defaultProps = {
  className: ''
};

Interpolate.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Interpolate);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  return node && node.children ? node.children : node.props && node.props.children;
}

function nodesToString(mem, children, index) {
  if (!children) return '';
  if (Object.prototype.toString.call(children) !== '[object Array]') children = [children];

  children.forEach(function (child, i) {
    // const isElement = React.isValidElement(child);
    // const elementKey = `${index !== 0 ? index + '-' : ''}${i}:${typeof child.type === 'function' ? child.type.name : child.type || 'var'}`;
    var elementKey = '' + i;

    if (typeof child === 'string') {
      mem = '' + mem + child;
    } else if (hasChildren(child)) {
      mem = mem + '<' + elementKey + '>' + nodesToString('', getChildren(child), i + 1) + '</' + elementKey + '>';
    } else if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      mem = mem + '<' + elementKey + '></' + elementKey + '>';
    } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object') {
      var clone = _extends({}, child);
      var format = clone.format;
      delete clone.format;

      var keys = Object.keys(clone);
      if (format && keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + ', ' + format + '}}</' + elementKey + '>';
      } else if (keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + '}}</' + elementKey + '>';
      } else if (console && console.warn) {
        // not a valid interpolation object (can only contain one value plus format)
        console.warn('react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.', child);
      }
    } else if (console && console.warn) {
      console.warn('react-i18next: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.', child);
    }
  });

  return mem;
}

function renderNodes(children, targetString, i18n) {
  if (targetString === "") return [];
  if (!children) return [targetString];

  // parse ast from string with additional wrapper tag
  // -> avoids issues in parser removing prepending text nodes
  var ast = __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default.a.parse('<0>' + targetString + '</0>');

  function mapAST(reactNodes, astNodes) {
    if (Object.prototype.toString.call(reactNodes) !== '[object Array]') reactNodes = [reactNodes];
    if (Object.prototype.toString.call(astNodes) !== '[object Array]') astNodes = [astNodes];

    return astNodes.reduce(function (mem, node, i) {
      if (node.type === 'tag') {
        var child = reactNodes[parseInt(node.name, 10)] || {};
        var isElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren(child)) {
          var inner = mapAST(getChildren(child), node.children);
          if (child.dummy) child.children = inner; // needed on preact!
          mem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, child.props, { key: i }), inner));
        } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && !isElement) {
          var interpolated = i18n.services.interpolator.interpolate(node.children[0].content, child, i18n.language);
          mem.push(interpolated);
        } else {
          mem.push(child);
        }
      } else if (node.type === 'text') {
        mem.push(node.content);
      }
      return mem;
    }, []);
  }

  // call mapAST with having react nodes nested into additional node like
  // we did for the string ast from translation
  // return the children of that extra node to get expected result
  var result = mapAST([{ dummy: true, children: children }], ast);
  return getChildren(result[0]);
}

var Trans = function (_React$Component) {
  _inherits(Trans, _React$Component);

  function Trans() {
    _classCallCheck(this, Trans);

    return _possibleConstructorReturn(this, (Trans.__proto__ || Object.getPrototypeOf(Trans)).apply(this, arguments));
  }

  _createClass(Trans, [{
    key: 'render',
    value: function render() {
      var contextAndProps = _extends({ i18n: this.context.i18n, t: this.context.t }, this.props);

      var children = contextAndProps.children,
          count = contextAndProps.count,
          parent = contextAndProps.parent,
          i18nKey = contextAndProps.i18nKey,
          tOptions = contextAndProps.tOptions,
          namespace = contextAndProps.ns,
          i18n = contextAndProps.i18n,
          tFromContextAndProps = contextAndProps.t,
          additionalProps = _objectWithoutProperties(contextAndProps, ['children', 'count', 'parent', 'i18nKey', 'tOptions', 'ns', 'i18n', 't']);

      var t = tFromContextAndProps || i18n.t.bind(i18n);

      var reactI18nextOptions = i18n.options && i18n.options.react || {};
      var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;

      var defaultValue = nodesToString('', children, 0);
      var hashTransKey = reactI18nextOptions.hashTransKey;
      var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
      var translation = key ? t(key, _extends({}, tOptions, { interpolation: { prefix: '#$?', suffix: '?$#' }, defaultValue: defaultValue, count: count, ns: namespace })) : defaultValue;

      if (reactI18nextOptions.exposeNamespace) {
        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];
        if (i18nKey && i18n.options && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
          var parts = i18nKey.split(i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (!useAsParent) return renderNodes(children, translation, i18n);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(useAsParent, additionalProps, renderNodes(children, translation, i18n));
    }
  }]);

  return Trans;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Trans);


Trans.propTypes = {
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  parent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  i18nKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

// Trans.defaultProps = {
//   parent: 'div'
// };

Trans.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    parse: __webpack_require__(790),
    stringify: __webpack_require__(793)
};


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint -W030 */
var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;
var parseTag = __webpack_require__(791);
// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
// common logic for pushing a child node onto a list
function pushTextNode(list, html, level, start, ignoreWhitespace) {
    // calculate correct end of the content slice in case there's
    // no tag after the text node.
    var end = html.indexOf('<', start);
    var content = html.slice(start, end === -1 ? undefined : end);
    // if a node is nothing but whitespace, collapse it as the spec states:
    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
    if (/^\s*$/.test(content)) {
        content = ' ';
    }
    // don't add whitespace-only text nodes if they would be trailing text nodes
    // or if they would be leading whitespace-only text nodes:
    //  * end > -1 indicates this is not a trailing text node
    //  * leading node is when level is -1 and list has length 0
    if ((!ignoreWhitespace && end > -1 && level + list.length >= 0) || content !== ' ') {
        list.push({
            type: 'text',
            content: content
        });
    }
}

module.exports = function parse(html, options) {
    options || (options = {});
    options.components || (options.components = empty);
    var result = [];
    var current;
    var level = -1;
    var arr = [];
    var byTag = {};
    var inComponent = false;

    html.replace(tagRE, function (tag, index) {
        if (inComponent) {
            if (tag !== ('</' + current.name + '>')) {
                return;
            } else {
                inComponent = false;
            }
        }

        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.indexOf('<!--') === 0;
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var parent;

        if (isOpen && !isComment) {
            level++;

            current = parseTag(tag);
            if (current.type === 'tag' && options.components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }

            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
            }

            byTag[current.tagName] = current;

            // if we're at root, push new base node
            if (level === 0) {
                result.push(current);
            }

            parent = arr[level - 1];

            if (parent) {
                parent.children.push(current);
            }

            arr[level] = current;
        }

        if (isComment || !isOpen || current.voidElement) {
            if (!isComment) {
                level--;
            }
            if (!inComponent && nextChar !== '<' && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
            }
        }
    });

    // If the "html" passed isn't actually html, add it as a text node.
    if (!result.length && html.length) {
        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
    }

    return result;
};


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;
var voidElements = __webpack_require__(792);

module.exports = function (tag) {
    var i = 0;
    var key;
    var expectingValueAfterEquals = true;
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };

    tag.replace(attrRE, function (match) {
        if (match === '=') {
            expectingValueAfterEquals = true;
            i++;
            return;
        }

        if (!expectingValueAfterEquals) {
            if (key) {
                res.attrs[key] = key; // boolean attribute
            }
            key=match;
        } else {
            if (i === 0) {
                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
                    res.voidElement = true;
                }
                res.name = match;
            } else {
                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
                key=undefined;
            }
        }
        i++;
        expectingValueAfterEquals = false;
    });

    return res;
};


/***/ }),
/* 792 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 793 */
/***/ (function(module, exports) {

function attrString(attrs) {
    var buff = [];
    for (var key in attrs) {
        buff.push(key + '="' + attrs[key] + '"');
    }
    if (!buff.length) {
        return '';
    }
    return ' ' + buff.join(' ');
}

function stringify(buff, doc) {
    switch (doc.type) {
    case 'text':
        return buff + doc.content;
    case 'tag':
        buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
        if (doc.voidElement) {
            return buff;
        }
        return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
    }
}

module.exports = function (doc) {
    return doc.reduce(function (token, rootEl) {
        return token + stringify('', rootEl);
    }, '');
};


/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var I18nextProvider = function (_Component) {
  _inherits(I18nextProvider, _Component);

  function I18nextProvider(props, context) {
    _classCallCheck(this, I18nextProvider);

    var _this = _possibleConstructorReturn(this, (I18nextProvider.__proto__ || Object.getPrototypeOf(I18nextProvider)).call(this, props, context));

    _this.i18n = props.i18n;
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.i18n.options.isInitialSSR = true; // if set will be deleted on first render in translate hoc
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }
    return _this;
  }

  _createClass(I18nextProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { i18n: this.i18n };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.i18n !== nextProps.i18n) {
        throw new Error('[react-i18next][I18nextProvider]does not support changing the i18n object.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children);
    }
  }]);

  return I18nextProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

I18nextProvider.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
};

I18nextProvider.childContextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (I18nextProvider);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadNamespaces;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// shim object entries
if (!Object.entries) Object.entries = function (obj) {
  var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }return resArray;
};

// Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16
function eachComponents(components, iterator) {
  for (var i = 0, l = components.length; i < l; i++) {
    // eslint-disable-line id-length
    if (_typeof(components[i]) === 'object') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          iterator(value, i, key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      iterator(components[i], i);
    }
  }
}

function filterAndFlattenComponents(components) {
  var flattened = [];
  eachComponents(components, function (Component) {
    if (Component && Component.namespaces) {

      Component.namespaces.forEach(function (namespace) {
        if (flattened.indexOf(namespace) === -1) {
          flattened.push(namespace);
        }
      });
    }
  });
  return flattened;
}

function loadNamespaces(_ref) {
  var components = _ref.components,
      i18n = _ref.i18n;

  var allNamespaces = filterAndFlattenComponents(components);

  return new Promise(function (resolve) {
    i18n.loadNamespaces(allNamespaces, resolve);
  });
}

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(797)


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(798);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(799);

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(800);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(3);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneInstance", function() { return cloneInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dir", function() { return dir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exists", function() { return exists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFixedT", function() { return getFixedT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguages", function() { return loadLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return loadNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadResources", function() { return loadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultNamespace", function() { return setDefaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "use", function() { return use; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18next_js__ = __webpack_require__(828);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

var changeLanguage = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].changeLanguage.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var cloneInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].cloneInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var createInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].createInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var dir = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].dir.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var exists = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].exists.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var getFixedT = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].getFixedT.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var init = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].init.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadLanguages = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadLanguages.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadNamespaces = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadNamespaces.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadResources = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadResources.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var off = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var on = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].on.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var setDefaultNamespace = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].setDefaultNamespace.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var t = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].t.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var use = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translator_js__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaults_js__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__postProcessor_js__ = __webpack_require__(288);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }












function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["b" /* transformOptions */])(options);
    _this.services = {};
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), _possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["a" /* get */])(), this.options, Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["b" /* transformOptions */])(options));

    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(null, this.options);
      }

      var lu = new __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__["a" /* default */](this.options);
      this.store = new __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__["a" /* default */](this.options.resources, this.options);

      var s = this.services;
      s.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__["a" /* default */](lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__["a" /* default */](this.options);

      s.backendConnector = new __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__["a" /* default */](createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }

      this.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */


  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.backendConnector.load(toLoad, this.options.ns, callback);
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    this.services.backendConnector.reload(lngs, ns);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }

    if (module.type === 'postProcessor') {
      __WEBPACK_IMPORTED_MODULE_9__postProcessor_js__["a" /* default */].addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      _this4.translator.changeLanguage(l);

      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        if (!_this4.translator.language) _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key, opts) {
      for (var _len3 = arguments.length, rest = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        rest[_key3 - 2] = arguments[_key3];
      }

      var options = _extends({}, opts);
      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
        options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      }

      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */


  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = _extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = clone.options; // sync options

    return clone;
  };

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new I18n());

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(136);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    _classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data || {};
    _this.options = options;
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator || this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { silent: false };

    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : { silent: false };

    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path) || {};

    if (deep) {
      __WEBPACK_IMPORTED_MODULE_1__utils_js__["b" /* deepExtend */](pack, resources, overwrite);
    } else {
      pack = _extends({}, pack, resources);
    }

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, pack);

    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(__WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceStore);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__(136);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }






var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* copy */](['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat'], services, _this);

    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    var resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys, options) {
    var _this2 = this;

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' && this.options.overloadTranslationOptionHandler) {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (!options) options = {};

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var resolved = this.resolve(keys, options);
    var res = resolved && resolved.res;
    var resUsedKey = resolved && resolved.usedKey || key;

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (res && handleAsObject && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (options.keySeparator || this.options.keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            var deepKey = '' + resUsedKey + keySeparator + m;
            copy[m] = this.translate(deepKey, _extends({}, options, { joinArrays: false, ns: namespaces }));
            if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
          }
        }
        res = copy;
      }
    } else if (joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;
        res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }

      // save missing
      var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        var send = function send(l, k) {
          if (_this2.options.missingKeyHandler) {
            _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
            _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          }
          _this2.emit('missingKey', l, namespace, k, res);
        };

        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && options.count) {
            lngs.forEach(function (l) {
              var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

              plurals.forEach(function (p) {
                return send([l], p);
              });
            });
          } else {
            send(lngs, key);
          }
        }
      }

      // extend
      res = this.extendTranslation(res, keys, options, resolved);

      // append namespace if still key
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options, resolved) {
    var _this3 = this;

    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey);
    } else {
      // i18next.parsing
      if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));

      // interpolate
      var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
      res = this.interpolator.interpolate(res, data, options.lng || this.language);

      // nesting
      if (options.nest !== false) res = this.interpolator.nest(res, function () {
        return _this3.translate.apply(_this3, arguments);
      }, options);

      if (options.interpolation) this.interpolator.reset();
    }

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__["a" /* default */].handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this4 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;
    var usedKey = void 0;
    var usedLng = void 0;
    var usedNS = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this4.isValidLookup(found)) return;
      var extracted = _this4.extractFromKey(k, options);
      var key = extracted.key;
      usedKey = key;
      var namespaces = extracted.namespaces;
      if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language);

      namespaces.forEach(function (ns) {
        if (_this4.isValidLookup(found)) return;
        usedNS = ns;

        codes.forEach(function (code) {
          if (_this4.isValidLookup(found)) return;
          usedLng = code;

          var finalKey = key;
          var finalKeys = [finalKey];

          if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
            _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            var pluralSuffix = void 0;
            if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);

            // fallback for plural if context not found
            if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

            // get key for context if needed
            if (needsContextHandling) finalKeys.push(finalKey += '' + _this4.options.contextSeparator + options.context);

            // get key for plural if needed
            if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
          }

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this4.isValidLookup(found)) {
              found = _this4.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return { res: found, usedKey: usedKey, usedLng: usedLng, usedNS: usedNS };
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Translator);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(93);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtil);

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(93);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getPluralFormsOfKey = function getPluralFormsOfKey(code, key) {
    var _this = this;

    var ret = [];

    var rule = this.getRule(code);

    if (!rule) return ret;

    rule.numbers.forEach(function (n) {
      var suffix = _this.getSuffix(code, n);
      ret.push('' + key + suffix);
    });

    return ret;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this2 = this;

    var rule = this.getRule(code);

    if (rule) {
      // if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ __webpack_exports__["a"] = (PluralResolver);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(93);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */


  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
      this.escape = options.interpolation && options.interpolation.escape || __WEBPACK_IMPORTED_MODULE_0__utils_js__["c" /* escape */];
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;

    this.prefix = iOpts.prefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */]('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](')');

    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
    var _this = this;

    var match = void 0;
    var value = void 0;
    var replaces = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(__WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, k), f, lng);
    };

    this.resetRegExp();

    replaces = 0;
    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }

    replaces = 0;
    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (value === undefined) {
        if (typeof this.options.missingInterpolationHandler === 'function') {
          var temp = this.options.missingInterpolationHandler(str, match);
          value = typeof temp === 'string' ? temp : '';
        } else {
          this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
          value = '';
        }
      } else if (typeof value !== 'string') {
        value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = _extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key, inheritedOptions) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);

        if (inheritedOptions) clonedOptions = _extends({}, inheritedOptions, clonedOptions);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interpolator);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__ = __webpack_require__(135);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (_this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _this3 = this;

    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // callback if ready
    this.queue.forEach(function (q) {
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["f" /* pushPath */](q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        _this3.emit('loaded', q.loaded);
        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this4 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this4.read.call(_this4, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this5 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    toLoad.toLoad.forEach(function (name) {
      _this5.loadOne(name);
    });
  };

  Connector.prototype.reload = function reload(languages, namespaces) {
    var _this6 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
    }

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    languages.forEach(function (l) {
      namespaces.forEach(function (n) {
        _this6.loadOne(l + '|' + n, 're');
      });
    });
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this7 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split3 = name.split('|'),
        _name$split4 = _slicedToArray(_name$split3, 2),
        lng = _name$split4[0],
        ns = _name$split4[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this7.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this7.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this7.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    if (this.backend && this.backend.create) {
      this.backend.create(languages, namespace, key, fallbackValue, null /* unused callback */, _extends({}, options, { isUpdate: isUpdate }));
    }

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (immutable) */ __webpack_exports__["b"] = transformOptions;

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    updateMissing: false, // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback', // 'current' || 'all'
    saveMissingPlurals: true, // will save all forms not only singular key
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false, // function(str, match)

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (args[1]) ret.defaultValue = args[1];
      if (args[2]) ret.tDescription = args[2];
      return ret;
    },

    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(837).default;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(838);

var utils = _interopRequireWildcard(_utils);

var _cookie = __webpack_require__(839);

var _cookie2 = _interopRequireDefault(_cookie);

var _querystring = __webpack_require__(840);

var _querystring2 = _interopRequireDefault(_querystring);

var _localStorage = __webpack_require__(841);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _navigator = __webpack_require__(842);

var _navigator2 = _interopRequireDefault(_navigator);

var _htmlTag = __webpack_require__(843);

var _htmlTag2 = _interopRequireDefault(_htmlTag);

var _path = __webpack_require__(844);

var _path2 = _interopRequireDefault(_path);

var _subdomain = __webpack_require__(845);

var _subdomain2 = _interopRequireDefault(_subdomain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',

    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode']
    //cookieMinutes: 10,
    //cookieDomain: 'myDomain'
  };
}

var Browser = function () {
  function Browser(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Browser);

    this.type = 'languageDetector';
    this.detectors = {};

    this.init(services, options);
  }

  _createClass(Browser, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());
      this.i18nOptions = i18nOptions;

      this.addDetector(_cookie2.default);
      this.addDetector(_querystring2.default);
      this.addDetector(_localStorage2.default);
      this.addDetector(_navigator2.default);
      this.addDetector(_htmlTag2.default);
      this.addDetector(_path2.default);
      this.addDetector(_subdomain2.default);
    }
  }, {
    key: 'addDetector',
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: 'detect',
    value: function detect(detectionOrder) {
      var _this = this;

      if (!detectionOrder) detectionOrder = this.options.order;

      var detected = [];
      detectionOrder.forEach(function (detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup = _this.detectors[detectorName].lookup(_this.options);
          if (lookup && typeof lookup === 'string') lookup = [lookup];
          if (lookup) detected = detected.concat(lookup);
        }
      });

      var found = void 0;
      detected.forEach(function (lng) {
        if (found) return;
        var cleanedLng = _this.services.languageUtils.formatLanguageCode(lng);
        if (_this.services.languageUtils.isWhitelisted(cleanedLng)) found = cleanedLng;
      });

      if (!found) {
        var fallbacks = this.i18nOptions.fallbackLng;
        if (typeof fallbacks === 'string') fallbacks = [fallbacks];
        if (!fallbacks) fallbacks = [];

        if (Object.prototype.toString.apply(fallbacks) === '[object Array]') {
          found = fallbacks[0];
        } else {
          found = fallbacks[0] || fallbacks.default && fallbacks.default[0];
        }
      };

      return found;
    }
  }, {
    key: 'cacheUserLanguage',
    value: function cacheUserLanguage(lng, caches) {
      var _this2 = this;

      if (!caches) caches = this.options.caches;
      if (!caches) return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
      caches.forEach(function (cacheName) {
        if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);

  return Browser;
}();

Browser.type = 'languageDetector';

exports.default = Browser;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cookie = {
  create: function create(name, value, minutes, domain) {
    var expires = void 0;
    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    } else expires = '';
    domain = domain ? 'domain=' + domain + ';' : '';
    document.cookie = name + '=' + value + expires + ';' + domain + 'path=/';
  },

  read: function read(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  remove: function remove(name) {
    this.create(name, '', -1);
  }
};

exports.default = {
  name: 'cookie',

  lookup: function lookup(options) {
    var found = void 0;

    if (options.lookupCookie && typeof document !== 'undefined') {
      var c = cookie.read(options.lookupCookie);
      if (c) found = c;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== 'undefined') {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain);
    }
  }
};

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'querystring',

  lookup: function lookup(options) {
    var found = void 0;

    if (typeof window !== 'undefined') {
      var query = window.location.search.substring(1);
      var params = query.split('&');
      for (var i = 0; i < params.length; i++) {
        var pos = params[i].indexOf('=');
        if (pos > 0) {
          var key = params[i].substring(0, pos);
          if (key === options.lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }

    return found;
  }
};

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasLocalStorageSupport = void 0;
try {
  hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
  var testKey = 'i18next.translate.boo';
  window.localStorage.setItem(testKey, 'foo');
  window.localStorage.removeItem(testKey);
} catch (e) {
  hasLocalStorageSupport = false;
}

exports.default = {
  name: 'localStorage',

  lookup: function lookup(options) {
    var found = void 0;

    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'navigator',

  lookup: function lookup(options) {
    var found = [];

    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (var i = 0; i < navigator.languages.length; i++) {
          found.push(navigator.languages[i]);
        }
      }
      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }
      if (navigator.language) {
        found.push(navigator.language);
      }
    }

    return found.length > 0 ? found : undefined;
  }
};

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'htmlTag',

  lookup: function lookup(options) {
    var found = void 0;
    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);

    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
      found = htmlTag.getAttribute('lang');
    }

    return found;
  }
};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'path',

  lookup: function lookup(options) {
    var found = void 0;
    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (language instanceof Array) {
        if (typeof options.lookupFromUrlIndex === 'number') {
          found = language[options.lookupFromPathIndex].replace('/', '');
        } else {
          found = language[0].replace('/', '');
        }
      }
    }
    return found;
  }
};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'subdomain',

  lookup: function lookup(options) {
    var found = void 0;
    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);
      if (language instanceof Array) {
        if (typeof options.lookupFromSubdomainIndex === 'number') {
          found = language[options.lookupFromSubdomainIndex].replace('http://', '').replace('https://', '').replace('.', '');
        } else {
          found = language[0].replace('http://', '').replace('https://', '').replace('.', '');
        }
      }
    }
    return found;
  }
};

/***/ }),
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 306,
	"./af.js": 306,
	"./ar": 307,
	"./ar-dz": 308,
	"./ar-dz.js": 308,
	"./ar-kw": 309,
	"./ar-kw.js": 309,
	"./ar-ly": 310,
	"./ar-ly.js": 310,
	"./ar-ma": 311,
	"./ar-ma.js": 311,
	"./ar-sa": 312,
	"./ar-sa.js": 312,
	"./ar-tn": 313,
	"./ar-tn.js": 313,
	"./ar.js": 307,
	"./az": 314,
	"./az.js": 314,
	"./be": 315,
	"./be.js": 315,
	"./bg": 316,
	"./bg.js": 316,
	"./bm": 317,
	"./bm.js": 317,
	"./bn": 318,
	"./bn.js": 318,
	"./bo": 319,
	"./bo.js": 319,
	"./br": 320,
	"./br.js": 320,
	"./bs": 321,
	"./bs.js": 321,
	"./ca": 322,
	"./ca.js": 322,
	"./cs": 323,
	"./cs.js": 323,
	"./cv": 324,
	"./cv.js": 324,
	"./cy": 325,
	"./cy.js": 325,
	"./da": 326,
	"./da.js": 326,
	"./de": 327,
	"./de-at": 328,
	"./de-at.js": 328,
	"./de-ch": 329,
	"./de-ch.js": 329,
	"./de.js": 327,
	"./dv": 330,
	"./dv.js": 330,
	"./el": 331,
	"./el.js": 331,
	"./en-au": 332,
	"./en-au.js": 332,
	"./en-ca": 333,
	"./en-ca.js": 333,
	"./en-gb": 334,
	"./en-gb.js": 334,
	"./en-ie": 335,
	"./en-ie.js": 335,
	"./en-il": 336,
	"./en-il.js": 336,
	"./en-nz": 337,
	"./en-nz.js": 337,
	"./eo": 338,
	"./eo.js": 338,
	"./es": 339,
	"./es-do": 340,
	"./es-do.js": 340,
	"./es-us": 341,
	"./es-us.js": 341,
	"./es.js": 339,
	"./et": 342,
	"./et.js": 342,
	"./eu": 343,
	"./eu.js": 343,
	"./fa": 344,
	"./fa.js": 344,
	"./fi": 345,
	"./fi.js": 345,
	"./fo": 346,
	"./fo.js": 346,
	"./fr": 347,
	"./fr-ca": 348,
	"./fr-ca.js": 348,
	"./fr-ch": 349,
	"./fr-ch.js": 349,
	"./fr.js": 347,
	"./fy": 350,
	"./fy.js": 350,
	"./gd": 351,
	"./gd.js": 351,
	"./gl": 352,
	"./gl.js": 352,
	"./gom-latn": 353,
	"./gom-latn.js": 353,
	"./gu": 354,
	"./gu.js": 354,
	"./he": 355,
	"./he.js": 355,
	"./hi": 356,
	"./hi.js": 356,
	"./hr": 357,
	"./hr.js": 357,
	"./hu": 358,
	"./hu.js": 358,
	"./hy-am": 359,
	"./hy-am.js": 359,
	"./id": 360,
	"./id.js": 360,
	"./is": 361,
	"./is.js": 361,
	"./it": 362,
	"./it.js": 362,
	"./ja": 363,
	"./ja.js": 363,
	"./jv": 364,
	"./jv.js": 364,
	"./ka": 365,
	"./ka.js": 365,
	"./kk": 366,
	"./kk.js": 366,
	"./km": 367,
	"./km.js": 367,
	"./kn": 368,
	"./kn.js": 368,
	"./ko": 369,
	"./ko.js": 369,
	"./ky": 370,
	"./ky.js": 370,
	"./lb": 371,
	"./lb.js": 371,
	"./lo": 372,
	"./lo.js": 372,
	"./lt": 373,
	"./lt.js": 373,
	"./lv": 374,
	"./lv.js": 374,
	"./me": 375,
	"./me.js": 375,
	"./mi": 376,
	"./mi.js": 376,
	"./mk": 377,
	"./mk.js": 377,
	"./ml": 378,
	"./ml.js": 378,
	"./mn": 379,
	"./mn.js": 379,
	"./mr": 380,
	"./mr.js": 380,
	"./ms": 381,
	"./ms-my": 382,
	"./ms-my.js": 382,
	"./ms.js": 381,
	"./mt": 383,
	"./mt.js": 383,
	"./my": 384,
	"./my.js": 384,
	"./nb": 385,
	"./nb.js": 385,
	"./ne": 386,
	"./ne.js": 386,
	"./nl": 387,
	"./nl-be": 388,
	"./nl-be.js": 388,
	"./nl.js": 387,
	"./nn": 389,
	"./nn.js": 389,
	"./pa-in": 390,
	"./pa-in.js": 390,
	"./pl": 391,
	"./pl.js": 391,
	"./pt": 392,
	"./pt-br": 393,
	"./pt-br.js": 393,
	"./pt.js": 392,
	"./ro": 394,
	"./ro.js": 394,
	"./ru": 395,
	"./ru.js": 395,
	"./sd": 396,
	"./sd.js": 396,
	"./se": 397,
	"./se.js": 397,
	"./si": 398,
	"./si.js": 398,
	"./sk": 399,
	"./sk.js": 399,
	"./sl": 400,
	"./sl.js": 400,
	"./sq": 401,
	"./sq.js": 401,
	"./sr": 402,
	"./sr-cyrl": 403,
	"./sr-cyrl.js": 403,
	"./sr.js": 402,
	"./ss": 404,
	"./ss.js": 404,
	"./sv": 405,
	"./sv.js": 405,
	"./sw": 406,
	"./sw.js": 406,
	"./ta": 407,
	"./ta.js": 407,
	"./te": 408,
	"./te.js": 408,
	"./tet": 409,
	"./tet.js": 409,
	"./tg": 410,
	"./tg.js": 410,
	"./th": 411,
	"./th.js": 411,
	"./tl-ph": 412,
	"./tl-ph.js": 412,
	"./tlh": 413,
	"./tlh.js": 413,
	"./tr": 414,
	"./tr.js": 414,
	"./tzl": 415,
	"./tzl.js": 415,
	"./tzm": 416,
	"./tzm-latn": 417,
	"./tzm-latn.js": 417,
	"./tzm.js": 416,
	"./ug-cn": 418,
	"./ug-cn.js": 418,
	"./uk": 419,
	"./uk.js": 419,
	"./ur": 420,
	"./ur.js": 420,
	"./uz": 421,
	"./uz-latn": 422,
	"./uz-latn.js": 422,
	"./uz.js": 421,
	"./vi": 423,
	"./vi.js": 423,
	"./x-pseudo": 424,
	"./x-pseudo.js": 424,
	"./yo": 425,
	"./yo.js": 425,
	"./zh-cn": 426,
	"./zh-cn.js": 426,
	"./zh-hk": 427,
	"./zh-hk.js": 427,
	"./zh-tw": 428,
	"./zh-tw.js": 428
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 890;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _en = __webpack_require__(892);

var _en2 = _interopRequireDefault(_en);

var _zhTW = __webpack_require__(893);

var _zhTW2 = _interopRequireDefault(_zhTW);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
	en: _en2.default,
	'zh-TW': _zhTW2.default
};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	common: {
		hello: 'Hello/ Hi'
	},
	navigator: {
		choose: 'Living In 9floor',
		filter: 'Search by Filter',
		map: 'Geographic Search',
		pauian: 'Pure Co-living',
		personalized: 'Recommend rooms ',
		ninthfloor: '9floor',
		about: 'About',
		media: 'Media',
		team: 'Team',
		contact: 'Contact',
		service: 'Service',
		space: 'Space Management',
		coliving: 'Coliving',
		journal: 'Journal',
		community: 'Community',
		news: 'News',
		note: 'Coliving',
		guide: 'Guide',
		member: 'Member',
		overview: 'Overview',
		setting: 'Settings',
		favorites: 'Favorites',
		propertyHistory: 'Property Viewing History',
		reservationHistory: 'Reservation History',
		onlineCommunity: 'Online Community',
		login: 'Login',
		logout: 'logout',
		register: 'Register',
		loginOrRegister: 'Login/ Register'
	},
	banner: {
		search: 'Search'
	},
	footer: {
		room: 'Living In 9floor',
		filter: 'Search by Filter',
		map: 'Geographic Search',
		pauian: 'Pure Co-living',
		personalized: 'Recommend rooms ',
		ninthfloor: '9floor',
		about: 'About',
		team: 'Team',
		space: 'Space Management',
		coliving: 'Coliving',
		community: 'Online Community',
		news: 'News',
		help: 'Help',
		how: 'How to Apply',
		FAQ: 'FAQ',
		contact: 'Contact',
		media: 'Media',
		moveIn: 'Terms of Service',
		privacy: 'Privacy Policy',
		termsofService: 'Terms of Service',
		sitemap: 'Sitemap',
		description: 'Description'
	},
	reservation: {
		MORNING: 'Morning',
		AFTERNOON: 'Afternoon',
		live: 'Live',
		phone: 'Phone',
		online: 'Virtual Viewing',
		checkin: 'Move-in',
		checkout: 'Check-out',
		interview_phone: 'Phone Interview ',
		interview_online: 'Online Interview',
		notValidText: 'Uh oh. Your application materials are incomplete. Please complete all required fields.',
		notValidReserve: 'Sorry, the time you selected has already been reserved. Please choose another time slot.',
		notReserveCheckinDate: "Can't find any time works for you? Please call 9floor team, our staff will fit you in. (Phone Number：+886 908959613)",
		notReserveCheckoutDate: "Can't find any time works for you? Please call 9floor team, our staff will fit you in. (Phone Number：+886 908959613)",
		checkinTime: 'Move-in Time',
		checkoutTime: 'Checkout Time',
		ViewTime: 'Property-viewing Time',
		checkinDescription: 'Move-in Description',
		checkoutDescription: 'Checkout Description',
		ViewMethod: 'Property-viewing Method',
		checkinResult: 'We are looking forward to your move-in day. Please set aside about one hour for the check-in process. One of our staff members will briefly meet with you to answer questions about the space, tell you more about the roommates, and go over a few details that we hope will help equip you to get connected quickly.',
		checkoutResult: 'For checkout, please leave your personal space in the same condition/appearance as check-in. Be sure to remove all personal belongings and trash. The checkout process will be conducted in accordance with the terms of stay. And last but not least, don’t forget to come back and visit everyone after moving out!',
		referenceNumber: 'Reference Number',
		address: 'Address',
		time: 'Time',
		phoneNumber: 'Phone Number',
		name: 'Name',
		cancelAnAppointment: 'Cancel an Appointment',
		changeAnAppointment: 'Change an Appointment',
		fillOutTheSurvey: 'Fill Out The Survey',
		successful: 'Reservation Successful',
		successDescription: 'Thank you for your reservation. If availability changes and the listing or time slot is no longer available, we will contact you via email. If the change is within 24 hours of the appointment, we will notify you via phone. If you would like to cancel or change your reservation, please submit a request through the online member center.',
		viewReservation: 'View Details',
		backToRoom: 'Return to Listing',
		ninefloor: '9floor',
		calendar: 'Calendar',
		addToCalendar: 'Add to Calendar',
		gtm: 'GMT+8 time',
		next: 'Next',
		edit: 'Send',
		phoneDescription: 'Phone Consultation: This service is currently only available for Taiwanese numbers. If you are in another country, please choose our virtual viewing option.',
		hangoutDescription: 'Virtual Viewing: We use Google hangouts to facilitate online property viewings. After you register for an appointment, we will send a link to your registered email address.',
		hangout: 'Your Google Hangout ID',
		hangoutAccount: 'Hangout ID',
		chooseTypeValid: 'Please choose the way to view the properity.',
		checkPhoneAndHangoutAlert: 'Please leave your phone number & google hangout account to make a reservation.',
		cancelSuccess: 'Your reservation is cancelled. If you have any question, please contact our staff at +886 908959613 or <a class="underline" href="mailto:service@9floorspace.com">service@9floorspace.com</a>.',
		updateSuccess: 'Your reservation is updated. If you have any question, please contact our staff at +886 908959613 or <a  class="underline" href="mailto:service@9floorspace.com">service@9floorspace.com</a>.',
		recordIsEmpty: 'There is no record for any current appointments.'
	},
	settings: {
		welcomeText: 'Welcome! Complete the application materials to finish your membership application. Help us get to know you better.',
		deniedText: 'We are sorry to inform you that your application has not been approved. It is possible that the information submitted was incomplete or incorrect. Please feel free to submit another application or contact us.',
		notValidText: 'Uh oh. Your application materials are incomplete. Please complete all required fields.',
		notValidCertificate: 'Uh oh. Your personal information is incorrect. Please re-enter.',
		nameTooltip: 'Important Note: Please provide the name that appears on the official ID used for your application. This may be required to verify your identity at move-in.',
		sexTooltip: 'This information is only collected due to our dorm options, which sometimes have gender restrictions.',
		passportTooltip: "Important Note:If you don't have National Identification Card (Republic of China), please provide passport number for your application. This may be required to verify your identity at move-in.",
		skillsTooltip: '',
		presonalTooltip: 'Use 300 words or less to describe your personal story. Please include your hopes and expectations related to your participation in 9floor.',
		privacyTooltip: 'We encourage all residents to consider the advantage of making their information available to other residents. Sharing facilitates new friendships and connections.',
		nicknameTooltip: 'What would you like for other residents to call you?',
		avatarTooltip: 'Please upload a recognizable photo for verification.',
		introductionTooltip: 'Let your fellow residents get to know you better.',
		socialTooltip: '*Accounts must be verified, so please include at least one account for initial setup. After the verification processes, you can add more accounts.',
		addAvatar: 'Profile Picture',
		reviewUploadPhoto: 'Please upload a recognizable personal photo for review.',
		basicInformation: 'Basic Information',
		nameAlert: 'Important Note: Please provide the name that appears on the official ID used for your application. This may be required to verify your identity at move-in.',
		selectFile: 'Select File',
		passportType: 'Passport Type',
		passportNumber: 'Passport Number',
		name: 'Name',
		fullName: 'Full Name',
		sex: 'Sex',
		sexAlert: 'This information is only collected due to our dorm options, which sometimes have gender restrictions.',
		dateOfBirth: 'Date of Birth',
		selectBirthday: 'Birthday select',
		nationality: 'Nationality',
		selectNationality: 'Nationality select',
		passport: 'Passport',
		workingArrangements: 'Working Arrangements',
		jobTypes: 'Job types select',
		skills: 'Skills',
		skillTypes: 'Skills select',
		phoneNumber: 'Phone Number',
		personalIntroduction: 'Personal Introduction & Expections',
		words300: ' Use 300 words or less to describe your personal story. Please include your hopes and expectations related to your participation in 9floor.',
		communityProfile: 'Community Profile',
		privacySetting: 'Privacy Setting',
		privacyDetail: 'We encourage all residents to consider the advantage of making their information available to other residents. Sharing facilitates new friendships and connections.',
		nameForDisplay: 'Name (for display)',
		nickname: 'What would you like for other residents to call you?',
		company: 'Company',
		occupation: 'Occupation',
		selectOccupation: 'Occupation select',
		shortIntroduction: 'Short Introduction',
		words150: '150 words or less.',
		personalInterests: 'Personal Interests',
		interests: 'Interests select',
		website: 'Link Your Social Media and Website',
		music: 'Your Music',
		spotify: 'Search for your page',
		accountLink: 'Community Account Link',
		alertAccountLink: 'Accounts must be verified, so please include at least one account for initial setup. After the verification processes, you can add more accounts.',
		instagram: 'Your Instagram',
		instagramLink: 'Link to Instagram',
		save: 'Save',
		submit: 'Submit',
		FEMALE: 'Female',
		MALE: 'Male',
		OTHER: ''
	},
	bookingBar: {
		available: 'Available',
		notAvailable: 'Rented',
		canBooking: '可即刻入住',
		waitRelease: 'Coming Soon',
		releaseTime: '{{MM}}/{{DD}}/{{YYYY}}',
		month: 'month',
		view: 'Schedule a Property Viewing',
		book: 'Book Your Room',
		noBook: 'Rented',
		reserved: 'Reserved',
		continue: 'Renew Your Lease',
		checkout: 'Schedule a Checkout Appointment',
		reservedMessage: 'Tooltip: You have already reserved a {{eventType}} for this room. The appointment time is {{time}}',
		verifying: 'Property viewings are only available after all {{link}} has been received and processed.',
		verifyingData: 'application information',
		verifyingPending: ' Information Under Review: Application review requires two to three business days (weekends and national holidays are excluded). If your application result is overdue, please contact us.',
		verifyingDenied: 'Hello! Due to insufficient information, we are currently unable to process your reservation. We recommend you complete the membership application again and provide more information about yourself. We want to get to know you better.',
		excessUserReserve: 'You have exceeded your allotted number of property viewings for this month',
		excessRoomReserve: 'There are too many active reservations to view this listing. We recommend you choose another listing to view or add this listing to your favorites.',
		reject: 'Due to an apparent conflict between your behavior and the values of the 9floor community, effective immediately we will suspend your use of all member-related services.',
		notCertificated: 'Reserving rooms is reserved for certified members. For more details, please refer to our {{link}}.',
		viewIntro: 'Before scheduling a viewing, please review the following rules and guidelines:\n\n1. Changes and Cancellations:\na) If you need to change or cancel your appointment, please use the member page to submit your request at least 24 hours in advance.\nb) If you need to cancel at the last minute or will be late for your appointment, please call the staff person scheduled to meet you as soon as possible.\nc) If you do not show up for your appointment, you will be unable to schedule a viewing or reserve a room for the following two months.\n\n2. If the apartment you wish to view is reserved by another member prior to your appointment, you will be contacted of the change via email. If this change of status occurs within 24 hours of your appointment, we will notify you by phone.\n\n3. Every member is allowed three property viewings per month.\n\nPlease accept our invitation to explore 9floor and find your new home.',
		bookIntro: 'Living in our community will likely be slightly different than your previous rental experiences:\n\n1. 9floor use NewebPay as the payment platform. NewebPay is compatible with VISA, Mastercard, and JCB credit and debit cards.\n2. After receiving the order, 9floor will perform a final review of the invoice within 24 hours. If the personal information submitted does not match your membership information, 9floor reserves the right to cancel the order.\n3. After the order confirmation has been completed, we are unable to refund the administrative fee if you need to modify or cancel the reservation.\n\nReminders:\n1. Reserving a room is a limited service provided to members only. Your identity will be authenticated during the process. Do not use another person\'s account to make a reservation.\n2. If you are completing an order where there will be a second resident, please make sure the listing allows this type of arrangement. Additionally, please verify the accuracy of your order.\n\nIf you violate any of the guidelines above, your membership may be directly canceled. Please refer to our ',
		term: 'Terms of Residence',
		bookIntroEnd: ' for details.\nYou have three remaining steps before your reservation is complete',
		checkoutIntro: 'For checkout, please leave your personal space in the same condition/appearance as check-in. Be sure to remove all personal belongings and trash. The checkout process will be conducted in accordance with the ',
		checkoutTerm: 'terms of stay',
		checkoutIntroEnd: '. And last but not least, don’t forget to come back and visit everyone after moving out!',
		serviceGuide: 'service guide',
		start: 'Start Reservation',
		next: 'Next',
		renew: 'Renew Your Lease',
		renewIntro: 'Thank you for your continued support and participation.\n\nHere are some guidelines for lease renewal:\n\n1. The latest renewal date for your lease is {{renewDate}}\n2. Renewal will not incur administrative fees, final cleaning fees, or additional deposit. If the lease was originally for more than six months, your first renewal will be subject to the long-term rental price regardless of the length of the new lease period.\n3. If you would like to change your card payment preferences, you can modify your card settings after the order is completed on the order details page.',
		appointment: 'Schedule a Move-in Appointment',
		appointmentIntro: 'We are looking forward to your move-in day. Please set aside about one hour for the check-in process. One of our staff members will briefly meet with you to answer questions about the space, tell you more about the roommates, and go over a few details that we hope will help equip you to get connected quickly.'
	},
	booking: {
		notValidText: 'Uh oh. Your application materials are incomplete. Please complete all required fields.',
		notValidCertificate: 'Uh oh. Your personal information is incorrect. Please re-enter.',
		notAcceptText: 'Uh oh. Please check the terms of stay.',
		notAcceptInsuranceText: 'Uh oh. Please check the insurance policy.',
		notValidFormat: 'Uh oh. Your application materials is wrong. Please confirm all required fields.',
		empty: 'There is no record for this reservation.',
		notValidCreditNumber: 'The credit card information is incorrect.',
		notValidCreditDate: 'The expiration date is incorrect.',
		notValidCreditCVC: 'The security code is incorrect.',
		expiredCreditCard: 'Credit card authorization failed.'
	},
	bookingOrder: {
		invoiceInformation: 'Invoice Information',
		bookingTimezone: 'GMT+8 time',
		orderStartDate: 'Lease Start Date',
		leaseEnd: 'Lease ends in (month)',
		leaseEndPlaceholder: 'Lease ends in (month)',
		longTermRentalPrice: 'Long-term Rental Price: NTD {{rent}}/month',
		middleTermRentalPrice: 'Short-term Rental Price (3-5 months): NTD {{rent}}/month',
		shortTermRentalPrice: 'Short-term Rental Price (1-2 months): NTD {{rent}}/month',
		optionalItems: 'Optional Items',
		itemizedInvoice: 'Itemized Invoice',
		orderDate: 'Order Information:',
		roomName: 'Listing:',
		address: 'Apartment Address:',
		orderStartFrom: 'Order Start Date:',
		orderStartTo: 'Order Expiration Date:',
		next: 'Next'
	},
	bookingRent: {
		initialPayment: 'Initial Payment',
		monthlyPayment: 'Standard Monthly Payment',
		totalMonth: '{{count}} Month',
		totalMonth_plural: '{{count}} Months',
		total: 'total',
		deposit: 'Deposit',
		monthlyPrice: '{{price}} NTD/month',
		depositDescription: 'The lease deposit is equivalent to two-months rent.',
		administrativeFee: 'Administrative Fee',
		paymentDetail: 'Detail',
		administrativeFeeDescription: 'When the first lease for each room is completed by the member resident, an administrative fee of NT$1,500 will be charged for lease processing. If the member resident renews the lease of the same room without any interruption between the two lease periods, the member resident will not be required to pay the administrative fee at the time of renewal. Any change made to the room reservation during the lease term shall be processed with an administrative fee of NT$1,500.',
		cleaningFee: 'Cleaning Fee',
		cleaningFeeDescription: '1.To ensure a good move-in experience and reduce checkout worries every room is professionally cleaned during a resident change. During checkout, you just need to remove all personal items and trash. We will take care of the rest.\n2.When the first lease for each room is completed by the member resident, a checkout cleaning fee of NT$1,500 shall be charged. If the member resident renews the lease of the same room without any interruption between the two lease periods, the member resident will not be required to pay the checkout cleaning fee at the time of renewal.',
		petCleaningFee: 'Checkout Cleaning Fee for Pets',
		petCleaningFeeDescription: 'A pet checkout cleaning fee of NT$1,000 will be charged if a member resident keeps pets. The payment amount will be collected when the first lease for each room is completed by the member resident. If the member resident renews the lease of the same room without any interruption between the two lease periods, the member resident will not be required to pay the pet checkout cleaning fee at the time of renewal.',
		monthlyRent: 'Monthly Rent',
		monthlyRentDescription: 'The monthly rent is deducted on a fixed date every month.',
		serviceFee: 'Service Fee',
		serviceFeeDescription: 'The service fee is the sum of both cleaning fees and the garbage disposal service fee for the space shared by member residents.',
		energyPrice: 'Utility Fee',
		energyPriceDescription: 'The utility fee is the cost of utility services for the living space shared by the member residents. This includes water, electricity, natural gas, and internet fees.',
		petDescription: '1.Member residents may keep pets in spaces designated as appropriate by 9floor. Each member resident is limited to keeping only one pet in the premises of 9floor. This single pet may be a dog or cat (other pet types must be approved by 9floor).\n2.The member resident checking-in with a pet shall pay an additional NT$1,500 per month. Guide dogs are not subject to such requirement or the additional charge stated in the preceding sentence.',
		extraPersionDescription: '1.The member resident is prohibited from checking-in with an unsanctioned roommate. If the member resident has a guest for more than 10 days within one month, 9floor may choose to terminate the lease contract at any time, or alternatively may require the member resident to pay an additional NT$2,000 per month for the second resident.\n2.The second resident is also required to abide by the terms of service agreement.'
	},
	roomFilter: {
		select: 'Select ',
		city: 'City',
		neighborhood: 'District',
		MRT: 'MRT Station',
		MRTLine: 'MRT Line',
		surroundingMRT: 'Include surrounding MRT stations',
		station: '{{station}} Station',
		line: '{{line}} Line',
		type: 'Room Type',
		anticipatedMovein: 'Expected Move-in date',
		chooseMonth: 'Choose a Month',
		monthlyRent: 'Monthly Rent',
		limit: 'Minimum/ Maximum',
		particularApartment: 'Particular Apartment',
		chooseApartment: 'Apartment',
		advancedSearch: 'Advanced Search',
		size: 'Room Size',
		twoResidents: 'Two Residents',
		all: 'All',
		allowed: 'Allowed',
		notAllow: 'Not Allowed',
		pets: 'Keeping Pets',
		special: 'Special Features',
		showUnavailable: 'Include Rooms not Currently Available',
		clear: 'clear'
	},
	roomType: {
		MEN_LIVING: 'Male Dormitory Room',
		WOMEN_LIVING: 'Female Dormitory Room',
		CO_LIVING: 'Mixed Dormitory Room',
		ROOM: 'Private Room (shared bathroom)',
		STUDIO: 'Suite'
	},
	roomStatus: {
		RENTED: 'Rented',
		AVAILABLE: 'Coming Soon',
		FULL: 'Available'
	},
	room: {
		additional: 'Initial Payment',
		monthAdditional: 'Monthly Payment',
		deposit: 'Deposit',
		monthlyRent: 'Monthly Rent',
		energyPrice: 'Utility Fees',
		energyPriceDescription: 'The utility fee is the cost of the living space shared by the member residents, including: water, electricity, natural gas, and internet fee.',
		serviceFee: 'Service Fee',
		serviceFeeDescription: 'The service fee is the cleaning fee and garbage disposal service fee for the space shared by the member residents.',
		shortRent: 'Short-term Rent',
		shortTerm: 'Short-term',
		month: 'month',
		info: 'Room Info',
		apartmentInfo: 'Apartment Info',
		type: 'Room Type',
		size: 'Size (Area)',
		ping: 'ping',
		amenities: 'Amenities',
		apartmentAmenities: 'Apartment Amenities',
		neighborAmenities: 'Neighborhood Amenities',
		transportation: 'Transportation Info',
		recommended: 'Recommended Listings',
		recommendedApartment: '附近公寓',
		balcony: 'Balcony',
		kitchen: 'Kitchen',
		sharedBathrooms: 'Shared Bathroom',
		bedrooms: 'Bedrooms',
		totalFloors: 'Total Number of Floors',
		elevator: 'Elevator',
		cleaningService: 'Cleaning Service',
		garbageDisposal: 'Garbage Disposal',
		more: 'More',
		yes: 'Y',
		no: 'N',
		roomSize: ' m²',
		floor: ' floor',
		room: '',
		hasPet: 'Pets Allowed',
		roommate: 'Roommate'
	},
	rooms: {
		UpToDate: 'Update Time',
		HighestPrice: 'Highest Price First',
		LowestPrice: 'Lowest Price First',
		location: 'location',
		price: 'price',
		advancedSearch: 'Advanced Search',
		results: 'results',
		SortBy: 'Results sorted by',
		More: 'More'
	},
	roomComponent: {
		photos: 'More photos'
	},
	userTabs: {
		overview: 'Overview',
		settings: 'Settings',
		favorites: 'Wishlist',
		viewingHistory: 'Property Viewing Record',
		reservationHistory: 'Reservation History',
		request: 'Contact Us',
		onlineCommunity: 'Community'
	},
	userOverview: {
		welcom: 'Welcome! Complete the application materials to finish your membership application. Help us get to know you better.',
		account: 'My Account',
		editProfile: 'Edit Profile',
		currentOrder: 'Current Reservation',
		checkinTime: 'Comfirm Move-in Time',
		details: 'View Details',
		recent: 'Recent Appointments',
		incomplete: 'Uh oh.Your application is still incomplete. Go to the setup page to complete the information and re-submit the application.',
		underPreview: 'Your application information is under review.',
		reject: 'We are sorry to inform you that your application has not been approved. It is possible that the information submitted was incomplete or incorrect. Please feel free to submit another application or contact us.',
		needCheckin: 'Your move-in day is coming soon. Please remember to reserve your move-in appointment before {{startDate}}.',
		needCheckout: 'Time flies! Your official checkout date is soon. Please remember to book your checkout appointment before {{endDate}}.',
		reserveMovein: 'Reserve Your Move-in Time',
		reserveCheckout: 'Reserve Your Checkout Time',
		member: 'Member'
	},
	bookingRecordCard: {
		address: 'Address',
		date: 'Order Date',
		moveinTime: 'Move-in Time',
		moveinAppointment: 'Schedule Move-in Appointment',
		checkoutAppointment: 'Schedule Check-out Appointment',
		renew: 'Renew Order',
		changeOrder: 'Change Your Order',
		download: 'Invoice Download ',
		changePayment: 'Update Payment Method',
		review: 'Review',
		cancel: 'Cancel'
	},
	bookingPayment: {
		DONE: 'Paid',
		NEXT: 'Next Payment',
		WAIT: 'Outstanding Payable',
		paymentHistory: 'Payment History',
		initialPayment: 'Initial Payment',
		total: 'Total:'
	},
	certificateType: {
		IDENTITY: 'Identity',
		PASSPORT: 'Passport',
		userAddress: 'Address',
		userAddressTooltip: 'Home address',
		certificateData: 'Official Document',
		extraCertificateData: 'Additional Residents',
		certificateDescription: 'Please provide a copy of a current official document. The name listed must match the information previously provided.',
		certificateField: 'ID or Passport number.',
		emergencyName: 'Emergency Contact Person',
		emergencyTelephone: 'Phone Number of Emergency Contact Person',
		emergencyRelationship: 'Relationship',
		emergencyAddress: 'Address of Emergency Contact Person',
		selectFile: 'Select File',
		passportType: 'Document Type',
		passportNumber: 'ID Number',
		passportNumberTooltip: 'ID or Passport number.',
		basicInformation: 'Basic Information',
		communityProfile: 'Community Profile',
		name: 'Name',
		fullName: 'Full Name',
		sex: 'Sex',
		dateOfBirth: 'Date of Birth',
		nationality: 'Nationality',
		workingArrangements: 'Working Arrangements',
		skills: 'Skills',
		phoneNumber: 'Phone Number',
		personalIntroduction: 'Personal Introduction & ',
		expections: 'Expections',
		back: 'Go Back',
		next: 'Next',
		term: 'Terms of Residence',
		agreeTerm: 'I have read and understood the terms of residence',
		insurance: 'Insurance Policy',
		insuranceContent: 'I understood and agree that 9floor will insure for accidents resulting from equipment failure within our facilities and fire/earthquake damaged for all roommates thus we will use the information provided above, including passport number, date of birth, home address and contact number. Note: There is not extra charge for the insurance.',
		agreeInsurance: 'I have read and understood the insurance policy'
	},
	modalLoginSignup: {
		forgetPasswordSendSuccess: 'An email has been sent to {{email}}. Please check your inbox.',
		verifySuccess: 'Email verification successful! Please fullfill your personal information to complete the application.',
		welcomeBack: 'Welcome Home, 9floor Member.',
		SignupLoginFail: 'Uh oh. Your account information is incorrect. Please re-enter.',
		verifyEmailFail: 'The Email is not correct.',
		verifyPasswordFail: 'Passwords must be at least 8 characters in length, including both characters and numbers.',
		verifyCheckPasswordFail: 'The passwords do not match.',
		verifyAgree: 'To complete the registration, you must agree to the Terms of Service.',
		verifyFail: 'You have not yet verified your email address. Click below to resend the verification email.',
		vipTokenFailed: 'The verification code is incorrect. Please signup directly or contact us. (Phone Number:+886 908959613)',
		agree: 'Agree to the',
		termsofService: 'Terms of Service',
		register: 'Register a New Account',
		already: 'Already registered?',
		loginNow: 'Login Now',
		successful: 'Registration Successful',
		verification_email: 'To ensure uninterrupted service, please respond to your verification email.',
		back: 'Back to Home',
		resend: 'Resend Verification',
		rememberMe: 'Remember me',
		login: 'Login',
		forgot: 'Forgot your password?',
		reset: 'Reset Here ',
		not_a_member: 'Not a member yet?',
		application: 'Submit an Application',
		resetPw: 'Forgot your password? No worries. Reset it now',
		send: 'Send',
		newPassword: 'Set Your New Password',
		placeholder1: 'New Password',
		placeholder2: 'New Password Confirmation',
		becomeResident: 'Become a 9floor resident. Explore the city and share life together.',
		young: '年輕漂泊，',
		year: '最美好的那幾年。'
	},
	about: {
		bannerTitle: 'About',
		title1: 'Urban community for the future',
		title1Split1: 'Urban community',
		title1Split2: 'for the future',
		describe1: 'In 2015 we started 9floor Coliving by renovating ten different urban apartments. In addition to private rooms, we created semi-public common spaces filled with the warmth of home. Our comfortable but minimal interiors attracted our first residents: students, office workers, freelancers, and internationals. Through our unique community-oriented business model, we are able to provide high-value housing to our residents. Our prompt and professional management also greatly benefits property owners. We work to activate urban spaces to their fullest potential for the benefit of both our residents and the surrounding community.',
		title2Split1: 'Not just space- A hub',
		title2Split2: 'for connecting',
		title2Split3: 'Not just space-',
		title2Split4: 'A hub for connecting',
		describe2: 'Through space design, management services, and our membership system, 9floor provides superior living experiences tailored for today’s urban environment. Coworking, social events, communal meals, and events organized in conjunction with local cultural organizations occur regularly. Through the sharing spirit of coliving new connections are formed.',
		title3Split1: 'Humanizing the alienating cityscape-',
		title3Split2: 'Creating a new lifestyle',
		describe3: 'In addition to our housing options for young people, 9floor has sought out opportunities to create new models meeting the particular needs of other age groups. Examples include intergenerational housing projects and new options in development for individuals already well-established in their adult lives. These projects have significant challenges, but we are motivated by our commitment to create a friendlier, more livable city.',
		qouteblock: 'Become a part of our community. Try out the best lifestyle for today’s urban environment.',
		moreButton: 'Learn more'
	},
	bookingFinish: {
		congratulations: 'Congratulations!',
		content: 'Your move-in appointment request has been received. We will review your request and confirm with you as soon as possible. Thank you again for scheduling an appointment. We look forward to seeing you at 9floor!',
		checkDetails: 'Check Reservation Details',
		returnToRoom: 'Return to Property Description'
	},
	page404: {
		headerText: 'The requested page does not exist.',
		paragraph: 'Error code: 404',
		buttonText: '9floor Home'
	},
	contact: {
		contact: 'Contact',
		support: 'Support',
		message: 'Leave a note to help us improve our service. ',
		request: ' Fill out a residential service request. ',
		inquiries: 'For all other inquiries please contact us at {{link}}',
		contactUs: 'Contact us',
		respond: 'Issue Report',
		property: 'Property Partner',
		propertyDescription: ' If you are seeking property management services, please provide {{link}} and any special considerations. We will contact you as soon as possible',
		work: 'Work Partner',
		workDescription: 'Join our management team. Please see {{link}}.',
		investment: 'Investment Partner',
		investmentDescription: 'If you are interested in providing a helping hand as we reshape the property rental industry, please contact us at {{link}}',
		media: 'Media',
		mediaDescription: 'For more information, please refer to our {{link}} page.',
		cooperation: 'Cooperation',
		cooperationDescription: 'Please provide {{link}}. We will contact you as soon as possible.',
		consulting: 'Consulting Services',
		consultingDescription: 'For space planning services, please provide {{link}}. We will contact you as soon as possible.',
		space: 'basic information about the property',
		teamPage: 'Team',
		mediaPage: 'Media',
		proposal: 'basic information related to your proposal',
		become: 'Become Our Partner'
	},
	service: {
		serviceGuide: 'Service Guide',
		member: '1. 9floor Membership',
		suTitle1: 'Why become a resident member?',
		description1: 'We continually work to improve our coliving and share spaces. However, we also understand that coliving lifestyles are not suitable for all. We strive to maintain a community that values intellectual freedom and diversity. Consequently, our process for resident selection may be different than what you expect. Once you have gone through the selection process, you become a community member. At different stages, you gain access to different services. These include community activities, the use of community space, the ability to reserve a room, etc.<br />As we continue to develop, we are constantly broadening our digital services. We are committed to the realization of a truly integrated online and offline shared community.',
		blockquoteTitle1: 'Our Ideal Residents',
		blockquoteList1: '1.Embrace the principles of {{link}} and community culture',
		blockquoteList2: "2.Willingly respect our diverse community's multifaceted nature",
		blockquoteList3: '3.Happily share, and work together within the community to grow',
		blockquoteList4: '4.Accept challenges and solve problems',
		blockquoteList5: '5.Are approachable, but committed to living intentionally',
		formTitle: 'Levels and Permissions',
		rowTitle1: 'Membership Level',
		rowTitle2: 'Method for Leveling Up',
		rowTitle3: 'Privileges/Service Items',
		rowTitle4: 'Explanation',
		columnTitle1: 'L1-Basic Member',
		column1Row1: 'An invitation letter will be sent out after the online application is reviewed.',
		column1Row21: '1.Room Viewings: 3 times per 30 days',
		column1Row22: '2.Online Community Newsletter',
		column1Row23: '3.Community Activities',
		column1Row3: 'We invite all who value diversity to apply for our basic membership. Services include the ability to schedule property viewings, and a newsletter to keep you up to date on our latest activities. Become a key player in our community. ',
		columnTitle2: 'L2-Certified Member',
		column2Row1: 'After the member has participated through property viewing, an online interview, and/or community activities an invitation to become a certified member will be generated.',
		column2Row21: '1.Free Room Viewings: 3 times per 30 days',
		column2Row22: '2.Online Community Newsletter',
		column2Row23: '3.Community Activities',
		column2Row24: '<b>4.The ability to immediately reserve a room</b>',
		column2Row3: 'In order to maintain a diverse community that values respectful, we have created a process to help ensure that your personal philosophy and behavior are accommodating toward other members. We will send invitation letters to suitable candidates based on their interview and any other relevant communication. Once you are upgraded to certified member, you can book your desired room at any time!',
		columnTitle3: 'L3- Resident Member',
		column3Row1: 'Moving into a 9floor room.',
		column3Row21: '1.Free Room Viewings: 3 times per 30 days',
		column3Row22: '2.Online Community Newsletter',
		column3Row23: '3.Community Activities',
		column3Row24: '4.The ability to immediately reserve a room',
		column3Row25: '<b>5.Exclusive discounts at preferred partner vendors</b>',
		column3Row26: '<b>6.Full access to online community features</b>',
		column3Row3: 'After becoming a resident, you can enjoy exclusive benefits such as exclusive discounts, dedicated customer service, and online community features. As a resident, your community is not only within your individual apartment but instead spread throughout our entire shared community.',
		reservationExpantation: '2. Online Property Viewing Reservation Process',
		description21: 'Property viewings, inquiries, interviews, move-in, and check-out are all facilitated through our online reservation system.',
		description22: 'Reserving a property viewing is open to <b>all members (basic and above)</b>. Members have the opportunity to reserve three viewings per month. The reservation process is described below:',
		description23: 'Step 1: Find an apartment you like, and click to select.',
		description24: 'Step 2: Select your preferred time slot, and submit your reservation request.',
		description25: 'Step 3: You should receive details confirming your appointment.',
		blockquoteTitle2: 'Change/Cancellation Policy:',
		blockquoteList21: '1.Changes/cancellations must be submitted via the online member page at least 24 hours in advance of the scheduled appointment.',
		blockquoteList22: '2.If you are suddenly unable to attend or will be late to the appointment, please call the staff scheduled to meet with you.',
		blockquoteList23: '3.If you fail to inform us you will be late or completely miss an appointment, you will be unable to reserve property viewings or directly book apartments for the following two months.',
		blockquoteList24: '4.If another potential resident signs a lease for the property before you are able to view it, we will notify you of the change by email. If this change occurs within 24 hours of your scheduled viewing, we will notify you by phone.',
		bookingExpantation: '3. Online Room Reservation Process',
		description31: 'The online room reservation option is reserved for <b>certified members</b>',
		blockquoteTitle3: 'Complete your room reservation in six steps:',
		blockquoteList31: 'Step1: Click “Reserve” on the room page to start your reservation.',
		blockquoteList32: 'Step2: Carefully confirm the room information and review the terms of stay.',
		blockquoteList33: 'Step3: Complete verification of your payment method.',
		blockquoteList34: 'Step4: After you complete the online reservation process, we will review your information within one working day to confirm that all information is complete.',
		blockquoteList35: 'Step5: After the reservation is approved, you may schedule your move-in appointment.',
		blockquoteList36: 'Step6: A staff member will help you check-in.',
		description32: 'Basic members who have scheduled {{link}}, completed their introductory interview, and participated in community activities are eligible to be considered for <b>certified member</b> status. We will upgrade members based on their participation, suitability, and interest. Please refer to the certified member description for more information.',
		description33: 'Room reservation is only for members. If you use other people’s accounts to reserve a room, we reserve the right to cancel the reservation and membership. Please refer to our {{link}} for details.',
		payRefundExpantation: '4. Financial Withholding and Refund Policy',
		description41: '9floor use NewebPay as the payment platform. NewebPay is compatible with VISA, Mastercard, and JCB credit and debit cards.',
		blockquoteList41: '1.After setup is complete, your account will be automatically debited every month. If necessary, you can check your transaction history at any time via the member page.',
		blockquoteList42: '2.Monthly rent deduction will occur on your lease start date.',
		blockquoteList43: '3.Other than the initial deposit, we will not place any advance holds on your account.',
		blockquoteList44: '4.If necessary, you have the option to change your preferred account.',
		blockquoteList45: '5.If you use an international (non-Taiwanese) card, your transaction may be subject to exchange and service fees. Check with the account provider for details.',
		onlineCommunityRule: '5. Online Community Rules',
		description51: 'The online community is our latest feature for resident members. Go to your member settings page to fill out interest tags, link your Instagram connection, share your favorite music, and further customize your settings. If you choose to set your privacy preferences to open you will have more opportunities to connect with other residents.',
		description52: 'As a platform for community interaction, there are still some guidelines that everyone needs to follow. Multiple violations could possibly be considered grounds for eviction. Please refer to our {{link}} for details.',
		blockquoteTitle5: 'The following behavior is prohibited:',
		blockquoteList51: '1.Malicious targeting and bullying are strictly forbidden.',
		blockquoteList52: "2.Do not share other people's personal details or contact information.",
		blockquoteList53: '3.Gossip: Shared community does not make the discussion of other residents’ private lives permissible.',
		blockquoteList54: '4.Disrespectful comments: Maintain good relationships with residents, neighbors, and the community.',
		blockquoteList55: '5.Discrimination: It is forbidden to discriminate on the basis of religion, gender, sexuality, ethnicity, or financial means.',
		blockquoteList56: '6.Sexual harassment is strictly forbidden.',
		coliving: 'coliving',
		property_viewings: 'property viewings',
		certified_members: 'certified members',
		terms_of_stay: 'terms of stay'
	},
	printOrder: {
		reservation: 'The Contract Agreement was sent to the member resident on {{link}} . (a reasonable period of at least 3 days must be given to consumers for them to review the contract terms.)',
		printButton: 'print',
		invoiceInformation: 'Invoice Infomation',
		orderDate: 'Order Date',
		room: 'Room',
		apartmentAddress: 'Apartment Address',
		movieInDate: 'Movie-in Date',
		checkoutDate: 'Check-out Date',
		termsOfService: 'Terms of Service',
		description: 'This Agreement is entered into between the Tenant ( referred to as “{{link}}” hereinaftert) and the sublessor (referred to as “9floor” hereinaftert). In consideration of the mutual covenants regarding the leasing of the premises, the parties hereby agree as follows:',
		companyInformation: 'Information of 9floor',
		companyName: 'Name of Company',
		companyNameValue: '共宅一生股份有限公司',
		companyResponsible: 'Name of Representative',
		companyResponsibleValue: '潘信榮',
		companyNo: 'VAT Number',
		RegistrationCertificateNumber: 'Certificate Number',
		RegistrationCertificateNumberValue: '(107) 北市租登字第0003號',
		companyAddress: 'Location of Company',
		companyAddressValue: '2F., No.119, Sec. 2, Xinhai Rd., Da’an Dist., Taipei City 106, Taiwan (R.O.C.)',
		user: 'Customer Info.',
		userName: 'Name',
		userBirthday: 'Birthday',
		userType: 'Type of ID',
		userNumber: 'ID number',
		userTelephone: 'Telephone',
		userAddress: 'Address',
		emergencyContact: 'Emergency Contact',
		emergencyName: 'Name',
		emergencyTelephone: 'Telephone',
		emergencyAddress: 'Address',
		emergencyRelationship: 'Relationship',
		manager: 'Manager of Rental Management',
		name: 'Name',
		certificateNumber: 'Certificate Number',
		residentAddress: 'Location of Company',
		residentAddressValue: 'No.64, Sec.3, Heiping W. Rd., Wanhua Dist., Taipei City',
		phoneNumber: 'Contact Number',
		mailAddress: 'Email'
	},
	termsOfService: {
		serviceTerms: 'Service Clause',
		paragraph1: 'Welcome to 9floor Coliving',
		paragraph2: '9floor is a rental housing service registered under the Republic of China Residential Law.We provide services such as space management and planning to the residents of the Republic of China.The following use of “this website” refers to, but is not limited to websites with Japanese or Taiwanese domains, including new or modified websites.',
		paragraph3: 'The following use of “this website” refers to, but is not limited to websites with Japanese or Taiwanese domains, including new or modified websites.',
		paragraph4: 'The company team will provide services and information to customers in accordance with the following stipulations ("the Terms of Service“).',
		paragraph5: 'If the customer uses 9floor, they will be deemed to have agreed to the Terms of Service. Please read these terms carefully. ',
		paragraph6: 'In addition, if the customer will use the current or future services of 9floor, link to the website of the partner businesses or purchase goods, regardless of whether the website contains this information, the guidelines for utilization of the service or business shall be followed.',
		paragraph7: 'If any usage guidelines or service descriptions are different from the contents of these Terms of Service, the policies herein take precedence.',
		title1: 'Regarding Privacy',
		paragraph8: 'The privacy policy applies to customers when they use the property.',
		paragraph9: 'Please carefully review the following policies.',
		title2: 'Electronic Communication',
		paragraph10: 'If the customer uses 9floor or sends an e-mail to 9floor, this is considered to be electronic communication.',
		paragraph11: 'The customer agrees in advance that all e-mail notification sent to the address registered by the customer or posted notices on the website or other means of communication through the website serves as a means of business notification or advertising that is a part of 9floor’s service. The customer shall agree that 9floor’s provision of electronic notices, information disclosures, or other communications to the Client shall serve as legal written notice.',
		title3: 'Copyright',
		paragraph12: 'All content provided by 9floor (including but not limited to text, graphics, layouts, logos, button icons, images, videos, audio clips, and all other digital content) is protected by Republic of China, Japanese, and international copyright laws. All written content is protected by Republic of China, Japanese, and international copyright laws. It is forbidden to reproduce the information and media provided by 9floor without permission.',
		title4: 'User License and Linked Content',
		paragraph13: 'As a condition of compliance with these terms of service 9floor grants users the personal (non-transferable) right for limited, non-exclusive, non-commercial use of our content. The license for use does not include rights for resale or any other use of content for commercial purposes. The collection and use of product forms, comments, prices, etc. as well as personal user account information is strictly forbidden. The use of data collection and extraction tools, data mining, bots, etc. is strictly forbidden.',
		paragraph14: 'The rights not expressly granted by these terms of service or other terms of service are reserved by 9floor or its licensors, suppliers, publishers, rights holders, or other content rights holders. Copying, printing, selling, re-selling, linking or any other unsanctioned use of content for commercial purposes is strictly forbidden without express written permission. The company logo and all other creative/intellectual property (including but not limited to images, text, page layout, form, etc) shall not be used or replicated without express written permission. Improper use of 9floor and violation of these terms of services may be punishable by law. Additionally, 9floor reserves the right to refuse service or cancel service based on violations of these terms. This decision is made at 9floor’s discretion.',
		title5: 'Account Security',
		paragraph15: 'When using this website, maintaining the confidentiality of the your account and password, and restricting connection to the computer you use to access your account is solely the responsibility of the user. The customer is responsible for any improper use of the account by a third party. In addition, if the customer leaks the account and password information to a third party or has information stolen, they should contact 9floor as soon as possible. 9floor may, at our sole discretion, stop or terminate the use of the account and password on this website without prior notice. Regardless of whether the issue is due to customer error, if the account and password are stolen or lost this may result in temporary suspension of use or termination of your account on the website. All expenses incurred by the temporary account suspension or account termination (including but not limited to investigation costs, countermeasures against recurrence, lawyer fees, customer complaints, etc.) are the responsibility of the customer and will not be repaid by 9floor.',
		paragraph16: ' We reserve the right to refuse service, stop accounts, delete and edit content, and change or cancel activities solely based on our own discretion and without notice.',
		title6: 'Registration Information Changes',
		paragraph17: 'If your preferred email or other contact information has changed, the information should be updated in a timely manner. 9floor is not responsible for the inability to obtain service resulting from failure to provide accurate contact information or other registration matters.',
		title7: 'Unaccompanied Minors',
		paragraph18: 'If a customer is determined to be a minor according to the law of their home country or territory, they must register with parental consent (or the consent of another functioning legal representative). If it is determined that no consent has been obtained, 9floor reserves the right to immediately refuse to provide service and suspend the account.',
		title8: '評價、留言、通訊、其他內容物',
		paragraph19: '利用玖樓之客戶得進行留言、貼圖或其他內容物之發文、傳送提案、想法、意見、問題或其他資訊。但該等內容包括違反法令、猥褻、脅迫、毀損名譽、侵害隱私權、侵害智慧財產權、毀謗中傷第三人、令人感到不悅、或軟體病毒、政治主張、商業目的之勸誘、連鎖信、大量發信或所謂「垃圾信」，以及違反刑法第360條者，則不在此限。不得使用虛偽之EMAIL信箱、冒充他人或組織、其他內容物之出處進行招致誤解之行為。玖樓保有將該等內容刪除或編輯之權利（並非義務），但並非定期確認發文內容。',
		paragraph20: '客戶進行內容物之發文或傳送素材時，除非本網站明示其他決定，應視為客戶授予玖樓使用、重製、變更、改作、公開、翻譯該等內容物、作成、散布第二次著作物、得以所有媒體型態向全世界表示其為非獨占性、無償、永續性、無法取消、包括完整再授權之權利。客戶於玖樓與被轉授權人希望時，視為客戶就該等內容物對其授權使用客戶發文名稱之權利。此外，客戶不得對玖樓或玖樓再授權之第三人行使著作人格權。客戶應聲明、保證保有或管理自身發文內容物相關所有權利、該內容物係屬正確、所提供內容物之使用並未違反此政策、未傷害任何他人或組織、就起因於其提供之內容物之所有請求向玖樓提出補償。玖樓不保證確實記錄或保存發文之資訊或素材。縱使該等資訊或素材之全部或部分消失、變樣或外流，無論其原因為何，玖樓概不負責。玖樓保有監視、編輯或刪除任何行為或內容物之權利，但並無義務。玖樓對於客戶或第三人發文之任何內容物亦不負責，未生義務。',
		title9: '侵害智慧財產權之相關聲請',
		paragraph21: '玖樓尊重他人智慧財產。經判斷客戶之著作物於本網站上，遭以如構成侵害著作權或智慧財產之方法複印或使用時，請依玖樓適當指定之智慧財產權侵害相關聲請程序，提出聲請。',
		title10: '商品及服務說明',
		paragraph22: '玖樓將致力於盡可能保持正確性。但玖樓不保證商品説明或本網站其他內容正確、完整、具信賴性、為最新內容、或係為無誤。',
		paragraph23: '請留意本項規定僅適用於玖樓所介紹之商品。',
		title11: '得利用玖樓之軟體條件',
		paragraph24: '利用玖樓時，推薦以下瀏覽器之最新版本。',
		paragraph25: 'Google Chrome',
		paragraph26: 'FireFox',
		paragraph27: 'Safari',
		title12: '由第三人提供',
		paragraph28: '玖樓不對身為第三人之企業或個人、第三人之行為、商品、內容物負任何責任，亦不產生義務。建議請仔細閱讀各公司之隱私權相關文件與利用規約。',
		title13: '免責事項',
		paragraph29: '除非另有書面規定，客戶得透過玖樓及本網站利用之所有資訊、內容物、素材、商品（包含軟體）及其他服務，玖樓以「現狀之原有狀態」及「得提供之限度」提供之。玖樓除非另有書面規定，就玖樓之營運或本網站或玖樓所登載資訊、內容物、素材、商品無論其為明示或黙示，不為任何種類之聲明與保證。並視為客戶已明示同意以自身責任利用玖樓。特別就本網站保存之資料消失，或伺服機運轉停止所發生之客訴、爭議、損害賠償請求等情況之一切損害、責任，視為已明示同意免除玖樓責任。',
		paragraph30: '玖樓並未就客戶透過玖樓及本網站得以利用之所有資訊（以下簡稱「提供之資訊」。）相關商品或服務之購買、出售、持有或利用、或該等申請（以下統稱「購買等行為」。）為任何推薦。',
		paragraph31: '關於提供之資訊內容可能隨時變化，故請客戶勿全面依據提供之資訊，而係依自身判斷進行購買商品或服務等行為。無論其是否經由本網站，玖樓就客戶所為之商談或契約並非當事人，亦不對商議業務予以對應，且概不負責。',
		paragraph32: '玖樓不介入以利用本網站為契機發生之所有客戶間之協商、交易。就客戶間之交易所發生各種作業、連絡、法律義務之履行及問題處理等，應由客戶間負責為之。就起因於利用本網站為契機所為交易之損害，及起因於揭露提供之資訊一事本身之損害，玖樓概不負責。',
		paragraph33: '玖樓就得透過本網站連結或取得之產品或服務，於適用之法律所認可之範圍內，無論其為明示或默示，不為一切保證（包括但不限於未違反特定目的，及就該目的具市場性或合適性者。）。玖樓不保證資訊、內容物、材料、商品（包含軟體）、包含於玖樓其他服務或由其提供之服務、伺服器、由玖樓寄送之EMAIL，未感染病毒或其他有害因子。',
		paragraph34: '玖樓對於使用玖樓所生之任何種類之損害，包含但不限於直接、間接、附隨、懲罰性、必然性之損害亦不負責。',
		title14: '準據法',
		paragraph35: '利用玖樓時，視為已同意無論法律牴觸原則為何，以中華民國國內法規範利用此規約，以及客戶與玖樓或支援玖樓之企業間可能發生之，與玖樓有關之所有類型爭議。',
		title15: '爭議',
		paragraph36: '關於連結至本網站以及利用規約相關之爭議，除法律認可之管轄法院外，附加指定台北地方法院為合意管轄法院。但關於身為企業經營者之客戶，指定台北地方法院為專屬之合意管轄法院。',
		title16: '網站之營運方針、變更、可分性',
		paragraph37: '詳閱登載於本網站關於價格等事宜之本網站營運方針。該等方針亦就客戶利用玖樓一事予以規範。玖樓保留得隨時變更本網站、營運方針、利用規約之權利。該規約之一部分為不當或無效、或因任何理由而無法施行時，該規約視為可分，不影響此部分以外規約之有效性及拘束力。',
		title17: '關於本網站之營運母體',
		paragraph38: '本網站由玖樓團隊進行管理營運。就本規約中規定玖樓得持有或行使之一切權限及權利暨免責事項，以及支援玖樓之企業或其從業人員得行使或為主張。',
		title18: '詢問信箱',
		paragraph39: 'EMAIL: support@9floor.co',
		title19: '個人資料保護方針',
		paragraph40: '各位客戶您好:<br />關於此文件，請於提供玖樓個人資料前閱讀一遍。於您同意後，將提供個人資料所伴生之各種服務。',
		subTitle1: '1. 個人資料之收集、處理及利用目的',
		listDescription1: '・本服務就所取得之客戶個人資料，將以下揭目的（以下簡稱「利用目的」）利用之。',
		listTitle1_1: '(1)  本服務會員身份之利用',
		listItem1_1: '・作為註冊本服務會員利用服務時之登入時及登入後之身份認證、各種畫面中之會員資料自動顯示。',
		listTitle1_2: '(2)  本服務所提供交易之完成',
		listItem1_2: '客戶參加抽獎、線上報名等活動、回應客戶所詢問題、由本服務向客戶提出詢問、相關售後服務、其他完成交易所需業務。',
		listTitle1_3: '(3)  本服務之廣告宣傳或行銷等',
		listItem1_3_1: '・提供客戶各種電子報等資訊。',
		listItem1_3_2: '・以電子郵件、郵寄信件、電話等提供服務相關資料。',
		listItem1_3_3: '・對於客戶瀏覽之內容物或廣告依客戶之性別、年齡、居住地、興趣/嗜好等個人屬性或購物紀錄及本服務網站之瀏覽紀錄設定個人化資料。',
		listItem1_3_4: '・伴隨分析客戶於本服務之利用内容，開發新服務或改善現有服務。',
		listItem1_3_5: '・進行意見調查、活動、評價等與服務相關之客戶聯絡。',
		listTitle1_4: '(4)  回應客戶所詢問題',
		listItem1_4: '・回應客戶於本服務以電子郵件、郵寄信件等所為之詢問。',
		listTitle1_5: '(5)  其他伴隨本服務之利用',
		listItem1_5: '・伴隨上述(1)至(4)，就本服務之提供判斷有必要而利用之情況。',
		listTitle1_6: '(6)  提供予服務提供人',
		listItem1_6: '・依「3.個人資料等之提供/委託」提供個人資料予服務提供人。',
		listTitle1_7: '(7)  其他',
		listItem1_7: '・於個別服務亦可能以未規定於上揭內容之目的利用個人資料。於此情形時，將於個別服務網站中登載該內容。',
		subTitle2: '2. 個人資料之取得方法、利用期間與地區',
		listDescription2: '服務之提供方面，主要是取得如下之客戶相關資料。將取得之項目為非必要項目，而無法取得該項目時，可能無法提供本服務、回應客戶所詢問題等事宜，敬請見諒。',
		listDescription2_1: '再者，以下為例示，此外，依資料具體內容亦可能有未符合個人資料之情形，得依利用目的之差異或需求，增刪已收集之個人情報類別與項目，敬請見諒。',
		listTitle2_1: '(1)  客戶提供之資訊',
		listItem2_1: '・姓名、性別、出生年月日、居住地、使用語言、宗教、電子信箱、手機信箱、現在身處位置相關資訊及入住村民會員調查表之回答資訊等客戶所提供之一切資料。',
		listTitle2_2: '(2)  與利用服務有關而取得之資訊',
		listItem2_2: '・客戶申請玖樓提供之社群活動、或其他交易時之得以辨識客戶之資訊，與係屬附帶狀態之交易紀錄相關資訊。',
		listTitle2_3: '(3) 以連結為契機，機械上所取得之資訊',
		listItem2_3_1: '・客戶電腦連結網路時使用之IP位置、手機之機體辨識相關資訊（包含連結地點之資訊）。',
		listItem2_3_2: '・除以連結本網站為契機取得之所使用瀏覽器種類/版本、作業系統、平台等外，客戶瀏覽之網頁 (URL)、瀏覽日期時間、標示或查閱商品等相關資訊。',
		listItem2_3_3: '・除上述外，使用小型文字檔案(cookie)或網頁信號(web beacon)之技術取得之連結資料等，於每次客戶利用本服務自動收集/保管之資料。',
		listTitle2_4: '(4) 個人資料利用期間:自客戶最新登入日起算之一年間。但帳號遭刪除時，客戶的個人資料也將一併被刪除。',
		listTitle2_5: '(5) 個人資料利用地區:台灣、日本',
		subTitle3: '3. 個人資料等之提供/委託',
		listDescription3: '本服務依中華民國之個人情報保護法處理個人資料，除法令規定之情況外，未經客戶許可，未有將該資料揭露、提供予第三人之情形。但亦有於達成利用目的所需之範圍內，提供客戶個人資料、或委託處理個人資料之情形。於此情形下，於第三人之契約規定將進行與本文件同樣之資料管理，適當確認第三人身份及由第三人所為之管理體制。',
		listTitle3_1: '(1) 提供/委託之目的同於「1. 個人資料利用目的」。',
		listTitle3_2: '(2) 提供之個人檔案與「2.個人資料之取得方法」相同。',
		listTitle3_3: '(3) 提供、委託人之範圍為業務上所需服務之提供人。',
		listTitle3_4: '(4) 提供之手段、方法為本服務管理系統、CD-ROM等電子媒體、紙面等類比媒體等。',
		listTitle3_5: '(5) 要求停止向提供人、委託人提供資料時，請採取「5. 個人資料利用目的之通知、揭露、訂正/新增/刪除或利用之停止/消去/停止提供予第三人」之程序。',
		subTitle4: '4. 個人資料之保護',
		listDescription3_2: '就客戶所提供之個人資料為適當管理，為防止個人資料之洩漏、滅失、或毀損，乃從技術及管理面採取適當且合理之保護處置。此外，本服務約定依係屬營運公司之共宅一生股份有限公司之個人資料保護方針設置保護管理之負責人，於該負責人指示下，限定正當之服務進行範圍，嚴格進行收集/利用/提供/管理/保護。',
		subTitle5: '5. 個人資料利用目的之通知、揭露、訂正、新增或刪除、或個人資料之利用停止、消去或停止提供予第三人',
		listItem3_1: '・客戶個人檔案利用目的之通知及客戶個人檔案之揭露、訂正、新增、刪除、消去或停止提供予第三人之相關請求得自「Contact Us」為之。再者，如忘記使用者ID、密碼時，請參照FAQ頁面。',
		listItem3_2: '・關於刪除或消去之程序，由客戶本身自「FAQ」頁面為之或由客戶透過「Contact Us」提出請求。Fun! Japan將以停止利用服務或停止向第三人提供個人資料對應之。',
		listItem3_3: '・玖樓有保管備份檔案，以備電腦故障或其他不可抗力或人為疏失導致之檔案消失之情形。該備份檔案性質上無法進行確認等程序。',
		listItem3_4: '・客戶個人檔案利用目的之通知及客戶個人檔案之揭露、訂正、新增、刪除、消去或停止提供予第三人之相關請求得自「Contact Us」為之。再者，如忘記使用者ID、密碼時，請參照FAQ頁面。',
		listItem3_5: '・客戶利用本服務時，將視為已就「5. 個人資料利用目的之通知、揭露、訂正、新增或刪除或個人資料之利用停止、消去或停止提供予第三人」予以同意辦理。',
		subTitle6: '6. 未成年客戶之個人資料',
		listDescription3_3: '本服務就所提供之未成年人資訊，經謀求與大人同様之保護。但就依個人資料之當事人所在國或區域法令，經認定為未成年人者，按必要可能須得到家長同意。',
		subTitle7: '7. 個人資料相關詢問窗口',
		listDescription3_4: ' 關於個人資料之處理，如有不明瞭的地方，請參照求助網頁。',
		subTitle8: '8. 本網站之安全',
		listDescription3_5: '・本服務為確保客戶個人檔案之正確性、最新性，亦有可能請客戶予以協助。',
		listDescription3_6: '・本服務為確保安全，以防止個人輸入特定個人資料等重要資料時，該等資料遭竊取、受阻或竄改為目的，乃使用SSL（Secure Sockets Layer）技術。',
		paragraph42: '以上'
	},
	team: {
		team: 'Team',
		room: '房子是租來的，',
		life: '但生活不是',
		subject: 'We are deeply inspired by the <a class="underline" href="https://www.ideo.com/post/the-ten-faces-of-innovation" target="_blank" rel="noopener noreferrer">10 faces of innovation</a> as identified by IDEO’s general manager, Tom Kelley. Individually, these archetypes are not the most powerful people, but each character has its own unique tools, viewpoint, and advantages. Through seeking out and combining these key types, we create a powerful organization capable of creating meaningful change in the city.',
		title1: '從實體社群出發，我們希望每個夥伴都是人類學家',
		career1: '1.人類學家',
		careerDescription1: '在共生日常裡進行田野調查',
		career2: '2.看護人',
		careerDescription2: '理解室友的生活需求，提供每個人適切合宜的居住選擇',
		career3: '3.說故事的人',
		careerDescription3: '透過生動故事和大眾溝通',
		career4: '4.實驗家',
		careerDescription4: '把生活問題、構想製成原型',
		title2: '多元創新，是我們骨子裡流的血',
		career5: '5.跨欄運動員',
		careerDescription5: '不斷克服障礙抵達終點',
		career6: '6.體驗建築師',
		careerDescription6: '優化室友的日常生活體驗',
		career7: '7.異花授粉者',
		careerDescription7: '探索其他產業和文化應用於共生之中',
		title3: '共享共創，這是一場弱連結的策展',
		career8: '8.導演',
		careerDescription8: '激發社群的內容與創造力',
		career9: '9.共同合作人',
		careerDescription9: '把各式各樣有趣的室友、外部團體結合',
		career10: '10.舞台設計師',
		summary: 'Whether as a resident, active participant, or distant admirer, we hope you will join us on our journey as we build a friendlier, more livable city.',
		LinkedIn: 'Our LinkedIn',
		Medium: 'Our Medium',
		qouteblock: 'If you are interested in joining our team, please follow our Medium account to stay up to date on current job postings.'
	},
	media: {
		bannerTitle: 'Media',
		sectionDescription: 'To support the greater coliving movement, we are happy to share our experience and philosophy. Our brand book is also available for download For an extensive look into our community, please fill out an interview request form. A selection of past press features is available below:',
		listTitle1: 'Community Development In Taiwan',
		listTitle2: "Taipei's 9floor Coliving: Defending the value of intergenerational co-Living through a new experimental project",
		listTitle3: "Pursuing A Better Life Together: Communication is empathizing with each other's values's",
		listTitle4: 'My Old Roommate',
		listTitle5: "9floor Coliving: Transforming Taipei's old apartments, living in the city without alienation",
		listTitle6: 'Creating A New Lifestyle Inside Old Apartments: Filling generational gaps in the cityscape',
		listTitle7: '"Urban Community For The Future" 9floor Coliving: Lively housing options for young renters',
		listTitle8: 'Living in a Community',
		listTitle9: 'Re-imagining The Concept Of Home: Promoting coliving apartments',
		listTitle10: 'The Rising Age Of Coliving: Moving the economy closer to the people',
		listTitle11: "Independent Living Doesn't Mean Living Alone",
		listTitle12: 'Space Sharing In Cities With High Housing Costs: 9floor Coliving, A new choice for renters',
		listTitle13: 'Redefining Cohabitation: 9floor Coliving is creating a new concept of home',
		listTitle14: 'Individualism From Physical To Spiritual: An economic explosion',
		listTitle15: 'Must include CV to Rent?',
		listTitle16: 'The Madness Of A Sociology Teacher: Changing Taiwan Through One Course ',
		listTitle17: 'Conditions And Opportunity For Intergenerational Coliving: Elderly Society And Vacant Apartments',
		listTitle18: 'Coliving, Greater Economic Efficiency',
		listTitle19: 'Coliving: A new trend breaking the traditional housing mold',
		listTitle20: 'Share Space: Three Examples Not Just For Work- The Common, Sit Together, 9floor Coliving',
		listSubtitle1: 'SOTOKOTO(ソトコト) December 2017 Issue',
		listSubtitle2: 'Ming Pao Weekly',
		listSubtitle3: 'The News Lens- Becoming Aces',
		listSubtitle4: 'Public TV IN-NEWS',
		listSubtitle5: "c'est si bon",
		listSubtitle6: 'Polysh',
		listSubtitle7: 'Social Enterprise Insights',
		listSubtitle8: 'TED x TKU',
		listSubtitle9: 'NPOst',
		listSubtitle10: 'POINT',
		listSubtitle11: '30 Magazine',
		listSubtitle12: 'GREEN Magazine',
		listSubtitle13: 'LaVie',
		listSubtitle14: 'Business Today',
		listSubtitle15: 'Business Weekly',
		listSubtitle16: 'CommonWealth',
		listSubtitle17: 'Village Taipei',
		listSubtitle18: 'FTV',
		listSubtitle19: 'TVBS',
		listSubtitle20: 'BIOS Monthly',
		interview: 'Media Cooperation',
		download: 'Brand Book (Download)',
		require: 'Contact Us',
		record: 'Stories'
	},
	manager: {
		bannerTitle: 'Space Management',
		summaryTitle: '9floor Coliving',
		summary: 'We are a comprehensive community management oriented coliving brand. Specific services offered include branding consultation, design planning, construction, leasing, and business management. We help property owners activate idle assets and improve surrounding communities.',
		sectionTitle1: 'The Development of Coliving Spaces<br> is a Win-win for both Residents and Society',
		sectionDescription11: "From the perspective of redevelopment, coliving spaces occupy an area between business class hotels and long-term rentals. There is a balanced emphasis on both affordability and tangible services. The price is slightly higher than traditional rental property, but building and operating costs are significantly lower than traditional hotels. Additionally, profit is relatively stable because housing is a fixed need. Through our team's long-term consulting services, assets are activated and maintained.",
		sectionDescription12: 'An added benefit of our professional management is a revitalization of the surrounding society. New threads are woven into local history. Property owners, investors, residents, and the surrounding city all benefit from an enlivening spirit of sharing and co-creation.',
		sectionTitle2: 'Why Work with 9floor?',
		sectionDescription21: '9floor is a pioneer of professional coliving spaces in Taiwan. From our grassroots beginning, we have consistently worked to create the best coliving options possible. In just three years we have received almost 3,000 resident applications and accumulated over 30,000 online followers. In addition to media accolades, we have also joined with the New Taipei City Government to create an intergenerational public housing project in Sanxia district and a social housing project in Yonghe district. In 2017 we became a <a class="underline"  class="underline" href="https://news.ltn.com.tw/news/local/paper/1138446" target="_blank" rel="noopener noreferrer">certified property manager for the Taipei City Government.</a>',
		sectionDescription22: 'As an organization, we have a history of close interaction and collaboration with like-minded organizations and innovators within Asia. We were awarded Hong Kong’s <a class="underline" href="https://www.socialinnovationaward.asia/about-us/" target="_blank" rel="noopener noreferrer">Asia Social Innovation Award (2017)</a>, served as the Taiwanese representative in Seoul’s <a class="underline" href="https://www.facebook.com/Anyse.Asia/" target="_blank" rel="noopener noreferrer">ANYSE (2016)</a>, and are mentored by Social Enterprise Insights iLab and the Taipei City Government Department of Economic Development. With our international vision, local experience, and unique management abilities, 9floor is the superior choice for creating higher value from your real estate assets.',
		sectionTitle3: 'Service Options',
		row1Title: 'A. Comprehensive Planning',
		row1Subtitle1: '1.Coliving Space',
		row1Subtitle2: '2.Space Brand Planning',
		row1Subtitle3: '3.Community/Social Experience',
		row1Description1: 'Market Analysis, Financial and Benefit Analysis, Space Utilization Planning, Mixed-use Development Planning',
		row1Description2: 'Consulting Services, Service Design, Operations Standards Development, Staff Training, Integrated Digital Marketing',
		row1Description3: 'Community Activity Planning, Online Community Event Planning, Neighborhood Co-creation Planning',
		row2Title: 'B. Design Supervision',
		row2Subtitle1: '1.Renovation',
		row2Sbtitle2: '2.Smart Home Integration',
		row2Description1: 'Space Restoration and Modification, Interior Design, Landscape Design',
		row2Description2: 'Smart Locks, Interior Renovation Projects',
		row3Title: 'C. Operations Management',
		row3Subtitle1: '1.Resident Management',
		row3Subtitle2: '2.Product Management',
		row3Description1: 'Resident Recruitment and Selection, Online Contract Management, Client Relations',
		row3Description2: 'Cleaning, Repairs, Maintenance, Property Insurance',
		section3Title: 'We are actively seeking the following cooperative partnerships to create more coliving spaces:',
		section3TitleWithHTML: 'We are actively seeking the following cooperative partnerships<br> to create more coliving spaces:',
		section3Sub1: 'Vacant Properties',
		section3Sub2: 'Special Projects',
		section3Sub3: 'Cross-Industry Alliances',
		section3Description1: 'We are constantly looking for new spaces to update. This includes any property suitable for blending private residence with shared common space. Convenient access to public transportation is a necessity. Unique local history is also a plus!',
		section3Description2: 'We hope that 9floor’s coliving and share spaces throughout the city can be incubation spaces for the creation of new culture. We welcome all proposals and are actively seeking possibilities for collaborations related to social design, community building, and innovating for future societ',
		section3Description3: 'Stemming from our ongoing exploration of lifestyle and space, we are actively seeking strategic partners in the following areas: smart home technologies, green appliances, healthy food options, lifestyle brands, etc. Help us create a sustainable city.',
		blockquoteWithHTML: 'Want to know more? Please provide us with basic information regarding your proposal. We will contact you as soon as possible.',
		contactUs: 'contact us',
		sloganLeft: '享受社交生活。',
		sloganRight: '在宜居的環境裡，',
		sloganTitle1: 'What is Coliving?',
		sloganTitle2: 'What is Coliving?',
		sloganContent: 'As inherently relational beings, we require much more than just a place to sleep. Social connections, cultural activities, and simple relaxation are just a few of our many critical needs. Coliving is one solution to make sure that these needs are met. Unlike renting a single room, living in a coliving space grants access to shared space (kitchens, living areas, event spaces, etc.) where community naturally grows.'
	},
	coliving: {
		coliving: 'Coliving Life',
		summaryTitle: '9floor Coliving',
		summaryDescription: '9floor is a community management driven coliving brand. Through space design and diverse community, we provide superior living experiences tailored to fit your contemporary urban lifestyle.',
		sloganTitle: 'What is Coliving?',
		slogan: '房子是租來的，但生活不是',
		sloganContent: 'As inherently relational beings, we require much more than just a place to sleep. Social connections, cultural activities, and simple relaxation are just a few of our many critical needs. Coliving is one solution to make sure that these needs are met. Unlike renting a single room, living in a coliving space grants access to shared space (kitchens, living areas, event spaces, etc.) where community naturally grows.',
		title1: 'A. Coliving Space',
		description1: 'The warm atmosphere of home with the internet access and communal workspace of a coffee shop. We curate thoughtful environments that offer a much-needed respite from the bustle of the city. Take your time sipping your morning coffee. Share a bottle of wine with your new neighbor as you unwind from the workday. Bring comfort and beauty back into your everyday routine.',
		imageDescription1: 'From heirloom recipes to late night ramen noodles, communal kitchens are an inviting space for sharing food and conversation.',
		imageDescription2: 'Make plans, prepare for exams, or enjoy your afternoon coffee break.',
		imageDescription3: 'Come home to your personal hideaway, and forget the worries of the workday.',
		title2: 'B. Convenient Leasing',
		description2: 'With automated bill pay, you no longer need to remember to pay your rent. A single online bill takes care of all expenses. If you are an intern, exchange student, or working on a short-term project, our one-month minimum frees you from the confines of a long lease.',
		imageDescription4: 'Our billing includes all utilities, cleaning fees, and administrative costs. One payment takes care of it all.',
		imageDescription5: 'Automatic payment options. You no longer need to set a reminder for your rent.',
		imageDescription6: 'Remote working, internships, short-term projects- with a one month minimum for leasing your options are flexible.',
		title3: 'C. Daily Support',
		description3: 'Weekly common area cleanings and garbage disposal save your precious time. Online maintenance requests minimize inconvenience and ensure timely resolution.',
		imageDescription7: 'Online maintenance requests with response times within 24 hours. Qualified service technicians quickly resolve facilities issues.',
		imageDescription8: 'Regular cleaning service for common areas and garbage disposal. *Excessive garbage or large items will be the responsibility of the resident.',
		imageDescription9: 'We are insured for accidents resulting from equipment failure within our facilities.',
		title4: 'D. Communal Life',
		description4: 'Our personal experiences may be limited, but the diverse {{link}} is a jumping off point for exploring new ideas and expanding your perspective. Rooftop pool parties, activities with local organizations, and impromptu communal meals are all great ways to connect with fellow residents.',
		imageDescription10: 'Social interaction is not confined to physical space. Online community plays a significant part in how we grow our personal networks.',
		imageDescription11: 'A magazine library, movie nights, and pool parties. Our community center is a hub for connecting and sharing.',
		imageDescription12: 'We hope you will experience the most rewarding and meaningful relationships of your lifetime.',
		community: 'community of coliving'
	},
	sitemap: {
		sitemap: 'Sitemap',
		member: 'Member',
		checkin: 'Choose Your Room',
		ninthfloor: 'Ninthfloor',
		service: 'Service',
		journal: 'Journal',
		help: 'Help',
		login: 'Login',
		filter: 'Fliter',
		area: 'Area',
		pauian: 'Pure Co-living',
		personalized: 'Personalized',
		about: 'About',
		media: 'Media',
		team: 'Team',
		contact: 'Contact',
		space: 'Space',
		coliving: 'Coliving',
		how: 'How to Apply',
		FAQ: 'FAQ',
		contactUs: 'Contact Us',
		termsofService: 'Terms of Service',
		privacy: 'Privacy Policy'
	},
	BookingInsto: {
		paymentDescription: 'Financial Withholding and Refund Policy',
		paymentItem1: '9floor use NewebPay as the payment platform. NewebPay is compatible with VISA, Mastercard, and JCB credit and debit cards.',
		paymentItem2: '1. After setup is complete, your account will be automatically debited every month. If necessary, you can check your transaction history at any time via the member page.',
		paymentItem3: '2. Monthly rent deduction will occur on your lease start date.',
		paymentItem4: '3. Other than the initial deposit, we will not place any advance holds on your account.',
		paymentItem5: '4. If necessary, you have the option to change your preferred account.',
		paymentItem6: '5. If you use an international (non-Taiwanese) card, your transaction may be subject to exchange and service fees. Check with the account provider for details.',
		agree: 'I understand and agree to the payment terms:',
		cardDetail: 'Credit/Debit Card Information',
		cardNumber: 'Card Number',
		dateline: 'Expiration Date',
		zipCode: 'Security Code',
		name: 'Name',
		continue: 'Continue to Payment',
		back: 'Go Back'
	},
	SocialSelectGroup: {
		otherSocialMedia: 'Link Other Social Media',
		linkSocialMedia: 'Social Media Link ',
		choiceSocialMedia: 'Choice',
		addLinkofSocialMedia: 'Add Link of Social Media'
	},
	MemberBadge: {
		REGISTERED: 'Registered',
		MEMBERSHIP_UNDER_REVIEW: 'Membership Under Review',
		MEMBERSHIP_DENIED: 'Membership Denied',
		BASIC_MEMBER: 'Basic Member',
		CERTIFIED_MEMBER: 'Certified Member',
		RESIDENT_MEMBER: 'Resident Member',
		BLOCKED: 'Blocked'
	},
	CoLivingSlider: {
		search: 'Search',
		serviceDetail: 'More Info'
	},
	CoLivingSection: {
		search: 'Search',
		serviceDetail: 'More Info',
		sectionTitle1: 'Urban Lifestyle',
		sectionDetail1: 'The warm atmosphere of home with the internet access and communal workspace of a coffee shop. We curate thoughtful environments that offer a much-needed respite from the bustle of the city. Take your time sipping your morning coffee. Share a bottle of wine with your new neighbor as you unwind from the workday. Bring comfort and beauty back into your everyday routine.',
		sectionTitle2: 'Flexible Convenience',
		sectionDetail2: 'With automated bill pay, you no longer need to remember to pay your rent. A single online bill takes care of all expenses. If you are an intern, exchange student, or working on a short-term project, our one-month minimum frees you from the confines of a long lease.',
		sectionTitle3: 'Daily Support ',
		sectionDetail3: 'Weekly common area cleanings and garbage disposal save your precious time. Online maintenance requests minimize inconvenience and ensure quick issue resolution.',
		sectionTitle4: 'Communal Life',
		sectionDetail4: 'Our personal experiences may be limited, but the diverse community of coliving is a jumping off point for exploring new ideas and expanding your perspective. Rooftop pool parties, activities with local organizations, and impromptu communal meals are all great ways to connect with fellow residents.'
	},
	Home: {
		qouteblock: 'Become a part of our community. Try out the best lifestyle for today’s urban environment.',
		moreButton: 'Learn more'
	},
	LocationInfo: {
		roommate: 'Roommates'
	},
	RoomCard: {
		month: 'month'
	},
	breadcrumb: {
		moveIn: 'Move-in',
		roomSearch: 'Room Search',
		geographicSearch: 'Geographic Search',
		home: '9floor',
		about: 'About',
		media: 'Media',
		team: 'Team',
		contact: 'Contact',
		service: 'Service',
		spaceManagement: 'Space Management',
		coliving: 'Coliving',
		member: 'Member',
		overview: 'Overview',
		add: 'Member Settings',
		settings: 'Member Settings',
		favorites: 'Wishlist',
		propertyViewingHistory: 'Appointment Record',
		reservationHistory: 'Booking History',
		onlineCommunity: 'Community',
		termsOfService: 'Terms',
		description: 'Description',
		privacyPolicy: 'Privacy Policy',
		sitemap: 'Sitemap',
		room: 'Room',
		booking: 'Booking',
		user: 'User',
		reservation: 'Reservation',
		renewYourLease: 'Renew Your Lease',
		book: 'Booking History',
		appointment: 'Appointment',
		checkin: 'Schedule a Move-in Appointment',
		checkout: 'Schedule a Checkout Appointment',
		cancel: 'Cancel',
		changeAppointment: 'Change an Appointment',
		interview: 'Interview'
	},
	cookie: {
		title: 'We use cookie',
		description: 'This website uses cookies. By continuing to use this site you are agreeing to our use of cookies. For more info, including how to adjust your settings, please view our',
		policy: 'Cookie Policy',
		buttonText: 'Agree'
	},
	community: {
		qouteblock: 'Become a part of our community. Try out the best lifestyle for today’s urban environment.',
		moreButton: 'Learn more',
		communitySearch: 'Our personal experiences may be limited, but the diverse community of coliving is a jumping off point for exploring new ideas and expanding your perspective. No matter your background, we hope that 9floor will be a place where you can find community and a sense of belonging.',
		selectCity: 'City',
		placeholder: 'Hobby (e.g., Basketball, Design, Book Club )',
		findbutton: 'Find Someone',
		communityAlert: 'This service is exclusive for Resident Member.'
	},
	previewSection: {
		review: 'Application Under Review',
		reviewDetail: 'After we receive your application, our staff requires 2-3 working days to review the information (weekends and national holidays excluded). Thank you for your patience.'
	},
	reservationCancel: {
		confirm: 'Confirm Your Cancellation',
		reason: 'Reason for Cancellation',
		AboutToCancel: 'You are about to cancel the appointment.',
		cancelAlert: 'Are you sure you would like to cancel your appointment? After canceling, your monthly allowance of property viewings will not be updated. You still have {{number}} remaining property viewings for this month.',
		cancellation: 'Confirm Cancellation'
	},
	songList: {
		song: "What's the name of the song?",
		addSong: 'Add'
	},
	roommateDetail: {
		favoriteSong: 'Favorite Song',
		communityLink: 'Community Link',
		more: 'More'
	}
};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	common: {
		hello: '哈囉!'
	},
	navigator: {
		choose: '入住玖樓',
		filter: '條件搜尋',
		map: '地圖搜尋',
		pauian: '玖樓璞園',
		personalized: '為我推薦',
		ninthfloor: '玖樓',
		about: '關於',
		media: '媒體',
		team: '團隊',
		contact: '聯繫',
		service: '服務',
		space: '空間管理',
		coliving: '共居生活',
		journal: '日誌',
		community: '社群',
		news: '消息',
		note: '筆記',
		guide: '指南',
		member: '會員',
		overview: '總覽',
		setting: '會員設定',
		favorites: '最愛收藏',
		propertyHistory: '預約記錄',
		reservationHistory: '入住紀錄',
		onlineCommunity: '線上社群',
		login: '登入',
		logout: '登出',
		register: '註冊',
		loginOrRegister: '登入/註冊'
	},
	banner: {
		search: '開始搜尋'
	},
	footer: {
		room: '入住玖樓',
		filter: '條件搜尋',
		map: '地圖搜尋',
		pauian: '玖樓璞園',
		personalized: '為我推薦',
		ninthfloor: '玖樓',
		about: '關於玖樓',
		team: '團隊夥伴',
		space: '空間管理',
		coliving: '共同生活',
		community: '線上社群',
		news: '最新消息',
		help: '協助',
		how: '如何申請',
		FAQ: '常見問題',
		contact: '聯繫我們',
		media: '媒體專區',
		moveIn: '入住條款',
		privacy: '隱私權政策',
		termsofService: '服務條款',
		sitemap: '網站地圖',
		description: '服務說明'
	},
	reservation: {
		MORNING: '上午',
		AFTERNOON: '下午',
		live: '現場看房',
		phone: '電話諮詢',
		online: '線上看房',
		checkin: '入住',
		checkout: '退房',
		interview_phone: '電話訪談',
		interview_online: '線上訪談',
		notValidText: '哎呀！還有沒填寫到的資料，趕快檢查並填寫完成唷！',
		notValidReserve: '抱歉，本時段已被搶先預約，請重新選擇',
		notReserveCheckinDate: '沒有適合的時段？請電話聯繫工作人員安排入住。（電話：+886 908959613）',
		notReserveCheckoutDate: '沒有適合的時段？請電話聯繫工作人員安排退房。（電話：+886 908959613）',
		checkinTime: '入住時間',
		checkoutTime: '退房時間',
		ViewTime: '看房時間',
		checkinDescription: '入住說明',
		checkoutDescription: '退房說明',
		ViewMethod: '看房方式',
		checkinResult: '很開心您加入玖樓，入住日當天將由社群經理協助辦理入住，約需花費一個小時，要幫我們將時間保留下來唷！社群經理將帶您認識共同生活空間、室友、生活需注意的小細節，讓您可以更快融入大家唷！',
		checkoutResult: '提醒您: 退房時，請將承租空間恢復至入住時原貌，並將私人物品及垃圾帶走。退房手續將按照入住條款內之細則辦理。道別後也別忘記要記得回來看看大家哦：)',
		referenceNumber: '預約編號',
		address: '地址',
		time: '時間',
		phoneNumber: '聯絡電話',
		name: '姓名',
		cancelAnAppointment: '取消預約',
		changeAnAppointment: '變更預約',
		fillOutTheSurvey: '填寫回饋',
		successful: '預約成功',
		successDescription: '太好了！您的預約已成功，相關資訊已寄至您的email信箱，也可隨時至會員中心查看。如有任何異動，我們將以email進行通知。若於預約時間24小時內之異動，我們將第一時間與您電話聯繫。如欲取消或變更預約。',
		viewReservation: '觀看預約',
		backToRoom: '返回房源',
		ninefloor: '玖樓',
		calendar: '月曆',
		addToCalendar: '加到月曆',
		gtm: '以下預約時段為台灣 GMT+8 時區時間',
		next: '下一步',
		edit: '確認預約',
		phoneDescription: '目前僅支援台灣區號碼，如人在國外，請選擇線上看房噢。',
		hangoutDescription: '線上看房使用 google hangout 進行，預約登記完畢後，將發送會議連結至聯絡信箱。',
		hangout: '您的 google hangout 帳號',
		hangoutAccount: '帳號',
		chooseTypeValid: '請先選擇看房方式才能完成預約喔！',
		checkPhoneAndHangoutAlert: '請填寫正確的聯絡電話/google hangout 帳號才能完成預約喔！',
		cancelSuccess: '取消預約成功，任何問題歡迎聯繫 <a class="underline" href="mailto:service@9floorspace.com">service@9floorspace.com</a> 或 撥打 +886 908959613',
		updateSuccess: '更新預約成功，任何問題歡迎聯繫 <a class="underline" href="mailto:service@9floorspace.com">service@9floorspace.com</a> 或 撥打 +886908959613',
		recordIsEmpty: '目前尚無任何預約紀錄'
	},
	settings: {
		welcomeText: '歡迎加入！完成會員申請剩下最後一步，完成申請資料，讓我們再更認識您吧！',
		deniedText: '嗨！很抱歉您的資料未通過審核，可能是資料填寫不夠完全或是資料有誤，歡迎修正後再次送出申請或是與我們聯繫。',
		notValidText: '哎呀！還有沒填寫到的資料，趕快檢查並填寫完成唷！',
		notValidCertificate: '哎呀！你填寫的資料格式有誤，請重新檢查',
		nameTooltip: '注意：請填寫與證件相符之中文或英文全名，未來入住時將進行第二次審核',
		sexTooltip: '因宿舍房型有生理性別限制，而需填此選項',
		passportTooltip: '\u64C1\u6709\u4E2D\u83EF\u6C11\u570B\u8EAB\u5206\u8B49\u8005\u8ACB\u63D0\u4F9B\u8EAB\u5206\u8B49\u5B57\u865F\u3002\n\u6CE8\u610F\uFF1A\u8ACB\u78BA\u5BE6\u586B\u5BEB\u8B49\u4EF6\u865F\u78BC\uFF0C\u672A\u4F86\u5165\u4F4F\u6642\u5C07\u9032\u884C\u7B2C\u4E8C\u6B21\u5BE9\u6838\u3002',
		skillsTooltip: '例如：廚藝、木工、素描、語言、人體計算機',
		presonalTooltip: '請用300字以內簡單說明自己的背景，以及談談對入住玖樓的生活想像或期待。',
		privacyTooltip: '住進我們的社群，連結更多有趣的人事物，選擇公開，我們將會於線上社群對其他入住室友開放您的社群資料。',
		nicknameTooltip: '希望村民們怎麼稱呼您呢？',
		avatarTooltip: '請上傳可辨認的個人照片以便審核。',
		introductionTooltip: '讓村民們可以更快地認識您喲！',
		socialTooltip: '*由於審核需要，首次申請請至少留一項，申請通過後可再變更！',
		addAvatar: '自訂頭像',
		reviewUploadPhoto: '請上傳可辨認的個人照片以便審核。',
		basicInformation: '個人資料',
		nameAlert: '注意：請填寫與證件相符之中文或英文全名，未來入住時將進行第二次審核',
		selectFile: '選擇檔案',
		passportType: '證件類型',
		passportNumber: '證件號碼',
		name: '姓名',
		fullName: '姓名全名 ',
		sex: '生理性別',
		sexAlert: '因合住房型有性別限制，故需填此選項',
		dateOfBirth: '生日',
		selectBirthday: '請選擇生日',
		nationality: '國家',
		selectNationality: '請選擇國家',
		passport: '證件',
		workingArrangements: '工作型態',
		jobTypes: '請選擇工作型態',
		skills: '專長',
		skillTypes: '請選擇專長',
		phoneNumber: '聯絡電話',
		personalIntroduction: '自我介紹＆對社群的想像',
		words300: '請用300字以內簡單說明自己的背景，以及談談對入住玖樓的生活想像或期待。',
		communityProfile: '社群資料',
		privacySetting: '是否公開',
		privacyDetail: '住進我們的社群，連結更多有趣的人事物，選擇公開，我們將會於線上社群對其他入住室友開放你的社群資料。',
		nameForDisplay: '顯示名稱',
		nickname: '希望村民們怎麼稱呼你呢？',
		company: '公司名稱',
		occupation: '職業',
		selectOccupation: '請選擇職業',
		shortIntroduction: '社群短自介',
		words150: '請用 150 字內文字介紹自己，讓村民們可以更快地認識你喲！',
		personalInterests: '興趣標籤',
		interests: '請選擇興趣',
		website: '新增其他社群帳號/個人網站',
		music: '喜歡的歌曲',
		spotify: '從Spotify中選擇',
		accountLink: '社群帳號連結',
		alertAccountLink: '由於審核需要，首次申請請至少留一項，申請通過後可再變更！',
		instagram: 'Instagram',
		instagramLink: 'Instagram 綁定',
		save: '儲存',
		submit: '送出申請',
		FEMALE: '女',
		MALE: '男',
		OTHER: ''
	},
	bookingBar: {
		available: '招募中',
		notAvailable: '未開放',
		canBooking: '可即刻入住',
		waitRelease: '即將釋出',
		releaseTime: '{{YYYY}}年{{MM}}月{{DD}}日',
		month: '月',
		view: '預約看房',
		book: '預訂入住',
		noBook: '目前不開放',
		reserved: '已預約',
		continue: '預訂續住',
		checkout: '預約退房時間',
		reservedMessage: '您已經預約了此房間的{{eventType}}，看房日期為 {{time}}',
		verifying: '我們尚未收到您的{{link}}，因此還無法預約看房唷！',
		verifyingData: '申請資料',
		verifyingPending: '資格審核中: 會員資格審核時間約為2-3個工作天（未含六日、國定假日），如未逾期仍未收到結果通知請連繫我們。',
		verifyingDenied: '由於你此次申請會員資料填寫不夠充分，沒有通過審核，因此無法預約看房。建議重新填寫會員申請，並多多介紹你自己',
		excessUserReserve: '您已超過本月可預約次數',
		excessRoomReserve: '目前本房預約看房人數過多，建議預約其他房源，或先加入收藏。',
		reject: '由於您已違反玖樓社群規章，我們將暫停您所有玖樓相關服務的使用權利。',
		notCertificated: '預訂入住為認證會員的功能。詳情請參考{{link}}',
		viewIntro: '很開心能邀請您來探索玖樓，在預約心儀房源之前請務必詳讀以下規則：\n\n1. 變更/取消\n   a)如需 變更/取消 預約需在24小時前至會員頁進行變更\n   b)如臨時不能到或延後抵達時間，請主動致電給我們的工作人員\n   c)無故未到者 ，兩個月內將無法預約及預訂玖樓居住空間\n2. 當次預約，如因其他會員預定此房間，我們將第一時間以email進行變更通知。如距離原訂時間24 小時內，則由電話即時通知\n3. 每位會員每月有 3 次無收費的看房機會。\n\n有乖乖看完相關規定嗎？快來找我們玩吧！',
		bookIntro: '\u5165\u4F4F\u7396\u6A13\u7684\u6D41\u7A0B\u53EF\u80FD\u6709\u4E9B\u8207\u60A8\u5148\u524D\u7684\u79DF\u623F\u7D93\u9A57\u4E0D\u592A\u76F8\u540C\uFF1A\n\n1. \u7396\u6A13\u4F7F\u7528\u85CD\u65B0\u91D1\u6D41NewebPay\u70BA\u652F\u4ED8\u7CFB\u7D71\uFF0C \u652F\u63F4 Visa, MasterCard, JCB \u4E4B\u4FE1\u7528\u5361\u3001\u7C3D\u5E33\u91D1\u878D\u5361\u3002\n2. \u6536\u5230\u8A02\u55AE\u5F8C\uFF0C\u7396\u6A13\u4ECD\u6703\u65BC24\u5C0F\u6642\u5167\u9032\u884C\u6700\u5F8C\u5BE9\u6838\uFF0C\u5982\u7533\u8ACB\u8005\u905E\u4EA4\u7684\u8EAB\u4EFD\u8CC7\u6599\u8207\u6703\u54E1\u8CC7\u6599\u4E0D\u7B26\uFF0C\u6216\u56E0\u7CFB\u7D71\u539F\u56E0\u5C0E\u81F4\u91CD\u8907\u9810\u5B9A\uFF0C\u7396\u6A13\u5C07\u4FDD\u7559\u53D6\u6D88\u8A02\u55AE\u4E4B\u6B0A\u5229\u3002\n3. \u8A02\u55AE\u78BA\u8A8D\u5B8C\u6210\u5F8C\uFF0C\u65BC\u5165\u4F4F\u524D\u5982\u9700\u8B8A\u66F4\u623F\u6E90\u3001\u53D6\u6D88\u9810\u5B9A\uFF0C\u672C\u7B46\u9810\u8A02\u4E4B\u884C\u653F\u624B\u7E8C\u8CBB\u5C07\u4E0D\u6703\u9000\u9084\u3002\n\n\u63D0\u9192\uFF1A\n1. \u9810\u8A02\u5165\u4F4F\u50C5\u9650\u5B9A\u6703\u54E1\u672C\u4EBA\u5165\u4F4F\uFF0C\u65BC\u6D41\u7A0B\u4E2D\u6211\u5011\u5C07\u9032\u884C\u8EAB\u4EFD\u9A57\u8B49\uFF0C\u5207\u52FF\u4F7F\u7528\u4ED6\u4EBA\u5E33\u865F\u9032\u884C\u9810\u8A02\n2. \u9996\u671F\u6B3E\u9805\u542B\uFF1A\u62BC\u91D1\uFF08\u5169\u500B\u6708\u79DF\u91D1\uFF09\u3001\u884C\u653F\u624B\u7E8C\u8CBB\uFF081500\u5143\uFF09\u3001\u9000\u623F\u6E05\u6F54\u8CBB\uFF081500\u5143\uFF09\n3. \u5982\u70BA\u7B2C\u4E8C\u4EBA\u5165\u4F4F\uFF0C\u8ACB\u78BA\u8A8D\u623F\u6E90\u6709\u958B\u653E\u6B64\u670D\u52D9\uFF0C\u540C\u6642\u78BA\u5BE6\u65BC\u8A02\u55AE\u4E2D\u9032\u884C\u52A0\u8CFC\n\u4EE5\u4E0A\u884C\u70BA\u5982\u6709\u9055\u53CD\uFF0C\u7D93\u67E5\u8B49\u5F8C\uFF0C\u5C07\u76F4\u63A5\u53D6\u6D88\u6703\u54E1\u8CC7\u683C\uFF0C\u8A73\u7D30\u53C3\u898B\u6211\u5011\u7684',
		term: '服務說明',
		serviceGuide: '服務說明',
		bookIntroEnd: '\n讀完了，離完成預定剩三步驟唷！',
		checkoutIntro: '退房時，將由社群經理為您辦理退房手續，並與您進行當面點交。（退房手續詳見',
		checkoutTerm: '服務條款',
		checkoutIntroEnd: '） 提醒您：請將承租房間恢復至入住時原貌，並將私人物品及垃圾帶走，否則將產生相關處理費用。 道別後也別忘記回來看看大家哦：）',
		start: '開始預約',
		next: '下一步',
		renew: '續訂',
		renewIntro: '\u8B1D\u8B1D\u4F60/\u59B3\u5C0D\u7396\u6A13\u7684\u793E\u7FA4\u53CA\u670D\u52D9\u7684\u652F\u6301\uFF0C\u4E5F\u671F\u5F85\u5728\u63A5\u4E0B\u4F86\u66F4\u591A\u7684\u65E5\u5B50\u6211\u5011\u80FD\u6301\u7E8C\u6FC0\u76EA\u51FA\u66F4\u591A\u7CBE\u5F69\u7684\u751F\u6D3B\u53CA\u6545\u4E8B\u3002\n\u7E8C\u8A02\u6CE8\u610F\u4E8B\u9805\u5982\u4E0B\uFF1A\n\n1.\u672C\u8A02\u55AE\u6700\u665A\u53EF\u7E8C\u7D04\u65E5\u671F\u70BA {{renewDate}}\n2.\u7E8C\u8A02\u5C07\u4E0D\u6703\u91CD\u8907\u6536\u53D6\u884C\u653F\u624B\u7E8C\u8CBB\u3001\u9000\u623F\u6E05\u6F54\u8CBB\u53CA\u62BC\u91D1\uFF0C\u5982\u539F\u672C\u70BA\u516D\u500B\u6708\u4EE5\u4E0A\u8A02\u55AE\uFF0C\u9996\u6B21\u7E8C\u8A02\u4E0D\u8AD6\u79DF\u671F\uFF0C\u7686\u53EF\u4EAB\u6709\u9577\u79DF\u50F9\u683C\u3002\n3.\u5982\u6263\u6B3E\u4FE1\u7528\u5361\u6709\u8B8A\u66F4\uFF0C\u53EF\u65BC\u8A02\u55AE\u5B8C\u6210\u5F8C\uFF0C\u81F3\u8A02\u55AE\u8A73\u60C5\u9801\u9032\u884C\u8B8A\u66F4\u3002',
		appointment: '預約入住時間',
		appointmentIntro: '很開心您加入玖樓，入住日當天將由社群經理協助辦理入住，約需花費一個小時，要幫我們將時間保留下來唷！ 社群經理將帶您認識共同生活空間、室友、生活需注意的小細節，讓您可以更快融入大家唷！'
	},
	booking: {
		notValidText: '哎呀！還有沒填寫到的資料，趕快檢查並填寫完成唷！',
		notValidCertificate: '哎呀！你填寫的資料格式有誤，請重新檢查',
		notAcceptText: '哎呀！請記得勾選同意入住條款',
		notAcceptInsuranceText: '哎呀！請記得勾選保險政策',
		notValidFormat: '哎呀！有資料填寫錯誤，請趕快檢查並填寫完成唷！',
		empty: '目前尚無任何入住紀錄',
		notValidCreditNumber: '信用卡資訊錯誤',
		notValidCreditDate: '到期日資訊錯誤',
		notValidCreditCVC: '安全碼資訊錯誤',
		expiredCreditCard: '信用卡授權失敗'
	},
	bookingOrder: {
		invoiceInformation: '訂單資訊',
		bookingTimezone: '以下預約時段為台灣 GMT+8 時區時間',
		orderStartDate: '起租日期',
		leaseEnd: '租期結束月份',
		leaseEndPlaceholder: '請選擇租期結束月份',
		longTermRentalPrice: '長租價格：NTD {{rent}}/月',
		middleTermRentalPrice: '短租3-5月：NTD {{rent}}/月',
		shortTermRentalPrice: '短租1-2月：NTD {{rent}}/月',
		optionalItems: '選配方案',
		itemizedInvoice: '訂單項目',
		orderDate: '訂單成立日期：',
		roomName: '房間：',
		address: '居住空間地址：',
		orderStartFrom: '訂單起始日：',
		orderStartTo: '訂單終止日：',
		next: '下一步'
	},
	bookingRent: {
		initialPayment: '首期款項',
		monthlyPayment: '每月扣繳',
		totalMonth: '共 {{count}} 個月',
		totalMonth_plural: '共 {{count}} 個月',
		total: '小計',
		deposit: '押金',
		monthlyPrice: '{{price}} NTD/月',
		depositDescription: '押金總額為兩期月租金。',
		administrativeFee: '行政手續費',
		paymentDetail: '付款明細',
		administrativeFeeDescription: '1.\u5165\u4F4F\u6703\u54E1\u9810\u8A02\u6BCF\u4E00\u623F\u9593\u4E4B\u7B2C\u4E00\u7B46\u8A02\u55AE\u6210\u7ACB\u6642\uFF0C\u5C07\u914C\u6536\u65B0\u53F0\u5E631,500\u5143\u6574\u4E4B\u8A02\u55AE\u8655\u7406\u4E4B\u884C\u653F\u624B\u7E8C\u8CBB\u3002\n2.\u5165\u4F4F\u6703\u54E1\u82E5\u6309\u539F\u7D04\u7E8C\u8A02\u76F8\u540C\u623F\u9593\uFF0C\u4E14\u5169\u7B46\u8A02\u55AE\u4E4B\u627F\u79DF\u6642\u9593\u7121\u4E2D\u65B7\uFF0C\u5247\u7E8C\u8A02\u6642\uFF0C\u5165\u4F4F\u6703\u54E1\u7121\u9808\u652F\u4ED8\u7E8C\u8A02\u8A02\u55AE\u4E4B\u884C\u653F\u624B\u7E8C\u8CBB\u3002\n3.\u8A02\u55AE\u6210\u7ACB\u81F3\u8A02\u55AE\u7D42\u6B62\u671F\u9593\u5167\u4E4B\u8A02\u55AE\u7570\u52D5\uFF0C\u5C07\u914C\u6536\u65B0\u53F0\u5E631,500\u5143\u6574\u4E4B\u8A02\u55AE\u8655\u7406\u4E4B\u884C\u653F\u624B\u7E8C\u8CBB\u3002',
		cleaningFee: '退房清潔費',
		cleaningFeeDescription: '1.\u70BA\u78BA\u4FDD\u6BCF\u4F4D\u5165\u4F4F\u6703\u54E1\u90FD\u80FD\u6709\u6700\u597D\u7684\u74B0\u5883\u54C1\u8CEA\uFF0C\u6211\u5011\u5C07\u7D71\u4E00\u6536\u53D6\u9000\u623F\u6E05\u6F54\u8CBB\uFF0C\u7531\u5C08\u4EBA\u9032\u884C\u6E05\u6F54\u6253\u6383\u3002\u552F\u6709\u56B4\u91CD\u6C61\u640D\u8207\u7834\u58DE\u60C5\u7BC0\u8005\uFF0C\u6211\u5011\u5C07\u65BC\u9EDE\u4EA4\u6642\u914C\u6536\u6E05\u6F54\u52A0\u6642\u8CBB\u7528\u3002\n2.\u5165\u4F4F\u6703\u54E1\u9810\u8A02\u6BCF\u4E00\u623F\u9593\u4E4B\u7B2C\u4E00\u7B46\u8A02\u55AE\u6210\u7ACB\u6642\uFF0C\u5C07\u914C\u6536\u65B0\u53F0\u5E631,500\u5143\u6574\u4E4B\u9000\u623F\u6E05\u6F54\u8CBB\u3002\u5165\u4F4F\u6703\u54E1\u82E5\u6309\u539F\u7D04\u7E8C\u8A02\u76F8\u540C\u623F\u9593\uFF0C\u4E14\u5169\u7B46\u8A02\u55AE\u4E4B\u627F\u79DF\u6642\u9593\u7121\u4E2D\u65B7\uFF0C\u5247\u7E8C\u8A02\u6642\u5165\u4F4F\u6703\u54E1\u7121\u9808\u652F\u4ED8\u9000\u623F\u6E05\u6F54\u8CBB\u3002',
		petCleaningFee: '寵物退房清潔費',
		petCleaningFeeDescription: '「寵物入住」將產生一筆新台幣1,000元整之「寵物退房清潔費」，此費用於訂單成立時酌收。入住會員若按原約續訂相同房間，且兩筆訂單之承租時間無中斷，則續訂時入住會員無須支付「寵物退房清潔費」。',
		monthlyRent: '月租金',
		monthlyRentDescription: '月租金為每月固定日期定期扣款，入住會員每期應繳納月租金。',
		serviceFee: '服務費',
		serviceFeeDescription: '服務費為入住會員共同分擔之公共空間清潔管理費用及垃圾收取服務費用。',
		energyPrice: '能源費',
		energyPriceDescription: '能源費為入住會員共同分擔之居住空間使用費用，包含：水費、電費、天然氣費以及網路費等費用。',
		petDescription: '1.\u5165\u4F4F\u6703\u54E1\u5F97\u65BC\u7396\u6A13\u958B\u653E\u98FC\u990A\u5BF5\u7269\u4E4B\u5C45\u4F4F\u7A7A\u9593\u98FC\u990A\u5BF5\u7269\u3002\u6BCF\u4F4D\u5165\u4F4F\u6703\u54E1\u81F3\u591A\u98FC\u990A1\u96BB\u5BF5\u7269\uFF0C\u98FC\u990A\u5BF5\u7269\u4EE5\u8C93\u8207\u72D7\u70BA\u9650\u3002\uFF08\u7279\u6B8A\u60C5\u6CC1\uFF0C\u61C9\u7D93\u7396\u6A13\u540C\u610F\u59CB\u5F97\u651C\u5165\uFF09\n2.\u98FC\u990A\u5BF5\u7269\u4E4B\u5165\u4F4F\u6703\u54E1\u6BCF\u6708\u9808\u984D\u5916\u652F\u4ED8\u65B0\u53F0\u5E631,500\u5143\u6574\u4E4B\u5BF5\u7269\u5165\u4F4F\u8CBB\u7528\u3002\uFF08\u5C0E\u76F2\u72AC\u4E0D\u5728\u6B64\u9650\uFF0C\u4E14\u7121\u9700\u984D\u5916\u914C\u6536\u8CBB\u7528\u3002\uFF09',
		extraPersionDescription: '玖樓之居住空間僅限於與玖樓成立訂單之入住會員1人居住使用。若入住會員承租之居住空間使用者超過1人之情況每月超過10日，玖樓得提前解約，或請求該入住會員每月需額外支付新台幣2,000元整之第二人入住費用。第二人於居住空間之使用規範與違規處理原則，與入住會員之規範相同。'
	},
	roomFilter: {
		select: '請選擇',
		city: '城市',
		neighborhood: '區域',
		MRT: '捷運站',
		MRTLine: '捷運線',
		surroundingMRT: '顯示周遭捷運站結果',
		station: '{{station}}站',
		line: '{{line}}線',
		type: '房型',
		anticipatedMovein: '預訂入住日期',
		chooseMonth: '月份複選',
		monthlyRent: '價格/月',
		limit: '上限/下限',
		particularApartment: '顯示特定居住空間',
		chooseApartment: '選居住空間',
		advancedSearch: '進階搜尋',
		size: '房間坪數',
		twoResidents: '第二人入住',
		all: '全部',
		allowed: '可以',
		notAllow: '不可以',
		pets: '養寵物',
		special: '居住空間特色',
		showUnavailable: '顯示目前無法預訂房間',
		clear: '清除'
	},
	roomType: {
		MEN_LIVING: '男生宿舍房',
		WOMEN_LIVING: '女生宿舍房',
		CO_LIVING: '混合宿舍房',
		ROOM: '雅房',
		STUDIO: '獨立套房'
	},
	roomStatus: {
		RENTED: '未開放',
		AVAILABLE: '招募中',
		FULL: '額滿'
	},
	room: {
		additional: '首期款項',
		monthAdditional: '每月小計',
		deposit: '押金',
		monthlyRent: '月租金',
		energyPrice: '能源費',
		energyPriceDescription: '能源費為入住會員共同分擔之居住空間使用費用，包含：水費、電費、天然氣費以及網路費等費用。',
		serviceFee: '服務費',
		serviceFeeDescription: '服務費為入住會員共同分擔之共享空間清潔管理費用及垃圾收取服務費。',
		shortRent: '短租方案',
		shortTerm: '短租',
		month: '月',
		info: '房間資訊',
		apartmentInfo: '居住空間資訊',
		type: '房型',
		size: '面積',
		ping: '坪',
		amenities: '房間設備',
		apartmentAmenities: '居住空間設備',
		neighborAmenities: '附近機能',
		transportation: '交通資訊',
		recommended: '房源推薦',
		recommendedApartment: '附近公寓',
		balcony: '陽台',
		kitchen: '廚房',
		sharedBathrooms: '公共衛浴',
		bedrooms: '房間',
		totalFloors: '總樓層',
		elevator: '是否有電梯',
		cleaningService: '清潔打掃',
		garbageDisposal: '垃圾處理',
		more: '更多',
		yes: '有',
		no: '無',
		roomSize: '坪',
		floor: '樓',
		room: '間',
		hasPet: '可以養寵物',
		roommate: '室友'
	},
	rooms: {
		UpToDate: '最新',
		HighestPrice: '最高價格',
		LowestPrice: '最低價格',
		location: '地點',
		price: '價格',
		advancedSearch: '進階搜尋',
		results: '筆結果',
		SortBy: '排序方式',
		More: '更多'
	},
	roomComponent: {
		photos: '所有照片'
	},
	userTabs: {
		overview: '總覽',
		settings: '設定',
		favorites: '收藏',
		viewingHistory: '預約紀錄',
		reservationHistory: '入住紀錄',
		request: '聯繫我們',
		onlineCommunity: '線上社群'
	},
	userOverview: {
		welcom: '歡迎加入！完成會員申請剩下最後一步，完成申請資料，讓我們再更認識您吧！',
		account: '我的帳號',
		editProfile: '修改個人資料',
		currentOrder: '目前預訂',
		checkinTime: '確認入住時間',
		details: '查看詳情',
		recent: '最近預約',
		incomplete: '哎呀！申請還差一步，趕緊到設定頁完成資料填寫，送出申請吧!',
		underPreview: '申請資料審核中',
		reject: '嗨！很抱歉您的資料未通過審核，可能是資料填寫不夠完全或是資料有誤，歡迎修正後再次送出申請 或是與我們聯繫。',
		needCheckin: '嗨！很快就是正式入住的日子，提醒您，記得於 {{startDate}} 前預約入住時間！',
		needCheckout: '時光飛逝，很快就來到要退房的日子了。提 醒您，記得於 {{endDate}} 前預約退房時間哦！',
		reserveMovein: '預約入住時間',
		reserveCheckout: '預約退房時間',
		member: '會員'
	},
	bookingRecordCard: {
		address: '地址',
		date: '訂單日期',
		moveinTime: '入住時間',
		moveinAppointment: '預約入住時間',
		checkoutAppointment: '預約退房時間',
		renew: '訂單續約',
		changeOrder: '訂單異動',
		download: '合約下載',
		changePayment: '變更付款方式',
		review: '待審核',
		cancel: '已取消'
	},
	bookingPayment: {
		DONE: '已收款',
		NEXT: '下一筆收款款項',
		WAIT: '待收應收款項',
		paymentHistory: '扣款紀錄',
		initialPayment: '首期款項',
		total: '總計：'
	},
	certificateType: {
		IDENTITY: '身分證',
		PASSPORT: '護照',
		userAddress: '戶籍地址或原國家居住地址',
		userAddressTooltip: '身分證件上之居住地址',
		certificateData: '證件資料',
		extraCertificateData: '第二入住人證件資料',
		certificateDescription: '請使用與基本資料裡姓名欄位相符的證件。',
		certificateField: '身分證字號 or 護照號碼。',
		emergencyName: '緊急聯絡人姓名',
		emergencyTelephone: '緊急聯絡人電話',
		emergencyRelationship: '緊急聯絡人關係',
		emergencyAddress: '緊急聯絡人地址',
		selectFile: '選擇檔案',
		passportType: '證件類型',
		passportNumber: '證件號碼',
		passportNumberTooltip: '身分證字號or護照號碼。',
		basicInformation: '個人資料',
		communityProfile: '社群資料',
		name: '姓名',
		fullName: '姓名全名 ',
		sex: '生理性別',
		dateOfBirth: '生日',
		nationality: '國籍',
		workingArrangements: '工作型態',
		skills: '專長',
		phoneNumber: '聯絡電話',
		personalIntroduction: '自我介紹＆',
		expections: '對社群的想像',
		next: '下一步',
		back: '上一步',
		term: '入住條款',
		agreeTerm: '我已詳閱，並同意此入住條款',
		insurance: '保險政策',
		insuranceContent: '我同意玖樓將為入住會員投保第三人責任險，將使用會員身份相關資料(本國籍身分證字號/護照號碼、生日、戶籍地址、聯絡號碼)進行加保。',
		agreeInsurance: '我已詳閱，並同意此保險政策'
	},
	modalLoginSignup: {
		forgetPasswordSendSuccess: '信件已寄出至 {{email}}，趕緊收信去吧！',
		verifySuccess: '信箱驗證成功！請完善個人資料，以完成申請流程。',
		welcomeBack: '「嗨！歡迎回來」',
		SignupLoginFail: 'oops! 帳號或密碼有錯哦，請重新輸入。',
		verifyEmailFail: '請輸入正確的 Email 格式',
		verifyPasswordFail: '密碼需要至少8個英數混合的字元喔！',
		verifyCheckPasswordFail: '你輸入的密碼不一致，請重新輸入',
		verifyAgree: '要同意服務條款才能註冊成功喔！',
		verifyFail: '您尚未驗證信箱喔！請點擊按鈕重新寄送認證信。',
		vipTokenFailed: '此驗證碼不存在，請直接註冊或聯繫工作人員（電話：+886 908959613）',
		agree: '同意',
		termsofService: '服務條款',
		register: '註冊新帳號',
		already: '已經註冊',
		loginNow: '立即登入',
		successful: '註冊成功',
		verification_email: '為確保後續服務流程順暢，請先前往驗證信箱唷！',
		back: '回首頁',
		resend: '重寄認證信',
		rememberMe: '記住我',
		login: '登入',
		forgot: '忘記密碼了嗎',
		reset: '點我重設',
		not_a_member: '還不是會員',
		application: '申請加入',
		resetPw: '忘記密碼了呀，沒關係，快來重設吧！',
		send: '送出',
		newPassword: '新密碼設定',
		placeholder1: '新密碼',
		placeholder2: '新密碼確認',
		becomeResident: '成為玖樓村民，一起探索城市、一起分享生活。 ',
		young: '年輕漂泊，',
		year: '最美好的那幾年。'
	},
	about: {
		bannerTitle: '關於玖樓',
		title1: '房子是租來的，但生活不是',
		title1Split1: '房子是租來的',
		title1Split2: '但生活不是',
		describe1: '成立於2015年，租不到像樣房子的台北，玖樓開始改造了10間老公寓，打造客廳、廚房成為類似咖啡館的半開放空間，簡約的設計吸引百餘位來臺北尋求夢想的學生、上班族、自由工作者、國際人士。新穎的物管模式，也吸引了許多屋主合作，掀起老屋欣立的新風潮。玖樓相信，人們不只在都市工作創業、上學實習，更應該「住」進一個社群，因著室友的共同生活互動，共享空間、知識、經驗與快樂。',
		title2Split1: '不只是硬體設備，更關乎人',
		title2Split2: '與人之間的關係',
		title2Split3: '不只是硬體設備，',
		title2Split4: '更關乎人與人之間的關係',
		describe2: '藉著空間設計、管理服務以及會員制的經營，玖樓致力於提升空間居住與物業管理品質，提供市場更好的居住選擇。讓室友們一起共食、看電影，工作、讀書會或小型聚會自然地發生在日常家裡，藉由共同居住、生活，在一般認為私密的空間裡，創造人與人的連結、營造出公共性的可能。',
		title3Split1: '重新建立社區，',
		title3Split2: '共同實踐理想生活的樣貌',
		describe3: '作為一個關注社會創新的品牌，玖樓近年透過許多社群活動串連橫跨不同領域的住客。同時我們也打造實體跨世代的共同生活空間如三峽青銀共居宅，持續回應我們為自己設定的挑戰；如何打造城市裡更友善、更有趣、更宜居的生活體驗。透過社群經營與串連，讓社區互相支持的概念跨越實體空間，與住民共同實踐理想生活的樣貌。',
		qouteblock: '加入我們，分享彼此的世界，如約翰藍儂曾《想像》的那樣。',
		moreButton: '更多物件'
	},
	bookingFinish: {
		congratulations: '恭喜您！',
		content: '完成入住預訂。我們將儘速進行審核。再次感謝您的預訂，期待我們在玖樓相見！',
		checkDetails: '查看預訂詳情',
		returnToRoom: '返回房間頁'
	},
	page404: {
		headerText: '噢不！這裡似乎不是您要找的頁面。',
		paragraph: '錯誤代碼：404',
		buttonText: '回首頁'
	},
	contact: {
		contact: '聯繫',
		support: '客服',
		message: '點此留下訊息，讓我們能提供更好的協助，',
		request: ' ',
		inquiries: '其他疑問與服務需求，請聯繫 {{link}}',
		contactUs: '聯繫我們',
		respond: '居住問題通報',
		property: '物業夥伴',
		propertyDescription: '物業委託管理服務，歡迎留下{{link}}，我們會儘速與您聯繫',
		work: '工作夥伴',
		workDescription: '加入玖樓團隊，請參考{{link}}',
		investment: '投資夥伴',
		investmentDescription: '如果有興趣與我們一起創造更棒的居住生活產業，請聯繫{{link}}',
		media: '媒體',
		mediaDescription: '親愛的媒體夥伴，如想更深入了解玖樓，請至{{link}}查看詳情',
		cooperation: '合作提案',
		cooperationDescription: '歡迎留下{{link}}，我們會儘速與您聯繫',
		consulting: '顧問諮詢',
		consultingDescription: '空間規劃諮詢，歡迎留下{{link}}，我們會儘速與您聯繫',
		space: '空間基本資料與需求',
		teamPage: '團隊',
		mediaPage: '媒體頁',
		proposal: '相關資料',
		become: '成為'
	},
	service: {
		serviceGuide: '服務說明',
		member: '1. 玖樓會員',
		suTitle1: '為什麼要成為會員？',
		description1: '一直以來，玖樓努力打造更多更好的共同生活空間，但我們也明白，並非所有人都適合共同生活的概念。我們希望為追求自由開放與尊重多元的社群努力，並為社群的品質做把關。因此有別於一般的租賃招租，我們以會員制進行申請審核。一但通過審核，就是我們社群的一員、在不同階段可以享有我們的不同服務、包含社群活動、社群空間使用、居住空間的即時預訂入住等。同時我們也希望，透過持續的創新，未來提供更多的數位線上服務，建立真正無疆界的共生社區。',
		blockquoteTitle1: '我們在尋找的社群會員',
		blockquoteList1: '1.認同{{link}}的理念與社群文化',
		blockquoteList2: '2.尊重多元的社群樣貌，開放的面對與自己不同的價值或文化',
		blockquoteList3: '3.樂於分享，願意與社群一同共創成長',
		blockquoteList4: '4.勇於接受挑戰、嘗試解決問題',
		blockquoteList5: '5.互動隨和但生活不隨便',
		formTitle: '等級與權限',
		rowTitle1: '村民等級',
		rowTitle2: '審核方式',
		rowTitle3: '優惠權限與服務項目',
		rowTitle4: '說明',
		columnTitle1: 'L1-一般會員',
		column1Row1: '於網站送出申請資料後，通過審核者將會於2-3天內收回覆通知。',
		column1Row21: '1.看房 3 次/30天',
		column1Row22: '2.社群電子報',
		column1Row23: '3.玖樓社群活動',
		column1Row3: '我們邀請認同自由與多元價值的你成為玖樓會員。通過後即享有看房服務、活動最新資訊，一起參與城市裡共生共創的玖樓社群。',
		columnTitle2: 'L2-認證會員',
		column2Row1: '透過預約看房、線上面談、活動參與等進一步了解彼此後，我們將視審核結果邀請成為認證會員。',
		column2Row21: '1.看房 3 次/30天',
		column2Row22: '2.社群電子報',
		column2Row23: '3.玖樓社群活動',
		column2Row24: '<b>4.即時預定房源</b>',
		column2Row3: '我們歡迎所有人，但共同生活不見得適合每個人。為了營造自由開放與彼此尊重的多元社群，並為共同生活的品質把關。我們會依照面談與實際接觸的情形進行審核評估後，發送邀請信給與我們理念契合的會員。一但升級為認證會員後便可隨時預定玖樓房源！',
		columnTitle3: 'L3- 入住會員',
		column3Row1: '預訂入住成功後即為入住會員。',
		column3Row21: '1.看房 3 次/30天',
		column3Row22: '2.社群電子報',
		column3Row23: '3.玖樓社群活動',
		column3Row24: '4.即時預定房源',
		column3Row25: '<b>5.合作店家隱藏優惠</b>',
		column3Row26: '<b>6.線上社群功能</b>',
		column3Row3: '入住玖樓，成為一起生活的夥伴吧！入住會員享有合作店家優惠、專人客服、空間服務、以及持續更新推出的相關線上社群功能。在玖樓，你的室友將不只局限於同個屋簷，而是整個共享社群。',
		reservationExpantation: '2. 線上預約流程說明',
		description21: '無論是看房、諮詢、訪談、入住、退房等項目皆使用玖樓線上預約系統進行。',
		description22: '預約看房為<b>一般會員</b>以上等級方可使用的功能，每月我們提供3次的看房機會，流程如下:',
		description23: 'Step1：找到喜歡的公寓，點選預約看房，開始預約',
		description24: 'Step2：選取預計看房的時間，送出預約申請',
		description25: 'Step3：預約成功且收到看房相關資訊',
		blockquoteTitle2: '以下幾點規則也希望會員能夠留意我們的變更/取消規則：',
		blockquoteList21: '1.變更/取消預約需在24小時前會員頁進行變更',
		blockquoteList22: '2.如臨時不能來了或延後抵達時間，請主動並提前致電給工作人員',
		blockquoteList23: '3.遲到未主動通知或無故未到 ，兩個月內將無法預約及預訂玖樓公寓',
		blockquoteList24: '4.當次預約，如因其他會員完成預定入住此房間，我們將第一時間以email進行變更通知。如距離原訂時間24 小時內，我們會以專人與你電話聯繫。',
		bookingExpantation: '3. 線上預訂流程說明',
		description31: '線上預訂流程為<b>認證會員</b>專屬之功能',
		blockquoteTitle3: '六步驟完成預訂！',
		blockquoteList31: 'Step1: 至釋出的房間頁面點選“預訂入住”,開始預訂',
		blockquoteList32: 'Step2: 仔細確認訂單資訊，並詳閱入住條款',
		blockquoteList33: 'Step3: 完成付款方式綁定',
		blockquoteList34: 'Step4: 完成預訂手續後，玖樓將於一個工作天進行審核並確認會員預訂資料正確無缺失',
		blockquoteList35: 'Step5: 完成預訂手續，預約入住時間',
		blockquoteList36: 'Step6: 暖心社群經理帶你入住玖樓新居',
		description32: '曾預約看房、{{link}}、參與社群活動等與我們有進一步互動的一般會員，我們將主動邀請當中合適且感興趣入住玖樓者，升級為{{strong}}，申請方式請參照第一點會員等級說明。',
		description33: '預訂入住僅限定會員本人入住，於流程中我們將進行身份驗證，切勿使用他人帳號進行預訂，如有違反經舉發，我們將取消會員資格，詳細參見我們的{{link}}。',
		payRefundExpantation: '4. 金流扣繳與退款說明 ',
		description41: '玖樓使用藍新金流NewebPay為支付系統， 支援 Visa, MasterCard, JCB 之信用卡、簽帳金融卡。',
		blockquoteList41: '1.訂單設定完成後，將於每月自動扣款。如有需要，可隨時至會員頁查看扣款紀錄。',
		blockquoteList42: '2.每月扣款日為租約起始日期。',
		blockquoteList43: '3.除了首期款項以外，我們並不會預扣金額。',
		blockquoteList44: '4.如有需要，未來仍可於會員頁變更扣款帳戶。',
		blockquoteList45: '5.如使用非台幣銀行卡，相關匯率以及手續費將由入住會員自行吸收，實際詳情請自行與銀行確認。',
		onlineCommunityRule: '5. 線上社群準則',
		description51: '線上社群目前為入住會員限定的最新功能。前往會員設定頁完成興趣標籤、instagram串連、最愛的歌曲等設定，並選擇公開即可有機會讓更多的室友認識你。同時你也能在線上社群裡快速搜尋趣味相投的村民，與這個無疆界的社群一起共同生活！',
		description52: '作為一個社群交流的平台仍有幾點需要大家一起遵守，如有違反經舉發，我們將列入計點，詳細參見我們的{{link}}',
		blockquoteTitle5: '第一次被玖樓拒絕往來就上手',
		blockquoteList51: '1.嚴禁蓄意地針對和欺凌。',
		blockquoteList52: '2.擅自散播他人的個人資訊或聯繫資訊。',
		blockquoteList53: '3.八卦：共同生活不代表要討論他人的私生活。',
		blockquoteList54: '4.缺乏尊重：與居民，鄰居和社區保持良好的關係。',
		blockquoteList55: '5.歧視：禁止基於宗教、性別、種族或經濟條件的歧視。',
		blockquoteList56: '6.性騷擾。',
		coliving: '共同生活',
		property_viewings: '線上面談',
		certified_members: '認證會員',
		terms_of_stay: '入住條款'
	},
	printOrder: {
		reservation: '住宅轉租契約（以下稱本契約）於民國{{link}}經承租人攜回審閱3日（契約審閱期間至少三日）。',
		printButton: '列印',
		invoiceInformation: '訂單資訊',
		orderDate: '訂單成立日期',
		room: '私人空間',
		apartmentAddress: '居住空間地址',
		movieInDate: '契約起始日期',
		checkoutDate: '契約結束日期',
		termsOfService: '入住條款',
		description: '立契約書人包租業共宅一生股份有限公司，入住會員 {{link}} 茲為住宅租賃事宜，雙方同意本契約條款如下：',
		companyInformation: '包租業資訊',
		companyName: '名稱',
		companyNameValue: '共宅一生股份有限公司',
		companyResponsible: '代表人姓名',
		companyResponsibleValue: '潘信榮',
		company: '名稱',
		companyNo: '統一編號',
		RegistrationCertificateNumber: '登記證字號',
		RegistrationCertificateNumberValue: '(107) 北市租登字第0003號',
		companyAddress: '營業地址 ',
		companyAddressValue: '台北市萬華區和平西路三段64號',
		user: '承租人（即入住會員）資訊',
		userName: '姓名',
		userBirthday: '出生年月日',
		userType: '證件類別',
		userNumber: '證件號碼',
		userTelephone: '聯絡電話',
		userAddress: '戶籍地址',
		emergencyContact: '緊急聯絡人',
		emergencyName: '姓名',
		emergencyTelephone: '電話',
		emergencyAddress: '地址',
		emergencyRelationship: '關係',
		manager: '租賃住宅管理人員',
		name: '姓名',
		certificateNumber: '證書字號',
		residentAddress: '通訊地址',
		residentAddressValue: '台北市萬華區和平西路三段64號',
		phoneNumber: '聯絡電話',
		mailAddress: '電子郵件信箱'
	},
	termsOfService: {
		serviceTerms: '服務條款',
		paragraph1: '歡迎加入玖樓（共宅一生股份有限公司）',
		paragraph2: '所謂「玖樓」是以藉由將空間經營與媒合或空間企劃服務等資訊介紹給各位消費者，為中華民國住宅法認定之租屋服務事業，並營運玖樓網站）',
		paragraph3: '（包括但不限於以jp/tw為網域之網站。以下簡稱「本網站」，包含如無論任何理由新增網域或内容，或為其他變更時，新增或變更後之網站。）',
		paragraph4: '以及提供本網站上所提供之服務（包括但不限資料提供以及社群媒體。）',
		paragraph5: '或提供其他相關服務之專案統稱（以下簡稱「玖樓專案」。）。',
		paragraph6: '身為玖樓營運母體之玖樓團隊將依以下利用規約（簡稱「本規約」。）向客戶提供服務、資訊。以下所謂之「玖樓」依文脈應個別或概括地代表玖樓專案、本網站或組成玖樓團隊之個人或法人。',
		paragraph7: '如客戶利用玖樓時，將視為已同意本規約，請仔細閱讀本規約。此外，如客戶將使用玖樓現在或未來的服務，連結至玖樓合作廠商網站或購買其商品時，無論本網站是否內含該等資訊，應遵從該服務或業務所適用之指導方針及利用規約。該等本規約以外之指導方針及利用規約內容、以及玖樓之服務說明等，如異於本規約內容，以本規約規定為優先適用。',
		title1: '關於隱私權 ',
		paragraph8: '隱私權政策適用於客戶利用玖樓時。',
		paragraph9: '煩請詳讀並予以理解。',
		title2: '電子通訊',
		paragraph10: '如客戶利用玖樓、或寄電子郵件予玖樓時，即表示客戶與玖樓正採用電子通訊之方式。',
		paragraph11: '客戶應預先同意由玖樓以寄信至客戶所註冊之電子信箱或於本網站刊登通知之方法或其他透過本網站進行之方法予以聯絡，以作為進行服務之營運上之告知、廣告、或作為功能之一環。客戶應同意玖樓以電子方式向客戶為所有合意、通知、資訊揭露或其他聯絡，係符合法律上以書面聯絡之要求。',
		title3: '著作權',
		paragraph12: '透過玖樓提供之所有內容物（包括但不限於文字、平面視覺設計、LOGO、按鈕圖示、圖片、影像、音頻片段、以數位形式下載者、加以編輯之檔案）為玖樓或內容物提供人之財產，受中華民國、日本著作權法及著作權相關國際法所保護。經玖樓提供之所有內容物之編輯物為玖樓之獨占財產，受中華民國、日本著作權法及著作權相關國際法所保護。經玖樓所提供之資訊及圖片等，謝絕未經許可之轉載。',
		title4: '利用之許可及網站之連結 ',
		paragraph13: '作為遵守本規約之條件，玖樓或內容物提供人授予客戶限定性、非獨占性、非商業性以及個人利用玖樓之權利（不得轉讓及再授權）。該利用之許可不包括玖樓或該內容物之轉售以及商業目的之利用、產品表單、解說、價格等之收集與利用、玖樓或該內容物之二次使用、為他人進行帳戶資料之下載與複製、資料探勘、機器人等之資料收集、抽取工具之使用。',
		paragraph14: '本規約或其他規約未明示授權之權利，均由玖樓N或其授權人、供應者、出版人、權利持有人或其他內容物權利人所保留。玖樓或其任何部分，除非獲得玖樓書面之明示性承諾，不得為商業目的之重製、複印、拷貝、銷售、轉售、連結或為其他利用。LOGO及玖樓所有之其他有財產權價值之資訊（包括但不限於圖像、文字、頁面布局、形式）除非取得書面之明示性承諾，不得採用框架(Frame)或使用框架技術套用之。禁止不當利用玖樓，僅得依適用之法律予以利用。其使用違反本規約及其他利用條件時，玖樓得於其裁量下，未經預告取消或終止授權、拒絕提供服務或停止帳戶。',
		title5: '帳戶',
		paragraph15: '利用本網站時，維護客戶帳戶與密碼之機密性、限制連結至電腦之責任是在客戶身上。此外，對於使用本身帳戶與密碼進行一切事項之責任，應同意縱於第三人未經客戶本人同意為之時或不當使用時，亦視為客戶自身所為之行為，將負一切責任。此外，如客戶將帳戶及密碼資訊洩漏予第三人時、或有洩漏之虞時，應盡速聯絡玖樓。玖樓得於獨自裁量下，未經事前通知，停止或終止該帳戶及密碼於本網站之利用。無論客戶有無故意過失，關於起因於帳戶及密碼遭盜用、遺失、第三人之不當使用，所導致暫時性停止使用或終止本網站等所生之一切費用（包括但不限於原因調査費用、防止再次發生之對策費用、律師費用、客訴因應費用等。）、損失及損害，客戶不得向玖樓提出請求。',
		paragraph16: '玖樓於其裁量下，保留未經預告拒絕提供服務、停止帳戶、刪除與編輯內容物、變更及停止活動或宣傳等之權利。',
		title6: '註冊事項之變更',
		paragraph17: '如EMAIL信箱等連絡方式或其他註冊事項變更時，應依所定方法，及時通知該變更事項。因客戶未提供正確聯絡方式或其他註冊事項以致受有無法獲取玖樓服務等不利益，玖樓概不負責。',
		title7: '致未成年之客戶 ',
		paragraph18: '依客戶所在國或地域之法令被認定為未成年者，請取得親權人或其他法定代理人同意後再進行註冊。如判斷確定未取得同意等，玖樓得立即拒絕提供服務以及停止帳戶。',
		title8: '評價、留言、通訊、其他內容物',
		paragraph19: '利用玖樓之客戶得進行留言、貼圖或其他內容物之發文、傳送提案、想法、意見、問題或其他資訊。但該等內容包括違反法令、猥褻、脅迫、毀損名譽、侵害隱私權、侵害智慧財產權、毀謗中傷第三人、令人感到不悅、或軟體病毒、政治主張、商業目的之勸誘、連鎖信、大量發信或所謂「垃圾信」，以及違反刑法第360條者，則不在此限。不得使用虛偽之EMAIL信箱、冒充他人或組織、其他內容物之出處進行招致誤解之行為。玖樓保有將該等內容刪除或編輯之權利（並非義務），但並非定期確認發文內容。',
		paragraph20: '客戶進行內容物之發文或傳送素材時，除非本網站明示其他決定，應視為客戶授予玖樓使用、重製、變更、改作、公開、翻譯該等內容物、作成、散布第二次著作物、得以所有媒體型態向全世界表示其為非獨占性、無償、永續性、無法取消、包括完整再授權之權利。客戶於玖樓與被轉授權人希望時，視為客戶就該等內容物對其授權使用客戶發文名稱之權利。此外，客戶不得對玖樓或玖樓再授權之第三人行使著作人格權。客戶應聲明、保證保有或管理自身發文內容物相關所有權利、該內容物係屬正確、所提供內容物之使用並未違反此政策、未傷害任何他人或組織、就起因於其提供之內容物之所有請求向玖樓提出補償。玖樓不保證確實記錄或保存發文之資訊或素材。縱使該等資訊或素材之全部或部分消失、變樣或外流，無論其原因為何，玖樓概不負責。玖樓保有監視、編輯或刪除任何行為或內容物之權利，但並無義務。玖樓對於客戶或第三人發文之任何內容物亦不負責，未生義務。',
		title9: '侵害智慧財產權之相關聲請',
		paragraph21: '玖樓尊重他人智慧財產。經判斷客戶之著作物於本網站上，遭以如構成侵害著作權或智慧財產之方法複印或使用時，請依玖樓適當指定之智慧財產權侵害相關聲請程序，提出聲請。',
		title10: '商品及服務說明',
		paragraph22: '玖樓將致力於盡可能保持正確性。但玖樓不保證商品説明或本網站其他內容正確、完整、具信賴性、為最新內容、或係為無誤。',
		paragraph23: '請留意本項規定僅適用於玖樓所介紹之商品。',
		title11: '得利用玖樓之軟體條件',
		paragraph24: '利用玖樓時，推薦以下瀏覽器之最新版本。',
		paragraph25: 'Google Chrome',
		paragraph26: 'FireFox',
		paragraph27: 'Safari',
		title12: '由第三人提供',
		paragraph28: '玖樓不對身為第三人之企業或個人、第三人之行為、商品、內容物負任何責任，亦不產生義務。建議請仔細閱讀各公司之隱私權相關文件與利用規約。',
		title13: '免責事項',
		paragraph29: '除非另有書面規定，客戶得透過玖樓及本網站利用之所有資訊、內容物、素材、商品（包含軟體）及其他服務，玖樓以「現狀之原有狀態」及「得提供之限度」提供之。玖樓除非另有書面規定，就玖樓之營運或本網站或玖樓所登載資訊、內容物、素材、商品無論其為明示或黙示，不為任何種類之聲明與保證。並視為客戶已明示同意以自身責任利用玖樓。特別就本網站保存之資料消失，或伺服機運轉停止所發生之客訴、爭議、損害賠償請求等情況之一切損害、責任，視為已明示同意免除玖樓責任。',
		paragraph30: '玖樓並未就客戶透過玖樓及本網站得以利用之所有資訊（以下簡稱「提供之資訊」。）相關商品或服務之購買、出售、持有或利用、或該等申請（以下統稱「購買等行為」。）為任何推薦。',
		paragraph31: '關於提供之資訊內容可能隨時變化，故請客戶勿全面依據提供之資訊，而係依自身判斷進行購買商品或服務等行為。無論其是否經由本網站，玖樓就客戶所為之商談或契約並非當事人，亦不對商議業務予以對應，且概不負責。',
		paragraph32: '玖樓不介入以利用本網站為契機發生之所有客戶間之協商、交易。就客戶間之交易所發生各種作業、連絡、法律義務之履行及問題處理等，應由客戶間負責為之。就起因於利用本網站為契機所為交易之損害，及起因於揭露提供之資訊一事本身之損害，玖樓概不負責。',
		paragraph33: '玖樓就得透過本網站連結或取得之產品或服務，於適用之法律所認可之範圍內，無論其為明示或默示，不為一切保證（包括但不限於未違反特定目的，及就該目的具市場性或合適性者。）。玖樓不保證資訊、內容物、材料、商品（包含軟體）、包含於玖樓其他服務或由其提供之服務、伺服器、由玖樓寄送之EMAIL，未感染病毒或其他有害因子。',
		paragraph34: '玖樓對於使用玖樓所生之任何種類之損害，包含但不限於直接、間接、附隨、懲罰性、必然性之損害亦不負責。',
		title14: '準據法',
		paragraph35: '利用玖樓時，視為已同意無論法律牴觸原則為何，以中華民國國內法規範利用此規約，以及客戶與玖樓或支援玖樓之企業間可能發生之，與玖樓有關之所有類型爭議。',
		title15: '爭議',
		paragraph36: '關於連結至本網站以及利用規約相關之爭議，除法律認可之管轄法院外，附加指定台北地方法院為合意管轄法院。但關於身為企業經營者之客戶，指定台北地方法院為專屬之合意管轄法院。',
		title16: '網站之營運方針、變更、可分性',
		paragraph37: '詳閱登載於本網站關於價格等事宜之本網站營運方針。該等方針亦就客戶利用玖樓一事予以規範。玖樓保留得隨時變更本網站、營運方針、利用規約之權利。該規約之一部分為不當或無效、或因任何理由而無法施行時，該規約視為可分，不影響此部分以外規約之有效性及拘束力。',
		title17: '關於本網站之營運母體',
		paragraph38: '本網站由玖樓團隊進行管理營運。就本規約中規定玖樓得持有或行使之一切權限及權利暨免責事項，以及支援玖樓之企業或其從業人員得行使或為主張。',
		title18: '詢問信箱',
		paragraph39: 'EMAIL: support@9floor.co',
		title19: '個人資料保護方針',
		paragraph40: '各位客戶您好:<br />關於此文件，請於提供玖樓個人資料前閱讀一遍。於您同意後，將提供個人資料所伴生之各種服務。',
		subTitle1: '1. 個人資料之收集、處理及利用目的',
		listDescription1: '・本服務就所取得之客戶個人資料，將以下揭目的（以下簡稱「利用目的」）利用之。',
		listTitle1_1: '(1)  本服務會員身份之利用',
		listItem1_1: '・作為註冊本服務會員利用服務時之登入時及登入後之身份認證、各種畫面中之會員資料自動顯示。',
		listTitle1_2: '(2)  本服務所提供交易之完成',
		listItem1_2: '客戶參加抽獎、線上報名等活動、回應客戶所詢問題、由本服務向客戶提出詢問、相關售後服務、其他完成交易所需業務。',
		listTitle1_3: '(3)  本服務之廣告宣傳或行銷等',
		listItem1_3_1: '・提供客戶各種電子報等資訊。',
		listItem1_3_2: '・以電子郵件、郵寄信件、電話等提供服務相關資料。',
		listItem1_3_3: '・對於客戶瀏覽之內容物或廣告依客戶之性別、年齡、居住地、興趣/嗜好等個人屬性或購物紀錄及本服務網站之瀏覽紀錄設定個人化資料。',
		listItem1_3_4: '・伴隨分析客戶於本服務之利用内容，開發新服務或改善現有服務。',
		listItem1_3_5: '・進行意見調查、活動、評價等與服務相關之客戶聯絡。',
		listTitle1_4: '(4)  回應客戶所詢問題',
		listItem1_4: '・回應客戶於本服務以電子郵件、郵寄信件等所為之詢問。',
		listTitle1_5: '(5)  其他伴隨本服務之利用',
		listItem1_5: '・伴隨上述(1)至(4)，就本服務之提供判斷有必要而利用之情況。',
		listTitle1_6: '(6)  提供予服務提供人',
		listItem1_6: '・依「3.個人資料等之提供/委託」提供個人資料予服務提供人。',
		listTitle1_7: '(7)  其他',
		listItem1_7: '・於個別服務亦可能以未規定於上揭內容之目的利用個人資料。於此情形時，將於個別服務網站中登載該內容。',
		subTitle2: '2. 個人資料之取得方法、利用期間與地區',
		listDescription2: '服務之提供方面，主要是取得如下之客戶相關資料。將取得之項目為非必要項目，而無法取得該項目時，可能無法提供本服務、回應客戶所詢問題等事宜，敬請見諒。',
		listDescription2_1: '再者，以下為例示，此外，依資料具體內容亦可能有未符合個人資料之情形，得依利用目的之差異或需求，增刪已收集之個人情報類別與項目，敬請見諒。',
		listTitle2_1: '(1)  客戶提供之資訊',
		listItem2_1: '・姓名、性別、出生年月日、居住地、使用語言、宗教、電子信箱、手機信箱、現在身處位置相關資訊及入住村民會員調查表之回答資訊等客戶所提供之一切資料。',
		listTitle2_2: '(2)  與利用服務有關而取得之資訊',
		listItem2_2: '・客戶申請玖樓提供之社群活動、或其他交易時之得以辨識客戶之資訊，與係屬附帶狀態之交易紀錄相關資訊。',
		listTitle2_3: '(3) 以連結為契機，機械上所取得之資訊',
		listItem2_3_1: '・客戶電腦連結網路時使用之IP位置、手機之機體辨識相關資訊（包含連結地點之資訊）。',
		listItem2_3_2: '・除以連結本網站為契機取得之所使用瀏覽器種類/版本、作業系統、平台等外，客戶瀏覽之網頁 (URL)、瀏覽日期時間、標示或查閱商品等相關資訊。',
		listItem2_3_3: '・除上述外，使用小型文字檔案(cookie)或網頁信號(web beacon)之技術取得之連結資料等，於每次客戶利用本服務自動收集/保管之資料。',
		listTitle2_4: '(4) 個人資料利用期間:自客戶最新登入日起算之一年間。但帳號遭刪除時，客戶的個人資料也將一併被刪除。',
		listTitle2_5: '(5) 個人資料利用地區:台灣、日本',
		subTitle3: '3. 個人資料等之提供/委託',
		listDescription3: '本服務依中華民國之個人情報保護法處理個人資料，除法令規定之情況外，未經客戶許可，未有將該資料揭露、提供予第三人之情形。但亦有於達成利用目的所需之範圍內，提供客戶個人資料、或委託處理個人資料之情形。於此情形下，於第三人之契約規定將進行與本文件同樣之資料管理，適當確認第三人身份及由第三人所為之管理體制。',
		listTitle3_1: '(1) 提供/委託之目的同於「1. 個人資料利用目的」。',
		listTitle3_2: '(2) 提供之個人檔案與「2.個人資料之取得方法」相同。',
		listTitle3_3: '(3) 提供、委託人之範圍為業務上所需服務之提供人。',
		listTitle3_4: '(4) 提供之手段、方法為本服務管理系統、CD-ROM等電子媒體、紙面等類比媒體等。',
		listTitle3_5: '(5) 要求停止向提供人、委託人提供資料時，請採取「5. 個人資料利用目的之通知、揭露、訂正/新增/刪除或利用之停止/消去/停止提供予第三人」之程序。',
		subTitle4: '4. 個人資料之保護',
		listDescription3_2: '就客戶所提供之個人資料為適當管理，為防止個人資料之洩漏、滅失、或毀損，乃從技術及管理面採取適當且合理之保護處置。此外，本服務約定依係屬營運公司之共宅一生股份有限公司之個人資料保護方針設置保護管理之負責人，於該負責人指示下，限定正當之服務進行範圍，嚴格進行收集/利用/提供/管理/保護。',
		subTitle5: '5. 個人資料利用目的之通知、揭露、訂正、新增或刪除、或個人資料之利用停止、消去或停止提供予第三人',
		listItem3_1: '・客戶個人檔案利用目的之通知及客戶個人檔案之揭露、訂正、新增、刪除、消去或停止提供予第三人之相關請求得自「Contact Us」為之。再者，如忘記使用者ID、密碼時，請參照FAQ頁面。',
		listItem3_2: '・關於刪除或消去之程序，由客戶本身自「FAQ」頁面為之或由客戶透過「Contact Us」提出請求。Fun! Japan將以停止利用服務或停止向第三人提供個人資料對應之。',
		listItem3_3: '・玖樓有保管備份檔案，以備電腦故障或其他不可抗力或人為疏失導致之檔案消失之情形。該備份檔案性質上無法進行確認等程序。',
		listItem3_4: '・客戶個人檔案利用目的之通知及客戶個人檔案之揭露、訂正、新增、刪除、消去或停止提供予第三人之相關請求得自「Contact Us」為之。再者，如忘記使用者ID、密碼時，請參照FAQ頁面。',
		listItem3_5: '・客戶利用本服務時，將視為已就「5. 個人資料利用目的之通知、揭露、訂正、新增或刪除或個人資料之利用停止、消去或停止提供予第三人」予以同意辦理。',
		subTitle6: '6. 未成年客戶之個人資料',
		listDescription3_3: '本服務就所提供之未成年人資訊，經謀求與大人同様之保護。但就依個人資料之當事人所在國或區域法令，經認定為未成年人者，按必要可能須得到家長同意。',
		subTitle7: '7. 個人資料相關詢問窗口',
		listDescription3_4: ' 關於個人資料之處理，如有不明瞭的地方，請參照求助網頁。',
		subTitle8: '8. 本網站之安全',
		listDescription3_5: '・本服務為確保客戶個人檔案之正確性、最新性，亦有可能請客戶予以協助。',
		listDescription3_6: '・本服務為確保安全，以防止個人輸入特定個人資料等重要資料時，該等資料遭竊取、受阻或竄改為目的，乃使用SSL（Secure Sockets Layer）技術。',
		paragraph42: '以上'
	},
	team: {
		team: '團隊',
		room: '房子是租來的，',
		life: '但生活不是',
		subject: '我們相信，決定未來靠 <a class="underline" href="https://www.ideo.com/post/the-ten-faces-of-innovation" target="_blank" rel="noopener noreferrer">10種人</a>；並不見得是最有能力的人，而是每一種角色，都有自己的槓桿、自己的工具、自己的技能，和自己的觀點。透過跨領域的共創結合起來，我們就能發揮驚人的力量，打造更友善的都市共同生活社區。',
		title1: '從實體社群出發，<br />我們希望每個夥伴都是人類學家',
		career1: '1.人類學家',
		careerDescription1: '在共生日常裡進行田野調查',
		career2: '2.看護人',
		careerDescription2: '理解室友的生活需求，<br />提供每個人適切合宜的居住選擇',
		career3: '3.說故事的人',
		careerDescription3: '透過生動故事和大眾溝通',
		career4: '4.實驗家',
		careerDescription4: '把生活問題、構想製成原型',
		title2: '多元創新，<br />是我們骨子裡流的血',
		career5: '5.跨欄運動員',
		careerDescription5: '不斷克服障礙抵達終點',
		career6: '6.體驗建築師',
		careerDescription6: '優化室友的日常生活體驗',
		career7: '7.異花授粉者',
		careerDescription7: '探索其他產業和文化應用於共生之中',
		title3: '共享共創，<br />這是一場弱連結的策展',
		career8: '8.導演',
		careerDescription8: '激發社群的內容與創造力',
		career9: '9.共同合作人',
		careerDescription9: '把各式各樣有趣的室友、外部團體結合',
		career10: '10.舞台設計師',
		careerDescription10: '把居住空間環境轉化成激發社群活力的舞台',
		summary: '我們在一條偉大的航道上，航向一個令人期待的未來。每個夥伴或許踏上這艘船的理由不盡相同，但我們盡可能地，與大家一起將夢想化為真實。',
		LinkedIn: '我們的LinkedIn',
		Medium: '我們的Medium',
		qouteblock: '如果想關注玖樓的職缺招募訊息，請追蹤我們的Medium ❤️'
	},
	media: {
		bannerTitle: '媒體',
		sectionDescription: '為了推廣共同生活空間，我們很樂意與大家分享玖樓的經歷與理念，可在此下載我們的品牌書。如果想進一步深入了解玖樓，歡迎留下您的採訪需求，我們會儘速與您聯繫。同時，也可先參以下考玖樓過往的媒體報導。',
		listTitle1: '台湾のまちづくり',
		listTitle2: '台北 「玖樓」共居實驗　捍衛跨代居住權益',
		listTitle3: '溝通是彼此價值的折衝與理解，追求更美好的共同生活',
		listTitle4: '我的老室友',
		listTitle5: '【玖樓】改造臺北老公寓 生活在一座不疏離的城市',
		listTitle6: '用老公寓盛裝生活新概念：填補世代居住落差，共生公寓「玖樓」',
		listTitle7: '「房子是租來的，但生活不是」：「玖樓」打造共生公寓，讓青年住進有生命力的空間',
		listTitle8: '住進一個社群 Living in a community',
		listTitle9: '「重新建立對家的想像！」推動共生公寓的玖樓團隊',
		listTitle10: '共居時代正興起！！經濟又拉近人際',
		listTitle11: '獨居不離群',
		listTitle12: '高房價城市中的空間共享：玖樓共生公寓―租屋生活的另一種可能',
		listTitle13: '同居新定義－玖樓打造對家的另類想像',
		listTitle14: '從生理到心靈 「一個人」經濟大爆發',
		listTitle15: '租房得投履歷？秀自己免費住天龍國',
		listTitle16: '社會學老師狂想　一堂課改變台灣',
		listTitle17: '台北青銀共居的條件與機會：高齡社會與閒置公寓',
		listTitle18: '共生，更便宜',
		listTitle19: '趨勢「共生公寓」打破居住模式！',
		listTitle20: '加入吧，共享空間（三）：那些不只是用來工作的空間——The Common、來坐夥、玖樓',
		listSubtitle1: 'SOTOKOTO(ソトコト) 2017年12月号',
		listSubtitle2: '明報周刊',
		listSubtitle3: '關鍵評論網「2017年未來大人物」',
		listSubtitle4: '公視-獨立特派員',
		listSubtitle5: '小日子雜誌',
		listSubtitle6: 'Polysh',
		listSubtitle7: '社企流',
		listSubtitle8: 'TED x TKU',
		listSubtitle9: 'NPOst 公益交流站',
		listSubtitle10: '破點',
		listSubtitle11: '30雜誌',
		listSubtitle12: 'Green 綠建築雜誌',
		listSubtitle13: 'LaVie',
		listSubtitle14: '今周刊',
		listSubtitle15: '商業週刊',
		listSubtitle16: '天下雜誌',
		listSubtitle17: '台北村落之聲',
		listSubtitle18: '民視異言堂',
		listSubtitle19: 'TVBS',
		listSubtitle20: 'BIOS Monthly',
		interview: '採訪玖樓',
		download: '下載品牌書',
		require: '採訪需求',
		record: '採訪紀錄'
	},
	manager: {
		bannerTitle: '空間管理',
		summaryTitle: 'Hi we are 9floor',
		summary: '玖樓是一個以社群經營為導向的全方位共同生活空間品牌，具體工作項目從品牌諮詢、設計規劃、施工、招租與經營管理等，協助業主活化閒置資產，提升社區價值。',
		sectionTitle1: '發展共同生活空間，<br>是一個城市共生的多贏選擇',
		sectionDescription11: '從活化空間的角度來看，共同生活空間介於商旅與長租套房之間，講求經濟實惠的服務及可量化的物件產品。定價可較一般租賃房屋高，但建置與營運成本卻遠低於旅館，且不受景氣淡旺之影響，獲利相對穩定。透過專業團隊的經營與策劃、也利於更緊密及長期的顧客關係，物件再活化及保值。',
		sectionDescription12: '也透過社群營造創造出更多屬於在地的活力及故事，連帶提升在地社區的價值。為物業主、投資人、居住者與城市創造良性的共生、共創、共榮的關係。',
		sectionTitle2: '為什麼要與玖樓合作',
		sectionDescription21: '玖樓（9floor）為台灣共同生活空間的先驅及專業品牌。從零開始，我們逐步嘗試並期許能做出一個有理想性的共居生活品牌。短短三年內累積近三千人次申請入住，並擁有三萬多名網路社群粉絲。獲得媒體高度關注外，亦與公部門攜手，規劃三峽青銀共居宅與永和社會住宅。並於2017年成為 <a class="underline" href="https://news.ltn.com.tw/news/local/paper/1138446" target="_blank" rel="noopener noreferrer">台北市政府認證專業房東</a>',
		sectionDescription22: '放眼亞洲，我們與國內外相關創新組織緊密互動，更於2017年獲得香港 <a class="underline" href="https://www.socialinnovationaward.asia/about-us/" target="_blank" rel="noopener noreferrer">Asia Social Innovation Award</a> 、2016年首爾 <a class="underline" href="https://www.facebook.com/Anyse.Asia/" target="_blank" rel="noopener noreferrer">ANYSE</a> 台灣代表、及社企流iLab與台北市產發局育成計輔導。作為一個同時具備國際視野、在地經驗及新創管理能力，玖樓，將會是與您一起透過品牌加成，為資產創造更高價值的首選團隊。',
		sectionTitle3: '服務項目',
		row1Title: 'A.統籌規劃 ',
		row1Subtitle1: '1.共同生活空間',
		row1Subtitle2: '2.空間品牌企劃',
		row1Subtitle3: '3.社區社群體驗',
		row1Description1: '市場與場域分析評估、財務與效益分析評估、空間利用規劃、複合商業模式提案',
		row1Description2: '顧問諮詢、服務設計、經營準則制定、人力培訓、數位整合行銷',
		row1Description3: '社群活動企劃、線上社群活動企劃、街區共創企劃',
		row2Title: 'B.設計監造',
		row2Subtitle1: '1.風格裝修',
		row2Sbtitle2: '2.智能家居整合',
		row2Description1: '老屋整建、空間設計、景觀規劃',
		row2Description2: '智慧門禁、裝修工程',
		row3Title: 'C.經營管理',
		row3Subtitle1: '1.住客管理',
		row3Subtitle2: '2.物產管理',
		row3Description1: '會員審核招募、數位金流合約管理、顧客關係維繫',
		row3Description2: '清潔修繕、空間維護、物業保險',
		section3Title: '我們正在尋找以下合作夥伴，一起打造更多理想的共同生活空間',
		section3TitleWithHTML: '我們正在尋找以下合作夥伴， <br> 一起打造更多理想的共同生活空間',
		section3Sub1: '空置物業',
		section3Sub2: '驚喜企畫',
		section3Sub3: '異業結盟',
		section3Description1: '我們持續探索生活場域的更多可能，因此積極尋找策略夥伴，包含智慧家居、綠能家電、友善食材、設計、生活品味風格等生活產業，一同創造永續發展的城市。',
		section3Description2: '玖樓的共同生活空間，就像是散落在這座城市的有機培養皿，搜羅這座城市最酷的人事物。我們歡迎一切有趣的企畫提案，也積極尋找與社會設計、社區共生、未來創新相關的合作可能。',
		section3Description3: '我們不停在尋找新的物件空間，一個適合打造成兼顧居住者社交生活、與居住生活，擁有私人房間與共享空間的場域。必備條件為交通便捷，此外如果能沾染一些地方文化特色就更棒了！',
		blockquoteWithHTML: '想了解更多嗎？歡迎留下相關資料，我們會儘速安排專人與您聯繫',
		contactUs: '與我們聯繫',
		sloganLeft: '享受社交生活。',
		sloganRight: '在宜居的環境裡，',
		sloganTitle1: '什麼是共同生活空間<br />&nbsp;(co-living space)',
		sloganTitle2: '什麼是共同生活空間<br />&nbsp;(co-living space)',
		sloganContent: '其實生活除了工作睡覺外、也需要適當的社交、以及透過不同方式例如活動參與、自己下廚等等以提升自我。因應現代人的生活模式，近年來開始有人提倡與投入建立共同生活空間。比起傳統租房產業最大化私人空間/房間數來獲利，Co-Living強調適當比例的公共空間，例如公共廚房、共同工作空間、休憩空間、甚至健身房等等、以及平價但適切的空間設計。為的是讓每位居民能在宜居的環境裡同時享受社交生活。而管理單位亦能透過整合管理，大幅降低單一物件環境提升的成本，而得以有效率的創造出略高於市場定價，但遠高於水平的服務與空間。也因此共同生活空間有別於傳統的隔間套房，吸引到為數不少，對於生活品質有所追求的族群入住。'
	},
	coliving: {
		coliving: '共居生活',
		summaryTitle: 'Hi we are 9floor',
		summaryDescription: '玖樓是一個以社群經營為主的全方位共同生活空間品牌，透過空間與多元的社群關係，創造更豐富的生活體驗。',
		sloganTitle: '什麼是共同生活空間<br />&nbsp;(co-living space)',
		slogan: '房子是租來的，但生活不是',
		sloganLeft: '但生活不是。',
		sloganRight: '房子是租來的，',
		sloganContent: '所謂的生活除了回家睡覺外、也包含適當的社交、活動參與、放鬆休憩等等。而共同生活空間正是為了回應當代的城市人口組成，所提供的生活空間新選擇。比起出租套房雅房，共同生活空間更強調完善的服務與透過適當比例的公共空間來凝聚社群，例如公共廚房、共同工作空間、休憩空間等等。以適切簡約為設計原則，創造每位室 友能同時享受社交生活的宜居場域。',
		title1: 'A.共生空間',
		description1: '擁有居家輕鬆溫暖的氛圍，同時備有咖啡館的工作生活機能。不只是物件的冰冷堆疊，我們在最愛的角落放上一盞落地燈、植入綠意、及能與室友分享私房菜的大桌。簡約的設計風格，乘載平凡生活的更多樂趣。',
		imageDescription1: '家鄉拿手菜、或深夜的泡麵，共煮共食的過程總能交換到些溫馨八卦。',
		imageDescription2: '討論計畫、準備期中考、咖啡小聚，在這容納彼此的場域，一起創造回憶。',
		imageDescription3: '回家後在床躺下的瞬間，舒適簡約的小天地，是對一整天的努力最好的報償。',
		title2: 'B.便捷租約',
		description2: '訂閱式的線上繳租，讓租房跟聽Spotify一樣簡單。一張帳單、線上刷卡，一次解決所有費用。不管是實習外派，還是留學交換，最短一個月的彈性租期、便利人性的入住流程，再也不用被租約綁住精彩的人生規劃。',
		imageDescription4: '我們的費用包含能源、清潔服務、行政手續等，一張帳單解決所有費用。',
		imageDescription5: '信用卡自動扣款，再也不用每個月設提醒繳房租了。',
		imageDescription6: '外派、實習、短期計畫，一個月以上的短租都沒問題。',
		title3: 'C.日常支援',
		description3: '每週公共區域清潔與垃圾清運服務，家事分工免煩惱，生活品質不打折。線上客服即時通報，設備、生活問題不麻煩。',
		imageDescription7: '線上報修系統即時通報，24小時內回覆，專業修繕人員為居住品質把關。',
		imageDescription8: '定期的公共空間專業清潔、以及定量的垃圾與回收物清運服務。*垃圾清運服務有每週定量標準，超量或是未依規定處理者，仍須自行處理。',
		imageDescription9: '所有入住的房客皆投保富邦產險1500萬第三人意外責任險，在外生活更有保障。',
		title4: 'D.社群生活',
		description4: '自己的視野有限，多元的社群卻是無界無邊。無論你是誰、從哪裡來，我們都希望你能在玖樓找到有歸感的落腳處。不只是精彩的實體聚會活動，小聚、早午餐、泳池派對，開放自由的氛圍，跨界的文化交流，我們也有很棒的{{link}}。成為入住會員、找到與你興趣相符的夥伴，一起探索城市吧！',
		imageDescription10: '社交當然不只發生在自己家裏，線上社群認識城市裡其他有趣的村民。',
		imageDescription11: '圖書館、電影夜、泳池派對，社群公共空間讓最酷的大家一起共同創造。',
		imageDescription12: '創業夥伴、異國戀情，參加社群活動，讓緣份就此展開。',
		community: '線上社群'
	},
	sitemap: {
		sitemap: '網站地圖',
		member: '會員',
		checkin: '入住',
		ninthfloor: '玖樓',
		service: '服務',
		journal: '日誌',
		help: '協助',
		login: '登入',
		filter: '條件搜尋',
		area: '地域搜尋',
		pauian: '玖樓璞園',
		personalized: '為我推薦',
		about: '關於',
		media: '媒體',
		team: '團隊',
		contact: '聯繫',
		space: '空間管理',
		coliving: '共居生活',
		how: '如何申請',
		FAQ: '常見問題',
		contactUs: '聯繫我們',
		termsofService: '服務條款',
		privacy: '隱私權政策'
	},
	BookingInsto: {
		paymentDescription: '金流扣繳與退款說明',
		paymentItem1: '玖樓使用藍新金流NewebPay為支付系統， 支援 Visa, MasterCard, JCB 之信用卡、簽帳金融卡。',
		paymentItem2: '1.訂單設定完成後，將於每月自動扣款。如有需要，可隨時至會員頁查看扣款紀錄。',
		paymentItem3: '2.每月扣款日為租約起始日期。',
		paymentItem4: '3.除了首期款項以外，我們並不會預扣金額。',
		paymentItem5: '4.如有需要，未來仍可於會員頁變更扣款帳戶。',
		paymentItem6: '5.如使用非台幣銀行卡，相關匯率以及手續費將由入住會員自行吸收，實際詳情請自行與銀行確認。',
		agree: '我都知道了，快讓我付款吧！',
		cardDetail: '卡片資訊',
		cardNumber: '卡號',
		dateline: '到期日',
		zipCode: '安全碼',
		name: '姓名',
		continue: '前往付款',
		back: '上一步'
	},
	SocialSelectGroup: {
		otherSocialMedia: '新增其他社群連結',
		linkSocialMedia: '社群連結',
		choiceSocialMedia: '選擇社群',
		addLinkofSocialMedia: '新增此連結'
	},
	MemberBadge: {
		REGISTERED: '已註冊',
		MEMBERSHIP_UNDER_REVIEW: '資格審核中',
		MEMBERSHIP_DENIED: '資格未過',
		BASIC_MEMBER: '一般會員',
		CERTIFIED_MEMBER: '認證會員',
		RESIDENT_MEMBER: '入住會員',
		BLOCKED: '黑名單'
	},
	CoLivingSlider: {
		search: '搜尋物件',
		serviceDetail: '服務詳情'
	},
	CoLivingSection: {
		search: '搜尋物件',
		serviceDetail: '服務詳情',
		sectionTitle1: '品味風格',
		sectionDetail1: '擁有輕鬆溫暖的氛圍，同時備有咖啡館的工作生活機能。不只是物件的冰冷堆疊，我們在最愛的角落放上一盞落地燈、植入綠意、以及能與室友分享私房菜的大桌。簡約的設計風格，乘載平凡生活的更多樂趣。',
		sectionTitle2: '便捷彈性',
		sectionDetail2: '訂閱式的線上繳租，讓租房跟聽Spotify一樣簡單。一張帳單、線上刷卡，一次解決所有費用。不管是實習外派，還是留學交換，最短一個月的彈性租期、便利人性的入住流程，再也不用被合約綁住精彩的人生規畫。',
		sectionTitle3: '日常支援 ',
		sectionDetail3: '每週公共區域清潔與垃圾清運服務，家事分工免煩惱，生活品質不打折。雲端系統即時通報，不論設備、還是生活，都貼心的幫你搞定一切。',
		sectionTitle4: '社群生活',
		sectionDetail4: '一個人的視野有限，多元的社群卻是無界無邊。調酒師、小資族、自由工作者，無論你從哪裡來，都能在玖樓找到歸屬的落腳處。小聚、早午餐、泳池派對，開放自由的氛圍，跨界的文化交流，與室友一起認識城裡最棒的人事物。'
	},
	Home: {
		qouteblock: '加入我們，分享彼此的世界，如約翰藍儂曾《想像》的那樣。',
		moreButton: '更多物件'
	},
	LocationInfo: {
		roommate: '位室友'
	},
	RoomCard: {
		month: '月'
	},
	breadcrumb: {
		moveIn: '入住',
		roomSearch: '房源搜尋',
		geographicSearch: '地圖搜尋',
		home: '玖樓',
		about: '關於',
		media: '媒體',
		team: '團體',
		contact: '聯繫',
		service: '服務',
		spaceManagement: '空間管理',
		coliving: '共居生活',
		member: 'Member',
		overview: '總覽',
		add: '新增個人資料',
		settings: '設定個人資料',
		favorites: '收藏',
		propertyViewingHistory: '預約紀錄',
		reservationHistory: '入住紀錄',
		onlineCommunity: '社群',
		termsOfService: '服務條款',
		description: '服務說明',
		privacyPolicy: '隱私權政策',
		sitemap: '網站地圖',
		room: '房源',
		booking: '預訂入住',
		user: 'User',
		reservation: '預約紀錄',
		renewYourLease: '預訂續住',
		book: '入住紀錄',
		appointment: '預約看房',
		checkin: '預約入住時間',
		checkout: '預約退房時間',
		cancel: '取消預約',
		changeAppointment: '變更預約',
		interview: '預約訪談'
	},
	cookie: {
		title: 'Cookie 提醒',
		description: '此網站使用Cookie。繼續使用此網站即表示您同意使用 Cookie。若要瞭解更多資訊，包括如何控制 Cookie，請參閱我們的',
		policy: 'Cookie 政策',
		buttonText: '同意'
	},
	community: {
		qouteblock: '加入我們，分享彼此的世界，如約翰藍儂曾《想像》的那樣。',
		moreButton: '更多物件',
		communitySearch: '自己的視野有限，多元的社群卻是無界無邊。無論你是誰、從哪裡來，我們都希望玖樓是你能感受到歸屬感的落腳處。快來體驗我們最新推出，目前為入住室友限定的線上社群功能吧！只要前往會員設定頁進行社群資料公開、完成興趣標籤、instagram串連、最愛的歌曲等設定，就可以開始搜尋與你趣味相同的新朋友！',
		selectCity: '選擇城市',
		placeholder: '輸入關鍵字，ex:籃球, 設計',
		findbutton: '找同好',
		communityAlert: '嗨，目前本服務僅入住會員限定。'
	},
	previewSection: {
		review: '審核中',
		reviewDetail: '收到申請了噢，審核時間約為2-3個工作天（未含六日、國定假日)，感謝你的耐心等候!'
	},
	reservationCancel: {
		confirm: '確認取消',
		reason: '取消原因',
		AboutToCancel: '您即將取消',
		cancelAlert: '真的要取消嗎！取消後，已使用的看房次數也無法恢復噢，當月還剩 {{number}} 次。',
		cancellation: '確認取消'
	},
	songList: {
		song: '請輸入歌曲名稱',
		addSong: '新增'
	},
	roommateDetail: {
		favoriteSong: '最愛歌曲',
		communityLink: '社群連結',
		more: '載入更多'
	}
};

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.addMatchMediaListener = exports.addScrollListener = exports.addResizeListener = undefined;

var _global = __webpack_require__(46);

var addResizeListener = exports.addResizeListener = function addResizeListener(store) {
	var ticking = false;

	var resizeEvent = function resizeEvent() {
		var _document$documentEle = document.documentElement,
		    clientWidth = _document$documentEle.clientWidth,
		    clientHeight = _document$documentEle.clientHeight;


		if (!ticking) {
			window.requestAnimationFrame(function () {
				store.dispatch((0, _global.resizeWindow)(clientWidth, clientHeight));
				ticking = false;
			});
		}
		ticking = true;
	};

	window.addEventListener('resize', resizeEvent);
};

var addScrollListener = exports.addScrollListener = function addScrollListener(store) {
	var ticking = false;

	var scrollEvent = function scrollEvent() {
		var _window = window,
		    scrollY = _window.scrollY;


		if (!ticking) {
			window.requestAnimationFrame(function () {
				store.dispatch((0, _global.scrollWindow)(scrollY));
				ticking = false;
			});
		}
		ticking = true;
	};

	window.addEventListener('scroll', scrollEvent, false);
};

var addMatchMediaListener = exports.addMatchMediaListener = function addMatchMediaListener(store) {
	var phoneMedia = window.matchMedia('(max-width: 575px)');
	var tabletMedia = window.matchMedia('(max-width: 1199px) and (min-width: 576px)');
	var desktopMedia = window.matchMedia('(min-width: 1200px)');

	var handleMediaChange = function handleMediaChange(callback) {
		return function (media) {
			if (media.matches) {
				callback();
			}
		};
	};

	phoneMedia.addListener(handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('phone'));
	}));
	tabletMedia.addListener(handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('tablet'));
	}));
	desktopMedia.addListener(handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('desktop'));
	}));

	// Initalize
	handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('phone'));
	})(phoneMedia);
	handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('tablet'));
	})(tabletMedia);
	handleMediaChange(function () {
		return store.dispatch((0, _global.matchMedia)('desktop'));
	})(desktopMedia);
};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.loadConfigFromLocalStorage = undefined;

var _global = __webpack_require__(46);

var _storage = __webpack_require__(66);

var _storage2 = _interopRequireDefault(_storage);

var _authStorage = __webpack_require__(105);

var _authStorage2 = _interopRequireDefault(_authStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadConfigFromLocalStorage = exports.loadConfigFromLocalStorage = function loadConfigFromLocalStorage(store) {
	// Load token
	var tokenData = _authStorage2.default.getToken();
	var tokenDefault = {
		accessToken: '',
		endAt: '',
		expiresIn: '',
		refreshToken: ''
	};

	var token = tokenData === null ? tokenDefault : JSON.parse(tokenData);

	var cookieData = _storage2.default.getItem('cookie');
	var cookieDefault = { display: true };

	var cookie = cookieData === null ? cookieDefault : JSON.parse(cookieData);

	store.dispatch((0, _global.loadConfig)({ token: token, cookie: cookie }));
};

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = configureStore;

var _redux = __webpack_require__(138);

var _reduxPromiseMiddleware = __webpack_require__(433);

var _reduxPromiseMiddleware2 = _interopRequireDefault(_reduxPromiseMiddleware);

var _reduxThunkFsa = __webpack_require__(434);

var _reduxThunkFsa2 = _interopRequireDefault(_reduxThunkFsa);

var _reactRouter = __webpack_require__(45);

var _reactRouterRedux = __webpack_require__(36);

var _reducers = __webpack_require__(917);

var _reducers2 = _interopRequireDefault(_reducers);

var _reduxObservable = __webpack_require__(201);

var _epics = __webpack_require__(940);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var epicMiddleware = (0, _reduxObservable.createEpicMiddleware)(_epics.rootEpic);

var reduxRouterMiddleware = (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory);

var middlewares = [reduxRouterMiddleware, _reduxThunkFsa2.default, (0, _reduxPromiseMiddleware2.default)(), epicMiddleware];
var composeEnhancers = _redux.compose;

if (false) {
	var _require = require('redux-logger'),
	    createLogger = _require.createLogger; // eslint-disable-line global-require


	middlewares.push(createLogger({
		predicate: function predicate(_, action) {
			return action.type !== 'SCROLL_WINDOW' && action.type !== 'RESIZE_WINDOW';
		}
	}));
	composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
}

function configureStore(preState) {
	var store = (0, _redux.createStore)(_reducers2.default, preState, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));

	if (false) {
		module.hot.accept('../reducers', function () {
			var nextReducers = require('../reducers').default; // eslint-disable-line global-require
			store.replaceReducer(nextReducers);
		});
	}

	return store;
}

/***/ }),
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _redux = __webpack_require__(138);

var _reactRouterRedux = __webpack_require__(36);

var _members = __webpack_require__(918);

var _members2 = _interopRequireDefault(_members);

var _blogs = __webpack_require__(919);

var _blogs2 = _interopRequireDefault(_blogs);

var _i18n = __webpack_require__(920);

var _i18n2 = _interopRequireDefault(_i18n);

var _global = __webpack_require__(921);

var _global2 = _interopRequireDefault(_global);

var _banner = __webpack_require__(922);

var _banner2 = _interopRequireDefault(_banner);

var _coLiving = __webpack_require__(923);

var _coLiving2 = _interopRequireDefault(_coLiving);

var _room = __webpack_require__(229);

var _room2 = _interopRequireDefault(_room);

var _apartment = __webpack_require__(228);

var _apartment2 = _interopRequireDefault(_apartment);

var _filter = __webpack_require__(924);

var _filter2 = _interopRequireDefault(_filter);

var _modal = __webpack_require__(925);

var _modal2 = _interopRequireDefault(_modal);

var _reservation = __webpack_require__(926);

var _reservation2 = _interopRequireDefault(_reservation);

var _booking = __webpack_require__(567);

var _booking2 = _interopRequireDefault(_booking);

var _auth = __webpack_require__(927);

var _auth2 = _interopRequireDefault(_auth);

var _user = __webpack_require__(928);

var _user2 = _interopRequireDefault(_user);

var _alert = __webpack_require__(929);

var _alert2 = _interopRequireDefault(_alert);

var _song = __webpack_require__(930);

var _song2 = _interopRequireDefault(_song);

var _social = __webpack_require__(931);

var _social2 = _interopRequireDefault(_social);

var _community = __webpack_require__(932);

var _community2 = _interopRequireDefault(_community);

var _collect = __webpack_require__(933);

var _collect2 = _interopRequireDefault(_collect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducers = (0, _redux.combineReducers)({
	routing: _reactRouterRedux.routerReducer,
	members: _members2.default,
	blogs: _blogs2.default,
	i18n: _i18n2.default,
	global: _global2.default,
	banner: _banner2.default,
	coLiving: _coLiving2.default,
	room: _room2.default,
	apartment: _apartment2.default,
	filter: _filter2.default,
	modal: _modal2.default,
	reservation: _reservation2.default,
	booking: _booking2.default,
	auth: _auth2.default,
	user: _user2.default,
	alert: _alert2.default,
	song: _song2.default,
	social: _social2.default,
	community: _community2.default,
	collect: _collect2.default
});

exports.default = reducers;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

exports.default = (0, _reduxActions.handleActions)({
	GET_MEMBERS_PENDING: function GET_MEMBERS_PENDING(state) {
		return _extends({}, state, {
			loading: true
		});
	},

	GET_MEMBERS_FULFILLED: function GET_MEMBERS_FULFILLED(state, action) {
		return _extends({}, state, {
			staffs: action.payload.staffs,
			loading: false
		});
	},

	CLEAN_MEMBERS: function CLEAN_MEMBERS(state) {
		return _extends({}, state, {
			staffs: {}
		});
	}
}, {
	loading: false,
	staffs: {}
});

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

exports.default = (0, _reduxActions.handleActions)({
	GET_BLOGS_PENDING: function GET_BLOGS_PENDING(state) {
		return _extends({}, state, {
			loading: true
		});
	},

	GET_BLOGS_FULFILLED: function GET_BLOGS_FULFILLED(state, action) {
		return _extends({}, state, {
			posts: action.payload.list,
			loading: false
		});
	},

	CLEAN_BLOGS: function CLEAN_BLOGS(state) {
		return _extends({}, state, {
			posts: []
		});
	}
}, {
	loading: false,
	posts: []
});

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

exports.default = (0, _reduxActions.handleActions)({
	CHANGE_LANGUAGE: function CHANGE_LANGUAGE(state, action) {
		return _extends({}, state, {
			lan: action.payload.lan
		});
	}
}, {
	lan: 'zh-TW',
	timeZone: 8
});

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

exports.default = (0, _reduxActions.handleActions)({
	RESIZE_WINDOW: function RESIZE_WINDOW(state, action) {
		return _extends({}, state, {

			width: action.payload.width,
			height: action.payload.height
		});
	},

	SCROLL_WINDOW: function SCROLL_WINDOW(state, action) {
		return _extends({}, state, {

			scrollY: action.payload.scrollY
		});
	},

	MATCH_MEDIA: function MATCH_MEDIA(state, action) {
		return _extends({}, state, {

			media: action.payload.media
		});
	},

	PAGE_LOADING: function PAGE_LOADING(state, action) {
		return _extends({}, state, {
			route: _extends({}, state.route, {
				loading: [].concat(state.route.loading, [action.payload.page])
			})
		});
	},

	PAGE_LOADED: function PAGE_LOADED(state, action) {
		return _extends({}, state, {
			route: _extends({}, state.route, {
				loading: state.route.loading.filter(function (page) {
					return page !== action.payload.page;
				})
			})
		});
	},

	PAGE_ENTERING: function PAGE_ENTERING(state, action) {
		return _extends({}, state, {
			route: _extends({}, state.route, {
				entering: [].concat(state.route.entering, [action.payload.page])
			})
		});
	},

	PAGE_ENTERED: function PAGE_ENTERED(state, action) {
		return _extends({}, state, {
			route: _extends({}, state.route, {
				entering: state.route.entering.filter(function (page) {
					return page !== action.payload.page;
				})
			})
		});
	},

	PAGE_CHANGING: function PAGE_CHANGING(state, action) {
		return _extends({}, state, {
			route: _extends({}, state.route, {
				changing: [].concat(state.route.changing, [action.payload.page])
			})
		});
	},

	PAGE_CHANGED: function PAGE_CHANGED(state, action) {
		return _extends({}, state, {
			route: _extends({}, state.route, {
				changing: state.route.changing.filter(function (page) {
					return page !== action.payload.page;
				})
			})
		});
	},

	LOADING_RATIO: function LOADING_RATIO(state, action) {
		var _extends2;

		return _extends({}, state, {
			route: _extends({}, state.route, {
				ratio: _extends({}, state.route.ratio, (_extends2 = {}, _extends2[action.payload.page] = action.payload.ratio, _extends2))
			})
		});
	},

	LOAD_LIBRARY: function LOAD_LIBRARY(state, action) {
		var _extends3;

		return _extends({}, state, {

			lib: _extends({}, state.lib, (_extends3 = {}, _extends3[action.payload.lib] = true, _extends3))
		});
	},

	UPDATE_OFFSET_TOP: function UPDATE_OFFSET_TOP(state, action) {
		var _extends4, _extends5;

		return _extends({}, state, {

			markerPosition: _extends({}, state.markerPosition, (_extends5 = {}, _extends5[action.payload.page] = _extends({}, state.markerPosition[action.payload.page], (_extends4 = {}, _extends4[action.payload.section] = action.payload.offsetTop, _extends4)), _extends5))
		});
	},

	LOAD_CONFIG: function LOAD_CONFIG(state, action) {
		return _extends({}, state, {

			cookie: action.payload.cookie
		});
	},

	AGREE_COOKIE: function AGREE_COOKIE(state) {
		return _extends({}, state, {

			cookie: { display: false }
		});
	}
}, {
	width: document.documentElement.clientWidth,
	height: document.documentElement.clientHeight,
	scrollY: window.scrollY,
	media: '',

	route: {
		loading: [],
		entering: ['ENTER_APP'],
		changing: [],
		ratio: {
			ENTER_APP: 0
		}
	},

	lib: {
		googleMap: false
	},

	markerPosition: {
		home: {
			coLiving: 0,
			housingInfo: 0,
			news: 0
		},
		sidebar: {
			normal: 0
		},
		bookingbar: {
			normal: 0
		},
		apartment: {
			info: 0,
			room: 0,
			roommate: 0,
			recommendation: 0
		},
		room: {
			info: 0,
			apartment: 0,
			roommate: 0,
			recommendation: 0
		},
		wishlist: {
			room: 0,
			apartment: 0
		},
		reservationRecord: {
			incoming: 0,
			history: 0
		},
		bookingList: {
			active: 0,
			past: 0
		},
		community: {
			search: 0,
			list: 0
		}
	},

	cookie: {
		display: true
	}
});

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

exports.default = (0, _reduxActions.handleActions)({
	FETCH_BANNER_FULFILLED: function FETCH_BANNER_FULFILLED(state, action) {
		return _extends({}, state, action.payload);
	}
}, {
	id: -1,
	subTitle: '',
	title: '',
	url: '',
	createdAt: null,
	updatedAt: null
});

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

exports.default = (0, _reduxActions.handleActions)({
	GET_COLIVING: function GET_COLIVING(state, action) {
		return _extends({}, state, {

			list: action.payload.list,
			data: action.payload.data
		});
	}
}, {
	list: [],
	data: {}
});

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

exports.default = (0, _reduxActions.handleActions)({
	UPDATE_ROOM_FILTER: function UPDATE_ROOM_FILTER(state, action) {
		var _extends2;

		return _extends({}, state, (_extends2 = {}, _extends2[action.payload.key] = _extends({}, state[action.payload.key], action.payload.value, {
			status: 'updated'
		}), _extends2));
	},

	UPDATE_DISTRICT_OPTIONS: function UPDATE_DISTRICT_OPTIONS(state, action) {
		return _extends({}, state, {
			district: _extends({}, state.district, {
				list: action.payload.list,
				select: []
			})
		});
	},

	UPDATE_MRT_STATION_OPTIONS: function UPDATE_MRT_STATION_OPTIONS(state, action) {
		return _extends({}, state, {
			mrtStation: _extends({}, state.mrtStation, {
				list: action.payload.list,
				select: []
			})
		});
	},

	FETCH_ROOM_FILTER_FULFILLED: function FETCH_ROOM_FILTER_FULFILLED(state, action) {
		return _extends({}, state, {

			city: _extends({}, state.city, {
				list: action.payload.cityList,
				data: action.payload.cityData
			}),

			district: _extends({}, state.district, {
				data: action.payload.districtsData
			}),

			mrtLine: _extends({}, state.mrtLine, {
				list: action.payload.mrtLineList,
				data: action.payload.mrtLineData
			}),

			mrtStation: _extends({}, state.mrtStation, {
				data: action.payload.mrtStationData
			}),

			apartment: _extends({}, state.apartment, {
				list: action.payload.apartmentList,
				data: action.payload.apartmentData
			}),

			roomType: _extends({}, state.roomType, {
				list: action.payload.roomTypeList,
				data: action.payload.roomTypeData
			}),

			price: _extends({}, state.price, {
				range: action.payload.minMaxPriceRange,
				minMax: action.payload.minMaxPriceRange
			}),

			area: _extends({}, state.area, {
				range: action.payload.minMaxAreaRange,
				minMax: action.payload.minMaxAreaRange
			}),

			feature: _extends({}, state.feature, {
				list: action.payload.featureList,
				data: action.payload.featureData
			})
		});
	},

	SET_ROOM_FILTER_QUERY: function SET_ROOM_FILTER_QUERY(state, action) {
		return _extends({}, state, {

			city: _extends({}, state.city, action.payload.city),
			district: _extends({}, state.district, action.payload.district),
			mrtLine: _extends({}, state.mrtLine, action.payload.mrtLine),
			mrtStation: _extends({}, state.mrtStation, action.payload.mrtStation),
			mrtAround: _extends({}, state.mrtAround, action.payload.mrtAround),
			apartment: _extends({}, state.apartment, action.payload.apartment),
			roomType: _extends({}, state.roomType, action.payload.roomType),
			month: _extends({}, state.month, action.payload.month),
			price: _extends({}, state.price, action.payload.price),
			area: _extends({}, state.area, action.payload.area),
			double: _extends({}, state.double, action.payload.double),
			pet: _extends({}, state.pet, action.payload.pet),
			feature: _extends({}, state.feature, action.payload.feature),
			unavailableType: _extends({}, state.unavailableType, action.payload.unavailableType),
			sort: _extends({}, state.sort, action.payload.sort)
		});
	}
}, {
	city: {
		select: [],
		list: [],
		data: {},
		status: 'init',
		message: ''
	},

	district: {
		select: [],
		list: [],
		data: {},
		status: 'init',
		message: ''
	},

	mrtLine: {
		select: [],
		list: [],
		data: {},
		status: 'init',
		message: ''
	},

	mrtStation: {
		select: [],
		list: [],
		data: {},
		status: 'init',
		message: ''
	},

	mrtAround: {
		value: false,
		status: 'init',
		message: ''
	},

	apartment: {
		select: [],
		list: [],
		data: {},
		status: 'init',
		message: ''
	},

	roomType: {
		select: [],
		list: [],
		data: {},
		status: 'init',
		message: ''
	},

	month: {
		range: [],
		yearRange: [],
		status: 'init',
		message: ''
	},

	price: {
		range: [],
		minMax: [],
		status: 'init',
		message: ''
	},

	area: {
		range: [],
		minMax: [],
		status: 'init',
		message: ''
	},

	double: {
		select: { label: '', value: '' },
		status: 'init',
		message: ''
	},

	pet: {
		select: { label: '', value: '' },
		status: 'init',
		message: ''
	},

	feature: {
		select: [],
		list: [],
		data: {},
		status: 'init',
		message: ''
	},

	unavailableType: {
		value: false,
		status: 'init',
		message: ''
	},

	sort: {
		select: [],
		status: 'init',
		message: ''
	}
});

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var handleMessage = function handleMessage(state, action) {
	if (typeof action.payload.message === 'string') {
		return action.payload.message;
	}

	return _extends({}, state[action.payload.modal].message, action.payload.message);
};

exports.default = (0, _reduxActions.handleActions)({
	SET_MODAL_BACKGROUND_SCROLLY: function SET_MODAL_BACKGROUND_SCROLLY(state, action) {
		return _extends({}, state, {
			globalTop: action.payload
		});
	},

	OPEN_MESSAGE_MODAL: function OPEN_MESSAGE_MODAL(state, action) {
		var _extends2;

		return _extends({}, state, (_extends2 = {}, _extends2[action.payload.modal] = {
			open: true,
			message: handleMessage(state, action)
		}, _extends2));
	},

	CLOSE_MESSAGE_MODAL: function CLOSE_MESSAGE_MODAL(state, action) {
		var _extends3;

		return _extends({}, state, (_extends3 = {}, _extends3[action.payload.modal] = {
			open: false,
			message: state[action.payload.modal].message === 'string' ? '' : {}
		}, _extends3));
	}
}, {
	filterAddress: {
		open: false,
		message: ''
	},

	filterPrice: {
		open: false,
		message: ''
	},

	filterAdvance: {
		open: false,
		message: ''
	},

	reservationVerifying: {
		open: false,
		message: ''
	},

	reservationInfo: {
		open: false,
		message: ''
	},

	bookingInfo: {
		open: false,
		message: ''
	},

	renewInfo: {
		open: false,
		message: ''
	},

	bookingCheckout: {
		open: false,
		message: ''
	},

	loginSignup: {
		open: false,
		message: {
			type: '',
			success: false,
			alert: ''
		}
	},

	selectSong: {
		open: false,
		message: ''
	},

	globalTop: 0
});

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const MORNING = [
// 	{
// 		time: '2018-06-01 00:00:00',
// 		live: 5,
// 		phone: 5,
// 		online: 5,
// 		available: true,
// 	},
// 	{
// 		time: '2018-06-01 00:30:00',
// 		live: 5,
// 		phone: 5,
// 		online: 5,
// 		available: true,
// 	},
// 	{
// 		time: '2018-06-01 01:00:00',
// 		live: 5,
// 		phone: 5,
// 		online: 5,
// 		available: true,
// 	},
// ];

var defaultForm = {
	phone: {
		value: '',
		country: {
			areaCodes: null,
			dialCode: '886',
			iso2: 'tw',
			name: 'Taiwan (台灣)',
			priority: 0
		},
		validate: false,
		status: ''
	},

	hangout: { value: '', status: '', valid: false }
};

exports.default = (0, _reduxActions.handleActions)({
	CHANGE_RESERVATION_STEP: function CHANGE_RESERVATION_STEP(state, action) {
		return _extends({}, state, {
			step: action.payload.step
		});
	},

	CLEAR_RESERVATION_TIME: function CLEAR_RESERVATION_TIME(state) {
		return _extends({}, state, {
			reservationTimeList: { MORNING: [], AFTERNOON: [] }
		});
	},

	FETCH_RESERVATION_TIME_FULFILLED: function FETCH_RESERVATION_TIME_FULFILLED(state, action) {
		return _extends({}, state, {

			reservationTimeList: _extends({}, state.reservationTimeList, action.payload.reservationTimeList)
		});
	},

	FETCH_RESERVATION_DATE_FULFILLED: function FETCH_RESERVATION_DATE_FULFILLED(state, action) {
		return _extends({}, state, {

			reservationDate: _extends({}, state.reservationDate, action.payload.reservationDate)
		});
	},

	RESERVE_PROCESS_FULFILLED: function RESERVE_PROCESS_FULFILLED(state, action) {
		return _extends({}, state, action.payload);
	},

	FETCH_RESERVATION_FULFILLED: function FETCH_RESERVATION_FULFILLED(state, action) {
		return _extends({}, state, {

			reservations: {
				list: action.payload.list,
				data: _extends({}, state.reservations.data, action.payload.data)
			}
		});
	},

	FETCH_USER_OVERVIEW_FULFILLED: function FETCH_USER_OVERVIEW_FULFILLED(state, action) {
		return _extends({}, state, {

			reservations: {
				list: action.payload.reservationList,
				data: _extends({}, state.reservations.data, action.payload.reservationData)
			}
		});
	},

	FETCH_RESERVATION_BY_ID_FULFILLED: function FETCH_RESERVATION_BY_ID_FULFILLED(state, action) {
		var _extends2;

		return _extends({}, state, {

			reservations: _extends({}, state.reservations, {
				data: _extends({}, state.reservations.data, (_extends2 = {}, _extends2[action.payload.data.id] = action.payload.data, _extends2))
			})
		});
	},

	UPDATE_RESERVATION_FIELD: function UPDATE_RESERVATION_FIELD(state, action) {
		var _extends3, _extends4;

		return _extends({}, state, (_extends4 = {}, _extends4[action.payload.type] = _extends({}, state[action.payload.type], (_extends3 = {}, _extends3[action.payload.key] = _extends({}, state[action.payload.type][action.payload.key], action.payload.value), _extends3)), _extends4));
	},

	INIT_RESERVATION_FORM_DATA: function INIT_RESERVATION_FORM_DATA(state) {
		return _extends({}, state, {

			form: defaultForm
		});
	},

	SET_RESERVATION_FORM_DATA: function SET_RESERVATION_FORM_DATA(state, action) {
		return _extends({}, state, {

			form: {
				phone: _extends({
					validate: false,
					status: 'FINISHED'
				}, action.payload.phone),
				hangout: _extends({
					status: 'FINISHED',
					valid: false
				}, action.payload.hangout)
			}
		});
	},

	SET_ACCESS_RESERVE: function SET_ACCESS_RESERVE(state) {
		return _extends({}, state, {
			canAccess: true
		});
	}
}, {
	step: 'reservation',
	reservationTimeList: { MORNING: [], AFTERNOON: [] },
	reservationDate: {},
	roomId: 0,
	type: 'live',
	time: (0, _moment2.default)().valueOf(),
	email: '',
	canAccess: false,

	reservations: {
		list: [],
		data: {}
	},

	form: defaultForm
});

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

exports.default = (0, _reduxActions.handleActions)({
	UPDATE_AUTH_FIELD: function UPDATE_AUTH_FIELD(state, action) {
		var _extends2, _extends3;

		return _extends({}, state, (_extends3 = {}, _extends3[action.payload.type] = _extends({}, state[action.payload.type], (_extends2 = {}, _extends2[action.payload.key] = action.payload.value, _extends2)), _extends3));
	},

	UPDATE_ACCESS_TOKEN: function UPDATE_ACCESS_TOKEN(state, action) {
		return _extends({}, state, {
			token: action.payload.token,
			status: action.payload.status,
			message: action.payload.message
		});
	},

	LOAD_CONFIG: function LOAD_CONFIG(state, action) {
		return _extends({}, state, {
			token: action.payload.token
		});
	},

	LOGOUT_FULFILLED: function LOGOUT_FULFILLED(state) {
		return _extends({}, state, {

			token: {
				accessToken: '',
				endAt: '',
				expiresIn: '',
				refreshToken: ''
			},

			status: 0,
			message: ''
		});
	}
}, {
	loginForm: {
		email: { value: '' },
		password: { value: '' },
		remember: { value: false }
	},

	signupForm: {
		email: { value: '' },
		password: { value: '' },
		checkPassword: { value: '' },
		agreement: { value: false }
	},

	forgetForm: {
		email: { value: '' }
	},

	passwordForm: {
		password: { value: '' },
		checkPassword: { value: '' }
	},

	token: {
		accessToken: '',
		endAt: '',
		expiresIn: '',
		refreshToken: ''
	},

	status: 0,
	message: ''
});

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultUserData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var defaultUserData = exports.defaultUserData = {
	name: { value: '喵', status: '', valid: false },
	gender: { value: { value: 'MALE', label: '男' }, status: '', valid: false },
	jobTypes: { value: [], list: [], data: {}, status: '', valid: false },
	birth: { value: '', status: '', valid: false },
	country: { value: [], status: '', valid: false },
	certificate: { value: '', type: [], status: '', valid: false },
	professions: { value: [], list: [], inputValue: '', data: {}, status: '', valid: false },
	phone: {
		value: '',
		country: {
			areaCodes: null,
			dialCode: '886',
			iso2: 'tw',
			name: 'Taiwan (台灣)',
			priority: 0
		},
		valid: false,
		validate: true,
		status: ''
	},
	expect: { value: '未填寫', status: '', valid: false },
	open: { value: '', status: '', valid: true },
	nickname: { value: '學妹', status: '', valid: false },
	company: { value: '玖樓', status: '', valid: true },
	career: { value: [], list: [], inputValue: '', data: {}, status: '', valid: true },
	intro: { value: '我是一隻魚', status: '', valid: true },
	interests: { value: [], list: [], inputValue: '', data: {}, status: '', valid: false },
	songs: { value: [], favoriteData: {}, status: '', valid: true },
	socialMedia: { value: [], status: '', valid: false, latestIndex: -1 },

	image: { value: '', url: '', valid: false }
};

exports.default = (0, _reduxActions.handleActions)({
	UPDATE_USER_FIELD: function UPDATE_USER_FIELD(state, action) {
		var _extends2, _extends3;

		return _extends({}, state, (_extends3 = {}, _extends3[action.payload.type] = _extends({}, state[action.payload.type], (_extends2 = {}, _extends2[action.payload.key] = _extends({}, state[action.payload.type][action.payload.key], action.payload.value), _extends2)), _extends3));
	},

	FETCH_USER_FULFILLED: function FETCH_USER_FULFILLED(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {
				name: _extends({}, state.form.name, action.payload.name),
				gender: _extends({}, state.form.gender, action.payload.gender),
				jobTypes: _extends({}, state.form.jobTypes, action.payload.jobTypes),
				birth: _extends({}, state.form.birth, action.payload.birth),
				country: _extends({}, state.form.country, action.payload.country),
				professions: _extends({}, state.form.professions, action.payload.professions),
				phone: _extends({}, state.form.phone, action.payload.phone),
				expect: _extends({}, state.form.expect, action.payload.expect),
				open: _extends({}, state.form.open, action.payload.open),
				nickname: _extends({}, state.form.nickname, action.payload.nickname),
				company: _extends({}, state.form.company, action.payload.company),
				career: _extends({}, state.form.career, action.payload.career),
				intro: _extends({}, state.form.intro, action.payload.intro),
				interests: _extends({}, state.form.interests, action.payload.interests),
				socialMedia: _extends({}, state.form.socialMedia, action.payload.socialMedia),
				image: _extends({}, state.form.image, action.payload.image),
				songs: _extends({}, state.form.songs, action.payload.songs),
				certificate: _extends({}, state.form.certificate, action.payload.certificate)
			}),

			data: action.payload.data,
			social: action.payload.social
		});
	},

	SYNC_USER_SETTING_FROM_LOCALSTORAGE: function SYNC_USER_SETTING_FROM_LOCALSTORAGE(state, action) {
		return _extends({}, state, {
			form: action.payload.form
		});
	},

	FETCH_USER_JOB_TYPE_OPTION_DATA_FULFILLED: function FETCH_USER_JOB_TYPE_OPTION_DATA_FULFILLED(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				jobTypes: _extends({}, state.form.jobTypes, action.payload.jobTypes)
			})
		});
	},

	FETCH_USER_INTEREST_OPTION_DATA_FULFILLED: function FETCH_USER_INTEREST_OPTION_DATA_FULFILLED(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				interests: _extends({}, state.form.interests, action.payload.interests)
			})
		});
	},

	UPDATE_USER_INTEREST_OPTION_DATA_FULFILLED: function UPDATE_USER_INTEREST_OPTION_DATA_FULFILLED(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				interests: _extends({}, state.form.interests, action.payload)
			})
		});
	},

	FETCH_USER_PROFESSION_OPTION_DATA_FULFILLED: function FETCH_USER_PROFESSION_OPTION_DATA_FULFILLED(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				professions: _extends({}, state.form.professions, action.payload.professions)
			})
		});
	},

	UPDATE_USER_PROFESSION_OPTION_DATA_FULFILLED: function UPDATE_USER_PROFESSION_OPTION_DATA_FULFILLED(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				professions: _extends({}, state.form.professions, action.payload)
			})
		});
	},

	FETCH_USER_CAREER_OPTION_DATA_FULFILLED: function FETCH_USER_CAREER_OPTION_DATA_FULFILLED(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				career: _extends({}, state.form.career, action.payload.career)
			})
		});
	},

	UPDATE_USER_CAREER_OPTION_DATA_FULFILLED: function UPDATE_USER_CAREER_OPTION_DATA_FULFILLED(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				career: _extends({}, state.form.career, action.payload)
			})
		});
	},

	UPLOAD_USER_PHOTO_FULFILLED: function UPLOAD_USER_PHOTO_FULFILLED(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				image: _extends({}, state.form.image, {
					value: action.payload.image,
					url: action.payload.imageUrl
				})
			})
		});
	},

	VALIDATE_USER_DATA: function VALIDATE_USER_DATA(state, action) {
		var _extends4;

		return _extends({}, state, {
			form: _extends({}, state.form, (_extends4 = {}, _extends4[action.payload.key] = _extends({}, state.form[action.payload.key], {
				status: 'VALIDATED',
				valid: action.payload.valid
			}), _extends4))
		});
	},

	CLEAR_VALIDATE_USER_DATA: function CLEAR_VALIDATE_USER_DATA(state) {
		return _extends({}, state, {
			form: _extends({}, state.form, {

				name: _extends({}, state.form.name, { status: 'VALIDATING', valid: false }),
				gender: _extends({}, state.form.gender, { status: 'VALIDATING', valid: false }),
				jobTypes: _extends({}, state.form.jobTypes, { status: 'VALIDATING', valid: false }),
				birth: _extends({}, state.form.birth, { status: 'VALIDATING', valid: false }),
				country: _extends({}, state.form.country, { status: 'VALIDATING', valid: false }),
				professions: _extends({}, state.form.professions, { status: 'VALIDATING', valid: false }),
				phone: _extends({}, state.form.phone, { status: 'VALIDATING', valid: false }),
				expect: _extends({}, state.form.expect, { status: 'VALIDATING', valid: false }),
				nickname: _extends({}, state.form.nickname, { status: 'VALIDATING', valid: false }),
				interests: _extends({}, state.form.interests, { status: 'VALIDATING', valid: false }),
				socialMedia: _extends({}, state.form.socialMedia, { status: 'VALIDATING', valid: false }),
				image: _extends({}, state.form.image, { status: 'VALIDATING', valid: false }),
				certificate: _extends({}, state.form.certificate, { status: 'VALIDATING', valid: false })
			})
		});
	},

	ADD_FAVORITE_SONG: function ADD_FAVORITE_SONG(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				songs: _extends({}, state.form.songs, {
					value: state.form.songs.value.includes(action.payload.id) ? state.form.songs.value : [].concat(state.form.songs.value, [action.payload.id])
				})
			})
		});
	},

	REMOVE_FAVORITE_SONG: function REMOVE_FAVORITE_SONG(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				songs: _extends({}, state.form.songs, {
					value: state.form.songs.value.filter(function (id) {
						return action.payload.id !== id;
					})
				})
			})
		});
	},

	FETCH_IG_MEDIA_FULFILLED: function FETCH_IG_MEDIA_FULFILLED(state, action) {
		return _extends({}, state, {

			userIgData: action.payload.userIgData
		});
	},

	REMOVE_IG_ACCESS_TOKEN_FULFILLED: function REMOVE_IG_ACCESS_TOKEN_FULFILLED(state) {
		return _extends({}, state, {
			userIgData: {
				id: '',
				username: ''
			}
		});
	},

	ADD_SOCIAL_LINK: function ADD_SOCIAL_LINK(state, action) {
		var _extends5;

		return _extends({}, state, {

			form: _extends({}, state.form, {

				socialMedia: _extends({}, state.form.socialMedia, {
					latestIndex: state.form.socialMedia.latestIndex - 1,
					value: [].concat(state.form.socialMedia.value, [state.form.socialMedia.latestIndex]),
					data: _extends({}, state.form.socialMedia.data, (_extends5 = {}, _extends5[state.form.socialMedia.latestIndex] = _extends({}, action.payload, {
						id: state.form.socialMedia.latestIndex
					}), _extends5))
				})
			})
		});
	},
	REMOVE_SOCIAL_LINK: function REMOVE_SOCIAL_LINK(state, action) {
		return _extends({}, state, {

			form: _extends({}, state.form, {

				socialMedia: _extends({}, state.form.socialMedia, {
					value: state.form.socialMedia.value.filter(function (id) {
						return action.payload.id !== id;
					})
				})
			})
		});
	}
}, {
	form: defaultUserData,

	data: {},

	userIgData: {
		id: '',
		username: ''
	}
});

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultAlert = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var defaultAlert = exports.defaultAlert = { show: false, success: false, message: '', option: {} };

exports.default = (0, _reduxActions.handleActions)({
	OPEN_ALERT: function OPEN_ALERT(state, action) {
		var _extends2;

		return _extends({}, state, (_extends2 = {}, _extends2[action.payload.type] = _extends({}, state[action.payload.type], {
			show: true,
			option: action.payload.option,
			message: action.payload.message,
			success: action.payload.success
		}), _extends2));
	},

	CLOSE_ALERT: function CLOSE_ALERT(state, action) {
		var _extends3;

		return _extends({}, state, (_extends3 = {}, _extends3[action.payload.type] = _extends({}, state[action.payload.type], {
			show: false,
			message: ''
		}), _extends3));
	},

	LOGOUT_FULFILLED: function LOGOUT_FULFILLED(state) {
		return _extends({}, state, {

			generic: defaultAlert,
			settings: defaultAlert,
			loginSignup: defaultAlert,
			reserve: defaultAlert,
			reserveRecord: defaultAlert,
			booking: defaultAlert,
			overview: defaultAlert
		});
	}
}, {
	generic: defaultAlert,
	settings: defaultAlert,
	loginSignup: defaultAlert,
	reserve: defaultAlert,
	reserveRecord: defaultAlert,
	booking: defaultAlert,
	overview: defaultAlert
});

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

exports.default = (0, _reduxActions.handleActions)({
	FETCH_SONG_FULFILLED: function FETCH_SONG_FULFILLED(state, action) {
		return _extends({}, state, {

			list: action.payload.list,

			data: _extends({}, state.data, action.payload.data),

			limit: action.payload.limit,
			offset: action.payload.offset
		});
	},

	UPDATE_SONG_KEYWORD: function UPDATE_SONG_KEYWORD(state, action) {
		return _extends({}, state, {

			keyword: action.payload.value
		});
	},

	FETCH_USER_FULFILLED: function FETCH_USER_FULFILLED(state, action) {
		return _extends({}, state, {

			data: _extends({}, state.data, action.payload.songData)
		});
	}
}, {
	list: [],
	data: {},
	limit: 10,
	offset: 0,
	keyword: ''
});

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

exports.default = (0, _reduxActions.handleActions)({
	FETCH_IG_MEDIA_FULFILLED: function FETCH_IG_MEDIA_FULFILLED(state, action) {
		return _extends({}, state, {

			ig: {
				list: action.payload.list,
				data: _extends({}, state.ig.data, action.payload.data)
			}
		});
	}
}, {
	ig: {
		list: [],
		data: {}
	}
});

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultCommunitySearchData = exports.defaultCommunityData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

var defaultCommunityData = exports.defaultCommunityData = {
	id: 1,
	name: 'Name_1',
	email: 'zone@25sprout.com',
	gender: 'MALE',
	nickname: 'NickName_1',
	career: '程序猿AA',
	ig_media: [],
	city_id: 13,
	image: 'u',
	intro: '努力裝成熟的威士忌漢子，暢談他們與酒作伴的人生。努力裝成熟的威士忌漢子，暢談他們與酒作伴的人生。 努力裝成熟的威士忌漢子，暢談他們與酒作伴的人生。努力裝成熟的威士忌漢子，暢談他們與酒作伴的人生。',
	image_url: 'https://9floorco-living.25demo.com/backend/web/user/u',
	songs: [],
	job_types: [],
	professions: [{
		id: 1,
		name: '專業_KPB4D',
		user_id: null,
		order: 9,
		created_at: '2018-07-18 15:15:39',
		updated_at: '2018-07-18 15:15:39',
		pivot: {
			user_id: 15,
			profession_id: 1
		}
	}],
	social_media: [],
	interests: [{
		id: 3,
		name: '興趣_zgHhl',
		user_id: '1',
		pivot: {
			user_id: 15,
			interest_tag_id: 3
		}
	}]
};

var defaultCommunitySearchData = exports.defaultCommunitySearchData = {
	keyword: { value: '', status: '', valid: false },
	city: { value: [], list: [], data: {}, status: '', valid: false }
};

exports.default = (0, _reduxActions.handleActions)({
	FETCH_COMMUNITY_FULFILLED: function FETCH_COMMUNITY_FULFILLED(state, action) {
		return _extends({}, state, {

			list: action.payload.list,
			data: _extends({}, state.data, action.payload.data),
			currentPage: action.payload.currentPage,
			lastPage: action.payload.lastPage
		});
	},

	FETCH_MORE_COMMUNITY_FULFILLED: function FETCH_MORE_COMMUNITY_FULFILLED(state, action) {
		return _extends({}, state, {

			list: [].concat(state.list, action.payload.list),
			data: _extends({}, state.data, action.payload.data),
			currentPage: action.payload.currentPage,
			lastPage: action.payload.lastPage
		});
	},

	UPDATE_COMMUNITY_FIELD: function UPDATE_COMMUNITY_FIELD(state, action) {
		var _extends2, _extends3;

		return _extends({}, state, (_extends3 = {}, _extends3[action.payload.type] = _extends({}, state[action.payload.type], (_extends2 = {}, _extends2[action.payload.key] = _extends({}, state[action.payload.type][action.payload.key], action.payload.value), _extends2)), _extends3));
	},

	FETCH_COMMUNITY_CITY_FULFILLED: function FETCH_COMMUNITY_CITY_FULFILLED(state, action) {
		return _extends({}, state, {

			search: _extends({}, state.search, {

				city: _extends({}, state.search.city, action.payload)
			})
		});
	}
}, {
	list: [],
	data: {},
	currentPage: -1,
	lastPage: -1,

	search: defaultCommunitySearchData
});

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(5);

exports.default = (0, _reduxActions.handleActions)({
	COLLECT_APARTMENT_OR_ROOM_FULFILLED: function COLLECT_APARTMENT_OR_ROOM_FULFILLED(state, action) {
		return _extends({}, state, {

			roomList: action.payload.roomList,
			apartmentList: action.payload.apartmentList
		});
	},

	FETCH_COLLECT_FULFILLED: function FETCH_COLLECT_FULFILLED(state, action) {
		return _extends({}, state, {

			roomList: action.payload.roomList,
			apartmentList: action.payload.apartmentList
		});
	}
}, {
	roomList: [],
	apartmentList: []
});

/***/ }),
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.rootEpic = undefined;

var _reduxObservable = __webpack_require__(201);

var _filter = __webpack_require__(234);

var _modal = __webpack_require__(56);

var _alert = __webpack_require__(17);

var _song = __webpack_require__(565);

var _bind = __webpack_require__(209);

var _booking = __webpack_require__(55);

var rootEpic = exports.rootEpic = (0, _reduxObservable.combineEpics)(_filter.handleCityChangeEpic, _filter.handleMrtLineChangeEpic, _filter.handleQueryStringEpic, _modal.openMessageModalEpic, _modal.closeMessageModalEpic, _modal.handleForgetVerifyModalEpic, _modal.handleLoginModalEpic, _alert.errorHandleEpic, _song.updateSongKeywordEpic, _bind.updateUserProfessionKeywordEpic, _bind.updateUserInterestKeywordEpic, _bind.updateUserCareerKeywordEpic, _booking.updateBookingMonthEpic, _bind.syncUserSettingLocalStorageEpic);

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.organizeMrtData = exports.stationData = exports.lineData = undefined;

var _i18n = __webpack_require__(16);

var lineData = exports.lineData = [{ id: 0, name: '文山內湖' }, { id: 1, name: '板橋南港' }, { id: 2, name: '淡水信義' }, { id: 3, name: '中和新蘆' }, { id: 4, name: '松山新店' }];

var stationData = exports.stationData = [{
	id: 1,
	name: '南港軟體園區',
	line: '文山內湖',
	near_station: '東湖,南港展覽館',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 2,
	name: '南港展覽館',
	line: '文山內湖,板橋南港',
	near_station: '南港軟體園區,南港',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 3,
	name: '東湖',
	line: '文山內湖',
	near_station: '葫洲,南港軟體園區',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 4,
	name: '葫洲',
	line: '文山內湖',
	near_station: '大湖公園,東湖',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 5,
	name: '大湖公園',
	line: '文山內湖',
	near_station: '內湖,葫洲',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 6,
	name: '內湖',
	line: '文山內湖',
	near_station: '文德,大湖公園',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 7,
	name: '文德',
	line: '文山內湖',
	near_station: '港墘,內湖',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 8,
	name: '港墘',
	line: '文山內湖',
	near_station: '西湖,文德',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 9,
	name: '西湖',
	line: '文山內湖',
	near_station: '劍南路,港墘',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 10,
	name: '劍南路',
	line: '文山內湖',
	near_station: '大直,西湖',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 11,
	name: '大直',
	line: '文山內湖',
	near_station: '松山機場,劍南路',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 12,
	name: '松山機場',
	line: '文山內湖',
	near_station: '中山國中,大直',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 13,
	name: '中山國中',
	line: '文山內湖',
	near_station: '南京復興,松山機場',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 14,
	name: '南京復興',
	line: '文山內湖,松山新店',
	near_station: '松江南京,中山國中,台北小巨蛋,忠孝復興',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 15,
	name: '忠孝復興',
	line: '文山內湖,板橋南港',
	near_station: '忠孝新生,南京復興,忠孝敦化,大安',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 16,
	name: '大安',
	line: '文山內湖,淡水信義',
	near_station: '大安森林公園,忠孝復興,信義安和,科技大樓',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 17,
	name: '科技大樓',
	line: '文山內湖',
	near_station: '大安,六張犁',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 18,
	name: '六張犁',
	line: '文山內湖',
	near_station: '科技大樓,麟光',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 19,
	name: '麟光',
	line: '文山內湖',
	near_station: '六張犁,辛亥',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 20,
	name: '辛亥',
	line: '文山內湖',
	near_station: '麟光,萬芳醫院',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 21,
	name: '萬芳醫院',
	line: '文山內湖',
	near_station: '辛亥,萬芳社區',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 22,
	name: '萬芳社區',
	line: '文山內湖',
	near_station: '萬芳醫院,木柵',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 23,
	name: '木柵',
	line: '文山內湖',
	near_station: '萬芳社區,動物園',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 24,
	name: '動物園',
	line: '文山內湖',
	near_station: '木柵',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 25,
	name: '淡水',
	line: '淡水信義',
	near_station: '紅樹林',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 26,
	name: '紅樹林',
	line: '淡水信義',
	near_station: '淡水,竹圍',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 27,
	name: '竹圍',
	line: '淡水信義',
	near_station: '紅樹林,關渡',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 28,
	name: '關渡',
	line: '淡水信義',
	near_station: '竹圍,忠義',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 29,
	name: '忠義',
	line: '淡水信義',
	near_station: '關渡,復興崗',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 30,
	name: '復興崗',
	line: '淡水信義',
	near_station: '忠義,北投',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 31,
	name: '北投',
	line: '淡水信義',
	near_station: '復興崗,新北投,奇岩',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 32,
	name: '新北投',
	line: '淡水信義',
	near_station: '北投',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 33,
	name: '奇岩',
	line: '淡水信義',
	near_station: '北投,唭哩岸',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 34,
	name: '唭哩岸',
	line: '淡水信義',
	near_station: '奇岩,石牌',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 35,
	name: '石牌',
	line: '淡水信義',
	near_station: '唭哩岸,明德',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 36,
	name: '明德',
	line: '淡水信義',
	near_station: '石牌,芝山',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 37,
	name: '芝山',
	line: '淡水信義',
	near_station: '明德,士林',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 38,
	name: '士林',
	line: '淡水信義',
	near_station: '芝山,劍潭',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 39,
	name: '劍潭',
	line: '淡水信義',
	near_station: '士林,圓山',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 40,
	name: '圓山',
	line: '淡水信義',
	near_station: '劍潭,民權西路',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 41,
	name: '民權西路',
	line: '淡水信義,中和新蘆',
	near_station: '圓山,中山國小,雙連,大橋頭',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 42,
	name: '雙連',
	line: '淡水信義',
	near_station: '民權西路,中山',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 43,
	name: '中山',
	line: '淡水信義,松山新店',
	near_station: '雙連,松江南京,台北車站,北門',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 44,
	name: '台北車站',
	line: '淡水信義,板橋南港',
	near_station: '中山,善導寺,台大醫院,西門',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 45,
	name: '台大醫院',
	line: '淡水信義',
	near_station: '台北車站,中正紀念堂',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 46,
	name: '中正紀念堂',
	line: '淡水信義,松山新店',
	near_station: '台大醫院,東門,古亭,小南門',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 47,
	name: '東門',
	line: '淡水信義,中和新蘆',
	near_station: '忠孝新生,大安森林公園,古亭,中正紀念堂',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 48,
	name: '大安森林公園',
	line: '淡水信義',
	near_station: '大安,東門',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 49,
	name: '信義安和',
	line: '淡水信義',
	near_station: '大安,台北101/世貿',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 50,
	name: '台北101/世貿',
	line: '淡水信義',
	near_station: '信義安和,象山',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 51,
	name: '象山',
	line: '淡水信義',
	near_station: '台北101/世貿',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 52,
	name: '小南門',
	line: '松山新店',
	near_station: '西門,中正紀念堂',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 53,
	name: '古亭',
	line: '松山新店,中和新蘆',
	near_station: '東門,台電大樓,頂溪,中正紀念堂',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 54,
	name: '台電大樓',
	line: '松山新店',
	near_station: '古亭,公館',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 55,
	name: '公館',
	line: '松山新店',
	near_station: '台電大樓,萬隆',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 56,
	name: '萬隆',
	line: '松山新店',
	near_station: '公館,景美',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 57,
	name: '景美',
	line: '松山新店',
	near_station: '萬隆,大坪林',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 58,
	name: '大坪林',
	line: '松山新店',
	near_station: '景美,七張',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 59,
	name: '七張',
	line: '松山新店',
	near_station: '大坪林,小碧潭,新店區公所',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 60,
	name: '小碧潭',
	line: '松山新店',
	near_station: '七張',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 61,
	name: '新店區公所',
	line: '松山新店',
	near_station: '小碧潭,新店',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 62,
	name: '新店',
	line: '松山新店',
	near_station: '新店區公所',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 63,
	name: '南勢角',
	line: '中和新蘆',
	near_station: '景安',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 64,
	name: '景安',
	line: '中和新蘆',
	near_station: '南勢角,永安市場',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 65,
	name: '永安市場',
	line: '中和新蘆',
	near_station: '景安,頂溪',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 66,
	name: '頂溪',
	line: '中和新蘆',
	near_station: '永安市場,古亭',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 67,
	name: '忠孝新生',
	line: '中和新蘆,板橋南港',
	near_station: '松江南京,忠孝復興,東門,善導寺',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 68,
	name: '松江南京',
	line: '中和新蘆',
	near_station: '行天宮,南京復興,忠孝新生,中山',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 69,
	name: '行天宮',
	line: '中和新蘆',
	near_station: '松江南京,中山國小',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 70,
	name: '中山國小',
	line: '中和新蘆',
	near_station: '行天宮,民權西路',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 71,
	name: '大橋頭',
	line: '中和新蘆',
	near_station: '民權西路,三重國小,台北橋',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 72,
	name: '三重國小',
	line: '中和新蘆',
	near_station: '三和國中,大橋頭',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 73,
	name: '三和國中',
	line: '中和新蘆',
	near_station: '三重國小,徐匯中學',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 74,
	name: '徐匯中學',
	line: '中和新蘆',
	near_station: '三和國中,三民高中',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 75,
	name: '三民高中',
	line: '中和新蘆',
	near_station: '徐匯中學,蘆洲',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 76,
	name: '蘆洲',
	line: '中和新蘆',
	near_station: '三民高中',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 77,
	name: '台北橋',
	line: '中和新蘆',
	near_station: '大橋頭,菜寮',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 78,
	name: '菜寮',
	line: '中和新蘆',
	near_station: '台北橋,三重',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 79,
	name: '三重',
	line: '中和新蘆',
	near_station: '菜寮,先嗇宮',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 80,
	name: '先嗇宮',
	line: '中和新蘆',
	near_station: '三重,頭前庄',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 81,
	name: '頭前庄',
	line: '中和新蘆',
	near_station: '先嗇宮,新莊',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 82,
	name: '新莊',
	line: '中和新蘆',
	near_station: '頭前庄,輔大',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 83,
	name: '輔大',
	line: '中和新蘆',
	near_station: '新莊,丹鳳',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 84,
	name: '丹鳳',
	line: '中和新蘆',
	near_station: '輔大,迴龍',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 85,
	name: '迴龍',
	line: '中和新蘆',
	near_station: '丹鳳',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 86,
	name: '南港',
	line: '板橋南港',
	near_station: '南港展覽館,昆陽',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 87,
	name: '昆陽',
	line: '板橋南港',
	near_station: '南港,後山埤',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 88,
	name: '後山埤',
	line: '板橋南港',
	near_station: '昆陽,永春',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 89,
	name: '永春',
	line: '板橋南港',
	near_station: '後山埤,市政府',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 90,
	name: '市政府',
	line: '板橋南港',
	near_station: '永春,國父紀念館',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 91,
	name: '國父紀念館',
	line: '板橋南港',
	near_station: '市政府,忠孝敦化',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 92,
	name: '忠孝敦化',
	line: '板橋南港',
	near_station: '國父紀念館,忠孝復興',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 93,
	name: '善導寺',
	line: '板橋南港',
	near_station: '忠孝新生,台北車站',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 94,
	name: '西門',
	line: '板橋南港',
	near_station: '北門,台北車站,小南門,龍山寺',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 95,
	name: '龍山寺',
	line: '板橋南港',
	near_station: '西門,江子翠',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 96,
	name: '江子翠',
	line: '板橋南港',
	near_station: '龍山寺,新埔',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 97,
	name: '新埔',
	line: '板橋南港',
	near_station: '江子翠,板橋',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 98,
	name: '板橋',
	line: '板橋南港',
	near_station: '新埔,府中',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 99,
	name: '府中',
	line: '板橋南港',
	near_station: '板橋,亞東醫院',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 100,
	name: '亞東醫院',
	line: '板橋南港',
	near_station: '府中,海山',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 101,
	name: '海山',
	line: '板橋南港',
	near_station: '亞東醫院,土城',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 102,
	name: '土城',
	line: '板橋南港',
	near_station: '海山,永寧',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 103,
	name: '永寧',
	line: '板橋南港',
	near_station: '土城,頂埔',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}, {
	id: 104,
	name: '頂埔',
	line: '板橋南港',
	near_station: '永寧',
	created_at: '2018-06-26 14:41:43',
	updated_at: '2018-06-26 14:41:43'
}];

exports.default = stationData;
var organizeMrtData = exports.organizeMrtData = function organizeMrtData(mrtData) {
	var mrtLineList = [];
	var mrtLineData = {};
	var mrtStationData = {};

	mrtLineList.push(0);

	mrtLineData[0] = { value: 0, label: (0, _i18n.t)('roomFilter:all'), name: '全部', stations: [] };

	mrtData.forEach(function (mrt) {
		var lines = mrt.line.split(',');

		lines.forEach(function (line) {
			// organize line data
			var lineId = mrtLineList.find(function (id) {
				return mrtLineData[id].name === line;
			});
			if (!lineId) {
				lineId = mrtLineList.length;

				mrtLineList.push(lineId);
				mrtLineData[lineId] = {
					value: lineId,
					label: (0, _i18n.t)('roomFilter:line', { line: line }),
					name: line,
					stations: []
				};
			}

			// organize station data
			mrtLineData[lineId].stations.push(mrt.id);
			// mrtStationList[lineId].push(mrt.id);
			mrtStationData[mrt.id] = {
				value: mrt.id,
				label: (0, _i18n.t)('roomFilter:station', { station: mrt.name }),
				name: mrt.name
			};
		});
	});

	return { mrtLineList: mrtLineList, mrtLineData: mrtLineData, mrtStationData: mrtStationData };
};

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.addCreditCard = exports.clearValidateOrderCreditData = exports.validateOrderCreditData = exports.generateCreditData = undefined;

var _reduxActions = __webpack_require__(5);

var _alert = __webpack_require__(17);

var _endpoint = __webpack_require__(35);

var _i18n = __webpack_require__(16);

var _exam = __webpack_require__(117);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var generateCreditData = exports.generateCreditData = function generateCreditData(creditForm) {
	return {
		card_number: creditForm.cardNumber.value,
		expiry_year: creditForm.expireYear.value,
		expiry_month: creditForm.expireMonth.value,
		security_code: creditForm.cvc.value,
		credit_name: creditForm.name.value
	};
};

var validateOrderCreditData = exports.validateOrderCreditData = (0, _reduxActions.createAction)('VALIDATE_ORDER_CREDIT_DATA', function (key, valid) {
	return {
		key: key,
		valid: valid
	};
});

var clearValidateOrderCreditData = exports.clearValidateOrderCreditData = (0, _reduxActions.createAction)('CLEAR_VALIDATE_ORDER_CREDIT_DATA');

var addCreditCard = exports.addCreditCard = (0, _reduxActions.createAction)('ADD_CREDIT_CARD', function () {
	return function () {
		var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
			var _getState, creditForm, creditData, creditCheckData, notValidData, _ref2, status, message;

			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_getState = getState(), creditForm = _getState.booking.creditForm;
							creditData = generateCreditData(creditForm);
							creditCheckData = (0, _exam.examCreditData)(creditData);


							dispatch(clearValidateOrderCreditData());

							if (creditCheckData.value) {
								_context.next = 22;
								break;
							}

							if (!creditCheckData.notValid.includes('card_number')) {
								_context.next = 9;
								break;
							}

							dispatch(validateOrderCreditData('cardNumber', false));
							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidCreditNumber'));

						case 9:
							if (!(creditCheckData.notValid.includes('expiry_year') || creditCheckData.notValid.includes('expiry_month'))) {
								_context.next = 14;
								break;
							}

							dispatch(validateOrderCreditData('expireYear', false));
							dispatch(validateOrderCreditData('expireMonth', false));
							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidCreditDate'));

						case 14:
							if (!creditCheckData.notValid.includes('security_code')) {
								_context.next = 18;
								break;
							}

							dispatch(validateOrderCreditData('cvc', false));
							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidCreditCVC'));

						case 18:
							notValidData = (0, _exam.creditKeyFrom)(creditCheckData.notValid);

							notValidData.forEach(function (key) {
								return dispatch(validateOrderCreditData(key, false));
							});
							window.scrollTo(0, 0);
							throw (0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidCreditNumber'));

						case 22:
							_context.next = 24;
							return (0, _endpoint.wrapFetchAuth)('user/addCreditCard', {
								method: 'POST',
								body: JSON.stringify(creditData)
							});

						case 24:
							_ref2 = _context.sent;
							status = _ref2.status;
							message = _ref2.message;

							if (!(status !== 200 && status !== 201)) {
								_context.next = 33;
								break;
							}

							if (!(message === 'credit card number error')) {
								_context.next = 30;
								break;
							}

							throw (0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:notValidCreditNumber'));

						case 30:
							if (!(message === 'credit card expired')) {
								_context.next = 32;
								break;
							}

							throw (0, _alert.openFailedAlert)('booking', (0, _i18n.t)('booking:expiredCreditCard'));

						case 32:
							throw (0, _alert.openFailedAlert)('booking', message);

						case 33:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x, _x2) {
			return _ref.apply(this, arguments);
		};
	}();
});

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  number: __webpack_require__(945),
  expirationDate: __webpack_require__(947),
  expirationMonth: __webpack_require__(452),
  expirationYear: __webpack_require__(210),
  cvv: __webpack_require__(950),
  postalCode: __webpack_require__(951),
  creditCardType: __webpack_require__(451)
};


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var luhn10 = __webpack_require__(946);
var getCardTypes = __webpack_require__(451);

function verification(card, isPotentiallyValid, isValid) {
  return {card: card, isPotentiallyValid: isPotentiallyValid, isValid: isValid};
}

function cardNumber(value, options) {
  var potentialTypes, cardType, isPotentiallyValid, isValid, i, maxLength;

  options = options || {};

  if (typeof value === 'number') {
    value = String(value);
  }

  if (typeof value !== 'string') { return verification(null, false, false); }

  value = value.replace(/\-|\s/g, '');

  if (!/^\d*$/.test(value)) { return verification(null, false, false); }

  potentialTypes = getCardTypes(value);

  if (potentialTypes.length === 0) {
    return verification(null, false, false);
  } else if (potentialTypes.length !== 1) {
    return verification(null, true, false);
  }

  cardType = potentialTypes[0];

  if (options.maxLength && value.length > options.maxLength) {
    return verification(cardType, false, false);
  }

  if (cardType.type === getCardTypes.types.UNIONPAY && options.luhnValidateUnionPay !== true) {
    isValid = true;
  } else {
    isValid = luhn10(value);
  }

  maxLength = Math.max.apply(null, cardType.lengths);
  if (options.maxLength) {
    maxLength = Math.min(options.maxLength, maxLength);
  }

  for (i = 0; i < cardType.lengths.length; i++) {
    if (cardType.lengths[i] === value.length) {
      isPotentiallyValid = value.length < maxLength || isValid;
      return verification(cardType, isPotentiallyValid, isValid);
    }
  }

  return verification(cardType, value.length < maxLength, false);
}

module.exports = cardNumber;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Luhn algorithm implementation in JavaScript
 * Copyright (c) 2009 Nicholas C. Zakas
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */


function luhn10(identifier) {
  var sum = 0;
  var alt = false;
  var i = identifier.length - 1;
  var num;

  while (i >= 0) {
    num = parseInt(identifier.charAt(i), 10);

    if (alt) {
      num *= 2;
      if (num > 9) {
        num = (num % 10) + 1; // eslint-disable-line no-extra-parens
      }
    }

    alt = !alt;

    sum += num;

    i--;
  }

  return sum % 10 === 0;
}

module.exports = luhn10;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var parseDate = __webpack_require__(948);
var expirationMonth = __webpack_require__(452);
var expirationYear = __webpack_require__(210);

function verification(isValid, isPotentiallyValid, month, year) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    month: month,
    year: year
  };
}

function expirationDate(value, maxElapsedYear) {
  var date, monthValid, yearValid, isValidForThisYear;

  if (typeof value === 'string') {
    value = value.replace(/^(\d\d) (\d\d(\d\d)?)$/, '$1/$2');
    date = parseDate(value);
  } else if (value !== null && typeof value === 'object') {
    date = {
      month: String(value.month),
      year: String(value.year)
    };
  } else {
    return verification(false, false, null, null);
  }

  monthValid = expirationMonth(date.month);
  yearValid = expirationYear(date.year, maxElapsedYear);

  if (monthValid.isValid) {
    if (yearValid.isCurrentYear) {
      isValidForThisYear = monthValid.isValidForThisYear;
      return verification(isValidForThisYear, isValidForThisYear, date.month, date.year);
    }

    if (yearValid.isValid) {
      return verification(true, true, date.month, date.year);
    }
  }

  if (monthValid.isPotentiallyValid && yearValid.isPotentiallyValid) {
    return verification(false, true, null, null);
  }

  return verification(false, false, null, null);
}

module.exports = expirationDate;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var expirationYear = __webpack_require__(210);
var isArray = __webpack_require__(949);

function parseDate(value) {
  var month, len, year, yearValid;

  if (/\//.test(value)) {
    value = value.split(/\s*\/\s*/g);
  } else if (/\s/.test(value)) {
    value = value.split(/ +/g);
  }

  if (isArray(value)) {
    return {
      month: value[0],
      year: value.slice(1).join()
    };
  }

  len = value[0] === '0' || value.length > 5 ? 2 : 1;

  if (value[0] === '1') {
    year = value.substr(1);
    yearValid = expirationYear(year);
    if (!yearValid.isPotentiallyValid) {
      len = 2;
    }
  }

  month = value.substr(0, len);

  return {
    month: month,
    year: value.substr(month.length)
  };
}

module.exports = parseDate;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Polyfill taken from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray#Polyfill>.

module.exports = Array.isArray || function (arg) {
  return Object.prototype.toString.call(arg) === '[object Array]';
};


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DEFAULT_LENGTH = 3;

function includes(array, thing) {
  var i = 0;

  for (; i < array.length; i++) {
    if (thing === array[i]) { return true; }
  }

  return false;
}

function max(array) {
  var maximum = DEFAULT_LENGTH;
  var i = 0;

  for (; i < array.length; i++) {
    maximum = array[i] > maximum ? array[i] : maximum;
  }

  return maximum;
}

function verification(isValid, isPotentiallyValid) {
  return {isValid: isValid, isPotentiallyValid: isPotentiallyValid};
}

function cvv(value, maxLength) {
  maxLength = maxLength || DEFAULT_LENGTH;
  maxLength = maxLength instanceof Array ? maxLength : [maxLength];

  if (typeof value !== 'string') { return verification(false, false); }
  if (!/^\d*$/.test(value)) { return verification(false, false); }
  if (includes(maxLength, value.length)) { return verification(true, true); }
  if (value.length < Math.min.apply(null, maxLength)) { return verification(false, true); }
  if (value.length > max(maxLength)) { return verification(false, false); }

  return verification(true, true);
}

module.exports = cvv;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DEFAULT_MIN_POSTAL_CODE_LENGTH = 3;

function verification(isValid, isPotentiallyValid) {
  return {isValid: isValid, isPotentiallyValid: isPotentiallyValid};
}

function postalCode(value, options) {
  var minLength;

  options = options || {};

  minLength = options.minLength || DEFAULT_MIN_POSTAL_CODE_LENGTH;

  if (typeof value !== 'string') {
    return verification(false, false);
  } else if (value.length < minLength) {
    return verification(false, true);
  }

  return verification(true, true);
}

module.exports = postalCode;


/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports = [{"name":{"common":"Aruba","official":"Aruba","native":{"nld":{"official":"Aruba","common":"Aruba"},"pap":{"official":"Aruba","common":"Aruba"}}},"tld":[".aw"],"cca2":"AW","ccn3":"533","cca3":"ABW","cioc":"ARU","independent":false,"status":"officially-assigned","currency":["AWG"],"callingCode":["297"],"capital":["Oranjestad"],"altSpellings":["AW"],"region":"Americas","subregion":"Caribbean","languages":{"nld":"Dutch","pap":"Papiamento"},"translations":{"deu":{"official":"Aruba","common":"Aruba"},"fra":{"official":"Aruba","common":"Aruba"},"hrv":{"official":"Aruba","common":"Aruba"},"ita":{"official":"Aruba","common":"Aruba"},"jpn":{"official":"アルバ","common":"アルバ"},"nld":{"official":"Aruba","common":"Aruba"},"por":{"official":"Aruba","common":"Aruba"},"rus":{"official":"Аруба","common":"Аруба"},"slk":{"official":"Aruba","common":"Aruba"},"spa":{"official":"Aruba","common":"Aruba"},"fin":{"official":"Aruba","common":"Aruba"},"est":{"official":"Aruba","common":"Aruba"},"zho":{"official":"阿鲁巴","common":"阿鲁巴"}},"latlng":[12.5,-69.96666666],"demonym":"Aruban","landlocked":false,"borders":[],"area":180,"flag":"🇦🇼"},{"name":{"common":"Afghanistan","official":"Islamic Republic of Afghanistan","native":{"prs":{"official":"جمهوری اسلامی افغانستان","common":"افغانستان"},"pus":{"official":"د افغانستان اسلامي جمهوریت","common":"افغانستان"},"tuk":{"official":"Owganystan Yslam Respublikasy","common":"Owganystan"}}},"tld":[".af"],"cca2":"AF","ccn3":"004","cca3":"AFG","cioc":"AFG","independent":true,"status":"officially-assigned","currency":["AFN"],"callingCode":["93"],"capital":["Kabul"],"altSpellings":["AF","Afġānistān"],"region":"Asia","subregion":"Southern Asia","languages":{"prs":"Dari","pus":"Pashto","tuk":"Turkmen"},"translations":{"cym":{"official":"Gweriniaeth Islamaidd Affganistan","common":"Affganistan"},"deu":{"official":"Islamische Republik Afghanistan","common":"Afghanistan"},"fra":{"official":"République islamique d'Afghanistan","common":"Afghanistan"},"hrv":{"official":"Islamska Republika Afganistan","common":"Afganistan"},"ita":{"official":"Repubblica islamica dell'Afghanistan","common":"Afghanistan"},"jpn":{"official":"アフガニスタン·イスラム共和国","common":"アフガニスタン"},"nld":{"official":"Islamitische Republiek Afghanistan","common":"Afghanistan"},"por":{"official":"República Islâmica do Afeganistão","common":"Afeganistão"},"rus":{"official":"Исламская Республика Афганистан","common":"Афганистан"},"slk":{"official":"Afgánsky islamský štát","common":"Afganistan"},"spa":{"official":"República Islámica de Afganistán","common":"Afganistán"},"fin":{"official":"Afganistanin islamilainen tasavalta","common":"Afganistan"},"est":{"official":"Afganistani Islamivabariik","common":"Afganistan"},"zho":{"official":"阿富汗伊斯兰共和国","common":"阿富汗"}},"latlng":[33,65],"demonym":"Afghan","landlocked":true,"borders":["IRN","PAK","TKM","UZB","TJK","CHN"],"area":652230,"flag":"🇦🇫"},{"name":{"common":"Angola","official":"Republic of Angola","native":{"por":{"official":"República de Angola","common":"Angola"}}},"tld":[".ao"],"cca2":"AO","ccn3":"024","cca3":"AGO","cioc":"ANG","independent":true,"status":"officially-assigned","currency":["AOA"],"callingCode":["244"],"capital":["Luanda"],"altSpellings":["AO","República de Angola","ʁɛpublika de an'ɡɔla"],"region":"Africa","subregion":"Middle Africa","languages":{"por":"Portuguese"},"translations":{"cym":{"official":"Gweriniaeth Angola","common":"Angola"},"deu":{"official":"Republik Angola","common":"Angola"},"fra":{"official":"République d'Angola","common":"Angola"},"hrv":{"official":"Republika Angola","common":"Angola"},"ita":{"official":"Repubblica dell'Angola","common":"Angola"},"jpn":{"official":"アンゴラ共和国","common":"アンゴラ"},"nld":{"official":"Republiek Angola","common":"Angola"},"por":{"official":"República de Angola","common":"Angola"},"rus":{"official":"Республика Ангола","common":"Ангола"},"slk":{"official":"Angolská republika","common":"Angola"},"spa":{"official":"República de Angola","common":"Angola"},"fin":{"official":"Angolan tasavalta","common":"Angola"},"est":{"official":"Angola Vabariik","common":"Angola"},"zho":{"official":"安哥拉共和国","common":"安哥拉"}},"latlng":[-12.5,18.5],"demonym":"Angolan","landlocked":false,"borders":["COG","COD","ZMB","NAM"],"area":1246700,"flag":"🇦🇴"},{"name":{"common":"Anguilla","official":"Anguilla","native":{"eng":{"official":"Anguilla","common":"Anguilla"}}},"tld":[".ai"],"cca2":"AI","ccn3":"660","cca3":"AIA","cioc":"","independent":false,"status":"officially-assigned","currency":["XCD"],"callingCode":["1264"],"capital":["The Valley"],"altSpellings":["AI"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"deu":{"official":"Anguilla","common":"Anguilla"},"fra":{"official":"Anguilla","common":"Anguilla"},"hrv":{"official":"Anguilla","common":"Angvila"},"ita":{"official":"Anguilla","common":"Anguilla"},"jpn":{"official":"アングィラ","common":"アンギラ"},"nld":{"official":"Anguilla","common":"Anguilla"},"por":{"official":"Anguilla","common":"Anguilla"},"rus":{"official":"Ангилья","common":"Ангилья"},"slk":{"official":"Anguilla","common":"Anguilla"},"spa":{"official":"Anguila","common":"Anguilla"},"fin":{"official":"Anguilla","common":"Anguilla"},"est":{"official":"Anguilla","common":"Anguilla"},"zho":{"official":"安圭拉","common":"安圭拉"}},"latlng":[18.25,-63.16666666],"demonym":"Anguillian","landlocked":false,"borders":[],"area":91,"flag":"🇦🇮"},{"name":{"common":"Åland Islands","official":"Åland Islands","native":{"swe":{"official":"Landskapet Åland","common":"Åland"}}},"tld":[".ax"],"cca2":"AX","ccn3":"248","cca3":"ALA","cioc":"","independent":false,"status":"officially-assigned","currency":["EUR"],"callingCode":["358"],"capital":["Mariehamn"],"altSpellings":["AX","Aaland","Aland","Ahvenanmaa"],"region":"Europe","subregion":"Northern Europe","languages":{"swe":"Swedish"},"translations":{"deu":{"official":"Åland-Inseln","common":"Åland"},"fra":{"official":"Ahvenanmaa","common":"Ahvenanmaa"},"hrv":{"official":"Aland Islands","common":"Ålandski otoci"},"ita":{"official":"Isole Åland","common":"Isole Aland"},"jpn":{"official":"オーランド諸島","common":"オーランド諸島"},"nld":{"official":"Åland eilanden","common":"Ålandeilanden"},"por":{"official":"Ilhas Åland","common":"Alândia"},"rus":{"official":"Аландские острова","common":"Аландские острова"},"slk":{"official":"Alandské ostrovy","common":"Alandy"},"spa":{"official":"Islas Åland","common":"Alandia"},"fin":{"official":"Ahvenanmaan maakunta","common":"Ahvenanmaa"},"est":{"official":"Ahvenamaa maakond","common":"Ahvenamaa"},"zho":{"official":"奥兰群岛","common":"奥兰群岛"}},"latlng":[60.116667,19.9],"demonym":"Ålandish","landlocked":false,"borders":[],"area":1580,"flag":"🇦🇽"},{"name":{"common":"Albania","official":"Republic of Albania","native":{"sqi":{"official":"Republika e Shqipërisë","common":"Shqipëria"}}},"tld":[".al"],"cca2":"AL","ccn3":"008","cca3":"ALB","cioc":"ALB","independent":true,"status":"officially-assigned","currency":["ALL"],"callingCode":["355"],"capital":["Tirana"],"altSpellings":["AL","Shqipëri","Shqipëria","Shqipnia"],"region":"Europe","subregion":"Southern Europe","languages":{"sqi":"Albanian"},"translations":{"cym":{"official":"Gweriniaeth Albania","common":"Albania"},"deu":{"official":"Republik Albanien","common":"Albanien"},"fra":{"official":"République d'Albanie","common":"Albanie"},"hrv":{"official":"Republika Albanija","common":"Albanija"},"ita":{"official":"Repubblica d'Albania","common":"Albania"},"jpn":{"official":"アルバニア共和国","common":"アルバニア"},"nld":{"official":"Republiek Albanië","common":"Albanië"},"por":{"official":"República da Albânia","common":"Albânia"},"rus":{"official":"Республика Албания","common":"Албания"},"slk":{"official":"Albánska republika","common":"Albánsko"},"spa":{"official":"República de Albania","common":"Albania"},"fin":{"official":"Albanian tasavalta","common":"Albania"},"est":{"official":"Albaania Vabariik","common":"Albaania"},"zho":{"official":"阿尔巴尼亚共和国","common":"阿尔巴尼亚"}},"latlng":[41,20],"demonym":"Albanian","landlocked":false,"borders":["MNE","GRC","MKD","UNK"],"area":28748,"flag":"🇦🇱"},{"name":{"common":"Andorra","official":"Principality of Andorra","native":{"cat":{"official":"Principat d'Andorra","common":"Andorra"}}},"tld":[".ad"],"cca2":"AD","ccn3":"020","cca3":"AND","cioc":"AND","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["376"],"capital":["Andorra la Vella"],"altSpellings":["AD","Principality of Andorra","Principat d'Andorra"],"region":"Europe","subregion":"Southern Europe","languages":{"cat":"Catalan"},"translations":{"cym":{"official":"Tywysogaeth Andorra","common":"Andorra"},"deu":{"official":"Fürstentum Andorra","common":"Andorra"},"fra":{"official":"Principauté d'Andorre","common":"Andorre"},"hrv":{"official":"Kneževina Andora","common":"Andora"},"ita":{"official":"Principato di Andorra","common":"Andorra"},"jpn":{"official":"アンドラ公国","common":"アンドラ"},"nld":{"official":"Prinsdom Andorra","common":"Andorra"},"por":{"official":"Principado de Andorra","common":"Andorra"},"rus":{"official":"Княжество Андорра","common":"Андорра"},"slk":{"official":"Andorrské kniežatstvo","common":"Andorra"},"spa":{"official":"Principado de Andorra","common":"Andorra"},"fin":{"official":"Andorran ruhtinaskunta","common":"Andorra"},"est":{"official":"Andorra Vürstiriik","common":"Andorra"},"zho":{"official":"安道尔公国","common":"安道尔"}},"latlng":[42.5,1.5],"demonym":"Andorran","landlocked":true,"borders":["FRA","ESP"],"area":468,"flag":"🇦🇩"},{"name":{"common":"United Arab Emirates","official":"United Arab Emirates","native":{"ara":{"official":"الإمارات العربية المتحدة","common":"دولة الإمارات العربية المتحدة"}}},"tld":[".ae","امارات."],"cca2":"AE","ccn3":"784","cca3":"ARE","cioc":"UAE","independent":true,"status":"officially-assigned","currency":["AED"],"callingCode":["971"],"capital":["Abu Dhabi"],"altSpellings":["AE","UAE","Emirates"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Vereinigte Arabische Emirate","common":"Vereinigte Arabische Emirate"},"fra":{"official":"Émirats arabes unis","common":"Émirats arabes unis"},"hrv":{"official":"Ujedinjeni Arapski Emirati","common":"Ujedinjeni Arapski Emirati"},"ita":{"official":"Emirati Arabi Uniti","common":"Emirati Arabi Uniti"},"jpn":{"official":"アラブ首長国連邦","common":"アラブ首長国連邦"},"nld":{"official":"Verenigde Arabische Emiraten","common":"Verenigde Arabische Emiraten"},"por":{"official":"Emirados Árabes Unidos","common":"Emirados Árabes Unidos"},"rus":{"official":"Объединенные Арабские Эмираты","common":"Объединённые Арабские Эмираты"},"slk":{"official":"Spojené arabské emiráty","common":"Spojené arabské emiráty"},"spa":{"official":"Emiratos Árabes Unidos","common":"Emiratos Árabes Unidos"},"fin":{"official":"Yhdistyneet arabiemiirikunnat","common":"Arabiemiraatit"},"est":{"official":"Araabia Ühendemiraadid","common":"Araabia Ühendemiraadid"},"zho":{"official":"阿拉伯联合酋长国","common":"阿拉伯联合酋长国"}},"latlng":[24,54],"demonym":"Emirati","landlocked":false,"borders":["OMN","SAU"],"area":83600,"flag":"🇦🇪"},{"name":{"common":"Argentina","official":"Argentine Republic","native":{"grn":{"official":"Argentine Republic","common":"Argentina"},"spa":{"official":"República Argentina","common":"Argentina"}}},"tld":[".ar"],"cca2":"AR","ccn3":"032","cca3":"ARG","cioc":"ARG","independent":true,"status":"officially-assigned","currency":["ARS"],"callingCode":["54"],"capital":["Buenos Aires"],"altSpellings":["AR","Argentine Republic","República Argentina"],"region":"Americas","subregion":"South America","languages":{"grn":"Guaraní","spa":"Spanish"},"translations":{"cym":{"official":"Gweriniaeth yr Ariannin","common":"Ariannin"},"deu":{"official":"Argentinische Republik","common":"Argentinien"},"fra":{"official":"République argentine","common":"Argentine"},"hrv":{"official":"Argentinski Republika","common":"Argentina"},"ita":{"official":"Repubblica Argentina","common":"Argentina"},"jpn":{"official":"アルゼンチン共和国","common":"アルゼンチン"},"nld":{"official":"Argentijnse Republiek","common":"Argentinië"},"por":{"official":"República Argentina","common":"Argentina"},"rus":{"official":"Аргентинская Республика","common":"Аргентина"},"slk":{"official":"Argentínska republika","common":"Argentína"},"spa":{"official":"República Argentina","common":"Argentina"},"fin":{"official":"Argentiinan tasavalta","common":"Argentiina"},"est":{"official":"Argentina Vabariik","common":"Argentina"},"zho":{"official":"阿根廷共和国","common":"阿根廷"}},"latlng":[-34,-64],"demonym":"Argentine","landlocked":false,"borders":["BOL","BRA","CHL","PRY","URY"],"area":2780400,"flag":"🇦🇷"},{"name":{"common":"Armenia","official":"Republic of Armenia","native":{"hye":{"official":"Հայաստանի Հանրապետություն","common":"Հայաստան"}}},"tld":[".am"],"cca2":"AM","ccn3":"051","cca3":"ARM","cioc":"ARM","independent":true,"status":"officially-assigned","currency":["AMD"],"callingCode":["374"],"capital":["Yerevan"],"altSpellings":["AM","Hayastan","Republic of Armenia","Հայաստանի Հանրապետություն"],"region":"Asia","subregion":"Western Asia","languages":{"hye":"Armenian"},"translations":{"cym":{"official":"Gweriniaeth Armenia","common":"Armenia"},"deu":{"official":"Republik Armenien","common":"Armenien"},"fra":{"official":"République d'Arménie","common":"Arménie"},"hrv":{"official":"Republika Armenija","common":"Armenija"},"ita":{"official":"Repubblica di Armenia","common":"Armenia"},"jpn":{"official":"アルメニア共和国","common":"アルメニア"},"nld":{"official":"Republiek Armenië","common":"Armenië"},"por":{"official":"República da Arménia","common":"Arménia"},"rus":{"official":"Республика Армения","common":"Армения"},"slk":{"official":"Arménska republika","common":"Arménsko"},"spa":{"official":"República de Armenia","common":"Armenia"},"fin":{"official":"Armenian tasavalta","common":"Armenia"},"est":{"official":"Armeenia Vabariik","common":"Armeenia"},"zho":{"official":"亚美尼亚共和国","common":"亚美尼亚"}},"latlng":[40,45],"demonym":"Armenian","landlocked":true,"borders":["AZE","GEO","IRN","TUR"],"area":29743,"flag":"🇦🇲"},{"name":{"common":"American Samoa","official":"American Samoa","native":{"eng":{"official":"American Samoa","common":"American Samoa"},"smo":{"official":"Sāmoa Amelika","common":"Sāmoa Amelika"}}},"tld":[".as"],"cca2":"AS","ccn3":"016","cca3":"ASM","cioc":"ASA","independent":false,"status":"officially-assigned","currency":["USD"],"callingCode":["1684"],"capital":["Pago Pago"],"altSpellings":["AS","Amerika Sāmoa","Amelika Sāmoa","Sāmoa Amelika"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","smo":"Samoan"},"translations":{"deu":{"official":"Amerikanisch-Samoa","common":"Amerikanisch-Samoa"},"fra":{"official":"Samoa américaines","common":"Samoa américaines"},"hrv":{"official":"američka Samoa","common":"Američka Samoa"},"ita":{"official":"Samoa americane","common":"Samoa Americane"},"jpn":{"official":"米サモア","common":"アメリカ領サモア"},"nld":{"official":"Amerikaans Samoa","common":"Amerikaans Samoa"},"por":{"official":"Samoa americana","common":"Samoa Americana"},"rus":{"official":"американское Самоа","common":"Американское Самоа"},"slk":{"official":"Americká Samoa","common":"Americká Samoa"},"spa":{"official":"Samoa Americana","common":"Samoa Americana"},"fin":{"official":"Amerikan Samoa","common":"Amerikan Samoa"},"est":{"official":"Ameerika Samoa","common":"Ameerika Samoa"},"zho":{"official":"美属萨摩亚","common":"美属萨摩亚"}},"latlng":[-14.33333333,-170],"demonym":"American Samoan","landlocked":false,"borders":[],"area":199,"flag":"🇦🇸"},{"name":{"common":"Antarctica","official":"Antarctica","native":[]},"tld":[".aq"],"cca2":"AQ","ccn3":"010","cca3":"ATA","cioc":"","independent":false,"status":"officially-assigned","currency":[],"callingCode":[],"capital":[""],"altSpellings":["AQ"],"region":"Antarctic","subregion":"","languages":{},"translations":{"cym":{"official":"Yr Antarctig","common":"Yr Antarctig"},"deu":{"official":"Antarktika","common":"Antarktis"},"fra":{"official":"Antarctique","common":"Antarctique"},"hrv":{"official":"Antarktika","common":"Antarktika"},"ita":{"official":"Antartide","common":"Antartide"},"jpn":{"official":"南極大陸","common":"南極"},"nld":{"official":"Antarctica","common":"Antarctica"},"por":{"official":"Antártica","common":"Antártida"},"rus":{"official":"Антарктида","common":"Антарктида"},"slk":{"official":"Antarktída","common":"Antarktída"},"spa":{"official":"Antártida","common":"Antártida"},"fin":{"official":"Etelämanner","common":"Etelämanner"},"est":{"official":"Antarktika","common":"Antarktika"},"zho":{"official":"南极洲","common":"南极洲"}},"latlng":[-90,0],"demonym":"Antarctican","landlocked":false,"borders":[],"area":14000000,"flag":"🇦🇶"},{"name":{"common":"French Southern and Antarctic Lands","official":"Territory of the French Southern and Antarctic Lands","native":{"fra":{"official":"Territoire des Terres australes et antarctiques françaises","common":"Terres australes et antarctiques françaises"}}},"tld":[".tf"],"cca2":"TF","ccn3":"260","cca3":"ATF","cioc":"","independent":false,"status":"officially-assigned","currency":["EUR"],"callingCode":[],"capital":["Port-aux-Français"],"altSpellings":["TF","French Southern Territories"],"region":"Antarctic","subregion":"","languages":{"fra":"French"},"translations":{"deu":{"official":"Gebiet der Französisch Süd-und Antarktisgebiete","common":"Französische Süd-und Antarktisgebiete"},"fra":{"official":"Territoire des Terres australes et antarctiques françaises","common":"Terres australes et antarctiques françaises"},"hrv":{"official":"Teritoriju Francuski južni i antarktički teritoriji","common":"Francuski južni i antarktički teritoriji"},"ita":{"official":"Territorio della australi e antartiche francesi Terre","common":"Territori Francesi del Sud"},"jpn":{"official":"フランス領南方·南極地域の領土","common":"フランス領南方・南極地域"},"nld":{"official":"Grondgebied van de Franse Zuidelijke en Antarctische gebieden","common":"Franse Gebieden in de zuidelijke Indische Oceaan"},"por":{"official":"Território do Sul e Antártica Francesa","common":"Terras Austrais e Antárticas Francesas"},"rus":{"official":"Территория Французские Южные и Антарктические земли","common":"Французские Южные и Антарктические территории"},"slk":{"official":"Francúzske južné a antarktické územia","common":"Francúzske juŽné a antarktické územia"},"spa":{"official":"Territorio del Francés Tierras australes y antárticas","common":"Tierras Australes y Antárticas Francesas"},"fin":{"official":"Ranskan eteläiset ja antarktiset alueet","common":"Ranskan eteläiset ja antarktiset alueet"},"est":{"official":"Prantsuse Lõunaalad","common":"Prantsuse Lõunaalad"},"zho":{"official":"法国南部和南极土地","common":"法国南部和南极土地"}},"latlng":[-49.25,69.167],"demonym":"French","landlocked":false,"borders":[],"area":7747,"flag":"🇹🇫"},{"name":{"common":"Antigua and Barbuda","official":"Antigua and Barbuda","native":{"eng":{"official":"Antigua and Barbuda","common":"Antigua and Barbuda"}}},"tld":[".ag"],"cca2":"AG","ccn3":"028","cca3":"ATG","cioc":"ANT","independent":true,"status":"officially-assigned","currency":["XCD"],"callingCode":["1268"],"capital":["Saint John's"],"altSpellings":["AG"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"cym":{"official":"Antigwa a Barbiwda","common":"Antigwa a Barbiwda"},"deu":{"official":"Antigua und Barbuda","common":"Antigua und Barbuda"},"fra":{"official":"Antigua -et-Barbuda","common":"Antigua-et-Barbuda"},"hrv":{"official":"Antigva i Barbuda","common":"Antigva i Barbuda"},"ita":{"official":"Antigua e Barbuda","common":"Antigua e Barbuda"},"jpn":{"official":"アンチグアバーブーダ","common":"アンティグア・バーブーダ"},"nld":{"official":"Antigua en Barbuda","common":"Antigua en Barbuda"},"por":{"official":"Antigua e Barbuda","common":"Antígua e Barbuda"},"rus":{"official":"Антигуа и Барбуда","common":"Антигуа и Барбуда"},"slk":{"official":"Antigua a Barbuda","common":"Antigua a Barbuda"},"spa":{"official":"Antigua y Barbuda","common":"Antigua y Barbuda"},"fin":{"official":"Antigua ja Barbuda","common":"Antigua ja Barbuda"},"est":{"official":"Antigua ja Barbuda","common":"Antigua ja Barbuda"},"zho":{"official":"安提瓜和巴布达","common":"安提瓜和巴布达"}},"latlng":[17.05,-61.8],"demonym":"Antiguan, Barbudan","landlocked":false,"borders":[],"area":442,"flag":"🇦🇬"},{"name":{"common":"Australia","official":"Commonwealth of Australia","native":{"eng":{"official":"Commonwealth of Australia","common":"Australia"}}},"tld":[".au"],"cca2":"AU","ccn3":"036","cca3":"AUS","cioc":"AUS","independent":true,"status":"officially-assigned","currency":["AUD"],"callingCode":["61"],"capital":["Canberra"],"altSpellings":["AU"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English"},"translations":{"cym":{"official":"Cymanwlad Awstralia","common":"Awstralia"},"deu":{"official":"Commonwealth Australien","common":"Australien"},"fra":{"official":"Australie","common":"Australie"},"hrv":{"official":"Commonwealth of Australia","common":"Australija"},"ita":{"official":"Commonwealth dell'Australia","common":"Australia"},"jpn":{"official":"オーストラリア連邦","common":"オーストラリア"},"nld":{"official":"Gemenebest van Australië","common":"Australië"},"por":{"official":"Comunidade da Austrália","common":"Austrália"},"rus":{"official":"Содружество Австралии","common":"Австралия"},"slk":{"official":"Austrálsky zväz","common":"Austrália"},"spa":{"official":"Mancomunidad de Australia","common":"Australia"},"fin":{"official":"Australian liittovaltio","common":"Australia"},"est":{"official":"Austraalia Ühendus","common":"Austraalia"},"zho":{"official":"澳大利亚联邦","common":"澳大利亚"}},"latlng":[-27,133],"demonym":"Australian","landlocked":false,"borders":[],"area":7692024,"flag":"🇦🇺"},{"name":{"common":"Austria","official":"Republic of Austria","native":{"bar":{"official":"Republik Österreich","common":"Österreich"}}},"tld":[".at"],"cca2":"AT","ccn3":"040","cca3":"AUT","cioc":"AUT","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["43"],"capital":["Vienna"],"altSpellings":["AT","Osterreich","Oesterreich"],"region":"Europe","subregion":"Western Europe","languages":{"bar":"Austro-Bavarian German"},"translations":{"cym":{"official":"Gweriniaeth Awstria","common":"Awstria"},"deu":{"official":"Republik Österreich","common":"Österreich"},"fra":{"official":"République d'Autriche","common":"Autriche"},"hrv":{"official":"Republika Austrija","common":"Austrija"},"ita":{"official":"Repubblica d'Austria","common":"Austria"},"jpn":{"official":"オーストリア共和国","common":"オーストリア"},"nld":{"official":"Republiek Oostenrijk","common":"Oostenrijk"},"por":{"official":"República da Áustria","common":"Áustria"},"rus":{"official":"Австрийская Республика","common":"Австрия"},"slk":{"official":"Rakúska republika","common":"Rakúsko"},"spa":{"official":"República de Austria","common":"Austria"},"fin":{"official":"Itävallan tasavalta","common":"Itävalta"},"est":{"official":"Austria Vabariik","common":"Austria"},"zho":{"official":"奥地利共和国","common":"奥地利"}},"latlng":[47.33333333,13.33333333],"demonym":"Austrian","landlocked":true,"borders":["CZE","DEU","HUN","ITA","LIE","SVK","SVN","CHE"],"area":83871,"flag":"🇦🇹"},{"name":{"common":"Azerbaijan","official":"Republic of Azerbaijan","native":{"aze":{"official":"Azərbaycan Respublikası","common":"Azərbaycan"},"rus":{"official":"Азербайджанская Республика","common":"Азербайджан"}}},"tld":[".az"],"cca2":"AZ","ccn3":"031","cca3":"AZE","cioc":"AZE","independent":true,"status":"officially-assigned","currency":["AZN"],"callingCode":["994"],"capital":["Baku"],"altSpellings":["AZ","Republic of Azerbaijan","Azərbaycan Respublikası"],"region":"Asia","subregion":"Western Asia","languages":{"aze":"Azerbaijani","rus":"Russian"},"translations":{"cym":{"official":"Gweriniaeth Aserbaijan","common":"Aserbaijan"},"deu":{"official":"Republik Aserbaidschan","common":"Aserbaidschan"},"fra":{"official":"République d'Azerbaïdjan","common":"Azerbaïdjan"},"hrv":{"official":"Republika Azerbajdžan","common":"Azerbajdžan"},"ita":{"official":"Repubblica dell'Azerbaigian","common":"Azerbaijan"},"jpn":{"official":"アゼルバイジャン共和国","common":"アゼルバイジャン"},"nld":{"official":"Republiek Azerbeidzjan","common":"Azerbeidzjan"},"por":{"official":"República do Azerbaijão","common":"Azerbeijão"},"rus":{"official":"Азербайджанская Республика","common":"Азербайджан"},"slk":{"official":"Azerbajǆanská republika","common":"AzerbajǇan"},"spa":{"official":"República de Azerbaiyán","common":"Azerbaiyán"},"fin":{"official":"Azerbaidzanin tasavalta","common":"Azerbaidzan"},"est":{"official":"Aserbaidžaani Vabariik","common":"Aserbaidžaan"},"zho":{"official":"阿塞拜疆共和国","common":"阿塞拜疆"}},"latlng":[40.5,47.5],"demonym":"Azerbaijani","landlocked":true,"borders":["ARM","GEO","IRN","RUS","TUR"],"area":86600,"flag":"🇦🇿"},{"name":{"common":"Burundi","official":"Republic of Burundi","native":{"fra":{"official":"République du Burundi","common":"Burundi"},"run":{"official":"Republika y'Uburundi ","common":"Uburundi"}}},"tld":[".bi"],"cca2":"BI","ccn3":"108","cca3":"BDI","cioc":"BDI","independent":true,"status":"officially-assigned","currency":["BIF"],"callingCode":["257"],"capital":["Bujumbura"],"altSpellings":["BI","Republic of Burundi","Republika y'Uburundi","République du Burundi"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French","run":"Kirundi"},"translations":{"cym":{"official":"Gweriniaeth Bwrwndi","common":"Bwrwndi"},"deu":{"official":"Republik Burundi","common":"Burundi"},"fra":{"official":"République du Burundi","common":"Burundi"},"hrv":{"official":"Burundi","common":"Burundi"},"ita":{"official":"Repubblica del Burundi","common":"Burundi"},"jpn":{"official":"ブルンジ共和国","common":"ブルンジ"},"nld":{"official":"Republiek Burundi","common":"Burundi"},"por":{"official":"República do Burundi","common":"Burundi"},"rus":{"official":"Республика Бурунди","common":"Бурунди"},"slk":{"official":"Burundská republika","common":"Burundi"},"spa":{"official":"República de Burundi","common":"Burundi"},"fin":{"official":"Burundin tasavalta","common":"Burundi"},"est":{"official":"Burundi Vabariik","common":"Burundi"},"zho":{"official":"布隆迪共和国","common":"布隆迪"}},"latlng":[-3.5,30],"demonym":"Burundian","landlocked":true,"borders":["COD","RWA","TZA"],"area":27834,"flag":"🇧🇮"},{"name":{"common":"Belgium","official":"Kingdom of Belgium","native":{"deu":{"official":"Königreich Belgien","common":"Belgien"},"fra":{"official":"Royaume de Belgique","common":"Belgique"},"nld":{"official":"Koninkrijk België","common":"België"}}},"tld":[".be"],"cca2":"BE","ccn3":"056","cca3":"BEL","cioc":"BEL","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["32"],"capital":["Brussels"],"altSpellings":["BE","België","Belgie","Belgien","Belgique","Kingdom of Belgium","Koninkrijk België","Royaume de Belgique","Königreich Belgien"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German","fra":"French","nld":"Dutch"},"translations":{"cym":{"official":"Teyrnas Gwlad Belg","common":"Gwlad Belg"},"deu":{"official":"Königreich Belgien","common":"Belgien"},"fra":{"official":"Royaume de Belgique","common":"Belgique"},"hrv":{"official":"Kraljevina Belgija","common":"Belgija"},"ita":{"official":"Regno del Belgio","common":"Belgio"},"jpn":{"official":"ベルギー王国","common":"ベルギー"},"nld":{"official":"Koninkrijk België","common":"België"},"por":{"official":"Reino da Bélgica","common":"Bélgica"},"rus":{"official":"Королевство Бельгия","common":"Бельгия"},"slk":{"official":"Belgické kráľovstvo","common":"Belgicko"},"spa":{"official":"Reino de Bélgica","common":"Bélgica"},"fin":{"official":"Belgian kuningaskunta","common":"Belgia"},"est":{"official":"Belgia Kuningriik","common":"Belgia"},"zho":{"official":"比利时王国","common":"比利时"}},"latlng":[50.83333333,4],"demonym":"Belgian","landlocked":false,"borders":["FRA","DEU","LUX","NLD"],"area":30528,"flag":"🇧🇪"},{"name":{"common":"Benin","official":"Republic of Benin","native":{"fra":{"official":"République du Bénin","common":"Bénin"}}},"tld":[".bj"],"cca2":"BJ","ccn3":"204","cca3":"BEN","cioc":"BEN","independent":true,"status":"officially-assigned","currency":["XOF"],"callingCode":["229"],"capital":["Porto-Novo"],"altSpellings":["BJ","Republic of Benin","République du Bénin"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"cym":{"official":"Gweriniaeth Benin","common":"Benin"},"deu":{"official":"Republik Benin","common":"Benin"},"fra":{"official":"République du Bénin","common":"Bénin"},"hrv":{"official":"Republika Benin","common":"Benin"},"ita":{"official":"Repubblica del Benin","common":"Benin"},"jpn":{"official":"ベナン共和国","common":"ベナン"},"nld":{"official":"Republiek Benin","common":"Benin"},"por":{"official":"República do Benin","common":"Benin"},"rus":{"official":"Республика Бенин","common":"Бенин"},"slk":{"official":"Beninská republika","common":"Benin"},"spa":{"official":"República de Benin","common":"Benín"},"fin":{"official":"Beninin tasavalta","common":"Benin"},"est":{"official":"Benini Vabariik","common":"Benin"},"zho":{"official":"贝宁共和国","common":"贝宁"}},"latlng":[9.5,2.25],"demonym":"Beninese","landlocked":false,"borders":["BFA","NER","NGA","TGO"],"area":112622,"flag":"🇧🇯"},{"name":{"common":"Burkina Faso","official":"Burkina Faso","native":{"fra":{"official":"République du Burkina","common":"Burkina Faso"}}},"tld":[".bf"],"cca2":"BF","ccn3":"854","cca3":"BFA","cioc":"BUR","independent":true,"status":"officially-assigned","currency":["XOF"],"callingCode":["226"],"capital":["Ouagadougou"],"altSpellings":["BF"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"cym":{"official":"Bwrcina Ffaso","common":"Bwrcina Ffaso"},"deu":{"official":"Burkina Faso","common":"Burkina Faso"},"fra":{"official":"République du Burkina","common":"Burkina Faso"},"hrv":{"official":"Burkina Faso","common":"Burkina Faso"},"ita":{"official":"Burkina Faso","common":"Burkina Faso"},"jpn":{"official":"ブルキナファソ","common":"ブルキナファソ"},"nld":{"official":"Burkina Faso","common":"Burkina Faso"},"por":{"official":"Burkina Faso","common":"Burkina Faso"},"rus":{"official":"Буркина -Фасо","common":"Буркина-Фасо"},"slk":{"official":"Burkina Faso","common":"Burkina Faso"},"spa":{"official":"Burkina Faso","common":"Burkina Faso"},"fin":{"official":"Burkina Faso","common":"Burkina Faso"},"est":{"official":"Burkina Faso","common":"Burkina Faso"},"zho":{"official":"布基纳法索","common":"布基纳法索"}},"latlng":[13,-2],"demonym":"Burkinabe","landlocked":true,"borders":["BEN","CIV","GHA","MLI","NER","TGO"],"area":272967,"flag":"🇧🇫"},{"name":{"common":"Bangladesh","official":"People's Republic of Bangladesh","native":{"ben":{"official":"বাংলাদেশ গণপ্রজাতন্ত্রী","common":"বাংলাদেশ"}}},"tld":[".bd"],"cca2":"BD","ccn3":"050","cca3":"BGD","cioc":"BAN","independent":true,"status":"officially-assigned","currency":["BDT"],"callingCode":["880"],"capital":["Dhaka"],"altSpellings":["BD","People's Republic of Bangladesh","Gônôprôjatôntri Bangladesh"],"region":"Asia","subregion":"Southern Asia","languages":{"ben":"Bengali"},"translations":{"cym":{"official":"Gweriniaeth Pobl Bangladesh","common":"Bangladesh"},"deu":{"official":"Volksrepublik Bangladesch","common":"Bangladesch"},"fra":{"official":"La République populaire du Bangladesh","common":"Bangladesh"},"hrv":{"official":"Narodna Republika Bangladeš","common":"Bangladeš"},"ita":{"official":"Repubblica popolare del Bangladesh","common":"Bangladesh"},"jpn":{"official":"バングラデシュ人民共和国","common":"バングラデシュ"},"nld":{"official":"Volksrepubliek Bangladesh","common":"Bangladesh"},"por":{"official":"República Popular do Bangladesh","common":"Bangladesh"},"rus":{"official":"Народная Республика Бангладеш","common":"Бангладеш"},"slk":{"official":"Bangladéšska ľudová republika","common":"Bangladéš"},"spa":{"official":"República Popular de Bangladesh","common":"Bangladesh"},"fin":{"official":"Bangladeshin kansantasavalta","common":"Bangladesh"},"est":{"official":"Bangladeshi Rahvavabariik","common":"Bangladesh"},"zho":{"official":"孟加拉人民共和国","common":"孟加拉国"}},"latlng":[24,90],"demonym":"Bangladeshi","landlocked":false,"borders":["MMR","IND"],"area":147570,"flag":"🇧🇩"},{"name":{"common":"Bulgaria","official":"Republic of Bulgaria","native":{"bul":{"official":"Република България","common":"България"}}},"tld":[".bg"],"cca2":"BG","ccn3":"100","cca3":"BGR","cioc":"BUL","independent":true,"status":"officially-assigned","currency":["BGN"],"callingCode":["359"],"capital":["Sofia"],"altSpellings":["BG","Republic of Bulgaria","Република България"],"region":"Europe","subregion":"Eastern Europe","languages":{"bul":"Bulgarian"},"translations":{"cym":{"official":"Gweriniaeth Bwlgaria","common":"Bwlgaria"},"deu":{"official":"Republik Bulgarien","common":"Bulgarien"},"fra":{"official":"République de Bulgarie","common":"Bulgarie"},"hrv":{"official":"Republika Bugarska","common":"Bugarska"},"ita":{"official":"Repubblica di Bulgaria","common":"Bulgaria"},"jpn":{"official":"ブルガリア共和国","common":"ブルガリア"},"nld":{"official":"Republiek Bulgarije","common":"Bulgarije"},"por":{"official":"República da Bulgária","common":"Bulgária"},"rus":{"official":"Республика Болгария","common":"Болгария"},"slk":{"official":"Bulharská republika","common":"Bulharsko"},"spa":{"official":"República de Bulgaria","common":"Bulgaria"},"fin":{"official":"Bulgarian tasavalta","common":"Bulgaria"},"est":{"official":"Bulgaaria Vabariik","common":"Bulgaaria"},"zho":{"official":"保加利亚共和国","common":"保加利亚"}},"latlng":[43,25],"demonym":"Bulgarian","landlocked":false,"borders":["GRC","MKD","ROU","SRB","TUR"],"area":110879,"flag":"🇧🇬"},{"name":{"common":"Bahrain","official":"Kingdom of Bahrain","native":{"ara":{"official":"مملكة البحرين","common":"‏البحرين"}}},"tld":[".bh"],"cca2":"BH","ccn3":"048","cca3":"BHR","cioc":"BRN","independent":true,"status":"officially-assigned","currency":["BHD"],"callingCode":["973"],"capital":["Manama"],"altSpellings":["BH","Kingdom of Bahrain","Mamlakat al-Baḥrayn"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"cym":{"official":"Teyrnas Bahrein","common":"Bahrain"},"deu":{"official":"Königreich Bahrain","common":"Bahrain"},"fra":{"official":"Royaume de Bahreïn","common":"Bahreïn"},"hrv":{"official":"Kraljevina Bahrein","common":"Bahrein"},"ita":{"official":"Regno del Bahrain","common":"Bahrein"},"jpn":{"official":"バーレーン王国","common":"バーレーン"},"nld":{"official":"Koninkrijk Bahrein","common":"Bahrein"},"por":{"official":"Reino do Bahrein","common":"Bahrein"},"rus":{"official":"Королевство Бахрейн","common":"Бахрейн"},"slk":{"official":"Bahrajnské kráľovstvo","common":"Bahrajn"},"spa":{"official":"Reino de Bahrein","common":"Bahrein"},"fin":{"official":"Bahrainin kuningaskunta","common":"Bahrain"},"est":{"official":"Bahreini Kuningriik","common":"Bahrein"},"zho":{"official":"巴林王国","common":"巴林"}},"latlng":[26,50.55],"demonym":"Bahraini","landlocked":false,"borders":[],"area":765,"flag":"🇧🇭"},{"name":{"common":"Bahamas","official":"Commonwealth of the Bahamas","native":{"eng":{"official":"Commonwealth of the Bahamas","common":"Bahamas"}}},"tld":[".bs"],"cca2":"BS","ccn3":"044","cca3":"BHS","cioc":"BAH","independent":true,"status":"officially-assigned","currency":["BSD"],"callingCode":["1242"],"capital":["Nassau"],"altSpellings":["BS","Commonwealth of the Bahamas"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"cym":{"official":"Cymanwlad y Bahamas","common":"Bahamas"},"deu":{"official":"Commonwealth der Bahamas","common":"Bahamas"},"fra":{"official":"Commonwealth des Bahamas","common":"Bahamas"},"hrv":{"official":"Zajednica Bahama","common":"Bahami"},"ita":{"official":"Commonwealth delle Bahamas","common":"Bahamas"},"jpn":{"official":"バハマ","common":"バハマ"},"nld":{"official":"Gemenebest van de Bahama's","common":"Bahama’s"},"por":{"official":"Comunidade das Bahamas","common":"Bahamas"},"rus":{"official":"Содружество Багамских Островов","common":"Багамские Острова"},"slk":{"official":"Bahamské spoločenstvo","common":"Bahamy"},"spa":{"official":"Commonwealth de las Bahamas","common":"Bahamas"},"fin":{"official":"Bahaman liittovaltio","common":"Bahamasaaret"},"est":{"official":"Bahama Ühendus","common":"Bahama"},"zho":{"official":"巴哈马联邦","common":"巴哈马"}},"latlng":[24.25,-76],"demonym":"Bahamian","landlocked":false,"borders":[],"area":13943,"flag":"🇧🇸"},{"name":{"common":"Bosnia and Herzegovina","official":"Bosnia and Herzegovina","native":{"bos":{"official":"Bosna i Hercegovina","common":"Bosna i Hercegovina"},"hrv":{"official":"Bosna i Hercegovina","common":"Bosna i Hercegovina"},"srp":{"official":"Боснa и Херцеговина","common":"Боснa и Херцеговина"}}},"tld":[".ba"],"cca2":"BA","ccn3":"070","cca3":"BIH","cioc":"BIH","independent":true,"status":"officially-assigned","currency":["BAM"],"callingCode":["387"],"capital":["Sarajevo"],"altSpellings":["BA","Bosnia-Herzegovina","Босна и Херцеговина"],"region":"Europe","subregion":"Southern Europe","languages":{"bos":"Bosnian","hrv":"Croatian","srp":"Serbian"},"translations":{"cym":{"official":"Bosnia a Hercegovina","common":"Bosnia a Hercegovina"},"deu":{"official":"Bosnien und Herzegowina","common":"Bosnien und Herzegowina"},"fra":{"official":"Bosnie-et-Herzégovine","common":"Bosnie-Herzégovine"},"hrv":{"official":"Bosna i Hercegovina","common":"Bosna i Hercegovina"},"ita":{"official":"Bosnia-Erzegovina","common":"Bosnia ed Erzegovina"},"jpn":{"official":"ボスニア·ヘルツェゴビナ","common":"ボスニア・ヘルツェゴビナ"},"nld":{"official":"Bosnië-Herzegovina","common":"Bosnië en Herzegovina"},"por":{"official":"Bósnia e Herzegovina","common":"Bósnia e Herzegovina"},"rus":{"official":"Босния и Герцеговина","common":"Босния и Герцеговина"},"slk":{"official":"Republika Bosny a Hercegoviny","common":"Bosna a Hercegovina"},"spa":{"official":"Bosnia y Herzegovina","common":"Bosnia y Herzegovina"},"fin":{"official":"Bosnia ja Hertsegovina","common":"Bosnia ja Hertsegovina"},"est":{"official":"Bosnia ja Hertsegoviina","common":"Bosnia ja Hertsegoviina"},"zho":{"official":"波斯尼亚和黑塞哥维那","common":"波斯尼亚和黑塞哥维那"}},"latlng":[44,18],"demonym":"Bosnian, Herzegovinian","landlocked":false,"borders":["HRV","MNE","SRB"],"area":51209,"flag":"🇧🇦"},{"name":{"common":"Saint Barthélemy","official":"Collectivity of Saint Barthélemy","native":{"fra":{"official":"Collectivité de Saint-Barthélemy","common":"Saint-Barthélemy"}}},"tld":[".bl"],"cca2":"BL","ccn3":"652","cca3":"BLM","cioc":"","independent":false,"status":"officially-assigned","currency":["EUR"],"callingCode":["590"],"capital":["Gustavia"],"altSpellings":["BL","St. Barthelemy","Collectivity of Saint Barthélemy","Collectivité de Saint-Barthélemy"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"deu":{"official":"Gebietskörperschaft Saint -Barthélemy","common":"Saint-Barthélemy"},"fra":{"official":"Collectivité de Saint-Barthélemy","common":"Saint-Barthélemy"},"hrv":{"official":"Kolektivnost sv Barthélemy","common":"Saint Barthélemy"},"ita":{"official":"Collettività di Saint Barthélemy","common":"Antille Francesi"},"jpn":{"official":"サン·バルテルミー島の集合体","common":"サン・バルテルミー"},"nld":{"official":"Gemeenschap Saint Barthélemy","common":"Saint Barthélemy"},"por":{"official":"Coletividade de Saint Barthélemy","common":"São Bartolomeu"},"rus":{"official":"Коллективность Санкт -Бартельми","common":"Сен-Бартелеми"},"slk":{"official":"Svätý Bartolomej","common":"Svätý Bartolomej"},"spa":{"official":"Colectividad de San Barthélemy","common":"San Bartolomé"},"fin":{"official":"Saint-Barthélemyn yhteisö","common":"Saint-Barthélemy"},"est":{"official":"Saint-Barthélemy territoriaalühendus","common":"Saint-Barthélemy"},"zho":{"official":"圣巴泰勒米集体","common":"圣巴泰勒米"}},"latlng":[18.5,-63.41666666],"demonym":"Saint Barthélemy Islander","landlocked":false,"borders":[],"area":21,"flag":"🇧🇱"},{"name":{"common":"Saint Helena, Ascension and Tristan da Cunha","official":"Saint Helena, Ascension and Tristan da Cunha","native":{"eng":{"official":"Saint Helena, Ascension and Tristan da Cunha","common":"Saint Helena, Ascension and Tristan da Cunha"}}},"tld":[".sh",".ac"],"cca2":"SH","ccn3":"654","cca3":"SHN","cioc":"","independent":false,"status":"officially-assigned","currency":["SHP","GBP"],"callingCode":["290","247"],"capital":["Jamestown"],"altSpellings":["Saint Helena","St. Helena, Ascension and Tristan da Cunha"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"deu":{"official":"Sankt Helena, Ascension und Tristan da Cunha","common":"St. Helena, Ascension und Tristan da Cunha"},"fra":{"official":"Sainte-Hélène, Ascension et Tristan da Cunha","common":"Sainte-Hélène, Ascension et Tristan da Cunha"},"hrv":{"official":"Sveta Helena","common":"Sveta Helena"},"ita":{"official":"Sant'Elena, Ascensione e Tristan da Cunha","common":"Sant'Elena, Ascensione e Tristan da Cunha"},"jpn":{"official":"セントヘレナ・アセンションおよびトリスタンダクーニャ","common":"セントヘレナ・アセンションおよびトリスタンダクーニャ"},"nld":{"official":"Sint-Helena, Ascension en Tristan da Cunha","common":"Sint-Helena, Ascension en Tristan da Cunha"},"por":{"official":"Santa Helena, Ascensão e Tristão da Cunha","common":"Santa Helena, Ascensão e Tristão da Cunha"},"rus":{"official":"Острова Святой Елены, Вознесения и Тристан-да-Кунья","common":"Острова Святой Елены, Вознесения и Тристан-да-Кунья"},"slk":{"official":"Svätá Helena (zámorské územie)","common":"Svätá Helena (zámorské územie)"},"spa":{"official":"Santa Elena, Ascensión y Tristán de Acuña","common":"Santa Elena, Ascensión y Tristán de Acuña"},"fin":{"official":"Saint Helena, Ascension ja Tristan da Cunha","common":"Saint Helena, Ascension ja Tristan da Cunha"},"est":{"official":"Saint Helena, Ascension ja Tristan da Cunha","common":"Saint Helena, Ascension ja Tristan da Cunha"},"zho":{"official":"圣赫勒拿、阿森松和特里斯坦-达库尼亚","common":"圣赫勒拿、阿森松和特里斯坦-达库尼亚"}},"latlng":[-15.95,-5.72],"demonym":"Saint Helenian","landlocked":false,"borders":[],"area":394,"flag":"🇸🇭"},{"name":{"common":"Belarus","official":"Republic of Belarus","native":{"bel":{"official":"Рэспубліка Беларусь","common":"Белару́сь"},"rus":{"official":"Республика Беларусь","common":"Беларусь"}}},"tld":[".by"],"cca2":"BY","ccn3":"112","cca3":"BLR","cioc":"BLR","independent":true,"status":"officially-assigned","currency":["BYN"],"callingCode":["375"],"capital":["Minsk"],"altSpellings":["BY","Bielaruś","Republic of Belarus","Белоруссия","Республика Белоруссия"],"region":"Europe","subregion":"Eastern Europe","languages":{"bel":"Belarusian","rus":"Russian"},"translations":{"cym":{"official":"Gweriniaeth Belarws","common":"Belarws"},"deu":{"official":"Republik Belarus","common":"Weißrussland"},"fra":{"official":"République de Biélorussie","common":"Biélorussie"},"hrv":{"official":"Republika Bjelorusija","common":"Bjelorusija"},"ita":{"official":"Repubblica di Belarus","common":"Bielorussia"},"jpn":{"official":"ベラルーシ共和国","common":"ベラルーシ"},"nld":{"official":"Republiek Belarus","common":"Wit-Rusland"},"por":{"official":"República da Bielorrússia","common":"Bielorússia"},"rus":{"official":"Республика Беларусь","common":"Беларусь"},"slk":{"official":"Bieloruská republika","common":"Bielorusko"},"spa":{"official":"República de Belarús","common":"Bielorrusia"},"fin":{"official":"Valko-Venäjän tasavalta","common":"Valko-Venäjä"},"est":{"official":"Valgevene Vabariik","common":"Valgevene"},"zho":{"official":"白俄罗斯共和国","common":"白俄罗斯"}},"latlng":[53,28],"demonym":"Belarusian","landlocked":true,"borders":["LVA","LTU","POL","RUS","UKR"],"area":207600,"flag":"🇧🇾"},{"name":{"common":"Belize","official":"Belize","native":{"bjz":{"official":"Belize","common":"Belize"},"eng":{"official":"Belize","common":"Belize"},"spa":{"official":"Belice","common":"Belice"}}},"tld":[".bz"],"cca2":"BZ","ccn3":"084","cca3":"BLZ","cioc":"BIZ","independent":true,"status":"officially-assigned","currency":["BZD"],"callingCode":["501"],"capital":["Belmopan"],"altSpellings":["BZ"],"region":"Americas","subregion":"Central America","languages":{"bjz":"Belizean Creole","eng":"English","spa":"Spanish"},"translations":{"cym":{"official":"Belîs","common":"Belîs"},"deu":{"official":"Belize","common":"Belize"},"fra":{"official":"Belize","common":"Belize"},"hrv":{"official":"Belize","common":"Belize"},"ita":{"official":"Belize","common":"Belize"},"jpn":{"official":"ベリーズ","common":"ベリーズ"},"nld":{"official":"Belize","common":"Belize"},"por":{"official":"Belize","common":"Belize"},"rus":{"official":"Белиз","common":"Белиз"},"slk":{"official":"Belize","common":"Belize"},"spa":{"official":"Belice","common":"Belice"},"fin":{"official":"Belize","common":"Belize"},"est":{"official":"Belize","common":"Belize"},"zho":{"official":"伯利兹","common":"伯利兹"}},"latlng":[17.25,-88.75],"demonym":"Belizean","landlocked":false,"borders":["GTM","MEX"],"area":22966,"flag":"🇧🇿"},{"name":{"common":"Bermuda","official":"Bermuda","native":{"eng":{"official":"Bermuda","common":"Bermuda"}}},"tld":[".bm"],"cca2":"BM","ccn3":"060","cca3":"BMU","cioc":"BER","independent":false,"status":"officially-assigned","currency":["BMD"],"callingCode":["1441"],"capital":["Hamilton"],"altSpellings":["BM","The Islands of Bermuda","The Bermudas","Somers Isles"],"region":"Americas","subregion":"Northern America","languages":{"eng":"English"},"translations":{"cym":{"official":"Bermiwda","common":"Bermiwda"},"deu":{"official":"Bermuda","common":"Bermuda"},"fra":{"official":"Bermudes","common":"Bermudes"},"hrv":{"official":"Bermuda","common":"Bermudi"},"ita":{"official":"Bermuda","common":"Bermuda"},"jpn":{"official":"バミューダ","common":"バミューダ"},"nld":{"official":"Bermuda","common":"Bermuda"},"por":{"official":"Bermudas","common":"Bermudas"},"rus":{"official":"Бермудские острова","common":"Бермудские Острова"},"slk":{"official":"Bermudy","common":"Bermudy"},"spa":{"official":"Bermuda","common":"Bermudas"},"fin":{"official":"Bermuda","common":"Bermuda"},"est":{"official":"Bermuda","common":"Bermuda"},"zho":{"official":"百慕大","common":"百慕大"}},"latlng":[32.33333333,-64.75],"demonym":"Bermudian","landlocked":false,"borders":[],"area":54,"flag":"🇧🇲"},{"name":{"common":"Bolivia","official":"Plurinational State of Bolivia","native":{"aym":{"official":"Wuliwya Suyu","common":"Wuliwya"},"grn":{"official":"Tetã Volívia","common":"Volívia"},"que":{"official":"Buliwya Mamallaqta","common":"Buliwya"},"spa":{"official":"Estado Plurinacional de Bolivia","common":"Bolivia"}}},"tld":[".bo"],"cca2":"BO","ccn3":"068","cca3":"BOL","cioc":"BOL","independent":true,"status":"officially-assigned","currency":["BOB","BOV"],"callingCode":["591"],"capital":["Sucre"],"altSpellings":["BO","Buliwya","Wuliwya","Bolivia, Plurinational State of","Plurinational State of Bolivia","Estado Plurinacional de Bolivia","Buliwya Mamallaqta","Wuliwya Suyu","Tetã Volívia"],"region":"Americas","subregion":"South America","languages":{"aym":"Aymara","grn":"Guaraní","que":"Quechua","spa":"Spanish"},"translations":{"cym":{"official":"Gweriniaeth Bolifia","common":"Bolifia"},"deu":{"official":"Multinationaler Staat von Bolivien","common":"Bolivien"},"fra":{"official":"État plurinational de Bolivie","common":"Bolivie"},"hrv":{"official":"Plurinational State of Bolivia","common":"Bolivija"},"ita":{"official":"Stato Plurinazionale della Bolivia","common":"Bolivia"},"jpn":{"official":"ボリビアの多民族国","common":"ボリビア多民族国"},"nld":{"official":"Plurinationale Staat van Bolivia","common":"Bolivia"},"por":{"official":"Estado Plurinacional da Bolívia","common":"Bolívia"},"rus":{"official":"Многонациональное Государство Боливия","common":"Боливия"},"slk":{"official":"Bolívijská republika","common":"Bolívia"},"spa":{"official":"Estado Plurinacional de Bolivia","common":"Bolivia"},"fin":{"official":"Bolivian monikansainen valtio","common":"Bolivia"},"est":{"official":"Boliivia Paljurahvuseline Riik","common":"Boliivia"},"zho":{"official":"多民族玻利维亚国","common":"玻利维亚"}},"latlng":[-17,-65],"demonym":"Bolivian","landlocked":true,"borders":["ARG","BRA","CHL","PRY","PER"],"area":1098581,"flag":"🇧🇴"},{"name":{"common":"Caribbean Netherlands","official":"Bonaire, Sint Eustatius and Saba","native":{"nld":{"official":"Bonaire, Sint Eustatius en Saba","common":"Caribisch Nederland"},"pap":{"official":"Boneiru, Sint Eustatius y Saba","common":"Boneiru, Sint Eustatius y Saba"}}},"tld":[".bq",".nl"],"cca2":"BQ","ccn3":"535","cca3":"BES","cioc":"","independent":false,"status":"officially-assigned","currency":["USD"],"callingCode":["599"],"capital":[],"altSpellings":["BES islands"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","nld":"Dutch","pap":"Papiamento"},"translations":{"deu":{"official":"Besonderen Gemeinden der Niederlande","common":"Karibische Niederlande"},"fra":{"official":"Bonaire, Saint-Eustache et Saba","common":"Pays-Bas caribéens"},"hrv":{"official":"Bonaire, Sint Eustatius i Saba","common":"Bonaire, Sint Eustatius i Saba"},"ita":{"official":"Bonaire, Sint Eustatius e Saba","common":"Paesi Bassi caraibici"},"jpn":{"official":"ボネール、シント・ユースタティウスおよびサバ","common":"ボネール、シント・ユースタティウスおよびサバ"},"nld":{"official":"Bonaire, Sint Eustatius en Saba","common":"Caribisch Nederland"},"por":{"official":"Bonaire, Saba e Santo Eustáquio","common":"Países Baixos Caribenhos"},"rus":{"official":"Бонэйр, Синт-Эстатиус и Саба","common":"Карибские Нидерланды"},"slk":{"official":"Bonaire, Sint Eustatius a Saba","common":"Bonaire, Sint Eustatius a Saba"},"spa":{"official":"Bonaire, San Eustaquio y Saba","common":"Caribe Neerlandés"},"fin":{"official":"Bonaire, Sint Eustatius ja Saba","common":"Bonaire, Sint Eustatius ja Saba"},"est":{"official":"Bonaire, Sint Eustatius ja Saba","common":"Bonaire, Sint Eustatius ja Saba"},"zho":{"official":"荷蘭加勒比區","common":"荷蘭加勒比區"}},"latlng":[12.18,-68.25],"demonym":"Dutch","landlocked":false,"borders":[],"area":328,"flag":""},{"name":{"common":"Brazil","official":"Federative Republic of Brazil","native":{"por":{"official":"República Federativa do Brasil","common":"Brasil"}}},"tld":[".br"],"cca2":"BR","ccn3":"076","cca3":"BRA","cioc":"BRA","independent":true,"status":"officially-assigned","currency":["BRL"],"callingCode":["55"],"capital":["Brasília"],"altSpellings":["BR","Brasil","Federative Republic of Brazil","República Federativa do Brasil"],"region":"Americas","subregion":"South America","languages":{"por":"Portuguese"},"translations":{"cym":{"official":"Gweriniaeth Ffederal Brasil","common":"Brasil"},"deu":{"official":"Föderative Republik Brasilien","common":"Brasilien"},"fra":{"official":"République fédérative du Brésil","common":"Brésil"},"hrv":{"official":"Savezne Republike Brazil","common":"Brazil"},"ita":{"official":"Repubblica federativa del Brasile","common":"Brasile"},"jpn":{"official":"ブラジル連邦共和国","common":"ブラジル"},"nld":{"official":"Federale Republiek Brazilië","common":"Brazilië"},"por":{"official":"República Federativa do Brasil","common":"Brasil"},"rus":{"official":"Федеративная Республика Бразилия","common":"Бразилия"},"slk":{"official":"Brazílska federatívna republika","common":"Brazília"},"spa":{"official":"República Federativa del Brasil","common":"Brasil"},"fin":{"official":"Brasilian liittotasavalta","common":"Brasilia"},"est":{"official":"Brasiilia Liitvabariik","common":"Brasiilia"},"zho":{"official":"巴西联邦共和国","common":"巴西"}},"latlng":[-10,-55],"demonym":"Brazilian","landlocked":false,"borders":["ARG","BOL","COL","GUF","GUY","PRY","PER","SUR","URY","VEN"],"area":8515767,"flag":"🇧🇷"},{"name":{"common":"Barbados","official":"Barbados","native":{"eng":{"official":"Barbados","common":"Barbados"}}},"tld":[".bb"],"cca2":"BB","ccn3":"052","cca3":"BRB","cioc":"BAR","independent":true,"status":"officially-assigned","currency":["BBD"],"callingCode":["1246"],"capital":["Bridgetown"],"altSpellings":["BB"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"cym":{"official":"Barbados","common":"Barbados"},"deu":{"official":"Barbados","common":"Barbados"},"fra":{"official":"Barbade","common":"Barbade"},"hrv":{"official":"Barbados","common":"Barbados"},"ita":{"official":"Barbados","common":"Barbados"},"jpn":{"official":"バルバドス","common":"バルバドス"},"nld":{"official":"Barbados","common":"Barbados"},"por":{"official":"Barbados","common":"Barbados"},"rus":{"official":"Барбадос","common":"Барбадос"},"slk":{"official":"Barbados","common":"Barbados"},"spa":{"official":"Barbados","common":"Barbados"},"fin":{"official":"Barbados","common":"Barbados"},"est":{"official":"Barbados","common":"Barbados"},"zho":{"official":"巴巴多斯","common":"巴巴多斯"}},"latlng":[13.16666666,-59.53333333],"demonym":"Barbadian","landlocked":false,"borders":[],"area":430,"flag":"🇧🇧"},{"name":{"common":"Brunei","official":"Nation of Brunei, Abode of Peace","native":{"msa":{"official":"Nation of Brunei, Abode Damai","common":"Negara Brunei Darussalam"}}},"tld":[".bn"],"cca2":"BN","ccn3":"096","cca3":"BRN","cioc":"BRU","independent":true,"status":"officially-assigned","currency":["BND"],"callingCode":["673"],"capital":["Bandar Seri Begawan"],"altSpellings":["BN","Brunei Darussalam","Nation of Brunei","the Abode of Peace"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"msa":"Malay"},"translations":{"cym":{"official":"Teyrnas Brwnei","common":"Brunei"},"deu":{"official":"Nation von Brunei, Wohnung des Friedens","common":"Brunei"},"fra":{"official":"État de Brunei Darussalam","common":"Brunei"},"hrv":{"official":"Nacija od Bruneja, Kuću Mira","common":"Brunej"},"ita":{"official":"Nazione di Brunei, Dimora della Pace","common":"Brunei"},"jpn":{"official":"ブルネイ、平和の精舎の国家","common":"ブルネイ・ダルサラーム"},"nld":{"official":"Natie van Brunei, de verblijfplaats van de Vrede","common":"Brunei"},"por":{"official":"Nação do Brunei, Morada da Paz","common":"Brunei"},"rus":{"official":"Нация Бруней, обитель мира","common":"Бруней"},"slk":{"official":"Brunejský sultanât","common":"Brunej"},"spa":{"official":"Nación de Brunei, Morada de la Paz","common":"Brunei"},"fin":{"official":"Brunei Darussalamin valtio","common":"Brunei"},"est":{"official":"Brunei Darussalami Riik","common":"Brunei"},"zho":{"official":"文莱和平之国","common":"文莱"}},"latlng":[4.5,114.66666666],"demonym":"Bruneian","landlocked":false,"borders":["MYS"],"area":5765,"flag":"🇧🇳"},{"name":{"common":"Bhutan","official":"Kingdom of Bhutan","native":{"dzo":{"official":"འབྲུག་རྒྱལ་ཁབ་","common":"འབྲུག་ཡུལ་"}}},"tld":[".bt"],"cca2":"BT","ccn3":"064","cca3":"BTN","cioc":"BHU","independent":true,"status":"officially-assigned","currency":["BTN","INR"],"callingCode":["975"],"capital":["Thimphu"],"altSpellings":["BT","Kingdom of Bhutan"],"region":"Asia","subregion":"Southern Asia","languages":{"dzo":"Dzongkha"},"translations":{"cym":{"official":"Teyrnas Bhwtan","common":"Bhwtan"},"deu":{"official":"Königreich Bhutan","common":"Bhutan"},"fra":{"official":"Royaume du Bhoutan","common":"Bhoutan"},"hrv":{"official":"Kraljevina Butan","common":"Butan"},"ita":{"official":"Regno del Bhutan","common":"Bhutan"},"jpn":{"official":"ブータン王国","common":"ブータン"},"nld":{"official":"Koninkrijk Bhutan","common":"Bhutan"},"por":{"official":"Reino do Butão","common":"Butão"},"rus":{"official":"Королевство Бутан","common":"Бутан"},"slk":{"official":"Bhutánske krâľovstvo","common":"Bhután"},"spa":{"official":"Reino de Bután","common":"Bután"},"fin":{"official":"Bhutanin kuningaskunta","common":"Bhutan"},"est":{"official":"Bhutani Kuningriik","common":"Bhutan"},"zho":{"official":"不丹王国","common":"不丹"}},"latlng":[27.5,90.5],"demonym":"Bhutanese","landlocked":true,"borders":["CHN","IND"],"area":38394,"flag":"🇧🇹"},{"name":{"common":"Bouvet Island","official":"Bouvet Island","native":{"nor":{"official":"Bouvetøya","common":"Bouvetøya"}}},"tld":[".bv"],"cca2":"BV","ccn3":"074","cca3":"BVT","cioc":"","independent":false,"status":"officially-assigned","currency":["NOK"],"callingCode":[],"capital":[""],"altSpellings":["BV","Bouvetøya","Bouvet-øya"],"region":"Antarctic","subregion":"","languages":{"nor":"Norwegian"},"translations":{"deu":{"official":"Bouvet-Insel","common":"Bouvetinsel"},"fra":{"official":"Île Bouvet","common":"Île Bouvet"},"hrv":{"official":"Bouvet Island","common":"Otok Bouvet"},"ita":{"official":"Isola Bouvet","common":"Isola Bouvet"},"jpn":{"official":"ブーヴェ島","common":"ブーベ島"},"nld":{"official":"Bouvet Island","common":"Bouveteiland"},"por":{"official":"Ilha Bouvet","common":"Ilha Bouvet"},"rus":{"official":"Остров Буве","common":"Остров Буве"},"slk":{"official":"Bouvetov ostrov","common":"Bouvetov ostrov"},"spa":{"official":"Isla Bouvet","common":"Isla Bouvet"},"fin":{"official":"Bouvet'nsaari","common":"Bouvet'nsaari"},"est":{"official":"Bouvet’ saar","common":"Bouvet’ saar"},"zho":{"official":"布维岛","common":"布维岛"}},"latlng":[-54.43333333,3.4],"demonym":"","landlocked":false,"borders":[],"area":49,"flag":"🇧🇻"},{"name":{"common":"Botswana","official":"Republic of Botswana","native":{"eng":{"official":"Republic of Botswana","common":"Botswana"},"tsn":{"official":"Lefatshe la Botswana","common":"Botswana"}}},"tld":[".bw"],"cca2":"BW","ccn3":"072","cca3":"BWA","cioc":"BOT","independent":true,"status":"officially-assigned","currency":["BWP"],"callingCode":["267"],"capital":["Gaborone"],"altSpellings":["BW","Republic of Botswana","Lefatshe la Botswana"],"region":"Africa","subregion":"Southern Africa","languages":{"eng":"English","tsn":"Tswana"},"translations":{"deu":{"official":"Republik Botsuana","common":"Botswana"},"fra":{"official":"République du Botswana","common":"Botswana"},"hrv":{"official":"Republika Bocvana","common":"Bocvana"},"ita":{"official":"Repubblica del Botswana","common":"Botswana"},"jpn":{"official":"ボツワナ共和国","common":"ボツワナ"},"nld":{"official":"Republiek Botswana","common":"Botswana"},"por":{"official":"República do Botswana","common":"Botswana"},"rus":{"official":"Республика Ботсвана","common":"Ботсвана"},"slk":{"official":"Botswanská republika","common":"Botswana"},"spa":{"official":"República de Botswana","common":"Botswana"},"fin":{"official":"Botswanan tasavalta","common":"Botswana"},"est":{"official":"Botswana Vabariik","common":"Botswana"},"zho":{"official":"博茨瓦纳共和国","common":"博茨瓦纳"}},"latlng":[-22,24],"demonym":"Motswana","landlocked":true,"borders":["NAM","ZAF","ZMB","ZWE"],"area":582000,"flag":"🇧🇼"},{"name":{"common":"Central African Republic","official":"Central African Republic","native":{"fra":{"official":"République centrafricaine","common":"République centrafricaine"},"sag":{"official":"Ködörösêse tî Bêafrîka","common":"Bêafrîka"}}},"tld":[".cf"],"cca2":"CF","ccn3":"140","cca3":"CAF","cioc":"CAF","independent":true,"status":"officially-assigned","currency":["XAF"],"callingCode":["236"],"capital":["Bangui"],"altSpellings":["CF","Central African Republic","République centrafricaine"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","sag":"Sango"},"translations":{"cym":{"official":"Gweriniaeth Canolbarth Affrica","common":"Gweriniaeth Canolbarth Affrica"},"deu":{"official":"Zentralafrikanische Republik","common":"Zentralafrikanische Republik"},"fra":{"official":"République centrafricaine","common":"République centrafricaine"},"hrv":{"official":"Centralna Afrička Republika","common":"Srednjoafrička Republika"},"ita":{"official":"Repubblica Centrafricana","common":"Repubblica Centrafricana"},"jpn":{"official":"中央アフリカ共和国","common":"中央アフリカ共和国"},"nld":{"official":"Centraal-Afrikaanse Republiek","common":"Centraal-Afrikaanse Republiek"},"por":{"official":"República Centro-Africano","common":"República Centro-Africana"},"rus":{"official":"Центрально-Африканская Республика","common":"Центральноафриканская Республика"},"slk":{"official":"Stredoafrická republika","common":"Stredoafrická republika"},"spa":{"official":"República Centroafricana","common":"República Centroafricana"},"fin":{"official":"Keski-Afrikan tasavalta","common":"Keski-Afrikan tasavalta"},"est":{"official":"Kesk-Aafrika Vabariik","common":"Kesk-Aafrika Vabariik"},"zho":{"official":"中非共和国","common":"中非共和国"}},"latlng":[7,21],"demonym":"Central African","landlocked":true,"borders":["CMR","TCD","COD","COG","SSD","SDN"],"area":622984,"flag":"🇨🇫"},{"name":{"common":"Canada","official":"Canada","native":{"eng":{"official":"Canada","common":"Canada"},"fra":{"official":"Canada","common":"Canada"}}},"tld":[".ca"],"cca2":"CA","ccn3":"124","cca3":"CAN","cioc":"CAN","independent":true,"status":"officially-assigned","currency":["CAD"],"callingCode":["1"],"capital":["Ottawa"],"altSpellings":["CA"],"region":"Americas","subregion":"Northern America","languages":{"eng":"English","fra":"French"},"translations":{"cym":{"official":"Canada","common":"Canada"},"deu":{"official":"Kanada","common":"Kanada"},"fra":{"official":"Canada","common":"Canada"},"hrv":{"official":"Kanada","common":"Kanada"},"ita":{"official":"Canada","common":"Canada"},"jpn":{"official":"カナダ","common":"カナダ"},"nld":{"official":"Canada","common":"Canada"},"por":{"official":"Canadá","common":"Canadá"},"rus":{"official":"Канада","common":"Канада"},"slk":{"official":"Kanada","common":"Kanada"},"spa":{"official":"Canadá","common":"Canadá"},"fin":{"official":"Kanada","common":"Kanada"},"est":{"official":"Kanada","common":"Kanada"},"zho":{"official":"加拿大","common":"加拿大"}},"latlng":[60,-95],"demonym":"Canadian","landlocked":false,"borders":["USA"],"area":9984670,"flag":"🇨🇦"},{"name":{"common":"Cocos (Keeling) Islands","official":"Territory of the Cocos (Keeling) Islands","native":{"eng":{"official":"Territory of the Cocos (Keeling) Islands","common":"Cocos (Keeling) Islands"}}},"tld":[".cc"],"cca2":"CC","ccn3":"166","cca3":"CCK","cioc":"","independent":false,"status":"officially-assigned","currency":["AUD"],"callingCode":["61"],"capital":["West Island"],"altSpellings":["CC","Keeling Islands","Cocos Islands"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English"},"translations":{"cym":{"official":"Tiriogaeth yr Ynysoedd Cocos (Keeling)","common":"Ynysoedd Cocos"},"deu":{"official":"Gebiet der Cocos (Keeling) Islands","common":"Kokosinseln"},"fra":{"official":"Territoire des îles Cocos (Keeling)","common":"Îles Cocos"},"hrv":{"official":"Teritoriju Kokosovi (Keeling) Islands","common":"Kokosovi Otoci"},"ita":{"official":"Territorio della (Keeling) Isole Cocos","common":"Isole Cocos e Keeling"},"jpn":{"official":"ココス諸島の領土","common":"ココス（キーリング）諸島"},"nld":{"official":"Grondgebied van de Eilanden Cocos (Keeling )","common":"Cocoseilanden"},"por":{"official":"Território dos Cocos (Keeling)","common":"Ilhas Cocos (Keeling)"},"rus":{"official":"Территория Кокосовые (Килинг) острова","common":"Кокосовые острова"},"slk":{"official":"Kokosové ostrovy","common":"Kokosové ostrovy"},"spa":{"official":"Territorio de los (Keeling) Islas Cocos","common":"Islas Cocos o Islas Keeling"},"fin":{"official":"Kookossaaret","common":"Kookossaaret"},"est":{"official":"Kookossaarte ala","common":"Kookossaared"},"zho":{"official":"科科斯","common":"科科斯"}},"latlng":[-12.5,96.83333333],"demonym":"Cocos Islander","landlocked":false,"borders":[],"area":14,"flag":"🇨🇨"},{"name":{"common":"Switzerland","official":"Swiss Confederation","native":{"fra":{"official":"Confédération suisse","common":"Suisse"},"gsw":{"official":"Schweizerische Eidgenossenschaft","common":"Schweiz"},"ita":{"official":"Confederazione Svizzera","common":"Svizzera"},"roh":{"official":"Confederaziun svizra","common":"Svizra"}}},"tld":[".ch"],"cca2":"CH","ccn3":"756","cca3":"CHE","cioc":"SUI","independent":true,"status":"officially-assigned","currency":["CHE","CHF","CHW"],"callingCode":["41"],"capital":["Bern"],"altSpellings":["CH","Swiss Confederation","Schweiz","Suisse","Svizzera","Svizra"],"region":"Europe","subregion":"Western Europe","languages":{"fra":"French","gsw":"Swiss German","ita":"Italian","roh":"Romansh"},"translations":{"deu":{"official":"Schweizerische Eidgenossenschaft","common":"Schweiz"},"fra":{"official":"Confédération suisse","common":"Suisse"},"hrv":{"official":"švicarska Konfederacija","common":"Švicarska"},"ita":{"official":"Confederazione svizzera","common":"Svizzera"},"jpn":{"official":"スイス連邦","common":"スイス"},"nld":{"official":"Zwitserse Confederatie","common":"Zwitserland"},"por":{"official":"Confederação Suíça","common":"Suíça"},"rus":{"official":"Швейцарская Конфедерация","common":"Швейцария"},"slk":{"official":"Švajčiarska konfederácia","common":"Švajčiarsko"},"spa":{"official":"Confederación Suiza","common":"Suiza"},"fin":{"official":"Sveitsin valaliitto","common":"Sveitsi"},"est":{"official":"Šveitsi Konföderatsioon","common":"Šveits"},"zho":{"official":"瑞士联邦","common":"瑞士"}},"latlng":[47,8],"demonym":"Swiss","landlocked":true,"borders":["AUT","FRA","ITA","LIE","DEU"],"area":41284,"flag":"🇨🇭"},{"name":{"common":"Chile","official":"Republic of Chile","native":{"spa":{"official":"República de Chile","common":"Chile"}}},"tld":[".cl"],"cca2":"CL","ccn3":"152","cca3":"CHL","cioc":"CHI","independent":true,"status":"officially-assigned","currency":["CLF","CLP"],"callingCode":["56"],"capital":["Santiago"],"altSpellings":["CL","Republic of Chile","República de Chile"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"cym":{"official":"Gweriniaeth Chile","common":"Chile"},"deu":{"official":"Republik Chile","common":"Chile"},"fra":{"official":"République du Chili","common":"Chili"},"hrv":{"official":"Republika Čile","common":"Čile"},"ita":{"official":"Repubblica del Cile","common":"Cile"},"jpn":{"official":"チリ共和国","common":"チリ"},"nld":{"official":"Republiek Chili","common":"Chili"},"por":{"official":"República do Chile","common":"Chile"},"rus":{"official":"Республика Чили","common":"Чили"},"slk":{"official":"Čílska republika","common":"Čile"},"spa":{"official":"República de Chile","common":"Chile"},"fin":{"official":"Chilen tasavalta","common":"Chile"},"est":{"official":"Tšiili Vabariik","common":"Tšiili"},"zho":{"official":"智利共和国","common":"智利"}},"latlng":[-30,-71],"demonym":"Chilean","landlocked":false,"borders":["ARG","BOL","PER"],"area":756102,"flag":"🇨🇱"},{"name":{"common":"China","official":"People's Republic of China","native":{"zho":{"official":"中华人民共和国","common":"中国"}}},"tld":[".cn",".中国",".中國",".公司",".网络"],"cca2":"CN","ccn3":"156","cca3":"CHN","cioc":"CHN","independent":true,"status":"officially-assigned","currency":["CNY"],"callingCode":["86"],"capital":["Beijing"],"altSpellings":["CN","Zhōngguó","Zhongguo","Zhonghua","People's Republic of China","中华人民共和国","Zhōnghuá Rénmín Gònghéguó"],"region":"Asia","subregion":"Eastern Asia","languages":{"zho":"Chinese"},"translations":{"cym":{"official":"Gweriniaeth Pobl Tsieina","common":"Tsieina"},"deu":{"official":"Volksrepublik China","common":"China"},"fra":{"official":"République populaire de Chine","common":"Chine"},"hrv":{"official":"Narodna Republika Kina","common":"Kina"},"ita":{"official":"Repubblica popolare cinese","common":"Cina"},"jpn":{"official":"中華人民共和国","common":"中国"},"nld":{"official":"Volksrepubliek China","common":"China"},"por":{"official":"República Popular da China","common":"China"},"rus":{"official":"Народная Республика Китай","common":"Китай"},"slk":{"official":"Čínska ľudová republika","common":"Čína"},"spa":{"official":"República Popular de China","common":"China"},"fin":{"official":"Kiinan kansantasavalta","common":"Kiina"},"est":{"official":"Hiina Rahvavabariik","common":"Hiina"}},"latlng":[35,105],"demonym":"Chinese","landlocked":false,"borders":["AFG","BTN","MMR","HKG","IND","KAZ","NPL","PRK","KGZ","LAO","MAC","MNG","PAK","RUS","TJK","VNM"],"area":9706961,"flag":"🇨🇳"},{"name":{"common":"Ivory Coast","official":"Republic of Côte d'Ivoire","native":{"fra":{"official":"République de Côte d'Ivoire","common":"Côte d'Ivoire"}}},"tld":[".ci"],"cca2":"CI","ccn3":"384","cca3":"CIV","cioc":"CIV","independent":true,"status":"officially-assigned","currency":["XOF"],"callingCode":["225"],"capital":["Yamoussoukro"],"altSpellings":["CI","Côte d'Ivoire","Ivory Coast","Republic of Côte d'Ivoire","République de Côte d'Ivoire"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"deu":{"official":"Republik Côte d'Ivoire","common":"Elfenbeinküste"},"fra":{"official":"République de Côte d' Ivoire","common":"Côte d'Ivoire"},"hrv":{"official":"Republika Côte d'Ivoire","common":"Obala Bjelokosti"},"ita":{"official":"Repubblica della Costa d'Avorio","common":"Costa d'Avorio"},"jpn":{"official":"コートジボワール共和国","common":"コートジボワール"},"nld":{"official":"Republiek Ivoorkust","common":"Ivoorkust"},"por":{"official":"República da Côte d'Ivoire","common":"Costa do Marfim"},"rus":{"official":"Республика Кот-д'Ивуаре","common":"Кот-д’Ивуар"},"slk":{"official":"Republika Pobrežie Slonoviny","common":"Pobržie Slonoviny"},"spa":{"official":"República de Côte d'Ivoire","common":"Costa de Marfil"},"fin":{"official":"Norsunluurannikon tasavalta","common":"Norsunluurannikko"},"est":{"official":"Côte d’Ivoire’i Vabariik","common":"Elevandiluurannik"},"zho":{"official":"科特迪瓦共和国","common":"科特迪瓦"}},"latlng":[8,-5],"demonym":"Ivorian","landlocked":false,"borders":["BFA","GHA","GIN","LBR","MLI"],"area":322463,"flag":"🇨🇮"},{"name":{"common":"Cameroon","official":"Republic of Cameroon","native":{"eng":{"official":"Republic of Cameroon","common":"Cameroon"},"fra":{"official":"République du Cameroun","common":"Cameroun"}}},"tld":[".cm"],"cca2":"CM","ccn3":"120","cca3":"CMR","cioc":"CMR","independent":true,"status":"officially-assigned","currency":["XAF"],"callingCode":["237"],"capital":["Yaoundé"],"altSpellings":["CM","Republic of Cameroon","République du Cameroun"],"region":"Africa","subregion":"Middle Africa","languages":{"eng":"English","fra":"French"},"translations":{"cym":{"official":"Gweriniaeth Camerŵn","common":"Camerŵn"},"deu":{"official":"Republik Kamerun","common":"Kamerun"},"fra":{"official":"République du Cameroun","common":"Cameroun"},"hrv":{"official":"Republika Kamerun","common":"Kamerun"},"ita":{"official":"Repubblica del Camerun","common":"Camerun"},"jpn":{"official":"カメルーン共和国","common":"カメルーン"},"nld":{"official":"Republiek Kameroen","common":"Kameroen"},"por":{"official":"República dos Camarões","common":"Camarões"},"rus":{"official":"Республика Камерун","common":"Камерун"},"slk":{"official":"Kamerunská republika","common":"Kamerun"},"spa":{"official":"República de Camerún","common":"Camerún"},"fin":{"official":"Kamerunin tasavalta","common":"Kamerun"},"est":{"official":"Kameruni Vabariik","common":"Kamerun"},"zho":{"official":"喀麦隆共和国","common":"喀麦隆"}},"latlng":[6,12],"demonym":"Cameroonian","landlocked":false,"borders":["CAF","TCD","COG","GNQ","GAB","NGA"],"area":475442,"flag":"🇨🇲"},{"name":{"common":"DR Congo","official":"Democratic Republic of the Congo","native":{"fra":{"official":"République démocratique du Congo","common":"RD Congo"},"kon":{"official":"Repubilika ya Kongo Demokratiki","common":"Repubilika ya Kongo Demokratiki"},"lin":{"official":"Republiki ya Kongó Demokratiki","common":"Republiki ya Kongó Demokratiki"},"lua":{"official":"Ditunga dia Kongu wa Mungalaata","common":"Ditunga dia Kongu wa Mungalaata"},"swa":{"official":"Jamhuri ya Kidemokrasia ya Kongo","common":"Jamhuri ya Kidemokrasia ya Kongo"}}},"tld":[".cd"],"cca2":"CD","ccn3":"180","cca3":"COD","cioc":"COD","independent":true,"status":"officially-assigned","currency":["CDF"],"callingCode":["243"],"capital":["Kinshasa"],"altSpellings":["CD","DR Congo","Congo-Kinshasa","Congo, the Democratic Republic of the","DRC"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","kon":"Kikongo","lin":"Lingala","lua":"Tshiluba","swa":"Swahili"},"translations":{"cym":{"official":"Gweriniaeth Ddemocrataidd Congo","common":"Gweriniaeth Ddemocrataidd Congo"},"deu":{"official":"Demokratische Republik Kongo","common":"Kongo (Dem. Rep.)"},"fra":{"official":"République démocratique du Congo","common":"Congo (Rép. dém.)"},"hrv":{"official":"Demokratska Republika Kongo","common":"Kongo, Demokratska Republika"},"ita":{"official":"Repubblica Democratica del Congo","common":"Congo (Rep. Dem.)"},"jpn":{"official":"コンゴ民主共和国","common":"コンゴ民主共和国"},"nld":{"official":"Democratische Republiek Congo","common":"Congo (DRC)"},"por":{"official":"República Democrática do Congo","common":"República Democrática do Congo"},"rus":{"official":"Демократическая Республика Конго","common":"Демократическая Республика Конго"},"slk":{"official":"Konžská demokratická republika","common":"Kongo"},"spa":{"official":"República Democrática del Congo","common":"Congo (Rep. Dem.)"},"fin":{"official":"Kongon demokraattinen tasavalta","common":"Kongon demokraattinen tasavalta"},"est":{"official":"Kongo Demokraatlik Vabariik","common":"Kongo DV"},"zho":{"official":"刚果民主共和国","common":"民主刚果"}},"latlng":[0,25],"demonym":"Congolese","landlocked":false,"borders":["AGO","BDI","CAF","COG","RWA","SSD","TZA","UGA","ZMB"],"area":2344858,"flag":"🇨🇩"},{"name":{"common":"Republic of the Congo","official":"Republic of the Congo","native":{"fra":{"official":"République du Congo","common":"République du Congo"},"kon":{"official":"Repubilika ya Kongo","common":"Repubilika ya Kongo"},"lin":{"official":"Republíki ya Kongó","common":"Republíki ya Kongó"}}},"tld":[".cg"],"cca2":"CG","ccn3":"178","cca3":"COG","cioc":"CGO","independent":true,"status":"officially-assigned","currency":["XAF"],"callingCode":["242"],"capital":["Brazzaville"],"altSpellings":["CG","Congo","Congo-Brazzaville"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","kon":"Kikongo","lin":"Lingala"},"translations":{"cym":{"official":"Gweriniaeth y Congo","common":"Gweriniaeth y Congo"},"deu":{"official":"Republik Kongo","common":"Kongo"},"fra":{"official":"République du Congo","common":"Congo"},"hrv":{"official":"Republika Kongo","common":"Kongo"},"ita":{"official":"Repubblica del Congo","common":"Congo"},"jpn":{"official":"コンゴ共和国","common":"コンゴ共和国"},"nld":{"official":"Republiek Congo","common":"Congo"},"por":{"official":"República do Congo","common":"Congo"},"rus":{"official":"Республика Конго","common":"Республика Конго"},"slk":{"official":"Konžská republika","common":"Kongo"},"spa":{"official":"República del Congo","common":"Congo"},"fin":{"official":"Kongon tasavalta","common":"Kongo-Brazzaville"},"est":{"official":"Kongo Vabariik","common":"Kongo Vabariik"},"zho":{"official":"刚果共和国","common":"刚果"}},"latlng":[-1,15],"demonym":"Congolese","landlocked":false,"borders":["AGO","CMR","CAF","COD","GAB"],"area":342000,"flag":"🇨🇬"},{"name":{"common":"Cook Islands","official":"Cook Islands","native":{"eng":{"official":"Cook Islands","common":"Cook Islands"},"rar":{"official":"Kūki 'Āirani","common":"Kūki 'Āirani"}}},"tld":[".ck"],"cca2":"CK","ccn3":"184","cca3":"COK","cioc":"COK","independent":false,"status":"officially-assigned","currency":["NZD","CKD"],"callingCode":["682"],"capital":["Avarua"],"altSpellings":["CK","Kūki 'Āirani"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","rar":"Cook Islands Māori"},"translations":{"cym":{"official":"Ynysoedd Cook","common":"Ynysoedd Cook"},"deu":{"official":"Cook-Inseln","common":"Cookinseln"},"fra":{"official":"Îles Cook","common":"Îles Cook"},"hrv":{"official":"Cook Islands","common":"Cookovo Otočje"},"ita":{"official":"Isole Cook","common":"Isole Cook"},"jpn":{"official":"クック諸島","common":"クック諸島"},"nld":{"official":"Cook eilanden","common":"Cookeilanden"},"por":{"official":"Ilhas Cook","common":"Ilhas Cook"},"rus":{"official":"острова Кука","common":"Острова Кука"},"slk":{"official":"Cookove ostrovy","common":"Cookove ostrovy"},"spa":{"official":"Islas Cook","common":"Islas Cook"},"fin":{"official":"Cookinsaaret","common":"Cookinsaaret"},"est":{"official":"Cooki saared","common":"Cooki saared"},"zho":{"official":"库克群岛","common":"库克群岛"}},"latlng":[-21.23333333,-159.76666666],"demonym":"Cook Islander","landlocked":false,"borders":[],"area":236,"flag":"🇨🇰"},{"name":{"common":"Colombia","official":"Republic of Colombia","native":{"spa":{"official":"República de Colombia","common":"Colombia"}}},"tld":[".co"],"cca2":"CO","ccn3":"170","cca3":"COL","cioc":"COL","independent":true,"status":"officially-assigned","currency":["COP"],"callingCode":["57"],"capital":["Bogotá"],"altSpellings":["CO","Republic of Colombia","República de Colombia"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"cym":{"official":"Gweriniaeth Colombia","common":"Colombia"},"deu":{"official":"Republik Kolumbien","common":"Kolumbien"},"fra":{"official":"République de Colombie","common":"Colombie"},"hrv":{"official":"Republika Kolumbija","common":"Kolumbija"},"ita":{"official":"Repubblica di Colombia","common":"Colombia"},"jpn":{"official":"コロンビア共和国","common":"コロンビア"},"nld":{"official":"Republiek Colombia","common":"Colombia"},"por":{"official":"República da Colômbia","common":"Colômbia"},"rus":{"official":"Республика Колумбия","common":"Колумбия"},"slk":{"official":"Kolumbijská republika","common":"Kolumbia"},"spa":{"official":"República de Colombia","common":"Colombia"},"fin":{"official":"Kolumbian tasavalta","common":"Kolumbia"},"est":{"official":"Colombia Vabariik","common":"Colombia"},"zho":{"official":"哥伦比亚共和国","common":"哥伦比亚"}},"latlng":[4,-72],"demonym":"Colombian","landlocked":false,"borders":["BRA","ECU","PAN","PER","VEN"],"area":1141748,"flag":"🇨🇴"},{"name":{"common":"Comoros","official":"Union of the Comoros","native":{"ara":{"official":"الاتحاد القمري","common":"القمر‎"},"fra":{"official":"Union des Comores","common":"Comores"},"zdj":{"official":"Udzima wa Komori","common":"Komori"}}},"tld":[".km"],"cca2":"KM","ccn3":"174","cca3":"COM","cioc":"COM","independent":true,"status":"officially-assigned","currency":["KMF"],"callingCode":["269"],"capital":["Moroni"],"altSpellings":["KM","Union of the Comoros","Union des Comores","Udzima wa Komori","al-Ittiḥād al-Qumurī"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","fra":"French","zdj":"Comorian"},"translations":{"cym":{"official":"Undeb y Comoros","common":"Y Comoros"},"deu":{"official":"Union der Komoren","common":"Union der Komoren"},"fra":{"official":"Union des Comores","common":"Comores"},"hrv":{"official":"Savez Komori","common":"Komori"},"ita":{"official":"Unione delle Comore","common":"Comore"},"jpn":{"official":"コモロ連合","common":"コモロ"},"nld":{"official":"Unie van de Comoren","common":"Comoren"},"por":{"official":"União das Comores","common":"Comores"},"rus":{"official":"Союз Коморских Островов","common":"Коморы"},"slk":{"official":"Komorská únia","common":"Komory"},"spa":{"official":"Unión de las Comoras","common":"Comoras"},"fin":{"official":"Komorien liitto","common":"Komorit"},"est":{"official":"Komoori Liit","common":"Komoorid"},"zho":{"official":"科摩罗联盟","common":"科摩罗"}},"latlng":[-12.16666666,44.25],"demonym":"Comoran","landlocked":false,"borders":[],"area":1862,"flag":"🇰🇲"},{"name":{"common":"Cape Verde","official":"Republic of Cabo Verde","native":{"por":{"official":"República de Cabo Verde","common":"Cabo Verde"}}},"tld":[".cv"],"cca2":"CV","ccn3":"132","cca3":"CPV","cioc":"CPV","independent":true,"status":"officially-assigned","currency":["CVE"],"callingCode":["238"],"capital":["Praia"],"altSpellings":["CV","Republic of Cabo Verde","República de Cabo Verde"],"region":"Africa","subregion":"Western Africa","languages":{"por":"Portuguese"},"translations":{"cym":{"official":"Gweriniaeth Cabo Verde","common":"Penrhyn Verde"},"deu":{"official":"Republik Cabo Verde","common":"Kap Verde"},"fra":{"official":"République du Cap-Vert","common":"Îles du Cap-Vert"},"hrv":{"official":"Republika Cabo Verde","common":"Zelenortska Republika"},"ita":{"official":"Repubblica di Capo Verde","common":"Capo Verde"},"jpn":{"official":"カーボベルデ共和国","common":"カーボベルデ"},"nld":{"official":"Republiek van Cabo Verde","common":"Kaapverdië"},"por":{"official":"República de Cabo Verde","common":"Cabo Verde"},"rus":{"official":"Республика Кабо -Верде","common":"Кабо-Верде"},"slk":{"official":"Kapverdská republika","common":"Kapverdy"},"spa":{"official":"República de Cabo Verde","common":"Cabo Verde"},"fin":{"official":"Kap Verden tasavalta","common":"Kap Verde"},"est":{"official":"Cabo Verde Vabariik","common":"Roheneemesaared"},"zho":{"official":"佛得角共和国","common":"佛得角"}},"latlng":[16,-24],"demonym":"Cape Verdian","landlocked":false,"borders":[],"area":4033,"flag":"🇨🇻"},{"name":{"common":"Costa Rica","official":"Republic of Costa Rica","native":{"spa":{"official":"República de Costa Rica","common":"Costa Rica"}}},"tld":[".cr"],"cca2":"CR","ccn3":"188","cca3":"CRI","cioc":"CRC","independent":true,"status":"officially-assigned","currency":["CRC"],"callingCode":["506"],"capital":["San José"],"altSpellings":["CR","Republic of Costa Rica","República de Costa Rica"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"cym":{"official":"Gweriniaeth Costa Rica","common":"Costa Rica"},"deu":{"official":"Republik Costa Rica","common":"Costa Rica"},"fra":{"official":"République du Costa Rica","common":"Costa Rica"},"hrv":{"official":"Republika Kostarika","common":"Kostarika"},"ita":{"official":"Repubblica di Costa Rica","common":"Costa Rica"},"jpn":{"official":"コスタリカ共和国","common":"コスタリカ"},"nld":{"official":"Republiek Costa Rica","common":"Costa Rica"},"por":{"official":"República da Costa Rica","common":"Costa Rica"},"rus":{"official":"Республика Коста-Рика","common":"Коста-Рика"},"slk":{"official":"Kostarická republika","common":"Kostarika"},"spa":{"official":"República de Costa Rica","common":"Costa Rica"},"fin":{"official":"Costa Rican tasavalta","common":"Costa Rica"},"est":{"official":"Costa Rica Vabariik","common":"Costa Rica"},"zho":{"official":"哥斯达黎加共和国","common":"哥斯达黎加"}},"latlng":[10,-84],"demonym":"Costa Rican","landlocked":false,"borders":["NIC","PAN"],"area":51100,"flag":"🇨🇷"},{"name":{"common":"Cuba","official":"Republic of Cuba","native":{"spa":{"official":"República de Cuba","common":"Cuba"}}},"tld":[".cu"],"cca2":"CU","ccn3":"192","cca3":"CUB","cioc":"CUB","independent":true,"status":"officially-assigned","currency":["CUC","CUP"],"callingCode":["53"],"capital":["Havana"],"altSpellings":["CU","Republic of Cuba","República de Cuba"],"region":"Americas","subregion":"Caribbean","languages":{"spa":"Spanish"},"translations":{"cym":{"official":"Gweriniaeth Ciwba","common":"Ciwba"},"deu":{"official":"Republik Kuba","common":"Kuba"},"fra":{"official":"République de Cuba","common":"Cuba"},"hrv":{"official":"Republika Kuba","common":"Kuba"},"ita":{"official":"Repubblica di Cuba","common":"Cuba"},"jpn":{"official":"キューバ共和国","common":"キューバ"},"nld":{"official":"Republiek Cuba","common":"Cuba"},"por":{"official":"República de Cuba","common":"Cuba"},"rus":{"official":"Республика Куба","common":"Куба"},"slk":{"official":"Kubánska republika","common":"Kuba"},"spa":{"official":"República de Cuba","common":"Cuba"},"fin":{"official":"Kuuban tasavalta","common":"Kuuba"},"est":{"official":"Kuuba Vabariik","common":"Kuuba"},"zho":{"official":"古巴共和国","common":"古巴"}},"latlng":[21.5,-80],"demonym":"Cuban","landlocked":false,"borders":[],"area":109884,"flag":"🇨🇺"},{"name":{"common":"Curaçao","official":"Country of Curaçao","native":{"eng":{"official":"Country of Curaçao","common":"Curaçao"},"nld":{"official":"Land Curaçao","common":"Curaçao"},"pap":{"official":"Pais Kòrsou","common":"Pais Kòrsou"}}},"tld":[".cw"],"cca2":"CW","ccn3":"531","cca3":"CUW","cioc":"","independent":false,"status":"officially-assigned","currency":["ANG"],"callingCode":["5999"],"capital":["Willemstad"],"altSpellings":["CW","Curacao","Kòrsou","Country of Curaçao","Land Curaçao","Pais Kòrsou"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","nld":"Dutch","pap":"Papiamento"},"translations":{"deu":{"official":"Land Curaçao","common":"Curaçao"},"fra":{"official":"Curaçao","common":"Curaçao"},"nld":{"official":"Land Curaçao","common":"Curaçao"},"por":{"official":"País de Curaçao","common":"ilha da Curação"},"rus":{"official":"Страна Кюрасао","common":"Кюрасао"},"slk":{"official":"Curacao","common":"Curacao"},"spa":{"official":"País de Curazao","common":"Curazao"},"fin":{"official":"Curaçao","common":"Curaçao"},"est":{"official":"Curaçao","common":"Curaçao"},"zho":{"official":"库拉索","common":"库拉索"}},"latlng":[12.116667,-68.933333],"demonym":"Dutch","landlocked":false,"borders":[],"area":444,"flag":"🇨🇼"},{"name":{"common":"Christmas Island","official":"Territory of Christmas Island","native":{"eng":{"official":"Territory of Christmas Island","common":"Christmas Island"}}},"tld":[".cx"],"cca2":"CX","ccn3":"162","cca3":"CXR","cioc":"","independent":false,"status":"officially-assigned","currency":["AUD"],"callingCode":["61"],"capital":["Flying Fish Cove"],"altSpellings":["CX","Territory of Christmas Island"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English"},"translations":{"cym":{"official":"Tiriogaeth yr Ynys y Nadolig","common":"Ynys y Nadolig"},"deu":{"official":"Gebiet der Weihnachtsinsel","common":"Weihnachtsinsel"},"fra":{"official":"Territoire de l'île Christmas","common":"Île Christmas"},"hrv":{"official":"Teritorij Božićni otok","common":"Božićni otok"},"ita":{"official":"Territorio di Christmas Island","common":"Isola di Natale"},"jpn":{"official":"クリスマス島の領土","common":"クリスマス島"},"nld":{"official":"Grondgebied van Christmas Island","common":"Christmaseiland"},"por":{"official":"Território da Ilha Christmas","common":"Ilha do Natal"},"rus":{"official":"Территория острова Рождества","common":"Остров Рождества"},"slk":{"official":"Teritórium Vianočného ostrova","common":"Vianočnú ostrov"},"spa":{"official":"Territorio de la Isla de Navidad","common":"Isla de Navidad"},"fin":{"official":"Joulusaaren alue","common":"Joulusaari"},"est":{"official":"Jõulusaare ala","common":"Jõulusaar"},"zho":{"official":"圣诞岛","common":"圣诞岛"}},"latlng":[-10.5,105.66666666],"demonym":"Christmas Islander","landlocked":false,"borders":[],"area":135,"flag":"🇨🇽"},{"name":{"common":"Cayman Islands","official":"Cayman Islands","native":{"eng":{"official":"Cayman Islands","common":"Cayman Islands"}}},"tld":[".ky"],"cca2":"KY","ccn3":"136","cca3":"CYM","cioc":"CAY","independent":false,"status":"officially-assigned","currency":["KYD"],"callingCode":["1345"],"capital":["George Town"],"altSpellings":["KY"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"cym":{"official":"Ynysoedd Cayman","common":"Ynysoedd Cayman"},"deu":{"official":"Cayman-Inseln","common":"Kaimaninseln"},"fra":{"official":"Îles Caïmans","common":"Îles Caïmans"},"hrv":{"official":"Kajmanski otoci","common":"Kajmanski otoci"},"ita":{"official":"Isole Cayman","common":"Isole Cayman"},"jpn":{"official":"ケイマン諸島","common":"ケイマン諸島"},"nld":{"official":"Caymaneilanden","common":"Caymaneilanden"},"por":{"official":"Ilhas Cayman","common":"Ilhas Caimão"},"rus":{"official":"Каймановы острова","common":"Каймановы острова"},"slk":{"official":"Kajmanie ostrovy","common":"Kajmanie ostrovy"},"spa":{"official":"Islas Caimán","common":"Islas Caimán"},"fin":{"official":"Caymansaaret","common":"Caymansaaret"},"est":{"official":"Kaimanisaared","common":"Kaimanisaared"},"zho":{"official":"开曼群岛","common":"开曼群岛"}},"latlng":[19.5,-80.5],"demonym":"Caymanian","landlocked":false,"borders":[],"area":264,"flag":"🇰🇾"},{"name":{"common":"Cyprus","official":"Republic of Cyprus","native":{"ell":{"official":"Δημοκρατία της Κύπρος","common":"Κύπρος"},"tur":{"official":"Kıbrıs Cumhuriyeti","common":"Kıbrıs"}}},"tld":[".cy"],"cca2":"CY","ccn3":"196","cca3":"CYP","cioc":"CYP","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["357"],"capital":["Nicosia"],"altSpellings":["CY","Kýpros","Kıbrıs","Republic of Cyprus","Κυπριακή Δημοκρατία","Kıbrıs Cumhuriyeti"],"region":"Europe","subregion":"Eastern Europe","languages":{"ell":"Greek","tur":"Turkish"},"translations":{"cym":{"official":"Gweriniaeth Cyprus","common":"Cyprus"},"deu":{"official":"Republik Zypern","common":"Zypern"},"fra":{"official":"République de Chypre","common":"Chypre"},"hrv":{"official":"Republika Cipar","common":"Cipar"},"ita":{"official":"Repubblica di Cipro","common":"Cipro"},"jpn":{"official":"キプロス共和国","common":"キプロス"},"nld":{"official":"Republiek Cyprus","common":"Cyprus"},"por":{"official":"República de Chipre","common":"Chipre"},"rus":{"official":"Республика Кипр","common":"Кипр"},"slk":{"official":"Cyperská republika","common":"Cyprus"},"spa":{"official":"República de Chipre","common":"Chipre"},"fin":{"official":"Kyproksen tasavalta","common":"Kypros"},"est":{"official":"Küprose Vabariik","common":"Küpros"},"zho":{"official":"塞浦路斯共和国","common":"塞浦路斯"}},"latlng":[35,33],"demonym":"Cypriot","landlocked":false,"borders":[],"area":9251,"flag":"🇨🇾"},{"name":{"common":"Czechia","official":"Czech Republic","native":{"ces":{"official":"česká republika","common":"Česko"},"slk":{"official":"Česká republika","common":"Česko"}}},"tld":[".cz"],"cca2":"CZ","ccn3":"203","cca3":"CZE","cioc":"CZE","independent":true,"status":"officially-assigned","currency":["CZK"],"callingCode":["420"],"capital":["Prague"],"altSpellings":["CZ","Česká republika","Česko"],"region":"Europe","subregion":"Eastern Europe","languages":{"ces":"Czech","slk":"Slovak"},"translations":{"cym":{"official":"Y Weriniaeth Tsiec","common":"Y Weriniaeth Tsiec"},"deu":{"official":"Tschechische Republik","common":"Tschechien"},"fra":{"official":"République tchèque","common":"Tchéquie"},"hrv":{"official":"Češka","common":"Češka"},"ita":{"official":"Repubblica Ceca","common":"Cechia"},"jpn":{"official":"チェコ共和国","common":"チェコ"},"nld":{"official":"Tsjechische Republiek","common":"Tsjechië"},"por":{"official":"República Checa","common":"Chéquia"},"rus":{"official":"Чешская Республика","common":"Чехия"},"slk":{"official":"Česká republika","common":"Česko"},"spa":{"official":"República Checa","common":"Chequia"},"fin":{"official":"Tšekin tasavalta","common":"Tšekki"},"est":{"official":"Tšehhi Vabariik","common":"Tšehhi"},"zho":{"official":"捷克共和国","common":"捷克"}},"latlng":[49.75,15.5],"demonym":"Czech","landlocked":true,"borders":["AUT","DEU","POL","SVK"],"area":78865,"flag":"🇨🇿"},{"name":{"common":"Germany","official":"Federal Republic of Germany","native":{"deu":{"official":"Bundesrepublik Deutschland","common":"Deutschland"}}},"tld":[".de"],"cca2":"DE","ccn3":"276","cca3":"DEU","cioc":"GER","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["49"],"capital":["Berlin"],"altSpellings":["DE","Federal Republic of Germany","Bundesrepublik Deutschland"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German"},"translations":{"deu":{"official":"Bundesrepublik Deutschland","common":"Deutschland"},"fra":{"official":"République fédérale d'Allemagne","common":"Allemagne"},"hrv":{"official":"Njemačka Federativna Republika","common":"Njemačka"},"ita":{"official":"Repubblica federale di Germania","common":"Germania"},"jpn":{"official":"ドイツ連邦共和国","common":"ドイツ"},"nld":{"official":"Bondsrepubliek Duitsland","common":"Duitsland"},"por":{"official":"República Federal da Alemanha","common":"Alemanha"},"rus":{"official":"Федеративная Республика Германия","common":"Германия"},"slk":{"official":"Nemecká spolková republika","common":"Nemecko"},"spa":{"official":"República Federal de Alemania","common":"Alemania"},"fin":{"official":"Saksan liittotasavalta","common":"Saksa"},"est":{"official":"Saksamaa Liitvabariik","common":"Saksamaa"},"zho":{"official":"德意志联邦共和国","common":"德国"}},"latlng":[51,9],"demonym":"German","landlocked":false,"borders":["AUT","BEL","CZE","DNK","FRA","LUX","NLD","POL","CHE"],"area":357114,"flag":"🇩🇪"},{"name":{"common":"Djibouti","official":"Republic of Djibouti","native":{"ara":{"official":"جمهورية جيبوتي","common":"جيبوتي‎"},"fra":{"official":"République de Djibouti","common":"Djibouti"}}},"tld":[".dj"],"cca2":"DJ","ccn3":"262","cca3":"DJI","cioc":"DJI","independent":true,"status":"officially-assigned","currency":["DJF"],"callingCode":["253"],"capital":["Djibouti"],"altSpellings":["DJ","Jabuuti","Gabuuti","Republic of Djibouti","République de Djibouti","Gabuutih Ummuuno","Jamhuuriyadda Jabuuti"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","fra":"French"},"translations":{"cym":{"official":"Gweriniaeth Jibwti","common":"Jibwti"},"deu":{"official":"Republik Dschibuti","common":"Dschibuti"},"fra":{"official":"République de Djibouti","common":"Djibouti"},"hrv":{"official":"Republika Džibuti","common":"Džibuti"},"ita":{"official":"Repubblica di Gibuti","common":"Gibuti"},"jpn":{"official":"ジブチ共和国","common":"ジブチ"},"nld":{"official":"Republiek Djibouti","common":"Djibouti"},"por":{"official":"República do Djibouti","common":"Djibouti"},"rus":{"official":"Республика Джибути","common":"Джибути"},"slk":{"official":"ǅibutská republika","common":"ǅibutsko"},"spa":{"official":"República de Djibouti","common":"Djibouti"},"fin":{"official":"Dijiboutin tasavalta","common":"Dijibouti"},"est":{"official":"Djibouti Vabariik","common":"Djibouti"},"zho":{"official":"吉布提共和国","common":"吉布提"}},"latlng":[11.5,43],"demonym":"Djibouti","landlocked":false,"borders":["ERI","ETH","SOM"],"area":23200,"flag":"🇩🇯"},{"name":{"common":"Dominica","official":"Commonwealth of Dominica","native":{"eng":{"official":"Commonwealth of Dominica","common":"Dominica"}}},"tld":[".dm"],"cca2":"DM","ccn3":"212","cca3":"DMA","cioc":"DMA","independent":true,"status":"officially-assigned","currency":["XCD"],"callingCode":["1767"],"capital":["Roseau"],"altSpellings":["DM","Dominique","Wai‘tu kubuli","Commonwealth of Dominica"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"cym":{"official":"Cymanwlad Dominica","common":"Dominica"},"deu":{"official":"Commonwealth von Dominica","common":"Dominica"},"fra":{"official":"Commonwealth de la Dominique","common":"Dominique"},"hrv":{"official":"Zajednica Dominika","common":"Dominika"},"ita":{"official":"Commonwealth di Dominica","common":"Dominica"},"jpn":{"official":"ドミニカ国","common":"ドミニカ国"},"nld":{"official":"Gemenebest Dominica","common":"Dominica"},"por":{"official":"Comunidade da Dominica","common":"Dominica"},"rus":{"official":"Содружество Доминики","common":"Доминика"},"slk":{"official":"Dominické spoločenstvo","common":"Dominika"},"spa":{"official":"Mancomunidad de Dominica","common":"Dominica"},"fin":{"official":"Dominican liittovaltio","common":"Dominica"},"est":{"official":"Dominica Ühendus","common":"Dominica"},"zho":{"official":"多米尼加共和国","common":"多米尼加"}},"latlng":[15.41666666,-61.33333333],"demonym":"Dominican","landlocked":false,"borders":[],"area":751,"flag":"🇩🇲"},{"name":{"common":"Denmark","official":"Kingdom of Denmark","native":{"dan":{"official":"Kongeriget Danmark","common":"Danmark"}}},"tld":[".dk"],"cca2":"DK","ccn3":"208","cca3":"DNK","cioc":"DEN","independent":true,"status":"officially-assigned","currency":["DKK"],"callingCode":["45"],"capital":["Copenhagen"],"altSpellings":["DK","Danmark","Kingdom of Denmark","Kongeriget Danmark"],"region":"Europe","subregion":"Northern Europe","languages":{"dan":"Danish"},"translations":{"cym":{"official":"Teyrnas Denmarc","common":"Denmarc"},"deu":{"official":"Königreich Dänemark","common":"Dänemark"},"fra":{"official":"Royaume du Danemark","common":"Danemark"},"hrv":{"official":"Kraljevina Danska","common":"Danska"},"ita":{"official":"Regno di Danimarca","common":"Danimarca"},"jpn":{"official":"デンマーク王国","common":"デンマーク"},"nld":{"official":"Koninkrijk Denemarken","common":"Denemarken"},"por":{"official":"Reino da Dinamarca","common":"Dinamarca"},"rus":{"official":"Королевство Дания","common":"Дания"},"slk":{"official":"Dánske kráľovstvo","common":"Dánsko"},"spa":{"official":"Reino de Dinamarca","common":"Dinamarca"},"fin":{"official":"Tanskan kuningaskunta","common":"Tanska"},"est":{"official":"Taani Kuningriik","common":"Taani"},"zho":{"official":"丹麦王国","common":"丹麦"}},"latlng":[56,10],"demonym":"Danish","landlocked":false,"borders":["DEU"],"area":43094,"flag":"🇩🇰"},{"name":{"common":"Dominican Republic","official":"Dominican Republic","native":{"spa":{"official":"República Dominicana","common":"República Dominicana"}}},"tld":[".do"],"cca2":"DO","ccn3":"214","cca3":"DOM","cioc":"DOM","independent":true,"status":"officially-assigned","currency":["DOP"],"callingCode":["1809","1829","1849"],"capital":["Santo Domingo"],"altSpellings":["DO"],"region":"Americas","subregion":"Caribbean","languages":{"spa":"Spanish"},"translations":{"cym":{"official":"Gweriniaeth Dominica","common":"Gweriniaeth Dominica"},"deu":{"official":"Dominikanische Republik","common":"Dominikanische Republik"},"fra":{"official":"République Dominicaine","common":"République dominicaine"},"hrv":{"official":"Dominikanska Republika","common":"Dominikanska Republika"},"ita":{"official":"Repubblica Dominicana","common":"Repubblica Dominicana"},"jpn":{"official":"ドミニカ共和国","common":"ドミニカ共和国"},"nld":{"official":"Dominicaanse Republiek","common":"Dominicaanse Republiek"},"por":{"official":"República Dominicana","common":"República Dominicana"},"rus":{"official":"Доминиканская Республика","common":"Доминиканская Республика"},"slk":{"official":"Dominikánska republika","common":"Dominikánska republika"},"spa":{"official":"República Dominicana","common":"República Dominicana"},"fin":{"official":"Dominikaaninen tasavalta","common":"Dominikaaninen tasavalta"},"est":{"official":"Dominikaani Vabariik","common":"Dominikaani Vabariik"},"zho":{"official":"多明尼加共和国","common":"多明尼加"}},"latlng":[19,-70.66666666],"demonym":"Dominican","landlocked":false,"borders":["HTI"],"area":48671,"flag":"🇩🇴"},{"name":{"common":"Algeria","official":"People's Democratic Republic of Algeria","native":{"ara":{"official":"الجمهورية الديمقراطية الشعبية الجزائرية","common":"الجزائر"}}},"tld":[".dz","الجزائر."],"cca2":"DZ","ccn3":"012","cca3":"DZA","cioc":"ALG","independent":true,"status":"officially-assigned","currency":["DZD"],"callingCode":["213"],"capital":["Algiers"],"altSpellings":["DZ","Dzayer","Algérie"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"cym":{"official":"Gweriniaeth Ddemocrataidd Pobl Algeria","common":"Algeria"},"deu":{"official":"Demokratische Volksrepublik Algerien","common":"Algerien"},"fra":{"official":"République démocratique et populaire d'Algérie","common":"Algérie"},"hrv":{"official":"Narodna Demokratska Republika Alžir","common":"Alžir"},"ita":{"official":"Repubblica popolare democratica di Algeria","common":"Algeria"},"jpn":{"official":"アルジェリア人民民主共和国","common":"アルジェリア"},"nld":{"official":"Democratische Volksrepubliek Algerije","common":"Algerije"},"por":{"official":"República Argelina Democrática e Popular","common":"Argélia"},"rus":{"official":"Народно-Демократическая Республика Алжир","common":"Алжир"},"slk":{"official":"Alžírska demokratická ľudová republika","common":"Alžírsko"},"spa":{"official":"República Argelina Democrática y Popular","common":"Argelia"},"fin":{"official":"Algerian demokraattinen kansantasavalta","common":"Algeria"},"est":{"official":"Alžeeria Demokraatlik Rahvavabariik","common":"Alžeeria"},"zho":{"official":"阿尔及利亚人民民主共和国","common":"阿尔及利亚"}},"latlng":[28,3],"demonym":"Algerian","landlocked":false,"borders":["TUN","LBY","NER","ESH","MRT","MLI","MAR"],"area":2381741,"flag":"🇩🇿"},{"name":{"common":"Ecuador","official":"Republic of Ecuador","native":{"spa":{"official":"República del Ecuador","common":"Ecuador"}}},"tld":[".ec"],"cca2":"EC","ccn3":"218","cca3":"ECU","cioc":"ECU","independent":true,"status":"officially-assigned","currency":["USD"],"callingCode":["593"],"capital":["Quito"],"altSpellings":["EC","Republic of Ecuador","República del Ecuador"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"cym":{"official":"Gweriniaeth Ecwador","common":"Ecwador"},"deu":{"official":"Republik Ecuador","common":"Ecuador"},"fra":{"official":"République de l'Équateur","common":"Équateur"},"hrv":{"official":"Republika Ekvador","common":"Ekvador"},"ita":{"official":"Repubblica dell'Ecuador","common":"Ecuador"},"jpn":{"official":"エクアドル共和国","common":"エクアドル"},"nld":{"official":"Republiek Ecuador","common":"Ecuador"},"por":{"official":"República do Equador","common":"Equador"},"rus":{"official":"Республика Эквадор","common":"Эквадор"},"slk":{"official":"Ekvádorská republika","common":"Ekvádor"},"spa":{"official":"República del Ecuador","common":"Ecuador"},"fin":{"official":"Ecuadorin tasavalta","common":"Ecuador"},"est":{"official":"Ecuadori Vabariik","common":"Ecuador"},"zho":{"official":"厄瓜多尔共和国","common":"厄瓜多尔"}},"latlng":[-2,-77.5],"demonym":"Ecuadorean","landlocked":false,"borders":["COL","PER"],"area":276841,"flag":"🇪🇨"},{"name":{"common":"Egypt","official":"Arab Republic of Egypt","native":{"ara":{"official":"جمهورية مصر العربية","common":"مصر"}}},"tld":[".eg",".مصر"],"cca2":"EG","ccn3":"818","cca3":"EGY","cioc":"EGY","independent":true,"status":"officially-assigned","currency":["EGP"],"callingCode":["20"],"capital":["Cairo"],"altSpellings":["EG","Arab Republic of Egypt"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"cym":{"official":"Gweriniaeth Arabaidd yr Aifft","common":"Yr Aifft"},"deu":{"official":"Arabische Republik Ägypten","common":"Ägypten"},"fra":{"official":"République arabe d'Égypte","common":"Égypte"},"hrv":{"official":"Arapska Republika Egipat","common":"Egipat"},"ita":{"official":"Repubblica araba d'Egitto","common":"Egitto"},"jpn":{"official":"エジプト·アラブ共和国","common":"エジプト"},"nld":{"official":"Arabische Republiek Egypte","common":"Egypte"},"por":{"official":"República Árabe do Egipto","common":"Egito"},"rus":{"official":"Арабская Республика Египет","common":"Египет"},"slk":{"official":"Egyptská arabská republika","common":"Egypt"},"spa":{"official":"República Árabe de Egipto","common":"Egipto"},"fin":{"official":"Egyptin arabitasavalta","common":"Egypti"},"est":{"official":"Egiptuse Araabia Vabariik","common":"Egiptus"},"zho":{"official":"阿拉伯埃及共和国","common":"埃及"}},"latlng":[27,30],"demonym":"Egyptian","landlocked":false,"borders":["ISR","LBY","PSE","SDN"],"area":1002450,"flag":"🇪🇬"},{"name":{"common":"Eritrea","official":"State of Eritrea","native":{"ara":{"official":"دولة إرتريا","common":"إرتريا‎"},"eng":{"official":"State of Eritrea","common":"Eritrea"},"tir":{"official":"ሃገረ ኤርትራ","common":"ኤርትራ"}}},"tld":[".er"],"cca2":"ER","ccn3":"232","cca3":"ERI","cioc":"ERI","independent":true,"status":"officially-assigned","currency":["ERN"],"callingCode":["291"],"capital":["Asmara"],"altSpellings":["ER","State of Eritrea","ሃገረ ኤርትራ","Dawlat Iritriyá","ʾErtrā","Iritriyā"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","eng":"English","tir":"Tigrinya"},"translations":{"cym":{"official":"Gwladwriaeth Eritrea","common":"Eritrea"},"deu":{"official":"Staat Eritrea","common":"Eritrea"},"fra":{"official":"État d'Érythrée","common":"Érythrée"},"hrv":{"official":"Država Eritreji","common":"Eritreja"},"ita":{"official":"Stato di Eritrea","common":"Eritrea"},"jpn":{"official":"エリトリア国","common":"エリトリア"},"nld":{"official":"Staat Eritrea","common":"Eritrea"},"por":{"official":"Estado da Eritreia","common":"Eritreia"},"rus":{"official":"Государство Эритрея","common":"Эритрея"},"slk":{"official":"Eritrejský štát","common":"Eritrea"},"spa":{"official":"Estado de Eritrea","common":"Eritrea"},"fin":{"official":"Eritrean valtio","common":"Eritrea"},"est":{"official":"Eritrea Riik","common":"Eritrea"},"zho":{"official":"厄立特里亚","common":"厄立特里亚"}},"latlng":[15,39],"demonym":"Eritrean","landlocked":false,"borders":["DJI","ETH","SDN"],"area":117600,"flag":"🇪🇷"},{"name":{"common":"Western Sahara","official":"Sahrawi Arab Democratic Republic","native":{"ber":{"official":"Sahrawi Arab Democratic Republic","common":"Western Sahara"},"mey":{"official":"الجمهورية العربية الصحراوية الديمقراطية","common":"الصحراء الغربية"},"spa":{"official":"República Árabe Saharaui Democrática","common":"Sahara Occidental"}}},"tld":[".eh"],"cca2":"EH","ccn3":"732","cca3":"ESH","cioc":"","independent":false,"status":"officially-assigned","currency":["MAD","DZD","MRO"],"callingCode":["212"],"capital":["El Aaiún"],"altSpellings":["EH","Taneẓroft Tutrimt"],"region":"Africa","subregion":"Northern Africa","languages":{"ber":"Berber","mey":"Hassaniya","spa":"Spanish"},"translations":{"deu":{"official":"Demokratische Arabische Republik Sahara","common":"Westsahara"},"fra":{"official":"République arabe sahraouie démocratique","common":"Sahara Occidental"},"hrv":{"official":"Sahrawi Arab Demokratska Republika","common":"Zapadna Sahara"},"ita":{"official":"Repubblica Araba Saharawi Democratica","common":"Sahara Occidentale"},"jpn":{"official":"サハラアラブ民主共和国","common":"西サハラ"},"nld":{"official":"Sahrawi Arabische Democratische Republiek","common":"Westelijke Sahara"},"por":{"official":"República Árabe Saharaui Democrática","common":"Saara Ocidental"},"rus":{"official":"Sahrawi Арабская Демократическая Республика","common":"Западная Сахара"},"slk":{"official":"Západná Sahara","common":"Západná Sahara"},"spa":{"official":"República Árabe Saharaui Democrática","common":"Sahara Occidental"},"fin":{"official":"Länsi-Sahara","common":"Länsi-Sahara"},"est":{"official":"Lääne-Sahara","common":"Lääne-Sahara"},"zho":{"official":"阿拉伯撒哈拉民主共和国","common":"西撒哈拉"}},"latlng":[24.5,-13],"demonym":"Sahrawi","landlocked":false,"borders":["DZA","MRT","MAR"],"area":266000,"flag":"🇪🇭"},{"name":{"common":"Spain","official":"Kingdom of Spain","native":{"spa":{"official":"Reino de España","common":"España"}}},"tld":[".es"],"cca2":"ES","ccn3":"724","cca3":"ESP","cioc":"ESP","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["34"],"capital":["Madrid"],"altSpellings":["ES","Kingdom of Spain","Reino de España"],"region":"Europe","subregion":"Southern Europe","languages":{"spa":"Spanish"},"translations":{"deu":{"official":"Königreich Spanien","common":"Spanien"},"fra":{"official":"Royaume d'Espagne","common":"Espagne"},"hrv":{"official":"Kraljevina Španjolska","common":"Španjolska"},"ita":{"official":"Regno di Spagna","common":"Spagna"},"jpn":{"official":"スペイン王国","common":"スペイン"},"nld":{"official":"Koninkrijk Spanje","common":"Spanje"},"por":{"official":"Reino de Espanha","common":"Espanha"},"rus":{"official":"Королевство Испания","common":"Испания"},"slk":{"official":"Španielske kráľovstvo","common":"Španielsko"},"spa":{"official":"Reino de España","common":"España"},"fin":{"official":"Espanjan kuningaskunta","common":"Espanja"},"est":{"official":"Hispaania Kuningriik","common":"Hispaania"},"zho":{"official":"西班牙王国","common":"西班牙"}},"latlng":[40,-4],"demonym":"Spanish","landlocked":false,"borders":["AND","FRA","GIB","PRT","MAR"],"area":505992,"flag":"🇪🇸"},{"name":{"common":"Estonia","official":"Republic of Estonia","native":{"est":{"official":"Eesti Vabariik","common":"Eesti"}}},"tld":[".ee"],"cca2":"EE","ccn3":"233","cca3":"EST","cioc":"EST","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["372"],"capital":["Tallinn"],"altSpellings":["EE","Eesti","Republic of Estonia","Eesti Vabariik"],"region":"Europe","subregion":"Northern Europe","languages":{"est":"Estonian"},"translations":{"cym":{"official":"Gweriniaeth Estonia","common":"Estonia"},"deu":{"official":"Republik Estland","common":"Estland"},"fra":{"official":"République d'Estonie","common":"Estonie"},"hrv":{"official":"Republika Estonija","common":"Estonija"},"ita":{"official":"Repubblica di Estonia","common":"Estonia"},"jpn":{"official":"エストニア共和国","common":"エストニア"},"nld":{"official":"Republiek Estland","common":"Estland"},"por":{"official":"República da Estónia","common":"Estónia"},"rus":{"official":"Эстонская Республика","common":"Эстония"},"slk":{"official":"Estónska republika","common":"Estónsko"},"spa":{"official":"República de Estonia","common":"Estonia"},"fin":{"official":"Viron tasavalta","common":"Viro"},"est":{"official":"Eesti Vabariik","common":"Eesti"},"zho":{"official":"爱沙尼亚共和国","common":"爱沙尼亚"}},"latlng":[59,26],"demonym":"Estonian","landlocked":false,"borders":["LVA","RUS"],"area":45227,"flag":"🇪🇪"},{"name":{"common":"Ethiopia","official":"Federal Democratic Republic of Ethiopia","native":{"amh":{"official":"የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ","common":"ኢትዮጵያ"}}},"tld":[".et"],"cca2":"ET","ccn3":"231","cca3":"ETH","cioc":"ETH","independent":true,"status":"officially-assigned","currency":["ETB"],"callingCode":["251"],"capital":["Addis Ababa"],"altSpellings":["ET","ʾĪtyōṗṗyā","Federal Democratic Republic of Ethiopia","የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ"],"region":"Africa","subregion":"Eastern Africa","languages":{"amh":"Amharic"},"translations":{"cym":{"official":"Gweriniaeth Ddemocrataidd Ffederal Ethiopia","common":"Ethiopia"},"deu":{"official":"Demokratische Bundesrepublik Äthiopien","common":"Äthiopien"},"fra":{"official":"République fédérale démocratique d'Éthiopie","common":"Éthiopie"},"hrv":{"official":"Savezna Demokratska Republika Etiopija","common":"Etiopija"},"ita":{"official":"Repubblica federale democratica di Etiopia","common":"Etiopia"},"jpn":{"official":"エチオピア連邦民主共和国","common":"エチオピア"},"nld":{"official":"Federale Democratische Republiek Ethiopië","common":"Ethiopië"},"por":{"official":"República Federal Democrática da Etiópia","common":"Etiópia"},"rus":{"official":"Федеративная Демократическая Республика Эфиопия","common":"Эфиопия"},"slk":{"official":"Etiópska federatívna demokratická republika","common":"Etiópia"},"spa":{"official":"República Democrática Federal de Etiopía","common":"Etiopía"},"fin":{"official":"Etiopian demokraattinen liittotasavalta","common":"Etiopia"},"est":{"official":"Etioopia Demokraatlik Liitvabariik","common":"Etioopia"},"zho":{"official":"埃塞俄比亚联邦民主共和国","common":"埃塞俄比亚"}},"latlng":[8,38],"demonym":"Ethiopian","landlocked":true,"borders":["DJI","ERI","KEN","SOM","SSD","SDN"],"area":1104300,"flag":"🇪🇹"},{"name":{"common":"Finland","official":"Republic of Finland","native":{"fin":{"official":"Suomen tasavalta","common":"Suomi"},"swe":{"official":"Republiken Finland","common":"Finland"}}},"tld":[".fi"],"cca2":"FI","ccn3":"246","cca3":"FIN","cioc":"FIN","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["358"],"capital":["Helsinki"],"altSpellings":["FI","Suomi","Republic of Finland","Suomen tasavalta","Republiken Finland"],"region":"Europe","subregion":"Northern Europe","languages":{"fin":"Finnish","swe":"Swedish"},"translations":{"deu":{"official":"Republik Finnland","common":"Finnland"},"fra":{"official":"République de Finlande","common":"Finlande"},"hrv":{"official":"Republika Finska","common":"Finska"},"ita":{"official":"Repubblica di Finlandia","common":"Finlandia"},"jpn":{"official":"フィンランド共和国","common":"フィンランド"},"nld":{"official":"Republiek Finland","common":"Finland"},"por":{"official":"República da Finlândia","common":"Finlândia"},"rus":{"official":"Финляндская Республика","common":"Финляндия"},"slk":{"official":"Fínska republika","common":"Fínsko"},"spa":{"official":"República de Finlandia","common":"Finlandia"},"fin":{"official":"Suomen tasavalta","common":"Suomi"},"est":{"official":"Soome Vabariik","common":"Soome"},"zho":{"official":"芬兰共和国","common":"芬兰"}},"latlng":[64,26],"demonym":"Finnish","landlocked":false,"borders":["NOR","SWE","RUS"],"area":338424,"flag":"🇫🇮"},{"name":{"common":"Fiji","official":"Republic of Fiji","native":{"eng":{"official":"Republic of Fiji","common":"Fiji"},"fij":{"official":"Matanitu Tugalala o Viti","common":"Viti"},"hif":{"official":"रिपब्लिक ऑफ फीजी","common":"फिजी"}}},"tld":[".fj"],"cca2":"FJ","ccn3":"242","cca3":"FJI","cioc":"FIJ","independent":true,"status":"officially-assigned","currency":["FJD"],"callingCode":["679"],"capital":["Suva"],"altSpellings":["FJ","Viti","Republic of Fiji","Matanitu ko Viti","Fijī Gaṇarājya"],"region":"Oceania","subregion":"Melanesia","languages":{"eng":"English","fij":"Fijian","hif":"Fiji Hindi"},"translations":{"deu":{"official":"Republik Fidschi","common":"Fidschi"},"fra":{"official":"République des Fidji","common":"Fidji"},"hrv":{"official":"Republika Fidži","common":"Fiđi"},"ita":{"official":"Repubblica di Figi","common":"Figi"},"jpn":{"official":"フィジー共和国","common":"フィジー"},"nld":{"official":"Republiek Fiji","common":"Fiji"},"por":{"official":"República de Fiji","common":"Fiji"},"rus":{"official":"Республика Фиджи","common":"Фиджи"},"slk":{"official":"Fiǆijská republika","common":"Fiǆi"},"spa":{"official":"República de Fiji","common":"Fiyi"},"fin":{"official":"Fidžin tasavalta","common":"Fidži"},"est":{"official":"Fidži Vabariik","common":"Fidži"},"zho":{"official":"斐济共和国","common":"斐济"}},"latlng":[-18,175],"demonym":"Fijian","landlocked":false,"borders":[],"area":18272,"flag":"🇫🇯"},{"name":{"common":"Falkland Islands","official":"Falkland Islands","native":{"eng":{"official":"Falkland Islands","common":"Falkland Islands"}}},"tld":[".fk"],"cca2":"FK","ccn3":"238","cca3":"FLK","cioc":"","independent":false,"status":"officially-assigned","currency":["FKP"],"callingCode":["500"],"capital":["Stanley"],"altSpellings":["FK","Islas Malvinas","Falkland Islands (Malvinas)"],"region":"Americas","subregion":"South America","languages":{"eng":"English"},"translations":{"deu":{"official":"Falkland-Inseln","common":"Falklandinseln"},"fra":{"official":"Îles Malouines","common":"Îles Malouines"},"hrv":{"official":"Falklandski otoci","common":"Falklandski Otoci"},"ita":{"official":"Isole Falkland","common":"Isole Falkland o Isole Malvine"},"jpn":{"official":"フォークランド","common":"フォークランド（マルビナス）諸島"},"nld":{"official":"Falkland eilanden","common":"Falklandeilanden"},"por":{"official":"Ilhas Malvinas","common":"Ilhas Malvinas"},"rus":{"official":"Фолклендские острова","common":"Фолклендские острова"},"slk":{"official":"Falklandské ostrovy","common":"Falklandy"},"spa":{"official":"islas Malvinas","common":"Islas Malvinas"},"fin":{"official":"Falkandinsaaret","common":"Falkandinsaaret"},"est":{"official":"Falklandi saared","common":"Falklandi saared"},"zho":{"official":"福克兰群岛","common":"福克兰群岛"}},"latlng":[-51.75,-59],"demonym":"Falkland Islander","landlocked":false,"borders":[],"area":12173,"flag":"🇫🇰"},{"name":{"common":"France","official":"French Republic","native":{"fra":{"official":"République française","common":"France"}}},"tld":[".fr"],"cca2":"FR","ccn3":"250","cca3":"FRA","cioc":"FRA","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["33"],"capital":["Paris"],"altSpellings":["FR","French Republic","République française"],"region":"Europe","subregion":"Western Europe","languages":{"fra":"French"},"translations":{"deu":{"official":"Französische Republik","common":"Frankreich"},"fra":{"official":"République française","common":"France"},"hrv":{"official":"Francuska Republika","common":"Francuska"},"ita":{"official":"Repubblica francese","common":"Francia"},"jpn":{"official":"フランス共和国","common":"フランス"},"nld":{"official":"Franse Republiek","common":"Frankrijk"},"por":{"official":"República Francesa","common":"França"},"rus":{"official":"Французская Республика","common":"Франция"},"slk":{"official":"Francúzska republika","common":"Francúzsko"},"spa":{"official":"República francés","common":"Francia"},"fin":{"official":"Ranskan tasavalta","common":"Ranska"},"est":{"official":"Prantsuse Vabariik","common":"Prantsusmaa"},"zho":{"official":"法兰西共和国","common":"法国"}},"latlng":[46,2],"demonym":"French","landlocked":false,"borders":["AND","BEL","DEU","ITA","LUX","MCO","ESP","CHE"],"area":551695,"flag":"🇫🇷"},{"name":{"common":"Faroe Islands","official":"Faroe Islands","native":{"dan":{"official":"Færøerne","common":"Færøerne"},"fao":{"official":"Føroyar","common":"Føroyar"}}},"tld":[".fo"],"cca2":"FO","ccn3":"234","cca3":"FRO","cioc":"","independent":false,"status":"officially-assigned","currency":["DKK"],"callingCode":["298"],"capital":["Tórshavn"],"altSpellings":["FO","Føroyar","Færøerne"],"region":"Europe","subregion":"Northern Europe","languages":{"dan":"Danish","fao":"Faroese"},"translations":{"deu":{"official":"Färöer","common":"Färöer-Inseln"},"fra":{"official":"Îles Féroé","common":"Îles Féroé"},"hrv":{"official":"Farski Otoci","common":"Farski Otoci"},"ita":{"official":"Isole Faroe","common":"Isole Far Oer"},"jpn":{"official":"フェロー諸島","common":"フェロー諸島"},"nld":{"official":"Faeröer","common":"Faeröer"},"por":{"official":"Ilhas Faroe","common":"Ilhas Faroé"},"rus":{"official":"Фарерские острова","common":"Фарерские острова"},"slk":{"official":"Faerské ostrovy","common":"Faerské ostrovy"},"spa":{"official":"Islas Feroe","common":"Islas Faroe"},"fin":{"official":"Färsaaret","common":"Färsaaret"},"est":{"official":"Fääri saared","common":"Fääri saared"},"zho":{"official":"法罗群岛","common":"法罗群岛"}},"latlng":[62,-7],"demonym":"Faroese","landlocked":false,"borders":[],"area":1393,"flag":"🇫🇴"},{"name":{"common":"Micronesia","official":"Federated States of Micronesia","native":{"eng":{"official":"Federated States of Micronesia","common":"Micronesia"}}},"tld":[".fm"],"cca2":"FM","ccn3":"583","cca3":"FSM","cioc":"FSM","independent":true,"status":"officially-assigned","currency":["USD"],"callingCode":["691"],"capital":["Palikir"],"altSpellings":["FM","Federated States of Micronesia","Micronesia, Federated States of"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English"},"translations":{"deu":{"official":"Föderierte Staaten von Mikronesien","common":"Mikronesien"},"fra":{"official":"États fédérés de Micronésie","common":"Micronésie"},"hrv":{"official":"Savezne Države Mikronezije","common":"Mikronezija"},"ita":{"official":"Stati federati di Micronesia","common":"Micronesia"},"jpn":{"official":"ミクロネシア連邦","common":"ミクロネシア連邦"},"nld":{"official":"Federale Staten van Micronesia","common":"Micronesië"},"por":{"official":"Estados Federados da Micronésia","common":"Micronésia"},"rus":{"official":"Федеративные Штаты Микронезии","common":"Федеративные Штаты Микронезии"},"slk":{"official":"Mikron/u00e9zske federatívne štáty","common":"Mikronézia"},"spa":{"official":"Estados Federados de Micronesia","common":"Micronesia"},"fin":{"official":"Mikronesian liittovaltio","common":"Mikronesia"},"est":{"official":"Mikroneesia Liiduriigid","common":"Mikroneesia"},"zho":{"official":"密克罗尼西亚联邦","common":"密克罗尼西亚"}},"latlng":[6.91666666,158.25],"demonym":"Micronesian","landlocked":false,"borders":[],"area":702,"flag":"🇫🇲"},{"name":{"common":"Gabon","official":"Gabonese Republic","native":{"fra":{"official":"République gabonaise","common":"Gabon"}}},"tld":[".ga"],"cca2":"GA","ccn3":"266","cca3":"GAB","cioc":"GAB","independent":true,"status":"officially-assigned","currency":["XAF"],"callingCode":["241"],"capital":["Libreville"],"altSpellings":["GA","Gabonese Republic","République Gabonaise"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French"},"translations":{"deu":{"official":"Gabunische Republik","common":"Gabun"},"fra":{"official":"République gabonaise","common":"Gabon"},"hrv":{"official":"Gabon Republika","common":"Gabon"},"ita":{"official":"Repubblica gabonese","common":"Gabon"},"jpn":{"official":"ガボン共和国","common":"ガボン"},"nld":{"official":"Republiek Gabon","common":"Gabon"},"por":{"official":"República do Gabão","common":"Gabão"},"rus":{"official":"Габона Республика","common":"Габон"},"slk":{"official":"Gabonská republika","common":"Gabon"},"spa":{"official":"República de Gabón","common":"Gabón"},"fin":{"official":"Gabonin tasavalta","common":"Gabon"},"est":{"official":"Gaboni Vabariik","common":"Gabon"},"zho":{"official":"加蓬共和国","common":"加蓬"}},"latlng":[-1,11.75],"demonym":"Gabonese","landlocked":false,"borders":["CMR","COG","GNQ"],"area":267668,"flag":"🇬🇦"},{"name":{"common":"United Kingdom","official":"United Kingdom of Great Britain and Northern Ireland","native":{"eng":{"official":"United Kingdom of Great Britain and Northern Ireland","common":"United Kingdom"}}},"tld":[".uk"],"cca2":"GB","ccn3":"826","cca3":"GBR","cioc":"GBR","independent":true,"status":"officially-assigned","currency":["GBP"],"callingCode":["44"],"capital":["London"],"altSpellings":["GB","UK","Great Britain"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English"},"translations":{"deu":{"official":"Vereinigtes Königreich Großbritannien und Nordirland","common":"Vereinigtes Königreich"},"fra":{"official":"Royaume-Uni de Grande-Bretagne et d'Irlande du Nord","common":"Royaume-Uni"},"hrv":{"official":"Ujedinjeno Kraljevstvo Velike Britanije i Sjeverne Irske","common":"Ujedinjeno Kraljevstvo"},"ita":{"official":"Regno Unito di Gran Bretagna e Irlanda del Nord","common":"Regno Unito"},"jpn":{"official":"グレート·ブリテンおよび北アイルランド連合王国","common":"イギリス"},"nld":{"official":"Verenigd Koninkrijk van Groot-Brittannië en Noord-Ierland","common":"Verenigd Koninkrijk"},"por":{"official":"Reino Unido da Grã-Bretanha e Irlanda do Norte","common":"Reino Unido"},"rus":{"official":"Соединенное Королевство Великобритании и Северной Ирландии","common":"Великобритания"},"slk":{"official":"Spojené kráľovstvo Veľkej Británie a SevernéhoÌrska","common":"Veľká Británia (Spojené kráľovstvo)"},"spa":{"official":"Reino Unido de Gran Bretaña e Irlanda del Norte","common":"Reino Unido"},"fin":{"official":"Ison-Britannian ja Pohjois-Irlannin yhdistynyt kuningaskunta","common":"Yhdistynyt kuningaskunta"},"est":{"official":"Suurbritannia ja Põhja-Iiri Ühendkuningriik","common":"Suurbritannia"},"zho":{"official":"大不列颠及北爱尔兰联合王国","common":"英国"}},"latlng":[54,-2],"demonym":"British","landlocked":false,"borders":["IRL"],"area":242900,"flag":"🇬🇧"},{"name":{"common":"Georgia","official":"Georgia","native":{"kat":{"official":"საქართველო","common":"საქართველო"}}},"tld":[".ge"],"cca2":"GE","ccn3":"268","cca3":"GEO","cioc":"GEO","independent":true,"status":"officially-assigned","currency":["GEL"],"callingCode":["995"],"capital":["Tbilisi"],"altSpellings":["GE","Sakartvelo"],"region":"Asia","subregion":"Western Asia","languages":{"kat":"Georgian"},"translations":{"deu":{"official":"Georgia","common":"Georgien"},"fra":{"official":"République de Géorgie","common":"Géorgie"},"hrv":{"official":"Gruzija","common":"Gruzija"},"ita":{"official":"Georgia","common":"Georgia"},"jpn":{"official":"グルジア","common":"グルジア"},"nld":{"official":"Georgia","common":"Georgië"},"por":{"official":"Georgia","common":"Geórgia"},"rus":{"official":"Грузия","common":"Грузия"},"slk":{"official":"Gruzínsko","common":"Gruzínsko"},"spa":{"official":"Georgia","common":"Georgia"},"fin":{"official":"Georgia","common":"Georgia"},"est":{"official":"Gruusia","common":"Gruusia"},"zho":{"official":"格鲁吉亚","common":"格鲁吉亚"}},"latlng":[42,43.5],"demonym":"Georgian","landlocked":false,"borders":["ARM","AZE","RUS","TUR"],"area":69700,"flag":"🇬🇪"},{"name":{"common":"Guernsey","official":"Bailiwick of Guernsey","native":{"eng":{"official":"Bailiwick of Guernsey","common":"Guernsey"},"fra":{"official":"Bailliage de Guernesey","common":"Guernesey"},"nfr":{"official":"Dgèrnésiais","common":"Dgèrnésiais"}}},"tld":[".gg"],"cca2":"GG","ccn3":"831","cca3":"GGY","cioc":"","independent":false,"status":"officially-assigned","currency":["GBP"],"callingCode":["44"],"capital":["St. Peter Port"],"altSpellings":["GG","Bailiwick of Guernsey","Bailliage de Guernesey"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","fra":"French","nfr":"Guernésiais"},"translations":{"deu":{"official":"Guernsey","common":"Guernsey"},"fra":{"official":"Bailliage de Guernesey","common":"Guernesey"},"hrv":{"official":"Struka Guernsey","common":"Guernsey"},"ita":{"official":"Baliato di Guernsey","common":"Guernsey"},"jpn":{"official":"ガーンジーの得意分野","common":"ガーンジー"},"nld":{"official":"Baljuwschap Guernsey","common":"Guernsey"},"por":{"official":"Bailiado de Guernsey","common":"Guernsey"},"rus":{"official":"Коронное владение Гернси","common":"Гернси"},"slk":{"official":"Guernsey","common":"Guernsey"},"spa":{"official":"Bailía de Guernsey","common":"Guernsey"},"fin":{"official":"Guernsey","common":"Guernsey"},"est":{"official":"Guernsey foogtkond","common":"Guernsey"},"zho":{"official":"根西岛","common":"根西岛"}},"latlng":[49.46666666,-2.58333333],"demonym":"Channel Islander","landlocked":false,"borders":[],"area":78,"flag":"🇬🇬"},{"name":{"common":"Ghana","official":"Republic of Ghana","native":{"eng":{"official":"Republic of Ghana","common":"Ghana"}}},"tld":[".gh"],"cca2":"GH","ccn3":"288","cca3":"GHA","cioc":"GHA","independent":true,"status":"officially-assigned","currency":["GHS"],"callingCode":["233"],"capital":["Accra"],"altSpellings":["GH"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"deu":{"official":"Republik Ghana","common":"Ghana"},"fra":{"official":"République du Ghana","common":"Ghana"},"hrv":{"official":"Republika Gana","common":"Gana"},"ita":{"official":"Repubblica del Ghana","common":"Ghana"},"jpn":{"official":"ガーナ共和国","common":"ガーナ"},"nld":{"official":"Republiek Ghana","common":"Ghana"},"por":{"official":"República do Gana","common":"Gana"},"rus":{"official":"Республика Гана","common":"Гана"},"slk":{"official":"Ghansk/u00e1 republika","common":"Ghana"},"spa":{"official":"República de Ghana","common":"Ghana"},"fin":{"official":"Ghanan tasavalta","common":"Ghana"},"est":{"official":"Ghana Vabariik","common":"Ghana"},"zho":{"official":"加纳共和国","common":"加纳"}},"latlng":[8,-2],"demonym":"Ghanaian","landlocked":false,"borders":["BFA","CIV","TGO"],"area":238533,"flag":"🇬🇭"},{"name":{"common":"Gibraltar","official":"Gibraltar","native":{"eng":{"official":"Gibraltar","common":"Gibraltar"}}},"tld":[".gi"],"cca2":"GI","ccn3":"292","cca3":"GIB","cioc":"","independent":false,"status":"officially-assigned","currency":["GIP"],"callingCode":["350"],"capital":["Gibraltar"],"altSpellings":["GI"],"region":"Europe","subregion":"Southern Europe","languages":{"eng":"English"},"translations":{"deu":{"official":"Gibraltar","common":"Gibraltar"},"fra":{"official":"Gibraltar","common":"Gibraltar"},"hrv":{"official":"Gibraltar","common":"Gibraltar"},"ita":{"official":"Gibilterra","common":"Gibilterra"},"jpn":{"official":"ジブラルタル","common":"ジブラルタル"},"nld":{"official":"Gibraltar","common":"Gibraltar"},"por":{"official":"Gibraltar","common":"Gibraltar"},"rus":{"official":"Гибралтар","common":"Гибралтар"},"slk":{"official":"Gibraltár","common":"Gibraltár"},"spa":{"official":"Gibraltar","common":"Gibraltar"},"fin":{"official":"Gibraltar","common":"Gibraltar"},"est":{"official":"Gibraltar","common":"Gibraltar"},"zho":{"official":"直布罗陀","common":"直布罗陀"}},"latlng":[36.13333333,-5.35],"demonym":"Gibraltar","landlocked":false,"borders":["ESP"],"area":6,"flag":"🇬🇮"},{"name":{"common":"Guinea","official":"Republic of Guinea","native":{"fra":{"official":"République de Guinée","common":"Guinée"}}},"tld":[".gn"],"cca2":"GN","ccn3":"324","cca3":"GIN","cioc":"GUI","independent":true,"status":"officially-assigned","currency":["GNF"],"callingCode":["224"],"capital":["Conakry"],"altSpellings":["GN","Republic of Guinea","République de Guinée"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"deu":{"official":"Republik Guinea","common":"Guinea"},"fra":{"official":"République de Guinée","common":"Guinée"},"hrv":{"official":"Republika Gvineja","common":"Gvineja"},"ita":{"official":"Repubblica di Guinea","common":"Guinea"},"jpn":{"official":"ギニア共和国","common":"ギニア"},"nld":{"official":"Republiek Guinee","common":"Guinee"},"por":{"official":"República da Guiné","common":"Guiné"},"rus":{"official":"Республика Гвинея","common":"Гвинея"},"slk":{"official":"Guinejská republika","common":"Guinea"},"spa":{"official":"República de Guinea","common":"Guinea"},"fin":{"official":"Guinean tasavalta","common":"Guinea"},"est":{"official":"Guinea Vabariik","common":"Guinea"},"zho":{"official":"几内亚共和国","common":"几内亚"}},"latlng":[11,-10],"demonym":"Guinean","landlocked":false,"borders":["CIV","GNB","LBR","MLI","SEN","SLE"],"area":245857,"flag":"🇬🇳"},{"name":{"common":"Guadeloupe","official":"Guadeloupe","native":{"fra":{"official":"Guadeloupe","common":"Guadeloupe"}}},"tld":[".gp"],"cca2":"GP","ccn3":"312","cca3":"GLP","cioc":"","independent":false,"status":"officially-assigned","currency":["EUR"],"callingCode":["590"],"capital":["Basse-Terre"],"altSpellings":["GP","Gwadloup"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"deu":{"official":"Guadeloupe","common":"Guadeloupe"},"fra":{"official":"Guadeloupe","common":"Guadeloupe"},"hrv":{"official":"Gvadalupa","common":"Gvadalupa"},"ita":{"official":"Guadeloupe","common":"Guadeloupa"},"jpn":{"official":"グアドループ島","common":"グアドループ"},"nld":{"official":"Guadeloupe","common":"Guadeloupe"},"por":{"official":"Guadalupe","common":"Guadalupe"},"rus":{"official":"Гваделупа","common":"Гваделупа"},"slk":{"official":"Guadeloupe","common":"Guadeloupe"},"spa":{"official":"Guadalupe","common":"Guadalupe"},"fin":{"official":"Guadeloupen departmentti","common":"Guadeloupe"},"est":{"official":"Guadeloupe’i ja sõltkondade departemang","common":"Guadeloupe"},"zho":{"official":"瓜德罗普岛","common":"瓜德罗普岛"}},"latlng":[16.25,-61.583333],"demonym":"Guadeloupian","landlocked":false,"borders":[],"area":1628,"flag":"🇬🇵"},{"name":{"common":"Gambia","official":"Republic of the Gambia","native":{"eng":{"official":"Republic of the Gambia","common":"Gambia"}}},"tld":[".gm"],"cca2":"GM","ccn3":"270","cca3":"GMB","cioc":"GAM","independent":true,"status":"officially-assigned","currency":["GMD"],"callingCode":["220"],"capital":["Banjul"],"altSpellings":["GM","Republic of the Gambia"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"deu":{"official":"Republik Gambia","common":"Gambia"},"fra":{"official":"République de Gambie","common":"Gambie"},"hrv":{"official":"Republika Gambija","common":"Gambija"},"ita":{"official":"Repubblica del Gambia","common":"Gambia"},"jpn":{"official":"ガンビア共和国","common":"ガンビア"},"nld":{"official":"Republiek Gambia","common":"Gambia"},"por":{"official":"República da Gâmbia","common":"Gâmbia"},"rus":{"official":"Республика Гамбия","common":"Гамбия"},"slk":{"official":"Gambijsk/u00e1 republika","common":"Gambia"},"spa":{"official":"República de Gambia","common":"Gambia"},"fin":{"official":"Gambian tasavalta","common":"Gambia"},"est":{"official":"Gambia Vabariik","common":"Gambia"},"zho":{"official":"冈比亚共和国","common":"冈比亚"}},"latlng":[13.46666666,-16.56666666],"demonym":"Gambian","landlocked":false,"borders":["SEN"],"area":10689,"flag":"🇬🇲"},{"name":{"common":"Guinea-Bissau","official":"Republic of Guinea-Bissau","native":{"por":{"official":"República da Guiné-Bissau","common":"Guiné-Bissau"},"pov":{"official":"República da Guiné-Bissau","common":"Guiné-Bissau"}}},"tld":[".gw"],"cca2":"GW","ccn3":"624","cca3":"GNB","cioc":"GBS","independent":true,"status":"officially-assigned","currency":["XOF"],"callingCode":["245"],"capital":["Bissau"],"altSpellings":["GW","Republic of Guinea-Bissau","República da Guiné-Bissau"],"region":"Africa","subregion":"Western Africa","languages":{"por":"Portuguese","pov":"Upper Guinea Creole"},"translations":{"deu":{"official":"Republik Guinea-Bissau","common":"Guinea-Bissau"},"fra":{"official":"République de Guinée-Bissau","common":"Guinée-Bissau"},"hrv":{"official":"Republika Gvineja Bisau","common":"Gvineja Bisau"},"ita":{"official":"Repubblica di Guinea-Bissau","common":"Guinea-Bissau"},"jpn":{"official":"ギニアビサウ共和国","common":"ギニアビサウ"},"nld":{"official":"Republiek Guinee-Bissau","common":"Guinee-Bissau"},"por":{"official":"República da Guiné-Bissau","common":"Guiné-Bissau"},"rus":{"official":"Республика Гвинея -Бисау","common":"Гвинея-Бисау"},"slk":{"official":"Guinejsko-bissauská republika","common":"Guinea-Bissau"},"spa":{"official":"República de Guinea-Bissau","common":"Guinea-Bisáu"},"fin":{"official":"Guinea-Bissaun tasavalta","common":"Guinea-Bissau"},"est":{"official":"Guinea-Bissau Vabariik","common":"Guinea-Bissau"},"zho":{"official":"几内亚比绍共和国","common":"几内亚比绍"}},"latlng":[12,-15],"demonym":"Guinea-Bissauan","landlocked":false,"borders":["GIN","SEN"],"area":36125,"flag":"🇬🇼"},{"name":{"common":"Equatorial Guinea","official":"Republic of Equatorial Guinea","native":{"fra":{"official":"République de la Guinée Équatoriale","common":"Guinée équatoriale"},"por":{"official":"República da Guiné Equatorial","common":"Guiné Equatorial"},"spa":{"official":"República de Guinea Ecuatorial","common":"Guinea Ecuatorial"}}},"tld":[".gq"],"cca2":"GQ","ccn3":"226","cca3":"GNQ","cioc":"GEQ","independent":true,"status":"officially-assigned","currency":["XAF"],"callingCode":["240"],"capital":["Malabo"],"altSpellings":["GQ","Republic of Equatorial Guinea","República de Guinea Ecuatorial","République de Guinée équatoriale","República da Guiné Equatorial"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","por":"Portuguese","spa":"Spanish"},"translations":{"cym":{"official":"Gweriniaeth Gini Gyhydeddol","common":"Gini Gyhydeddol"},"deu":{"official":"Republik Äquatorialguinea","common":"Äquatorialguinea"},"fra":{"official":"République de Guinée équatoriale","common":"Guinée équatoriale"},"hrv":{"official":"Republika Ekvatorska Gvineja","common":"Ekvatorijalna Gvineja"},"ita":{"official":"Repubblica della Guinea Equatoriale","common":"Guinea Equatoriale"},"jpn":{"official":"赤道ギニア共和国","common":"赤道ギニア"},"nld":{"official":"Republiek Equatoriaal-Guinea","common":"Equatoriaal-Guinea"},"por":{"official":"República da Guiné Equatorial","common":"Guiné Equatorial"},"rus":{"official":"Республика Экваториальная Гвинея","common":"Экваториальная Гвинея"},"slk":{"official":"Republika rovníkovej Guiney","common":"Rovníková Guinea"},"spa":{"official":"República de Guinea Ecuatorial","common":"Guinea Ecuatorial"},"fin":{"official":"Päiväntasaajan Guinean tasavalta","common":"Päiväntasaajan Guinea"},"est":{"official":"Ekvatoriaal-Guinea Vabariik","common":"Ekvatoriaal-Guinea"},"zho":{"official":"赤道几内亚共和国","common":"赤道几内亚"}},"latlng":[2,10],"demonym":"Equatorial Guinean","landlocked":false,"borders":["CMR","GAB"],"area":28051,"flag":"🇬🇶"},{"name":{"common":"Greece","official":"Hellenic Republic","native":{"ell":{"official":"Ελληνική Δημοκρατία","common":"Ελλάδα"}}},"tld":[".gr"],"cca2":"GR","ccn3":"300","cca3":"GRC","cioc":"GRE","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["30"],"capital":["Athens"],"altSpellings":["GR","Elláda","Hellenic Republic","Ελληνική Δημοκρατία"],"region":"Europe","subregion":"Southern Europe","languages":{"ell":"Greek"},"translations":{"deu":{"official":"Hellenische Republik","common":"Griechenland"},"fra":{"official":"République hellénique","common":"Grèce"},"hrv":{"official":"Helenska Republika","common":"Grčka"},"ita":{"official":"Repubblica ellenica","common":"Grecia"},"jpn":{"official":"ギリシャ共和国","common":"ギリシャ"},"nld":{"official":"Helleense Republiek","common":"Griekenland"},"por":{"official":"República Helénica","common":"Grécia"},"rus":{"official":"Греческая Республика","common":"Греция"},"slk":{"official":"Grécka republika","common":"Greécko"},"spa":{"official":"República Helénica","common":"Grecia"},"fin":{"official":"Helleenien tasavalta","common":"Kreikka"},"est":{"official":"Kreeka Vabariik","common":"Kreeka"},"zho":{"official":"希腊共和国","common":"希腊"}},"latlng":[39,22],"demonym":"Greek","landlocked":false,"borders":["ALB","BGR","TUR","MKD"],"area":131990,"flag":"🇬🇷"},{"name":{"common":"Grenada","official":"Grenada","native":{"eng":{"official":"Grenada","common":"Grenada"}}},"tld":[".gd"],"cca2":"GD","ccn3":"308","cca3":"GRD","cioc":"GRN","independent":true,"status":"officially-assigned","currency":["XCD"],"callingCode":["1473"],"capital":["St. George's"],"altSpellings":["GD"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"deu":{"official":"Grenada","common":"Grenada"},"fra":{"official":"Grenade","common":"Grenade"},"hrv":{"official":"Grenada","common":"Grenada"},"ita":{"official":"Grenada","common":"Grenada"},"jpn":{"official":"グレナダ","common":"グレナダ"},"nld":{"official":"Grenada","common":"Grenada"},"por":{"official":"Grenada","common":"Granada"},"rus":{"official":"Гренада","common":"Гренада"},"slk":{"official":"Grenada","common":"Grenada"},"spa":{"official":"Granada","common":"Grenada"},"fin":{"official":"Grenada","common":"Grenada"},"est":{"official":"Grenada","common":"Grenada"},"zho":{"official":"格林纳达","common":"格林纳达"}},"latlng":[12.11666666,-61.66666666],"demonym":"Grenadian","landlocked":false,"borders":[],"area":344,"flag":"🇬🇩"},{"name":{"common":"Greenland","official":"Greenland","native":{"kal":{"official":"Kalaallit Nunaat","common":"Kalaallit Nunaat"}}},"tld":[".gl"],"cca2":"GL","ccn3":"304","cca3":"GRL","cioc":"","independent":false,"status":"officially-assigned","currency":["DKK"],"callingCode":["299"],"capital":["Nuuk"],"altSpellings":["GL","Grønland"],"region":"Americas","subregion":"Northern America","languages":{"kal":"Greenlandic"},"translations":{"deu":{"official":"Grönland","common":"Grönland"},"fra":{"official":"Groenland","common":"Groenland"},"hrv":{"official":"Grenland","common":"Grenland"},"ita":{"official":"Groenlandia","common":"Groenlandia"},"jpn":{"official":"グリーンランド","common":"グリーンランド"},"nld":{"official":"Groenland","common":"Groenland"},"por":{"official":"Groenlândia","common":"Gronelândia"},"rus":{"official":"Гренландия","common":"Гренландия"},"slk":{"official":"Grónsko","common":"Grónsko"},"spa":{"official":"Groenlandia","common":"Groenlandia"},"fin":{"official":"Groönlanti","common":"Groönlanti"},"est":{"official":"Gröönimaa","common":"Gröönimaa"},"zho":{"official":"格陵兰","common":"格陵兰"}},"latlng":[72,-40],"demonym":"Greenlandic","landlocked":false,"borders":[],"area":2166086,"flag":"🇬🇱"},{"name":{"common":"Guatemala","official":"Republic of Guatemala","native":{"spa":{"official":"República de Guatemala","common":"Guatemala"}}},"tld":[".gt"],"cca2":"GT","ccn3":"320","cca3":"GTM","cioc":"GUA","independent":true,"status":"officially-assigned","currency":["GTQ"],"callingCode":["502"],"capital":["Guatemala City"],"altSpellings":["GT"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"deu":{"official":"Republik Guatemala","common":"Guatemala"},"fra":{"official":"République du Guatemala","common":"Guatemala"},"hrv":{"official":"Republika Gvatemala","common":"Gvatemala"},"ita":{"official":"Repubblica del Guatemala","common":"Guatemala"},"jpn":{"official":"グアテマラ共和国","common":"グアテマラ"},"nld":{"official":"Republiek Guatemala","common":"Guatemala"},"por":{"official":"República da Guatemala","common":"Guatemala"},"rus":{"official":"Республика Гватемала","common":"Гватемала"},"slk":{"official":"Guatemalská republika","common":"Guatemala"},"spa":{"official":"República de Guatemala","common":"Guatemala"},"fin":{"official":"Guatemalan tasavalta","common":"Guatemala"},"est":{"official":"Guatemala Vabariik","common":"Guatemala"},"zho":{"official":"危地马拉共和国","common":"危地马拉"}},"latlng":[15.5,-90.25],"demonym":"Guatemalan","landlocked":false,"borders":["BLZ","SLV","HND","MEX"],"area":108889,"flag":"🇬🇹"},{"name":{"common":"French Guiana","official":"Guiana","native":{"fra":{"official":"Guyane","common":"Guyane française"}}},"tld":[".gf"],"cca2":"GF","ccn3":"254","cca3":"GUF","cioc":"","independent":false,"status":"officially-assigned","currency":["EUR"],"callingCode":["594"],"capital":["Cayenne"],"altSpellings":["GF","Guiana","Guyane"],"region":"Americas","subregion":"South America","languages":{"fra":"French"},"translations":{"deu":{"official":"Guayana","common":"Französisch Guyana"},"fra":{"official":"Guyane","common":"Guyane"},"hrv":{"official":"Gijana","common":"Francuska Gvajana"},"ita":{"official":"Guiana","common":"Guyana francese"},"jpn":{"official":"ギアナ","common":"フランス領ギアナ"},"nld":{"official":"Guyana","common":"Frans-Guyana"},"por":{"official":"Guiana","common":"Guiana Francesa"},"rus":{"official":"Гвиана","common":"Французская Гвиана"},"slk":{"official":"Francúzska Guyana","common":"Guyana"},"spa":{"official":"Guayana","common":"Guayana Francesa"},"fin":{"official":"Ranskan Guayana","common":"Ranskan Guayana"},"est":{"official":"Guajaana departemang","common":"Prantsuse Guajaana"},"zho":{"official":"法属圭亚那","common":"法属圭亚那"}},"latlng":[4,-53],"demonym":"Guianan","landlocked":false,"borders":["BRA","SUR"],"area":83534,"flag":"🇬🇫"},{"name":{"common":"Guam","official":"Guam","native":{"cha":{"official":"Guåhån","common":"Guåhån"},"eng":{"official":"Guam","common":"Guam"},"spa":{"official":"Guam","common":"Guam"}}},"tld":[".gu"],"cca2":"GU","ccn3":"316","cca3":"GUM","cioc":"GUM","independent":false,"status":"officially-assigned","currency":["USD"],"callingCode":["1671"],"capital":["Hagåtña"],"altSpellings":["GU","Guåhån"],"region":"Oceania","subregion":"Micronesia","languages":{"cha":"Chamorro","eng":"English","spa":"Spanish"},"translations":{"deu":{"official":"Guam","common":"Guam"},"fra":{"official":"Guam","common":"Guam"},"hrv":{"official":"Guam","common":"Guam"},"ita":{"official":"Guam","common":"Guam"},"jpn":{"official":"グアム","common":"グアム"},"nld":{"official":"Guam","common":"Guam"},"por":{"official":"Guam","common":"Guam"},"rus":{"official":"Гуам","common":"Гуам"},"slk":{"official":"Guam","common":"Guam"},"spa":{"official":"Guam","common":"Guam"},"fin":{"official":"Guam","common":"Guam"},"est":{"official":"Guami ala","common":"Guam"},"zho":{"official":"关岛","common":"关岛"}},"latlng":[13.46666666,144.78333333],"demonym":"Guamanian","landlocked":false,"borders":[],"area":549,"flag":"🇬🇺"},{"name":{"common":"Guyana","official":"Co-operative Republic of Guyana","native":{"eng":{"official":"Co-operative Republic of Guyana","common":"Guyana"}}},"tld":[".gy"],"cca2":"GY","ccn3":"328","cca3":"GUY","cioc":"GUY","independent":true,"status":"officially-assigned","currency":["GYD"],"callingCode":["592"],"capital":["Georgetown"],"altSpellings":["GY","Co-operative Republic of Guyana"],"region":"Americas","subregion":"South America","languages":{"eng":"English"},"translations":{"deu":{"official":"Kooperative Republik Guyana","common":"Guyana"},"fra":{"official":"République coopérative de Guyana","common":"Guyana"},"hrv":{"official":"Zadruga Republika Gvajana","common":"Gvajana"},"ita":{"official":"Co -operative Republic of Guyana","common":"Guyana"},"jpn":{"official":"ガイアナの協同共和国","common":"ガイアナ"},"nld":{"official":"Coöperatieve Republiek Guyana","common":"Guyana"},"por":{"official":"Co -operative República da Guiana","common":"Guiana"},"rus":{"official":"Кооперативная Республика Гайана","common":"Гайана"},"slk":{"official":"Guyanská kooperatívna republika","common":"Guyana"},"spa":{"official":"República Cooperativa de Guyana","common":"Guyana"},"fin":{"official":"Guayanan osuustoiminnallinen tasavalta","common":"Guayana"},"est":{"official":"Guyana Vabariik","common":"Guyana"},"zho":{"official":"圭亚那共和国","common":"圭亚那"}},"latlng":[5,-59],"demonym":"Guyanese","landlocked":false,"borders":["BRA","SUR","VEN"],"area":214969,"flag":"🇬🇾"},{"name":{"common":"Hong Kong","official":"Hong Kong Special Administrative Region of the People's Republic of China","native":{"eng":{"official":"Hong Kong Special Administrative Region of the People's Republic of China","common":"Hong Kong"},"zho":{"official":"中华人民共和国香港特别行政区","common":"香港"}}},"tld":[".hk",".香港"],"cca2":"HK","ccn3":"344","cca3":"HKG","cioc":"HKG","independent":false,"status":"officially-assigned","currency":["HKD"],"callingCode":["852"],"capital":["City of Victoria"],"altSpellings":["HK"],"region":"Asia","subregion":"Eastern Asia","languages":{"eng":"English","zho":"Chinese"},"translations":{"deu":{"official":"Sonderverwaltungszone der Volksrepublik China","common":"Hongkong"},"fra":{"official":"Région administrative spéciale de Hong Kong de la République populaire de Chine","common":"Hong Kong"},"hrv":{"official":"Hong Kong Posebnog upravnog područjaNarodne Republike Kine","common":"Hong Kong"},"ita":{"official":"Hong Kong Regione amministrativa speciale della Repubblica Popolare Cinese","common":"Hong Kong"},"jpn":{"official":"中華人民共和国香港特別行政区","common":"香港"},"nld":{"official":"Hong Kong Speciale Administratieve Regio van de Volksrepubliek China","common":"Hongkong"},"por":{"official":"Hong Kong Região Administrativa Especial da República Popular da China","common":"Hong Kong"},"rus":{"official":"Hong Kong Специальный административный район Китайской Народной Республики Китая","common":"Гонконг"},"slk":{"official":"Špeciálna administratívna oblasťČínskej ľudovej republiky Hongkong","common":"Hongkong"},"spa":{"official":"Hong Kong Región Administrativa Especial de la República Popular China","common":"Hong Kong"},"fin":{"official":"Hong Kongin erityishallintoalue","common":"Hongkong"},"est":{"official":"Hongkongi erihalduspiirkond","common":"Hongkong"}},"latlng":[22.267,114.188],"demonym":"Hong Konger","landlocked":false,"borders":["CHN"],"area":1104,"flag":"🇭🇰"},{"name":{"common":"Heard Island and McDonald Islands","official":"Heard Island and McDonald Islands","native":{"eng":{"official":"Heard Island and McDonald Islands","common":"Heard Island and McDonald Islands"}}},"tld":[".hm",".aq"],"cca2":"HM","ccn3":"334","cca3":"HMD","cioc":"","independent":false,"status":"officially-assigned","currency":["AUD"],"callingCode":[],"capital":[""],"altSpellings":["HM","Heard Island and McDonald Islands"],"region":"Antarctic","subregion":"","languages":{"eng":"English"},"translations":{"deu":{"official":"Heard und McDonaldinseln","common":"Heard und die McDonaldinseln"},"fra":{"official":"Des îles Heard et McDonald","common":"Îles Heard-et-MacDonald"},"hrv":{"official":"Otok Heard i otočje McDonald","common":"Otok Heard i otočje McDonald"},"ita":{"official":"Isole Heard e McDonald","common":"Isole Heard e McDonald"},"jpn":{"official":"ハード島とマクドナルド諸島","common":"ハード島とマクドナルド諸島"},"nld":{"official":"Heard en McDonaldeilanden","common":"Heard-en McDonaldeilanden"},"por":{"official":"Ilha Heard e Ilhas McDonald","common":"Ilha Heard e Ilhas McDonald"},"rus":{"official":"Остров Херд и острова Макдональд","common":"Остров Херд и острова Макдональд"},"slk":{"official":"Teritórium Heardovho ostrova a Macdonaldových ostrovov","common":"Heardov ostrov"},"spa":{"official":"Islas Heard y McDonald","common":"Islas Heard y McDonald"},"fin":{"official":"Heard ja McDonaldinsaaret","common":"Heard ja McDonaldinsaaret"},"est":{"official":"Heardi ja McDonaldi saarte ala","common":"Heard ja McDonald"},"zho":{"official":"赫德岛和麦当劳群岛","common":"赫德岛和麦当劳群岛"}},"latlng":[-53.1,72.51666666],"demonym":"Heard and McDonald Islander","landlocked":false,"borders":[],"area":412,"flag":"🇭🇲"},{"name":{"common":"Honduras","official":"Republic of Honduras","native":{"spa":{"official":"República de Honduras","common":"Honduras"}}},"tld":[".hn"],"cca2":"HN","ccn3":"340","cca3":"HND","cioc":"HON","independent":true,"status":"officially-assigned","currency":["HNL"],"callingCode":["504"],"capital":["Tegucigalpa"],"altSpellings":["HN","Republic of Honduras","República de Honduras"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"deu":{"official":"Republik Honduras","common":"Honduras"},"fra":{"official":"République du Honduras","common":"Honduras"},"hrv":{"official":"Republika Honduras","common":"Honduras"},"ita":{"official":"Repubblica di Honduras","common":"Honduras"},"jpn":{"official":"ホンジュラス共和国","common":"ホンジュラス"},"nld":{"official":"Republiek Honduras","common":"Honduras"},"por":{"official":"República de Honduras","common":"Honduras"},"rus":{"official":"Республика Гондурас","common":"Гондурас"},"slk":{"official":"Honduraská republika","common":"Honduras"},"spa":{"official":"República de Honduras","common":"Honduras"},"fin":{"official":"Hondurasin tasavalta","common":"Honduras"},"est":{"official":"Hondurase Vabariik","common":"Honduras"},"zho":{"official":"洪都拉斯共和国","common":"洪都拉斯"}},"latlng":[15,-86.5],"demonym":"Honduran","landlocked":false,"borders":["GTM","SLV","NIC"],"area":112492,"flag":"🇭🇳"},{"name":{"common":"Croatia","official":"Republic of Croatia","native":{"hrv":{"official":"Republika Hrvatska","common":"Hrvatska"}}},"tld":[".hr"],"cca2":"HR","ccn3":"191","cca3":"HRV","cioc":"CRO","independent":true,"status":"officially-assigned","currency":["HRK"],"callingCode":["385"],"capital":["Zagreb"],"altSpellings":["HR","Hrvatska","Republic of Croatia","Republika Hrvatska"],"region":"Europe","subregion":"Southern Europe","languages":{"hrv":"Croatian"},"translations":{"cym":{"official":"Gweriniaeth Croatia","common":"Croatia"},"deu":{"official":"Republik Kroatien","common":"Kroatien"},"fra":{"official":"République de Croatie","common":"Croatie"},"hrv":{"official":"Republika Hrvatska","common":"Hrvatska"},"ita":{"official":"Repubblica di Croazia","common":"Croazia"},"jpn":{"official":"クロアチア共和国","common":"クロアチア"},"nld":{"official":"Republiek Kroatië","common":"Kroatië"},"por":{"official":"República da Croácia","common":"Croácia"},"rus":{"official":"Республика Хорватия","common":"Хорватия"},"slk":{"official":"Chorvátska republika","common":"Chorvátsko"},"spa":{"official":"República de Croacia","common":"Croacia"},"fin":{"official":"Kroatian tasavalta","common":"Kroatia"},"est":{"official":"Horvaatia Vabariik","common":"Horvaatia"},"zho":{"official":"克罗地亚共和国","common":"克罗地亚"}},"latlng":[45.16666666,15.5],"demonym":"Croatian","landlocked":false,"borders":["BIH","HUN","MNE","SRB","SVN"],"area":56594,"flag":"🇭🇷"},{"name":{"common":"Haiti","official":"Republic of Haiti","native":{"fra":{"official":"République d'Haïti","common":"Haïti"},"hat":{"official":"Repiblik Ayiti","common":"Ayiti"}}},"tld":[".ht"],"cca2":"HT","ccn3":"332","cca3":"HTI","cioc":"HAI","independent":true,"status":"officially-assigned","currency":["HTG","USD"],"callingCode":["509"],"capital":["Port-au-Prince"],"altSpellings":["HT","Republic of Haiti","République d'Haïti","Repiblik Ayiti"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French","hat":"Haitian Creole"},"translations":{"deu":{"official":"Republik Haiti","common":"Haiti"},"fra":{"official":"République d'Haïti","common":"Haïti"},"hrv":{"official":"Republika Haiti","common":"Haiti"},"ita":{"official":"Repubblica di Haiti","common":"Haiti"},"jpn":{"official":"ハイチ共和国","common":"ハイチ"},"nld":{"official":"Republiek Haïti","common":"Haïti"},"por":{"official":"República do Haiti","common":"Haiti"},"rus":{"official":"Республика Гаити","common":"Гаити"},"slk":{"official":"Haitská republika","common":"Haiti"},"spa":{"official":"República de Haití","common":"Haiti"},"fin":{"official":"Haitin tasavalta","common":"Haiti"},"est":{"official":"Haiti Vabariik","common":"Haiti"},"zho":{"official":"海地共和国","common":"海地"}},"latlng":[19,-72.41666666],"demonym":"Haitian","landlocked":false,"borders":["DOM"],"area":27750,"flag":"🇭🇹"},{"name":{"common":"Hungary","official":"Hungary","native":{"hun":{"official":"Magyarország","common":"Magyarország"}}},"tld":[".hu"],"cca2":"HU","ccn3":"348","cca3":"HUN","cioc":"HUN","independent":true,"status":"officially-assigned","currency":["HUF"],"callingCode":["36"],"capital":["Budapest"],"altSpellings":["HU"],"region":"Europe","subregion":"Eastern Europe","languages":{"hun":"Hungarian"},"translations":{"deu":{"official":"Ungarn","common":"Ungarn"},"fra":{"official":"Hongrie","common":"Hongrie"},"hrv":{"official":"Madžarska","common":"Mađarska"},"ita":{"official":"Ungheria","common":"Ungheria"},"jpn":{"official":"ハンガリー","common":"ハンガリー"},"nld":{"official":"Hongarije","common":"Hongarije"},"por":{"official":"Hungria","common":"Hungria"},"rus":{"official":"Венгрия","common":"Венгрия"},"slk":{"official":"Maďarsko","common":"Maďarsko"},"spa":{"official":"Hungría","common":"Hungría"},"fin":{"official":"Unkari","common":"Unkari"},"est":{"official":"Ungari","common":"Ungari"},"zho":{"official":"匈牙利","common":"匈牙利"}},"latlng":[47,20],"demonym":"Hungarian","landlocked":true,"borders":["AUT","HRV","ROU","SRB","SVK","SVN","UKR"],"area":93028,"flag":"🇭🇺"},{"name":{"common":"Indonesia","official":"Republic of Indonesia","native":{"ind":{"official":"Republik Indonesia","common":"Indonesia"}}},"tld":[".id"],"cca2":"ID","ccn3":"360","cca3":"IDN","cioc":"INA","independent":true,"status":"officially-assigned","currency":["IDR"],"callingCode":["62"],"capital":["Jakarta"],"altSpellings":["ID","Republic of Indonesia","Republik Indonesia"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"ind":"Indonesian"},"translations":{"deu":{"official":"Republik Indonesien","common":"Indonesien"},"fra":{"official":"République d'Indonésie","common":"Indonésie"},"hrv":{"official":"Republika Indonezija","common":"Indonezija"},"ita":{"official":"Repubblica di Indonesia","common":"Indonesia"},"jpn":{"official":"インドネシア共和国","common":"インドネシア"},"nld":{"official":"Republiek Indonesië","common":"Indonesië"},"por":{"official":"República da Indonésia","common":"Indonésia"},"rus":{"official":"Республика Индонезия","common":"Индонезия"},"slk":{"official":"Indonézska republika","common":"Indonézia"},"spa":{"official":"República de Indonesia","common":"Indonesia"},"fin":{"official":"Indonesian tasavalta","common":"Indonesia"},"est":{"official":"Indoneesia Vabariik","common":"Indoneesia"},"zho":{"official":"印度尼西亚共和国","common":"印度尼西亚"}},"latlng":[-5,120],"demonym":"Indonesian","landlocked":false,"borders":["TLS","MYS","PNG"],"area":1904569,"flag":"🇮🇩"},{"name":{"common":"Isle of Man","official":"Isle of Man","native":{"eng":{"official":"Isle of Man","common":"Isle of Man"},"glv":{"official":"Ellan Vannin or Mannin","common":"Mannin"}}},"tld":[".im"],"cca2":"IM","ccn3":"833","cca3":"IMN","cioc":"","independent":false,"status":"officially-assigned","currency":["GBP"],"callingCode":["44"],"capital":["Douglas"],"altSpellings":["IM","Ellan Vannin","Mann","Mannin"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","glv":"Manx"},"translations":{"deu":{"official":"Isle of Man","common":"Insel Man"},"fra":{"official":"Isle of Man","common":"Île de Man"},"hrv":{"official":"Mana ostrvo","common":"Otok Man"},"ita":{"official":"Isola di Man","common":"Isola di Man"},"jpn":{"official":"マン島","common":"マン島"},"nld":{"official":"Isle of Man","common":"Isle of Man"},"por":{"official":"Isle of Man","common":"Ilha de Man"},"rus":{"official":"Остров Мэн","common":"Остров Мэн"},"slk":{"official":"Ostrov Man","common":"Man"},"spa":{"official":"Isla de Man","common":"Isla de Man"},"fin":{"official":"Mansaari","common":"Mansaari"},"est":{"official":"Mani saar","common":"Mani saar"},"zho":{"official":"马恩岛","common":"马恩岛"}},"latlng":[54.25,-4.5],"demonym":"Manx","landlocked":false,"borders":[],"area":572,"flag":"🇮🇲"},{"name":{"common":"India","official":"Republic of India","native":{"eng":{"official":"Republic of India","common":"India"},"hin":{"official":"भारत गणराज्य","common":"भारत"},"tam":{"official":"இந்தியக் குடியரசு","common":"இந்தியா"}}},"tld":[".in"],"cca2":"IN","ccn3":"356","cca3":"IND","cioc":"IND","independent":true,"status":"officially-assigned","currency":["INR"],"callingCode":["91"],"capital":["New Delhi"],"altSpellings":["IN","Bhārat","Republic of India","Bharat Ganrajya","இந்தியா"],"region":"Asia","subregion":"Southern Asia","languages":{"eng":"English","hin":"Hindi","tam":"Tamil"},"translations":{"deu":{"official":"Republik Indien","common":"Indien"},"fra":{"official":"République de l'Inde","common":"Inde"},"hrv":{"official":"Republika Indija","common":"Indija"},"ita":{"official":"Repubblica dell'India","common":"India"},"jpn":{"official":"インド共和国","common":"インド"},"nld":{"official":"Republiek India","common":"India"},"por":{"official":"República da Índia","common":"Índia"},"rus":{"official":"Республика Индия","common":"Индия"},"slk":{"official":"Indická republika","common":"India"},"spa":{"official":"República de la India","common":"India"},"fin":{"official":"Intian tasavalta","common":"Intia"},"est":{"official":"India Vabariik","common":"India"},"zho":{"official":"印度共和国","common":"印度"}},"latlng":[20,77],"demonym":"Indian","landlocked":false,"borders":["BGD","BTN","MMR","CHN","NPL","PAK"],"area":3287590,"flag":"🇮🇳"},{"name":{"common":"British Indian Ocean Territory","official":"British Indian Ocean Territory","native":{"eng":{"official":"British Indian Ocean Territory","common":"British Indian Ocean Territory"}}},"tld":[".io"],"cca2":"IO","ccn3":"086","cca3":"IOT","cioc":"","independent":false,"status":"officially-assigned","currency":["USD"],"callingCode":["246"],"capital":["Diego Garcia"],"altSpellings":["IO"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English"},"translations":{"cym":{"official":"Tiriogaeth Brydeinig Cefnfor India","common":"Tiriogaeth Brydeinig Cefnfor India"},"deu":{"official":"Britisch-Indischer Ozean","common":"Britisches Territorium im Indischen Ozean"},"fra":{"official":"Territoire britannique de l' océan Indien","common":"Territoire britannique de l'océan Indien"},"hrv":{"official":"British Indian Ocean Territory","common":"Britanski Indijskooceanski teritorij"},"ita":{"official":"Territorio britannico dell'Oceano Indiano","common":"Territorio britannico dell'oceano indiano"},"jpn":{"official":"イギリス領インド洋地域","common":"イギリス領インド洋地域"},"nld":{"official":"Brits Indische Oceaan Territorium","common":"Britse Gebieden in de Indische Oceaan"},"por":{"official":"British Indian Ocean Territory","common":"Território Britânico do Oceano Índico"},"rus":{"official":"Британская территория Индийского океана","common":"Британская территория в Индийском океане"},"slk":{"official":"Britské indickooceánske územie","common":"Britské indickooceánske územie"},"spa":{"official":"Territorio Británico del Océano Índico","common":"Territorio Británico del Océano Índico"},"fin":{"official":"Brittiläinen Intian valtameren alue","common":"Brittiläinen Intian valtameren alue"},"est":{"official":"Briti India ookeani ala","common":"Briti India ookeani ala"},"zho":{"official":"英属印度洋领地","common":"英属印度洋领地"}},"latlng":[-6,71.5],"demonym":"Indian","landlocked":false,"borders":[],"area":60,"flag":"🇮🇴"},{"name":{"common":"Ireland","official":"Republic of Ireland","native":{"eng":{"official":"Republic of Ireland","common":"Ireland"},"gle":{"official":"Poblacht na hÉireann","common":"Éire"}}},"tld":[".ie"],"cca2":"IE","ccn3":"372","cca3":"IRL","cioc":"IRL","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["353"],"capital":["Dublin"],"altSpellings":["IE","Éire","Republic of Ireland","Poblacht na hÉireann"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","gle":"Irish"},"translations":{"deu":{"official":"Republik Irland","common":"Irland"},"fra":{"official":"République d'Irlande","common":"Irlande"},"hrv":{"official":"Republika Irska","common":"Irska"},"ita":{"official":"Repubblica d'Irlanda","common":"Irlanda"},"jpn":{"official":"アイルランド共和国","common":"アイルランド"},"nld":{"official":"Republic of Ireland","common":"Ierland"},"por":{"official":"República da Irlanda","common":"Irlanda"},"rus":{"official":"Ирландия","common":"Ирландия"},"slk":{"official":"Írska republika","common":"Írsko"},"spa":{"official":"República de Irlanda","common":"Irlanda"},"fin":{"official":"Irlannin tasavalta","common":"Irlanti"},"est":{"official":"Iirimaa","common":"Iirimaa"},"zho":{"official":"爱尔兰共和国","common":"爱尔兰"}},"latlng":[53,-8],"demonym":"Irish","landlocked":false,"borders":["GBR"],"area":70273,"flag":"🇮🇪"},{"name":{"common":"Iran","official":"Islamic Republic of Iran","native":{"fas":{"official":"جمهوری اسلامی ایران","common":"ایران"}}},"tld":[".ir","ایران."],"cca2":"IR","ccn3":"364","cca3":"IRN","cioc":"IRI","independent":true,"status":"officially-assigned","currency":["IRR"],"callingCode":["98"],"capital":["Tehran"],"altSpellings":["IR","Islamic Republic of Iran","Iran, Islamic Republic of","Jomhuri-ye Eslāmi-ye Irān"],"region":"Asia","subregion":"Southern Asia","languages":{"fas":"Persian"},"translations":{"deu":{"official":"Islamische Republik Iran","common":"Iran"},"fra":{"official":"République islamique d'Iran","common":"Iran"},"hrv":{"official":"Islamska Republika Iran","common":"Iran"},"ita":{"official":"Repubblica islamica dell'Iran","common":"Iran"},"jpn":{"official":"イラン·イスラム共和国","common":"イラン・イスラム共和国"},"nld":{"official":"Islamitische Republiek Iran","common":"Iran"},"por":{"official":"República Islâmica do Irã","common":"Irão"},"rus":{"official":"Исламская Республика Иран","common":"Иран"},"slk":{"official":"Iránska islamská republika","common":"Irán"},"spa":{"official":"República Islámica de Irán","common":"Iran"},"fin":{"official":"Iranin islamilainen tasavalta","common":"Iran"},"est":{"official":"Iraani Islamivabariik","common":"Iraan"},"zho":{"official":"伊朗伊斯兰共和国","common":"伊朗"}},"latlng":[32,53],"demonym":"Iranian","landlocked":false,"borders":["AFG","ARM","AZE","IRQ","PAK","TUR","TKM"],"area":1648195,"flag":"🇮🇷"},{"name":{"common":"Iraq","official":"Republic of Iraq","native":{"ara":{"official":"جمهورية العراق","common":"العراق"},"arc":{"official":"ܩܘܼܛܢܵܐ ܐܝܼܪܲܩ","common":"ܩܘܼܛܢܵܐ"},"ckb":{"official":"کۆماری عێراق","common":"کۆماری"}}},"tld":[".iq"],"cca2":"IQ","ccn3":"368","cca3":"IRQ","cioc":"IRQ","independent":true,"status":"officially-assigned","currency":["IQD"],"callingCode":["964"],"capital":["Baghdad"],"altSpellings":["IQ","Republic of Iraq","Jumhūriyyat al-‘Irāq"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic","arc":"Aramaic","ckb":"Sorani"},"translations":{"deu":{"official":"Republik Irak","common":"Irak"},"fra":{"official":"République d'Irak","common":"Irak"},"hrv":{"official":"Republika Irak","common":"Irak"},"ita":{"official":"Repubblica dell'Iraq","common":"Iraq"},"jpn":{"official":"イラク共和国","common":"イラク"},"nld":{"official":"Republiek Irak","common":"Irak"},"por":{"official":"República do Iraque","common":"Iraque"},"rus":{"official":"Республика Ирак","common":"Ирак"},"slk":{"official":"Iracká republika","common":"Irak"},"spa":{"official":"República de Irak","common":"Irak"},"fin":{"official":"Irakin tasavalta","common":"Irak"},"est":{"official":"Iraagi Vabariik","common":"Iraak"},"zho":{"official":"伊拉克共和国","common":"伊拉克"}},"latlng":[33,44],"demonym":"Iraqi","landlocked":false,"borders":["IRN","JOR","KWT","SAU","SYR","TUR"],"area":438317,"flag":"🇮🇶"},{"name":{"common":"Iceland","official":"Iceland","native":{"isl":{"official":"Ísland","common":"Ísland"}}},"tld":[".is"],"cca2":"IS","ccn3":"352","cca3":"ISL","cioc":"ISL","independent":true,"status":"officially-assigned","currency":["ISK"],"callingCode":["354"],"capital":["Reykjavik"],"altSpellings":["IS","Island","Republic of Iceland","Lýðveldið Ísland"],"region":"Europe","subregion":"Northern Europe","languages":{"isl":"Icelandic"},"translations":{"deu":{"official":"Island","common":"Island"},"fra":{"official":"République d'Islande","common":"Islande"},"hrv":{"official":"Island","common":"Island"},"ita":{"official":"Islanda","common":"Islanda"},"jpn":{"official":"アイスランド","common":"アイスランド"},"nld":{"official":"IJsland","common":"IJsland"},"por":{"official":"Islândia","common":"Islândia"},"rus":{"official":"Исландия","common":"Исландия"},"slk":{"official":"Islandská republika","common":"Island"},"spa":{"official":"Islandia","common":"Islandia"},"fin":{"official":"Islanti","common":"Islanti"},"est":{"official":"Islandi Vabariik","common":"Island"},"zho":{"official":"冰岛","common":"冰岛"}},"latlng":[65,-18],"demonym":"Icelander","landlocked":false,"borders":[],"area":103000,"flag":"🇮🇸"},{"name":{"common":"Israel","official":"State of Israel","native":{"ara":{"official":"دولة إسرائيل","common":"إسرائيل"},"heb":{"official":"מדינת ישראל","common":"ישראל"}}},"tld":[".il"],"cca2":"IL","ccn3":"376","cca3":"ISR","cioc":"ISR","independent":true,"status":"officially-assigned","currency":["ILS"],"callingCode":["972"],"capital":["Jerusalem"],"altSpellings":["IL","State of Israel","Medīnat Yisrā'el"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic","heb":"Hebrew"},"translations":{"deu":{"official":"Staat Israel","common":"Israel"},"fra":{"official":"État d'Israël","common":"Israël"},"hrv":{"official":"Država Izrael","common":"Izrael"},"ita":{"official":"Stato di Israele","common":"Israele"},"jpn":{"official":"イスラエル国","common":"イスラエル"},"nld":{"official":"Staat Israël","common":"Israël"},"por":{"official":"Estado de Israel","common":"Israel"},"rus":{"official":"Государство Израиль","common":"Израиль"},"slk":{"official":"Izraelský štát","common":"Izrael"},"spa":{"official":"Estado de Israel","common":"Israel"},"fin":{"official":"Israelin valtio","common":"Israel"},"est":{"official":"Iisraeli Riik","common":"Iisrael"},"zho":{"official":"以色列国","common":"以色列"}},"latlng":[31.47,35.13],"demonym":"Israeli","landlocked":false,"borders":["EGY","JOR","LBN","PSE","SYR"],"area":20770,"flag":"🇮🇱"},{"name":{"common":"Italy","official":"Italian Republic","native":{"ita":{"official":"Repubblica italiana","common":"Italia"}}},"tld":[".it"],"cca2":"IT","ccn3":"380","cca3":"ITA","cioc":"ITA","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["39"],"capital":["Rome"],"altSpellings":["IT","Italian Republic","Repubblica italiana"],"region":"Europe","subregion":"Southern Europe","languages":{"ita":"Italian"},"translations":{"deu":{"official":"Italienische Republik","common":"Italien"},"fra":{"official":"République italienne","common":"Italie"},"hrv":{"official":"talijanska Republika","common":"Italija"},"ita":{"official":"Repubblica italiana","common":"Italia"},"jpn":{"official":"イタリア共和国","common":"イタリア"},"nld":{"official":"Italiaanse Republiek","common":"Italië"},"por":{"official":"República Italiana","common":"Itália"},"rus":{"official":"итальянская Республика","common":"Италия"},"slk":{"official":"Talianska republika","common":"Taliansko"},"spa":{"official":"República Italiana","common":"Italia"},"fin":{"official":"Italian tasavalta","common":"Italia"},"est":{"official":"Itaalia Vabariik","common":"Itaalia"},"zho":{"official":"意大利共和国","common":"意大利"}},"latlng":[42.83333333,12.83333333],"demonym":"Italian","landlocked":false,"borders":["AUT","FRA","SMR","SVN","CHE","VAT"],"area":301336,"flag":"🇮🇹"},{"name":{"common":"Jamaica","official":"Jamaica","native":{"eng":{"official":"Jamaica","common":"Jamaica"},"jam":{"official":"Jamaica","common":"Jamaica"}}},"tld":[".jm"],"cca2":"JM","ccn3":"388","cca3":"JAM","cioc":"JAM","independent":true,"status":"officially-assigned","currency":["JMD"],"callingCode":["1876"],"capital":["Kingston"],"altSpellings":["JM"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","jam":"Jamaican Patois"},"translations":{"deu":{"official":"Jamaika","common":"Jamaika"},"fra":{"official":"Jamaïque","common":"Jamaïque"},"hrv":{"official":"Jamajka","common":"Jamajka"},"ita":{"official":"Giamaica","common":"Giamaica"},"jpn":{"official":"ジャマイカ","common":"ジャマイカ"},"nld":{"official":"Jamaica","common":"Jamaica"},"por":{"official":"Jamaica","common":"Jamaica"},"rus":{"official":"Ямайка","common":"Ямайка"},"slk":{"official":"Jamajka","common":"Jamajka"},"spa":{"official":"Jamaica","common":"Jamaica"},"fin":{"official":"Jamaika","common":"Jamaika"},"est":{"official":"Jamaica","common":"Jamaica"},"zho":{"official":"牙买加","common":"牙买加"}},"latlng":[18.25,-77.5],"demonym":"Jamaican","landlocked":false,"borders":[],"area":10991,"flag":"🇯🇲"},{"name":{"common":"Jersey","official":"Bailiwick of Jersey","native":{"eng":{"official":"Bailiwick of Jersey","common":"Jersey"},"fra":{"official":"Bailliage de Jersey","common":"Jersey"},"nrf":{"official":"Bailliage dé Jèrri","common":"Jèrri"}}},"tld":[".je"],"cca2":"JE","ccn3":"832","cca3":"JEY","cioc":"","independent":false,"status":"officially-assigned","currency":["GBP"],"callingCode":["44"],"capital":["Saint Helier"],"altSpellings":["JE","Bailiwick of Jersey","Bailliage de Jersey","Bailliage dé Jèrri"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","fra":"French","nrf":"Jèrriais"},"translations":{"deu":{"official":"Vogtei Jersey","common":"Jersey"},"fra":{"official":"Bailliage de Jersey","common":"Jersey"},"hrv":{"official":"Struka od Jersey","common":"Jersey"},"ita":{"official":"Baliato di Jersey","common":"Isola di Jersey"},"jpn":{"official":"ジャージの得意分野","common":"ジャージー"},"nld":{"official":"Baljuwschap Jersey","common":"Jersey"},"por":{"official":"Bailiado de Jersey","common":"Jersey"},"rus":{"official":"Коронное владение Джерси","common":"Джерси"},"slk":{"official":"Bailiwick Jersey","common":"Jersey"},"spa":{"official":"Bailía de Jersey","common":"Jersey"},"fin":{"official":"Jersey","common":"Jersey"},"est":{"official":"Jersey foogtkond","common":"Jersey"},"zho":{"official":"泽西岛","common":"泽西岛"}},"latlng":[49.25,-2.16666666],"demonym":"Channel Islander","landlocked":false,"borders":[],"area":116,"flag":"🇯🇪"},{"name":{"common":"Jordan","official":"Hashemite Kingdom of Jordan","native":{"ara":{"official":"المملكة الأردنية الهاشمية","common":"الأردن"}}},"tld":[".jo","الاردن."],"cca2":"JO","ccn3":"400","cca3":"JOR","cioc":"JOR","independent":true,"status":"officially-assigned","currency":["JOD"],"callingCode":["962"],"capital":["Amman"],"altSpellings":["JO","Hashemite Kingdom of Jordan","al-Mamlakah al-Urdunīyah al-Hāshimīyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Haschemitisches Königreich Jordanien","common":"Jordanien"},"fra":{"official":"Royaume hachémite de Jordanie","common":"Jordanie"},"hrv":{"official":"Hašemitske Kraljevine Jordan","common":"Jordan"},"ita":{"official":"Regno hascemita di Giordania","common":"Giordania"},"jpn":{"official":"ヨルダン·ハシミテ王国","common":"ヨルダン"},"nld":{"official":"Hasjemitisch Koninkrijk Jordanië","common":"Jordanië"},"por":{"official":"Reino Hachemita da Jordânia","common":"Jordânia"},"rus":{"official":"Иорданского Хашимитского Королевства","common":"Иордания"},"slk":{"official":"Jordánske hášimovské kráľovstvo","common":"Jordánsko"},"spa":{"official":"Reino Hachemita de Jordania","common":"Jordania"},"fin":{"official":"Jordanian hašemiittinen kunigaskunta","common":"Jordania"},"est":{"official":"Jordaania Hašimiidi Kuningriik","common":"Jordaania"},"zho":{"official":"约旦哈希姆王国","common":"约旦"}},"latlng":[31,36],"demonym":"Jordanian","landlocked":false,"borders":["IRQ","ISR","PSE","SAU","SYR"],"area":89342,"flag":"🇯🇴"},{"name":{"common":"Japan","official":"Japan","native":{"jpn":{"official":"日本","common":"日本"}}},"tld":[".jp",".みんな"],"cca2":"JP","ccn3":"392","cca3":"JPN","cioc":"JPN","independent":true,"status":"officially-assigned","currency":["JPY"],"callingCode":["81"],"capital":["Tokyo"],"altSpellings":["JP","Nippon","Nihon"],"region":"Asia","subregion":"Eastern Asia","languages":{"jpn":"Japanese"},"translations":{"deu":{"official":"Japan","common":"Japan"},"fra":{"official":"Japon","common":"Japon"},"hrv":{"official":"Japan","common":"Japan"},"ita":{"official":"Giappone","common":"Giappone"},"jpn":{"official":"日本","common":"日本"},"nld":{"official":"Japan","common":"Japan"},"por":{"official":"Japão","common":"Japão"},"rus":{"official":"Япония","common":"Япония"},"slk":{"official":"Japonsko","common":"Japonsko"},"spa":{"official":"Japón","common":"Japón"},"fin":{"official":"Japani","common":"Japani"},"est":{"official":"Jaapan","common":"Jaapan"},"zho":{"official":"日本国","common":"日本"}},"latlng":[36,138],"demonym":"Japanese","landlocked":false,"borders":[],"area":377930,"flag":"🇯🇵"},{"name":{"common":"Kazakhstan","official":"Republic of Kazakhstan","native":{"kaz":{"official":"Қазақстан Республикасы","common":"Қазақстан"},"rus":{"official":"Республика Казахстан","common":"Казахстан"}}},"tld":[".kz",".қаз"],"cca2":"KZ","ccn3":"398","cca3":"KAZ","cioc":"KAZ","independent":true,"status":"officially-assigned","currency":["KZT"],"callingCode":["76","77"],"capital":["Astana"],"altSpellings":["KZ","Qazaqstan","Казахстан","Republic of Kazakhstan","Қазақстан Республикасы","Qazaqstan Respublïkası","Республика Казахстан","Respublika Kazakhstan"],"region":"Asia","subregion":"Central Asia","languages":{"kaz":"Kazakh","rus":"Russian"},"translations":{"deu":{"official":"Republik Kasachstan","common":"Kasachstan"},"fra":{"official":"République du Kazakhstan","common":"Kazakhstan"},"hrv":{"official":"Republika Kazahstan","common":"Kazahstan"},"ita":{"official":"Repubblica del Kazakhstan","common":"Kazakistan"},"jpn":{"official":"カザフスタン共和国","common":"カザフスタン"},"nld":{"official":"Republiek Kazachstan","common":"Kazachstan"},"por":{"official":"República do Cazaquistão","common":"Cazaquistão"},"rus":{"official":"Республика Казахстан","common":"Казахстан"},"slk":{"official":"Kazašská republika","common":"Kazachstan"},"spa":{"official":"República de Kazajstán","common":"Kazajistán"},"fin":{"official":"Kazakstanin tasavalta","common":"Kazakstan"},"est":{"official":"Kasahstani Vabariik","common":"Kasahstan"},"zho":{"official":"哈萨克斯坦共和国","common":"哈萨克斯坦"}},"latlng":[48,68],"demonym":"Kazakhstani","landlocked":true,"borders":["CHN","KGZ","RUS","TKM","UZB"],"area":2724900,"flag":"🇰🇿"},{"name":{"common":"Kenya","official":"Republic of Kenya","native":{"eng":{"official":"Republic of Kenya","common":"Kenya"},"swa":{"official":"Republic of Kenya","common":"Kenya"}}},"tld":[".ke"],"cca2":"KE","ccn3":"404","cca3":"KEN","cioc":"KEN","independent":true,"status":"officially-assigned","currency":["KES"],"callingCode":["254"],"capital":["Nairobi"],"altSpellings":["KE","Republic of Kenya","Jamhuri ya Kenya"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","swa":"Swahili"},"translations":{"deu":{"official":"Republik Kenia","common":"Kenia"},"fra":{"official":"République du Kenya","common":"Kenya"},"hrv":{"official":"Republika Kenija","common":"Kenija"},"ita":{"official":"Repubblica del Kenya","common":"Kenya"},"jpn":{"official":"ケニア共和国","common":"ケニア"},"nld":{"official":"Republiek Kenia","common":"Kenia"},"por":{"official":"República do Quénia","common":"Quénia"},"rus":{"official":"Республика Кения","common":"Кения"},"slk":{"official":"Kenská republika","common":"Keňa"},"spa":{"official":"República de Kenya","common":"Kenia"},"fin":{"official":"Kenian tasavalta","common":"Kenia"},"est":{"official":"Keenia Vabariik","common":"Keenia"},"zho":{"official":"肯尼亚共和国","common":"肯尼亚"}},"latlng":[1,38],"demonym":"Kenyan","landlocked":false,"borders":["ETH","SOM","SSD","TZA","UGA"],"area":580367,"flag":"🇰🇪"},{"name":{"common":"Kyrgyzstan","official":"Kyrgyz Republic","native":{"kir":{"official":"Кыргыз Республикасы","common":"Кыргызстан"},"rus":{"official":"Кыргызская Республика","common":"Киргизия"}}},"tld":[".kg"],"cca2":"KG","ccn3":"417","cca3":"KGZ","cioc":"KGZ","independent":true,"status":"officially-assigned","currency":["KGS"],"callingCode":["996"],"capital":["Bishkek"],"altSpellings":["KG","Киргизия","Kyrgyz Republic","Кыргыз Республикасы","Kyrgyz Respublikasy"],"region":"Asia","subregion":"Central Asia","languages":{"kir":"Kyrgyz","rus":"Russian"},"translations":{"deu":{"official":"Kirgisische Republik","common":"Kirgisistan"},"fra":{"official":"République kirghize","common":"Kirghizistan"},"hrv":{"official":"Kirgistanu","common":"Kirgistan"},"ita":{"official":"Kirghizistan","common":"Kirghizistan"},"jpn":{"official":"キルギス共和国","common":"キルギス"},"nld":{"official":"Kirgizische Republiek","common":"Kirgizië"},"por":{"official":"República do Quirguistão","common":"Quirguistão"},"rus":{"official":"Кыргызская Республика","common":"Киргизия"},"slk":{"official":"Kirgizská republika","common":"Kirgizsko"},"spa":{"official":"República Kirguisa","common":"Kirguizistán"},"fin":{"official":"Kirgisian tasavalta","common":"Kirgisia"},"est":{"official":"Kirgiisi Vabariik","common":"Kõrgõzstan"},"zho":{"official":"吉尔吉斯斯坦共和国","common":"吉尔吉斯斯坦"}},"latlng":[41,75],"demonym":"Kirghiz","landlocked":true,"borders":["CHN","KAZ","TJK","UZB"],"area":199951,"flag":"🇰🇬"},{"name":{"common":"Cambodia","official":"Kingdom of Cambodia","native":{"khm":{"official":"ព្រះរាជាណាចក្រកម្ពុជា","common":"Kâmpŭchéa"}}},"tld":[".kh"],"cca2":"KH","ccn3":"116","cca3":"KHM","cioc":"CAM","independent":true,"status":"officially-assigned","currency":["KHR"],"callingCode":["855"],"capital":["Phnom Penh"],"altSpellings":["KH","Kingdom of Cambodia"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"khm":"Khmer"},"translations":{"cym":{"official":"Teyrnas Cambodia","common":"Cambodia"},"deu":{"official":"Königreich Kambodscha","common":"Kambodscha"},"fra":{"official":"Royaume du Cambodge","common":"Cambodge"},"hrv":{"official":"Kraljevina Kambodža","common":"Kambodža"},"ita":{"official":"Regno di Cambogia","common":"Cambogia"},"jpn":{"official":"カンボジア王国","common":"カンボジア"},"nld":{"official":"Koninkrijk Cambodja","common":"Cambodja"},"por":{"official":"Reino do Camboja","common":"Camboja"},"rus":{"official":"Королевство Камбоджа","common":"Камбоджа"},"slk":{"official":"Kamboǆské kráľovstvo","common":"Kamboǆa"},"spa":{"official":"Reino de Camboya","common":"Camboya"},"fin":{"official":"Kambodžan kuningaskunta","common":"Kambodža"},"est":{"official":"Kambodža Kuningriik","common":"Kambodža"},"zho":{"official":"柬埔寨王国","common":"柬埔寨"}},"latlng":[13,105],"demonym":"Cambodian","landlocked":false,"borders":["LAO","THA","VNM"],"area":181035,"flag":"🇰🇭"},{"name":{"common":"Kiribati","official":"Independent and Sovereign Republic of Kiribati","native":{"eng":{"official":"Independent and Sovereign Republic of Kiribati","common":"Kiribati"},"gil":{"official":"Ribaberiki Kiribati","common":"Kiribati"}}},"tld":[".ki"],"cca2":"KI","ccn3":"296","cca3":"KIR","cioc":"KIR","independent":true,"status":"officially-assigned","currency":["AUD"],"callingCode":["686"],"capital":["South Tarawa"],"altSpellings":["KI","Republic of Kiribati","Ribaberiki Kiribati"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","gil":"Gilbertese"},"translations":{"deu":{"official":"Unabhängige und souveräne Republik Kiribati","common":"Kiribati"},"fra":{"official":"République de Kiribati","common":"Kiribati"},"hrv":{"official":"Samostalne i suverene Republike Kiribati","common":"Kiribati"},"ita":{"official":"Repubblica indipendente e sovrano di Kiribati","common":"Kiribati"},"jpn":{"official":"キリバスの独立と主権共和国","common":"キリバス"},"nld":{"official":"Onafhankelijke en soevereine republiek Kiribati","common":"Kiribati"},"por":{"official":"Independente e soberano República de Kiribati","common":"Kiribati"},"rus":{"official":"Независимой и суверенной Республики Кирибати","common":"Кирибати"},"slk":{"official":"Kiribatská republika","common":"Kiribati"},"spa":{"official":"República Independiente y Soberano de Kiribati","common":"Kiribati"},"fin":{"official":"Kiribatin tasavalta","common":"Kiribati"},"est":{"official":"Kiribati Vabariik","common":"Kiribati"},"zho":{"official":"基里巴斯共和国","common":"基里巴斯"}},"latlng":[1.41666666,173],"demonym":"I-Kiribati","landlocked":false,"borders":[],"area":811,"flag":"🇰🇮"},{"name":{"common":"Saint Kitts and Nevis","official":"Federation of Saint Christopher and Nevisa","native":{"eng":{"official":"Federation of Saint Christopher and Nevisa","common":"Saint Kitts and Nevis"}}},"tld":[".kn"],"cca2":"KN","ccn3":"659","cca3":"KNA","cioc":"SKN","independent":true,"status":"officially-assigned","currency":["XCD"],"callingCode":["1869"],"capital":["Basseterre"],"altSpellings":["KN","Federation of Saint Christopher and Nevis"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"deu":{"official":"Föderation von Saint Kitts und Nevisa","common":"Saint Christopher und Nevis"},"fra":{"official":"Fédération de Saint -Christophe-et Nevisa","common":"Saint-Christophe-et-Niévès"},"hrv":{"official":"Federacija Sv.Kristofora i Nevisa","common":"Sveti Kristof i Nevis"},"ita":{"official":"Federazione di Saint Christopher e Nevisa","common":"Saint Kitts e Nevis"},"jpn":{"official":"セントクリストファーNevisa連盟","common":"セントクリストファー・ネイビス"},"nld":{"official":"Federatie van Saint Kitts en Nevisa","common":"Saint Kitts en Nevis"},"por":{"official":"Federação de São Cristóvão e Nevisa","common":"São Cristóvão e Nevis"},"rus":{"official":"Федерация Сент-Кристофер и Nevisa","common":"Сент-Китс и Невис"},"slk":{"official":"Feder໡cia Svätého Krištofa a Nevisu","common":"Svätý Krištof a Nevis"},"spa":{"official":"Federación de San Cristóbal y Nevisa","common":"San Cristóbal y Nieves"},"fin":{"official":"Saint Christopherin ja Nevisin federaatio","common":"Saint Kitts ja Nevis"},"est":{"official":"Saint Kittsi ja Nevise Föderatsioon","common":"Saint Kitts ja Nevis"},"zho":{"official":"圣克里斯托弗和尼维斯联邦","common":"圣基茨和尼维斯"}},"latlng":[17.33333333,-62.75],"demonym":"Kittitian or Nevisian","landlocked":false,"borders":[],"area":261,"flag":"🇰🇳"},{"name":{"common":"South Korea","official":"Republic of Korea","native":{"kor":{"official":"한국","common":"대한민국"}}},"tld":[".kr",".한국"],"cca2":"KR","ccn3":"410","cca3":"KOR","cioc":"KOR","independent":true,"status":"officially-assigned","currency":["KRW"],"callingCode":["82"],"capital":["Seoul"],"altSpellings":["KR","Korea, Republic of","Republic of Korea"],"region":"Asia","subregion":"Eastern Asia","languages":{"kor":"Korean"},"translations":{"deu":{"official":"Republik Korea","common":"Südkorea"},"fra":{"official":"République de Corée","common":"Corée du Sud"},"hrv":{"official":"Republika Koreja","common":"Južna Koreja"},"ita":{"official":"Repubblica di Corea","common":"Corea del Sud"},"jpn":{"official":"大韓民国","common":"大韓民国"},"nld":{"official":"Republiek Korea","common":"Zuid-Korea"},"por":{"official":"República da Coreia","common":"Coreia do Sul"},"rus":{"official":"Республика Корея","common":"Южная Корея"},"slk":{"official":"Kórejská republika","common":"Južná Kórea"},"spa":{"official":"República de Corea","common":"Corea del Sur"},"fin":{"official":"Korean tasavalta","common":"Etelä-Korea"},"est":{"official":"Korea Vabariik","common":"Lõuna-Korea"},"zho":{"official":"大韩民国","common":"韩国"}},"latlng":[37,127.5],"demonym":"South Korean","landlocked":false,"borders":["PRK"],"area":100210,"flag":"🇰🇷"},{"name":{"common":"Kosovo","official":"Republic of Kosovo","native":{"sqi":{"official":"Republika e Kosovës","common":"Kosova"},"srp":{"official":"Република Косово","common":"Косово"}}},"tld":[],"cca2":"XK","ccn3":"","cca3":"UNK","cioc":"KOS","independent":null,"status":"user-assigned","currency":["EUR"],"callingCode":["383"],"capital":["Pristina"],"altSpellings":["XK","Република Косово"],"region":"Europe","subregion":"Eastern Europe","languages":{"sqi":"Albanian","srp":"Serbian"},"translations":{"deu":{"official":"Republik Kosovo","common":"Kosovo"},"fra":{"official":"République du Kosovo","common":"Kosovo"},"hrv":{"official":"Republika Kosovo","common":"Kosovo"},"ita":{"official":"Repubblica del Kosovo","common":"Kosovo"},"nld":{"official":"Republiek Kosovo","common":"Kosovo"},"por":{"official":"República do Kosovo","common":"Kosovo"},"rus":{"official":"Республика Косово","common":"Республика Косово"},"slk":{"official":"Republika Kosovo","common":"Kosovo"},"spa":{"official":"República de Kosovo","common":"Kosovo"},"fin":{"official":"Kosovon tasavalta","common":"Kosovo"},"est":{"official":"Kosovo Vabariik","common":"Kosovo"},"zho":{"official":"科索沃共和国","common":"科索沃"}},"latlng":[42.666667,21.166667],"demonym":"Kosovar","landlocked":true,"borders":["ALB","MKD","MNE","SRB"],"area":10908,"flag":"🇽🇰"},{"name":{"common":"Kuwait","official":"State of Kuwait","native":{"ara":{"official":"دولة الكويت","common":"الكويت"}}},"tld":[".kw"],"cca2":"KW","ccn3":"414","cca3":"KWT","cioc":"KUW","independent":true,"status":"officially-assigned","currency":["KWD"],"callingCode":["965"],"capital":["Kuwait City"],"altSpellings":["KW","State of Kuwait","Dawlat al-Kuwait"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Staat Kuwait","common":"Kuwait"},"fra":{"official":"État du Koweït","common":"Koweït"},"hrv":{"official":"Država Kuvajt","common":"Kuvajt"},"ita":{"official":"Stato del Kuwait","common":"Kuwait"},"jpn":{"official":"クウェート国","common":"クウェート"},"nld":{"official":"Staat Koeweit","common":"Koeweit"},"por":{"official":"Estado do Kuwait","common":"Kuwait"},"rus":{"official":"Государство Кувейт","common":"Кувейт"},"slk":{"official":"Kuvajtský štát","common":"Kuvajt"},"spa":{"official":"Estado de Kuwait","common":"Kuwait"},"fin":{"official":"Kuwaitin valtio","common":"Kuwait"},"est":{"official":"Kuveidi Riik","common":"Kuveit"},"zho":{"official":"科威特国","common":"科威特"}},"latlng":[29.5,45.75],"demonym":"Kuwaiti","landlocked":false,"borders":["IRQ","SAU"],"area":17818,"flag":"🇰🇼"},{"name":{"common":"Laos","official":"Lao People's Democratic Republic","native":{"lao":{"official":"ສາທາລະນະ ຊາທິປະໄຕ ຄົນລາວ ຂອງ","common":"ສປປລາວ"}}},"tld":[".la"],"cca2":"LA","ccn3":"418","cca3":"LAO","cioc":"LAO","independent":true,"status":"officially-assigned","currency":["LAK"],"callingCode":["856"],"capital":["Vientiane"],"altSpellings":["LA","Lao","Lao People's Democratic Republic","Sathalanalat Paxathipatai Paxaxon Lao"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"lao":"Lao"},"translations":{"deu":{"official":"Laos, Demokratische Volksrepublik","common":"Laos"},"fra":{"official":"République démocratique populaire lao","common":"Laos"},"hrv":{"official":"Narodna Demokratska Republika","common":"Laos"},"ita":{"official":"Repubblica democratica popolare del Laos","common":"Laos"},"jpn":{"official":"ラオス人民民主共和国","common":"ラオス人民民主共和国"},"nld":{"official":"Lao Democratische Volksrepubliek","common":"Laos"},"por":{"official":"Laos, República Democrática","common":"Laos"},"rus":{"official":"Лаосская Народно-Демократическая Республика","common":"Лаос"},"slk":{"official":"Laoská ľudovodemokratická republika","common":"Laos"},"spa":{"official":"República Democrática Popular Lao","common":"Laos"},"fin":{"official":"Laosin demokraattinen kansantasavalta","common":"Laos"},"est":{"official":"Laose Demokraatlik Rahvavabariik","common":"Laos"},"zho":{"official":"老挝人民民主共和国","common":"老挝"}},"latlng":[18,105],"demonym":"Laotian","landlocked":true,"borders":["MMR","KHM","CHN","THA","VNM"],"area":236800,"flag":"🇱🇦"},{"name":{"common":"Lebanon","official":"Lebanese Republic","native":{"ara":{"official":"الجمهورية اللبنانية","common":"لبنان"},"fra":{"official":"République libanaise","common":"Liban"}}},"tld":[".lb"],"cca2":"LB","ccn3":"422","cca3":"LBN","cioc":"LIB","independent":true,"status":"officially-assigned","currency":["LBP"],"callingCode":["961"],"capital":["Beirut"],"altSpellings":["LB","Lebanese Republic","Al-Jumhūrīyah Al-Libnānīyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic","fra":"French"},"translations":{"deu":{"official":"Libanesische Republik","common":"Libanon"},"fra":{"official":"République libanaise","common":"Liban"},"hrv":{"official":"Libanonska Republika","common":"Libanon"},"ita":{"official":"Repubblica libanese","common":"Libano"},"jpn":{"official":"レバノン共和国","common":"レバノン"},"nld":{"official":"Libanese Republiek","common":"Libanon"},"por":{"official":"República Libanesa","common":"Líbano"},"rus":{"official":"Ливанская Республика","common":"Ливан"},"slk":{"official":"Libanonská republika","common":"Libanon"},"spa":{"official":"República Libanesa","common":"Líbano"},"fin":{"official":"Libanonin tasavalta","common":"Libanon"},"est":{"official":"Liibanoni Vabariik","common":"Liibanon"},"zho":{"official":"黎巴嫩共和国","common":"黎巴嫩"}},"latlng":[33.83333333,35.83333333],"demonym":"Lebanese","landlocked":false,"borders":["ISR","SYR"],"area":10452,"flag":"🇱🇧"},{"name":{"common":"Liberia","official":"Republic of Liberia","native":{"eng":{"official":"Republic of Liberia","common":"Liberia"}}},"tld":[".lr"],"cca2":"LR","ccn3":"430","cca3":"LBR","cioc":"LBR","independent":true,"status":"officially-assigned","currency":["LRD"],"callingCode":["231"],"capital":["Monrovia"],"altSpellings":["LR","Republic of Liberia"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"deu":{"official":"Republik Liberia","common":"Liberia"},"fra":{"official":"République du Libéria","common":"Liberia"},"hrv":{"official":"Republika Liberija","common":"Liberija"},"ita":{"official":"Repubblica di Liberia","common":"Liberia"},"jpn":{"official":"リベリア共和国","common":"リベリア"},"nld":{"official":"Republiek Liberia","common":"Liberia"},"por":{"official":"República da Libéria","common":"Libéria"},"rus":{"official":"Республика Либерия","common":"Либерия"},"slk":{"official":"Libérijská republika","common":"Libéria"},"spa":{"official":"República de Liberia","common":"Liberia"},"fin":{"official":"Liberian tasavalta","common":"Liberia"},"est":{"official":"Libeeria Vabariik","common":"Libeeria"},"zho":{"official":"利比里亚共和国","common":"利比里亚"}},"latlng":[6.5,-9.5],"demonym":"Liberian","landlocked":false,"borders":["GIN","CIV","SLE"],"area":111369,"flag":"🇱🇷"},{"name":{"common":"Libya","official":"State of Libya","native":{"ara":{"official":"الدولة ليبيا","common":"‏ليبيا"}}},"tld":[".ly"],"cca2":"LY","ccn3":"434","cca3":"LBY","cioc":"LBA","independent":true,"status":"officially-assigned","currency":["LYD"],"callingCode":["218"],"capital":["Tripoli"],"altSpellings":["LY","State of Libya","Dawlat Libya"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Staat Libyen","common":"Libyen"},"fra":{"official":"Grande République arabe libyenne populaire et socialiste","common":"Libye"},"hrv":{"official":"Država Libiji","common":"Libija"},"ita":{"official":"Stato della Libia","common":"Libia"},"jpn":{"official":"リビアの国家","common":"リビア"},"nld":{"official":"Staat van Libië","common":"Libië"},"por":{"official":"Estado da Líbia","common":"Líbia"},"rus":{"official":"Государство Ливии","common":"Ливия"},"slk":{"official":"Líbya","common":"Líbya"},"spa":{"official":"Estado de Libia","common":"Libia"},"fin":{"official":"Libyan valtio","common":"Libya"},"est":{"official":"Liibüa","common":"Liibüa"},"zho":{"official":"利比亚国","common":"利比亚"}},"latlng":[25,17],"demonym":"Libyan","landlocked":false,"borders":["DZA","TCD","EGY","NER","SDN","TUN"],"area":1759540,"flag":"🇱🇾"},{"name":{"common":"Saint Lucia","official":"Saint Lucia","native":{"eng":{"official":"Saint Lucia","common":"Saint Lucia"}}},"tld":[".lc"],"cca2":"LC","ccn3":"662","cca3":"LCA","cioc":"LCA","independent":true,"status":"officially-assigned","currency":["XCD"],"callingCode":["1758"],"capital":["Castries"],"altSpellings":["LC"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"deu":{"official":"St. Lucia","common":"Saint Lucia"},"fra":{"official":"Sainte-Lucie","common":"Sainte-Lucie"},"hrv":{"official":"Sveta Lucija","common":"Sveta Lucija"},"ita":{"official":"Santa Lucia","common":"Santa Lucia"},"jpn":{"official":"セントルシア","common":"セントルシア"},"nld":{"official":"Saint Lucia","common":"Saint Lucia"},"por":{"official":"Santa Lúcia","common":"Santa Lúcia"},"rus":{"official":"Сент-Люсия","common":"Сент-Люсия"},"slk":{"official":"Svätá Lucia","common":"Svätá Lucia"},"spa":{"official":"Santa Lucía","common":"Santa Lucía"},"fin":{"official":"Saint Lucia","common":"Saint Lucia"},"est":{"official":"Saint Lucia","common":"Saint Lucia"},"zho":{"official":"圣卢西亚","common":"圣卢西亚"}},"latlng":[13.88333333,-60.96666666],"demonym":"Saint Lucian","landlocked":false,"borders":[],"area":616,"flag":"🇱🇨"},{"name":{"common":"Liechtenstein","official":"Principality of Liechtenstein","native":{"deu":{"official":"Fürstentum Liechtenstein","common":"Liechtenstein"}}},"tld":[".li"],"cca2":"LI","ccn3":"438","cca3":"LIE","cioc":"LIE","independent":true,"status":"officially-assigned","currency":["CHF"],"callingCode":["423"],"capital":["Vaduz"],"altSpellings":["LI","Principality of Liechtenstein","Fürstentum Liechtenstein"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German"},"translations":{"deu":{"official":"Fürstentum Liechtenstein","common":"Liechtenstein"},"fra":{"official":"Principauté du Liechtenstein","common":"Liechtenstein"},"hrv":{"official":"Kneževina Lihtenštajn","common":"Lihtenštajn"},"ita":{"official":"Principato del Liechtenstein","common":"Liechtenstein"},"jpn":{"official":"リヒテンシュタイン公国","common":"リヒテンシュタイン"},"nld":{"official":"Vorstendom Liechtenstein","common":"Liechtenstein"},"por":{"official":"Principado de Liechtenstein","common":"Liechtenstein"},"rus":{"official":"Княжество Лихтенштейн","common":"Лихтенштейн"},"slk":{"official":"Lichtenštajnské kniežatstvo","common":"Lichtenštajnsko"},"spa":{"official":"Principado de Liechtenstein","common":"Liechtenstein"},"fin":{"official":"Liechensteinin ruhtinaskunta","common":"Liechenstein"},"est":{"official":"Liechtensteini Vürstiriik","common":"Liechtenstein"},"zho":{"official":"列支敦士登公国","common":"列支敦士登"}},"latlng":[47.26666666,9.53333333],"demonym":"Liechtensteiner","landlocked":true,"borders":["AUT","CHE"],"area":160,"flag":"🇱🇮"},{"name":{"common":"Sri Lanka","official":"Democratic Socialist Republic of Sri Lanka","native":{"sin":{"official":"ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජය","common":"ශ්‍රී ලංකාව"},"tam":{"official":"இலங்கை சனநாயக சோசலிசக் குடியரசு","common":"இலங்கை"}}},"tld":[".lk",".இலங்கை",".ලංකා"],"cca2":"LK","ccn3":"144","cca3":"LKA","cioc":"SRI","independent":true,"status":"officially-assigned","currency":["LKR"],"callingCode":["94"],"capital":["Colombo"],"altSpellings":["LK","ilaṅkai","Democratic Socialist Republic of Sri Lanka"],"region":"Asia","subregion":"Southern Asia","languages":{"sin":"Sinhala","tam":"Tamil"},"translations":{"deu":{"official":"Demokratische Sozialistische Republik Sri Lanka","common":"Sri Lanka"},"fra":{"official":"République démocratique socialiste du Sri Lanka","common":"Sri Lanka"},"hrv":{"official":"Demokratska Socijalističke Republike Šri Lanke","common":"Šri Lanka"},"ita":{"official":"Repubblica democratica socialista dello Sri Lanka","common":"Sri Lanka"},"jpn":{"official":"スリランカ民主社会主義共和国","common":"スリランカ"},"nld":{"official":"Democratische Socialistische Republiek Sri Lanka","common":"Sri Lanka"},"por":{"official":"República Democrática Socialista do Sri Lanka","common":"Sri Lanka"},"rus":{"official":"Демократическая Социалистическая Республика Шри-Ланка","common":"Шри-Ланка"},"slk":{"official":"Srílanská demokratická socialistická republika","common":"Srí Lanka"},"spa":{"official":"República Democrática Socialista de Sri Lanka","common":"Sri Lanka"},"fin":{"official":"Sri Lankan demokraattinen sosialistinen tasavalta","common":"Sri Lanka"},"est":{"official":"Sri Lanka Demokraatlik Sotsialistlik Vabariik","common":"Sri Lanka"},"zho":{"official":"斯里兰卡民主社会主义共和国","common":"斯里兰卡"}},"latlng":[7,81],"demonym":"Sri Lankan","landlocked":false,"borders":["IND"],"area":65610,"flag":"🇱🇰"},{"name":{"common":"Lesotho","official":"Kingdom of Lesotho","native":{"eng":{"official":"Kingdom of Lesotho","common":"Lesotho"},"sot":{"official":"Kingdom of Lesotho","common":"Lesotho"}}},"tld":[".ls"],"cca2":"LS","ccn3":"426","cca3":"LSO","cioc":"LES","independent":true,"status":"officially-assigned","currency":["LSL","ZAR"],"callingCode":["266"],"capital":["Maseru"],"altSpellings":["LS","Kingdom of Lesotho","Muso oa Lesotho"],"region":"Africa","subregion":"Southern Africa","languages":{"eng":"English","sot":"Sotho"},"translations":{"deu":{"official":"Königreich Lesotho","common":"Lesotho"},"fra":{"official":"Royaume du Lesotho","common":"Lesotho"},"hrv":{"official":"Kraljevina Lesoto","common":"Lesoto"},"ita":{"official":"Regno del Lesotho","common":"Lesotho"},"jpn":{"official":"レソト王国","common":"レソト"},"nld":{"official":"Koninkrijk Lesotho","common":"Lesotho"},"por":{"official":"Reino do Lesoto","common":"Lesoto"},"rus":{"official":"Королевство Лесото","common":"Лесото"},"slk":{"official":"Lesothské kráľovstvo","common":"Lesotho"},"spa":{"official":"Reino de Lesotho","common":"Lesotho"},"fin":{"official":"Lesothon kuningaskunta","common":"Lesotho"},"est":{"official":"Lesotho Kuningriik","common":"Lesotho"},"zho":{"official":"莱索托王国","common":"莱索托"}},"latlng":[-29.5,28.5],"demonym":"Mosotho","landlocked":true,"borders":["ZAF"],"area":30355,"flag":"🇱🇸"},{"name":{"common":"Lithuania","official":"Republic of Lithuania","native":{"lit":{"official":"Lietuvos Respublikos","common":"Lietuva"}}},"tld":[".lt"],"cca2":"LT","ccn3":"440","cca3":"LTU","cioc":"LTU","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["370"],"capital":["Vilnius"],"altSpellings":["LT","Republic of Lithuania","Lietuvos Respublika"],"region":"Europe","subregion":"Northern Europe","languages":{"lit":"Lithuanian"},"translations":{"deu":{"official":"Republik Litauen","common":"Litauen"},"fra":{"official":"République de Lituanie","common":"Lituanie"},"hrv":{"official":"Republika Litva","common":"Litva"},"ita":{"official":"Repubblica di Lituania","common":"Lituania"},"jpn":{"official":"リトアニア共和国","common":"リトアニア"},"nld":{"official":"Republiek Litouwen","common":"Litouwen"},"por":{"official":"República da Lituânia","common":"Lituânia"},"rus":{"official":"Литовская Республика","common":"Литва"},"slk":{"official":"Litovská republika","common":"Litva"},"spa":{"official":"República de Lituania","common":"Lituania"},"fin":{"official":"Liettuan tasavalta","common":"Liettua"},"est":{"official":"Leedu Vabariik","common":"Leedu"},"zho":{"official":"立陶宛共和国","common":"立陶宛"}},"latlng":[56,24],"demonym":"Lithuanian","landlocked":false,"borders":["BLR","LVA","POL","RUS"],"area":65300,"flag":"🇱🇹"},{"name":{"common":"Luxembourg","official":"Grand Duchy of Luxembourg","native":{"deu":{"official":"Großherzogtum Luxemburg","common":"Luxemburg"},"fra":{"official":"Grand-Duché de Luxembourg","common":"Luxembourg"},"ltz":{"official":"Groussherzogtum Lëtzebuerg","common":"Lëtzebuerg"}}},"tld":[".lu"],"cca2":"LU","ccn3":"442","cca3":"LUX","cioc":"LUX","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["352"],"capital":["Luxembourg"],"altSpellings":["LU","Grand Duchy of Luxembourg","Grand-Duché de Luxembourg","Großherzogtum Luxemburg","Groussherzogtum Lëtzebuerg"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German","fra":"French","ltz":"Luxembourgish"},"translations":{"deu":{"official":"Großherzogtum Luxemburg,","common":"Luxemburg"},"fra":{"official":"Grand-Duché de Luxembourg","common":"Luxembourg"},"hrv":{"official":"Veliko Vojvodstvo Luksemburg","common":"Luksemburg"},"ita":{"official":"Granducato di Lussemburgo","common":"Lussemburgo"},"jpn":{"official":"ルクセンブルク大公国","common":"ルクセンブルク"},"nld":{"official":"Groothertogdom Luxemburg","common":"Luxemburg"},"por":{"official":"Grão-Ducado do Luxemburgo","common":"Luxemburgo"},"rus":{"official":"Великое Герцогство Люксембург","common":"Люксембург"},"slk":{"official":"Luxemburské veľkovojvodstvo","common":"Luxembursko"},"spa":{"official":"Gran Ducado de Luxemburgo","common":"Luxemburgo"},"fin":{"official":"Luxemburgin suurherttuakunta","common":"Luxemburg"},"est":{"official":"Luksemburgi Suurhertsogiriik","common":"Luksemburg"},"zho":{"official":"卢森堡大公国","common":"卢森堡"}},"latlng":[49.75,6.16666666],"demonym":"Luxembourger","landlocked":true,"borders":["BEL","FRA","DEU"],"area":2586,"flag":"🇱🇺"},{"name":{"common":"Latvia","official":"Republic of Latvia","native":{"lav":{"official":"Latvijas Republikas","common":"Latvija"}}},"tld":[".lv"],"cca2":"LV","ccn3":"428","cca3":"LVA","cioc":"LAT","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["371"],"capital":["Riga"],"altSpellings":["LV","Republic of Latvia","Latvijas Republika"],"region":"Europe","subregion":"Northern Europe","languages":{"lav":"Latvian"},"translations":{"deu":{"official":"Republik Lettland","common":"Lettland"},"fra":{"official":"République de Lettonie","common":"Lettonie"},"hrv":{"official":"Republika Latvija","common":"Latvija"},"ita":{"official":"Repubblica di Lettonia","common":"Lettonia"},"jpn":{"official":"ラトビア共和国","common":"ラトビア"},"nld":{"official":"Republiek Letland","common":"Letland"},"por":{"official":"República da Letónia","common":"Letónia"},"rus":{"official":"Латвийская Республика","common":"Латвия"},"slk":{"official":"Lotyšská republika","common":"Lotyšsko"},"spa":{"official":"República de Letonia","common":"Letonia"},"fin":{"official":"Latvian tasavalta","common":"Latvia"},"est":{"official":"Läti Vabariik","common":"Läti"},"zho":{"official":"拉脱维亚共和国","common":"拉脱维亚"}},"latlng":[57,25],"demonym":"Latvian","landlocked":false,"borders":["BLR","EST","LTU","RUS"],"area":64559,"flag":"🇱🇻"},{"name":{"common":"Macau","official":"Macao Special Administrative Region of the People's Republic of China","native":{"por":{"official":"Região Administrativa Especial de Macau da República Popular da China","common":"Macau"},"zho":{"official":"中华人民共和国澳门特别行政区","common":"澳门"}}},"tld":[".mo"],"cca2":"MO","ccn3":"446","cca3":"MAC","cioc":"","independent":false,"status":"officially-assigned","currency":["MOP"],"callingCode":["853"],"capital":[""],"altSpellings":["MO","澳门","Macao","Macao Special Administrative Region of the People's Republic of China","中華人民共和國澳門特別行政區","Região Administrativa Especial de Macau da República Popular da China"],"region":"Asia","subregion":"Eastern Asia","languages":{"por":"Portuguese","zho":"Chinese"},"translations":{"deu":{"official":"Sonderverwaltungsregion Macau der Volksrepublik China","common":"Macao"},"fra":{"official":"Région administrative spéciale de Macao de la République populaire de Chine","common":"Macao"},"hrv":{"official":"Makao Posebnog upravnog područjaNarodne Republike Kine","common":"Makao"},"ita":{"official":"Macao Regione amministrativa speciale della Repubblica Popolare Cinese","common":"Macao"},"jpn":{"official":"中華人民共和国マカオ特別行政区","common":"マカオ"},"nld":{"official":"Speciale Administratieve Regio Macau van de Volksrepubliek China","common":"Macao"},"por":{"official":"Macau Região Administrativa Especial da República Popular da China","common":"Macau"},"rus":{"official":"Специальный административный район Макао Китайской Народной Республики Китай","common":"Макао"},"slk":{"official":"Macao, Špeciàlna administratívna oblasŦ","common":"Macao"},"spa":{"official":"Macao, Región Administrativa Especial de la República Popular China","common":"Macao"},"fin":{"official":"Macaon Kiinan kansantasavallan erityishallintoalue","common":"Macao"},"est":{"official":"Macau erihalduspiirkond","common":"Macau"}},"latlng":[22.16666666,113.55],"demonym":"Chinese","landlocked":false,"borders":["CHN"],"area":30,"flag":"🇲🇴"},{"name":{"common":"Saint Martin","official":"Saint Martin","native":{"fra":{"official":"Saint-Martin","common":"Saint-Martin"}}},"tld":[".fr",".gp"],"cca2":"MF","ccn3":"663","cca3":"MAF","cioc":"","independent":false,"status":"officially-assigned","currency":["EUR"],"callingCode":["590"],"capital":["Marigot"],"altSpellings":["MF","Collectivity of Saint Martin","Collectivité de Saint-Martin","Saint Martin (French part)"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"deu":{"official":"St. Martin","common":"Saint Martin"},"fra":{"official":"Saint-Martin","common":"Saint-Martin"},"hrv":{"official":"Saint Martin","common":"Sveti Martin"},"ita":{"official":"saint Martin","common":"Saint Martin"},"jpn":{"official":"サンマルタン島","common":"サン・マルタン（フランス領）"},"nld":{"official":"Saint Martin","common":"Saint-Martin"},"por":{"official":"saint Martin","common":"São Martinho"},"rus":{"official":"Сен-Мартен","common":"Сен-Мартен"},"slk":{"official":"Saint-Martin","common":"Saint-Martin"},"spa":{"official":"Saint Martin","common":"Saint Martin"},"fin":{"official":"Saint-Martin","common":"Saint-Martin"},"est":{"official":"Saint-Martini ühendus","common":"Saint-Martin"},"zho":{"official":"圣马丁","common":"圣马丁"}},"latlng":[18.08333333,-63.95],"demonym":"Saint Martin Islander","landlocked":false,"borders":["SXM"],"area":53,"flag":"🇲🇫"},{"name":{"common":"Morocco","official":"Kingdom of Morocco","native":{"ara":{"official":"المملكة المغربية","common":"المغرب"},"ber":{"official":"ⵜⴰⴳⵍⴷⵉⵜ ⵏ ⵍⵎⵖⵔⵉⴱ","common":"ⵍⵎⴰⵖⵔⵉⴱ"}}},"tld":[".ma","المغرب."],"cca2":"MA","ccn3":"504","cca3":"MAR","cioc":"MAR","independent":true,"status":"officially-assigned","currency":["MAD"],"callingCode":["212"],"capital":["Rabat"],"altSpellings":["MA","Kingdom of Morocco","Al-Mamlakah al-Maġribiyah"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic","ber":"Berber"},"translations":{"deu":{"official":"Königreich Marokko","common":"Marokko"},"fra":{"official":"Royaume du Maroc","common":"Maroc"},"hrv":{"official":"Kraljevina Maroko","common":"Maroko"},"ita":{"official":"Regno del Marocco","common":"Marocco"},"jpn":{"official":"モロッコ王国","common":"モロッコ"},"nld":{"official":"Koninkrijk Marokko","common":"Marokko"},"por":{"official":"Reino de Marrocos","common":"Marrocos"},"rus":{"official":"Королевство Марокко","common":"Марокко"},"slk":{"official":"Marocké kniežatstvo","common":"Maroko"},"spa":{"official":"Reino de Marruecos","common":"Marruecos"},"fin":{"official":"Marokon kuningaskunta","common":"Marokko"},"est":{"official":"Maroko Kuningriik","common":"Maroko"},"zho":{"official":"摩洛哥王国","common":"摩洛哥"}},"latlng":[32,-5],"demonym":"Moroccan","landlocked":false,"borders":["DZA","ESH","ESP"],"area":446550,"flag":"🇲🇦"},{"name":{"common":"Monaco","official":"Principality of Monaco","native":{"fra":{"official":"Principauté de Monaco","common":"Monaco"}}},"tld":[".mc"],"cca2":"MC","ccn3":"492","cca3":"MCO","cioc":"MON","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["377"],"capital":["Monaco"],"altSpellings":["MC","Principality of Monaco","Principauté de Monaco"],"region":"Europe","subregion":"Western Europe","languages":{"fra":"French"},"translations":{"deu":{"official":"Fürstentum Monaco","common":"Monaco"},"fra":{"official":"Principauté de Monaco","common":"Monaco"},"hrv":{"official":"Kneževina Monako","common":"Monako"},"ita":{"official":"Principato di Monaco","common":"Principato di Monaco"},"jpn":{"official":"モナコ公国","common":"モナコ"},"nld":{"official":"Vorstendom Monaco","common":"Monaco"},"por":{"official":"Principado do Mónaco","common":"Mónaco"},"rus":{"official":"Княжество Монако","common":"Монако"},"slk":{"official":"Monacké kniežatstvo","common":"Monako"},"spa":{"official":"Principado de Mónaco","common":"Mónaco"},"fin":{"official":"Monacon ruhtinaskunta","common":"Monaco"},"est":{"official":"Monaco Vürstiriik","common":"Monaco"},"zho":{"official":"摩纳哥公国","common":"摩纳哥"}},"latlng":[43.73333333,7.4],"demonym":"Monegasque","landlocked":false,"borders":["FRA"],"area":2.02,"flag":"🇲🇨"},{"name":{"common":"Moldova","official":"Republic of Moldova","native":{"ron":{"official":"Republica Moldova","common":"Moldova"}}},"tld":[".md"],"cca2":"MD","ccn3":"498","cca3":"MDA","cioc":"MDA","independent":true,"status":"officially-assigned","currency":["MDL"],"callingCode":["373"],"capital":["Chișinău"],"altSpellings":["MD","Moldova, Republic of","Republic of Moldova","Republica Moldova"],"region":"Europe","subregion":"Eastern Europe","languages":{"ron":"Moldavian"},"translations":{"deu":{"official":"Republik Moldau","common":"Moldawie"},"fra":{"official":"République de Moldavie","common":"Moldavie"},"hrv":{"official":"Moldavija","common":"Moldova"},"ita":{"official":"Repubblica di Moldova","common":"Moldavia"},"jpn":{"official":"モルドバ共和国","common":"モルドバ共和国"},"nld":{"official":"Republiek Moldavië","common":"Moldavië"},"por":{"official":"República da Moldávia","common":"Moldávia"},"rus":{"official":"Молдова","common":"Молдавия"},"slk":{"official":"Moldavská republika","common":"Moldavsko"},"spa":{"official":"República de Moldova","common":"Moldavia"},"fin":{"official":"Moldovan tasavalta","common":"Moldova"},"est":{"official":"Moldova Vabariik","common":"Moldova"},"zho":{"official":"摩尔多瓦共和国","common":"摩尔多瓦"}},"latlng":[47,29],"demonym":"Moldovan","landlocked":true,"borders":["ROU","UKR"],"area":33846,"flag":"🇲🇩"},{"name":{"common":"Madagascar","official":"Republic of Madagascar","native":{"fra":{"official":"République de Madagascar","common":"Madagascar"},"mlg":{"official":"Repoblikan'i Madagasikara","common":"Madagasikara"}}},"tld":[".mg"],"cca2":"MG","ccn3":"450","cca3":"MDG","cioc":"MAD","independent":true,"status":"officially-assigned","currency":["MGA"],"callingCode":["261"],"capital":["Antananarivo"],"altSpellings":["MG","Republic of Madagascar","Repoblikan'i Madagasikara","République de Madagascar"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French","mlg":"Malagasy"},"translations":{"deu":{"official":"Republik Madagaskar","common":"Madagaskar"},"fra":{"official":"République de Madagascar","common":"Madagascar"},"hrv":{"official":"Republika Madagaskar","common":"Madagaskar"},"ita":{"official":"Repubblica del Madagascar","common":"Madagascar"},"jpn":{"official":"マダガスカル共和国","common":"マダガスカル"},"nld":{"official":"Republiek Madagaskar","common":"Madagaskar"},"por":{"official":"República de Madagáscar","common":"Madagáscar"},"rus":{"official":"Республика Мадагаскар","common":"Мадагаскар"},"slk":{"official":"Madagaskarská republika","common":"Madagaskar"},"spa":{"official":"República de Madagascar","common":"Madagascar"},"fin":{"official":"Madagaskarin tasavalta","common":"Madagaskar"},"est":{"official":"Madagaskari Vabariik","common":"Madagaskar"},"zho":{"official":"马达加斯加共和国","common":"马达加斯加"}},"latlng":[-20,47],"demonym":"Malagasy","landlocked":false,"borders":[],"area":587041,"flag":"🇲🇬"},{"name":{"common":"Maldives","official":"Republic of the Maldives","native":{"div":{"official":"ދިވެހިރާއްޖޭގެ ޖުމްހޫރިއްޔާ","common":"ދިވެހިރާއްޖޭގެ"}}},"tld":[".mv"],"cca2":"MV","ccn3":"462","cca3":"MDV","cioc":"MDV","independent":true,"status":"officially-assigned","currency":["MVR"],"callingCode":["960"],"capital":["Malé"],"altSpellings":["MV","Maldive Islands","Republic of the Maldives","Dhivehi Raajjeyge Jumhooriyya"],"region":"Asia","subregion":"Southern Asia","languages":{"div":"Maldivian"},"translations":{"deu":{"official":"Republik Malediven","common":"Malediven"},"fra":{"official":"République des Maldives","common":"Maldives"},"hrv":{"official":"Republika Maldivi","common":"Maldivi"},"ita":{"official":"Repubblica delle Maldive","common":"Maldive"},"jpn":{"official":"モルディブ共和国","common":"モルディブ"},"nld":{"official":"Republiek van de Malediven","common":"Maldiven"},"por":{"official":"República das Maldivas","common":"Maldivas"},"spa":{"official":"República de las Maldivas","common":"Maldivas"},"rus":{"official":"Республика Мальдивы","common":"Мальдивы"},"slk":{"official":"Maldivská republika","common":"Maldivy"},"fin":{"official":"Malediivien tasavalta","common":"Malediivit"},"est":{"official":"Maldiivi Vabariik","common":"Maldiivid"},"zho":{"official":"马尔代夫共和国","common":"马尔代夫"}},"latlng":[3.25,73],"demonym":"Maldivan","landlocked":false,"borders":[],"area":300,"flag":"🇲🇻"},{"name":{"common":"Mexico","official":"United Mexican States","native":{"spa":{"official":"Estados Unidos Mexicanos","common":"México"}}},"tld":[".mx"],"cca2":"MX","ccn3":"484","cca3":"MEX","cioc":"MEX","independent":true,"status":"officially-assigned","currency":["MXN"],"callingCode":["52"],"capital":["Mexico City"],"altSpellings":["MX","Mexicanos","United Mexican States","Estados Unidos Mexicanos"],"region":"Americas","subregion":"Northern America","languages":{"spa":"Spanish"},"translations":{"deu":{"official":"Vereinigte Mexikanische Staaten","common":"Mexiko"},"fra":{"official":"États-Unis du Mexique","common":"Mexique"},"hrv":{"official":"Sjedinjene Meksičke Države","common":"Meksiko"},"ita":{"official":"Stati Uniti del Messico","common":"Messico"},"jpn":{"official":"メキシコ合衆国","common":"メキシコ"},"nld":{"official":"Verenigde Mexicaanse Staten","common":"Mexico"},"por":{"official":"Estados Unidos Mexicanos","common":"México"},"rus":{"official":"Мексиканские Соединённые Штаты","common":"Мексика"},"slk":{"official":"Spojené štášy mexické","common":"Mexiko"},"spa":{"official":"Estados Unidos Mexicanos","common":"México"},"fin":{"official":"Meksikon yhdysvallat","common":"Meksiko"},"est":{"official":"Mehhiko Ühendriigid","common":"Mehhiko"},"zho":{"official":"墨西哥合众国","common":"墨西哥"}},"latlng":[23,-102],"demonym":"Mexican","landlocked":false,"borders":["BLZ","GTM","USA"],"area":1964375,"flag":"🇲🇽"},{"name":{"common":"Marshall Islands","official":"Republic of the Marshall Islands","native":{"eng":{"official":"Republic of the Marshall Islands","common":"Marshall Islands"},"mah":{"official":"Republic of the Marshall Islands","common":"M̧ajeļ"}}},"tld":[".mh"],"cca2":"MH","ccn3":"584","cca3":"MHL","cioc":"MHL","independent":true,"status":"officially-assigned","currency":["USD"],"callingCode":["692"],"capital":["Majuro"],"altSpellings":["MH","Republic of the Marshall Islands","Aolepān Aorōkin M̧ajeļ"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","mah":"Marshallese"},"translations":{"deu":{"official":"Republik der Marshall-Inseln","common":"Marshallinseln"},"fra":{"official":"République des Îles Marshall","common":"Îles Marshall"},"hrv":{"official":"Republika Maršalovi Otoci","common":"Maršalovi Otoci"},"ita":{"official":"Repubblica delle Isole Marshall","common":"Isole Marshall"},"jpn":{"official":"マーシャル諸島共和国","common":"マーシャル諸島"},"nld":{"official":"Republiek van de Marshall-eilanden","common":"Marshalleilanden"},"por":{"official":"República das Ilhas Marshall","common":"Ilhas Marshall"},"rus":{"official":"Республика Маршалловы острова","common":"Маршалловы Острова"},"slk":{"official":"Republika Marshallových ostrovov","common":"Marshallove ostrovy"},"spa":{"official":"República de las Islas Marshall","common":"Islas Marshall"},"fin":{"official":"Marshallinsaarten tasavalta","common":"Marshallinsaaret"},"est":{"official":"Marshalli Saarte Vabariik","common":"Marshalli Saared"},"zho":{"official":"马绍尔群岛共和国","common":"马绍尔群岛"}},"latlng":[9,168],"demonym":"Marshallese","landlocked":false,"borders":[],"area":181,"flag":"🇲🇭"},{"name":{"common":"Macedonia","official":"Republic of Macedonia","native":{"mkd":{"official":"Република Македонија","common":"Македонија"}}},"tld":[".mk"],"cca2":"MK","ccn3":"807","cca3":"MKD","cioc":"MKD","independent":true,"status":"officially-assigned","currency":["MKD"],"callingCode":["389"],"capital":["Skopje"],"altSpellings":["MK","Macedonia, the Former Yugoslav Republic of","Republic of Macedonia","Република Македонија"],"region":"Europe","subregion":"Southern Europe","languages":{"mkd":"Macedonian"},"translations":{"deu":{"official":"Republik Mazedonien","common":"Mazedonien"},"fra":{"official":"République de Macédoine","common":"Macédoine"},"hrv":{"official":"Republika Makedonija","common":"Makedonija"},"ita":{"official":"Repubblica di Macedonia","common":"Macedonia"},"jpn":{"official":"マケドニア共和国","common":"マケドニア旧ユーゴスラビア共和国"},"nld":{"official":"Republic of Macedonia","common":"Macedonië"},"por":{"official":"República da Macedónia","common":"Macedónia"},"rus":{"official":"Республика Македония","common":"Республика Македония"},"slk":{"official":"Macedónska republika","common":"Macedónsko"},"spa":{"official":"República de Macedonia","common":"Macedonia"},"fin":{"official":"Makedonian tasavalta","common":"Makedonia"},"est":{"official":"Makedoonia Vabariik","common":"Makedoonia"},"zho":{"official":"马其顿共和国","common":"马其顿"}},"latlng":[41.83333333,22],"demonym":"Macedonian","landlocked":true,"borders":["ALB","BGR","GRC","UNK","SRB"],"area":25713,"flag":"🇲🇰"},{"name":{"common":"Mali","official":"Republic of Mali","native":{"fra":{"official":"République du Mali","common":"Mali"}}},"tld":[".ml"],"cca2":"ML","ccn3":"466","cca3":"MLI","cioc":"MLI","independent":true,"status":"officially-assigned","currency":["XOF"],"callingCode":["223"],"capital":["Bamako"],"altSpellings":["ML","Republic of Mali","République du Mali"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"deu":{"official":"Republik Mali","common":"Mali"},"fra":{"official":"République du Mali","common":"Mali"},"hrv":{"official":"Republika Mali","common":"Mali"},"ita":{"official":"Repubblica del Mali","common":"Mali"},"jpn":{"official":"マリ共和国","common":"マリ"},"nld":{"official":"Republiek Mali","common":"Mali"},"por":{"official":"República do Mali","common":"Mali"},"rus":{"official":"Республика Мали","common":"Мали"},"slk":{"official":"Malijská republika","common":"Mali"},"spa":{"official":"República de Malí","common":"Mali"},"fin":{"official":"Malin tasavalta","common":"Mali"},"est":{"official":"Mali Vabariik","common":"Mali"},"zho":{"official":"马里共和国","common":"马里"}},"latlng":[17,-4],"demonym":"Malian","landlocked":true,"borders":["DZA","BFA","GIN","CIV","MRT","NER","SEN"],"area":1240192,"flag":"🇲🇱"},{"name":{"common":"Malta","official":"Republic of Malta","native":{"eng":{"official":"Republic of Malta","common":"Malta"},"mlt":{"official":"Repubblika ta ' Malta","common":"Malta"}}},"tld":[".mt"],"cca2":"MT","ccn3":"470","cca3":"MLT","cioc":"MLT","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["356"],"capital":["Valletta"],"altSpellings":["MT","Republic of Malta","Repubblika ta' Malta"],"region":"Europe","subregion":"Southern Europe","languages":{"eng":"English","mlt":"Maltese"},"translations":{"deu":{"official":"Republik Malta","common":"Malta"},"fra":{"official":"République de Malte","common":"Malte"},"hrv":{"official":"Republika Malta","common":"Malta"},"ita":{"official":"Repubblica di Malta","common":"Malta"},"jpn":{"official":"マルタ共和国","common":"マルタ"},"nld":{"official":"Republiek Malta","common":"Malta"},"por":{"official":"República de Malta","common":"Malta"},"rus":{"official":"Республика Мальта","common":"Мальта"},"slk":{"official":"Maltská republika","common":"Malta"},"spa":{"official":"República de Malta","common":"Malta"},"fin":{"official":"Maltan tasavalta","common":"Malta"},"est":{"official":"Malta Vabariik","common":"Malta"},"zho":{"official":"马耳他共和国","common":"马耳他"}},"latlng":[35.83333333,14.58333333],"demonym":"Maltese","landlocked":false,"borders":[],"area":316,"flag":"🇲🇹"},{"name":{"common":"Myanmar","official":"Republic of the Union of Myanmar","native":{"mya":{"official":"ပြည်ထောင်စု သမ္မတ မြန်မာနိုင်ငံတော်","common":"မြန်မာ"}}},"tld":[".mm"],"cca2":"MM","ccn3":"104","cca3":"MMR","cioc":"MYA","independent":true,"status":"officially-assigned","currency":["MMK"],"callingCode":["95"],"capital":["Naypyidaw"],"altSpellings":["MM","Burma","Republic of the Union of Myanmar","Pyidaunzu Thanmăda Myăma Nainngandaw"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"mya":"Burmese"},"translations":{"deu":{"official":"Republik der Union von Myanmar","common":"Myanmar"},"fra":{"official":"République de l'Union du Myanmar","common":"Birmanie"},"hrv":{"official":"Republika Unije Mijanmar","common":"Mijanmar"},"ita":{"official":"Repubblica dell'Unione di Myanmar","common":"Birmania"},"jpn":{"official":"ミャンマー連邦共和国","common":"ミャンマー"},"nld":{"official":"Republiek van de Unie van Myanmar","common":"Myanmar"},"por":{"official":"República da União de Myanmar","common":"Myanmar"},"rus":{"official":"Республика Союза Мьянма","common":"Мьянма"},"slk":{"official":"Mjanmarská zväzová republika","common":"Mjanmarsko"},"spa":{"official":"República de la Unión de Myanmar","common":"Myanmar"},"fin":{"official":"Myanmarin liiton tasavalta","common":"Myanmar"},"est":{"official":"Myanmari Liidu Vabariik","common":"Myanmar"},"zho":{"official":"缅甸联邦共和国","common":"缅甸"}},"latlng":[22,98],"demonym":"Bamar","landlocked":false,"borders":["BGD","CHN","IND","LAO","THA"],"area":676578,"flag":"🇲🇲"},{"name":{"common":"Montenegro","official":"Montenegro","native":{"srp":{"official":"Црна Гора","common":"Црна Гора"}}},"tld":[".me"],"cca2":"ME","ccn3":"499","cca3":"MNE","cioc":"MNE","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["382"],"capital":["Podgorica"],"altSpellings":["ME","Crna Gora"],"region":"Europe","subregion":"Southern Europe","languages":{"srp":"Montenegrin"},"translations":{"deu":{"official":"Montenegro","common":"Montenegro"},"fra":{"official":"Monténégro","common":"Monténégro"},"hrv":{"official":"Crna Gora","common":"Crna Gora"},"ita":{"official":"Montenegro","common":"Montenegro"},"jpn":{"official":"モンテネグロ","common":"モンテネグロ"},"nld":{"official":"Montenegro","common":"Montenegro"},"por":{"official":"Montenegro","common":"Montenegro"},"rus":{"official":"Черногория","common":"Черногория"},"slk":{"official":"Čierna Hora","common":"Čierna Hora"},"spa":{"official":"Montenegro","common":"Montenegro"},"fin":{"official":"Montenegro","common":"Montenegro"},"est":{"official":"Montenegro","common":"Montenegro"},"zho":{"official":"黑山","common":"黑山"}},"latlng":[42.5,19.3],"demonym":"Montenegrin","landlocked":false,"borders":["ALB","BIH","HRV","UNK","SRB"],"area":13812,"flag":"🇲🇪"},{"name":{"common":"Mongolia","official":"Mongolia","native":{"mon":{"official":"Монгол улс","common":"Монгол улс"}}},"tld":[".mn"],"cca2":"MN","ccn3":"496","cca3":"MNG","cioc":"MGL","independent":true,"status":"officially-assigned","currency":["MNT"],"callingCode":["976"],"capital":["Ulan Bator"],"altSpellings":["MN"],"region":"Asia","subregion":"Eastern Asia","languages":{"mon":"Mongolian"},"translations":{"deu":{"official":"Mongolei","common":"Mongolei"},"fra":{"official":"Mongolie","common":"Mongolie"},"hrv":{"official":"Mongolija","common":"Mongolija"},"ita":{"official":"Mongolia","common":"Mongolia"},"jpn":{"official":"モンゴル","common":"モンゴル"},"nld":{"official":"Mongolië","common":"Mongolië"},"por":{"official":"Mongólia","common":"Mongólia"},"rus":{"official":"Монголия","common":"Монголия"},"slk":{"official":"Mongolsko","common":"Mongolsko"},"spa":{"official":"Mongolia","common":"Mongolia"},"fin":{"official":"Mongolian tasavalta","common":"Mongolia"},"est":{"official":"Mongoolia","common":"Mongoolia"},"zho":{"official":"蒙古","common":"蒙古"}},"latlng":[46,105],"demonym":"Mongolian","landlocked":true,"borders":["CHN","RUS"],"area":1564110,"flag":"🇲🇳"},{"name":{"common":"Northern Mariana Islands","official":"Commonwealth of the Northern Mariana Islands","native":{"cal":{"official":"Commonwealth of the Northern Mariana Islands","common":"Northern Mariana Islands"},"cha":{"official":"Sankattan Siha Na Islas Mariånas","common":"Na Islas Mariånas"},"eng":{"official":"Commonwealth of the Northern Mariana Islands","common":"Northern Mariana Islands"}}},"tld":[".mp"],"cca2":"MP","ccn3":"580","cca3":"MNP","cioc":"","independent":false,"status":"officially-assigned","currency":["USD"],"callingCode":["1670"],"capital":["Saipan"],"altSpellings":["MP","Commonwealth of the Northern Mariana Islands","Sankattan Siha Na Islas Mariånas"],"region":"Oceania","subregion":"Micronesia","languages":{"cal":"Carolinian","cha":"Chamorro","eng":"English"},"translations":{"deu":{"official":"Commonwealth der Nördlichen Marianen","common":"Nördliche Marianen"},"fra":{"official":"Commonwealth des îles Mariannes du Nord","common":"Îles Mariannes du Nord"},"hrv":{"official":"Zajednica je Sjeverni Marijanski otoci","common":"Sjevernomarijanski otoci"},"ita":{"official":"Commonwealth delle Isole Marianne Settentrionali","common":"Isole Marianne Settentrionali"},"jpn":{"official":"北マリアナ諸島","common":"北マリアナ諸島"},"nld":{"official":"Commonwealth van de Noordelijke Marianen","common":"Noordelijke Marianeneilanden"},"por":{"official":"Comunidade das Ilhas Marianas do Norte","common":"Marianas Setentrionais"},"rus":{"official":"Содружество Северных Марианских островов","common":"Северные Марианские острова"},"slk":{"official":"Spoločenstvo ostrovov Severné Mariány","common":"Severné Mariány"},"spa":{"official":"Mancomunidad de las Islas Marianas del Norte","common":"Islas Marianas del Norte"},"fin":{"official":"Pohjois-Mariaanit","common":"Pohjois-Mariaanit"},"est":{"official":"Põhja-Mariaani Ühendus","common":"Põhja-Mariaanid"},"zho":{"official":"北马里亚纳群岛","common":"北马里亚纳群岛"}},"latlng":[15.2,145.75],"demonym":"American","landlocked":false,"borders":[],"area":464,"flag":"🇲🇵"},{"name":{"common":"Mozambique","official":"Republic of Mozambique","native":{"por":{"official":"República de Moçambique","common":"Moçambique"}}},"tld":[".mz"],"cca2":"MZ","ccn3":"508","cca3":"MOZ","cioc":"MOZ","independent":true,"status":"officially-assigned","currency":["MZN"],"callingCode":["258"],"capital":["Maputo"],"altSpellings":["MZ","Republic of Mozambique","República de Moçambique"],"region":"Africa","subregion":"Eastern Africa","languages":{"por":"Portuguese"},"translations":{"deu":{"official":"Republik Mosambik","common":"Mosambik"},"fra":{"official":"République du Mozambique","common":"Mozambique"},"hrv":{"official":"Republika Mozambiku","common":"Mozambik"},"ita":{"official":"Repubblica del Mozambico","common":"Mozambico"},"jpn":{"official":"モザンビーク共和国","common":"モザンビーク"},"nld":{"official":"Republiek Mozambique","common":"Mozambique"},"por":{"official":"República de Moçambique","common":"Moçambique"},"rus":{"official":"Республика Мозамбик","common":"Мозамбик"},"slk":{"official":"Mozambická republika","common":"Mozambik"},"spa":{"official":"República de Mozambique","common":"Mozambique"},"fin":{"official":"Mosambikin tasavalta","common":"Mosambik"},"est":{"official":"Mosambiigi Vabariik","common":"Mosambiik"},"zho":{"official":"莫桑比克共和国","common":"莫桑比克"}},"latlng":[-18.25,35],"demonym":"Mozambican","landlocked":false,"borders":["MWI","ZAF","SWZ","TZA","ZMB","ZWE"],"area":801590,"flag":"🇲🇿"},{"name":{"common":"Mauritania","official":"Islamic Republic of Mauritania","native":{"ara":{"official":"الجمهورية الإسلامية الموريتانية","common":"موريتانيا"}}},"tld":[".mr"],"cca2":"MR","ccn3":"478","cca3":"MRT","cioc":"MTN","independent":true,"status":"officially-assigned","currency":["MRO"],"callingCode":["222"],"capital":["Nouakchott"],"altSpellings":["MR","Islamic Republic of Mauritania","al-Jumhūriyyah al-ʾIslāmiyyah al-Mūrītāniyyah"],"region":"Africa","subregion":"Western Africa","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Islamische Republik Mauretanien","common":"Mauretanien"},"fra":{"official":"République islamique de Mauritanie","common":"Mauritanie"},"hrv":{"official":"Islamska Republika Mauritanija","common":"Mauritanija"},"ita":{"official":"Repubblica islamica di Mauritania","common":"Mauritania"},"jpn":{"official":"モーリタニア·イスラム共和国","common":"モーリタニア"},"nld":{"official":"Islamitische Republiek Mauritanië","common":"Mauritanië"},"por":{"official":"República Islâmica da Mauritânia","common":"Mauritânia"},"rus":{"official":"Исламская Республика Мавритания","common":"Мавритания"},"slk":{"official":"Mauritánska islamská republika","common":"Mauritánia"},"spa":{"official":"República Islámica de Mauritania","common":"Mauritania"},"fin":{"official":"Mauritanian islamilainen tasavalta","common":"Mauritania"},"est":{"official":"Mauritaania Islamivabariik","common":"Mauritaania"},"zho":{"official":"毛里塔尼亚伊斯兰共和国","common":"毛里塔尼亚"}},"latlng":[20,-12],"demonym":"Mauritanian","landlocked":false,"borders":["DZA","MLI","SEN","ESH"],"area":1030700,"flag":"🇲🇷"},{"name":{"common":"Montserrat","official":"Montserrat","native":{"eng":{"official":"Montserrat","common":"Montserrat"}}},"tld":[".ms"],"cca2":"MS","ccn3":"500","cca3":"MSR","cioc":"","independent":false,"status":"officially-assigned","currency":["XCD"],"callingCode":["1664"],"capital":["Plymouth"],"altSpellings":["MS"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"deu":{"official":"Montserrat","common":"Montserrat"},"fra":{"official":"Montserrat","common":"Montserrat"},"hrv":{"official":"Montserrat","common":"Montserrat"},"ita":{"official":"Montserrat","common":"Montserrat"},"jpn":{"official":"モントセラト","common":"モントセラト"},"nld":{"official":"Montserrat","common":"Montserrat"},"por":{"official":"Montserrat","common":"Montserrat"},"rus":{"official":"Монтсеррат","common":"Монтсеррат"},"slk":{"official":"Montserrat","common":"Montserrat"},"spa":{"official":"Montserrat","common":"Montserrat"},"fin":{"official":"Montserrat","common":"Montserrat"},"est":{"official":"Montserrat","common":"Montserrat"},"zho":{"official":"蒙特塞拉特","common":"蒙特塞拉特"}},"latlng":[16.75,-62.2],"demonym":"Montserratian","landlocked":false,"borders":[],"area":102,"flag":"🇲🇸"},{"name":{"common":"Martinique","official":"Martinique","native":{"fra":{"official":"Martinique","common":"Martinique"}}},"tld":[".mq"],"cca2":"MQ","ccn3":"474","cca3":"MTQ","cioc":"","independent":false,"status":"officially-assigned","currency":["EUR"],"callingCode":["596"],"capital":["Fort-de-France"],"altSpellings":["MQ"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"deu":{"official":"Martinique","common":"Martinique"},"fra":{"official":"Martinique","common":"Martinique"},"hrv":{"official":"Martinique","common":"Martinique"},"ita":{"official":"Martinique","common":"Martinica"},"jpn":{"official":"マルティニーク島","common":"マルティニーク"},"nld":{"official":"Martinique","common":"Martinique"},"por":{"official":"Martinique","common":"Martinica"},"rus":{"official":"Мартиника","common":"Мартиника"},"spa":{"official":"Martinica","common":"Martinica"},"slk":{"official":"Martinique","common":"Martinique"},"fin":{"official":"Martinique","common":"Martinique"},"est":{"official":"Martinique’i departemang","common":"Martinique"},"zho":{"official":"马提尼克","common":"马提尼克"}},"latlng":[14.666667,-61],"demonym":"French","landlocked":false,"borders":[],"area":1128,"flag":"🇲🇶"},{"name":{"common":"Mauritius","official":"Republic of Mauritius","native":{"eng":{"official":"Republic of Mauritius","common":"Mauritius"},"fra":{"official":"République de Maurice","common":"Maurice"},"mfe":{"official":"Republik Moris","common":"Moris"}}},"tld":[".mu"],"cca2":"MU","ccn3":"480","cca3":"MUS","cioc":"MRI","independent":true,"status":"officially-assigned","currency":["MUR"],"callingCode":["230"],"capital":["Port Louis"],"altSpellings":["MU","Republic of Mauritius","République de Maurice"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","fra":"French","mfe":"Mauritian Creole"},"translations":{"deu":{"official":"Republik Mauritius","common":"Mauritius"},"fra":{"official":"République de Maurice","common":"Île Maurice"},"hrv":{"official":"Republika Mauricijus","common":"Mauricijus"},"ita":{"official":"Repubblica di Mauritius","common":"Mauritius"},"jpn":{"official":"モーリシャス共和国","common":"モーリシャス"},"nld":{"official":"Republiek Mauritius","common":"Mauritius"},"por":{"official":"República das Maurícias","common":"Maurício"},"rus":{"official":"Республика Маврикий","common":"Маврикий"},"slk":{"official":"Maurícijská republika","common":"Maurícius"},"spa":{"official":"República de Mauricio","common":"Mauricio"},"fin":{"official":"Mauritiuksen tasavalta","common":"Mauritius"},"est":{"official":"Mauritiuse Vabariik","common":"Mauritius"},"zho":{"official":"毛里求斯共和国","common":"毛里求斯"}},"latlng":[-20.28333333,57.55],"demonym":"Mauritian","landlocked":false,"borders":[],"area":2040,"flag":"🇲🇺"},{"name":{"common":"Malawi","official":"Republic of Malawi","native":{"eng":{"official":"Republic of Malawi","common":"Malawi"},"nya":{"official":"Chalo cha Malawi, Dziko la Malaŵi","common":"Malaŵi"}}},"tld":[".mw"],"cca2":"MW","ccn3":"454","cca3":"MWI","cioc":"MAW","independent":true,"status":"officially-assigned","currency":["MWK"],"callingCode":["265"],"capital":["Lilongwe"],"altSpellings":["MW","Republic of Malawi"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","nya":"Chewa"},"translations":{"deu":{"official":"Republik Malawi","common":"Malawi"},"fra":{"official":"République du Malawi","common":"Malawi"},"hrv":{"official":"Republika Malavi","common":"Malavi"},"ita":{"official":"Repubblica del Malawi","common":"Malawi"},"jpn":{"official":"マラウイ共和国","common":"マラウイ"},"nld":{"official":"Republiek Malawi","common":"Malawi"},"por":{"official":"República do Malawi","common":"Malawi"},"rus":{"official":"Республика Малави","common":"Малави"},"slk":{"official":"Malawijská republika","common":"Malawi"},"spa":{"official":"República de Malawi","common":"Malawi"},"fin":{"official":"Malawin tasavalta","common":"Malawi"},"est":{"official":"Malawi Vabariik","common":"Malawi"},"zho":{"official":"马拉维共和国","common":"马拉维"}},"latlng":[-13.5,34],"demonym":"Malawian","landlocked":true,"borders":["MOZ","TZA","ZMB"],"area":118484,"flag":"🇲🇼"},{"name":{"common":"Malaysia","official":"Malaysia","native":{"eng":{"official":"Malaysia","common":"Malaysia"},"msa":{"official":"مليسيا","common":"مليسيا"}}},"tld":[".my"],"cca2":"MY","ccn3":"458","cca3":"MYS","cioc":"MAS","independent":true,"status":"officially-assigned","currency":["MYR"],"callingCode":["60"],"capital":["Kuala Lumpur"],"altSpellings":["MY"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"eng":"English","msa":"Malay"},"translations":{"deu":{"official":"Malaysia","common":"Malaysia"},"fra":{"official":"Fédération de Malaisie","common":"Malaisie"},"hrv":{"official":"Malezija","common":"Malezija"},"ita":{"official":"Malaysia","common":"Malesia"},"jpn":{"official":"マレーシア","common":"マレーシア"},"nld":{"official":"Maleisië","common":"Maleisië"},"por":{"official":"Malásia","common":"Malásia"},"rus":{"official":"Малайзия","common":"Малайзия"},"slk":{"official":"Malajzia","common":"Malajzia"},"spa":{"official":"Malasia","common":"Malasia"},"fin":{"official":"Malesia","common":"Malesia"},"est":{"official":"Malaisia","common":"Malaisia"},"zho":{"official":"马来西亚","common":"马来西亚"}},"latlng":[2.5,112.5],"demonym":"Malaysian","landlocked":false,"borders":["BRN","IDN","THA"],"area":330803,"flag":"🇲🇾"},{"name":{"common":"Mayotte","official":"Department of Mayotte","native":{"fra":{"official":"Département de Mayotte","common":"Mayotte"}}},"tld":[".yt"],"cca2":"YT","ccn3":"175","cca3":"MYT","cioc":"","independent":false,"status":"officially-assigned","currency":["EUR"],"callingCode":["262"],"capital":["Mamoudzou"],"altSpellings":["YT","Department of Mayotte","Département de Mayotte"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French"},"translations":{"deu":{"official":"Übersee-Département Mayotte","common":"Mayotte"},"fra":{"official":"Département de Mayotte","common":"Mayotte"},"hrv":{"official":"Odjel Mayotte","common":"Mayotte"},"ita":{"official":"Dipartimento di Mayotte","common":"Mayotte"},"jpn":{"official":"マヨット科","common":"マヨット"},"nld":{"official":"Afdeling Mayotte","common":"Mayotte"},"por":{"official":"Departamento de Mayotte","common":"Mayotte"},"rus":{"official":"Департамент Майотта","common":"Майотта"},"slk":{"official":"Department Mayotte","common":"Mayotte"},"spa":{"official":"Departamento de Mayotte","common":"Mayotte"},"fin":{"official":"Mayotte","common":"Mayotte"},"est":{"official":"Mayotte","common":"Mayotte"},"zho":{"official":"马约特","common":"马约特"}},"latlng":[-12.83333333,45.16666666],"demonym":"Mahoran","landlocked":false,"borders":[],"area":374,"flag":"🇾🇹"},{"name":{"common":"Namibia","official":"Republic of Namibia","native":{"afr":{"official":"Republiek van Namibië","common":"Namibië"},"deu":{"official":"Republik Namibia","common":"Namibia"},"eng":{"official":"Republic of Namibia","common":"Namibia"},"her":{"official":"Republic of Namibia","common":"Namibia"},"hgm":{"official":"Republic of Namibia","common":"Namibia"},"kwn":{"official":"Republic of Namibia","common":"Namibia"},"loz":{"official":"Republic of Namibia","common":"Namibia"},"ndo":{"official":"Republic of Namibia","common":"Namibia"},"tsn":{"official":"Lefatshe la Namibia","common":"Namibia"}}},"tld":[".na"],"cca2":"NA","ccn3":"516","cca3":"NAM","cioc":"NAM","independent":true,"status":"officially-assigned","currency":["NAD","ZAR"],"callingCode":["264"],"capital":["Windhoek"],"altSpellings":["NA","Namibië","Republic of Namibia"],"region":"Africa","subregion":"Southern Africa","languages":{"afr":"Afrikaans","deu":"German","eng":"English","her":"Herero","hgm":"Khoekhoe","kwn":"Kwangali","loz":"Lozi","ndo":"Ndonga","tsn":"Tswana"},"translations":{"deu":{"official":"Republik Namibia","common":"Namibia"},"fra":{"official":"République de Namibie","common":"Namibie"},"hrv":{"official":"Republika Namibija","common":"Namibija"},"ita":{"official":"Repubblica di Namibia","common":"Namibia"},"jpn":{"official":"ナミビア共和国","common":"ナミビア"},"nld":{"official":"Republiek Namibië","common":"Namibië"},"por":{"official":"República da Namíbia","common":"Namíbia"},"rus":{"official":"Республика Намибия","common":"Намибия"},"slk":{"official":"Namíbijská republika","common":"Namíbia"},"spa":{"official":"República de Namibia","common":"Namibia"},"fin":{"official":"Namibian tasavalta","common":"Namibia"},"est":{"official":"Namiibia Vabariik","common":"Namiibia"},"zho":{"official":"纳米比亚共和国","common":"纳米比亚"}},"latlng":[-22,17],"demonym":"Namibian","landlocked":false,"borders":["AGO","BWA","ZAF","ZMB"],"area":825615,"flag":"🇳🇦"},{"name":{"common":"New Caledonia","official":"New Caledonia","native":{"fra":{"official":"Nouvelle-Calédonie","common":"Nouvelle-Calédonie"}}},"tld":[".nc"],"cca2":"NC","ccn3":"540","cca3":"NCL","cioc":"","independent":false,"status":"officially-assigned","currency":["XPF"],"callingCode":["687"],"capital":["Nouméa"],"altSpellings":["NC"],"region":"Oceania","subregion":"Melanesia","languages":{"fra":"French"},"translations":{"deu":{"official":"Neukaledonien","common":"Neukaledonien"},"fra":{"official":"Nouvelle-Calédonie","common":"Nouvelle-Calédonie"},"hrv":{"official":"Nova Kaledonija","common":"Nova Kaledonija"},"ita":{"official":"Nuova Caledonia","common":"Nuova Caledonia"},"jpn":{"official":"ニューカレドニア","common":"ニューカレドニア"},"nld":{"official":"nieuw -Caledonië","common":"Nieuw-Caledonië"},"por":{"official":"New Caledonia","common":"Nova Caledónia"},"rus":{"official":"Новая Каледония","common":"Новая Каледония"},"slk":{"official":"Nová Kaledónia","common":"Nová Kaledónia"},"spa":{"official":"nueva Caledonia","common":"Nueva Caledonia"},"fin":{"official":"Uusi-Kaledonia","common":"Uusi-Kaledonia"},"est":{"official":"Uus-Kaledoonia","common":"Uus-Kaledoonia"},"zho":{"official":"新喀里多尼亚","common":"新喀里多尼亚"}},"latlng":[-21.5,165.5],"demonym":"New Caledonian","landlocked":false,"borders":[],"area":18575,"flag":"🇳🇨"},{"name":{"common":"Niger","official":"Republic of Niger","native":{"fra":{"official":"République du Niger","common":"Niger"}}},"tld":[".ne"],"cca2":"NE","ccn3":"562","cca3":"NER","cioc":"NIG","independent":true,"status":"officially-assigned","currency":["XOF"],"callingCode":["227"],"capital":["Niamey"],"altSpellings":["NE","Nijar"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"deu":{"official":"Republik Niger","common":"Niger"},"fra":{"official":"République du Niger","common":"Niger"},"hrv":{"official":"Republika Niger","common":"Niger"},"ita":{"official":"Repubblica del Niger","common":"Niger"},"jpn":{"official":"ニジェール共和国","common":"ニジェール"},"nld":{"official":"Republiek Niger","common":"Niger"},"por":{"official":"República do Níger","common":"Níger"},"rus":{"official":"Республика Нигер","common":"Нигер"},"slk":{"official":"Nigérská republika","common":"Niger"},"spa":{"official":"República de Níger","common":"Níger"},"fin":{"official":"Nigerin tasavalta","common":"Niger"},"est":{"official":"Nigeri Vabariik","common":"Niger"},"zho":{"official":"尼日尔共和国","common":"尼日尔"}},"latlng":[16,8],"demonym":"Nigerien","landlocked":true,"borders":["DZA","BEN","BFA","TCD","LBY","MLI","NGA"],"area":1267000,"flag":"🇳🇪"},{"name":{"common":"Norfolk Island","official":"Territory of Norfolk Island","native":{"eng":{"official":"Territory of Norfolk Island","common":"Norfolk Island"},"pih":{"official":"Teratri of Norf'k Ailen","common":"Norf'k Ailen"}}},"tld":[".nf"],"cca2":"NF","ccn3":"574","cca3":"NFK","cioc":"","independent":false,"status":"officially-assigned","currency":["AUD"],"callingCode":["672"],"capital":["Kingston"],"altSpellings":["NF","Territory of Norfolk Island","Teratri of Norf'k Ailen"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English","pih":"Norfuk"},"translations":{"deu":{"official":"Gebiet der Norfolk-Insel","common":"Norfolkinsel"},"fra":{"official":"Territoire de l'île Norfolk","common":"Île Norfolk"},"hrv":{"official":"Teritorij Norfolk Island","common":"Otok Norfolk"},"ita":{"official":"Territorio di Norfolk Island","common":"Isola Norfolk"},"jpn":{"official":"ノーフォーク島の領土","common":"ノーフォーク島"},"nld":{"official":"Grondgebied van Norfolk Island","common":"Norfolkeiland"},"por":{"official":"Território da Ilha Norfolk","common":"Ilha Norfolk"},"rus":{"official":"Территория острова Норфолк","common":"Норфолк"},"slk":{"official":"Teritórium ostrova Norfolk","common":"Norfolk"},"spa":{"official":"Territorio de la Isla Norfolk","common":"Isla de Norfolk"},"fin":{"official":"Norfolkinsaaren territorio","common":"Norfolkinsaari"},"est":{"official":"Norfolki saare ala","common":"Norfolk"},"zho":{"official":"诺福克岛","common":"诺福克岛"}},"latlng":[-29.03333333,167.95],"demonym":"Norfolk Islander","landlocked":false,"borders":[],"area":36,"flag":"🇳🇫"},{"name":{"common":"Nigeria","official":"Federal Republic of Nigeria","native":{"eng":{"official":"Federal Republic of Nigeria","common":"Nigeria"}}},"tld":[".ng"],"cca2":"NG","ccn3":"566","cca3":"NGA","cioc":"NGR","independent":true,"status":"officially-assigned","currency":["NGN"],"callingCode":["234"],"capital":["Abuja"],"altSpellings":["NG","Nijeriya","Naíjíríà","Federal Republic of Nigeria"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"deu":{"official":"Bundesrepublik Nigeria","common":"Nigeria"},"fra":{"official":"République fédérale du Nigeria","common":"Nigéria"},"hrv":{"official":"Savezna Republika Nigerija","common":"Nigerija"},"ita":{"official":"Repubblica federale di Nigeria","common":"Nigeria"},"jpn":{"official":"ナイジェリア連邦共和国","common":"ナイジェリア"},"nld":{"official":"Federale Republiek Nigeria","common":"Nigeria"},"por":{"official":"República Federal da Nigéria","common":"Nigéria"},"rus":{"official":"Федеративная Республика Нигерия","common":"Нигерия"},"slk":{"official":"Nigérijská federatívna republika","common":"Nigéria"},"spa":{"official":"República Federal de Nigeria","common":"Nigeria"},"fin":{"official":"Nigerian liittotasavalta","common":"Nigeria"},"est":{"official":"Nigeeria Liitvabariik","common":"Nigeeria"},"zho":{"official":"尼日利亚联邦共和国","common":"尼日利亚"}},"latlng":[10,8],"demonym":"Nigerian","landlocked":false,"borders":["BEN","CMR","TCD","NER"],"area":923768,"flag":"🇳🇬"},{"name":{"common":"Nicaragua","official":"Republic of Nicaragua","native":{"spa":{"official":"República de Nicaragua","common":"Nicaragua"}}},"tld":[".ni"],"cca2":"NI","ccn3":"558","cca3":"NIC","cioc":"NCA","independent":true,"status":"officially-assigned","currency":["NIO"],"callingCode":["505"],"capital":["Managua"],"altSpellings":["NI","Republic of Nicaragua","República de Nicaragua"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"deu":{"official":"Republik Nicaragua","common":"Nicaragua"},"fra":{"official":"République du Nicaragua","common":"Nicaragua"},"hrv":{"official":"Republika Nikaragva","common":"Nikaragva"},"ita":{"official":"Repubblica del Nicaragua","common":"Nicaragua"},"jpn":{"official":"ニカラグア共和国","common":"ニカラグア"},"nld":{"official":"Republiek Nicaragua","common":"Nicaragua"},"por":{"official":"República da Nicarágua","common":"Nicarágua"},"rus":{"official":"Республика Никарагуа","common":"Никарагуа"},"slk":{"official":"Nikaragujská republika","common":"Nikaragua"},"spa":{"official":"República de Nicaragua","common":"Nicaragua"},"fin":{"official":"Nicaraguan tasavalta","common":"Nicaragua"},"est":{"official":"Nicaragua Vabariik","common":"Nicaragua"},"zho":{"official":"尼加拉瓜共和国","common":"尼加拉瓜"}},"latlng":[13,-85],"demonym":"Nicaraguan","landlocked":false,"borders":["CRI","HND"],"area":130373,"flag":"🇳🇮"},{"name":{"common":"Niue","official":"Niue","native":{"eng":{"official":"Niue","common":"Niue"},"niu":{"official":"Niuē","common":"Niuē"}}},"tld":[".nu"],"cca2":"NU","ccn3":"570","cca3":"NIU","cioc":"","independent":false,"status":"officially-assigned","currency":["NZD"],"callingCode":["683"],"capital":["Alofi"],"altSpellings":["NU"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","niu":"Niuean"},"translations":{"deu":{"official":"Niue","common":"Niue"},"fra":{"official":"Niue","common":"Niue"},"hrv":{"official":"Niue","common":"Niue"},"ita":{"official":"Niue","common":"Niue"},"jpn":{"official":"ニウエ","common":"ニウエ"},"nld":{"official":"Niue","common":"Niue"},"por":{"official":"Niue","common":"Niue"},"rus":{"official":"Ниуэ","common":"Ниуэ"},"slk":{"official":"Niue","common":"Niue"},"spa":{"official":"Niue","common":"Niue"},"fin":{"official":"Niue","common":"Niue"},"est":{"official":"Niue","common":"Niue"},"zho":{"official":"纽埃","common":"纽埃"}},"latlng":[-19.03333333,-169.86666666],"demonym":"Niuean","landlocked":false,"borders":[],"area":260,"flag":"🇳🇺"},{"name":{"common":"Netherlands","official":"Netherlands","native":{"nld":{"official":"Nederland","common":"Nederland"}}},"tld":[".nl"],"cca2":"NL","ccn3":"528","cca3":"NLD","cioc":"NED","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["31"],"capital":["Amsterdam"],"altSpellings":["NL","Holland","Nederland","The Netherlands"],"region":"Europe","subregion":"Western Europe","languages":{"nld":"Dutch"},"translations":{"deu":{"official":"Niederlande","common":"Niederlande"},"fra":{"official":"Pays-Bas","common":"Pays-Bas"},"hrv":{"official":"Holandija","common":"Nizozemska"},"ita":{"official":"Paesi Bassi","common":"Paesi Bassi"},"jpn":{"official":"オランダ","common":"オランダ"},"nld":{"official":"Nederland","common":"Nederland"},"por":{"official":"Holanda","common":"Holanda"},"rus":{"official":"Нидерланды","common":"Нидерланды"},"slk":{"official":"Holandské kráľovstvo","common":"Holansko"},"spa":{"official":"Países Bajos","common":"Países Bajos"},"fin":{"official":"Alankomaat","common":"Alankomaat"},"est":{"official":"Madalmaade Kuningriik","common":"Holland"},"zho":{"official":"荷兰","common":"荷兰"}},"latlng":[52.5,5.75],"demonym":"Dutch","landlocked":false,"borders":["BEL","DEU"],"area":41850,"flag":"🇳🇱"},{"name":{"common":"Norway","official":"Kingdom of Norway","native":{"nno":{"official":"Kongeriket Noreg","common":"Noreg"},"nob":{"official":"Kongeriket Norge","common":"Norge"},"smi":{"official":"Norgga gonagasriika","common":"Norgga"}}},"tld":[".no"],"cca2":"NO","ccn3":"578","cca3":"NOR","cioc":"NOR","independent":true,"status":"officially-assigned","currency":["NOK"],"callingCode":["47"],"capital":["Oslo"],"altSpellings":["NO","Norge","Noreg","Kingdom of Norway","Kongeriket Norge","Kongeriket Noreg"],"region":"Europe","subregion":"Northern Europe","languages":{"nno":"Norwegian Nynorsk","nob":"Norwegian Bokmål","smi":"Sami"},"translations":{"deu":{"official":"Königreich Norwegen","common":"Norwegen"},"fra":{"official":"Royaume de Norvège","common":"Norvège"},"hrv":{"official":"Kraljevina Norveška","common":"Norveška"},"ita":{"official":"Regno di Norvegia","common":"Norvegia"},"jpn":{"official":"ノルウェー王国","common":"ノルウェー"},"nld":{"official":"Koninkrijk Noorwegen","common":"Noorwegen"},"por":{"official":"Reino da Noruega","common":"Noruega"},"rus":{"official":"Королевство Норвегия","common":"Норвегия"},"slk":{"official":"Nórske kráľovstvo","common":"Nórsko"},"spa":{"official":"Reino de Noruega","common":"Noruega"},"fin":{"official":"Norjan kuningaskunta","common":"Norja"},"est":{"official":"Norra Kuningriik","common":"Norra"},"zho":{"official":"挪威王国","common":"挪威"}},"latlng":[62,10],"demonym":"Norwegian","landlocked":false,"borders":["FIN","SWE","RUS"],"area":323802,"flag":"🇳🇴"},{"name":{"common":"Nepal","official":"Federal Democratic Republic of Nepal","native":{"nep":{"official":"नेपाल संघीय लोकतान्त्रिक गणतन्त्र","common":"नेपाल"}}},"tld":[".np"],"cca2":"NP","ccn3":"524","cca3":"NPL","cioc":"NEP","independent":true,"status":"officially-assigned","currency":["NPR"],"callingCode":["977"],"capital":["Kathmandu"],"altSpellings":["NP","Federal Democratic Republic of Nepal","Loktāntrik Ganatantra Nepāl"],"region":"Asia","subregion":"Southern Asia","languages":{"nep":"Nepali"},"translations":{"deu":{"official":"Demokratischen Bundesrepublik Nepal","common":"Népal"},"fra":{"official":"République du Népal","common":"Népal"},"hrv":{"official":"Savezna Demokratska Republika Nepal","common":"Nepal"},"ita":{"official":"Repubblica federale democratica del Nepal","common":"Nepal"},"jpn":{"official":"ネパール連邦民主共和国","common":"ネパール"},"nld":{"official":"Federale Democratische Republiek Nepal","common":"Nepal"},"por":{"official":"República Democrática Federal do Nepal","common":"Nepal"},"rus":{"official":"Федеративная Демократическая Республика Непал","common":"Непал"},"slk":{"official":"Nepálska federatívna demokratická republika","common":"Nepál"},"spa":{"official":"República Democrática Federal de Nepal","common":"Nepal"},"fin":{"official":"Nepalin demokraattinen liittotasavalta","common":"Nepal"},"est":{"official":"Nepali Demokraatlik Liitvabariik","common":"Nepal"},"zho":{"official":"尼泊尔联邦民主共和国","common":"尼泊尔"}},"latlng":[28,84],"demonym":"Nepalese","landlocked":true,"borders":["CHN","IND"],"area":147181,"flag":"🇳🇵"},{"name":{"common":"Nauru","official":"Republic of Nauru","native":{"eng":{"official":"Republic of Nauru","common":"Nauru"},"nau":{"official":"Republic of Nauru","common":"Nauru"}}},"tld":[".nr"],"cca2":"NR","ccn3":"520","cca3":"NRU","cioc":"NRU","independent":true,"status":"officially-assigned","currency":["AUD"],"callingCode":["674"],"capital":["Yaren"],"altSpellings":["NR","Naoero","Pleasant Island","Republic of Nauru","Ripublik Naoero"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","nau":"Nauru"},"translations":{"deu":{"official":"Republik Nauru","common":"Nauru"},"fra":{"official":"République de Nauru","common":"Nauru"},"hrv":{"official":"Republika Nauru","common":"Nauru"},"ita":{"official":"Repubblica di Nauru","common":"Nauru"},"jpn":{"official":"ナウル共和国","common":"ナウル"},"nld":{"official":"Republiek Nauru","common":"Nauru"},"por":{"official":"República de Nauru","common":"Nauru"},"rus":{"official":"Республика Науру","common":"Науру"},"slk":{"official":"Naurská republika","common":"Nauru"},"spa":{"official":"República de Nauru","common":"Nauru"},"fin":{"official":"Naurun tasavalta","common":"Nauru"},"est":{"official":"Nauru Vabariik","common":"Nauru"},"zho":{"official":"瑙鲁共和国","common":"瑙鲁"}},"latlng":[-0.53333333,166.91666666],"demonym":"Nauruan","landlocked":false,"borders":[],"area":21,"flag":"🇳🇷"},{"name":{"common":"New Zealand","official":"New Zealand","native":{"eng":{"official":"New Zealand","common":"New Zealand"},"mri":{"official":"Aotearoa","common":"Aotearoa"},"nzs":{"official":"New Zealand","common":"New Zealand"}}},"tld":[".nz"],"cca2":"NZ","ccn3":"554","cca3":"NZL","cioc":"NZL","independent":true,"status":"officially-assigned","currency":["NZD"],"callingCode":["64"],"capital":["Wellington"],"altSpellings":["NZ","Aotearoa"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English","mri":"Māori","nzs":"New Zealand Sign Language"},"translations":{"deu":{"official":"Neuseeland","common":"Neuseeland"},"fra":{"official":"Nouvelle-Zélande","common":"Nouvelle-Zélande"},"hrv":{"official":"Novi Zeland","common":"Novi Zeland"},"ita":{"official":"Nuova Zelanda","common":"Nuova Zelanda"},"jpn":{"official":"ニュージーランド","common":"ニュージーランド"},"nld":{"official":"Nieuw Zeeland","common":"Nieuw-Zeeland"},"por":{"official":"nova Zelândia","common":"Nova Zelândia"},"rus":{"official":"Новая Зеландия","common":"Новая Зеландия"},"slk":{"official":"Nový Zéland","common":"Nový Zéland"},"spa":{"official":"nueva Zelanda","common":"Nueva Zelanda"},"fin":{"official":"Uusi-Seelanti","common":"Uusi-Seelanti"},"est":{"official":"Uus-Meremaa","common":"Uus-Meremaa"},"zho":{"official":"新西兰","common":"新西兰"}},"latlng":[-41,174],"demonym":"New Zealander","landlocked":false,"borders":[],"area":270467,"flag":"🇳🇿"},{"name":{"common":"Oman","official":"Sultanate of Oman","native":{"ara":{"official":"سلطنة عمان","common":"عمان"}}},"tld":[".om"],"cca2":"OM","ccn3":"512","cca3":"OMN","cioc":"OMA","independent":true,"status":"officially-assigned","currency":["OMR"],"callingCode":["968"],"capital":["Muscat"],"altSpellings":["OM","Sultanate of Oman","Salṭanat ʻUmān"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Sultanat Oman","common":"Oman"},"fra":{"official":"Sultanat d'Oman","common":"Oman"},"hrv":{"official":"Sultanat Oman","common":"Oman"},"ita":{"official":"Sultanato dell'Oman","common":"oman"},"jpn":{"official":"オマーン·スルタン国","common":"オマーン"},"nld":{"official":"Sultanaat van Oman","common":"Oman"},"por":{"official":"Sultanato de Omã","common":"Omã"},"rus":{"official":"Султанат Оман","common":"Оман"},"slk":{"official":"Ománsky sultanát","common":"Omán"},"spa":{"official":"Sultanato de Omán","common":"Omán"},"fin":{"official":"Omanin sulttaanikunta","common":"Oman"},"est":{"official":"Omaani Sultaniriik","common":"Omaan"},"zho":{"official":"阿曼苏丹国","common":"阿曼"}},"latlng":[21,57],"demonym":"Omani","landlocked":false,"borders":["SAU","ARE","YEM"],"area":309500,"flag":"🇴🇲"},{"name":{"common":"Pakistan","official":"Islamic Republic of Pakistan","native":{"eng":{"official":"Islamic Republic of Pakistan","common":"Pakistan"},"urd":{"official":"اسلامی جمہوریۂ پاكستان","common":"پاكستان"}}},"tld":[".pk"],"cca2":"PK","ccn3":"586","cca3":"PAK","cioc":"PAK","independent":true,"status":"officially-assigned","currency":["PKR"],"callingCode":["92"],"capital":["Islamabad"],"altSpellings":["PK","Pākistān","Islamic Republic of Pakistan","Islāmī Jumhūriya'eh Pākistān"],"region":"Asia","subregion":"Southern Asia","languages":{"eng":"English","urd":"Urdu"},"translations":{"deu":{"official":"Islamische Republik Pakistan","common":"Pakistan"},"fra":{"official":"République islamique du Pakistan","common":"Pakistan"},"hrv":{"official":"Islamska Republika Pakistan","common":"Pakistan"},"ita":{"official":"Repubblica islamica del Pakistan","common":"Pakistan"},"jpn":{"official":"パキスタン","common":"パキスタン"},"nld":{"official":"Islamitische Republiek Pakistan","common":"Pakistan"},"por":{"official":"República Islâmica do Paquistão","common":"Paquistão"},"rus":{"official":"Исламская Республика Пакистан","common":"Пакистан"},"slk":{"official":"Pakistanská islamská republika","common":"Pakistan"},"spa":{"official":"República Islámica de Pakistán","common":"Pakistán"},"fin":{"official":"Pakistanin islamilainen tasavalta","common":"Pakistan"},"est":{"official":"Pakistani Islamivabariik","common":"Pakistan"},"zho":{"official":"巴基斯坦伊斯兰共和国","common":"巴基斯坦"}},"latlng":[30,70],"demonym":"Pakistani","landlocked":false,"borders":["AFG","CHN","IND","IRN"],"area":881912,"flag":"🇵🇰"},{"name":{"common":"Panama","official":"Republic of Panama","native":{"spa":{"official":"República de Panamá","common":"Panamá"}}},"tld":[".pa"],"cca2":"PA","ccn3":"591","cca3":"PAN","cioc":"PAN","independent":true,"status":"officially-assigned","currency":["PAB","USD"],"callingCode":["507"],"capital":["Panama City"],"altSpellings":["PA","Republic of Panama","República de Panamá"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"deu":{"official":"Republik Panama","common":"Panama"},"fra":{"official":"République du Panama","common":"Panama"},"hrv":{"official":"Republika Panama","common":"Panama"},"ita":{"official":"Repubblica di Panama","common":"Panama"},"jpn":{"official":"パナマ共和国","common":"パナマ"},"nld":{"official":"Republiek Panama","common":"Panama"},"por":{"official":"República do Panamá","common":"Panamá"},"rus":{"official":"Республика Панама","common":"Панама"},"slk":{"official":"Panamská republika","common":"Panama"},"spa":{"official":"República de Panamá","common":"Panamá"},"fin":{"official":"Panaman tasavalta","common":"Panama"},"est":{"official":"Panama Vabariik","common":"Panama"},"zho":{"official":"巴拿马共和国","common":"巴拿马"}},"latlng":[9,-80],"demonym":"Panamanian","landlocked":false,"borders":["COL","CRI"],"area":75417,"flag":"🇵🇦"},{"name":{"common":"Pitcairn Islands","official":"Pitcairn Group of Islands","native":{"eng":{"official":"Pitcairn Group of Islands","common":"Pitcairn Islands"}}},"tld":[".pn"],"cca2":"PN","ccn3":"612","cca3":"PCN","cioc":"","independent":false,"status":"officially-assigned","currency":["NZD"],"callingCode":["64"],"capital":["Adamstown"],"altSpellings":["PN","Pitcairn","Pitcairn Henderson Ducie and Oeno Islands"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English"},"translations":{"deu":{"official":"Pitcairn Inselgruppe","common":"Pitcairn"},"fra":{"official":"Groupe d'îles Pitcairn","common":"Îles Pitcairn"},"hrv":{"official":"Pitcairn skupine otoka","common":"Pitcairnovo otočje"},"ita":{"official":"Pitcairn gruppo di isole","common":"Isole Pitcairn"},"jpn":{"official":"島のピトケアングループ","common":"ピトケアン"},"nld":{"official":"Pitcairn groep eilanden","common":"Pitcairneilanden"},"por":{"official":"Pitcairn grupo de ilhas","common":"Ilhas Pitcairn"},"rus":{"official":"Питкэрн группа островов","common":"Острова Питкэрн"},"slk":{"official":"Pitcairnove ostrovy","common":"Pitcairnove ostrovy"},"spa":{"official":"Grupo de Islas Pitcairn","common":"Islas Pitcairn"},"fin":{"official":"Pitcairn","common":"Pitcairn"},"est":{"official":"Pitcairni, Hendersoni, Ducie ja Oeno saar","common":"Pitcairn"},"zho":{"official":"皮特凯恩群岛","common":"皮特凯恩群岛"}},"latlng":[-25.06666666,-130.1],"demonym":"Pitcairn Islander","landlocked":false,"borders":[],"area":47,"flag":"🇵🇳"},{"name":{"common":"Peru","official":"Republic of Peru","native":{"aym":{"official":"Piruw Suyu","common":"Piruw"},"que":{"official":"Piruw Ripuwlika","common":"Piruw"},"spa":{"official":"República del Perú","common":"Perú"}}},"tld":[".pe"],"cca2":"PE","ccn3":"604","cca3":"PER","cioc":"PER","independent":true,"status":"officially-assigned","currency":["PEN"],"callingCode":["51"],"capital":["Lima"],"altSpellings":["PE","Republic of Peru","República del Perú"],"region":"Americas","subregion":"South America","languages":{"aym":"Aymara","que":"Quechua","spa":"Spanish"},"translations":{"deu":{"official":"Republik Peru","common":"Peru"},"fra":{"official":"République du Pérou","common":"Pérou"},"hrv":{"official":"Republika Peru","common":"Peru"},"ita":{"official":"Repubblica del Perù","common":"Perù"},"jpn":{"official":"ペルー共和国","common":"ペルー"},"nld":{"official":"Republiek Peru","common":"Peru"},"por":{"official":"República do Peru","common":"Perú"},"rus":{"official":"Республика Перу","common":"Перу"},"slk":{"official":"Peruánska republika","common":"Peru"},"spa":{"official":"República de Perú","common":"Perú"},"fin":{"official":"Perun tasavalta","common":"Peru"},"est":{"official":"Peruu Vabariik","common":"Peruu"},"zho":{"official":"秘鲁共和国","common":"秘鲁"}},"latlng":[-10,-76],"demonym":"Peruvian","landlocked":false,"borders":["BOL","BRA","CHL","COL","ECU"],"area":1285216,"flag":"🇵🇪"},{"name":{"common":"Philippines","official":"Republic of the Philippines","native":{"eng":{"official":"Republic of the Philippines","common":"Philippines"},"fil":{"official":"Republic of the Philippines","common":"Pilipinas"}}},"tld":[".ph"],"cca2":"PH","ccn3":"608","cca3":"PHL","cioc":"PHI","independent":true,"status":"officially-assigned","currency":["PHP"],"callingCode":["63"],"capital":["Manila"],"altSpellings":["PH","Republic of the Philippines","Repúblika ng Pilipinas"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"eng":"English","fil":"Filipino"},"translations":{"deu":{"official":"Republik der Philippinen","common":"Philippinen"},"fra":{"official":"République des Philippines","common":"Philippines"},"hrv":{"official":"Republika Filipini","common":"Filipini"},"ita":{"official":"Repubblica delle Filippine","common":"Filippine"},"jpn":{"official":"フィリピン共和国","common":"フィリピン"},"nld":{"official":"Republiek der Filipijnen","common":"Filipijnen"},"por":{"official":"República das Filipinas","common":"Filipinas"},"rus":{"official":"Республика Филиппины","common":"Филиппины"},"slk":{"official":"Filipínska republika","common":"Filipíny"},"spa":{"official":"República de las Filipinas","common":"Filipinas"},"fin":{"official":"Filippiinien tasavalta","common":"Filippiinit"},"est":{"official":"Filipiini Vabariik","common":"Filipiinid"},"zho":{"official":"菲律宾共和国","common":"菲律宾"}},"latlng":[13,122],"demonym":"Filipino","landlocked":false,"borders":[],"area":342353,"flag":"🇵🇭"},{"name":{"common":"Palau","official":"Republic of Palau","native":{"eng":{"official":"Republic of Palau","common":"Palau"},"pau":{"official":"Beluu er a Belau","common":"Belau"}}},"tld":[".pw"],"cca2":"PW","ccn3":"585","cca3":"PLW","cioc":"PLW","independent":true,"status":"officially-assigned","currency":["USD"],"callingCode":["680"],"capital":["Ngerulmud"],"altSpellings":["PW","Republic of Palau","Beluu er a Belau"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","pau":"Palauan"},"translations":{"deu":{"official":"Palau","common":"Palau"},"fra":{"official":"République des Palaos (Palau)","common":"Palaos (Palau)"},"hrv":{"official":"Republika Palau","common":"Palau"},"ita":{"official":"Repubblica di Palau","common":"Palau"},"jpn":{"official":"パラオ共和国","common":"パラオ"},"nld":{"official":"Republiek van Palau","common":"Palau"},"por":{"official":"República de Palau","common":"Palau"},"rus":{"official":"Республика Палау","common":"Палау"},"slk":{"official":"Palauská republika","common":"Palau"},"spa":{"official":"República de Palau","common":"Palau"},"fin":{"official":"Palaun tasavalta","common":"Palau"},"est":{"official":"Belau Vabariik","common":"Belau"},"zho":{"official":"帕劳共和国","common":"帕劳"}},"latlng":[7.5,134.5],"demonym":"Palauan","landlocked":false,"borders":[],"area":459,"flag":"🇵🇼"},{"name":{"common":"Papua New Guinea","official":"Independent State of Papua New Guinea","native":{"eng":{"official":"Independent State of Papua New Guinea","common":"Papua New Guinea"},"hmo":{"official":"Independen Stet bilong Papua Niugini","common":"Papua Niu Gini"},"tpi":{"official":"Independen Stet bilong Papua Niugini","common":"Papua Niugini"}}},"tld":[".pg"],"cca2":"PG","ccn3":"598","cca3":"PNG","cioc":"PNG","independent":true,"status":"officially-assigned","currency":["PGK"],"callingCode":["675"],"capital":["Port Moresby"],"altSpellings":["PG","Independent State of Papua New Guinea","Independen Stet bilong Papua Niugini"],"region":"Oceania","subregion":"Melanesia","languages":{"eng":"English","hmo":"Hiri Motu","tpi":"Tok Pisin"},"translations":{"deu":{"official":"Unabhängige Staat Papua-Neuguinea","common":"Papua-Neuguinea"},"fra":{"official":"État indépendant de Papouasie-Nouvelle-Guinée","common":"Papouasie-Nouvelle-Guinée"},"hrv":{"official":"Nezavisna Država Papui Novoj Gvineji","common":"Papua Nova Gvineja"},"ita":{"official":"Stato indipendente di Papua Nuova Guinea","common":"Papua Nuova Guinea"},"jpn":{"official":"パプアニューギニア独立国","common":"パプアニューギニア"},"nld":{"official":"Onafhankelijke Staat Papoea -Nieuw-Guinea","common":"Papoea-Nieuw-Guinea"},"por":{"official":"Estado Independente da Papua Nova Guiné","common":"Papua Nova Guiné"},"rus":{"official":"Независимое Государство Папуа-Новой Гвинеи","common":"Папуа — Новая Гвинея"},"slk":{"official":"Nezávislý štát Papua-Nová Guinea","common":"Papua-Nová Guinea"},"spa":{"official":"Estado Independiente de Papúa Nueva Guinea","common":"Papúa Nueva Guinea"},"fin":{"official":"Papua-Uuden-Guinean Itsenäinen valtio","common":"Papua-Uusi-Guinea"},"est":{"official":"Paapua Uus-Guinea Iseseisvusriik","common":"Paapua Uus-Guinea"},"zho":{"official":"巴布亚新几内亚","common":"巴布亚新几内亚"}},"latlng":[-6,147],"demonym":"Papua New Guinean","landlocked":false,"borders":["IDN"],"area":462840,"flag":"🇵🇬"},{"name":{"common":"Poland","official":"Republic of Poland","native":{"pol":{"official":"Rzeczpospolita Polska","common":"Polska"}}},"tld":[".pl"],"cca2":"PL","ccn3":"616","cca3":"POL","cioc":"POL","independent":true,"status":"officially-assigned","currency":["PLN"],"callingCode":["48"],"capital":["Warsaw"],"altSpellings":["PL","Republic of Poland","Rzeczpospolita Polska"],"region":"Europe","subregion":"Eastern Europe","languages":{"pol":"Polish"},"translations":{"deu":{"official":"Republik Polen","common":"Polen"},"fra":{"official":"République de Pologne","common":"Pologne"},"hrv":{"official":"Republika Poljska","common":"Poljska"},"ita":{"official":"Repubblica di Polonia","common":"Polonia"},"jpn":{"official":"ポーランド共和国","common":"ポーランド"},"nld":{"official":"Republiek Polen","common":"Polen"},"por":{"official":"República da Polónia","common":"Polónia"},"rus":{"official":"Республика Польша","common":"Польша"},"slk":{"official":"Poľská republika","common":"Poľsko"},"spa":{"official":"República de Polonia","common":"Polonia"},"fin":{"official":"Puolan tasavalta","common":"Puola"},"est":{"official":"Poola Vabariik","common":"Poola"},"zho":{"official":"波兰共和国","common":"波兰"}},"latlng":[52,20],"demonym":"Polish","landlocked":false,"borders":["BLR","CZE","DEU","LTU","RUS","SVK","UKR"],"area":312679,"flag":"🇵🇱"},{"name":{"common":"Puerto Rico","official":"Commonwealth of Puerto Rico","native":{"eng":{"official":"Commonwealth of Puerto Rico","common":"Puerto Rico"},"spa":{"official":"Estado Libre Asociado de Puerto Rico","common":"Puerto Rico"}}},"tld":[".pr"],"cca2":"PR","ccn3":"630","cca3":"PRI","cioc":"PUR","independent":false,"status":"officially-assigned","currency":["USD"],"callingCode":["1787","1939"],"capital":["San Juan"],"altSpellings":["PR","Commonwealth of Puerto Rico","Estado Libre Asociado de Puerto Rico"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","spa":"Spanish"},"translations":{"deu":{"official":"Commonwealth von Puerto Rico","common":"Puerto Rico"},"fra":{"official":"Porto Rico","common":"Porto Rico"},"hrv":{"official":"Zajednica Puerto Rico","common":"Portoriko"},"ita":{"official":"Commonwealth di Porto Rico","common":"Porto Rico"},"jpn":{"official":"プエルトリコのコモンウェルス","common":"プエルトリコ"},"nld":{"official":"Gemenebest van Puerto Rico","common":"Puerto Rico"},"por":{"official":"Commonwealth of Puerto Rico","common":"Porto Rico"},"rus":{"official":"Содружество Пуэрто-Рико","common":"Пуэрто-Рико"},"slk":{"official":"Portorické spoločenstvo","common":"Portoriko"},"spa":{"official":"Asociado de Puerto Rico","common":"Puerto Rico"},"fin":{"official":"Puerto Rico","common":"Puerto Rico"},"est":{"official":"Puerto Rico Ühendus","common":"Puerto Rico"},"zho":{"official":"波多黎各联邦","common":"波多黎各"}},"latlng":[18.25,-66.5],"demonym":"Puerto Rican","landlocked":false,"borders":[],"area":8870,"flag":"🇵🇷"},{"name":{"common":"North Korea","official":"Democratic People's Republic of Korea","native":{"kor":{"official":"조선 민주주의 인민 공화국","common":"북한"}}},"tld":[".kp"],"cca2":"KP","ccn3":"408","cca3":"PRK","cioc":"PRK","independent":true,"status":"officially-assigned","currency":["KPW"],"callingCode":["850"],"capital":["Pyongyang"],"altSpellings":["KP","Democratic People's Republic of Korea","조선민주주의인민공화국","Chosŏn Minjujuŭi Inmin Konghwaguk","Korea, Democratic People's Republic of"],"region":"Asia","subregion":"Eastern Asia","languages":{"kor":"Korean"},"translations":{"deu":{"official":"Demokratische Volksrepublik Korea","common":"Nordkorea"},"fra":{"official":"République populaire démocratique de Corée","common":"Corée du Nord"},"hrv":{"official":"Demokratska Narodna Republika Koreja","common":"Sjeverna Koreja"},"ita":{"official":"Repubblica democratica popolare di Corea","common":"Corea del Nord"},"jpn":{"official":"朝鮮民主主義人民共和国","common":"朝鮮民主主義人民共和国"},"nld":{"official":"Democratische Volksrepubliek Korea","common":"Noord-Korea"},"por":{"official":"República Popular Democrática da Coreia","common":"Coreia do Norte"},"rus":{"official":"Корейская Народно-Демократическая Республика Корея","common":"Северная Корея"},"slk":{"official":"Kórejská ľudovodemokratická republika","common":"Kórejská ľudovodemokratická republika (KĽR, Severná Kórea)"},"spa":{"official":"República Popular Democrática de Corea","common":"Corea del Norte"},"fin":{"official":"Korean demokraattinen kansantasavalta","common":"Pohjois-Korea"},"est":{"official":"Korea Rahvademokraatlik Vabariik","common":"Põhja-Korea"},"zho":{"official":"朝鲜人民民主共和国","common":"朝鲜"}},"latlng":[40,127],"demonym":"North Korean","landlocked":false,"borders":["CHN","KOR","RUS"],"area":120538,"flag":"🇰🇵"},{"name":{"common":"Portugal","official":"Portuguese Republic","native":{"por":{"official":"República português","common":"Portugal"}}},"tld":[".pt"],"cca2":"PT","ccn3":"620","cca3":"PRT","cioc":"POR","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["351"],"capital":["Lisbon"],"altSpellings":["PT","Portuguesa","Portuguese Republic","República Portuguesa"],"region":"Europe","subregion":"Southern Europe","languages":{"por":"Portuguese"},"translations":{"deu":{"official":"Portugiesische Republik","common":"Portugal"},"fra":{"official":"République portugaise","common":"Portugal"},"hrv":{"official":"Portugalska Republika","common":"Portugal"},"ita":{"official":"Repubblica portoghese","common":"Portogallo"},"jpn":{"official":"ポルトガル共和国","common":"ポルトガル"},"nld":{"official":"Portugese Republiek","common":"Portugal"},"por":{"official":"República português","common":"Portugal"},"rus":{"official":"Португальская Республика","common":"Португалия"},"slk":{"official":"Portugalská republika","common":"Portugalsko"},"spa":{"official":"República Portuguesa","common":"Portugal"},"fin":{"official":"Portugalin tasavalta","common":"Portugali"},"est":{"official":"Portugali Vabariik","common":"Portugal"},"zho":{"official":"葡萄牙共和国","common":"葡萄牙"}},"latlng":[39.5,-8],"demonym":"Portuguese","landlocked":false,"borders":["ESP"],"area":92090,"flag":"🇵🇹"},{"name":{"common":"Paraguay","official":"Republic of Paraguay","native":{"grn":{"official":"Tetã Paraguái","common":"Paraguái"},"spa":{"official":"República de Paraguay","common":"Paraguay"}}},"tld":[".py"],"cca2":"PY","ccn3":"600","cca3":"PRY","cioc":"PAR","independent":true,"status":"officially-assigned","currency":["PYG"],"callingCode":["595"],"capital":["Asunción"],"altSpellings":["PY","Republic of Paraguay","República del Paraguay","Tetã Paraguái"],"region":"Americas","subregion":"South America","languages":{"grn":"Guaraní","spa":"Spanish"},"translations":{"deu":{"official":"Republik Paraguay","common":"Paraguay"},"fra":{"official":"République du Paraguay","common":"Paraguay"},"hrv":{"official":"Republika Paragvaj","common":"Paragvaj"},"ita":{"official":"Repubblica del Paraguay","common":"Paraguay"},"jpn":{"official":"パラグアイ共和国","common":"パラグアイ"},"nld":{"official":"Republiek Paraguay","common":"Paraguay"},"por":{"official":"República do Paraguai","common":"Paraguai"},"rus":{"official":"Республика Парагвай","common":"Парагвай"},"slk":{"official":"Paraguajská republika","common":"Paraguaj"},"spa":{"official":"República de Paraguay","common":"Paraguay"},"fin":{"official":"Paraguayn tasavalta","common":"Paraguay"},"est":{"official":"Paraguay Vabariik","common":"Paraguay"},"zho":{"official":"巴拉圭共和国","common":"巴拉圭"}},"latlng":[-23,-58],"demonym":"Paraguayan","landlocked":true,"borders":["ARG","BOL","BRA"],"area":406752,"flag":"🇵🇾"},{"name":{"common":"Palestine","official":"State of Palestine","native":{"ara":{"official":"دولة فلسطين","common":"فلسطين"}}},"tld":[".ps","فلسطين."],"cca2":"PS","ccn3":"275","cca3":"PSE","cioc":"PLE","independent":false,"status":"officially-assigned","currency":["ILS"],"callingCode":["970"],"capital":["Ramallah"],"altSpellings":["PS","Palestine, State of","State of Palestine","Dawlat Filasṭin"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Staat Palästina","common":"Palästina"},"fra":{"official":"État de Palestine","common":"Palestine"},"hrv":{"official":"State of Palestine","common":"Palestina"},"ita":{"official":"Stato di Palestina","common":"Palestina"},"jpn":{"official":"パレスチナ自治政府","common":"パレスチナ"},"nld":{"official":"Staat Palestina","common":"Palestijnse gebieden"},"por":{"official":"Estado da Palestina","common":"Palestina"},"rus":{"official":"Государство Палестина","common":"Палестина"},"slk":{"official":"Palestínsky štát","common":"Palestína"},"spa":{"official":"Estado de Palestina","common":"Palestina"},"fin":{"official":"Palestiinan valtio","common":"Palestiina"},"est":{"official":"Palestiina Riik","common":"Palestiina"},"zho":{"official":"巴勒斯坦国","common":"巴勒斯坦"}},"latlng":[31.9,35.2],"demonym":"Palestinian","landlocked":false,"borders":["ISR","EGY","JOR"],"area":6220,"flag":"🇵🇸"},{"name":{"common":"French Polynesia","official":"French Polynesia","native":{"fra":{"official":"Polynésie française","common":"Polynésie française"}}},"tld":[".pf"],"cca2":"PF","ccn3":"258","cca3":"PYF","cioc":"","independent":false,"status":"officially-assigned","currency":["XPF"],"callingCode":["689"],"capital":["Papeetē"],"altSpellings":["PF","Polynésie française","French Polynesia","Pōrīnetia Farāni"],"region":"Oceania","subregion":"Polynesia","languages":{"fra":"French"},"translations":{"deu":{"official":"Französisch-Polynesien","common":"Französisch-Polynesien"},"fra":{"official":"Polynésie française","common":"Polynésie française"},"hrv":{"official":"Francuska Polinezija","common":"Francuska Polinezija"},"ita":{"official":"Polinesia Francese","common":"Polinesia Francese"},"jpn":{"official":"フランス領ポリネシア","common":"フランス領ポリネシア"},"nld":{"official":"Frans-Polynesië","common":"Frans-Polynesië"},"por":{"official":"Polinésia Francesa","common":"Polinésia Francesa"},"rus":{"official":"Французская Полинезия","common":"Французская Полинезия"},"slk":{"official":"Francúzska Polynézia","common":"Francúzska Polynézia"},"spa":{"official":"Polinesia francés","common":"Polinesia Francesa"},"fin":{"official":"Ranskan Polynesia","common":"Ranskan Polynesia"},"est":{"official":"Prantsuse Polüneesia","common":"Prantsuse Polüneesia"},"zho":{"official":"法属波利尼西亚","common":"法属波利尼西亚"}},"latlng":[-15,-140],"demonym":"French Polynesian","landlocked":false,"borders":[],"area":4167,"flag":"🇵🇫"},{"name":{"common":"Qatar","official":"State of Qatar","native":{"ara":{"official":"دولة قطر","common":"قطر"}}},"tld":[".qa","قطر."],"cca2":"QA","ccn3":"634","cca3":"QAT","cioc":"QAT","independent":true,"status":"officially-assigned","currency":["QAR"],"callingCode":["974"],"capital":["Doha"],"altSpellings":["QA","State of Qatar","Dawlat Qaṭar"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Staat Katar","common":"Katar"},"fra":{"official":"État du Qatar","common":"Qatar"},"hrv":{"official":"Država Katar","common":"Katar"},"ita":{"official":"Stato del Qatar","common":"Qatar"},"jpn":{"official":"カタール国","common":"カタール"},"nld":{"official":"Staat Qatar","common":"Qatar"},"por":{"official":"Estado do Qatar","common":"Catar"},"rus":{"official":"Государство Катар","common":"Катар"},"slk":{"official":"Katarský štát","common":"Katar"},"spa":{"official":"Estado de Qatar","common":"Catar"},"fin":{"official":"Qatarin valtio","common":"Qatar"},"est":{"official":"Katari Riik","common":"Katar"},"zho":{"official":"卡塔尔国","common":"卡塔尔"}},"latlng":[25.5,51.25],"demonym":"Qatari","landlocked":false,"borders":["SAU"],"area":11586,"flag":"🇶🇦"},{"name":{"common":"Réunion","official":"Réunion Island","native":{"fra":{"official":"Ile de la Réunion","common":"La Réunion"}}},"tld":[".re"],"cca2":"RE","ccn3":"638","cca3":"REU","cioc":"","independent":false,"status":"officially-assigned","currency":["EUR"],"callingCode":["262"],"capital":["Saint-Denis"],"altSpellings":["RE","Reunion"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French"},"translations":{"deu":{"official":"Réunion","common":"Réunion"},"fra":{"official":"Ile de la Réunion","common":"Réunion"},"hrv":{"official":"Réunion Island","common":"Réunion"},"ita":{"official":"Réunion","common":"Riunione"},"jpn":{"official":"レユニオン島","common":"レユニオン"},"nld":{"official":"Réunion","common":"Réunion"},"por":{"official":"Ilha da Reunião","common":"Reunião"},"rus":{"official":"Реюньон","common":"Реюньон"},"slk":{"official":"Réunionský zámorský departmán","common":"Réunion"},"spa":{"official":"Isla de la Reunión","common":"Reunión"},"fin":{"official":"Réunion","common":"Réunion"},"est":{"official":"Réunioni departemang","common":"Réunion"},"zho":{"official":"留尼旺岛","common":"留尼旺岛"}},"latlng":[-21.15,55.5],"demonym":"French","landlocked":false,"borders":[],"area":2511,"flag":"🇷🇪"},{"name":{"common":"Romania","official":"Romania","native":{"ron":{"official":"România","common":"România"}}},"tld":[".ro"],"cca2":"RO","ccn3":"642","cca3":"ROU","cioc":"ROU","independent":true,"status":"officially-assigned","currency":["RON"],"callingCode":["40"],"capital":["Bucharest"],"altSpellings":["RO","Rumania","Roumania","România"],"region":"Europe","subregion":"Eastern Europe","languages":{"ron":"Romanian"},"translations":{"deu":{"official":"Rumänien","common":"Rumänien"},"fra":{"official":"Roumanie","common":"Roumanie"},"hrv":{"official":"Rumunija","common":"Rumunjska"},"ita":{"official":"Romania","common":"Romania"},"jpn":{"official":"ルーマニア","common":"ルーマニア"},"nld":{"official":"Roemenië","common":"Roemenië"},"por":{"official":"Romênia","common":"Roménia"},"rus":{"official":"Румыния","common":"Румыния"},"slk":{"official":"Rumunsko","common":"Rumunsko"},"spa":{"official":"Rumania","common":"Rumania"},"fin":{"official":"Romania","common":"Romania"},"est":{"official":"Rumeenia","common":"Rumeenia"},"zho":{"official":"罗马尼亚","common":"罗马尼亚"}},"latlng":[46,25],"demonym":"Romanian","landlocked":false,"borders":["BGR","HUN","MDA","SRB","UKR"],"area":238391,"flag":"🇷🇴"},{"name":{"common":"Russia","official":"Russian Federation","native":{"rus":{"official":"Российская Федерация","common":"Россия"}}},"tld":[".ru",".su",".рф"],"cca2":"RU","ccn3":"643","cca3":"RUS","cioc":"RUS","independent":true,"status":"officially-assigned","currency":["RUB"],"callingCode":["7"],"capital":["Moscow"],"altSpellings":["RU","Russian Federation","Российская Федерация"],"region":"Europe","subregion":"Eastern Europe","languages":{"rus":"Russian"},"translations":{"deu":{"official":"Russische Föderation","common":"Russland"},"fra":{"official":"Fédération de Russie","common":"Russie"},"hrv":{"official":"Ruska Federacija","common":"Rusija"},"ita":{"official":"Federazione russa","common":"Russia"},"jpn":{"official":"ロシア連邦","common":"ロシア連邦"},"nld":{"official":"Russische Federatie","common":"Rusland"},"por":{"official":"Federação Russa","common":"Rússia"},"rus":{"official":"Российская Федерация","common":"Россия"},"slk":{"official":"Ruská federácia","common":"Rusko"},"spa":{"official":"Federación de Rusia","common":"Rusia"},"fin":{"official":"Venäjän federaatio","common":"Venäjä"},"est":{"official":"Venemaa Föderatsioon","common":"Venemaa"},"zho":{"official":"俄罗斯联邦","common":"俄罗斯"}},"latlng":[60,100],"demonym":"Russian","landlocked":false,"borders":["AZE","BLR","CHN","EST","FIN","GEO","KAZ","PRK","LVA","LTU","MNG","NOR","POL","UKR"],"area":17098242,"flag":"🇷🇺"},{"name":{"common":"Rwanda","official":"Republic of Rwanda","native":{"eng":{"official":"Republic of Rwanda","common":"Rwanda"},"fra":{"official":"République rwandaise","common":"Rwanda"},"kin":{"official":"Repubulika y'u Rwanda","common":"Rwanda"}}},"tld":[".rw"],"cca2":"RW","ccn3":"646","cca3":"RWA","cioc":"RWA","independent":true,"status":"officially-assigned","currency":["RWF"],"callingCode":["250"],"capital":["Kigali"],"altSpellings":["RW","Republic of Rwanda","Repubulika y'u Rwanda","République du Rwanda"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","fra":"French","kin":"Kinyarwanda"},"translations":{"deu":{"official":"Republik Ruanda","common":"Ruanda"},"fra":{"official":"République rwandaise","common":"Rwanda"},"hrv":{"official":"Republika Ruandi","common":"Ruanda"},"ita":{"official":"Repubblica del Ruanda","common":"Ruanda"},"jpn":{"official":"ルワンダ共和国","common":"ルワンダ"},"nld":{"official":"Republiek Rwanda","common":"Rwanda"},"por":{"official":"República do Ruanda","common":"Ruanda"},"rus":{"official":"Республика Руанда","common":"Руанда"},"slk":{"official":"Rwandská republika","common":"Rwanda"},"spa":{"official":"República de Rwanda","common":"Ruanda"},"fin":{"official":"Ruandan tasavalta","common":"Ruanda"},"est":{"official":"Rwanda Vabariik","common":"Rwanda"},"zho":{"official":"卢旺达共和国","common":"卢旺达"}},"latlng":[-2,30],"demonym":"Rwandan","landlocked":true,"borders":["BDI","COD","TZA","UGA"],"area":26338,"flag":"🇷🇼"},{"name":{"common":"Saudi Arabia","official":"Kingdom of Saudi Arabia","native":{"ara":{"official":"المملكة العربية السعودية","common":"العربية السعودية"}}},"tld":[".sa",".السعودية"],"cca2":"SA","ccn3":"682","cca3":"SAU","cioc":"KSA","independent":true,"status":"officially-assigned","currency":["SAR"],"callingCode":["966"],"capital":["Riyadh"],"altSpellings":["Saudi","SA","Kingdom of Saudi Arabia","Al-Mamlakah al-‘Arabiyyah as-Su‘ūdiyyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Königreich Saudi-Arabien","common":"Saudi-Arabien"},"fra":{"official":"Royaume d'Arabie Saoudite","common":"Arabie Saoudite"},"hrv":{"official":"Kraljevina Saudijska Arabija","common":"Saudijska Arabija"},"ita":{"official":"Arabia Saudita","common":"Arabia Saudita"},"jpn":{"official":"サウジアラビア王国","common":"サウジアラビア"},"nld":{"official":"Koninkrijk van Saoedi-Arabië","common":"Saoedi-Arabië"},"por":{"official":"Reino da Arábia Saudita","common":"Arábia Saudita"},"rus":{"official":"Королевство Саудовская Аравия","common":"Саудовская Аравия"},"slk":{"official":"Saudskoarabské kráľovstvo","common":"Saudská Arábia"},"spa":{"official":"Reino de Arabia Saudita","common":"Arabia Saudí"},"fin":{"official":"Saudi-Arabian kuningaskunta","common":"Saudi-Arabia"},"est":{"official":"Saudi Araabia Kuningriik","common":"Saudi Araabia"},"zho":{"official":"沙特阿拉伯王国","common":"沙特阿拉伯"}},"latlng":[25,45],"demonym":"Saudi Arabian","landlocked":false,"borders":["IRQ","JOR","KWT","OMN","QAT","ARE","YEM"],"area":2149690,"flag":"🇸🇦"},{"name":{"common":"Sudan","official":"Republic of the Sudan","native":{"ara":{"official":"جمهورية السودان","common":"السودان"},"eng":{"official":"Republic of the Sudan","common":"Sudan"}}},"tld":[".sd"],"cca2":"SD","ccn3":"729","cca3":"SDN","cioc":"SUD","independent":true,"status":"officially-assigned","currency":["SDG"],"callingCode":["249"],"capital":["Khartoum"],"altSpellings":["SD","Republic of the Sudan","Jumhūrīyat as-Sūdān"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic","eng":"English"},"translations":{"deu":{"official":"Republik Sudan","common":"Sudan"},"fra":{"official":"République du Soudan","common":"Soudan"},"hrv":{"official":"Republika Sudan","common":"Sudan"},"ita":{"official":"Repubblica del Sudan","common":"Sudan"},"jpn":{"official":"スーダン共和国","common":"スーダン"},"nld":{"official":"Republiek Soedan","common":"Soedan"},"por":{"official":"República do Sudão","common":"Sudão"},"rus":{"official":"Республика Судан","common":"Судан"},"slk":{"official":"Sudánska republika","common":"Sudán"},"spa":{"official":"República de Sudán","common":"Sudán"},"fin":{"official":"Sudanin tasavalta","common":"Sudan"},"est":{"official":"Sudaani Vabariik","common":"Sudaan"},"zho":{"official":"苏丹共和国","common":"苏丹"}},"latlng":[15,30],"demonym":"Sudanese","landlocked":false,"borders":["CAF","TCD","EGY","ERI","ETH","LBY","SSD"],"area":1886068,"flag":"🇸🇩"},{"name":{"common":"Senegal","official":"Republic of Senegal","native":{"fra":{"official":"République du Sénégal","common":"Sénégal"}}},"tld":[".sn"],"cca2":"SN","ccn3":"686","cca3":"SEN","cioc":"SEN","independent":true,"status":"officially-assigned","currency":["XOF"],"callingCode":["221"],"capital":["Dakar"],"altSpellings":["SN","Republic of Senegal","République du Sénégal"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"deu":{"official":"Republik Senegal","common":"Senegal"},"fra":{"official":"République du Sénégal","common":"Sénégal"},"hrv":{"official":"Republika Senegal","common":"Senegal"},"ita":{"official":"Repubblica del Senegal","common":"Senegal"},"jpn":{"official":"セネガル共和国","common":"セネガル"},"nld":{"official":"Republiek Senegal","common":"Senegal"},"por":{"official":"República do Senegal","common":"Senegal"},"rus":{"official":"Республика Сенегал","common":"Сенегал"},"slk":{"official":"Senegalská republika","common":"Senegal"},"spa":{"official":"República de Senegal","common":"Senegal"},"fin":{"official":"Senegalin tasavalta","common":"Senegal"},"est":{"official":"Senegali Vabariik","common":"Senegal"},"zho":{"official":"塞内加尔共和国","common":"塞内加尔"}},"latlng":[14,-14],"demonym":"Senegalese","landlocked":false,"borders":["GMB","GIN","GNB","MLI","MRT"],"area":196722,"flag":"🇸🇳"},{"name":{"common":"Singapore","official":"Republic of Singapore","native":{"zho":{"official":"新加坡共和国","common":"新加坡"},"eng":{"official":"Republic of Singapore","common":"Singapore"},"msa":{"official":"Republik Singapura","common":"Singapura"},"tam":{"official":"சிங்கப்பூர் குடியரசு","common":"சிங்கப்பூர்"}}},"tld":[".sg",".新加坡",".சிங்கப்பூர்"],"cca2":"SG","ccn3":"702","cca3":"SGP","cioc":"SIN","independent":true,"status":"officially-assigned","currency":["SGD"],"callingCode":["65"],"capital":["Singapore"],"altSpellings":["SG","Singapura","Republik Singapura","新加坡共和国"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"zho":"Chinese","eng":"English","msa":"Malay","tam":"Tamil"},"translations":{"deu":{"official":"Republik Singapur","common":"Singapur"},"fra":{"official":"République de Singapour","common":"Singapour"},"hrv":{"official":"Republika Singapur","common":"Singapur"},"ita":{"official":"Repubblica di Singapore","common":"Singapore"},"jpn":{"official":"シンガポール共和国","common":"シンガポール"},"nld":{"official":"Republiek Singapore","common":"Singapore"},"por":{"official":"República de Singapura","common":"Singapura"},"rus":{"official":"Республика Сингапур","common":"Сингапур"},"slk":{"official":"Singapurská republika","common":"Singapur"},"spa":{"official":"República de Singapur","common":"Singapur"},"fin":{"official":"Singaporen tasavalta","common":"Singapore"},"est":{"official":"Singapuri Vabariik","common":"Singapur"}},"latlng":[1.36666666,103.8],"demonym":"Singaporean","landlocked":false,"borders":[],"area":710,"flag":"🇸🇬"},{"name":{"common":"South Georgia","official":"South Georgia and the South Sandwich Islands","native":{"eng":{"official":"South Georgia and the South Sandwich Islands","common":"South Georgia"}}},"tld":[".gs"],"cca2":"GS","ccn3":"239","cca3":"SGS","cioc":"","independent":false,"status":"officially-assigned","currency":["GBP"],"callingCode":["500"],"capital":["King Edward Point"],"altSpellings":["GS","South Georgia and the South Sandwich Islands"],"region":"Antarctic","subregion":"","languages":{"eng":"English"},"translations":{"deu":{"official":"Südgeorgien und die Südlichen Sandwichinseln","common":"Südgeorgien und die Südlichen Sandwichinseln"},"fra":{"official":"Géorgie du Sud et les îles Sandwich du Sud","common":"Géorgie du Sud-et-les Îles Sandwich du Sud"},"hrv":{"official":"Južna Džordžija i Otoci Južni Sendvič","common":"Južna Georgija i otočje Južni Sandwich"},"ita":{"official":"Georgia del Sud e isole Sandwich del Sud","common":"Georgia del Sud e Isole Sandwich Meridionali"},"jpn":{"official":"サウスジョージア·サウスサンドウィッチ諸島","common":"サウスジョージア・サウスサンドウィッチ諸島"},"nld":{"official":"Zuid-Georgië en de Zuidelijke Sandwich-eilanden","common":"Zuid-Georgia en Zuidelijke Sandwicheilanden"},"por":{"official":"Geórgia do Sul e Sandwich do Sul","common":"Ilhas Geórgia do Sul e Sandwich do Sul"},"rus":{"official":"Южная Георгия и Южные Сандвичевы острова","common":"Южная Георгия и Южные Сандвичевы острова"},"slk":{"official":"Južná Georgia a Južné Sandwichove ostrovy","common":"Južná Georgia a Južné Sandwichove ostrovy"},"spa":{"official":"Georgia del Sur y las Islas Sandwich del Sur","common":"Islas Georgias del Sur y Sandwich del Sur"},"fin":{"official":"Etelä-Georgia ja Eteläiset Sandwichsaaret","common":"Etelä-Georgia ja Eteläiset Sandwichsaaret"},"est":{"official":"Lõuna-Georgia ja Lõuna-Sandwichi saared","common":"Lõuna-Georgia ja Lõuna-Sandwichi saared"},"zho":{"official":"南乔治亚岛和南桑威奇群岛","common":"南乔治亚"}},"latlng":[-54.5,-37],"demonym":"South Georgian South Sandwich Islander","landlocked":false,"borders":[],"area":3903,"flag":"🇬🇸"},{"name":{"common":"Svalbard and Jan Mayen","official":"Svalbard og Jan Mayen","native":{"nor":{"official":"Svalbard og Jan Mayen","common":"Svalbard og Jan Mayen"}}},"tld":[".sj"],"cca2":"SJ","ccn3":"744","cca3":"SJM","cioc":"","independent":false,"status":"officially-assigned","currency":["NOK"],"callingCode":["4779"],"capital":["Longyearbyen"],"altSpellings":["SJ","Svalbard and Jan Mayen Islands"],"region":"Europe","subregion":"Northern Europe","languages":{"nor":"Norwegian"},"translations":{"deu":{"official":"Inselgruppe Spitzbergen","common":"Spitzbergen"},"fra":{"official":"Jan Mayen Svalbard","common":"Svalbard et Jan Mayen"},"hrv":{"official":"Svalbard og Jan Mayen","common":"Svalbard i Jan Mayen"},"ita":{"official":"Svalbard og Jan Mayen","common":"Svalbard e Jan Mayen"},"jpn":{"official":"スバールバル諸島OGヤンマイエン","common":"スヴァールバル諸島およびヤンマイエン島"},"nld":{"official":"Svalbard og Jan Mayen","common":"Svalbard en Jan Mayen"},"por":{"official":"Svalbard og Jan Mayen","common":"Ilhas Svalbard e Jan Mayen"},"rus":{"official":"Свальбарда ог Ян-Майен","common":"Шпицберген и Ян-Майен"},"slk":{"official":"Svalbard a Jan Mayen","common":"Svalbard a Jan Mayen"},"spa":{"official":"Svalbard og Jan Mayen","common":"Islas Svalbard y Jan Mayen"},"fin":{"official":"Huippuvuoret","common":"Huippuvuoret"},"est":{"official":"Svalbard","common":"Svalbard"},"zho":{"official":"斯瓦尔巴特","common":"斯瓦尔巴特"}},"latlng":[78,20],"demonym":"Norwegian","landlocked":false,"borders":[],"area":-1,"flag":"🇸🇯"},{"name":{"common":"Solomon Islands","official":"Solomon Islands","native":{"eng":{"official":"Solomon Islands","common":"Solomon Islands"}}},"tld":[".sb"],"cca2":"SB","ccn3":"090","cca3":"SLB","cioc":"SOL","independent":true,"status":"officially-assigned","currency":["SBD"],"callingCode":["677"],"capital":["Honiara"],"altSpellings":["SB"],"region":"Oceania","subregion":"Melanesia","languages":{"eng":"English"},"translations":{"deu":{"official":"Salomon-Inseln","common":"Salomonen"},"fra":{"official":"Îles Salomon","common":"Îles Salomon"},"hrv":{"official":"Solomonski Otoci","common":"Solomonski Otoci"},"ita":{"official":"Isole Salomone","common":"Isole Salomone"},"jpn":{"official":"ソロモン諸島","common":"ソロモン諸島"},"nld":{"official":"Solomon eilanden","common":"Salomonseilanden"},"por":{"official":"Ilhas Salomão","common":"Ilhas Salomão"},"rus":{"official":"Соломоновы острова","common":"Соломоновы Острова"},"slk":{"official":"Salomonove ostrovy","common":"Salomonove ostrovy"},"spa":{"official":"islas Salomón","common":"Islas Salomón"},"fin":{"official":"Salomonsaaret","common":"Salomonsaaret"},"est":{"official":"Saalomoni Saared","common":"Saalomoni Saared"},"zho":{"official":"所罗门群岛","common":"所罗门群岛"}},"latlng":[-8,159],"demonym":"Solomon Islander","landlocked":false,"borders":[],"area":28896,"flag":"🇸🇧"},{"name":{"common":"Sierra Leone","official":"Republic of Sierra Leone","native":{"eng":{"official":"Republic of Sierra Leone","common":"Sierra Leone"}}},"tld":[".sl"],"cca2":"SL","ccn3":"694","cca3":"SLE","cioc":"SLE","independent":true,"status":"officially-assigned","currency":["SLL"],"callingCode":["232"],"capital":["Freetown"],"altSpellings":["SL","Republic of Sierra Leone"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"deu":{"official":"Republik Sierra Leone","common":"Sierra Leone"},"fra":{"official":"République de Sierra Leone","common":"Sierra Leone"},"hrv":{"official":"Republika Sijera Leone","common":"Sijera Leone"},"ita":{"official":"Repubblica della Sierra Leone","common":"Sierra Leone"},"jpn":{"official":"シエラレオネ共和国","common":"シエラレオネ"},"nld":{"official":"Republiek Sierra Leone","common":"Sierra Leone"},"por":{"official":"República da Serra Leoa","common":"Serra Leoa"},"rus":{"official":"Республика Сьерра-Леоне","common":"Сьерра-Леоне"},"slk":{"official":"Sierraleonská republika","common":"Sierra Leone"},"spa":{"official":"República de Sierra Leona","common":"Sierra Leone"},"fin":{"official":"Sierra Leonen tasavalta","common":"Sierra Leone"},"est":{"official":"Sierra Leone Vabariik","common":"Sierra Leone"},"zho":{"official":"塞拉利昂共和国","common":"塞拉利昂"}},"latlng":[8.5,-11.5],"demonym":"Sierra Leonean","landlocked":false,"borders":["GIN","LBR"],"area":71740,"flag":"🇸🇱"},{"name":{"common":"El Salvador","official":"Republic of El Salvador","native":{"spa":{"official":"República de El Salvador","common":"El Salvador"}}},"tld":[".sv"],"cca2":"SV","ccn3":"222","cca3":"SLV","cioc":"ESA","independent":true,"status":"officially-assigned","currency":["SVC","USD"],"callingCode":["503"],"capital":["San Salvador"],"altSpellings":["SV","Republic of El Salvador","República de El Salvador"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"cym":{"official":"Gweriniaeth El Salfador","common":"El Salfador"},"deu":{"official":"Republik El Salvador","common":"El Salvador"},"fra":{"official":"République du Salvador","common":"Salvador"},"hrv":{"official":"Republika El Salvador","common":"Salvador"},"ita":{"official":"Repubblica di El Salvador","common":"El Salvador"},"jpn":{"official":"エルサルバドル共和国","common":"エルサルバドル"},"nld":{"official":"Republiek El Salvador","common":"El Salvador"},"por":{"official":"República de El Salvador","common":"El Salvador"},"rus":{"official":"Республика Эль-Сальвадор","common":"Сальвадор"},"slk":{"official":"Salvádorská republika","common":"Salvádor"},"spa":{"official":"República de El Salvador","common":"El Salvador"},"fin":{"official":"El Salvadorin tasavalta","common":"El Salvador"},"est":{"official":"El Salvadori Vabariik","common":"El Salvador"},"zho":{"official":"萨尔瓦多共和国","common":"萨尔瓦多"}},"latlng":[13.83333333,-88.91666666],"demonym":"Salvadoran","landlocked":false,"borders":["GTM","HND"],"area":21041,"flag":"🇸🇻"},{"name":{"common":"San Marino","official":"Most Serene Republic of San Marino","native":{"ita":{"official":"Serenissima Repubblica di San Marino","common":"San Marino"}}},"tld":[".sm"],"cca2":"SM","ccn3":"674","cca3":"SMR","cioc":"SMR","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["378"],"capital":["City of San Marino"],"altSpellings":["SM","Republic of San Marino","Repubblica di San Marino"],"region":"Europe","subregion":"Southern Europe","languages":{"ita":"Italian"},"translations":{"deu":{"official":"Republik San Marino","common":"San Marino"},"fra":{"official":"République de Saint-Marin","common":"Saint-Marin"},"hrv":{"official":"Većina Serene Republika San Marino","common":"San Marino"},"ita":{"official":"Serenissima Repubblica di San Marino","common":"San Marino"},"jpn":{"official":"サンマリノのほとんどセリーヌ共和国","common":"サンマリノ"},"nld":{"official":"Meest Serene Republiek San Marino","common":"San Marino"},"por":{"official":"Sereníssima República de San Marino","common":"San Marino"},"rus":{"official":"Большинство Serene Республика Сан-Марино","common":"Сан-Марино"},"slk":{"official":"Sanmarínska republika","common":"San Maríno"},"spa":{"official":"Serenísima República de San Marino","common":"San Marino"},"fin":{"official":"San Marinon seesteinen tasavalta","common":"San Marino"},"est":{"official":"San Marino Vabariik","common":"San Marino"},"zho":{"official":"圣马力诺共和国","common":"圣马力诺"}},"latlng":[43.76666666,12.41666666],"demonym":"Sammarinese","landlocked":true,"borders":["ITA"],"area":61,"flag":"🇸🇲"},{"name":{"common":"Somalia","official":"Federal Republic of Somalia","native":{"ara":{"official":"جمهورية الصومال‎‎","common":"الصومال‎‎"},"som":{"official":"Jamhuuriyadda Federaalka Soomaaliya","common":"Soomaaliya"}}},"tld":[".so"],"cca2":"SO","ccn3":"706","cca3":"SOM","cioc":"SOM","independent":true,"status":"officially-assigned","currency":["SOS"],"callingCode":["252"],"capital":["Mogadishu"],"altSpellings":["SO","aṣ-Ṣūmāl","Federal Republic of Somalia","Jamhuuriyadda Federaalka Soomaaliya","Jumhūriyyat aṣ-Ṣūmāl al-Fiderāliyya"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","som":"Somali"},"translations":{"deu":{"official":"Bundesrepublik Somalia","common":"Somalia"},"fra":{"official":"République fédérale de Somalie","common":"Somalie"},"hrv":{"official":"Savezna Republika Somaliji","common":"Somalija"},"ita":{"official":"Repubblica federale di Somalia","common":"Somalia"},"jpn":{"official":"ソマリア連邦共和国","common":"ソマリア"},"nld":{"official":"Federale Republiek Somalië","common":"Somalië"},"por":{"official":"República Federal da Somália","common":"Somália"},"rus":{"official":"Федеративная Республика Сомали","common":"Сомали"},"slk":{"official":"Somálska federatívna republika","common":"Somálsko"},"spa":{"official":"República Federal de Somalia","common":"Somalia"},"fin":{"official":"Somalian liittotasavalta","common":"Somalia"},"est":{"official":"Somaalia Liitvabariik","common":"Somaalia"},"zho":{"official":"索马里共和国","common":"索马里"}},"latlng":[10,49],"demonym":"Somali","landlocked":false,"borders":["DJI","ETH","KEN"],"area":637657,"flag":"🇸🇴"},{"name":{"common":"Saint Pierre and Miquelon","official":"Saint Pierre and Miquelon","native":{"fra":{"official":"Collectivité territoriale de Saint-Pierre-et-Miquelon","common":"Saint-Pierre-et-Miquelon"}}},"tld":[".pm"],"cca2":"PM","ccn3":"666","cca3":"SPM","cioc":"","independent":false,"status":"officially-assigned","currency":["EUR"],"callingCode":["508"],"capital":["Saint-Pierre"],"altSpellings":["PM","Collectivité territoriale de Saint-Pierre-et-Miquelon"],"region":"Americas","subregion":"Northern America","languages":{"fra":"French"},"translations":{"deu":{"official":"St. Pierre und Miquelon","common":"Saint-Pierre und Miquelon"},"fra":{"official":"Saint-Pierre-et-Miquelon","common":"Saint-Pierre-et-Miquelon"},"hrv":{"official":"Saint Pierre i Miquelon","common":"Sveti Petar i Mikelon"},"ita":{"official":"Saint Pierre e Miquelon","common":"Saint-Pierre e Miquelon"},"jpn":{"official":"サンピエール島·ミクロン島","common":"サンピエール島・ミクロン島"},"nld":{"official":"Saint-Pierre en Miquelon","common":"Saint Pierre en Miquelon"},"por":{"official":"Saint Pierre e Miquelon","common":"Saint-Pierre e Miquelon"},"rus":{"official":"Сен-Пьер и Микелон","common":"Сен-Пьер и Микелон"},"slk":{"official":"Ostrovy Saint Pierre a Miquelon","common":"Saint Pierre a Miquelon"},"spa":{"official":"San Pedro y Miquelón","common":"San Pedro y Miquelón"},"fin":{"official":"Saint-Pierre ja Miquelon","common":"Saint-Pierre ja Miquelon"},"est":{"official":"Saint-Pierre’i ja Miqueloni territoriaalühendus","common":"Saint-Pierre ja Miquelon"},"zho":{"official":"圣皮埃尔和密克隆","common":"圣皮埃尔和密克隆"}},"latlng":[46.83333333,-56.33333333],"demonym":"French","landlocked":false,"borders":[],"area":242,"flag":"🇵🇲"},{"name":{"common":"Serbia","official":"Republic of Serbia","native":{"srp":{"official":"Република Србија","common":"Србија"}}},"tld":[".rs",".срб"],"cca2":"RS","ccn3":"688","cca3":"SRB","cioc":"SRB","independent":true,"status":"officially-assigned","currency":["RSD"],"callingCode":["381"],"capital":["Belgrade"],"altSpellings":["RS","Srbija","Republic of Serbia","Република Србија","Republika Srbija"],"region":"Europe","subregion":"Southern Europe","languages":{"srp":"Serbian"},"translations":{"deu":{"official":"Republik Serbien","common":"Serbien"},"fra":{"official":"République de Serbie","common":"Serbie"},"hrv":{"official":"Republika Srbija","common":"Srbija"},"ita":{"official":"Repubblica di Serbia","common":"Serbia"},"jpn":{"official":"セルビア共和国","common":"セルビア"},"nld":{"official":"Republiek Servië","common":"Servië"},"por":{"official":"República da Sérvia","common":"Sérvia"},"rus":{"official":"Республика Сербия","common":"Сербия"},"slk":{"official":"Srbská republika","common":"Srbsko"},"spa":{"official":"República de Serbia","common":"Serbia"},"fin":{"official":"Serbian tasavalta","common":"Serbia"},"est":{"official":"Serbia Vabariik","common":"Serbia"},"zho":{"official":"塞尔维亚共和国","common":"塞尔维亚"}},"latlng":[44,21],"demonym":"Serbian","landlocked":true,"borders":["BIH","BGR","HRV","HUN","UNK","MKD","MNE","ROU"],"area":88361,"flag":"🇷🇸"},{"name":{"common":"South Sudan","official":"Republic of South Sudan","native":{"eng":{"official":"Republic of South Sudan","common":"South Sudan"}}},"tld":[".ss"],"cca2":"SS","ccn3":"728","cca3":"SSD","cioc":"","independent":true,"status":"officially-assigned","currency":["SSP"],"callingCode":["211"],"capital":["Juba"],"altSpellings":["SS"],"region":"Africa","subregion":"Middle Africa","languages":{"eng":"English"},"translations":{"deu":{"official":"Republik Südsudan","common":"Südsudan"},"fra":{"official":"République du Soudan du Sud","common":"Soudan du Sud"},"hrv":{"official":"Republika Južni Sudan","common":"Južni Sudan"},"ita":{"official":"Repubblica del Sudan del Sud","common":"Sudan del sud"},"jpn":{"official":"南スーダン共和国","common":"南スーダン"},"nld":{"official":"Republiek Zuid-Soedan","common":"Zuid-Soedan"},"por":{"official":"República do Sudão do Sul","common":"Sudão do Sul"},"rus":{"official":"Республика Южный Судан","common":"Южный Судан"},"slk":{"official":"Juhosudánska republika","common":"Južný Sudán"},"spa":{"official":"República de Sudán del Sur","common":"Sudán del Sur"},"fin":{"official":"Etelä-Sudanin tasavalta","common":"Etelä-Sudan"},"est":{"official":"Lõuna-Sudaani Vabariik","common":"Lõuna-Sudaan"},"zho":{"official":"南苏丹共和国","common":"南苏丹"}},"latlng":[7,30],"demonym":"South Sudanese","landlocked":true,"borders":["CAF","COD","ETH","KEN","SDN","UGA"],"area":619745,"flag":"🇸🇸"},{"name":{"common":"São Tomé and Príncipe","official":"Democratic Republic of São Tomé and Príncipe","native":{"por":{"official":"República Democrática do São Tomé e Príncipe","common":"São Tomé e Príncipe"}}},"tld":[".st"],"cca2":"ST","ccn3":"678","cca3":"STP","cioc":"STP","independent":true,"status":"officially-assigned","currency":["STD"],"callingCode":["239"],"capital":["São Tomé"],"altSpellings":["ST","Democratic Republic of São Tomé and Príncipe","Sao Tome and Principe","República Democrática de São Tomé e Príncipe"],"region":"Africa","subregion":"Middle Africa","languages":{"por":"Portuguese"},"translations":{"deu":{"official":"Demokratische Republik São Tomé und Príncipe","common":"São Tomé und Príncipe"},"fra":{"official":"République démocratique de São Tomé et Príncipe","common":"São Tomé et Príncipe"},"hrv":{"official":"Demokratska Republika São Tome i Principe","common":"Sveti Toma i Princip"},"ita":{"official":"Repubblica democratica di São Tomé e Príncipe","common":"São Tomé e Príncipe"},"jpn":{"official":"サントメ·プリンシペ民主共和国","common":"サントメ・プリンシペ"},"nld":{"official":"Democratische Republiek Sao Tomé en Principe","common":"Sao Tomé en Principe"},"por":{"official":"República Democrática de São Tomé e Príncipe","common":"São Tomé e Príncipe"},"spa":{"official":"República Democrática de Santo Tomé y Príncipe","common":"Santo Tomé y Príncipe"},"rus":{"official":"Демократическая Республика Сан-Томе и Принсипи","common":"Сан-Томе и Принсипи"},"slk":{"official":"Demokratická republika Svätého Tomáša A princovho ostrova","common":"Svätý Tomáš a Princov ostrov"},"fin":{"official":"São Tomé ja Príncipen demokraattinen tasavalta","common":"São Téme ja Príncipe"},"est":{"official":"São Tomé ja Príncipe Demokraatlik Vabariik","common":"São Tomé ja Príncipe"},"zho":{"official":"圣多美和普林西比民主共和国","common":"圣多美和普林西比"}},"latlng":[1,7],"demonym":"Sao Tomean","landlocked":false,"borders":[],"area":964,"flag":"🇸🇹"},{"name":{"common":"Suriname","official":"Republic of Suriname","native":{"nld":{"official":"Republiek Suriname","common":"Suriname"}}},"tld":[".sr"],"cca2":"SR","ccn3":"740","cca3":"SUR","cioc":"SUR","independent":true,"status":"officially-assigned","currency":["SRD"],"callingCode":["597"],"capital":["Paramaribo"],"altSpellings":["SR","Sarnam","Sranangron","Republic of Suriname","Republiek Suriname"],"region":"Americas","subregion":"South America","languages":{"nld":"Dutch"},"translations":{"deu":{"official":"Republik Suriname","common":"Suriname"},"fra":{"official":"République du Suriname","common":"Surinam"},"hrv":{"official":"Republika Surinam","common":"Surinam"},"ita":{"official":"Repubblica del Suriname","common":"Suriname"},"jpn":{"official":"スリナム共和国","common":"スリナム"},"nld":{"official":"Republiek Suriname","common":"Suriname"},"por":{"official":"República do Suriname","common":"Suriname"},"rus":{"official":"Республика Суринам","common":"Суринам"},"slk":{"official":"Surinamská republika","common":"Surinam"},"spa":{"official":"República de Suriname","common":"Surinam"},"fin":{"official":"Surinamen tasavalta","common":"Suriname"},"est":{"official":"Suriname Vabariik","common":"Suriname"},"zho":{"official":"苏里南共和国","common":"苏里南"}},"latlng":[4,-56],"demonym":"Surinamer","landlocked":false,"borders":["BRA","GUF","GUY"],"area":163820,"flag":"🇸🇷"},{"name":{"common":"Slovakia","official":"Slovak Republic","native":{"slk":{"official":"Slovenská republika","common":"Slovensko"}}},"tld":[".sk"],"cca2":"SK","ccn3":"703","cca3":"SVK","cioc":"SVK","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["421"],"capital":["Bratislava"],"altSpellings":["SK","Slovak Republic","Slovenská republika"],"region":"Europe","subregion":"Central Europe","languages":{"slk":"Slovak"},"translations":{"deu":{"official":"Slowakische Republik","common":"Slowakei"},"fra":{"official":"République slovaque","common":"Slovaquie"},"hrv":{"official":"slovačka","common":"Slovačka"},"ita":{"official":"Repubblica slovacca","common":"Slovacchia"},"jpn":{"official":"スロバキア共和国","common":"スロバキア"},"nld":{"official":"Slowaakse Republiek","common":"Slowakije"},"por":{"official":"República Eslovaca","common":"Eslováquia"},"rus":{"official":"Словацкая Республика","common":"Словакия"},"slk":{"official":"Slovenská republika","common":"Slovensko"},"spa":{"official":"República Eslovaca","common":"República Eslovaca"},"fin":{"official":"Slovakian tasavalta","common":"Slovakia"},"est":{"official":"Slovaki Vabariik","common":"Slovakkia"},"zho":{"official":"斯洛伐克共和国","common":"斯洛伐克"}},"latlng":[48.66666666,19.5],"demonym":"Slovak","landlocked":true,"borders":["AUT","CZE","HUN","POL","UKR"],"area":49037,"flag":"🇸🇰"},{"name":{"common":"Slovenia","official":"Republic of Slovenia","native":{"slv":{"official":"Republika Slovenija","common":"Slovenija"}}},"tld":[".si"],"cca2":"SI","ccn3":"705","cca3":"SVN","cioc":"SLO","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["386"],"capital":["Ljubljana"],"altSpellings":["SI","Republic of Slovenia","Republika Slovenija"],"region":"Europe","subregion":"Southern Europe","languages":{"slv":"Slovene"},"translations":{"deu":{"official":"Republik Slowenien","common":"Slowenien"},"fra":{"official":"République de Slovénie","common":"Slovénie"},"hrv":{"official":"Republika Slovenija","common":"Slovenija"},"ita":{"official":"Repubblica di Slovenia","common":"Slovenia"},"jpn":{"official":"スロベニア共和国","common":"スロベニア"},"nld":{"official":"Republiek Slovenië","common":"Slovenië"},"por":{"official":"República da Eslovénia","common":"Eslovénia"},"rus":{"official":"Республика Словения","common":"Словения"},"slk":{"official":"Slovinská republika","common":"Slovinsko"},"spa":{"official":"República de Eslovenia","common":"Eslovenia"},"fin":{"official":"Slovenian tasavalta","common":"Slovenia"},"est":{"official":"Sloveenia Vabariik","common":"Sloveenia"},"zho":{"official":"斯洛文尼亚共和国","common":"斯洛文尼亚"}},"latlng":[46.11666666,14.81666666],"demonym":"Slovene","landlocked":false,"borders":["AUT","HRV","ITA","HUN"],"area":20273,"flag":"🇸🇮"},{"name":{"common":"Sweden","official":"Kingdom of Sweden","native":{"swe":{"official":"Konungariket Sverige","common":"Sverige"}}},"tld":[".se"],"cca2":"SE","ccn3":"752","cca3":"SWE","cioc":"SWE","independent":true,"status":"officially-assigned","currency":["SEK"],"callingCode":["46"],"capital":["Stockholm"],"altSpellings":["SE","Kingdom of Sweden","Konungariket Sverige"],"region":"Europe","subregion":"Northern Europe","languages":{"swe":"Swedish"},"translations":{"deu":{"official":"Königreich Schweden","common":"Schweden"},"fra":{"official":"Royaume de Suède","common":"Suède"},"hrv":{"official":"Kraljevina Švedska","common":"Švedska"},"ita":{"official":"Regno di Svezia","common":"Svezia"},"jpn":{"official":"スウェーデン王国","common":"スウェーデン"},"nld":{"official":"Koninkrijk Zweden","common":"Zweden"},"por":{"official":"Reino da Suécia","common":"Suécia"},"rus":{"official":"Королевство Швеция","common":"Швеция"},"slk":{"official":"Švédske kráľovstvo","common":"Švédsko"},"spa":{"official":"Reino de Suecia","common":"Suecia"},"fin":{"official":"Ruotsin kuningaskunta","common":"Ruotsi"},"est":{"official":"Rootsi Kuningriik","common":"Rootsi"},"zho":{"official":"瑞典王国","common":"瑞典"}},"latlng":[62,15],"demonym":"Swedish","landlocked":false,"borders":["FIN","NOR"],"area":450295,"flag":"🇸🇪"},{"name":{"common":"Swaziland","official":"Kingdom of Swaziland","native":{"eng":{"official":"Kingdom of Swaziland","common":"Swaziland"},"ssw":{"official":"Kingdom of Swaziland","common":"Swaziland"}}},"tld":[".sz"],"cca2":"SZ","ccn3":"748","cca3":"SWZ","cioc":"SWZ","independent":true,"status":"officially-assigned","currency":["SZL"],"callingCode":["268"],"capital":["Lobamba"],"altSpellings":["SZ","weSwatini","Swatini","Ngwane","Kingdom of Swaziland","Umbuso waseSwatini"],"region":"Africa","subregion":"Southern Africa","languages":{"eng":"English","ssw":"Swazi"},"translations":{"deu":{"official":"Königreich Swasiland","common":"Swasiland"},"fra":{"official":"Royaume du Swaziland","common":"Swaziland"},"hrv":{"official":"Kraljevina Svazi","common":"Svazi"},"ita":{"official":"Regno dello Swaziland","common":"Swaziland"},"jpn":{"official":"スワジランド王国","common":"スワジランド"},"nld":{"official":"Koninkrijk Swaziland","common":"Swaziland"},"por":{"official":"Reino da Suazilândia","common":"Suazilândia"},"rus":{"official":"Королевство Свазиленд","common":"Свазиленд"},"slk":{"official":"Svazijské kráľovstvo","common":"Svazijsko"},"spa":{"official":"Reino de Swazilandia","common":"Suazilandia"},"fin":{"official":"Swazimaan kuningaskunta","common":"Swazimaa"},"est":{"official":"Svaasimaa Kuningriik","common":"Svaasimaa"},"zho":{"official":"斯威士兰王国","common":"斯威士兰"}},"latlng":[-26.5,31.5],"demonym":"Swazi","landlocked":true,"borders":["MOZ","ZAF"],"area":17364,"flag":"🇸🇿"},{"name":{"common":"Sint Maarten","official":"Sint Maarten","native":{"eng":{"official":"Sint Maarten","common":"Sint Maarten"},"fra":{"official":"Saint-Martin","common":"Saint-Martin"},"nld":{"official":"Sint Maarten","common":"Sint Maarten"}}},"tld":[".sx"],"cca2":"SX","ccn3":"534","cca3":"SXM","cioc":"","independent":false,"status":"officially-assigned","currency":["ANG"],"callingCode":["1721"],"capital":["Philipsburg"],"altSpellings":["SX","Sint Maarten (Dutch part)"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","fra":"French","nld":"Dutch"},"translations":{"deu":{"official":"Sint Maarten","common":"Sint Maarten"},"fra":{"official":"Sint Maarten","common":"Saint-Martin"},"ita":{"official":"Sint Maarten","common":"Sint Maarten"},"jpn":{"official":"シントマールテン島","common":"シント・マールテン"},"nld":{"official":"Sint Maarten","common":"Sint Maarten"},"por":{"official":"Sint Maarten","common":"São Martinho"},"rus":{"official":"Синт-Маартен","common":"Синт-Мартен"},"slk":{"official":"Sint Maarten","common":"Sint Maarten"},"spa":{"official":"Sint Maarten","common":"Sint Maarten"},"fin":{"official":"Sint Maarten","common":"Sint Maarten"},"est":{"official":"Sint Maarten","common":"Sint Maarten"},"zho":{"official":"圣马丁岛","common":"圣马丁岛"}},"latlng":[18.033333,-63.05],"demonym":"St. Maartener","landlocked":false,"borders":["MAF"],"area":34,"flag":"🇸🇽"},{"name":{"common":"Seychelles","official":"Republic of Seychelles","native":{"crs":{"official":"Repiblik Sesel","common":"Sesel"},"eng":{"official":"Republic of Seychelles","common":"Seychelles"},"fra":{"official":"République des Seychelles","common":"Seychelles"}}},"tld":[".sc"],"cca2":"SC","ccn3":"690","cca3":"SYC","cioc":"SEY","independent":true,"status":"officially-assigned","currency":["SCR"],"callingCode":["248"],"capital":["Victoria"],"altSpellings":["SC","Republic of Seychelles","Repiblik Sesel","République des Seychelles"],"region":"Africa","subregion":"Eastern Africa","languages":{"crs":"Seychellois Creole","eng":"English","fra":"French"},"translations":{"deu":{"official":"Republik der Seychellen","common":"Seychellen"},"fra":{"official":"République des Seychelles","common":"Seychelles"},"hrv":{"official":"Republika Sejšeli","common":"Sejšeli"},"ita":{"official":"Repubblica delle Seychelles","common":"Seychelles"},"jpn":{"official":"セイシェル共和国","common":"セーシェル"},"nld":{"official":"Republiek der Seychellen","common":"Seychellen"},"por":{"official":"República das Seychelles","common":"Seicheles"},"rus":{"official":"Республика Сейшельские Острова","common":"Сейшельские Острова"},"slk":{"official":"Seychelská republika","common":"Seychely"},"spa":{"official":"República de las Seychelles","common":"Seychelles"},"fin":{"official":"Seychellien tasavalta","common":"Seychellit"},"est":{"official":"Seišelli Vabariik","common":"Seišellid"},"zho":{"official":"塞舌尔共和国","common":"塞舌尔"}},"latlng":[-4.58333333,55.66666666],"demonym":"Seychellois","landlocked":false,"borders":[],"area":452,"flag":"🇸🇨"},{"name":{"common":"Syria","official":"Syrian Arab Republic","native":{"ara":{"official":"الجمهورية العربية السورية","common":"سوريا"}}},"tld":[".sy","سوريا."],"cca2":"SY","ccn3":"760","cca3":"SYR","cioc":"SYR","independent":true,"status":"officially-assigned","currency":["SYP"],"callingCode":["963"],"capital":["Damascus"],"altSpellings":["SY","Syrian Arab Republic","Al-Jumhūrīyah Al-ʻArabīyah As-Sūrīyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Arabische Republik Syrien","common":"Syrien"},"fra":{"official":"République arabe syrienne","common":"Syrie"},"hrv":{"official":"Sirijska Arapska Republika","common":"Sirija"},"ita":{"official":"Repubblica araba siriana","common":"Siria"},"jpn":{"official":"シリアアラブ共和国","common":"シリア・アラブ共和国"},"nld":{"official":"Syrische Arabische Republiek","common":"Syrië"},"por":{"official":"República Árabe Síria","common":"Síria"},"rus":{"official":"Сирийская Арабская Республика","common":"Сирия"},"slk":{"official":"Sýrska arabská republika","common":"Sýria"},"spa":{"official":"República Árabe Siria","common":"Siria"},"fin":{"official":"Syyrian arabitasavalta","common":"Syyria"},"est":{"official":"Süüria Araabia Vabariik","common":"Süüria"},"zho":{"official":"叙利亚阿拉伯共和国","common":"叙利亚"}},"latlng":[35,38],"demonym":"Syrian","landlocked":false,"borders":["IRQ","ISR","JOR","LBN","TUR"],"area":185180,"flag":"🇸🇾"},{"name":{"common":"Turks and Caicos Islands","official":"Turks and Caicos Islands","native":{"eng":{"official":"Turks and Caicos Islands","common":"Turks and Caicos Islands"}}},"tld":[".tc"],"cca2":"TC","ccn3":"796","cca3":"TCA","cioc":"","independent":false,"status":"officially-assigned","currency":["USD"],"callingCode":["1649"],"capital":["Cockburn Town"],"altSpellings":["TC"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"deu":{"official":"Turks und Caicos Inseln","common":"Turks-und Caicosinseln"},"fra":{"official":"Îles Turques et Caïques","common":"Îles Turques-et-Caïques"},"hrv":{"official":"Otoci Turks i Caicos","common":"Otoci Turks i Caicos"},"ita":{"official":"Turks e Caicos","common":"Isole Turks e Caicos"},"jpn":{"official":"タークス·カイコス諸島","common":"タークス・カイコス諸島"},"nld":{"official":"Turks-en Caicoseilanden","common":"Turks-en Caicoseilanden"},"por":{"official":"Ilhas Turks e Caicos","common":"Ilhas Turks e Caicos"},"rus":{"official":"Теркс и Кайкос острова","common":"Теркс и Кайкос"},"slk":{"official":"Ostrovy Turks a Caicos","common":"Turks a Caicos"},"spa":{"official":"Islas Turcas y Caicos","common":"Islas Turks y Caicos"},"fin":{"official":"Turks-ja Caicossaaret","common":"Turks-ja Caicossaaret"},"est":{"official":"Turksi ja Caicose saared","common":"Turks ja Caicos"},"zho":{"official":"特克斯和凯科斯群岛","common":"特克斯和凯科斯群岛"}},"latlng":[21.75,-71.58333333],"demonym":"Turks and Caicos Islander","landlocked":false,"borders":[],"area":948,"flag":"🇹🇨"},{"name":{"common":"Chad","official":"Republic of Chad","native":{"ara":{"official":"جمهورية تشاد","common":"تشاد‎"},"fra":{"official":"République du Tchad","common":"Tchad"}}},"tld":[".td"],"cca2":"TD","ccn3":"148","cca3":"TCD","cioc":"CHA","independent":true,"status":"officially-assigned","currency":["XAF"],"callingCode":["235"],"capital":["N'Djamena"],"altSpellings":["TD","Tchad","Republic of Chad","République du Tchad"],"region":"Africa","subregion":"Middle Africa","languages":{"ara":"Arabic","fra":"French"},"translations":{"cym":{"official":"Gweriniaeth Tsiad","common":"Tsiad"},"deu":{"official":"Republik Tschad","common":"Tschad"},"fra":{"official":"République du Tchad","common":"Tchad"},"hrv":{"official":"Čadu","common":"Čad"},"ita":{"official":"Repubblica del Ciad","common":"Ciad"},"jpn":{"official":"チャド共和国","common":"チャド"},"nld":{"official":"Republiek Tsjaad","common":"Tsjaad"},"por":{"official":"República do Chade","common":"Chade"},"rus":{"official":"Республика Чад","common":"Чад"},"slk":{"official":"Čadská republika","common":"Čad"},"spa":{"official":"República de Chad","common":"Chad"},"fin":{"official":"Tšadin tasavalta","common":"Tšad"},"est":{"official":"Tšaadi Vabariik","common":"Tšaad"},"zho":{"official":"乍得共和国","common":"乍得"}},"latlng":[15,19],"demonym":"Chadian","landlocked":true,"borders":["CMR","CAF","LBY","NER","NGA","SDN"],"area":1284000,"flag":"🇹🇩"},{"name":{"common":"Togo","official":"Togolese Republic","native":{"fra":{"official":"République togolaise","common":"Togo"}}},"tld":[".tg"],"cca2":"TG","ccn3":"768","cca3":"TGO","cioc":"TOG","independent":true,"status":"officially-assigned","currency":["XOF"],"callingCode":["228"],"capital":["Lomé"],"altSpellings":["TG","Togolese","Togolese Republic","République Togolaise"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"deu":{"official":"Republik Togo","common":"Togo"},"fra":{"official":"République togolaise","common":"Togo"},"hrv":{"official":"Togolese Republika","common":"Togo"},"ita":{"official":"Repubblica del Togo","common":"Togo"},"jpn":{"official":"トーゴ共和国","common":"トーゴ"},"nld":{"official":"Republiek Togo","common":"Togo"},"por":{"official":"República do Togo","common":"Togo"},"rus":{"official":"Того Республика","common":"Того"},"slk":{"official":"Togská republika","common":"Togo"},"spa":{"official":"República de Togo","common":"Togo"},"fin":{"official":"Togon tasavalta","common":"Togo"},"est":{"official":"Togo Vabariik","common":"Togo"},"zho":{"official":"多哥共和国","common":"多哥"}},"latlng":[8,1.16666666],"demonym":"Togolese","landlocked":false,"borders":["BEN","BFA","GHA"],"area":56785,"flag":"🇹🇬"},{"name":{"common":"Thailand","official":"Kingdom of Thailand","native":{"tha":{"official":"ราชอาณาจักรไทย","common":"ประเทศไทย"}}},"tld":[".th",".ไทย"],"cca2":"TH","ccn3":"764","cca3":"THA","cioc":"THA","independent":true,"status":"officially-assigned","currency":["THB"],"callingCode":["66"],"capital":["Bangkok"],"altSpellings":["TH","Prathet","Thai","Kingdom of Thailand","ราชอาณาจักรไทย","Ratcha Anachak Thai"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"tha":"Thai"},"translations":{"deu":{"official":"Königreich Thailand","common":"Thailand"},"fra":{"official":"Royaume de Thaïlande","common":"Thaïlande"},"hrv":{"official":"Kraljevina Tajland","common":"Tajland"},"ita":{"official":"Regno di Thailandia","common":"Tailandia"},"jpn":{"official":"タイ王国","common":"タイ"},"nld":{"official":"Koninkrijk Thailand","common":"Thailand"},"por":{"official":"Reino da Tailândia","common":"Tailândia"},"rus":{"official":"Королевство Таиланд","common":"Таиланд"},"slk":{"official":"Thajské kráľovstvo","common":"Thajsko"},"spa":{"official":"Reino de Tailandia","common":"Tailandia"},"fin":{"official":"Thaimaan kuningaskunta","common":"Thaimaa"},"est":{"official":"Tai Kuningriik","common":"Tai"},"zho":{"official":"泰王国","common":"泰国"}},"latlng":[15,100],"demonym":"Thai","landlocked":false,"borders":["MMR","KHM","LAO","MYS"],"area":513120,"flag":"🇹🇭"},{"name":{"common":"Tajikistan","official":"Republic of Tajikistan","native":{"rus":{"official":"Республика Таджикистан","common":"Таджикистан"},"tgk":{"official":"Ҷумҳурии Тоҷикистон","common":"Тоҷикистон"}}},"tld":[".tj"],"cca2":"TJ","ccn3":"762","cca3":"TJK","cioc":"TJK","independent":true,"status":"officially-assigned","currency":["TJS"],"callingCode":["992"],"capital":["Dushanbe"],"altSpellings":["TJ","Toçikiston","Republic of Tajikistan","Ҷумҳурии Тоҷикистон","Çumhuriyi Toçikiston"],"region":"Asia","subregion":"Central Asia","languages":{"rus":"Russian","tgk":"Tajik"},"translations":{"deu":{"official":"Republik Tadschikistan","common":"Tadschikistan"},"fra":{"official":"République du Tadjikistan","common":"Tadjikistan"},"hrv":{"official":"Republika Tadžikistan","common":"Tađikistan"},"ita":{"official":"Repubblica del Tajikistan","common":"Tagikistan"},"jpn":{"official":"タジキスタン共和国","common":"タジキスタン"},"nld":{"official":"Tadzjikistan","common":"Tadzjikistan"},"por":{"official":"República do Tajiquistão","common":"Tajiquistão"},"rus":{"official":"Республика Таджикистан","common":"Таджикистан"},"slk":{"official":"Taǆická republika","common":"Taǆikistan"},"spa":{"official":"República de Tayikistán","common":"Tayikistán"},"fin":{"official":"Tadžikistanin tasavalta","common":"Tadžikistan"},"est":{"official":"Tadžikistani Vabariik","common":"Tadžikistan"},"zho":{"official":"塔吉克斯坦共和国","common":"塔吉克斯坦"}},"latlng":[39,71],"demonym":"Tadzhik","landlocked":true,"borders":["AFG","CHN","KGZ","UZB"],"area":143100,"flag":"🇹🇯"},{"name":{"common":"Tokelau","official":"Tokelau","native":{"eng":{"official":"Tokelau","common":"Tokelau"},"smo":{"official":"Tokelau","common":"Tokelau"},"tkl":{"official":"Tokelau","common":"Tokelau"}}},"tld":[".tk"],"cca2":"TK","ccn3":"772","cca3":"TKL","cioc":"","independent":false,"status":"officially-assigned","currency":["NZD"],"callingCode":["690"],"capital":["Fakaofo"],"altSpellings":["TK"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","smo":"Samoan","tkl":"Tokelauan"},"translations":{"deu":{"official":"Tokelau","common":"Tokelau"},"fra":{"official":"Îles Tokelau","common":"Tokelau"},"hrv":{"official":"Tokelau","common":"Tokelau"},"ita":{"official":"Tokelau","common":"Isole Tokelau"},"jpn":{"official":"トケラウ諸島","common":"トケラウ"},"nld":{"official":"Tokelau","common":"Tokelau"},"por":{"official":"Tokelau","common":"Tokelau"},"rus":{"official":"Токелау","common":"Токелау"},"slk":{"official":"Tokelauské ostrovy","common":"Tokelau"},"spa":{"official":"Tokelau","common":"Islas Tokelau"},"fin":{"official":"Tokelau","common":"Tokelau"},"est":{"official":"Tokelau","common":"Tokelau"},"zho":{"official":"托克劳","common":"托克劳"}},"latlng":[-9,-172],"demonym":"Tokelauan","landlocked":false,"borders":[],"area":12,"flag":"🇹🇰"},{"name":{"common":"Turkmenistan","official":"Turkmenistan","native":{"rus":{"official":"Туркменистан","common":"Туркмения"},"tuk":{"official":"Türkmenistan","common":"Türkmenistan"}}},"tld":[".tm"],"cca2":"TM","ccn3":"795","cca3":"TKM","cioc":"TKM","independent":true,"status":"officially-assigned","currency":["TMT"],"callingCode":["993"],"capital":["Ashgabat"],"altSpellings":["TM"],"region":"Asia","subregion":"Central Asia","languages":{"rus":"Russian","tuk":"Turkmen"},"translations":{"deu":{"official":"Turkmenistan","common":"Turkmenistan"},"fra":{"official":"Turkménistan","common":"Turkménistan"},"hrv":{"official":"Turkmenistan","common":"Turkmenistan"},"ita":{"official":"Turkmenistan","common":"Turkmenistan"},"jpn":{"official":"トルクメニスタン","common":"トルクメニスタン"},"nld":{"official":"Turkmenistan","common":"Turkmenistan"},"por":{"official":"Turcomenistão","common":"Turquemenistão"},"rus":{"official":"Туркменистан","common":"Туркмения"},"slk":{"official":"Turkménsko","common":"Turkménsko"},"spa":{"official":"Turkmenistán","common":"Turkmenistán"},"fin":{"official":"Turkmenistan","common":"Turkmenistan"},"est":{"official":"Türkmenistan","common":"Türkmenistan"},"zho":{"official":"土库曼斯坦","common":"土库曼斯坦"}},"latlng":[40,60],"demonym":"Turkmen","landlocked":true,"borders":["AFG","IRN","KAZ","UZB"],"area":488100,"flag":"🇹🇲"},{"name":{"common":"Timor-Leste","official":"Democratic Republic of Timor-Leste","native":{"por":{"official":"República Democrática de Timor-Leste","common":"Timor-Leste"},"tet":{"official":"Repúblika Demokrátika Timór-Leste","common":"Timór-Leste"}}},"tld":[".tl"],"cca2":"TL","ccn3":"626","cca3":"TLS","cioc":"TLS","independent":true,"status":"officially-assigned","currency":["USD"],"callingCode":["670"],"capital":["Dili"],"altSpellings":["TL","East Timor","Democratic Republic of Timor-Leste","República Democrática de Timor-Leste","Repúblika Demokrátika Timór-Leste","Timór Lorosa'e","Timor Lorosae"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"por":"Portuguese","tet":"Tetum"},"translations":{"deu":{"official":"Demokratische Republik Timor-Leste","common":"Timor-Leste"},"fra":{"official":"République démocratique du Timor oriental","common":"Timor oriental"},"hrv":{"official":"Demokratska Republika Timor-Leste","common":"Istočni Timor"},"ita":{"official":"Repubblica Democratica di Timor Est","common":"Timor Est"},"jpn":{"official":"東ティモール民主共和国","common":"東ティモール"},"nld":{"official":"Democratische Republiek Oost-Timor","common":"Oost-Timor"},"por":{"official":"República Democrática de Timor-Leste","common":"Timor-Leste"},"rus":{"official":"Демократическая Республика Тимор -Лешти","common":"Восточный Тимор"},"slk":{"official":"Východotimorská demokratická republika","common":"Východný Timor"},"spa":{"official":"República Democrática de Timor-Leste","common":"Timor Oriental"},"fin":{"official":"Itä-Timorin demokraattinen tasavalta","common":"Itä-Timor"},"est":{"official":"Timor-Leste Demokraatlik Vabariik","common":"Ida-Timor"},"zho":{"official":"东帝汶民主共和国","common":"东帝汶"}},"latlng":[-8.83333333,125.91666666],"demonym":"East Timorese","landlocked":false,"borders":["IDN"],"area":14874,"flag":"🇹🇱"},{"name":{"common":"Tonga","official":"Kingdom of Tonga","native":{"eng":{"official":"Kingdom of Tonga","common":"Tonga"},"ton":{"official":"Kingdom of Tonga","common":"Tonga"}}},"tld":[".to"],"cca2":"TO","ccn3":"776","cca3":"TON","cioc":"TGA","independent":true,"status":"officially-assigned","currency":["TOP"],"callingCode":["676"],"capital":["Nuku'alofa"],"altSpellings":["TO"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","ton":"Tongan"},"translations":{"deu":{"official":"Königreich Tonga","common":"Tonga"},"fra":{"official":"Royaume des Tonga","common":"Tonga"},"hrv":{"official":"Kraljevina Tonga","common":"Tonga"},"ita":{"official":"Regno di Tonga","common":"Tonga"},"jpn":{"official":"トンガ王国","common":"トンガ"},"nld":{"official":"Koninkrijk Tonga","common":"Tonga"},"por":{"official":"Reino de Tonga","common":"Tonga"},"rus":{"official":"Королевство Тонга","common":"Тонга"},"slk":{"official":"Tongské kráľovstvo","common":"Tonga"},"spa":{"official":"Reino de Tonga","common":"Tonga"},"fin":{"official":"Tongan kuningaskunta","common":"Tonga"},"est":{"official":"Tonga Kuningriik","common":"Tonga"},"zho":{"official":"汤加王国","common":"汤加"}},"latlng":[-20,-175],"demonym":"Tongan","landlocked":false,"borders":[],"area":747,"flag":"🇹🇴"},{"name":{"common":"Trinidad and Tobago","official":"Republic of Trinidad and Tobago","native":{"eng":{"official":"Republic of Trinidad and Tobago","common":"Trinidad and Tobago"}}},"tld":[".tt"],"cca2":"TT","ccn3":"780","cca3":"TTO","cioc":"TTO","independent":true,"status":"officially-assigned","currency":["TTD"],"callingCode":["1868"],"capital":["Port of Spain"],"altSpellings":["TT","Republic of Trinidad and Tobago"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"deu":{"official":"Republik Trinidad und Tobago","common":"Trinidad und Tobago"},"fra":{"official":"République de Trinité-et-Tobago","common":"Trinité-et-Tobago"},"hrv":{"official":"Republika Trinidad i Tobago","common":"Trinidad i Tobago"},"ita":{"official":"Repubblica di Trinidad e Tobago","common":"Trinidad e Tobago"},"jpn":{"official":"トリニダード·トバゴ共和国","common":"トリニダード・トバゴ"},"nld":{"official":"Republiek Trinidad en Tobago","common":"Trinidad en Tobago"},"por":{"official":"República de Trinidad e Tobago","common":"Trinidade e Tobago"},"rus":{"official":"Республика Тринидад и Тобаго","common":"Тринидад и Тобаго"},"slk":{"official":"Republika Trinidad a Tobaga","common":"Trinidad a Tobago"},"spa":{"official":"República de Trinidad y Tobago","common":"Trinidad y Tobago"},"fin":{"official":"Trinidadin ja Tobagon tasavalta","common":"Trinidad ja Tobago"},"est":{"official":"Trinidadi ja Tobago Vabariik","common":"Trinidad ja Tobago"},"zho":{"official":"特立尼达和多巴哥共和国","common":"特立尼达和多巴哥"}},"latlng":[11,-61],"demonym":"Trinidadian","landlocked":false,"borders":[],"area":5130,"flag":"🇹🇹"},{"name":{"common":"Tunisia","official":"Tunisian Republic","native":{"ara":{"official":"الجمهورية التونسية","common":"تونس"}}},"tld":[".tn"],"cca2":"TN","ccn3":"788","cca3":"TUN","cioc":"TUN","independent":true,"status":"officially-assigned","currency":["TND"],"callingCode":["216"],"capital":["Tunis"],"altSpellings":["TN","Republic of Tunisia","al-Jumhūriyyah at-Tūnisiyyah"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Tunesische Republik","common":"Tunesien"},"fra":{"official":"République tunisienne","common":"Tunisie"},"hrv":{"official":"Tuniski Republika","common":"Tunis"},"ita":{"official":"Repubblica tunisina","common":"Tunisia"},"jpn":{"official":"チュニジア共和国","common":"チュニジア"},"nld":{"official":"Republiek Tunesië","common":"Tunesië"},"por":{"official":"República da Tunísia","common":"Tunísia"},"rus":{"official":"Тунисской Республики","common":"Тунис"},"slk":{"official":"Tuniská republika","common":"Tunisko"},"spa":{"official":"República de Túnez","common":"Túnez"},"fin":{"official":"Tunisian tasavalta","common":"Tunisia"},"est":{"official":"Tuneesia Vabariik","common":"Tuneesia"},"zho":{"official":"突尼斯共和国","common":"突尼斯"}},"latlng":[34,9],"demonym":"Tunisian","landlocked":false,"borders":["DZA","LBY"],"area":163610,"flag":"🇹🇳"},{"name":{"common":"Turkey","official":"Republic of Turkey","native":{"tur":{"official":"Türkiye Cumhuriyeti","common":"Türkiye"}}},"tld":[".tr"],"cca2":"TR","ccn3":"792","cca3":"TUR","cioc":"TUR","independent":true,"status":"officially-assigned","currency":["TRY"],"callingCode":["90"],"capital":["Ankara"],"altSpellings":["TR","Turkiye","Republic of Turkey","Türkiye Cumhuriyeti"],"region":"Asia","subregion":"Western Asia","languages":{"tur":"Turkish"},"translations":{"deu":{"official":"Republik Türkei","common":"Türkei"},"fra":{"official":"République de Turquie","common":"Turquie"},"hrv":{"official":"Republika Turska","common":"Turska"},"ita":{"official":"Repubblica di Turchia","common":"Turchia"},"jpn":{"official":"トルコ共和国","common":"トルコ"},"nld":{"official":"Republiek Turkije","common":"Turkije"},"por":{"official":"República da Turquia","common":"Turquia"},"rus":{"official":"Республика Турции","common":"Турция"},"slk":{"official":"Turecká republika","common":"Turecko"},"spa":{"official":"República de Turquía","common":"Turquía"},"fin":{"official":"Turkin tasavalta","common":"Turkki"},"est":{"official":"Türgi Vabariik","common":"Türgi"},"zho":{"official":"土耳其共和国","common":"土耳其"}},"latlng":[39,35],"demonym":"Turkish","landlocked":false,"borders":["ARM","AZE","BGR","GEO","GRC","IRN","IRQ","SYR"],"area":783562,"flag":"🇹🇷"},{"name":{"common":"Tuvalu","official":"Tuvalu","native":{"eng":{"official":"Tuvalu","common":"Tuvalu"},"tvl":{"official":"Tuvalu","common":"Tuvalu"}}},"tld":[".tv"],"cca2":"TV","ccn3":"798","cca3":"TUV","cioc":"TUV","independent":true,"status":"officially-assigned","currency":["AUD"],"callingCode":["688"],"capital":["Funafuti"],"altSpellings":["TV"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","tvl":"Tuvaluan"},"translations":{"deu":{"official":"Tuvalu","common":"Tuvalu"},"fra":{"official":"Tuvalu","common":"Tuvalu"},"hrv":{"official":"Tuvalu","common":"Tuvalu"},"ita":{"official":"Tuvalu","common":"Tuvalu"},"jpn":{"official":"ツバル","common":"ツバル"},"nld":{"official":"Tuvalu","common":"Tuvalu"},"por":{"official":"Tuvalu","common":"Tuvalu"},"rus":{"official":"Тувалу","common":"Тувалу"},"slk":{"official":"Tuvalu","common":"Tuvalu"},"spa":{"official":"Tuvalu","common":"Tuvalu"},"fin":{"official":"Tuvalu","common":"Tuvalu"},"est":{"official":"Tuvalu","common":"Tuvalu"},"zho":{"official":"图瓦卢","common":"图瓦卢"}},"latlng":[-8,178],"demonym":"Tuvaluan","landlocked":false,"borders":[],"area":26,"flag":"🇹🇻"},{"name":{"common":"Taiwan","official":"Republic of China (Taiwan)","native":{"zho":{"official":"中華民國","common":"台灣"}}},"tld":[".tw",".台灣",".台湾"],"cca2":"TW","ccn3":"158","cca3":"TWN","cioc":"TPE","independent":false,"status":"officially-assigned","currency":["TWD"],"callingCode":["886"],"capital":["Taipei"],"altSpellings":["TW","Táiwān","Republic of China","中華民國","Zhōnghuá Mínguó","Chinese Taipei"],"region":"Asia","subregion":"Eastern Asia","languages":{"zho":"Chinese"},"translations":{"deu":{"official":"Republik China (Taiwan)","common":"Taiwan"},"fra":{"official":"République de Chine (Taïwan)","common":"Taïwan"},"hrv":{"official":"Republika Kina","common":"Tajvan"},"ita":{"official":"Repubblica cinese (Taiwan)","common":"Taiwan"},"jpn":{"official":"中華民国","common":"台湾"},"nld":{"official":"Republiek China (Taiwan)","common":"Taiwan"},"por":{"official":"República da China","common":"Ilha Formosa"},"rus":{"official":"Китайская Республика","common":"Тайвань"},"slk":{"official":"Čínska republika","common":"Taiwan"},"spa":{"official":"República de China en Taiwán","common":"Taiwán"},"fin":{"official":"Kiinan tasavalta","common":"Taiwan"},"est":{"official":"Taiwani","common":"Taiwan"}},"latlng":[23.5,121],"demonym":"Taiwanese","landlocked":false,"borders":[],"area":36193,"flag":"🇹🇼"},{"name":{"common":"Tanzania","official":"United Republic of Tanzania","native":{"eng":{"official":"United Republic of Tanzania","common":"Tanzania"},"swa":{"official":"Jamhuri ya Muungano wa Tanzania","common":"Tanzania"}}},"tld":[".tz"],"cca2":"TZ","ccn3":"834","cca3":"TZA","cioc":"TAN","independent":true,"status":"officially-assigned","currency":["TZS"],"callingCode":["255"],"capital":["Dodoma"],"altSpellings":["TZ","Tanzania, United Republic of","United Republic of Tanzania","Jamhuri ya Muungano wa Tanzania"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","swa":"Swahili"},"translations":{"deu":{"official":"Vereinigte Republik Tansania","common":"Tansania"},"fra":{"official":"République -Unie de Tanzanie","common":"Tanzanie"},"hrv":{"official":"Ujedinjena Republika Tanzanija","common":"Tanzanija"},"ita":{"official":"Repubblica Unita di Tanzania","common":"Tanzania"},"jpn":{"official":"タンザニア連合共和国","common":"タンザニア"},"nld":{"official":"Verenigde Republiek Tanzania","common":"Tanzania"},"por":{"official":"República Unida da Tanzânia","common":"Tanzânia"},"rus":{"official":"Объединенная Республика Танзания","common":"Танзания"},"slk":{"official":"Tanzánijská zjednotená republika","common":"Tanzánia"},"spa":{"official":"República Unida de Tanzania","common":"Tanzania"},"fin":{"official":"Tansanian yhdistynyt tasavalta","common":"Tansania"},"est":{"official":"Tansaania Ühendvabariik","common":"Tansaania"},"zho":{"official":"坦桑尼亚联合共和国","common":"坦桑尼亚"}},"latlng":[-6,35],"demonym":"Tanzanian","landlocked":false,"borders":["BDI","COD","KEN","MWI","MOZ","RWA","UGA","ZMB"],"area":945087,"flag":"🇹🇿"},{"name":{"common":"Uganda","official":"Republic of Uganda","native":{"eng":{"official":"Republic of Uganda","common":"Uganda"},"swa":{"official":"Republic of Uganda","common":"Uganda"}}},"tld":[".ug"],"cca2":"UG","ccn3":"800","cca3":"UGA","cioc":"UGA","independent":true,"status":"officially-assigned","currency":["UGX"],"callingCode":["256"],"capital":["Kampala"],"altSpellings":["UG","Republic of Uganda","Jamhuri ya Uganda"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","swa":"Swahili"},"translations":{"deu":{"official":"Republik Uganda","common":"Uganda"},"fra":{"official":"République de l'Ouganda","common":"Ouganda"},"hrv":{"official":"Republika Uganda","common":"Uganda"},"ita":{"official":"Repubblica di Uganda","common":"Uganda"},"jpn":{"official":"ウガンダ共和国","common":"ウガンダ"},"nld":{"official":"Republiek Uganda","common":"Oeganda"},"por":{"official":"República do Uganda","common":"Uganda"},"rus":{"official":"Республика Уганда","common":"Уганда"},"slk":{"official":"Ugandská republika","common":"Uganda"},"spa":{"official":"República de Uganda","common":"Uganda"},"fin":{"official":"Ugandan tasavalta","common":"Uganda"},"est":{"official":"Uganda Vabariik","common":"Uganda"},"zho":{"official":"乌干达共和国","common":"乌干达"}},"latlng":[1,32],"demonym":"Ugandan","landlocked":true,"borders":["COD","KEN","RWA","SSD","TZA"],"area":241550,"flag":"🇺🇬"},{"name":{"common":"Ukraine","official":"Ukraine","native":{"ukr":{"official":"Україна","common":"Україна"}}},"tld":[".ua",".укр"],"cca2":"UA","ccn3":"804","cca3":"UKR","cioc":"UKR","independent":true,"status":"officially-assigned","currency":["UAH"],"callingCode":["380"],"capital":["Kyiv"],"altSpellings":["UA","Ukrayina"],"region":"Europe","subregion":"Eastern Europe","languages":{"ukr":"Ukrainian"},"translations":{"deu":{"official":"Ukraine","common":"Ukraine"},"fra":{"official":"Ukraine","common":"Ukraine"},"hrv":{"official":"Ukrajina","common":"Ukrajina"},"ita":{"official":"Ucraina","common":"Ucraina"},"jpn":{"official":"ウクライナ","common":"ウクライナ"},"nld":{"official":"Oekraïne","common":"Oekraïne"},"por":{"official":"Ucrânia","common":"Ucrânia"},"rus":{"official":"Украина","common":"Украина"},"slk":{"official":"Ukrajina","common":"Ukrajina"},"spa":{"official":"Ucrania","common":"Ucrania"},"fin":{"official":"Ukraina","common":"Ukraina"},"est":{"official":"Ukraina","common":"Ukraina"},"zho":{"official":"乌克兰","common":"乌克兰"}},"latlng":[49,32],"demonym":"Ukrainian","landlocked":false,"borders":["BLR","HUN","MDA","POL","ROU","RUS","SVK"],"area":603500,"flag":"🇺🇦"},{"name":{"common":"United States Minor Outlying Islands","official":"United States Minor Outlying Islands","native":{"eng":{"official":"United States Minor Outlying Islands","common":"United States Minor Outlying Islands"}}},"tld":[".us"],"cca2":"UM","ccn3":"581","cca3":"UMI","cioc":"","independent":false,"status":"officially-assigned","currency":["USD"],"callingCode":[],"capital":[""],"altSpellings":["UM"],"region":"Americas","subregion":"Northern America","languages":{"eng":"English"},"translations":{"deu":{"official":"USA, kleinere ausgelagerte Inseln","common":"Kleinere Inselbesitzungen der Vereinigten Staaten"},"fra":{"official":"Îles mineures éloignées des États-Unis","common":"Îles mineures éloignées des États-Unis"},"hrv":{"official":"Mali udaljeni otoci SAD-a","common":"Mali udaljeni otoci SAD-a"},"ita":{"official":"Stati Uniti Isole Minori","common":"Isole minori esterne degli Stati Uniti d'America"},"jpn":{"official":"アメリカ合衆国外諸島","common":"合衆国領有小離島"},"nld":{"official":"Kleine afgelegen eilanden van de Verenigde Staten","common":"Kleine afgelegen eilanden van de Verenigde Staten"},"por":{"official":"Estados Unidos Ilhas Menores Distantes","common":"Ilhas Menores Distantes dos Estados Unidos"},"rus":{"official":"Внешние малые острова США","common":"Внешние малые острова США"},"slk":{"official":"Menšie odľahlé ostrovy Spjoených štátov","common":"Menšie odľahlé ostrovy USA"},"spa":{"official":"Estados Unidos Islas menores alejadas de","common":"Islas Ultramarinas Menores de Estados Unidos"},"fin":{"official":"Yhdysvaltain asumattomat saaret","common":"Yhdysvaltain asumattomat saaret"},"est":{"official":"Ühendriikide väikesed hajasaared","common":"Ühendriikide hajasaared"},"zho":{"official":"美国本土外小岛屿","common":"美国本土外小岛屿"}},"latlng":[19.3,166.633333],"demonym":"American","landlocked":false,"borders":[],"area":34.2,"flag":"🇺🇲"},{"name":{"common":"Uruguay","official":"Oriental Republic of Uruguay","native":{"spa":{"official":"República Oriental del Uruguay","common":"Uruguay"}}},"tld":[".uy"],"cca2":"UY","ccn3":"858","cca3":"URY","cioc":"URU","independent":true,"status":"officially-assigned","currency":["UYI","UYU"],"callingCode":["598"],"capital":["Montevideo"],"altSpellings":["UY","Oriental Republic of Uruguay","República Oriental del Uruguay"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"deu":{"official":"Republik Östlich des Uruguay","common":"Uruguay"},"fra":{"official":"République orientale de l'Uruguay","common":"Uruguay"},"hrv":{"official":"Orijentalna Republika Urugvaj","common":"Urugvaj"},"ita":{"official":"Repubblica Orientale dell'Uruguay","common":"Uruguay"},"jpn":{"official":"ウルグアイ東方共和国","common":"ウルグアイ"},"nld":{"official":"Oosterse Republiek Uruguay","common":"Uruguay"},"por":{"official":"República Oriental do Uruguai","common":"Uruguai"},"rus":{"official":"Восточной Республики Уругвай","common":"Уругвай"},"slk":{"official":"Uruguajská východná republika","common":"Uruguaj"},"spa":{"official":"República Oriental del Uruguay","common":"Uruguay"},"fin":{"official":"Uruguayn itäinen tasavalta","common":"Uruguay"},"est":{"official":"Uruguay Idavabariik","common":"Uruguay"},"zho":{"official":"乌拉圭东岸共和国","common":"乌拉圭"}},"latlng":[-33,-56],"demonym":"Uruguayan","landlocked":false,"borders":["ARG","BRA"],"area":181034,"flag":"🇺🇾"},{"name":{"common":"United States","official":"United States of America","native":{"eng":{"official":"United States of America","common":"United States"}}},"tld":[".us"],"cca2":"US","ccn3":"840","cca3":"USA","cioc":"USA","independent":true,"status":"officially-assigned","currency":["USD","USN","USS"],"callingCode":["1"],"capital":["Washington D.C."],"altSpellings":["US","USA","United States of America"],"region":"Americas","subregion":"Northern America","languages":{"eng":"English"},"translations":{"deu":{"official":"Vereinigte Staaten von Amerika","common":"Vereinigte Staaten von Amerika"},"fra":{"official":"Les états-unis d'Amérique","common":"États-Unis"},"hrv":{"official":"Sjedinjene Države Amerike","common":"Sjedinjene Američke Države"},"ita":{"official":"Stati Uniti d'America","common":"Stati Uniti d'America"},"jpn":{"official":"アメリカ合衆国","common":"アメリカ合衆国"},"nld":{"official":"Verenigde Staten van Amerika","common":"Verenigde Staten"},"por":{"official":"Estados Unidos da América","common":"Estados Unidos"},"rus":{"official":"Соединенные Штаты Америки","common":"Соединённые Штаты Америки"},"slk":{"official":"Spojené štáty Americké","common":"Spojené štáty americké"},"spa":{"official":"Estados Unidos de América","common":"Estados Unidos"},"fin":{"official":"Amerikan yhdysvallat","common":"Yhdysvallat"},"est":{"official":"Ameerika Ühendriigid","common":"Ameerika Ühendriigid"},"zho":{"official":"美利坚合众国","common":"美国"}},"latlng":[38,-97],"demonym":"American","landlocked":false,"borders":["CAN","MEX"],"area":9372610,"flag":"🇺🇸"},{"name":{"common":"Uzbekistan","official":"Republic of Uzbekistan","native":{"rus":{"official":"Республика Узбекистан","common":"Узбекистан"},"uzb":{"official":"O'zbekiston Respublikasi","common":"O‘zbekiston"}}},"tld":[".uz"],"cca2":"UZ","ccn3":"860","cca3":"UZB","cioc":"UZB","independent":true,"status":"officially-assigned","currency":["UZS"],"callingCode":["998"],"capital":["Tashkent"],"altSpellings":["UZ","Republic of Uzbekistan","O‘zbekiston Respublikasi","Ўзбекистон Республикаси"],"region":"Asia","subregion":"Central Asia","languages":{"rus":"Russian","uzb":"Uzbek"},"translations":{"deu":{"official":"Republik Usbekistan","common":"Usbekistan"},"fra":{"official":"République d'Ouzbékistan","common":"Ouzbékistan"},"hrv":{"official":"Republika Uzbekistan","common":"Uzbekistan"},"ita":{"official":"Repubblica di Uzbekistan","common":"Uzbekistan"},"jpn":{"official":"ウズベキスタン共和国","common":"ウズベキスタン"},"nld":{"official":"Republiek Oezbekistan","common":"Oezbekistan"},"por":{"official":"República do Usbequistão","common":"Uzbequistão"},"rus":{"official":"Республика Узбекистан","common":"Узбекистан"},"slk":{"official":"Uzbecká republika","common":"Uzbekistan"},"spa":{"official":"República de Uzbekistán","common":"Uzbekistán"},"fin":{"official":"Uzbekistanin tasavalta","common":"Uzbekistan"},"est":{"official":"Usbekistani Vabariik","common":"Usbekistan"},"zho":{"official":"乌兹别克斯坦共和国","common":"乌兹别克斯坦"}},"latlng":[41,64],"demonym":"Uzbekistani","landlocked":true,"borders":["AFG","KAZ","KGZ","TJK","TKM"],"area":447400,"flag":"🇺🇿"},{"name":{"common":"Vatican City","official":"Vatican City State","native":{"ita":{"official":"Stato della Città del Vaticano","common":"Vaticano"},"lat":{"official":"Status Civitatis Vaticanæ","common":"Vaticanæ"}}},"tld":[".va"],"cca2":"VA","ccn3":"336","cca3":"VAT","cioc":"","independent":true,"status":"officially-assigned","currency":["EUR"],"callingCode":["3906698","379"],"capital":["Vatican City"],"altSpellings":["VA","Holy See (Vatican City State)","Vatican City State","Stato della Città del Vaticano"],"region":"Europe","subregion":"Southern Europe","languages":{"ita":"Italian","lat":"Latin"},"translations":{"deu":{"official":"Staat Vatikanstadt","common":"Vatikanstadt"},"fra":{"official":"Cité du Vatican","common":"Cité du Vatican"},"hrv":{"official":"Vatikan","common":"Vatikan"},"ita":{"official":"Città del Vaticano","common":"Città del Vaticano"},"jpn":{"official":"バチカン市国の状態","common":"バチカン市国"},"nld":{"official":"Vaticaanstad","common":"Vaticaanstad"},"por":{"official":"Cidade do Vaticano","common":"Cidade do Vaticano"},"rus":{"official":"Город-государство Ватикан","common":"Ватикан"},"slk":{"official":"Svätá stolica (Vatikánsky mestský štát","common":"Vatikán"},"spa":{"official":"Ciudad del Vaticano","common":"Ciudad del Vaticano"},"fin":{"official":"Vatikaanin kaupunkivaltio","common":"Vatikaani"},"est":{"official":"Vatikani Linnriik","common":"Vatikan"},"zho":{"official":"梵蒂冈城国","common":"梵蒂冈"}},"latlng":[41.9,12.45],"demonym":"Italian","landlocked":true,"borders":["ITA"],"area":0.44,"flag":"🇻🇦"},{"name":{"common":"Saint Vincent and the Grenadines","official":"Saint Vincent and the Grenadines","native":{"eng":{"official":"Saint Vincent and the Grenadines","common":"Saint Vincent and the Grenadines"}}},"tld":[".vc"],"cca2":"VC","ccn3":"670","cca3":"VCT","cioc":"VIN","independent":true,"status":"officially-assigned","currency":["XCD"],"callingCode":["1784"],"capital":["Kingstown"],"altSpellings":["VC"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"deu":{"official":"St. Vincent und die Grenadinen","common":"Saint Vincent und die Grenadinen"},"fra":{"official":"Saint-Vincent-et-les Grenadines","common":"Saint-Vincent-et-les-Grenadines"},"hrv":{"official":"Sveti Vincent i Grenadini","common":"Sveti Vincent i Grenadini"},"ita":{"official":"Saint Vincent e Grenadine","common":"Saint Vincent e Grenadine"},"jpn":{"official":"セントビンセントおよびグレナディーン諸島","common":"セントビンセントおよびグレナディーン諸島"},"nld":{"official":"Saint Vincent en de Grenadines","common":"Saint Vincent en de Grenadines"},"por":{"official":"São Vicente e Granadinas","common":"São Vincente e Granadinas"},"rus":{"official":"Сент-Винсент и Гренадины","common":"Сент-Винсент и Гренадины"},"slk":{"official":"Svätý Vincent a Grenadíny","common":"Svätý Vincent a Grenadíny"},"spa":{"official":"San Vicente y las Granadinas","common":"San Vicente y Granadinas"},"fin":{"official":"Saint Vincent ja Grenadiinit","common":"Saint Vincent ja Grenadiinit"},"est":{"official":"Saint Vincent ja Grenadiinid","common":"Saint Vincent"},"zho":{"official":"圣文森特和格林纳丁斯","common":"圣文森特和格林纳丁斯"}},"latlng":[13.25,-61.2],"demonym":"Saint Vincentian","landlocked":false,"borders":[],"area":389,"flag":"🇻🇨"},{"name":{"common":"Venezuela","official":"Bolivarian Republic of Venezuela","native":{"spa":{"official":"República Bolivariana de Venezuela","common":"Venezuela"}}},"tld":[".ve"],"cca2":"VE","ccn3":"862","cca3":"VEN","cioc":"VEN","independent":true,"status":"officially-assigned","currency":["VEF"],"callingCode":["58"],"capital":["Caracas"],"altSpellings":["VE","Bolivarian Republic of Venezuela","Venezuela, Bolivarian Republic of","República Bolivariana de Venezuela"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"deu":{"official":"Bolivarische Republik Venezuela","common":"Venezuela"},"fra":{"official":"République bolivarienne du Venezuela","common":"Venezuela"},"hrv":{"official":"BOLIVARIJANSKA Republika Venezuela","common":"Venezuela"},"ita":{"official":"Repubblica Bolivariana del Venezuela","common":"Venezuela"},"jpn":{"official":"ベネズエラ·ボリバル共和国","common":"ベネズエラ・ボリバル共和国"},"nld":{"official":"Bolivariaanse Republiek Venezuela","common":"Venezuela"},"por":{"official":"República Bolivariana da Venezuela","common":"Venezuela"},"rus":{"official":"Боливарианская Республика Венесуэла","common":"Венесуэла"},"slk":{"official":"Venezuelská bolívarovská republika","common":"Venezuela"},"spa":{"official":"República Bolivariana de Venezuela","common":"Venezuela"},"fin":{"official":"Venezuelan bolivariaainen tasavalta","common":"Venezuela"},"est":{"official":"Venezuela Bolívari Vabariik","common":"Venezuela"},"zho":{"official":"委内瑞拉玻利瓦尔共和国","common":"委内瑞拉"}},"latlng":[8,-66],"demonym":"Venezuelan","landlocked":false,"borders":["BRA","COL","GUY"],"area":916445,"flag":"🇻🇪"},{"name":{"common":"British Virgin Islands","official":"Virgin Islands","native":{"eng":{"official":"Virgin Islands","common":"British Virgin Islands"}}},"tld":[".vg"],"cca2":"VG","ccn3":"092","cca3":"VGB","cioc":"IVB","independent":false,"status":"officially-assigned","currency":["USD"],"callingCode":["1284"],"capital":["Road Town"],"altSpellings":["VG","Virgin Islands, British"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"deu":{"official":"Jungferninseln","common":"Britische Jungferninseln"},"fra":{"official":"îles Vierges","common":"Îles Vierges britanniques"},"hrv":{"official":"Djevičanski Otoci","common":"Britanski Djevičanski Otoci"},"ita":{"official":"Isole Vergini","common":"Isole Vergini Britanniche"},"jpn":{"official":"バージン諸島","common":"イギリス領ヴァージン諸島"},"nld":{"official":"Maagdeneilanden","common":"Britse Maagdeneilanden"},"por":{"official":"Ilhas Virgens","common":"Ilhas Virgens"},"rus":{"official":"Виргинские острова","common":"Британские Виргинские острова"},"slk":{"official":"Panenské ostrovy","common":"Panenské ostrovy"},"spa":{"official":"Islas Vírgenes","common":"Islas Vírgenes del Reino Unido"},"fin":{"official":"Brittiläiset Neitsytsaaret","common":"Neitsytsaaret"},"est":{"official":"Neitsisaared","common":"Briti Neitsisaared"},"zho":{"official":"英属维尔京群岛","common":"英属维尔京群岛"}},"latlng":[18.431383,-64.62305],"demonym":"Virgin Islander","landlocked":false,"borders":[],"area":151,"flag":"🇻🇬"},{"name":{"common":"United States Virgin Islands","official":"Virgin Islands of the United States","native":{"eng":{"official":"Virgin Islands of the United States","common":"United States Virgin Islands"}}},"tld":[".vi"],"cca2":"VI","ccn3":"850","cca3":"VIR","cioc":"ISV","independent":false,"status":"officially-assigned","currency":["USD"],"callingCode":["1340"],"capital":["Charlotte Amalie"],"altSpellings":["VI","Virgin Islands, U.S."],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"deu":{"official":"Jungferninseln der Vereinigten Staaten","common":"Amerikanische Jungferninseln"},"fra":{"official":"Îles Vierges des États-Unis","common":"Îles Vierges des États-Unis"},"hrv":{"official":"Djevičanski Otoci SAD","common":"Američki Djevičanski Otoci"},"ita":{"official":"Isole Vergini degli Stati Uniti","common":"Isole Vergini americane"},"jpn":{"official":"米国のバージン諸島","common":"アメリカ領ヴァージン諸島"},"nld":{"official":"Maagdeneilanden van de Verenigde Staten","common":"Amerikaanse Maagdeneilanden"},"por":{"official":"Ilhas Virgens dos Estados Unidos","common":"Ilhas Virgens dos Estados Unidos"},"rus":{"official":"Виргинские острова Соединенных Штатов","common":"Виргинские Острова"},"slk":{"official":"Americké Panenské ostrovy","common":"Americké Panenské ostrovy"},"spa":{"official":"Islas Vírgenes de los Estados Unidos","common":"Islas Vírgenes de los Estados Unidos"},"fin":{"official":"Yhdysvaltain Neitsytsaaret","common":"Neitsytsaaret"},"est":{"official":"Ühendriikide Neitsisaared","common":"Neitsisaared, USA"},"zho":{"official":"美属维尔京群岛","common":"美属维尔京群岛"}},"latlng":[18.35,-64.933333],"demonym":"Virgin Islander","landlocked":false,"borders":[],"area":347,"flag":"🇻🇮"},{"name":{"common":"Vietnam","official":"Socialist Republic of Vietnam","native":{"vie":{"official":"Cộng hòa xã hội chủ nghĩa Việt Nam","common":"Việt Nam"}}},"tld":[".vn"],"cca2":"VN","ccn3":"704","cca3":"VNM","cioc":"VIE","independent":true,"status":"officially-assigned","currency":["VND"],"callingCode":["84"],"capital":["Hanoi"],"altSpellings":["VN","Socialist Republic of Vietnam","Cộng hòa Xã hội chủ nghĩa Việt Nam","Viet Nam"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"vie":"Vietnamese"},"translations":{"deu":{"official":"Sozialistische Republik Vietnam","common":"Vietnam"},"fra":{"official":"République socialiste du Viêt Nam","common":"Viêt Nam"},"hrv":{"official":"Socijalistička Republika Vijetnam","common":"Vijetnam"},"ita":{"official":"Repubblica socialista del Vietnam","common":"Vietnam"},"jpn":{"official":"ベトナム社会主義共和国","common":"ベトナム"},"nld":{"official":"Socialistische Republiek Vietnam","common":"Vietnam"},"por":{"official":"República Socialista do Vietname","common":"Vietname"},"rus":{"official":"Социалистическая Республика Вьетнам","common":"Вьетнам"},"slk":{"official":"Vietnamská socialistická republika","common":"Vietnam"},"spa":{"official":"República Socialista de Vietnam","common":"Vietnam"},"fin":{"official":"Vietnamin sosialistinen tasavalta","common":"Vietnam"},"est":{"official":"Vietnami Sotsialistlik Vabariik","common":"Vietnam"},"zho":{"official":"越南社会主义共和国","common":"越南"}},"latlng":[16.16666666,107.83333333],"demonym":"Vietnamese","landlocked":false,"borders":["KHM","CHN","LAO"],"area":331212,"flag":"🇻🇳"},{"name":{"common":"Vanuatu","official":"Republic of Vanuatu","native":{"bis":{"official":"Ripablik blong Vanuatu","common":"Vanuatu"},"eng":{"official":"Republic of Vanuatu","common":"Vanuatu"},"fra":{"official":"République de Vanuatu","common":"Vanuatu"}}},"tld":[".vu"],"cca2":"VU","ccn3":"548","cca3":"VUT","cioc":"VAN","independent":true,"status":"officially-assigned","currency":["VUV"],"callingCode":["678"],"capital":["Port Vila"],"altSpellings":["VU","Republic of Vanuatu","Ripablik blong Vanuatu","République de Vanuatu"],"region":"Oceania","subregion":"Melanesia","languages":{"bis":"Bislama","eng":"English","fra":"French"},"translations":{"deu":{"official":"Vanuatu","common":"Vanuatu"},"fra":{"official":"République de Vanuatu","common":"Vanuatu"},"hrv":{"official":"Republika Vanuatu","common":"Vanuatu"},"ita":{"official":"Repubblica di Vanuatu","common":"Vanuatu"},"jpn":{"official":"バヌアツ共和国","common":"バヌアツ"},"nld":{"official":"Republiek Vanuatu","common":"Vanuatu"},"por":{"official":"República de Vanuatu","common":"Vanuatu"},"rus":{"official":"Республика Вануату","common":"Вануату"},"slk":{"official":"Vanuatská republika","common":"Vanuatu"},"spa":{"official":"República de Vanuatu","common":"Vanuatu"},"fin":{"official":"Vanuatun tasavalta","common":"Vanuatu"},"est":{"official":"Vanuatu Vabariik","common":"Vanuatu"},"zho":{"official":"瓦努阿图共和国","common":"瓦努阿图"}},"latlng":[-16,167],"demonym":"Ni-Vanuatu","landlocked":false,"borders":[],"area":12189,"flag":"🇻🇺"},{"name":{"common":"Wallis and Futuna","official":"Territory of the Wallis and Futuna Islands","native":{"fra":{"official":"Territoire des îles Wallis et Futuna","common":"Wallis et Futuna"}}},"tld":[".wf"],"cca2":"WF","ccn3":"876","cca3":"WLF","cioc":"","independent":false,"status":"officially-assigned","currency":["XPF"],"callingCode":["681"],"capital":["Mata-Utu"],"altSpellings":["WF","Territory of the Wallis and Futuna Islands","Territoire des îles Wallis et Futuna"],"region":"Oceania","subregion":"Polynesia","languages":{"fra":"French"},"translations":{"deu":{"official":"Gebiet der Wallis und Futuna","common":"Wallis und Futuna"},"fra":{"official":"Territoire des îles Wallis et Futuna","common":"Wallis-et-Futuna"},"hrv":{"official":"Teritoriju Wallis i Futuna","common":"Wallis i Fortuna"},"ita":{"official":"Territorio delle Isole Wallis e Futuna","common":"Wallis e Futuna"},"jpn":{"official":"ウォリス·フツナ諸島の領土","common":"ウォリス・フツナ"},"nld":{"official":"Grondgebied van de Wallis en Futuna","common":"Wallis en Futuna"},"por":{"official":"Território das Ilhas Wallis e Futuna","common":"Wallis e Futuna"},"rus":{"official":"Территория Уоллис и Футуна острова","common":"Уоллис и Футуна"},"slk":{"official":"Teritórium ostrovov Wallis a Futuna","common":"Wallis a Futuna"},"spa":{"official":"Territorio de las Islas Wallis y Futuna","common":"Wallis y Futuna"},"fin":{"official":"Wallisin ja Futunan yhteisö","common":"Wallis ja Futuna"},"est":{"official":"Wallise ja Futuna ala","common":"Wallis ja Futuna"},"zho":{"official":"瓦利斯和富图纳群岛","common":"瓦利斯和富图纳群岛"}},"latlng":[-13.3,-176.2],"demonym":"Wallis and Futuna Islander","landlocked":false,"borders":[],"area":142,"flag":"🇼🇫"},{"name":{"common":"Samoa","official":"Independent State of Samoa","native":{"eng":{"official":"Independent State of Samoa","common":"Samoa"},"smo":{"official":"Malo Saʻoloto Tutoʻatasi o Sāmoa","common":"Sāmoa"}}},"tld":[".ws"],"cca2":"WS","ccn3":"882","cca3":"WSM","cioc":"SAM","independent":true,"status":"officially-assigned","currency":["WST"],"callingCode":["685"],"capital":["Apia"],"altSpellings":["WS","Independent State of Samoa","Malo Saʻoloto Tutoʻatasi o Sāmoa"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","smo":"Samoan"},"translations":{"deu":{"official":"Unabhängige Staat Samoa","common":"Samoa"},"fra":{"official":"Samoa","common":"Samoa"},"hrv":{"official":"Nezavisna Država Samoa","common":"Samoa"},"ita":{"official":"Stato indipendente di Samoa","common":"Samoa"},"jpn":{"official":"サモア独立国","common":"サモア"},"nld":{"official":"Onafhankelijke Staat Samoa","common":"Samoa"},"por":{"official":"Estado Independente de Samoa","common":"Samoa"},"rus":{"official":"Независимое Государство Самоа","common":"Самоа"},"slk":{"official":"Nezávislý štátSamoa","common":"Samoa"},"spa":{"official":"Estado Independiente de Samoa","common":"Samoa"},"fin":{"official":"Samoan itsenäinen valtio","common":"Samoa"},"est":{"official":"Samoa Iseseisvusriik","common":"Samoa"},"zho":{"official":"萨摩亚独立国","common":"萨摩亚"}},"latlng":[-13.58333333,-172.33333333],"demonym":"Samoan","landlocked":false,"borders":[],"area":2842,"flag":"🇼🇸"},{"name":{"common":"Yemen","official":"Republic of Yemen","native":{"ara":{"official":"الجمهورية اليمنية","common":"اليَمَن"}}},"tld":[".ye"],"cca2":"YE","ccn3":"887","cca3":"YEM","cioc":"YEM","independent":true,"status":"officially-assigned","currency":["YER"],"callingCode":["967"],"capital":["Sana'a"],"altSpellings":["YE","Yemeni Republic","al-Jumhūriyyah al-Yamaniyyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"deu":{"official":"Republik Jemen","common":"Jemen"},"fra":{"official":"République du Yémen","common":"Yémen"},"hrv":{"official":"Republika Jemen","common":"Jemen"},"ita":{"official":"Repubblica dello Yemen","common":"Yemen"},"jpn":{"official":"イエメン共和国","common":"イエメン"},"nld":{"official":"Republiek Jemen","common":"Jemen"},"por":{"official":"República do Iêmen","common":"Iémen"},"rus":{"official":"Йеменская Республика","common":"Йемен"},"slk":{"official":"Jemenská republika","common":"Jemen"},"spa":{"official":"República de Yemen","common":"Yemen"},"fin":{"official":"Jemenin tasavalta","common":"Jemen"},"est":{"official":"Jeemeni Vabariik","common":"Jeemen"},"zho":{"official":"也门共和国","common":"也门"}},"latlng":[15,48],"demonym":"Yemeni","landlocked":false,"borders":["OMN","SAU"],"area":527968,"flag":"🇾🇪"},{"name":{"common":"South Africa","official":"Republic of South Africa","native":{"afr":{"official":"Republiek van Suid-Afrika","common":"South Africa"},"eng":{"official":"Republic of South Africa","common":"South Africa"},"nbl":{"official":"IRiphabliki yeSewula Afrika","common":"Sewula Afrika"},"nso":{"official":"Rephaboliki ya Afrika-Borwa ","common":"Afrika-Borwa"},"sot":{"official":"Rephaboliki ya Afrika Borwa","common":"Afrika Borwa"},"ssw":{"official":"IRiphabhulikhi yeNingizimu Afrika","common":"Ningizimu Afrika"},"tsn":{"official":"Rephaboliki ya Aforika Borwa","common":"Aforika Borwa"},"tso":{"official":"Riphabliki ra Afrika Dzonga","common":"Afrika Dzonga"},"ven":{"official":"Riphabuḽiki ya Afurika Tshipembe","common":"Afurika Tshipembe"},"xho":{"official":"IRiphabliki yaseMzantsi Afrika","common":"Mzantsi Afrika"},"zul":{"official":"IRiphabliki yaseNingizimu Afrika","common":"Ningizimu Afrika"}}},"tld":[".za"],"cca2":"ZA","ccn3":"710","cca3":"ZAF","cioc":"RSA","independent":true,"status":"officially-assigned","currency":["ZAR"],"callingCode":["27"],"capital":["Pretoria","Bloemfontein","Cape Town"],"altSpellings":["ZA","RSA","Suid-Afrika","Republic of South Africa"],"region":"Africa","subregion":"Southern Africa","languages":{"afr":"Afrikaans","eng":"English","nbl":"Southern Ndebele","nso":"Northern Sotho","sot":"Southern Sotho","ssw":"Swazi","tsn":"Tswana","tso":"Tsonga","ven":"Venda","xho":"Xhosa","zul":"Zulu"},"translations":{"deu":{"official":"Republik Südafrika","common":"Republik Südafrika"},"fra":{"official":"République d'Afrique du Sud","common":"Afrique du Sud"},"hrv":{"official":"Južnoafrička Republika","common":"Južnoafrička Republika"},"ita":{"official":"Repubblica del Sud Africa","common":"Sud Africa"},"jpn":{"official":"南アフリカ共和国","common":"南アフリカ"},"nld":{"official":"Zuid -Afrika","common":"Zuid-Afrika"},"por":{"official":"República da África do Sul","common":"África do Sul"},"rus":{"official":"Южно-Африканская Республика","common":"Южно-Африканская Республика"},"slk":{"official":"Juhoafrická republika","common":"Juhoafrická republika"},"spa":{"official":"República de Sudáfrica","common":"República de Sudáfrica"},"fin":{"official":"Etelä-Afrikan tasavalta","common":"Etelä-Afrikka"},"est":{"official":"Lõuna-Aafrika Vabariik","common":"Lõuna-Aafrika Vabariik"},"zho":{"official":"南非共和国","common":"南非"}},"latlng":[-29,24],"demonym":"South African","landlocked":false,"borders":["BWA","LSO","MOZ","NAM","SWZ","ZWE"],"area":1221037,"flag":"🇿🇦"},{"name":{"common":"Zambia","official":"Republic of Zambia","native":{"eng":{"official":"Republic of Zambia","common":"Zambia"}}},"tld":[".zm"],"cca2":"ZM","ccn3":"894","cca3":"ZMB","cioc":"ZAM","independent":true,"status":"officially-assigned","currency":["ZMW"],"callingCode":["260"],"capital":["Lusaka"],"altSpellings":["ZM","Republic of Zambia"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English"},"translations":{"deu":{"official":"Republik Sambia","common":"Sambia"},"fra":{"official":"République de Zambie","common":"Zambie"},"hrv":{"official":"Republika Zambija","common":"Zambija"},"ita":{"official":"Repubblica di Zambia","common":"Zambia"},"jpn":{"official":"ザンビア共和国","common":"ザンビア"},"nld":{"official":"Republiek Zambia","common":"Zambia"},"por":{"official":"República da Zâmbia","common":"Zâmbia"},"rus":{"official":"Республика Замбия","common":"Замбия"},"slk":{"official":"Zambijská republika","common":"Zambia"},"spa":{"official":"República de Zambia","common":"Zambia"},"fin":{"official":"Sambian tasavalta","common":"Sambia"},"est":{"official":"Sambia Vabariik","common":"Sambia"},"zho":{"official":"赞比亚共和国","common":"赞比亚"}},"latlng":[-15,30],"demonym":"Zambian","landlocked":true,"borders":["AGO","BWA","COD","MWI","MOZ","NAM","TZA","ZWE"],"area":752612,"flag":"🇿🇲"},{"name":{"common":"Zimbabwe","official":"Republic of Zimbabwe","native":{"bwg":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"eng":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"kck":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"khi":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"ndc":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"nde":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"nya":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"sna":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"sot":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"toi":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"tsn":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"tso":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"ven":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"xho":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"zib":{"official":"Republic of Zimbabwe","common":"Zimbabwe"}}},"tld":[".zw"],"cca2":"ZW","ccn3":"716","cca3":"ZWE","cioc":"ZIM","independent":true,"status":"officially-assigned","currency":["ZWL"],"callingCode":["263"],"capital":["Harare"],"altSpellings":["ZW","Republic of Zimbabwe"],"region":"Africa","subregion":"Eastern Africa","languages":{"bwg":"Chibarwe","eng":"English","kck":"Kalanga","khi":"Khoisan","ndc":"Ndau","nde":"Northern Ndebele","nya":"Chewa","sna":"Shona","sot":"Sotho","toi":"Tonga","tsn":"Tswana","tso":"Tsonga","ven":"Venda","xho":"Xhosa","zib":"Zimbabwean Sign Language"},"translations":{"deu":{"official":"Republik Simbabwe","common":"Simbabwe"},"fra":{"official":"République du Zimbabwe","common":"Zimbabwe"},"hrv":{"official":"Republika Zimbabve","common":"Zimbabve"},"ita":{"official":"Repubblica dello Zimbabwe","common":"Zimbabwe"},"jpn":{"official":"ジンバブエ共和国","common":"ジンバブエ"},"nld":{"official":"Republiek Zimbabwe","common":"Zimbabwe"},"por":{"official":"República do Zimbabwe","common":"Zimbabwe"},"rus":{"official":"Республика Зимбабве","common":"Зимбабве"},"slk":{"official":"Zimbabwianska republika","common":"Zimbabwe"},"spa":{"official":"República de Zimbabue","common":"Zimbabue"},"fin":{"official":"Zimbabwen tasavalta","common":"Zimbabwe"},"est":{"official":"Zimbabwe Vabariik","common":"Zimbabwe"},"zho":{"official":"津巴布韦共和国","common":"津巴布韦"}},"latlng":[-20,30],"demonym":"Zimbabwean","landlocked":true,"borders":["BWA","MOZ","ZAF","ZMB"],"area":390757,"flag":"🇿🇼"}]

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(40);

var _reactRouter = __webpack_require__(45);

var _App = __webpack_require__(963);

var _App2 = _interopRequireDefault(_App);

var _banner = __webpack_require__(1015);

var _room = __webpack_require__(47);

var _global = __webpack_require__(46);

var _user = __webpack_require__(71);

var _collect = __webpack_require__(233);

var _i18n = __webpack_require__(16);

var _routeHelper = __webpack_require__(7);

var _helper = __webpack_require__(28);

var _Map = __webpack_require__(1017);

var _Map2 = _interopRequireDefault(_Map);

var _Room = __webpack_require__(1306);

var _Room2 = _interopRequireDefault(_Room);

var _Apartment = __webpack_require__(1309);

var _Apartment2 = _interopRequireDefault(_Apartment);

var _About = __webpack_require__(1310);

var _About2 = _interopRequireDefault(_About);

var _Media = __webpack_require__(1311);

var _Media2 = _interopRequireDefault(_Media);

var _Team = __webpack_require__(1312);

var _Team2 = _interopRequireDefault(_Team);

var _Contact = __webpack_require__(1313);

var _Contact2 = _interopRequireDefault(_Contact);

var _Space = __webpack_require__(1314);

var _Space2 = _interopRequireDefault(_Space);

var _Coliving = __webpack_require__(1315);

var _Coliving2 = _interopRequireDefault(_Coliving);

var _SiteMap = __webpack_require__(1316);

var _SiteMap2 = _interopRequireDefault(_SiteMap);

var _Service = __webpack_require__(1317);

var _Service2 = _interopRequireDefault(_Service);

var _Page = __webpack_require__(1318);

var _Page2 = _interopRequireDefault(_Page);

var _User = __webpack_require__(1319);

var _User2 = _interopRequireDefault(_User);

var _Forget = __webpack_require__(1334);

var _Forget2 = _interopRequireDefault(_Forget);

var _Verify = __webpack_require__(1335);

var _Verify2 = _interopRequireDefault(_Verify);

var _Login = __webpack_require__(1336);

var _Login2 = _interopRequireDefault(_Login);

var _Signup = __webpack_require__(1337);

var _Signup2 = _interopRequireDefault(_Signup);

var _Privacy = __webpack_require__(1338);

var _Privacy2 = _interopRequireDefault(_Privacy);

var _Terms = __webpack_require__(1339);

var _Terms2 = _interopRequireDefault(_Terms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var createRoutes = function createRoutes(store) {
	return {
		path: '/',
		component: _App2.default,
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(0).then((function (require) {
					var component = __webpack_require__(573).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'HOME'),
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_, __, updateRatio) {
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									_context.next = 2;
									return Promise.all([store.dispatch((0, _banner.getBanner)()), store.dispatch((0, _room.getRoom)())]);

								case 2:
									updateRatio(0.9);

								case 3:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, undefined);
				}));

				return function (_x, _x2, _x3) {
					return _ref.apply(this, arguments);
				};
			}(), store, 'ENTER_HOME')
		},
		onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
			var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_ref3, _, updateRatio) {
				var pathname = _ref3.location.pathname;

				var _store$getState, accessToken, lan;

				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								updateRatio(0.5);
								_store$getState = store.getState(), accessToken = _store$getState.auth.token.accessToken, lan = _store$getState.i18n.lan;

								if (!(accessToken !== '' && !pathname.includes('user/settings') && !pathname.includes('user/interview'))) {
									_context2.next = 8;
									break;
								}

								_context2.next = 5;
								return store.dispatch((0, _user.getUser)());

							case 5:
								if (!pathname.includes((0, _i18n.languageMapRoute)(lan) + '/room')) {
									_context2.next = 8;
									break;
								}

								_context2.next = 8;
								return store.dispatch((0, _collect.getCollect)());

							case 8:

								updateRatio(0.8);

							case 9:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, undefined);
			}));

			return function (_x4, _x5, _x6) {
				return _ref2.apply(this, arguments);
			};
		}(), store, 'ENTER_APP'),
		onChange: function () {
			var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(prevState, nextState, replace, cb) {
				var prevPathname, nextPathname, effectLoading;
				return regeneratorRuntime.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								prevPathname = prevState.location.pathname;
								nextPathname = nextState.location.pathname;
								effectLoading = prevPathname !== nextPathname;

								if (!effectLoading) {
									_context3.next = 13;
									break;
								}

								store.dispatch((0, _global.pageChanging)('CHANGE_APP'));
								store.dispatch((0, _global.loadingRatio)(0, 'CHANGE_APP'));
								_context3.next = 8;
								return (0, _helper.sleep)(300);

							case 8:
								cb();
								store.dispatch((0, _global.loadingRatio)(1, 'CHANGE_APP'));
								store.dispatch((0, _global.pageChanged)('CHANGE_APP'));
								_context3.next = 14;
								break;

							case 13:
								cb();

							case 14:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, undefined);
			}));

			return function onChange(_x7, _x8, _x9, _x10) {
				return _ref4.apply(this, arguments);
			};
		}(),
		childRoutes: [{
			path: 'auth',
			indexRoute: {
				component: null
			},
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(_ref6, _, updateRatio) {
					var _ref6$location$query$ = _ref6.location.query.code,
					    code = _ref6$location$query$ === undefined ? '' : _ref6$location$query$;
					return regeneratorRuntime.wrap(function _callee4$(_context4) {
						while (1) {
							switch (_context4.prev = _context4.next) {
								case 0:
									updateRatio(0.8);

									_context4.next = 3;
									return store.dispatch((0, _user.setIgAccessToken)(code));

								case 3:
								case 'end':
									return _context4.stop();
							}
						}
					}, _callee4, undefined);
				}));

				return function (_x11, _x12, _x13) {
					return _ref5.apply(this, arguments);
				};
			}(), store, 'ENTER_AUTH')
		}, {
			path: ':lang',
			indexRoute: {
				getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
					return __webpack_require__.e/* require.ensure */(0).then((function (require) {
						var component = __webpack_require__(573).default;
						cb(null, component);
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}, store, 'LANGUAGE_HOME'),
				onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
					var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(_, __, updateRatio) {
						return regeneratorRuntime.wrap(function _callee5$(_context5) {
							while (1) {
								switch (_context5.prev = _context5.next) {
									case 0:
										_context5.next = 2;
										return Promise.all([store.dispatch((0, _banner.getBanner)()), store.dispatch((0, _room.getRoom)())]);

									case 2:
										updateRatio(0.9);

									case 3:
									case 'end':
										return _context5.stop();
								}
							}
						}, _callee5, undefined);
					}));

					return function (_x14, _x15, _x16) {
						return _ref7.apply(this, arguments);
					};
				}(), store, 'ENTER_LANGUAGE_HOME')
			},
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(_ref9, replace) {
					var lang = _ref9.params.lang;

					var _store$getState2, lan, newLang;

					return regeneratorRuntime.wrap(function _callee6$(_context6) {
						while (1) {
							switch (_context6.prev = _context6.next) {
								case 0:
									_store$getState2 = store.getState(), lan = _store$getState2.i18n.lan;

									if ((0, _i18n.isLanguageSupportWithRoute)(lang)) {
										_context6.next = 4;
										break;
									}

									replace('/' + (0, _i18n.languageMapRoute)(lan) + '/404');
									return _context6.abrupt('return');

								case 4:
									newLang = (0, _i18n.routeMapLanguage)(lang);


									if (newLang !== lan) {
										(0, _i18n.changeLng)(newLang);
									}

								case 6:
								case 'end':
									return _context6.stop();
							}
						}
					}, _callee6, undefined);
				}));

				return function (_x17, _x18) {
					return _ref8.apply(this, arguments);
				};
			}(), store, 'ENTER_LANGUAGE_HOME'),
			childRoutes: [(0, _Map2.default)(store), (0, _Room2.default)(store), (0, _Apartment2.default)(store), (0, _About2.default)(store), (0, _Media2.default)(store), (0, _Team2.default)(store), (0, _Contact2.default)(store), (0, _Space2.default)(store), (0, _Coliving2.default)(store), (0, _SiteMap2.default)(store), (0, _Service2.default)(store), (0, _User2.default)(store), (0, _Forget2.default)(store), (0, _Verify2.default)(store), (0, _Login2.default)(store), (0, _Signup2.default)(store), (0, _Privacy2.default)(store), (0, _Terms2.default)(store), (0, _Page2.default)(store)]
		}]
	};
};

var Routes = function Routes(_ref10) {
	var store = _ref10.store,
	    history = _ref10.history;
	return _react2.default.createElement(
		_reactRedux.Provider,
		{ store: store },
		_react2.default.createElement(_reactRouter.Router, {
			key: Math.random(),
			onUpdate: function onUpdate() {
				return window.scrollTo(0, 0);
			},
			history: history,
			routes: createRoutes(store)
		})
	);
};

exports.default = Routes;

/***/ }),
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(40);

var _global = __webpack_require__(46);

var _i18n = __webpack_require__(16);

var _component = __webpack_require__(964);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var _ref$global = _ref.global,
	    _ref$global$route = _ref$global.route,
	    loading = _ref$global$route.loading,
	    entering = _ref$global$route.entering,
	    changing = _ref$global$route.changing,
	    cookie = _ref$global.cookie,
	    pathname = _ref.routing.locationBeforeTransitions.pathname,
	    lan = _ref.i18n.lan;
	return {
		loading: loading.length > 0 || entering.length > 0 || changing.length > 0,
		hideHeaderFooter: pathname.includes('print'),
		displayCookie: cookie.display,
		routeName: (0, _i18n.languageMapRoute)(lan)
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		onAgreeCookie: function onAgreeCookie() {
			return dispatch((0, _global.agreeCookie)());
		}
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_component2.default);

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(27);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Header = __webpack_require__(965);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(1007);

var _Footer2 = _interopRequireDefault(_Footer);

var _ErrorBoundary = __webpack_require__(1010);

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

var _Alert = __webpack_require__(231);

var _Alert2 = _interopRequireDefault(_Alert);

var _Cookie = __webpack_require__(1012);

var _Cookie2 = _interopRequireDefault(_Cookie);

var _index = __webpack_require__(1014);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = function App(_ref) {
	var _classnames;

	var children = _ref.children,
	    _ref$loading = _ref.loading,
	    loading = _ref$loading === undefined ? true : _ref$loading,
	    hideHeaderFooter = _ref.hideHeaderFooter,
	    displayCookie = _ref.displayCookie,
	    onAgreeCookie = _ref.onAgreeCookie,
	    routeName = _ref.routeName;
	return _react2.default.createElement(
		_react.Fragment,
		null,
		!hideHeaderFooter && _react2.default.createElement(_Header2.default, null),
		_react2.default.createElement(
			'div',
			{
				className: (0, _classnames3.default)(_index2.default.content, (_classnames = {}, _classnames[_index2.default.show] = !loading, _classnames[_index2.default.hideHeaderFooter] = hideHeaderFooter, _classnames))
			},
			_react2.default.createElement(
				_ErrorBoundary2.default,
				null,
				children
			),
			!hideHeaderFooter && _react2.default.createElement(_Footer2.default, null),
			displayCookie && _react2.default.createElement(_Cookie2.default, { className: _index2.default.cookie, onAgreeCookie: onAgreeCookie, routeName: routeName })
		),
		_react2.default.createElement(
			_Alert2.default,
			{ className: _index2.default.alert, namespace: 'generic' },
			_react2.default.createElement('br', null),
			'Should not be display alert. Just for debug. It should be an API error'
		)
	);
};

exports.default = App;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _Navigator = __webpack_require__(966);

var _Navigator2 = _interopRequireDefault(_Navigator);

var _index = __webpack_require__(1006);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header() {
	return _react2.default.createElement(
		'header',
		{ className: _index2.default.header },
		_react2.default.createElement(_Navigator2.default, null)
	);
};

exports.default = Header;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = __webpack_require__(40);

var _modal = __webpack_require__(56);

var _auth = __webpack_require__(212);

var _i18n = __webpack_require__(16);

var _container = __webpack_require__(554);

var _country = __webpack_require__(85);

var _country2 = _interopRequireDefault(_country);

var _survey = __webpack_require__(559);

var _component = __webpack_require__(969);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initState = function initState() {
	return {
		open: false
	};
};

var mapSetStateToProps = function mapSetStateToProps(_ref, props, setState) {
	var open = _ref.open;
	return _extends({
		open: open,
		closeMenu: function closeMenu() {
			setState({ open: false });
		},
		toggleMenu: function toggleMenu() {
			setState({ open: !open });
		}
	}, props);
};

var NavigatorContainer = (0, _container.contain)(initState, mapSetStateToProps)(_component2.default);

var checkLoading = function checkLoading(_ref2) {
	var loading = _ref2.loading,
	    entering = _ref2.entering,
	    changing = _ref2.changing;
	return loading.length > 0 || entering.length > 0 || changing.length > 0;
};

var calculateRatio = function calculateRatio(_ref3) {
	var loading = _ref3.loading,
	    entering = _ref3.entering,
	    changing = _ref3.changing,
	    ratio = _ref3.ratio;

	var enteringRatio = entering.map(function (page) {
		return ratio[page];
	});
	var changingRatio = changing.map(function (page) {
		return ratio[page];
	});

	return (enteringRatio.reduce(function (sum, cur) {
		return sum + cur;
	}, 0) + changingRatio.reduce(function (sum, cur) {
		return sum + cur;
	}, 0)) / (loading.length + enteringRatio.length + changingRatio.length);
};

var checkTransparentWithPathname = function checkTransparentWithPathname(pathname) {
	var pathArray = pathname.split('/');

	if (pathArray.length <= 2 && pathArray[0] !== 'auth') {
		return true;
	}

	if (pathname.includes('/room/') && !pathname.includes('reservation') && !pathname.includes('booking')) {
		return true;
	}

	return false;
};

var getSurveyOption = function getSurveyOption(name, email, phone, phoneCountry) {
	return {
		ssn11: name,
		ssn12: '+' + _country2.default.getCountryByCode(phoneCountry).dialCode + ' ' + phone,
		ssn13: email
	};
};

var mapStateToProps = function mapStateToProps(_ref4) {
	var pathname = _ref4.routing.locationBeforeTransitions.pathname,
	    lan = _ref4.i18n.lan,
	    _ref4$global = _ref4.global,
	    route = _ref4$global.route,
	    scrollY = _ref4$global.scrollY,
	    media = _ref4$global.media,
	    accessToken = _ref4.auth.token.accessToken,
	    _ref4$user$data = _ref4.user.data,
	    imageUrl = _ref4$user$data.imageUrl,
	    nickname = _ref4$user$data.nickname,
	    name = _ref4$user$data.name,
	    phone = _ref4$user$data.phone,
	    phoneCountry = _ref4$user$data.phoneCountry,
	    email = _ref4$user$data.email;
	return {
		transparent: checkTransparentWithPathname(pathname) && scrollY === 0 && !checkLoading(route),
		loading: checkLoading(route),
		ratio: calculateRatio(route),
		media: media,
		routeName: (0, _i18n.languageMapRoute)(lan),
		isLogin: accessToken !== '',
		suggestSruvey: accessToken === '' ? (0, _survey.generateSurvey)('Mp63x') : (0, _survey.generateSurvey)('Mp63x', getSurveyOption(name, email, phone, phoneCountry)),
		avatar: imageUrl,
		nickname: nickname
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		onOpenLoginSignupModal: function onOpenLoginSignupModal(type) {
			return dispatch((0, _modal.openMessageModal)('loginSignup', { type: type }));
		},
		onLogout: function onLogout() {
			return dispatch((0, _auth.logout)());
		}
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NavigatorContainer);

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isByteLength;

var _assertString = __webpack_require__(213);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFQDN;

var _assertString = __webpack_require__(213);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(458);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFQDN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  for (var i = 0; i < parts.length; i++) {
    if (parts[i].length > 63) {
      return false;
    }
  }
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
    // disallow spaces
    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }
  for (var part, _i = 0; _i < parts.length; _i++) {
    part = parts[_i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    // disallow full-width chars
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(69);

var _classnames7 = __webpack_require__(27);

var _classnames8 = _interopRequireDefault(_classnames7);

var _reactRouter = __webpack_require__(45);

var _Button = __webpack_require__(153);

var _Button2 = _interopRequireDefault(_Button);

var _ProgressBar = __webpack_require__(972);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _MenuButton = __webpack_require__(974);

var _MenuButton2 = _interopRequireDefault(_MenuButton);

var _MobileMenu = __webpack_require__(976);

var _MobileMenu2 = _interopRequireDefault(_MobileMenu);

var _Modal = __webpack_require__(564);

var _Modal2 = _interopRequireDefault(_Modal);

var _Signup = __webpack_require__(995);

var _Signup2 = _interopRequireDefault(_Signup);

var _helper = __webpack_require__(28);

var _logoBlackInline = __webpack_require__(236);

var _logoBlackInline2 = _interopRequireDefault(_logoBlackInline);

var _logoIconInline = __webpack_require__(1004);

var _logoIconInline2 = _interopRequireDefault(_logoIconInline);

var _index = __webpack_require__(1005);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Dropdown = function Dropdown(_ref) {
	var _classnames;

	var transparent = _ref.transparent,
	    title = _ref.title,
	    items = _ref.items,
	    _ref$avatar = _ref.avatar,
	    avatar = _ref$avatar === undefined ? '' : _ref$avatar,
	    children = _ref.children;
	return _react2.default.createElement(
		'li',
		{
			className: (0, _classnames8.default)(_index2.default.dropdown, (_classnames = {}, _classnames[_index2.default.transparent] = transparent, _classnames[_index2.default.avatar] = avatar !== '', _classnames))
		},
		_react2.default.createElement(
			'div',
			{ className: _index2.default.title },
			avatar !== '' && _react2.default.createElement('div', { className: _index2.default.avatar, style: { backgroundImage: 'url(' + avatar + ')' } }),
			title,
			_react2.default.createElement(
				'i',
				{ className: 'material-icons' },
				'keyboard_arrow_down'
			)
		),
		_react2.default.createElement(
			'ul',
			null,
			items.map(function (item) {
				return _react2.default.createElement(
					'li',
					{ key: item.name },
					item.type === 'external' && _react2.default.createElement(
						'a',
						{ href: item.url, target: '_blank' },
						item.name
					),
					item.type === 'internal' && _react2.default.createElement(
						_reactRouter.Link,
						{ to: item.url },
						item.name
					)
				);
			}),
			children
		)
	);
};

var AuthSection = function AuthSection(_ref2) {
	var _classnames2, _classnames3;

	var transparent = _ref2.transparent,
	    routeName = _ref2.routeName,
	    onOpenLoginSignupModal = _ref2.onOpenLoginSignupModal,
	    isLogin = _ref2.isLogin,
	    avatar = _ref2.avatar,
	    nickname = _ref2.nickname,
	    t = _ref2.t,
	    onLogout = _ref2.onLogout;

	if (isLogin) {
		return _react2.default.createElement(
			Dropdown,
			{
				avatar: avatar,
				title: (0, _helper.isEmpty)(nickname) ? t('member') : nickname,
				transparent: transparent,
				items: [{ url: '/' + routeName + '/user/overview', name: t('overview'), type: 'internal' }, { url: '/' + routeName + '/user/settings', name: t('setting'), type: 'internal' }, { url: '/' + routeName + '/user/wishlist', name: t('favorites'), type: 'internal' }, { url: '/' + routeName + '/user/reservation', name: t('propertyHistory'), type: 'internal' }, {
					url: '/' + routeName + '/user/booking',
					name: t('reservationHistory'),
					type: 'internal'
				}, {
					url: '/' + routeName + '/user/community',
					name: t('onlineCommunity'),
					type: 'internal'
				}]
			},
			_react2.default.createElement(
				'li',
				null,
				_react2.default.createElement(
					'button',
					{ onClick: onLogout },
					t('logout')
				)
			)
		);
	}

	return _react2.default.createElement(
		_react.Fragment,
		null,
		_react2.default.createElement(
			'li',
			{ className: (0, _classnames8.default)((_classnames2 = {}, _classnames2[_index2.default.transparent] = transparent, _classnames2)) },
			_react2.default.createElement(
				'button',
				{ className: _index2.default.title, onClick: function onClick() {
						return onOpenLoginSignupModal('loginForm');
					} },
				t('login')
			)
		),
		_react2.default.createElement(
			'li',
			{ className: (0, _classnames8.default)((_classnames3 = {}, _classnames3[_index2.default.transparent] = transparent, _classnames3)) },
			_react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					_Button2.default,
					{
						color: transparent ? 'inverse' : '',
						onClick: function onClick() {
							return onOpenLoginSignupModal('signup');
						}
					},
					t('register')
				)
			)
		)
	);
};

var NavigatorDesktop = function NavigatorDesktop(_ref3) {
	var _classnames4, _classnames5;

	var _ref3$transparent = _ref3.transparent,
	    transparent = _ref3$transparent === undefined ? false : _ref3$transparent,
	    _ref3$loading = _ref3.loading,
	    loading = _ref3$loading === undefined ? false : _ref3$loading,
	    ratio = _ref3.ratio,
	    routeName = _ref3.routeName,
	    onOpenLoginSignupModal = _ref3.onOpenLoginSignupModal,
	    isLogin = _ref3.isLogin,
	    avatar = _ref3.avatar,
	    nickname = _ref3.nickname,
	    t = _ref3.t,
	    onLogout = _ref3.onLogout;
	return _react2.default.createElement(
		'nav',
		{
			className: (0, _classnames8.default)(_index2.default.navigatorDesktop, (_classnames4 = {}, _classnames4[_index2.default.transparent] = transparent, _classnames4[_index2.default.englishWording] = routeName === 'en', _classnames4))
		},
		!transparent && loading && _react2.default.createElement(_ProgressBar2.default, { className: _index2.default.loading, ratio: ratio }),
		_react2.default.createElement(
			_reactRouter.Link,
			{ to: '/' },
			_react2.default.createElement(_logoBlackInline2.default, null)
		),
		_react2.default.createElement(
			'ul',
			null,
			_react2.default.createElement(Dropdown, {
				title: t('choose'),
				transparent: transparent,
				items: [{ url: '/' + routeName + '/room', name: t('filter'), type: 'internal' }, { url: '/' + routeName + '/map', name: t('map'), type: 'internal' }, { url: 'https://pure.9floor.co/', name: t('pauian'), type: 'external' }]
			}),
			_react2.default.createElement(Dropdown, {
				title: t('ninthfloor'),
				transparent: transparent,
				items: [{ url: '/' + routeName + '/about', name: t('about'), type: 'internal' }, { url: '/' + routeName + '/media', name: t('media'), type: 'internal' }, { url: '/' + routeName + '/team', name: t('team'), type: 'internal' }, { url: '/' + routeName + '/contact', name: t('contact'), type: 'internal' }]
			}),
			_react2.default.createElement(Dropdown, {
				title: t('service'),
				transparent: transparent,
				items: [{ url: '/' + routeName + '/space', name: t('space'), type: 'internal' }, { url: '/' + routeName + '/coliving', name: t('coliving'), type: 'internal' }]
			}),
			_react2.default.createElement(
				'li',
				{
					className: (0, _classnames8.default)(_index2.default.dropdown, (_classnames5 = {}, _classnames5[_index2.default.transparent] = transparent, _classnames5))
				},
				_react2.default.createElement(
					'div',
					{ className: _index2.default.title },
					_react2.default.createElement(
						'a',
						{ target: '_blank', rel: 'noopener noreferrer', href: 'https://medium.com/9floor-co-living' },
						t('journal')
					)
				)
			),
			_react2.default.createElement(AuthSection, {
				transparent: transparent,
				routeName: routeName,
				onOpenLoginSignupModal: onOpenLoginSignupModal,
				isLogin: isLogin,
				avatar: avatar,
				nickname: nickname,
				onLogout: onLogout,
				t: t
			})
		)
	);
};

var NavigatorMobile = function NavigatorMobile(_ref4) {
	var _classnames6;

	var _ref4$open = _ref4.open,
	    open = _ref4$open === undefined ? false : _ref4$open,
	    _ref4$transparent = _ref4.transparent,
	    transparent = _ref4$transparent === undefined ? false : _ref4$transparent,
	    _ref4$loading = _ref4.loading,
	    loading = _ref4$loading === undefined ? false : _ref4$loading,
	    isLogin = _ref4.isLogin,
	    nickname = _ref4.nickname,
	    ratio = _ref4.ratio,
	    media = _ref4.media,
	    toggleMenu = _ref4.toggleMenu,
	    routeName = _ref4.routeName,
	    onOpenLoginSignupModal = _ref4.onOpenLoginSignupModal,
	    t = _ref4.t,
	    onLogout = _ref4.onLogout,
	    closeMenu = _ref4.closeMenu;
	return _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(
			'nav',
			{
				className: (0, _classnames8.default)(_index2.default.navigatorMobile, (_classnames6 = {}, _classnames6[_index2.default.transparent] = transparent, _classnames6[_index2.default.open] = open, _classnames6[_index2.default.englishWording] = routeName === 'en', _classnames6))
			},
			_react2.default.createElement(_MenuButton2.default, { open: open, reverseColor: transparent, onClick: toggleMenu }),
			!transparent && loading && _react2.default.createElement(_ProgressBar2.default, { className: _index2.default.loading, ratio: ratio }),
			_react2.default.createElement(
				_reactRouter.Link,
				{ to: '/' },
				media === 'phone' ? _react2.default.createElement(_logoIconInline2.default, null) : _react2.default.createElement(_logoBlackInline2.default, null)
			),
			!isLogin ? _react2.default.createElement(
				'button',
				{
					onClick: function onClick() {
						closeMenu();
						onOpenLoginSignupModal('loginForm');
					}
				},
				t('loginOrRegister')
			) : _react2.default.createElement(
				'span',
				null,
				(0, _helper.isEmpty)(nickname) ? t('member') : nickname
			)
		),
		_react2.default.createElement(_MobileMenu2.default, {
			open: open,
			routeName: routeName,
			onOpenLoginSignupModal: onOpenLoginSignupModal,
			closeMenu: closeMenu,
			isLogin: isLogin,
			t: t,
			onLogout: onLogout
		})
	);
};

var Navigator = function Navigator(_ref5) {
	var media = _ref5.media,
	    _ref5$routeName = _ref5.routeName,
	    routeName = _ref5$routeName === undefined ? 'zh-tw' : _ref5$routeName,
	    other = _objectWithoutProperties(_ref5, ['media', 'routeName']);

	return _react2.default.createElement(
		_react.Fragment,
		null,
		media === 'desktop' ? _react2.default.createElement(NavigatorDesktop, _extends({ routeName: routeName }, other)) : _react2.default.createElement(NavigatorMobile, _extends({ media: media, routeName: routeName }, other)),
		_react2.default.createElement(
			_Modal2.default,
			{ name: 'loginSignup' },
			function (_ref6) {
				var _ref6$message = _ref6.message,
				    type = _ref6$message.type,
				    alert = _ref6$message.alert,
				    success = _ref6$message.success,
				    onDeactive = _ref6.onDeactive;
				return _react2.default.createElement(
					'div',
					{ className: _index2.default.loginDialog },
					_react2.default.createElement(_Signup2.default, { type: type, alert: alert, success: success }),
					_react2.default.createElement(
						'button',
						{ className: _index2.default.closeButton, onClick: onDeactive },
						_react2.default.createElement(
							'i',
							{ className: 'material-icons' },
							'close'
						)
					)
				);
			}
		)
	);
};

exports.default = (0, _reactI18next.translate)('navigator')(Navigator);

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames4 = __webpack_require__(27);

var _classnames5 = _interopRequireDefault(_classnames4);

var _reactRouter = __webpack_require__(45);

var _index = __webpack_require__(971);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Button = function Button(_ref) {
	var _classnames3;

	var children = _ref.children,
	    className = _ref.className,
	    color = _ref.color,
	    link = _ref.link,
	    lan = _ref.lan,
	    _ref$type = _ref.type,
	    type = _ref$type === undefined ? 'internal' : _ref$type,
	    _ref$disabled = _ref.disabled,
	    disabled = _ref$disabled === undefined ? false : _ref$disabled,
	    _ref$onClick = _ref.onClick,
	    _onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	    other = _objectWithoutProperties(_ref, ['children', 'className', 'color', 'link', 'lan', 'type', 'disabled', 'onClick']);

	if (link) {
		var _classnames2;

		if (type === 'external') {
			var _classnames;

			return _react2.default.createElement(
				'a',
				_extends({
					className: (0, _classnames5.default)(_index2.default.button, className, (_classnames = {}, _classnames[_index2.default.inverse] = color === 'inverse', _classnames[_index2.default.primary] = color === 'primary', _classnames[_index2.default.accent] = color === 'accent', _classnames[_index2.default.disabled] = disabled, _classnames[_index2.default.noLetterSpacing] = lan === 'en', _classnames)),
					href: link,
					target: '_blank',
					onClick: function onClick(e) {
						if (!disabled) {
							_onClick(e);
						}
					}
				}, other),
				_react2.default.createElement(
					'div',
					null,
					children
				)
			);
		}

		return _react2.default.createElement(
			_reactRouter.Link,
			_extends({
				className: (0, _classnames5.default)(_index2.default.button, className, (_classnames2 = {}, _classnames2[_index2.default.inverse] = color === 'inverse', _classnames2[_index2.default.primary] = color === 'primary', _classnames2[_index2.default.accent] = color === 'accent', _classnames2[_index2.default.disabled] = disabled, _classnames2[_index2.default.noLetterSpacing] = lan === 'en', _classnames2)),
				to: link,
				onClick: function onClick(e) {
					if (!disabled) {
						_onClick(e);
					}
				}
			}, other),
			_react2.default.createElement(
				'div',
				null,
				children
			)
		);
	}

	return _react2.default.createElement(
		'button',
		_extends({
			className: (0, _classnames5.default)(_index2.default.button, className, (_classnames3 = {}, _classnames3[_index2.default.inverse] = color === 'inverse', _classnames3[_index2.default.primary] = color === 'primary', _classnames3[_index2.default.accent] = color === 'accent', _classnames3[_index2.default.disabled] = disabled, _classnames3[_index2.default.noLetterSpacing] = lan === 'en', _classnames3)),
			onClick: function onClick(e) {
				if (!disabled) {
					_onClick(e);
				}
			}
		}, other),
		_react2.default.createElement(
			'div',
			null,
			children
		)
	);
};

exports.default = Button;

/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"index__button___eMuHc","primary":"index__primary___dhX7w","accent":"index__accent___1tAh4","disabled":"index__disabled___ohqRW","inverse":"index__inverse___16V2m","noLetterSpacing":"index__noLetterSpacing___YJTr0"};

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(973);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(_ref) {
	var ratio = _ref.ratio,
	    className = _ref.className;
	return _react2.default.createElement('div', { className: (0, _classnames2.default)(_index2.default.progressBar, className), style: { width: ratio * 100 + '%' } });
};

exports.default = ProgressBar;

/***/ }),
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progress-bar":"index__progress-bar___1xZzg","progressBar":"index__progress-bar___1xZzg"};

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(975);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuButton = function MenuButton(_ref) {
	var open = _ref.open,
	    reverseColor = _ref.reverseColor,
	    _ref$onClick = _ref.onClick,
	    onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;
	return _react2.default.createElement(
		'div',
		{
			className: (0, _classnames2.default)(_index2.default.menuButton, open ? _index2.default.open : ''),
			role: 'button',
			tabIndex: '0',
			onClick: onClick,
			onKeyPress: onClick
		},
		_react2.default.createElement(
			'div',
			{ className: (0, _classnames2.default)(_index2.default.hamburger, reverseColor ? _index2.default.reverse : '') },
			_react2.default.createElement('div', { className: _index2.default.inner })
		)
	);
};

exports.default = MenuButton;

/***/ }),
/* 975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menu-button":"index__menu-button___16ovZ","menuButton":"index__menu-button___16ovZ","hamburger":"index__hamburger___bQL3x","inner":"index__inner___23CV9","reverse":"index__reverse___CKhLT","open":"index__open___2O-eF"};

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactI18next = __webpack_require__(69);

var _MenuBlock = __webpack_require__(977);

var _MenuBlock2 = _interopRequireDefault(_MenuBlock);

var _LanguageButton = __webpack_require__(235);

var _LanguageButton2 = _interopRequireDefault(_LanguageButton);

var _SocialMedia = __webpack_require__(459);

var _SocialMedia2 = _interopRequireDefault(_SocialMedia);

var _index = __webpack_require__(985);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fisrtItem = function fisrtItem(t, onOpenLoginSignupModal) {
	return [{
		id: 0,
		name: t('login'),
		type: 'action',
		onClick: function onClick() {
			onOpenLoginSignupModal('loginForm');
		}
	}];
};

var authItem = function authItem(t, routeName, onLogout) {
	return [{ id: 0, name: t('navigator:overview'), url: '/' + routeName + '/user/overview', type: 'internal' }, { id: 1, name: t('navigator:setting'), url: '/' + routeName + '/user/settings', type: 'internal' }, { id: 2, name: t('navigator:favorites'), url: '/' + routeName + '/user/wishlist', type: 'internal' }, {
		id: 3,
		name: t('navigator:propertyHistory'),
		url: '/' + routeName + '/user/reservation',
		type: 'internal'
	}, {
		id: 4,
		name: t('navigator:reservationHistory'),
		url: '/' + routeName + '/user/booking',
		type: 'internal'
	}, {
		id: 5,
		name: t('navigator:onlineCommunity'),
		url: '/' + routeName + '/user/community',
		type: 'internal'
	}, { id: 6, name: t('navigator:logout'), type: 'action', onClick: onLogout }];
};

var secondItem = function secondItem(t, routeName) {
	return [{ id: 0, name: t('filter'), url: '/' + routeName + '/room', type: 'internal' }, { id: 1, name: t('area'), url: '/' + routeName + '/map', type: 'internal' }, { id: 2, name: t('pauian'), url: 'https://pure.9floor.co/', type: 'external' }];
};

var thirdItem = function thirdItem(t, routeName) {
	return [{ id: 0, name: t('about'), url: '/' + routeName + '/about', type: 'internal' }, { id: 1, name: t('media'), url: '/' + routeName + '/media', type: 'internal' }, { id: 2, name: t('team'), url: '/' + routeName + '/team', type: 'internal' }, { id: 3, name: t('contact'), url: '/' + routeName + '/contact', type: 'internal' }];
};

var fourthItem = function fourthItem(t, routeName) {
	return [{ id: 0, name: t('space'), url: '/' + routeName + '/space', type: 'internal' }, { id: 1, name: t('coliving'), url: '/' + routeName + '/coliving', type: 'internal' }];
};

var fifthItem = function fifthItem() {
	return [];
};

var sixthItem = function sixthItem(t, routeName) {
	return [{ id: 0, name: t('how'), url: '/' + routeName + '/service', type: 'internal' }, { id: 1, name: t('FAQ'), url: 'https://medium.com/9floor-co-living', type: 'external' }, { id: 2, name: t('contactUs'), url: '/' + routeName + '/contact', type: 'internal' }];
};

var seventhItem = function seventhItem(t, routeName) {
	return [{ id: 0, name: t('termsofService'), url: '/' + routeName + '/terms', type: 'internal' }, { id: 1, name: t('privacy'), url: '/' + routeName + '/privacy', type: 'internal' }, { id: 2, name: t('sitemap'), url: '/' + routeName + '/sitemap', type: 'internal' }];
};

var MobileMenu = function MobileMenu(_ref) {
	var open = _ref.open,
	    _ref$routeName = _ref.routeName,
	    routeName = _ref$routeName === undefined ? 'zh-tw' : _ref$routeName,
	    onOpenLoginSignupModal = _ref.onOpenLoginSignupModal,
	    closeMenu = _ref.closeMenu,
	    isLogin = _ref.isLogin,
	    t = _ref.t,
	    onLogout = _ref.onLogout;
	return _react2.default.createElement(
		'div',
		{ className: (0, _classnames2.default)(_index2.default.mobileMenu, open ? _index2.default.open : '') },
		_react2.default.createElement(
			'div',
			{ className: _index2.default.blocks },
			_react2.default.createElement(_MenuBlock2.default, {
				title: t('member'),
				list: isLogin ? authItem(t, routeName, onLogout) : fisrtItem(t, onOpenLoginSignupModal),
				closeMenu: closeMenu
			}),
			_react2.default.createElement(_MenuBlock2.default, { title: t('checkin'), list: secondItem(t, routeName), closeMenu: closeMenu }),
			_react2.default.createElement(_MenuBlock2.default, { title: t('ninthfloor'), list: thirdItem(t, routeName), closeMenu: closeMenu }),
			_react2.default.createElement(_MenuBlock2.default, { title: t('service'), list: fourthItem(t, routeName), closeMenu: closeMenu }),
			_react2.default.createElement(_MenuBlock2.default, {
				title: t('journal'),
				list: fifthItem(),
				closeMenu: closeMenu,
				titleLink: 'https://medium.com/9floor-co-living'
			}),
			_react2.default.createElement(_MenuBlock2.default, { title: t('help'), list: sixthItem(t, routeName), closeMenu: closeMenu }),
			_react2.default.createElement(_MenuBlock2.default, { title: '', list: seventhItem(t, routeName), closeMenu: closeMenu })
		),
		_react2.default.createElement(
			'div',
			{ className: _index2.default.bottom },
			_react2.default.createElement(_SocialMedia2.default, null),
			_react2.default.createElement(_LanguageButton2.default, null)
		)
	);
};

exports.default = (0, _reactI18next.translate)('sitemap')(MobileMenu);

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(45);

var _index = __webpack_require__(978);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderListItem = function renderListItem(list, closeMenu) {
	return list.map(function (item) {
		var button = null;
		switch (item.type) {
			case 'external':
				button = _react2.default.createElement(
					'a',
					{
						key: item.id,
						className: _index2.default.item,
						href: item.url,
						target: '_blank',
						onClick: closeMenu
					},
					item.name
				);
				break;
			case 'internal':
				button = _react2.default.createElement(
					_reactRouter.Link,
					{ key: item.id, className: _index2.default.item, to: item.url, onClick: closeMenu },
					item.name
				);
				break;
			case 'action':
				button = _react2.default.createElement(
					'button',
					{
						key: item.id,
						className: _index2.default.item,
						onClick: function onClick() {
							closeMenu();
							if (item.onClick) {
								item.onClick();
							}
						}
					},
					item.name
				);
				break;
			default:
				button = null;
				break;
		}
		return button;
	});
};

var MenuBlock = function MenuBlock(_ref) {
	var title = _ref.title,
	    list = _ref.list,
	    titleLink = _ref.titleLink,
	    closeMenu = _ref.closeMenu;
	return _react2.default.createElement(
		'div',
		{ className: _index2.default.menuBlock },
		_react2.default.createElement(
			'div',
			{ className: _index2.default.title },
			titleLink ? _react2.default.createElement(
				'a',
				{ href: titleLink, target: '_blank' },
				title
			) : title
		),
		_react2.default.createElement(
			'div',
			{ className: _index2.default.list },
			renderListItem(list, closeMenu)
		)
	);
};

exports.default = MenuBlock;

/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menu-block":"index__menu-block___1b_3_","menuBlock":"index__menu-block___1b_3_","title":"index__title___3AsOb","list":"index__list___1cQeE","item":"index__item___qNDjl"};

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(227);

var _Icon2 = _interopRequireDefault(_Icon);

var _i18n = __webpack_require__(16);

var _index = __webpack_require__(981);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LanguageButton = function LanguageButton(_ref) {
	var lan = _ref.lan,
	    select = _ref.select,
	    className = _ref.className;
	return _react2.default.createElement(
		'div',
		{ className: (0, _classnames2.default)(_index2.default.outer, className), lang: lan },
		_react2.default.createElement(
			'button',
			{ className: _index2.default.languageButton },
			_react2.default.createElement(
				'div',
				{ className: _index2.default.wrap + ' ' + _index2.default.icon },
				_react2.default.createElement(
					_Icon2.default,
					{ light: true },
					'translate'
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _index2.default.wrap },
				_react2.default.createElement(
					'span',
					null,
					(0, _i18n.mapLanguageName)(lan)
				),
				_react2.default.createElement(
					_Icon2.default,
					null,
					'keyboard_arrow_down'
				)
			)
		),
		_react2.default.createElement(
			'div',
			{ className: _index2.default.dropdown },
			_i18n.LANGUAGE_OPTIONS.map(function (item) {
				return _react2.default.createElement(
					'div',
					{
						key: item.value,
						className: _index2.default.item,
						onKeyPress: function onKeyPress() {},
						role: 'button',
						tabIndex: '0',
						onClick: function onClick() {
							return select(item.value);
						}
					},
					item.label
				);
			})
		)
	);
};

exports.default = LanguageButton;

/***/ }),
/* 980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"index__icon___1quHO","light":"index__light___18-yi"};

/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"outer":"index__outer___eUXlS","language-button":"index__language-button___3wQGD","languageButton":"index__language-button___3wQGD","wrap":"index__wrap___2QeCf","icon":"index__icon___3dKEJ","dropdown":"index__dropdown___3a6_u","item":"index__item___19pJs"};

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgComponent = function SvgComponent(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    version: 1.1,
    fill: "#000000"
  }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    id: "surface1",
    fill: "#000000"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    style: {},
    d: "M 11.46875 5 C 7.917969 5 5 7.914063 5 11.46875 L 5 20.53125 C 5 24.082031 7.914063 27 11.46875 27 L 20.53125 27 C 24.082031 27 27 24.085938 27 20.53125 L 27 11.46875 C 27 7.917969 24.085938 5 20.53125 5 Z M 11.46875 7 L 20.53125 7 C 23.003906 7 25 8.996094 25 11.46875 L 25 20.53125 C 25 23.003906 23.003906 25 20.53125 25 L 11.46875 25 C 8.996094 25 7 23.003906 7 20.53125 L 7 11.46875 C 7 8.996094 8.996094 7 11.46875 7 Z M 21.90625 9.1875 C 21.402344 9.1875 21 9.589844 21 10.09375 C 21 10.597656 21.402344 11 21.90625 11 C 22.410156 11 22.8125 10.597656 22.8125 10.09375 C 22.8125 9.589844 22.410156 9.1875 21.90625 9.1875 Z M 16 10 C 12.699219 10 10 12.699219 10 16 C 10 19.300781 12.699219 22 16 22 C 19.300781 22 22 19.300781 22 16 C 22 12.699219 19.300781 10 16 10 Z M 16 12 C 18.222656 12 20 13.777344 20 16 C 20 18.222656 18.222656 20 16 20 C 13.777344 20 12 18.222656 12 16 C 12 13.777344 13.777344 12 16 12 Z ",
    fill: "#000000"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgComponent);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgComponent = function SvgComponent(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    version: 1.1,
    fill: "#000000"
  }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    id: "surface1",
    fill: "#000000"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    style: {},
    d: "M 7 5 C 5.90625 5 5 5.90625 5 7 L 5 25 C 5 26.09375 5.90625 27 7 27 L 25 27 C 26.09375 27 27 26.09375 27 25 L 27 7 C 27 5.90625 26.09375 5 25 5 Z M 7 7 L 25 7 L 25 25 L 19.8125 25 L 19.8125 18.25 L 22.40625 18.25 L 22.78125 15.25 L 19.8125 15.25 L 19.8125 13.3125 C 19.8125 12.4375 20.027344 11.84375 21.28125 11.84375 L 22.90625 11.84375 L 22.90625 9.125 C 22.628906 9.089844 21.667969 9.03125 20.5625 9.03125 C 18.257813 9.03125 16.6875 10.417969 16.6875 13 L 16.6875 15.25 L 14.0625 15.25 L 14.0625 18.25 L 16.6875 18.25 L 16.6875 25 L 7 25 Z ",
    fill: "#000000"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgComponent);

/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"social-media":"index__social-media___Xpwti","socialMedia":"index__social-media___Xpwti"};

/***/ }),
/* 985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mobile-menu":"index__mobile-menu___1UPaW","mobileMenu":"index__mobile-menu___1UPaW","blocks":"index__blocks___2SRcb","bottom":"index__bottom___1q_7-","open":"index__open___2HcqX"};

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(987);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(991);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(462);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(460);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(15);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(988);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(990);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(460);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(461);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node && node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(989);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(15);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(96);

var _TransitionGroup = __webpack_require__(462);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(3);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"index__modal___c8SFw","inline":"index__inline___23vMg"};

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(40);

var _auth = __webpack_require__(212);

var _modal = __webpack_require__(56);

var _alert = __webpack_require__(17);

var _component = __webpack_require__(996);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var type = _ref.alert.loginSignup.option.type,
	    lan = _ref.i18n.lan;
	return {
		alertType: type,
		lan: lan
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		onSignup: function onSignup() {
			return dispatch((0, _auth.signupNormal)());
		},
		onLogin: function onLogin() {
			return dispatch((0, _auth.loginNormal)());
		},
		onChangeToLogin: function onChangeToLogin() {
			dispatch((0, _alert.closeAlert)('loginSignup'));
			dispatch((0, _modal.openMessageModal)('loginSignup', { type: 'loginForm' }));
		},
		onChangeToSignup: function onChangeToSignup() {
			dispatch((0, _alert.closeAlert)('loginSignup'));
			dispatch((0, _modal.openMessageModal)('loginSignup', { type: 'signup' }));
		},
		onChangeToForget: function onChangeToForget() {
			dispatch((0, _alert.closeAlert)('loginSignup'));
			dispatch((0, _modal.openMessageModal)('loginSignup', { type: 'forgetPassword' }));
		},
		onSendForget: function onSendForget() {
			return dispatch((0, _auth.forgetPassword)());
		},
		onSetPassword: function onSetPassword() {
			return dispatch((0, _auth.setNewPassword)());
		},
		onResendVerifyEmail: function onResendVerifyEmail() {
			return dispatch((0, _auth.resendVerifyEmail)());
		},
		onCloseLoginSignupModal: function onCloseLoginSignupModal() {
			return dispatch((0, _modal.closeMessageModal)('loginSignup'));
		}
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_component2.default);

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactI18next = __webpack_require__(69);

var _reactRouter = __webpack_require__(45);

var _i18n = __webpack_require__(16);

var _logoFontBlackInline = __webpack_require__(997);

var _logoFontBlackInline2 = _interopRequireDefault(_logoFontBlackInline);

var _signupBanner = __webpack_require__(998);

var _signupBanner2 = _interopRequireDefault(_signupBanner);

var _bannerTemp = __webpack_require__(570);

var _bannerTemp2 = _interopRequireDefault(_bannerTemp);

var _Field = __webpack_require__(557);

var _Field2 = _interopRequireDefault(_Field);

var _Checkbox = __webpack_require__(556);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Button = __webpack_require__(153);

var _Button2 = _interopRequireDefault(_Button);

var _Alert = __webpack_require__(231);

var _Alert2 = _interopRequireDefault(_Alert);

var _bind = __webpack_require__(558);

var _index = __webpack_require__(1003);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignupEmailField = (0, _bind.bindField)('auth', 'signupForm', 'email')(_Field2.default);
var SignupPasswordField = (0, _bind.bindField)('auth', 'signupForm', 'password')(_Field2.default);
var SignupCheckPasswordField = (0, _bind.bindField)('auth', 'signupForm', 'checkPassword')(_Field2.default);
var AgreementCheckbox = (0, _bind.bindField)('auth', 'signupForm', 'agreement')(_Checkbox2.default);

var SignUpForm = function SignUpForm(_ref) {
	var onSignup = _ref.onSignup,
	    onChangeToLogin = _ref.onChangeToLogin,
	    t = _ref.t,
	    lan = _ref.lan,
	    onCloseLoginSignupModal = _ref.onCloseLoginSignupModal;
	return _react2.default.createElement(
		_react.Fragment,
		null,
		_react2.default.createElement(_logoFontBlackInline2.default, { className: _index2.default.logo }),
		_react2.default.createElement(_Alert2.default, { className: (0, _classnames2.default)(_index2.default.alert, _index2.default.withlogo), namespace: 'loginSignup' }),
		_react2.default.createElement(SignupEmailField, {
			className: _index2.default.input,
			type: 'email',
			name: 'email',
			icon: 'person_outline',
			placeholder: 'Email'
		}),
		_react2.default.createElement(SignupPasswordField, {
			className: _index2.default.input,
			type: 'password',
			name: 'password',
			icon: 'lock_outline',
			placeholder: 'Password'
		}),
		_react2.default.createElement(SignupCheckPasswordField, {
			className: _index2.default.input,
			type: 'password',
			name: 'check-password',
			icon: 'lock_outline',
			placeholder: 'Confirm password'
		}),
		_react2.default.createElement(
			'span',
			null,
			_react2.default.createElement(AgreementCheckbox, {
				className: _index2.default.checkbox,
				name: 'agree',
				value: 'agree',
				content: t('agree')
			}),
			_react2.default.createElement(
				_reactRouter.Link,
				{ to: '/' + (0, _i18n.languageMapRoute)(lan) + '/terms', onClick: onCloseLoginSignupModal },
				t('termsofService')
			)
		),
		_react2.default.createElement(
			_Button2.default,
			{ className: _index2.default.send, color: 'primary', onClick: onSignup },
			t('register')
		),
		_react2.default.createElement('div', { className: _index2.default.line }),
		_react2.default.createElement(
			'p',
			{ className: _index2.default.status },
			t('already'),
			_react2.default.createElement(
				'span',
				{ onClick: onChangeToLogin, role: 'presentation' },
				t('loginNow')
			)
		)
	);
};

var SignUpSuccess = function SignUpSuccess(_ref2) {
	var onCloseLoginSignupModal = _ref2.onCloseLoginSignupModal,
	    t = _ref2.t;
	return _react2.default.createElement(
		_react.Fragment,
		null,
		_react2.default.createElement(
			'h4',
			null,
			t('successful')
		),
		_react2.default.createElement(
			'p',
			{ className: _index2.default.left },
			t('verification_email')
		),
		_react2.default.createElement(
			_Button2.default,
			{ className: _index2.default.send, color: 'primary', link: '/', onClick: onCloseLoginSignupModal },
			t('back')
		)
	);
};

var LoginEmailField = (0, _bind.bindField)('auth', 'loginForm', 'email')(_Field2.default);
var LoginPasswordField = (0, _bind.bindField)('auth', 'loginForm', 'password')(_Field2.default);
var RememberCheckbox = (0, _bind.bindField)('auth', 'loginForm', 'remember')(_Checkbox2.default);

var LoginForm = function LoginForm(_ref3) {
	var onLogin = _ref3.onLogin,
	    onChangeToSignup = _ref3.onChangeToSignup,
	    onChangeToForget = _ref3.onChangeToForget,
	    alertType = _ref3.alertType,
	    onResendVerifyEmail = _ref3.onResendVerifyEmail,
	    t = _ref3.t;
	return _react2.default.createElement(
		_react.Fragment,
		null,
		_react2.default.createElement(_logoFontBlackInline2.default, { className: _index2.default.logo }),
		_react2.default.createElement(
			_Alert2.default,
			{ className: (0, _classnames2.default)(_index2.default.alert, _index2.default.withlogo), namespace: 'loginSignup' },
			alertType && alertType === 'resendVerifyEmail' && _react2.default.createElement(
				_Button2.default,
				{ onClick: onResendVerifyEmail },
				t('resend')
			)
		),
		_react2.default.createElement(LoginEmailField, {
			className: _index2.default.input,
			type: 'email',
			name: 'email',
			icon: 'person_outline',
			placeholder: 'Email'
		}),
		_react2.default.createElement(LoginPasswordField, {
			className: _index2.default.input,
			type: 'password',
			name: 'password',
			icon: 'lock_outline',
			placeholder: 'Password'
		}),
		_react2.default.createElement(
			'span',
			null,
			_react2.default.createElement(RememberCheckbox, {
				className: _index2.default.checkbox,
				name: 'remember',
				value: 'remember',
				content: t('rememberMe')
			})
		),
		_react2.default.createElement(
			_Button2.default,
			{ className: _index2.default.send, color: 'primary', onClick: onLogin },
			t('login')
		),
		_react2.default.createElement(
			'p',
			{ className: _index2.default.forget },
			t('forgot'),
			_react2.default.createElement(
				'span',
				{ onClick: onChangeToForget, role: 'presentation' },
				t('reset')
			)
		),
		_react2.default.createElement('div', { className: _index2.default.line }),
		_react2.default.createElement(
			'p',
			{ className: _index2.default.status },
			t('not_a_member'),
			_react2.default.createElement(
				'span',
				{ onClick: onChangeToSignup, role: 'presentation' },
				t('application')
			)
		)
	);
};

var ForgetEmailField = (0, _bind.bindField)('auth', 'forgetForm', 'email')(_Field2.default);

var ForgetPassword = function ForgetPassword(_ref4) {
	var onSendForget = _ref4.onSendForget,
	    t = _ref4.t;
	return _react2.default.createElement(
		_react.Fragment,
		null,
		_react2.default.createElement(
			'h4',
			null,
			t('resetPw')
		),
		_react2.default.createElement(_Alert2.default, { className: _index2.default.alert, namespace: 'loginSignup' }),
		_react2.default.createElement(ForgetEmailField, {
			className: _index2.default.input,
			type: 'email',
			name: 'email',
			icon: 'person_outline',
			placeholder: 'Email'
		}),
		_react2.default.createElement(
			_Button2.default,
			{ className: _index2.default.send, color: 'primary', onClick: onSendForget },
			t('send')
		)
	);
};

var NewPasswordField = (0, _bind.bindField)('auth', 'passwordForm', 'password')(_Field2.default);
var NewPasswordCheckField = (0, _bind.bindField)('auth', 'passwordForm', 'checkPassword')(_Field2.default);

var NewPassword = function NewPassword(_ref5) {
	var onSetPassword = _ref5.onSetPassword,
	    t = _ref5.t;
	return _react2.default.createElement(
		_react.Fragment,
		null,
		_react2.default.createElement(
			'h4',
			null,
			t('newPassword')
		),
		_react2.default.createElement(_Alert2.default, { className: _index2.default.alert, namespace: 'loginSignup' }),
		_react2.default.createElement(NewPasswordField, {
			className: _index2.default.input,
			type: 'password',
			name: 'password',
			icon: 'lock_outline',
			placeholder: t('placeholder1')
		}),
		_react2.default.createElement(NewPasswordCheckField, {
			className: _index2.default.input,
			type: 'password',
			name: 'password',
			icon: 'lock_outline',
			placeholder: t('placeholder2')
		}),
		_react2.default.createElement(
			_Button2.default,
			{ className: _index2.default.send, color: 'primary', onClick: onSetPassword },
			t('send')
		)
	);
};

var SignupBanner = function SignupBanner(_ref6) {
	var t = _ref6.t;
	return _react2.default.createElement(
		'div',
		{ className: _index2.default.banner, style: { backgroundImage: 'url(' + _signupBanner2.default + ')' } },
		_react2.default.createElement(
			'div',
			{ className: _index2.default.content },
			_react2.default.createElement(
				'h4',
				null,
				t('becomeResident')
			)
		)
	);
};

var LoginBanner = function LoginBanner(_ref7) {
	var t = _ref7.t;
	return _react2.default.createElement(
		'div',
		{ className: _index2.default.banner, style: { backgroundImage: 'url(' + _bannerTemp2.default + ')' } },
		_react2.default.createElement(
			'p',
			{ className: 'vertical' },
			t('young'),
			_react2.default.createElement('br', null),
			t('year')
		)
	);
};

var TransSignUpForm = (0, _reactI18next.translate)('modalLoginSignup')(SignUpForm);
var TransSignUpSuccess = (0, _reactI18next.translate)('modalLoginSignup')(SignUpSuccess);
var TransLoginForm = (0, _reactI18next.translate)('modalLoginSignup')(LoginForm);
var TransNewPassword = (0, _reactI18next.translate)('modalLoginSignup')(NewPassword);
var TransForgetPassword = (0, _reactI18next.translate)('modalLoginSignup')(ForgetPassword);
var TransSignupBanner = (0, _reactI18next.translate)('modalLoginSignup')(SignupBanner);
var TransLoginBanner = (0, _reactI18next.translate)('modalLoginSignup')(LoginBanner);

var Signup = function Signup(_ref8) {
	var type = _ref8.type,
	    onSignup = _ref8.onSignup,
	    onLogin = _ref8.onLogin,
	    onChangeToLogin = _ref8.onChangeToLogin,
	    onChangeToSignup = _ref8.onChangeToSignup,
	    onChangeToForget = _ref8.onChangeToForget,
	    onSendForget = _ref8.onSendForget,
	    onSetPassword = _ref8.onSetPassword,
	    alertType = _ref8.alertType,
	    onResendVerifyEmail = _ref8.onResendVerifyEmail,
	    onCloseLoginSignupModal = _ref8.onCloseLoginSignupModal,
	    lan = _ref8.lan;
	return _react2.default.createElement(
		'div',
		{ className: _index2.default.signupWrapper },
		_react2.default.createElement(
			'div',
			{ className: _index2.default.form },
			type === 'signup' && _react2.default.createElement(TransSignUpForm, {
				onSignup: onSignup,
				onChangeToLogin: onChangeToLogin,
				onCloseLoginSignupModal: onCloseLoginSignupModal,
				lan: lan
			}),
			type === 'signupSuccess' && _react2.default.createElement(TransSignUpSuccess, { onCloseLoginSignupModal: onCloseLoginSignupModal }),
			type === 'loginForm' && _react2.default.createElement(TransLoginForm, {
				alertType: alertType,
				onLogin: onLogin,
				onChangeToSignup: onChangeToSignup,
				onChangeToForget: onChangeToForget,
				onResendVerifyEmail: onResendVerifyEmail
			}),
			type === 'forgetPassword' && _react2.default.createElement(TransForgetPassword, { onSendForget: onSendForget }),
			type === 'newPassword' && _react2.default.createElement(TransNewPassword, { onSetPassword: onSetPassword })
		),
		type === 'signup' ? _react2.default.createElement(TransSignupBanner, null) : _react2.default.createElement(TransLoginBanner, null)
	);
};

exports.default = (0, _reactI18next.translate)('modalLoginSignup')(Signup);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "logo/black",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "logo",
  transform: "translate(1.000000, 4.000000)",
  fill: "#1F1F1F"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "logo-text"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M17,7.00044444 L17.062,7.00044444 C17.027,6.99944444 17,7.00044444 17,7.00044444",
  id: "Fill-1"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M7.23807769,13.4144033 C7.05830324,13.7442983 6.72993293,14.0145737 6.25363013,14.2258919 C5.77533722,14.4358853 5.17830029,14.5412132 4.45920248,14.5412132 C3.74010467,14.5412132 3.13709737,14.3106842 2.65349746,13.8489638 C2.42861355,13.6330084 2.23689836,13.3826062 2.07835188,13.0984196 C1.91781529,12.8148954 1.79907128,12.5128229 1.7207931,12.1915397 C1.6405248,11.8709189 1.60204909,11.5065771 1.60204909,11.0978518 C1.60204909,10.6891265 1.66108941,10.2817261 1.77850667,9.87498817 C2.18581853,8.49711366 3.08933441,7.8081764 4.49104445,7.8081764 C5.26984595,7.8081764 5.9000516,8.11819816 6.38564163,8.73691682 C6.60588192,9.01514148 6.79096337,9.34304912 6.94420285,9.71798997 C7.09677895,10.0935933 7.20557234,10.4857575 7.27456328,10.8944828 C7.34156409,11.3025457 7.37672293,11.7775149 7.37672293,12.3180657 C7.37672293,12.8586164 7.33028673,13.2242831 7.23807769,13.4144033 M4.42006339,7 C3.40775411,7 2.5334267,7.25305195 1.80039802,7.75849342 C1.43686887,8.00823318 1.11977593,8.30831835 0.850445935,8.66007381 C0.581115943,9.01182928 0.37082627,9.42519163 0.223557161,9.89949844 C0.0742979288,10.3738052 0,10.9395287 0,11.595344 C0,12.2511593 0.154566227,12.8765023 0.463035306,13.4700483 C0.770177637,14.0629318 1.21861871,14.5292893 1.80570502,14.8658086 C2.39212796,15.2029904 3.0223336,15.3712501 3.69300509,15.3712501 C4.36433994,15.3712501 4.95076288,15.3003691 5.4496204,15.1572821 C5.9491413,15.0141951 6.3166507,14.8691208 6.55612884,14.7233841 C6.79494361,14.5763225 6.92828186,14.504779 6.95813371,14.5080912 C6.9866588,14.5120659 6.97538144,14.5908962 6.92430161,14.7452446 C6.49178153,15.9621463 5.79988207,16.9783288 4.8492666,17.7951169 C4.43399425,18.1581338 4.00147417,18.4840541 3.54838947,18.7742027 C3.09464141,19.0630264 2.66344807,19.2968676 2.25348272,19.4744014 C1.84550748,19.6525977 1.47534459,19.8023091 1.14697428,19.9228731 C0.81926734,20.0434371 0.55789784,20.1375035 0.363529152,20.2057348 C0.169160463,20.2733037 0.0716444313,20.3203369 0.0716444313,20.346172 C0.0716444313,20.4481878 0.0975160315,20.582663 0.147932483,20.7495978 C0.200339058,20.9165326 0.257389253,21 0.319083069,21 C0.623571902,21 1.26107467,20.8184915 2.22893786,20.456137 C2.76560772,20.2540929 3.32814919,20.0076654 3.91987912,19.7168544 C4.5102823,19.4253809 5.10930935,19.0438157 5.71696027,18.5734835 C6.32328444,18.1024889 6.86990492,17.5837986 7.3541682,17.0174127 C7.83776811,16.4516892 8.23313923,15.7647393 8.54028157,14.9565629 C8.84676052,14.1483865 9,13.2885398 9,12.3763604 C9,10.6460679 8.55553918,9.30860225 7.6672809,8.36330084 C6.8055576,7.45443361 5.72293064,7 4.42006339,7",
  id: "Fill-3"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M28.4067428,14.3097439 C27.7383992,14.3097439 27.1795315,14.069075 26.7308154,13.5877372 C26.0867998,12.9025612 25.7664815,12.0281521 25.7664815,10.96324 C25.7664815,8.11521908 26.6760775,6.69025612 28.4972969,6.69025612 C29.0953597,6.69025612 29.6048956,6.87821915 30.0272563,7.25478022 C30.8158883,7.96027658 31.2105421,8.94390743 31.2105421,10.2050377 C31.2105421,12.9412968 30.2766181,14.3097439 28.4067428,14.3097439 M28.7777444,6 C27.3525304,6 26.1962757,6.45720737 25.3062772,7.37035208 C24.8994594,7.78818881 24.579141,8.28095675 24.3480252,8.84802088 C24.1148821,9.41572003 24,10.0050095 24,10.6158894 C24,11.8382841 24.4210092,12.8746208 25.2616759,13.7248995 C26.1063974,14.5751782 27.1545277,15 28.4067428,15 C29.8346599,15 30.9618561,14.5612079 31.7883316,13.6829888 C32.5958853,12.825725 33,11.7169971 33,10.3574402 C33,9.14584068 32.614807,8.12029916 31.8437453,7.28081564 C31.0632227,6.42736189 30.0407719,6 28.7777444,6",
  id: "Fill-5"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M39.4074185,14.3097439 C38.7390749,14.3097439 38.1795315,14.069075 37.7308154,13.5877372 C37.0881514,12.9025612 36.7671572,12.0281521 36.7671572,10.96324 C36.7671572,8.11521908 37.6760775,6.69025612 39.4979727,6.69025612 C40.0960354,6.69025612 40.6048956,6.87821915 41.0272563,7.25478022 C41.816564,7.96027658 42.2112179,8.94390743 42.2112179,10.2050377 C42.2112179,12.9412968 41.2772939,14.3097439 39.4074185,14.3097439 M39.7777444,6 C38.3532062,6 37.1962757,6.45720737 36.306953,7.37035208 C35.9001352,7.78818881 35.579141,8.28095675 35.3480252,8.84802088 C35.1155579,9.41572003 35,10.0050095 35,10.6158894 C35,11.8382841 35.4210092,12.8746208 36.2616759,13.7248995 C37.1063974,14.5751782 38.1552035,15 39.4074185,15 C40.8353356,15 41.9625319,14.5612079 42.7890074,13.6829888 C43.596561,12.825725 44,11.7169971 44,10.3574402 C44,9.14584068 43.614807,8.12029916 42.8444211,7.28081564 C42.0638985,6.42736189 41.0407719,6 39.7777444,6",
  id: "Fill-7"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M52.5573258,6.3775809 C52.2617535,6.1258603 51.9319715,6 51.5672955,6 C51.2019353,6 50.8092073,6.17594084 50.3884273,6.52782252 C49.9690157,6.8797042 49.6303392,7.35217455 49.3730818,7.94655147 C49.3162936,8.05593791 49.2882416,8.1211744 49.2882416,8.14357885 L49.2820839,8.05593791 L49.2820839,7.90240152 L49.3046623,6.60162542 C49.3046623,6.50278225 49.2923468,6.44611217 49.2670316,6.42897935 C49.2430847,6.41316445 47.806275,6.42634353 46.5117779,6.47049348 C46.2620467,6.47049348 46.1258919,6.51398448 46.1019451,6.60162542 C46.0916821,6.66027237 46.077314,6.72023722 46.0602092,6.78151999 C46.0431043,6.84412066 46.0294204,6.9014497 46.0171049,6.95416606 C46.0061578,7.00688241 46,7.03324059 46,7.07014204 C46,7.10638454 46.0547356,7.14262703 46.1655752,7.14262703 L47.6324895,7.09913604 L47.6324895,14.261971 L46.5343564,14.261971 C46.3982015,14.261971 46.3167823,14.2968956 46.2900987,14.3654269 C46.2750464,14.4023283 46.2654677,14.4365939 46.2620467,14.4695417 C46.2579416,14.5024894 46.2565732,14.5710206 46.2565732,14.6744765 C46.2565732,14.7785913 46.273678,14.8589837 46.3099404,14.9149949 C46.3462027,14.971665 46.4276219,15 46.5562506,15 L51.1608836,15 C51.3052488,15 51.3941941,14.9598038 51.4284039,14.8794113 C51.4468771,14.8398741 51.4585085,14.8029726 51.4612452,14.7700249 C51.4653504,14.7377361 51.4680872,14.6731586 51.4680872,14.5756333 C51.4680872,14.479426 51.4489297,14.4036462 51.4106148,14.3469761 C51.3736683,14.290306 51.2888281,14.261971 51.1608836,14.261971 L49.6898641,14.2652658 C49.324504,14.2652658 49.3115043,13.9990482 49.3115043,11.9081857 C49.3115043,8.64372529 49.8355977,7.32383951 50.6730525,7.32383951 C50.8283648,7.32383951 51.0418336,7.44376922 51.3148275,7.68362864 C51.4160884,7.77126959 51.5358225,7.85232098 51.6726615,7.92810075 C51.8088163,8.0025626 51.9559183,8.03946405 52.1153357,8.03946405 C52.274069,8.03946405 52.4608543,7.91030898 52.6770599,7.65133987 C52.8925814,7.39237077 53,7.17821057 53,7.00885928 C53,6.83950798 52.8528981,6.62930151 52.5573258,6.3775809",
  id: "Fill-9"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M20.7122964,14.2791865 L19.4892275,14.2791865 C19.4314241,14.2791865 19.4248555,3.54550135 19.482659,0.90809628 C19.482659,0.647444974 19.510247,0.436993178 19.4012086,0.436993178 C19.339464,0.436993178 19.3420914,0.445359763 19.2619548,0.46144935 C19.182475,0.477538937 19.0714661,0.498133608 18.9302417,0.52258978 C18.7883605,0.547689535 18.6451655,0.56892779 18.5,0.586948127 C18.3541776,0.604968464 18.2576195,0.609473549 18.2096689,0.60046338 C18.1630321,0.590809628 18.0815817,0.551551036 17.9653179,0.480113271 C17.3984498,0.160252285 16.8335523,0 16.2699685,0 C15.1953494,0 14.3217288,0.293474064 13.6484498,0.881065774 C12.6999475,1.70678337 12.3445875,2.76032951 12.2263531,4.37250611 L12.2480294,6.49311366 C12.2480294,6.52786716 12.2460589,6.55682842 12.2427746,6.58128459 C12.2381766,6.6198996 12.2283237,6.64564294 12.2145297,6.65851461 C12.1935102,6.67975286 12.1370205,6.69069378 12.047031,6.69069378 L11.3809774,6.69069378 C11.271939,6.69069378 11.2023121,6.7132192 11.1740673,6.75698288 C11.1451655,6.80203372 11.1307147,6.89599691 11.1307147,7.04080319 C11.1307147,7.18496589 11.1504204,7.27892908 11.1904887,7.32333634 C11.230557,7.36838718 11.3159485,7.39026902 11.4466632,7.39026902 L12.2263531,7.39026902 C12.2368628,7.39026902 12.2513137,7.42180461 12.2513137,7.62775132 L12.2506569,14.2791865 L12.1830005,14.2791865 L11.2666842,14.2791865 C11.1359695,14.2791865 11.0578035,14.3132964 11.032186,14.3802291 C11.0177352,14.4162698 11.009196,14.4503797 11.0052549,14.4819153 C11.0013137,14.5140945 11,14.5784528 11,14.6743468 C11,14.7708843 11.013794,14.8545501 11.0433526,14.9253443 C11.0650289,14.9749002 11.1464792,15 11.2883605,15 L15.2833684,15 C15.4942197,15 15.6006306,14.8777191 15.6006306,14.6318703 C15.6006306,14.5636504 15.5980032,14.5140945 15.594062,14.4819153 C15.580268,14.3467628 15.4758276,14.2791865 15.2833684,14.2791865 L13.9460063,14.2791865 L13.7877036,14.2791865 L13.8317131,7.56596731 C13.8317131,7.47779637 13.850762,7.42244819 13.8888597,7.40056635 C13.9269574,7.3793281 14.0957698,7.36903076 14.2586705,7.36903076 L16.2344982,7.36903076 C16.2883605,7.36903076 16.3704677,7.37611018 16.3704677,7.30016733 L16.3704677,6.80267731 C16.3704677,6.70871412 16.2909879,6.69262453 16.2410667,6.69069378 L16.2023121,6.69069378 L14.2586705,6.69069378 C14.0589858,6.69069378 13.8750657,6.67782211 13.8395954,6.65336594 C13.8264582,6.64306861 13.8146348,6.62118677 13.8060956,6.58900759 C13.8060956,6.58900759 13.9460063,3.22564037 13.9492906,3.02806024 C13.9538886,2.73394259 14.0162901,2.43725061 14.0740935,2.21843223 C14.1312401,1.99961385 14.2100631,1.78465697 14.3079348,1.57484876 C14.4058066,1.36504055 14.5233841,1.19191659 14.6593537,1.05676406 C14.79598,0.921611533 14.962165,0.812845926 15.1579086,0.731110825 C15.354309,0.648732141 15.6209932,0.608186382 15.9573043,0.608186382 C16.2923016,0.608186382 16.5655544,0.731110825 16.7711508,0.976316128 C16.8769049,1.0979534 16.9629532,1.21701635 17.0312664,1.33479212 C17.097609,1.45192431 17.1764319,1.59866135 17.268392,1.77500322 C17.3583815,1.95134509 17.4280084,2.07620028 17.4772727,2.14892522 C17.526537,2.22229373 17.5764582,2.29051358 17.6250657,2.35487193 C17.6736731,2.41858669 17.7071729,2.46685545 17.7255649,2.49839104 C17.7426432,2.53057021 17.7623489,2.58076973 17.7800841,2.64834599 C17.7978192,2.71592226 17.9035733,3.12266701 17.9173673,3.86858025 C17.9318182,4.61384992 17.8214661,14.2791865 17.7636626,14.2791865 L16.7113768,14.2791865 C16.5806621,14.2791865 16.5024961,14.3132964 16.4781923,14.3802291 C16.4624277,14.4162698 16.4538886,14.4503797 16.4499475,14.4819153 C16.4460063,14.5140945 16.4446926,14.5810272 16.4446926,14.6820698 C16.4446926,14.783756 16.4624277,14.8622731 16.4992118,14.9169777 C16.5359958,14.9723259 16.6154756,15 16.7389648,15 L20.7122964,15 C20.7806096,15 20.8469522,14.9871283 20.9080399,14.9600978 C20.9710983,14.9337109 21,14.8236581 21,14.6318703 C21,14.3969623 20.9047556,14.2791865 20.7122964,14.2791865",
  id: "Fill-11"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M17,7 C17.076,7.003 17.196,7.028 17.196,7.174",
  id: "Fill-13"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M13,4 L13.025,6 C13.031,5.97785548 13.033,5.9516317 13.033,5.92016317 L13,4 Z",
  id: "Fill-15"
}))));

var SvgComponent = function SvgComponent(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    width: "55px",
    height: "30px",
    viewBox: "0 0 55 30",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgComponent);

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./assets/signupBanner__214e4fc0038061e3c44b94dc57eea5a9.png";

/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field":"index__field___hO4CV","icon":"index__icon___1lkGF","file":"index__file___2htsb","invalid":"index__invalid___3bGVN"};

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"index__label___1BkqV","checkbox":"index__checkbox___1-8M_","small":"index__small___1btrb"};

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "Bounding_Boxes"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_3",
  display: "none"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  fill: "none",
  d: "M0,0h24v24H0V0z"
}));

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "Rounded",
  display: "none"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_5"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  display: "inline"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M12,17L12,17c-0.55,0-1-0.45-1-1v-4 c0-0.55,0.45-1,1-1h0c0.55,0,1,0.45,1,1v4C13,16.55,12.55,17,12,17z M13,9h-2V7h2V9z"
})));

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "Sharp",
  display: "none"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_4"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  display: "inline"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2V9z"
})));

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "Outline"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "ui_x5F_spec_x5F_header",
  display: "none"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", {
  x: 11,
  y: 7,
  width: 2,
  height: 2
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", {
  x: 11,
  y: 11,
  width: 2,
  height: 6
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8 c0-4.41,3.59-8,8-8s8,3.59,8,8C20,16.41,16.41,20,12,20z"
})));

var _ref5 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "Duotone",
  display: "none"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_2"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  display: "inline"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  opacity: 0.3,
  d: "M12,4c-4.41,0-8,3.59-8,8c0,4.41,3.59,8,8,8s8-3.59,8-8C20,7.59,16.41,4,12,4z M13,17h-2v-6h2V17z M13,9h-2 V7h2V9z"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", {
  x: 11,
  y: 7,
  width: 2,
  height: 2
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", {
  x: 11,
  y: 11,
  width: 2,
  height: 6
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8 c0-4.41,3.59-8,8-8s8,3.59,8,8C20,16.41,16.41,20,12,20z"
})));

var _ref6 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "Material",
  display: "none"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  display: "inline"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2V9z"
})));

var SvgComponent = function SvgComponent(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgComponent);

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"alert":"index__alert___21llZ","show":"index__show___2C53N","text":"index__text___3VY6T","success":"index__success___1Nmfb"};

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"signup-wrapper":"index__signup-wrapper___34dd4","signupWrapper":"index__signup-wrapper___34dd4","form":"index__form___3I2nx","logo":"index__logo___2grAR","alert":"index__alert___uBoNr","withlogo":"index__withlogo___zpPG_","left":"index__left___jfbK9","input":"index__input___2mWKs","checkbox":"index__checkbox___1oKTA","send":"index__send___2BxzX","line":"index__line___1enhW","forget":"index__forget___1CpAZ","status":"index__status___2InAd","banner":"index__banner___Zq8Te","content":"index__content___1i-1R"};

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, "logo/icon-black");

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon", {
  id: "path-1",
  points: "8.82352941e-05 0.522082949 29.4441176 0.522082949 29.4441176 28.202765 8.82352941e-05 28.202765"
}));

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "logo/icon-black",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "logo-icon"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M9.0975,13.1871982 C9.01102941,13.4675668 8.96867647,13.7495945 8.96867647,14.0307926 C8.96867647,14.3128203 8.99691176,14.5649862 9.05514706,14.7864608 C9.1125,15.007106 9.19985294,15.2153088 9.31720588,15.4118986 C9.43367647,15.607659 9.57485294,15.7801935 9.73897059,15.9295023 C10.0936765,16.2471982 10.5348529,16.4072903 11.0625,16.4072903 C11.5892647,16.4072903 12.0269118,16.3351244 12.3772059,16.1891336 C12.7266176,16.0431429 12.9675,15.8573364 13.0998529,15.6292258 C13.1669118,15.4973364 13.1995588,15.246 13.1995588,14.8727281 C13.1995588,14.4994562 13.1757353,14.1718065 13.1254412,13.8906083 C13.0760294,13.6085806 12.9948529,13.3381659 12.8836765,13.0793641 C12.7725,12.8205622 12.6348529,12.5941106 12.4742647,12.4016682 C12.1186765,11.9744793 11.6563235,11.76047 11.0863235,11.76047 C10.0583824,11.76047 9.39573529,12.2365991 9.0975,13.1871982 M9.11691176,16.630424 C8.68720588,16.3981659 8.35897059,16.0763226 8.13308824,15.6673825 C7.90720588,15.2576129 7.79338235,14.827106 7.79338235,14.3742028 C7.79338235,13.922129 7.84808824,13.5314378 7.9575,13.2046175 C8.06602941,12.8761382 8.21955882,12.5916221 8.41720588,12.3485806 C8.61573529,12.1055392 8.84691176,11.8989954 9.11338235,11.7264608 C9.65073529,11.3772442 10.2913235,11.2030507 11.0333824,11.2030507 C11.9880882,11.2030507 12.7822059,11.5165991 13.4139706,12.1436959 C14.0642647,12.7956774 14.3907353,13.7197327 14.3907353,14.9125438 C14.3907353,15.542129 14.2786765,16.1360461 14.0536765,16.6934654 C13.8286765,17.2508848 13.5392647,17.7253548 13.1845588,18.1152166 C12.8289706,18.5059078 12.4292647,18.8642488 11.9836765,19.1885806 C11.5389706,19.5137419 11.0995588,19.7766912 10.6663235,19.9782581 C10.2339706,20.1798249 9.82102941,20.349871 9.42838235,20.4883963 C8.71808824,20.7389032 8.25132353,20.8633272 8.02808824,20.8633272 C7.98220588,20.8633272 7.94073529,20.8069217 7.90279412,20.6916221 C7.86573529,20.5754931 7.84632353,20.4825899 7.84632353,20.4129124 C7.84632353,20.3938341 7.91779412,20.3623134 8.06073529,20.3158618 C8.20279412,20.2685806 8.39426471,20.2038802 8.63514706,20.1201014 C8.87602941,20.0363226 9.14602941,19.9334654 9.44602941,19.81153 C9.74602941,19.688765 10.0619118,19.5278433 10.3945588,19.327106 C10.7263235,19.1280276 11.0448529,18.903235 11.3483824,18.6527281 C12.0445588,18.0886728 12.5519118,17.3860922 12.8695588,16.5474747 C12.9066176,16.4412995 12.9154412,16.386553 12.8933824,16.3840645 C12.8722059,16.3824055 12.7742647,16.4305161 12.5995588,16.5325438 C12.4248529,16.6329124 12.1539706,16.7324516 11.7877941,16.8328203 C11.4225,16.9307005 10.9936765,16.9796406 10.5013235,16.9796406 C10.0089706,16.9796406 9.5475,16.8635115 9.11691176,16.630424",
  id: "Fill-1",
  fill: "#1F1F1F"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M17.2028824,13.036977 L16.5649412,13.036977 C16.467,13.036977 16.4034706,13.0203871 16.3752353,12.9888664 C16.3461176,12.9565161 16.332,12.8893272 16.332,12.78647 C16.332,12.6844424 16.3434706,12.6155945 16.3672941,12.5824147 C16.3902353,12.549235 16.4396471,12.5326452 16.5164118,12.5326452 L17.0202353,12.5326452 C17.0740588,12.5326452 17.1075882,12.5268387 17.1181765,12.5135668 C17.1296471,12.5011244 17.1340588,12.4596498 17.1340588,12.3908018 L17.1014118,10.8620461 C17.1014118,9.2760553 17.6422941,8.28315207 18.7231765,7.88250691 C19.032,7.76637788 19.3399412,7.70914286 19.6487647,7.70914286 C19.9575882,7.70914286 20.2205294,7.75310599 20.4393529,7.84020276 C20.6572941,7.92729954 20.8408235,8.05670046 20.9899412,8.22840553 C21.1381765,8.4001106 21.2131765,8.58591705 21.2131765,8.78333641 C21.2131765,8.98075576 21.1064118,9.16656221 20.8937647,9.33992627 C20.6802353,9.51246083 20.4967059,9.59872811 20.3414118,9.59872811 C20.1852353,9.59872811 20.1005294,9.53651613 20.0872941,9.41126267 C20.0872941,9.41126267 20.0714118,9.2884977 20.0396471,9.06785253 C20.0087647,8.84720737 19.9478824,8.6398341 19.8578824,8.44656221 C19.7678824,8.25246083 19.5975882,8.15292166 19.3505294,8.14711521 C19.1255294,8.14711521 18.9675882,8.21347465 18.8749412,8.34287558 C18.7822941,8.4722765 18.7117059,8.58674654 18.6640588,8.68711521 C18.6164118,8.78665438 18.5775882,8.90693088 18.5467059,9.04628571 C18.5175882,9.18647005 18.4928824,9.32001843 18.4734706,9.44527189 C18.4540588,9.57135484 18.4408235,9.71485714 18.4328824,9.87660829 C18.4187647,10.1461935 18.4125882,10.3651797 18.4125882,10.5343963 C18.4125882,10.7036129 18.3993529,11.2967005 18.3755294,12.313659 C18.3755294,12.4190046 18.3975882,12.4812166 18.4408235,12.5011244 C18.4849412,12.5226912 18.5925882,12.5326452 18.7646471,12.5326452 L20.6228824,12.5326452 C20.7349412,12.5326452 20.7914118,12.5625069 20.7914118,12.6205714 C20.7914118,12.6802949 20.7764118,12.7615853 20.7481765,12.8652719 C20.7190588,12.969788 20.6828824,13.0212166 20.6396471,13.0212166 L18.7646471,13.0212166 C18.6331765,13.0212166 18.5467059,13.0295115 18.507,13.0461014 C18.4655294,13.0626912 18.4443529,13.1016774 18.4443529,13.1638894 L18.4443529,18.0023226 L19.7343529,18.0023226 C19.8278824,18.0023226 19.8843529,18.0189124 19.9046471,18.0512627 C19.9249412,18.0827834 19.9355294,18.1524608 19.9355294,18.2586359 C19.9355294,18.3656406 19.9231765,18.4361475 19.9011176,18.4701567 C19.8772941,18.5058249 19.8111176,18.5215853 19.7025882,18.5215853 L17.892,18.4917235 L16.4996471,18.5215853 C16.3902353,18.5215853 16.3187647,18.5025069 16.2834706,18.4610323 C16.2472941,18.4195576 16.2296471,18.3515392 16.2296471,18.256977 C16.2296471,18.0877604 16.3143529,18.0023226 16.4837647,18.0023226 L17.1861176,18.0023226 L17.2028824,13.036977 Z",
  id: "Fill-3",
  fill: "#1F1F1F"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "Group-7",
  transform: "translate(0.000000, 0.307410)"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", {
  xlinkHref: "#path-1"
})), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
  id: "Clip-6"
}), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M14.7221471,1.53987097 C7.20185294,1.53987097 1.08273529,7.29240553 1.08273529,14.3621751 C1.08273529,21.4327742 7.20185294,27.1853088 14.7221471,27.1853088 C22.2433235,27.1853088 28.3615588,21.4327742 28.3615588,14.3621751 C28.3615588,7.29240553 22.2433235,1.53987097 14.7221471,1.53987097 M14.7221471,28.2030968 C6.6045,28.2030968 8.82352941e-05,21.9935115 8.82352941e-05,14.3621751 C8.82352941e-05,6.73083871 6.6045,0.522082949 14.7221471,0.522082949 C22.8397941,0.522082949 29.4442059,6.73083871 29.4442059,14.3621751 C29.4442059,21.9935115 22.8397941,28.2030968 14.7221471,28.2030968",
  id: "Fill-5",
  fill: "#1F1F1F",
  mask: "url(#mask-2)"
}))));

var SvgComponent = function SvgComponent(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgComponent);

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navigator-desktop":"index__navigator-desktop___272Y-","navigatorDesktop":"index__navigator-desktop___272Y-","transparent":"index__transparent___2vkcF","english-wording":"index__english-wording___1SuC4","englishWording":"index__english-wording___1SuC4","title":"index__title___2CG9c","dropdown":"index__dropdown___634G3","avatar":"index__avatar___2Ck3C","loading":"index__loading___1xfSo","navigator-mobile":"index__navigator-mobile___lGOhi","navigatorMobile":"index__navigator-mobile___lGOhi","open":"index__open___3Qsu-","login-dialog":"index__login-dialog___1p2uF","loginDialog":"index__login-dialog___1p2uF","close-button":"index__close-button___3cVnI","closeButton":"index__close-button___3cVnI"};

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"index__header___2FuYt"};

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(40);

var _i18n = __webpack_require__(16);

var _component = __webpack_require__(1008);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var lan = _ref.i18n.lan;
	return {
		lan: lan,
		mapLanguage: (0, _i18n.languageMapRoute)(lan)
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_component2.default);

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(45);

var _reactI18next = __webpack_require__(69);

var _classnames2 = __webpack_require__(27);

var _classnames3 = _interopRequireDefault(_classnames2);

var _LanguageButton = __webpack_require__(235);

var _LanguageButton2 = _interopRequireDefault(_LanguageButton);

var _SocialMedia = __webpack_require__(459);

var _SocialMedia2 = _interopRequireDefault(_SocialMedia);

var _logoBlackInline = __webpack_require__(236);

var _logoBlackInline2 = _interopRequireDefault(_logoBlackInline);

var _index = __webpack_require__(1009);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(_ref) {
	var _classnames;

	var lan = _ref.lan,
	    mapLanguage = _ref.mapLanguage,
	    t = _ref.t;
	return _react2.default.createElement(
		'footer',
		{
			className: (0, _classnames3.default)(_index2.default.footer, (_classnames = {}, _classnames[_index2.default.englishWording] = lan === 'en', _classnames))
		},
		_react2.default.createElement(
			'div',
			{ className: _index2.default.footerTop },
			_react2.default.createElement(
				'div',
				{ className: _index2.default.footerSitemap },
				_react2.default.createElement(
					'div',
					{ className: _index2.default.column },
					_react2.default.createElement(
						'h5',
						null,
						t('room')
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: '/' + mapLanguage + '/room' },
						t('filter')
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: '/' + mapLanguage + '/map' },
						t('map')
					),
					_react2.default.createElement(
						'a',
						{
							href: 'https://pure.9floor.co/',
							target: '_blank',
							rel: 'noopener noreferrer'
						},
						t('pauian')
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _index2.default.column },
					_react2.default.createElement(
						'h5',
						null,
						t('ninthfloor')
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: '/' + mapLanguage + '/about' },
						t('about')
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: '/' + mapLanguage + '/team' },
						t('team')
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: '/' + mapLanguage + '/space' },
						t('space')
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: '/' + mapLanguage + '/coliving' },
						t('coliving')
					),
					_react2.default.createElement(
						'a',
						{
							href: 'https://medium.com/9floor-co-living/tagged/9fnews',
							target: '_blank',
							rel: 'noopener noreferrer'
						},
						t('news')
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _index2.default.column },
					_react2.default.createElement(
						'h5',
						null,
						t('help')
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: '/' + mapLanguage + '/service' },
						t('how')
					),
					_react2.default.createElement(
						'a',
						{ href: 'https://medium.com/9floor-co-living', target: '_blank', rel: 'noopener noreferrer' },
						t('FAQ')
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: '/' + mapLanguage + '/contact' },
						t('contact')
					),
					_react2.default.createElement(
						_reactRouter.Link,
						{ href: '/' + mapLanguage + '/media' },
						t('media')
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _index2.default.footerInfo },
				_react2.default.createElement(
					'div',
					{ className: _index2.default.logo },
					_react2.default.createElement(_logoBlackInline2.default, null)
				),
				_react2.default.createElement(_LanguageButton2.default, { className: _index2.default.lanButton }),
				_react2.default.createElement(_SocialMedia2.default, null)
			)
		),
		_react2.default.createElement(
			'div',
			{ className: _index2.default.footerBottom },
			_react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(
					'span',
					{ role: 'img', 'aria-labelledby': 'copy-right' },
					'\xA9'
				),
				'\u7396\u6A13 9floor 2019'
			),
			_react2.default.createElement(
				'div',
				{ className: _index2.default.footerPolicy },
				_react2.default.createElement(
					_reactRouter.Link,
					{ to: '/' + mapLanguage + '/terms' },
					_react2.default.createElement(
						'span',
						null,
						t('termsofService')
					)
				),
				_react2.default.createElement(
					_reactRouter.Link,
					{ to: '/' + mapLanguage + '/service' },
					_react2.default.createElement(
						'span',
						null,
						t('description')
					)
				),
				_react2.default.createElement(
					_reactRouter.Link,
					{ to: '/' + mapLanguage + '/privacy' },
					_react2.default.createElement(
						'span',
						null,
						t('privacy')
					)
				),
				_react2.default.createElement(
					_reactRouter.Link,
					{ to: '/' + mapLanguage + '/sitemap' },
					_react2.default.createElement(
						'span',
						null,
						t('sitemap')
					)
				)
			)
		)
	);
};

exports.default = (0, _reactI18next.translate)('footer')(Footer);

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"index__footer___3G6lz","footer-top":"index__footer-top___2pjg4","footerTop":"index__footer-top___2pjg4","footer-policy":"index__footer-policy___OiSE3","footerPolicy":"index__footer-policy___OiSE3","footer-sitemap":"index__footer-sitemap___3PF5n","footerSitemap":"index__footer-sitemap___3PF5n","column":"index__column___2J2d0","footer-info":"index__footer-info___ILNd5","footerInfo":"index__footer-info___ILNd5","logo":"index__logo___15ADa","lan-button":"index__lan-button___1Ltlr","lanButton":"index__lan-button___1Ltlr","footer-bottom":"index__footer-bottom___3_jVx","footerBottom":"index__footer-bottom___3_jVx","english-wording":"index__english-wording___3Ye9j","englishWording":"index__english-wording___3Ye9j","social-media":"index__social-media___mF3p_","socialMedia":"index__social-media___mF3p_"};

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1011);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorBoundary = function (_Component) {
	_inherits(ErrorBoundary, _Component);

	function ErrorBoundary(props) {
		_classCallCheck(this, ErrorBoundary);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			hasError: false,
			info: {
				componentStack: ''
			}
		};
		return _this;
	}

	ErrorBoundary.prototype.componentDidCatch = function componentDidCatch(error, info) {
		this.setState({ hasError: true, info: info });
	};

	ErrorBoundary.prototype.render = function render() {
		if (this.state.hasError) {
			return _react2.default.createElement(
				'div',
				{ className: _index2.default.errorBoundary },
				_react2.default.createElement(
					'h3',
					null,
					'OOPS! \u6709\u5730\u65B9\u51FA\u932F\u4E86'
				),
				_react2.default.createElement(
					'div',
					null,
					this.state.info.componentStack
				)
			);
		}
		return this.props.children;
	};

	return ErrorBoundary;
}(_react.Component);

exports.default = ErrorBoundary;

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"error-boundary":"index__error-boundary___3nquK","errorBoundary":"index__error-boundary___3nquK"};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactI18next = __webpack_require__(69);

var _reactRouter = __webpack_require__(45);

var _Button = __webpack_require__(153);

var _Button2 = _interopRequireDefault(_Button);

var _index = __webpack_require__(1013);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cookie = function Cookie(_ref) {
	var className = _ref.className,
	    t = _ref.t,
	    onAgreeCookie = _ref.onAgreeCookie,
	    routeName = _ref.routeName;
	return _react2.default.createElement(
		'div',
		{ className: (0, _classnames2.default)(className, _index2.default.cookie) },
		_react2.default.createElement(
			'h5',
			null,
			t('title')
		),
		_react2.default.createElement(
			'div',
			{ className: _index2.default.sectionBottom },
			_react2.default.createElement(
				'p',
				null,
				t('description'),
				' ',
				_react2.default.createElement(
					_reactRouter.Link,
					{ className: 'underline', to: routeName + '/privacy' },
					t('policy')
				)
			),
			_react2.default.createElement(
				_Button2.default,
				{ onClick: onAgreeCookie },
				t('buttonText')
			)
		)
	);
};

exports.default = (0, _reactI18next.translate)('cookie')(Cookie);

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cookie":"index__cookie___37oug","sectionBottom":"index__sectionBottom___21rSU"};

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"index__content___1tCaL","show":"index__show___27iWO","hide-header-footer":"index__hide-header-footer___28xpb","hideHeaderFooter":"index__hide-header-footer___28xpb","cookie":"index__cookie___2jgnO","alert":"index__alert___3Yd94"};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getBanner = undefined;

var _reduxActions = __webpack_require__(5);

var _alert = __webpack_require__(17);

var _coLiving = __webpack_require__(1016);

var _endpoint = __webpack_require__(35);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getBanner = exports.getBanner = (0, _reduxActions.createAction)('FETCH_BANNER', function () {
	return function () {
		var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
			var _ref2, status, message, _ref2$data, banner, lifestyle;

			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return (0, _endpoint.wrapFetch)('banner', {
								method: 'GET'
							});

						case 2:
							_ref2 = _context.sent;
							status = _ref2.status;
							message = _ref2.message;
							_ref2$data = _ref2.data;
							banner = _ref2$data.banner;
							lifestyle = _ref2$data.lifestyle;

							if (!(status !== 200)) {
								_context.next = 10;
								break;
							}

							throw (0, _alert.openFailedAlert)('generic', message);

						case 10:

							dispatch((0, _coLiving.getCoLiving)(lifestyle));

							return _context.abrupt('return', {
								id: banner.id,
								subTitle: banner.subtitle,
								title: banner.title,
								url: banner.url_url,
								createdAt: banner.created_at,
								updatedAt: banner.updated_at
							});

						case 12:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x) {
			return _ref.apply(this, arguments);
		};
	}();
});

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getCoLiving = undefined;

var _reduxActions = __webpack_require__(5);

var getCoLiving = exports.getCoLiving = (0, _reduxActions.createAction)('GET_COLIVING', function (items) {
	var data = {};
	var list = items.map(function (item) {
		data[item.id] = {
			apartmentId: item.apartment_id,
			apartmentName: '',
			content: item.content,
			id: item.id,
			position: item.position,
			url: item.url_url,
			title: item.title,
			createdAt: item.created_at
		};

		return item.id;
	});

	return { list: list, data: data };
});

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _global = __webpack_require__(46);

var _apartment = __webpack_require__(145);

var _routeHelper = __webpack_require__(7);

var _script = __webpack_require__(214);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'map',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(3).then((function (require) {
					var component = __webpack_require__(1341).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'MAP'),
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_, __, updateRatio) {
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									updateRatio(0.3);

									_context.next = 3;
									return (0, _script.loadGoogleMapLibrary)();

								case 3:
									store.dispatch((0, _global.loadedLibrary)('googleMap'));

									_context.next = 6;
									return store.dispatch((0, _apartment.getApartment)());

								case 6:
									updateRatio(0.8);

								case 7:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, undefined);
				}));

				return function (_x, _x2, _x3) {
					return _ref.apply(this, arguments);
				};
			}(), store, 'ENTER_MAP')
		}
	};
};

/***/ }),
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _global = __webpack_require__(46);

var _room = __webpack_require__(47);

var _filter = __webpack_require__(234);

var _routeHelper = __webpack_require__(7);

var _script = __webpack_require__(214);

var _Reservation = __webpack_require__(1307);

var _Reservation2 = _interopRequireDefault(_Reservation);

var _Booking = __webpack_require__(1308);

var _Booking2 = _interopRequireDefault(_Booking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'room',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(7).then((function (require) {
					var component = __webpack_require__(1344).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'ROOMS'),
			onChange: (0, _routeHelper.withAsyncChangeLoader)(function () {
				var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_, _ref2, __, updateRatio) {
					var query = _ref2.location.query;
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									updateRatio(0.5);
									_context.next = 3;
									return store.dispatch((0, _room.getRoom)(query));

								case 3:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, undefined);
				}));

				return function (_x, _x2, _x3, _x4) {
					return _ref.apply(this, arguments);
				};
			}(), store, 'CHANGE_ROOMS'),
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_ref4, __, updateRatio) {
					var query = _ref4.location.query;
					return regeneratorRuntime.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									updateRatio(0.3);

									_context2.next = 3;
									return store.dispatch((0, _filter.getRoomFilter)());

								case 3:
									_context2.next = 5;
									return [store.dispatch((0, _room.getRoom)(query)), store.dispatch((0, _filter.setRoomFilterQuery)(query))];

								case 5:
									updateRatio(0.8);

								case 6:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, undefined);
				}));

				return function (_x5, _x6, _x7) {
					return _ref3.apply(this, arguments);
				};
			}(), store, 'ENTER_ROOMS')
		},
		childRoutes: [{
			path: ':id',
			indexRoute: {
				getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
					return __webpack_require__.e/* require.ensure */(1).then((function (require) {
						var component = __webpack_require__(1345).default;
						cb(null, component);
					}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
				}, store, 'ROOM'),
				onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
					var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(_ref6, __, updateRatio) {
						var id = _ref6.params.id;
						return regeneratorRuntime.wrap(function _callee3$(_context3) {
							while (1) {
								switch (_context3.prev = _context3.next) {
									case 0:
										updateRatio(0.3);

										_context3.next = 3;
										return (0, _script.loadGoogleMapLibrary)();

									case 3:
										store.dispatch((0, _global.loadedLibrary)('googleMap'));
										_context3.next = 6;
										return [store.dispatch((0, _room.getRoomById)(id))];

									case 6:

										updateRatio(0.8);

									case 7:
									case 'end':
										return _context3.stop();
								}
							}
						}, _callee3, undefined);
					}));

					return function (_x8, _x9, _x10) {
						return _ref5.apply(this, arguments);
					};
				}(), store, 'ENTER_ROOM_HOME')
			},
			childRoutes: [(0, _Reservation2.default)(store), (0, _Booking2.default)(store)]
		}]
	};
};

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reservation = __webpack_require__(97);

var _room = __webpack_require__(47);

var _alert = __webpack_require__(17);

var _routeHelper = __webpack_require__(7);

var _i18n = __webpack_require__(16);

var _helper = __webpack_require__(28);

var _country = __webpack_require__(85);

var _country2 = _interopRequireDefault(_country);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'reservation',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(8).then((function (require) {
					var component = __webpack_require__(1342).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'RoomReservation')
		},
		onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
			var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2, replace, updateRatio) {
				var id = _ref2.params.id,
				    _ref2$location$query$ = _ref2.location.query.step,
				    step = _ref2$location$query$ === undefined ? 'reservation' : _ref2$location$query$;

				var _store$getState, canAccess, lan, _store$getState2, data, today;

				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_store$getState = store.getState(), canAccess = _store$getState.reservation.canAccess, lan = _store$getState.i18n.lan;

								if (canAccess) {
									_context.next = 4;
									break;
								}

								replace('/' + (0, _i18n.languageMapRoute)(lan) + '/room/' + id);
								return _context.abrupt('return');

							case 4:
								store.dispatch((0, _alert.closeAlert)('reserve'));

								store.dispatch((0, _reservation.changeReservationStep)(step));
								updateRatio(0.8);

								// Auto setup reservation form data
								store.dispatch((0, _reservation.initReservationFormData)());

								_store$getState2 = store.getState(), data = _store$getState2.user.data;


								store.dispatch((0, _reservation.setReservationFormData)({
									value: (0, _helper.serverMapEmpty)(data.phone),
									country: _country2.default.getCountryByCode(data.phoneCountry)
								}, { value: (0, _helper.serverMapEmpty)(data.hangout) }));

								// Setup reservation time
								store.dispatch((0, _reservation.clearReservationTime)());
								today = (0, _moment2.default)().add(1, 'day').hour(8).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss');
								_context.next = 14;
								return Promise.all([store.dispatch((0, _room.getRoomById)(id)), store.dispatch((0, _reservation.getReservationTime)(today, id, 'MORNING')), store.dispatch((0, _reservation.getReservationTime)(today, id, 'AFTERNOON')), store.dispatch((0, _reservation.getReservationDate)(today, id))]);

							case 14:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, undefined);
			}));

			return function (_x, _x2, _x3) {
				return _ref.apply(this, arguments);
			};
		}(), store, 'ENTER_ROOM_RESERVATION'),
		onChange: (0, _routeHelper.withAsyncChangeLoader)(function () {
			var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_, _ref4, replace, updateRatio) {
				var id = _ref4.params.id,
				    _ref4$location$query$ = _ref4.location.query.step,
				    step = _ref4$location$query$ === undefined ? 'reservation' : _ref4$location$query$;

				var _store$getState3, canAccess, lan, today;

				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								store.dispatch((0, _alert.closeAlert)('reserve'));
								store.dispatch((0, _reservation.changeReservationStep)(step));
								updateRatio(0.8);

								if (!(step === 'reservation')) {
									_context2.next = 12;
									break;
								}

								_store$getState3 = store.getState(), canAccess = _store$getState3.reservation.canAccess, lan = _store$getState3.i18n.lan;

								if (canAccess) {
									_context2.next = 8;
									break;
								}

								replace('/' + (0, _i18n.languageMapRoute)(lan) + '/room/' + id);
								return _context2.abrupt('return');

							case 8:

								store.dispatch((0, _reservation.clearReservationTime)());
								today = (0, _moment2.default)().add(1, 'day').hour(8).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss');
								_context2.next = 12;
								return Promise.all([store.dispatch((0, _room.getRoomById)(id)), store.dispatch((0, _reservation.getReservationTime)(today, id, 'MORNING')), store.dispatch((0, _reservation.getReservationTime)(today, id, 'AFTERNOON')), store.dispatch((0, _reservation.getReservationDate)(today, id))]);

							case 12:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, undefined);
			}));

			return function (_x4, _x5, _x6, _x7) {
				return _ref3.apply(this, arguments);
			};
		}(), store, 'CHANGE_ROOM_RESERVATION')
	};
};

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _booking = __webpack_require__(55);

var _i18n = __webpack_require__(16);

var _room = __webpack_require__(47);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'booking',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(6).then((function (require) {
					var component = __webpack_require__(1343).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'BOOKING')
		},
		onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
			var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2, replace, updateRatio) {
				var id = _ref2.params.id;

				var _store$getState, canAccess, lan;

				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_store$getState = store.getState(), canAccess = _store$getState.booking.canAccess, lan = _store$getState.i18n.lan;

								if (canAccess) {
									_context.next = 4;
									break;
								}

								replace('/' + (0, _i18n.languageMapRoute)(lan) + '/room/' + id);
								return _context.abrupt('return');

							case 4:

								store.dispatch((0, _booking.bookingGoToStep)(0));
								updateRatio(0.5);

								_context.next = 8;
								return Promise.all([store.dispatch((0, _room.getRoomById)(id)), store.dispatch((0, _booking.getOrderItemByRoomId)(id))]);

							case 8:
								updateRatio(0.8);

							case 9:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, undefined);
			}));

			return function (_x, _x2, _x3) {
				return _ref.apply(this, arguments);
			};
		}(), store, 'ENTER_BOOKING')
	};
};

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _global = __webpack_require__(46);

var _apartment = __webpack_require__(145);

var _routeHelper = __webpack_require__(7);

var _script = __webpack_require__(214);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'apartment',
		indexRoute: {
			component: null,
			onEnter: function onEnter(_ref, replace) {
				var lang = _ref.params.lang;
				return replace('/' + lang + '/404');
			}
		},
		childRoutes: [{
			path: ':id',
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(2).then((function (require) {
					var component = __webpack_require__(1346).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'APARTMENT'),
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref3, __, updateRatio) {
					var id = _ref3.params.id;
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									updateRatio(0.3);

									_context.next = 3;
									return store.dispatch((0, _apartment.getApartmentById)(id));

								case 3:
									updateRatio(0.5);

									_context.next = 6;
									return (0, _script.loadGoogleMapLibrary)();

								case 6:
									store.dispatch((0, _global.loadedLibrary)('googleMap'));

									updateRatio(0.8);

								case 8:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, undefined);
				}));

				return function (_x, _x2, _x3) {
					return _ref2.apply(this, arguments);
				};
			}(), store, 'ENTER_APARTMENT')
		}]
	};
};

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'about',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(19).then((function (require) {
					var component = __webpack_require__(1347).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'ABOUT')
		}
	};
};

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'media',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(24).then((function (require) {
					var component = __webpack_require__(1348).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'MEDIA')
		}
	};
};

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'team',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(21).then((function (require) {
					var component = __webpack_require__(1349).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'TEAM')
		}
	};
};

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'contact',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(25).then((function (require) {
					var component = __webpack_require__(1350).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'CONTACT')
		}
	};
};

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'space',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(18).then((function (require) {
					var component = __webpack_require__(1351).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'SPACE')
		}
	};
};

// withLoader(func, store, 'MEDIA')

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'coliving',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(14).then((function (require) {
					var component = __webpack_require__(1352).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'COLIVING')
		}
	};
};

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'sitemap',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(26).then((function (require) {
					var component = __webpack_require__(1353).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'SITEMAP')
		}
	};
};

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'service',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(29).then((function (require) {
					var component = __webpack_require__(1354).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'SERVICE')
		}
	};
};

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: '*',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(30).then((function (require) {
					var component = __webpack_require__(1355).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'PAGE404')
		}
	};
};

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _i18n = __webpack_require__(16);

var _Overview = __webpack_require__(1320);

var _Overview2 = _interopRequireDefault(_Overview);

var _Settings = __webpack_require__(1321);

var _Settings2 = _interopRequireDefault(_Settings);

var _Wishlist = __webpack_require__(1322);

var _Wishlist2 = _interopRequireDefault(_Wishlist);

var _Booking = __webpack_require__(1323);

var _Booking2 = _interopRequireDefault(_Booking);

var _ReservationRecord = __webpack_require__(1329);

var _ReservationRecord2 = _interopRequireDefault(_ReservationRecord);

var _Community = __webpack_require__(1332);

var _Community2 = _interopRequireDefault(_Community);

var _Interview = __webpack_require__(1333);

var _Interview2 = _interopRequireDefault(_Interview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
	return {
		path: 'user',
		indexRoute: {
			component: null,
			onEnter: function onEnter(_ref, replace) {
				var lang = _ref.params.lang;
				return replace('/' + lang + '/user/overview');
			}
		},
		onEnter: (0, _routeHelper.withSyncEnterLoader)(function (nextState, replace, updateRatio, callback) {
			updateRatio(0.8);

			var _store$getState = store.getState(),
			    accessToken = _store$getState.auth.token.accessToken,
			    lan = _store$getState.i18n.lan;

			if (accessToken === '') {
				replace({
					pathname: '/' + (0, _i18n.languageMapRoute)(lan) + '/login',
					state: {
						nextPathname: nextState.location.pathname,
						nextQuery: nextState.location.query
					}
				});
			}
			callback();
		}, store, 'ENTER_USER'),
		childRoutes: [(0, _Overview2.default)(store), (0, _Settings2.default)(store), (0, _Wishlist2.default)(store), (0, _Booking2.default)(store), (0, _ReservationRecord2.default)(store), (0, _Community2.default)(store), (0, _Interview2.default)(store)]
	};
};

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _user = __webpack_require__(71);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'overview',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(17).then((function (require) {
					var component = __webpack_require__(1356).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'OVERVIEW'),
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_, __, updateRatio) {
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									_context.next = 2;
									return store.dispatch((0, _user.getUserOverview)());

								case 2:
									updateRatio(0.8);

								case 3:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, undefined);
				}));

				return function (_x, _x2, _x3) {
					return _ref.apply(this, arguments);
				};
			}(), store, 'ENTER_OVERVIEW')
		}
	};
};

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _user = __webpack_require__(71);

var _helper = __webpack_require__(28);

var _storage = __webpack_require__(66);

var _bind = __webpack_require__(209);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'settings',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(4).then((function (require) {
					var component = __webpack_require__(1357).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'SETTINGS'),
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_, __, updateRatio) {
					var _store$getState, user, userForm;

					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									updateRatio(0.3);

									_context.next = 3;
									return store.dispatch((0, _user.getUser)());

								case 3:
									_store$getState = store.getState(), user = _store$getState.user;


									if ((0, _helper.mapUserLevel)(user.data.levelId) === 'REGISTERED') {
										userForm = _storage.sessionStorage.getItem('userForm');


										if ((0, _helper.isExist)(userForm)) {
											store.dispatch((0, _bind.syncUserSettingFromLocalStorage)(JSON.parse(userForm)));
										}
									}

									updateRatio(0.8);
									_context.next = 8;
									return Promise.all([store.dispatch((0, _user.getUserJobTypeOptionData)()), store.dispatch((0, _user.getUserInterestOptionData)()), store.dispatch((0, _user.getIgMedia)()), store.dispatch((0, _user.getUserProfessionOptionData)()), store.dispatch((0, _user.getUserCareerOptionData)())]);

								case 8:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, undefined);
				}));

				return function (_x, _x2, _x3) {
					return _ref.apply(this, arguments);
				};
			}(), store, 'ENTER_SETTINGS')
		}
	};
};

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _collect = __webpack_require__(233);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'wishlist',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(16).then((function (require) {
					var component = __webpack_require__(1358).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'WISHLIST'),
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_, __, updateRatio) {
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									_context.next = 2;
									return store.dispatch((0, _collect.getCollect)());

								case 2:
									updateRatio(0.8);

								case 3:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, undefined);
				}));

				return function (_x, _x2, _x3) {
					return _ref.apply(this, arguments);
				};
			}(), store, 'ENTER_WISHLIST')
		}
	};
};

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _booking = __webpack_require__(55);

var _Checkin = __webpack_require__(1324);

var _Checkin2 = _interopRequireDefault(_Checkin);

var _Checkout = __webpack_require__(1325);

var _Checkout2 = _interopRequireDefault(_Checkout);

var _Print = __webpack_require__(1326);

var _Print2 = _interopRequireDefault(_Print);

var _Renew = __webpack_require__(1327);

var _Renew2 = _interopRequireDefault(_Renew);

var _Payment = __webpack_require__(1328);

var _Payment2 = _interopRequireDefault(_Payment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'booking',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(13).then((function (require) {
					var component = __webpack_require__(1364).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'USER_BOOKING'),
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_, __, updateRatio) {
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									_context.next = 2;
									return store.dispatch((0, _booking.getOrder)());

								case 2:
									updateRatio(0.8);

								case 3:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, undefined);
				}));

				return function (_x, _x2, _x3) {
					return _ref.apply(this, arguments);
				};
			}(), store, 'ENTER_USER_BOOKING')
		},
		childRoutes: [{
			path: ':id',
			indexRoute: {
				component: null,
				onEnter: function onEnter(_ref2, replace) {
					var lang = _ref2.params.lang;
					return replace('/' + lang + '/user/booking');
				}
			},
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_, __, updateRatio) {
					return regeneratorRuntime.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									updateRatio(0.8);

								case 1:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, undefined);
				}));

				return function (_x4, _x5, _x6) {
					return _ref3.apply(this, arguments);
				};
			}(), store, 'ENTER_BOOKING_BY_ID'),
			childRoutes: [(0, _Checkin2.default)(store), (0, _Checkout2.default)(store), (0, _Print2.default)(store), (0, _Renew2.default)(store), (0, _Payment2.default)(store)]
		}]
	};
};

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reservation = __webpack_require__(97);

var _booking = __webpack_require__(55);

var _alert = __webpack_require__(17);

var _routeHelper = __webpack_require__(7);

var _room = __webpack_require__(47);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'checkin',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(11).then((function (require) {
					var component = __webpack_require__(1359).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'BookingCheckin')
		},
		onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
			var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2, __, updateRatio) {
				var orderId = _ref2.params.id,
				    _ref2$location$query$ = _ref2.location.query.step,
				    step = _ref2$location$query$ === undefined ? 'reservation' : _ref2$location$query$;

				var _store$getState, booking, roomId;

				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								store.dispatch((0, _alert.closeAlert)('reserve'));
								store.dispatch((0, _reservation.changeReservationStep)(step));
								_context.next = 4;
								return store.dispatch((0, _booking.getOrderById)(orderId));

							case 4:
								updateRatio(0.8);

								if (!(step === 'reservation')) {
									_context.next = 11;
									break;
								}

								store.dispatch((0, _reservation.clearReservationTime)());

								_store$getState = store.getState(), booking = _store$getState.booking;
								roomId = booking.data[orderId].room.id;
								_context.next = 11;
								return Promise.all([store.dispatch((0, _room.getRoomById)(roomId)), store.dispatch((0, _reservation.getReservationTime)(booking.data[orderId].dateFrom, roomId, 'MORNING')), store.dispatch((0, _reservation.getReservationTime)(booking.data[orderId].dateFrom, roomId, 'AFTERNOON')), store.dispatch((0, _reservation.getReservationDateWithOrder)(orderId, 'CHECKIN'))]);

							case 11:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, undefined);
			}));

			return function (_x, _x2, _x3) {
				return _ref.apply(this, arguments);
			};
		}(), store, 'ENTER_BOOKING_CHECKIN'),
		onChange: (0, _routeHelper.withAsyncChangeLoader)(function () {
			var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_, _ref4, __, updateRatio) {
				var orderId = _ref4.params.id,
				    _ref4$location$query$ = _ref4.location.query.step,
				    step = _ref4$location$query$ === undefined ? 'reservation' : _ref4$location$query$;

				var _store$getState2, booking, roomId;

				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								store.dispatch((0, _alert.closeAlert)('reserve'));
								store.dispatch((0, _reservation.changeReservationStep)(step));
								_context2.next = 4;
								return store.dispatch((0, _booking.getOrderById)(orderId));

							case 4:
								updateRatio(0.8);

								if (!(step === 'reservation')) {
									_context2.next = 11;
									break;
								}

								store.dispatch((0, _reservation.clearReservationTime)());

								_store$getState2 = store.getState(), booking = _store$getState2.booking;
								roomId = booking.data[orderId].room.id;
								_context2.next = 11;
								return Promise.all([store.dispatch((0, _reservation.getReservationTime)(booking.data[orderId].dateFrom, roomId, 'MORNING')), store.dispatch((0, _reservation.getReservationTime)(booking.data[orderId].dateFrom, roomId, 'AFTERNOON')), store.dispatch((0, _reservation.getReservationDateWithOrder)(orderId, 'CHECKIN'))]);

							case 11:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, undefined);
			}));

			return function (_x4, _x5, _x6, _x7) {
				return _ref3.apply(this, arguments);
			};
		}(), store, 'CHANGE_BOOKING_CHECKIN')
	};
};

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reservation = __webpack_require__(97);

var _booking = __webpack_require__(55);

var _alert = __webpack_require__(17);

var _routeHelper = __webpack_require__(7);

var _room = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'checkout',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(10).then((function (require) {
					var component = __webpack_require__(1360).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'BookingCheckout')
		},
		onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
			var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2, __, updateRatio) {
				var orderId = _ref2.params.id,
				    _ref2$location$query$ = _ref2.location.query.step,
				    step = _ref2$location$query$ === undefined ? 'reservation' : _ref2$location$query$;

				var _store$getState, booking, roomId, endDate;

				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								store.dispatch((0, _alert.closeAlert)('reserve'));
								store.dispatch((0, _reservation.changeReservationStep)(step));
								_context.next = 4;
								return store.dispatch((0, _booking.getOrderById)(orderId));

							case 4:
								updateRatio(0.8);

								if (!(step === 'reservation')) {
									_context.next = 12;
									break;
								}

								store.dispatch((0, _reservation.clearReservationTime)());

								_store$getState = store.getState(), booking = _store$getState.booking;
								roomId = booking.data[orderId].room.id;
								endDate = (0, _moment2.default)(booking.data[orderId].dateTo).add(-1, 'weeks').hour(8).minute(0).format('YYYY-MM-DD HH:mm:ss');
								_context.next = 12;
								return Promise.all([store.dispatch((0, _room.getRoomById)(roomId)), store.dispatch((0, _reservation.getReservationTime)(endDate, roomId, 'MORNING')), store.dispatch((0, _reservation.getReservationTime)(endDate, roomId, 'AFTERNOON')), store.dispatch((0, _reservation.getReservationDateWithOrder)(orderId, 'CHECKOUT'))]);

							case 12:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, undefined);
			}));

			return function (_x, _x2, _x3) {
				return _ref.apply(this, arguments);
			};
		}(), store, 'ENTER_BOOKING_CHECKOUT'),
		onChange: (0, _routeHelper.withAsyncChangeLoader)(function () {
			var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_, _ref4, __, updateRatio) {
				var orderId = _ref4.params.id,
				    _ref4$location$query$ = _ref4.location.query.step,
				    step = _ref4$location$query$ === undefined ? 'reservation' : _ref4$location$query$;

				var _store$getState2, booking, roomId, endDate;

				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								store.dispatch((0, _alert.closeAlert)('reserve'));
								store.dispatch((0, _reservation.changeReservationStep)(step));
								_context2.next = 4;
								return store.dispatch((0, _booking.getOrderById)(orderId));

							case 4:
								updateRatio(0.8);

								if (!(step === 'reservation')) {
									_context2.next = 12;
									break;
								}

								store.dispatch((0, _reservation.clearReservationTime)());

								_store$getState2 = store.getState(), booking = _store$getState2.booking;
								roomId = booking.data[orderId].room.id;
								endDate = (0, _moment2.default)(booking.data[orderId].dateTo).add(-1, 'weeks').hour(8).minute(0).format('YYYY-MM-DD HH:mm:ss');
								_context2.next = 12;
								return Promise.all([store.dispatch((0, _reservation.getReservationTime)(endDate, roomId, 'MORNING')), store.dispatch((0, _reservation.getReservationTime)(endDate, roomId, 'AFTERNOON')), store.dispatch((0, _reservation.getReservationDateWithOrder)(orderId, 'CHECKOUT'))]);

							case 12:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, undefined);
			}));

			return function (_x4, _x5, _x6, _x7) {
				return _ref3.apply(this, arguments);
			};
		}(), store, 'CHANGE_BOOKING_CHECKOUT')
	};
};

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _booking = __webpack_require__(55);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'print',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(31).then((function (require) {
					var component = __webpack_require__(1361).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'PRINT')
		},
		onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
			var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2, __, updateRatio) {
				var orderId = _ref2.params.id;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								updateRatio(0.5);
								_context.next = 3;
								return store.dispatch((0, _booking.getOrderById)(orderId));

							case 3:
								updateRatio(0.8);

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, undefined);
			}));

			return function (_x, _x2, _x3) {
				return _ref.apply(this, arguments);
			};
		}(), store, 'ENTER_PRINT')
	};
};

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _booking = __webpack_require__(55);

var _routeHelper = __webpack_require__(7);

var _room = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'renew',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(5).then((function (require) {
					var component = __webpack_require__(1362).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'BookingRenew')
		},
		onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
			var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2, replace, updateRatio) {
				var orderId = _ref2.params.id;

				var _store$getState, booking, _booking$data$orderId, roomId, dateTo, detail;

				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								store.dispatch((0, _booking.bookingGoToStep)(0));
								_context.next = 3;
								return store.dispatch((0, _booking.getOrderById)(orderId));

							case 3:
								updateRatio(0.5);

								_store$getState = store.getState(), booking = _store$getState.booking;
								_booking$data$orderId = booking.data[orderId], roomId = _booking$data$orderId.roomId, dateTo = _booking$data$orderId.dateTo, detail = _booking$data$orderId.detail;
								_context.next = 8;
								return Promise.all([store.dispatch((0, _room.getRoomById)(roomId)), store.dispatch((0, _booking.getOrderItemByRoomId)(roomId)), store.dispatch((0, _booking.updateBookingField)('form', 'dateFrom', {
									value: (0, _moment2.default)(dateTo).add(1, 'days').format('X')
								})), store.dispatch((0, _booking.updateBookingField)('form', 'orderItem', {
									value: detail.map(function (item) {
										return item.order_item_id;
									})
								}))]);

							case 8:
								updateRatio(0.8);

							case 9:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, undefined);
			}));

			return function (_x, _x2, _x3) {
				return _ref.apply(this, arguments);
			};
		}(), store, 'ENTER_BOOKING_RENEW')
	};
};

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _booking = __webpack_require__(55);

var _room = __webpack_require__(47);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'payment',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(23).then((function (require) {
					var component = __webpack_require__(1363).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'PAYMENT')
		},
		onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
			var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2, _, updateRatio) {
				var orderId = _ref2.params.id;

				var _store$getState, booking, roomId;

				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return store.dispatch((0, _booking.getOrderById)(orderId));

							case 2:
								updateRatio(0.5);

								_store$getState = store.getState(), booking = _store$getState.booking;
								roomId = booking.data[orderId].roomId;
								_context.next = 7;
								return store.dispatch((0, _room.getRoomById)(roomId));

							case 7:
								updateRatio(0.8);

							case 8:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, undefined);
			}));

			return function (_x, _x2, _x3) {
				return _ref.apply(this, arguments);
			};
		}(), store, 'ENTER_BOOKING_RENEW')
	};
};

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _reservation = __webpack_require__(97);

var _alert = __webpack_require__(17);

var _country = __webpack_require__(85);

var _country2 = _interopRequireDefault(_country);

var _helper = __webpack_require__(28);

var _Cancel = __webpack_require__(1330);

var _Cancel2 = _interopRequireDefault(_Cancel);

var _Edit = __webpack_require__(1331);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'reservation',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(22).then((function (require) {
					var component = __webpack_require__(1367).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'RESERVATION'),
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_, __, updateRatio) {
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									_context.next = 2;
									return store.dispatch((0, _reservation.getReservation)());

								case 2:
									updateRatio(0.8);

								case 3:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, undefined);
				}));

				return function (_x, _x2, _x3) {
					return _ref.apply(this, arguments);
				};
			}(), store, 'ENTER_RESERVATION')
		},
		childRoutes: [{
			path: ':id',
			indexRoute: {
				component: null,
				onEnter: function onEnter(_ref2, replace) {
					var lang = _ref2.params.lang;
					return replace('/' + lang + '/user/reservation');
				}
			},
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_ref4, __, updateRatio) {
					var id = _ref4.params.id,
					    pathname = _ref4.location.pathname;

					var _store$getState, data;

					return regeneratorRuntime.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									store.dispatch((0, _alert.closeAlert)('reserve'));
									_context2.next = 3;
									return store.dispatch((0, _reservation.getReservationById)(id));

								case 3:
									if (!pathname.includes('edit')) {
										_context2.next = 9;
										break;
									}

									_store$getState = store.getState(), data = _store$getState.reservation.reservations.data;


									store.dispatch((0, _reservation.initReservationFormData)());

									updateRatio(0.6);

									_context2.next = 9;
									return Promise.all([store.dispatch((0, _reservation.getReservationTime)(data[id].work_date, data[id].room_id, 'MORNING')), store.dispatch((0, _reservation.getReservationTime)(data[id].work_date, data[id].room_id, 'AFTERNOON')), store.dispatch((0, _reservation.setReservationFormData)({
										value: (0, _helper.serverMapEmpty)(data[id].user.phone),
										country: _country2.default.getCountryByCode(data[id].user.phone_country)
									}, { value: (0, _helper.serverMapEmpty)(data[id].user.hangout) })), store.dispatch((0, _reservation.getReservationDate)(data[id].work_date, data[id].room_id))]);

								case 9:
									updateRatio(0.8);

								case 10:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, undefined);
				}));

				return function (_x4, _x5, _x6) {
					return _ref3.apply(this, arguments);
				};
			}(), store, 'ENTER_RESERVATION_BY_ID'),
			childRoutes: [(0, _Cancel2.default)(store), (0, _Edit2.default)(store)]
		}]
	};
};

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'cancel',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(20).then((function (require) {
					var component = __webpack_require__(1365).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'RESERVATION_CANCEL')
		}
	};
};

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'edit',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(12).then((function (require) {
					var component = __webpack_require__(1366).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'RESERVATION_EDIT')
		}
	};
};

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _community = __webpack_require__(566);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'community',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(15).then((function (require) {
					var component = __webpack_require__(1368).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'COMMUNITY'),
			onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
				var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_, __, updateRatio) {
					return regeneratorRuntime.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									updateRatio(0.3);

									_context.next = 3;
									return store.dispatch((0, _community.getCommunityCity)());

								case 3:
									_context.next = 5;
									return store.dispatch((0, _community.getCommunity)());

								case 5:

									updateRatio(0.8);

								case 6:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, undefined);
				}));

				return function (_x, _x2, _x3) {
					return _ref.apply(this, arguments);
				};
			}(), store, 'ENTER_COMMUNITY')
		}
	};
};

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reservation = __webpack_require__(97);

var _alert = __webpack_require__(17);

var _routeHelper = __webpack_require__(7);

var _helper = __webpack_require__(28);

var _country = __webpack_require__(85);

var _country2 = _interopRequireDefault(_country);

var _user = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'interview',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(9).then((function (require) {
					var component = __webpack_require__(1369).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'USER_INTERVIEW')
		},
		onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
			var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2, replace, updateRatio) {
				var _ref2$location$query$ = _ref2.location.query.step,
				    step = _ref2$location$query$ === undefined ? 'reservation' : _ref2$location$query$;

				var _store$getState, data, today;

				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								store.dispatch((0, _alert.closeAlert)('reserve'));

								store.dispatch((0, _reservation.changeReservationStep)(step));
								updateRatio(0.8);

								// Auto setup reservation form data
								store.dispatch((0, _reservation.initReservationFormData)());

								_context.next = 6;
								return store.dispatch((0, _user.getUser)());

							case 6:
								_store$getState = store.getState(), data = _store$getState.user.data;


								store.dispatch((0, _reservation.setReservationFormData)({
									value: (0, _helper.serverMapEmpty)(data.phone),
									country: _country2.default.getCountryByCode(data.phoneCountry)
								}, { value: (0, _helper.serverMapEmpty)(data.hangout) }));

								// Setup reservation time
								store.dispatch((0, _reservation.clearReservationTime)());
								today = (0, _moment2.default)().add(1, 'day').hour(8).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss');
								_context.next = 12;
								return Promise.all([store.dispatch((0, _reservation.getReservationTimeWithInterview)(today, 'MORNING')), store.dispatch((0, _reservation.getReservationTimeWithInterview)(today, 'AFTERNOON')), store.dispatch((0, _reservation.getReservationDateWithInterview)(today))]);

							case 12:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, undefined);
			}));

			return function (_x, _x2, _x3) {
				return _ref.apply(this, arguments);
			};
		}(), store, 'ENTER_USER_INTERVIEW'),
		onChange: (0, _routeHelper.withAsyncChangeLoader)(function () {
			var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_, _ref4, replace, updateRatio) {
				var _ref4$location$query$ = _ref4.location.query.step,
				    step = _ref4$location$query$ === undefined ? 'reservation' : _ref4$location$query$;
				var today;
				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								store.dispatch((0, _alert.closeAlert)('reserve'));
								store.dispatch((0, _reservation.changeReservationStep)(step));
								updateRatio(0.8);

								if (!(step === 'reservation')) {
									_context2.next = 8;
									break;
								}

								store.dispatch((0, _reservation.clearReservationTime)());
								today = (0, _moment2.default)().add(1, 'day').hour(8).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss');
								_context2.next = 8;
								return Promise.all([store.dispatch((0, _reservation.getReservationTimeWithInterview)(today, 'MORNING')), store.dispatch((0, _reservation.getReservationTimeWithInterview)(today, 'AFTERNOON')), store.dispatch((0, _reservation.getReservationDateWithInterview)(today))]);

							case 8:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, undefined);
			}));

			return function (_x4, _x5, _x6, _x7) {
				return _ref3.apply(this, arguments);
			};
		}(), store, 'CHANGE_USER_INTERVIEW')
	};
};

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _modal = __webpack_require__(56);

exports.default = function (store) {
	return {
		path: 'forget',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(35).then((function (require) {
					var component = __webpack_require__(1370).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'FORGET')
		},
		onEnter: function onEnter() {
			store.dispatch((0, _modal.openMessageModal)('loginSignup', { type: 'newPassword' }));
		}
	};
};

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _auth = __webpack_require__(212);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = function (store) {
	return {
		path: 'verify',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(32).then((function (require) {
					var component = __webpack_require__(1371).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'VERIFY')
		},

		onEnter: (0, _routeHelper.withAsyncEnterLoader)(function () {
			var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2, __, updateRatio) {
				var token = _ref2.location.query.token;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								updateRatio(0.8);
								_context.next = 3;
								return store.dispatch((0, _auth.verifyEmail)(token));

							case 3:
								updateRatio(1);

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, undefined);
			}));

			return function (_x, _x2, _x3) {
				return _ref.apply(this, arguments);
			};
		}(), store, 'ENTER_VERIFY')
	};
};

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _modal = __webpack_require__(56);

exports.default = function (store) {
	return {
		path: 'login',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(34).then((function (require) {
					var component = __webpack_require__(1372).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'LOGIN')
		},
		onEnter: function onEnter() {
			store.dispatch((0, _modal.openMessageModal)('loginSignup', { type: 'loginForm' }));
		}
	};
};

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

var _modal = __webpack_require__(56);

exports.default = function (store) {
	return {
		path: 'signup',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(33).then((function (require) {
					var component = __webpack_require__(1373).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'SIGNUP')
		},
		onEnter: function onEnter() {
			store.dispatch((0, _modal.openMessageModal)('loginSignup', { type: 'newPassword' }));
		}
	};
};

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'privacy',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(27).then((function (require) {
					var component = __webpack_require__(1374).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'PRIVACY')
		}
	};
};

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _routeHelper = __webpack_require__(7);

exports.default = function (store) {
	return {
		path: 'terms',
		indexRoute: {
			getComponent: (0, _routeHelper.withLoader)(function (nextState, cb) {
				return __webpack_require__.e/* require.ensure */(28).then((function (require) {
					var component = __webpack_require__(1375).default;
					cb(null, component);
				}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
			}, store, 'TERMS')
		}
	};
};

/***/ })
],[574]);


// WEBPACK FOOTER //
// app.4f55769ca56ed9877959.js